module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "000b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPullOutTab_vue_vue_type_style_index_0_id_18d2e2f0_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0842");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPullOutTab_vue_vue_type_style_index_0_id_18d2e2f0_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPullOutTab_vue_vue_type_style_index_0_id_18d2e2f0_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPullOutTab_vue_vue_type_style_index_0_id_18d2e2f0_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "00fd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, "*{-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);


/***/ }),

/***/ "00fdb":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "0234":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;
exports._setTarget = exports.target = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var stack = [];
var target = null;
exports.target = target;

var _setTarget = function _setTarget(x) {
  exports.target = target = x;
};

exports._setTarget = _setTarget;

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }

  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;

  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }

    newTarget.$sub.push(lastTarget);
  }

  return lastTarget;
}

function addParams(params) {
  if (_typeof(params) === 'object' && !Array.isArray(params)) {
    exports.target = target = _objectSpread({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();

    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }

  return withParamsClosure(paramsOrClosure);
}

/***/ }),

/***/ "0303":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".icon[data-v-0dc263e4]{-webkit-transition-property:color;transition-property:color;-webkit-transition-duration:.2s;transition-duration:.2s}.icon:not(.light) .icon[data-v-0dc263e4]:not(.subtle){color:var(--c-text--lighten-20)}.icon:not(.light) .icon[data-v-0dc263e4]:not(.subtle):hover{color:var(--c-text)}.icon:not(.light) .icon.subtle[data-v-0dc263e4]{color:var(--c-text--lighten-40)}.icon:not(.light) .icon.subtle[data-v-0dc263e4]:hover{color:var(--c-text--lighten-20)}.icon.light[data-v-0dc263e4]{color:var(--c-text-light)}", ""]);


/***/ }),

/***/ "03dd":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("eac5"),
    nativeKeys = __webpack_require__("57a5");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "0481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "0585":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableRow_vue_vue_type_style_index_0_id_efec1a2c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1163");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableRow_vue_vue_type_style_index_0_id_efec1a2c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableRow_vue_vue_type_style_index_0_id_efec1a2c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableRow_vue_vue_type_style_index_0_id_efec1a2c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0621":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $values = __webpack_require__("6f53").values;

// `Object.values` method
// https://tc39.github.io/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "07c7":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "0842":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b030");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ebeab2e4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0856":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dca9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2ab214d6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "087d":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "08cc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "099a":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "0b07":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("34ac"),
    getValue = __webpack_require__("3698");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "0ba0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableCellContent_vue_vue_type_style_index_0_id_9f12c722_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5b33");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableCellContent_vue_vue_type_style_index_0_id_9f12c722_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableCellContent_vue_vue_type_style_index_0_id_9f12c722_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableCellContent_vue_vue_type_style_index_0_id_9f12c722_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0c06":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1405");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6b195cdc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d03":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}


/***/ }),

/***/ "0d17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeader_vue_vue_type_style_index_0_id_1b9e769c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2330");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeader_vue_vue_type_style_index_0_id_1b9e769c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeader_vue_vue_type_style_index_0_id_1b9e769c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeader_vue_vue_type_style_index_0_id_1b9e769c_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0d24":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("2b3e"),
    stubFalse = __webpack_require__("07c7");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "0eaf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-code[data-v-8fad4ba8]{position:relative;background-color:var(--c-black--opacity-5);border-radius:.125rem}.ui-code .code[data-v-8fad4ba8]{margin:0;padding:.5rem;font-size:.375rem;font-weight:700;overflow-y:auto}.ui-code .code.pad-for-button[data-v-8fad4ba8]{padding-right:2.5rem}.ui-code .copy-button[data-v-8fad4ba8]{position:absolute;top:.25rem;right:.25rem}", ""]);


/***/ }),

/***/ "0f0f":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keysIn = __webpack_require__("9934");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "0f5c":
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__("159a");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ "100e":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("cd9d"),
    overRest = __webpack_require__("2286"),
    setToString = __webpack_require__("c1c9");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "1041":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    getSymbolsIn = __webpack_require__("a029");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "1163":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("42e6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4886e17c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1290":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "1310":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "131a":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var setPrototypeOf = __webpack_require__("d2bb");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "1333":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiFormattedText_vue_vue_type_style_index_0_id_0479b597_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cf7e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiFormattedText_vue_vue_type_style_index_0_id_0479b597_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiFormattedText_vue_vue_type_style_index_0_id_0479b597_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiFormattedText_vue_vue_type_style_index_0_id_0479b597_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1368":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("da03");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "1393":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("eae9");

// `String.prototype.big` method
// https://tc39.github.io/ecma262/#sec-string.prototype.big
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});


/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var sloppyArrayMethod = __webpack_require__("b301");

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: sloppyArrayMethod('reduce') }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "13de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModal_vue_vue_type_style_index_0_id_b0f1ccda_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae2a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModal_vue_vue_type_style_index_0_id_b0f1ccda_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModal_vue_vue_type_style_index_0_id_b0f1ccda_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModal_vue_vue_type_style_index_0_id_b0f1ccda_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1405":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-grid[data-v-74847860]{display:grid;grid-gap:.5rem}.ui-grid.auto-fill.small[data-v-74847860]{grid-template-columns:repeat(auto-fill,minmax(4rem,1fr))}.ui-grid.auto-fill.small .item[data-v-74847860]{height:4rem}.ui-grid.auto-fill.medium[data-v-74847860]{grid-template-columns:repeat(auto-fill,minmax(6rem,1fr))}.ui-grid.auto-fill.medium .item[data-v-74847860]{height:6rem}.ui-grid.auto-fill.big[data-v-74847860]{grid-template-columns:repeat(auto-fill,minmax(8rem,1fr))}.ui-grid.auto-fill.big .item[data-v-74847860]{height:8rem}.ui-grid.auto-fit.small[data-v-74847860]{grid-template-columns:repeat(auto-fit,minmax(4rem,1fr))}.ui-grid.auto-fit.small .item[data-v-74847860]{height:4rem}.ui-grid.auto-fit.medium[data-v-74847860]{grid-template-columns:repeat(auto-fit,minmax(6rem,1fr))}.ui-grid.auto-fit.medium .item[data-v-74847860]{height:6rem}.ui-grid.auto-fit.big[data-v-74847860]{grid-template-columns:repeat(auto-fit,minmax(8rem,1fr))}.ui-grid.auto-fit.big .item[data-v-74847860]{height:8rem}", ""]);


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "157a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0303");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b028e31c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "159a":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("32b3"),
    castPath = __webpack_require__("e2e4"),
    isIndex = __webpack_require__("c098"),
    isObject = __webpack_require__("1a8c"),
    toKey = __webpack_require__("f4d6");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "1685":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_id_5f65fa32_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2529");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_id_5f65fa32_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_id_5f65fa32_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_id_5f65fa32_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var sloppyArrayMethod = __webpack_require__("b301");

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1838":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("c05f"),
    get = __webpack_require__("9b02"),
    hasIn = __webpack_require__("8604"),
    isKey = __webpack_require__("f608"),
    isStrictComparable = __webpack_require__("08cc"),
    matchesStrictComparable = __webpack_require__("20ec"),
    toKey = __webpack_require__("f4d6");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "18d8":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("234d");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "19fd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7d6c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2256f140", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("42a2"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "1a8c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "1bac":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("7d1f"),
    getSymbolsIn = __webpack_require__("a029"),
    keysIn = __webpack_require__("9934");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c3c":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    Uint8Array = __webpack_require__("2474"),
    eq = __webpack_require__("9638"),
    equalArrays = __webpack_require__("a2be"),
    mapToArray = __webpack_require__("edfa"),
    setToArray = __webpack_require__("ac41");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cec":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vuelidate = Vuelidate;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _params.withParams;
  }
});
exports.default = exports.validationMixin = void 0;

var _vval = __webpack_require__("fbf4");

var _params = __webpack_require__("0234");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NIL = function NIL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (_typeof(val) === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');

  for (var i = 0; i < path.length; i++) {
    if (obj && _typeof(obj) === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true,
      v: false
    }
  });
  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });
  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $anyDirty: function $anyDirty() {
    var _this3 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$anyDirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $anyError: function $anyError() {
    return this.$anyDirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this4 = this;

    return this.ruleKeys.some(function (key) {
      return _this4.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this4.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this5 = this;

    var vals = this.validations;
    return _objectSpread({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this5.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];

    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();

        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }

        params = params.concat(childParams);
      } else {
        params.push({
          path: [],
          name: key,
          params: this.$params[key]
        });
      }
    }

    return params;
  }
};
var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);
var _cachedComponent = null;

var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};

        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });

        return refs;
      }
    },
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
        this._vval = null;
      }
    },
    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();

        if (model) {
          return model[key];
        }
      },
      hasIter: function hasIter() {
        return false;
      }
    }
  });
  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: {
      runRule: function runRule(parent) {
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
        return {
          output: output,
          params: params
        };
      }
    },
    computed: {
      run: function run() {
        var _this6 = this;

        var parent = this.lazyParentModel();

        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();
          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this, function () {
              return _this6.runRule(parent);
            }, null, {
              lazy: true
            });
          }

          var model = this.getModel();

          if (!this._indirectWatcher.dirty && this._lastModel === model) {
            this._indirectWatcher.depend();

            return target.value;
          }

          this._lastModel = model;

          this._indirectWatcher.evaluate();

          this._indirectWatcher.depend();
        } else if (this._indirectWatcher) {
          this._indirectWatcher.teardown();

          this._indirectWatcher = null;
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }

        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }

        return false;
      }
    },
    destroyed: function destroyed() {
      if (this._indirectWatcher) {
        this._indirectWatcher.teardown();

        this._indirectWatcher = null;
      }
    }
  });
  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: _objectSpread({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _objectSpread({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this7 = this;

        return this.keys.filter(function (k) {
          return !_this7.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this8 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8.refProxy(key);
            }
          };
        });
        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var iterDefs = this.hasIter() ? {
          $iter: {
            enumerable: true,
            value: Object.defineProperties({}, _objectSpread({}, keyDefs))
          }
        } : {};
        return Object.defineProperties({}, _objectSpread({}, keyDefs, iterDefs, {
          $model: {
            enumerable: true,
            get: function get() {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                return parent[_this8.prop];
              } else {
                return null;
              }
            },
            set: function set(value) {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                parent[_this8.prop] = value;

                _this8.$touch();
              }
            }
          }
        }, getterDefs, methodDefs));
      },
      children: function children() {
        var _this9 = this;

        return _toConsumableArray(this.nestedKeys.map(function (key) {
          return renderNested(_this9, key);
        })).concat(_toConsumableArray(this.ruleKeys.map(function (key) {
          return renderRule(_this9, key);
        }))).filter(Boolean);
      }
    })
  });
  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            return vm.validations[key]() || false;
          }

        };
      }
    }
  });
  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();

        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this10 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return "".concat(getPath(_this10.rootModel, _this10.getModelKey(key), trackBy));
        } : function (x) {
          return "".concat(x);
        };
      },
      getModelLazy: function getModelLazy() {
        var _this11 = this;

        return function () {
          return _this11.getModel();
        };
      },
      children: function children() {
        var _this12 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _objectSpread({}, def);

        delete validations['$trackBy'];
        var usedTracks = {};
        return this.keys.map(function (key) {
          var track = _this12.tracker(key);

          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }

          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this12.getModelLazy,
            model: model[key],
            rootModel: _this12.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      },
      hasIter: function hasIter() {
        return true;
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }

    var validations = vm.validations[key];

    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NIL,
        prop: key,
        lazyModel: NIL,
        rootModel: root
      });
    }

    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = {
    VBase: VBase,
    Validation: Validation
  };
  return _cachedComponent;
};

var _cachedVue = null;

function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;

  while (Vue.super) {
    Vue = Vue.super;
  }

  _cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;
        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NIL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;

    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;

    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();

      this._vuelidate = null;
    }
  }
};
exports.validationMixin = validationMixin;

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

var _default = Vuelidate;
exports.default = _default;

/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1efc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "1f89":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c780");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("96109576", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1fbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiList_vue_vue_type_style_index_0_id_2fabe444_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("efbb");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiList_vue_vue_type_style_index_0_id_2fabe444_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiList_vue_vue_type_style_index_0_id_2fabe444_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiList_vue_vue_type_style_index_0_id_2fabe444_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1fc8":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "208a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenu_vue_vue_type_style_index_0_id_7a58c329_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e2bc");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenu_vue_vue_type_style_index_0_id_7a58c329_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenu_vue_vue_type_style_index_0_id_7a58c329_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenu_vue_vue_type_style_index_0_id_7a58c329_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "20ec":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "21e7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-label[data-v-f4f16454]{font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20);-webkit-transition:color .2s;transition:color .2s;margin-bottom:.125rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-label[data-v-f4f16454]>:not(:last-child){margin-right:.125rem}.ui-label.light[data-v-f4f16454]{font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20);color:var(--c-text-light)}.ui-label.align-to-left[data-v-f4f16454]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.ui-label.align-to-center[data-v-f4f16454]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui-label.align-to-right[data-v-f4f16454]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("f8c2");
var getIteratorMethod = __webpack_require__("35a1");
var callWithSafeIterationClosing = __webpack_require__("9bdd");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),

/***/ "2286":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("85e3");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "22e4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_id_001c5c02_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e402");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_id_001c5c02_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_id_001c5c02_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_id_001c5c02_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2330":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c546");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("63452bd7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "234d":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("e380");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "2366":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "242e":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("72af"),
    keys = __webpack_require__("ec69");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "2474":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "2478":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], "{").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    for (var i = 0; i < this.length; i++) {
      // eslint-disable-next-line prefer-destructuring
      var id = this[i][0];

      if (id != null) {
        alreadyImportedModules[id] = true;
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = modules[_i]; // skip already imported module
      // this implementation is not 100% perfect for weird media query combinations
      // when a module is imported multiple times with different media queries.
      // I hope this will never occur (Hey this way we have smaller bundles)

      if (item[0] == null || !alreadyImportedModules[item[0]]) {
        if (mediaQuery && !item[2]) {
          item[2] = mediaQuery;
        } else if (mediaQuery) {
          item[2] = "(".concat(item[2], ") and (").concat(mediaQuery, ")");
        }

        list.push(item);
      }
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot).concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2524":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "2529":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e26a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("eeb8bdb8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "252c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserver; });
function getInternetExplorerVersion() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return -1;
}

var isIE = void 0;

function initCompat() {
	if (!initCompat.init) {
		initCompat.init = true;
		isIE = getInternetExplorerVersion() !== -1;
	}
}

var ResizeObserver = { render: function render() {
		var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "resize-observer", attrs: { "tabindex": "-1" } });
	}, staticRenderFns: [], _scopeId: 'data-v-b329ee4c',
	name: 'resize-observer',

	methods: {
		compareAndNotify: function compareAndNotify() {
			if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
				this._w = this.$el.offsetWidth;
				this._h = this.$el.offsetHeight;
				this.$emit('notify');
			}
		},
		addResizeHandlers: function addResizeHandlers() {
			this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);
			this.compareAndNotify();
		},
		removeResizeHandlers: function removeResizeHandlers() {
			if (this._resizeObject && this._resizeObject.onload) {
				if (!isIE && this._resizeObject.contentDocument) {
					this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
				}
				delete this._resizeObject.onload;
			}
		}
	},

	mounted: function mounted() {
		var _this = this;

		initCompat();
		this.$nextTick(function () {
			_this._w = _this.$el.offsetWidth;
			_this._h = _this.$el.offsetHeight;
		});
		var object = document.createElement('object');
		this._resizeObject = object;
		object.setAttribute('aria-hidden', 'true');
		object.setAttribute('tabindex', -1);
		object.onload = this.addResizeHandlers;
		object.type = 'text/html';
		if (isIE) {
			this.$el.appendChild(object);
		}
		object.data = 'about:blank';
		if (!isIE) {
			this.$el.appendChild(object);
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.removeResizeHandlers();
	}
};

// Install the components
function install(Vue) {
	Vue.component('resize-observer', ResizeObserver);
	Vue.component('ResizeObserver', ResizeObserver);
}

// Plugin
var plugin = {
	// eslint-disable-next-line no-undef
	version: "0.4.5",
	install: install
};

// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "253c":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "2589":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".rise-enter-active[data-v-64afbb52],.rise-leave-active[data-v-64afbb52]{-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform;-webkit-transition-duration:.2s;transition-duration:.2s;position:absolute;bottom:0}.rise-enter[data-v-64afbb52],.rise-leave-to[data-v-64afbb52]{opacity:0;-webkit-transform:translateY(20%);transform:translateY(20%)}.ui-toast[data-v-64afbb52]{background-color:var(--c-white);-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);border-radius:.25rem;max-width:16rem;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-toast .message[data-v-64afbb52]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui-toast.compact[data-v-64afbb52]{padding:.25rem}.ui-toast.compact[data-v-64afbb52]>:not(:last-child){margin-right:.25rem}.ui-toast.compact .message[data-v-64afbb52]{margin-left:.125rem}.ui-toast.spacious[data-v-64afbb52]{padding:.5rem}.ui-toast.spacious[data-v-64afbb52]>:not(:last-child){margin-right:.5rem}", ""]);


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "26e8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "280f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdown_vue_vue_type_style_index_0_id_1a183058_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("318e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdown_vue_vue_type_style_index_0_id_1a183058_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdown_vue_vue_type_style_index_0_id_1a183058_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdown_vue_vue_type_style_index_0_id_1a183058_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "28c9":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "293b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6b63");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6e65649c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "29f3":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "2b03":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "2b3e":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("585a");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "2b88":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

 /*! 
  * portal-vue © Thorsten Lünborg, 2019 
  * 
  * Version: 2.1.6
  * 
  * LICENCE: MIT 
  * 
  * https://github.com/linusborg/portal-vue
  * 
 */



Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__("8bbf"));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var inBrowser = typeof window !== 'undefined';
function freeze(item) {
  if (Array.isArray(item) || _typeof(item) === 'object') {
    return Object.freeze(item);
  }

  return item;
}
function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return transports.reduce(function (passengers, transport) {
    var temp = transport.passengers[0];
    var newPassengers = typeof temp === 'function' ? temp(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}
function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return compareFn(a[1], b[1]) || a[0] - b[0];
  }).map(function (c) {
    return c[1];
  });
}
function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var transports = {};
var targets = {};
var sources = {};
var Wormhole = Vue.extend({
  data: function data() {
    return {
      transports: transports,
      targets: targets,
      sources: sources,
      trackInstances: inBrowser
    };
  },
  methods: {
    open: function open(transport) {
      if (!inBrowser) return;
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers,
          _transport$order = transport.order,
          order = _transport$order === void 0 ? Infinity : _transport$order;
      if (!to || !from || !passengers) return;
      var newTransport = {
        to: to,
        from: from,
        passengers: freeze(passengers),
        order: order
      };
      var keys = Object.keys(this.transports);

      if (keys.indexOf(to) === -1) {
        Vue.set(this.transports, to, []);
      }

      var currentIndex = this.$_getTransportIndex(newTransport); // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays

      var newTransports = this.transports[to].slice(0);

      if (currentIndex === -1) {
        newTransports.push(newTransport);
      } else {
        newTransports[currentIndex] = newTransport;
      }

      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;
      if (!to || !from && force === false) return;

      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.$_getTransportIndex(transport);

        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    registerTarget: function registerTarget(target, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.targets[target]) {
        console.warn("[portal-vue]: Target ".concat(target, " already exists"));
      }

      this.$set(this.targets, target, Object.freeze([vm]));
    },
    unregisterTarget: function unregisterTarget(target) {
      this.$delete(this.targets, target);
    },
    registerSource: function registerSource(source, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.sources[source]) {
        console.warn("[portal-vue]: source ".concat(source, " already exists"));
      }

      this.$set(this.sources, source, Object.freeze([vm]));
    },
    unregisterSource: function unregisterSource(source) {
      this.$delete(this.sources, source);
    },
    hasTarget: function hasTarget(to) {
      return !!(this.targets[to] && this.targets[to][0]);
    },
    hasSource: function hasSource(to) {
      return !!(this.sources[to] && this.sources[to][0]);
    },
    hasContentFor: function hasContentFor(to) {
      return !!this.transports[to] && !!this.transports[to].length;
    },
    // Internal
    $_getTransportIndex: function $_getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return +i;
        }
      }

      return -1;
    }
  }
});
var wormhole = new Wormhole(transports);

var _id = 1;
var Portal = Vue.extend({
  name: 'portal',
  props: {
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: function _default() {
        return String(_id++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerSource(_this.name, _this);
    });
  },
  mounted: function mounted() {
    if (!this.disabled) {
      this.sendUpdate();
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterSource(this.name);
    this.clear();
  },
  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    }
  },
  methods: {
    clear: function clear(target) {
      var closer = {
        from: this.name,
        to: target || this.to
      };
      wormhole.close(closer);
    },
    normalizeSlots: function normalizeSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    normalizeOwnChildren: function normalizeOwnChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizeSlots();

      if (slotContent) {
        var transport = {
          from: this.name,
          to: this.to,
          passengers: _toConsumableArray(slotContent),
          order: this.order
        };
        wormhole.open(transport);
      } else {
        this.clear();
      }
    }
  },
  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;

    if (children && this.disabled) {
      return children.length <= 1 && this.slim ? this.normalizeOwnChildren(children)[0] : h(Tag, [this.normalizeOwnChildren(children)]);
    } else {
      return this.slim ? h() : h(Tag, {
        class: {
          'v-portal': true
        },
        style: {
          display: 'none'
        },
        key: 'v-portal-placeholder'
      });
    }
  }
});

var PortalTarget = Vue.extend({
  name: 'portalTarget',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    slim: {
      type: Boolean,
      default: false
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerTarget(_this.name, _this);
    });
  },
  watch: {
    ownTransports: function ownTransports() {
      this.$emit('change', this.children().length > 0);
    },
    name: function name(newVal, oldVal) {
      /**
       * TODO
       * This should warn as well ...
       */
      wormhole.unregisterTarget(oldVal);
      wormhole.registerTarget(newVal, this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.transition) {
      this.$nextTick(function () {
        // only when we have a transition, because it causes a re-render
        _this2.firstRender = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterTarget(this.name);
  },
  computed: {
    ownTransports: function ownTransports() {
      var transports = this.transports[this.name] || [];

      if (this.multiple) {
        return transports;
      }

      return transports.length === 0 ? [] : [transports[transports.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    }
  },
  methods: {
    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$scopedSlots.default ? this.$scopedSlots.default(this.slotProps) : this.$slots.default || [];
    },
    // can't be a computed prop because it has to "react" to this.children().
    noWrapper: function noWrapper() {
      var noWrapper = this.slim && !this.transition;

      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }

      return noWrapper;
    }
  },
  render: function render(h) {
    var noWrapper = this.noWrapper();
    var children = this.children();
    var Tag = this.transition || this.tag;
    return noWrapper ? children[0] : this.slim && !Tag ? h() : h(Tag, {
      props: {
        // if we have a transition component, pass the tag if it exists
        tag: this.transition && this.tag ? this.tag : undefined
      },
      class: {
        'vue-portal-target': true
      }
    }, children);
  }
});

var _id$1 = 0;
var portalProps = ['disabled', 'name', 'order', 'slim', 'slotProps', 'tag', 'to'];
var targetProps = ['multiple', 'transition'];
var MountingPortal = Vue.extend({
  name: 'MountingPortal',
  inheritAttrs: false,
  props: {
    append: {
      type: [Boolean, String]
    },
    bail: {
      type: Boolean
    },
    mountTo: {
      type: String,
      required: true
    },
    // Portal
    disabled: {
      type: Boolean
    },
    // name for the portal
    name: {
      type: String,
      default: function _default() {
        return 'mounted_' + String(_id$1++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    // name for the target
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    },
    // Target
    multiple: {
      type: Boolean,
      default: false
    },
    targetSlim: {
      type: Boolean
    },
    targetSlotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    targetTag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  created: function created() {
    if (typeof document === 'undefined') return;
    var el = document.querySelector(this.mountTo);

    if (!el) {
      console.error("[portal-vue]: Mount Point '".concat(this.mountTo, "' not found in document"));
      return;
    }

    var props = this.$props; // Target already exists

    if (wormhole.targets[props.name]) {
      if (props.bail) {
        console.warn("[portal-vue]: Target ".concat(props.name, " is already mounted.\n        Aborting because 'bail: true' is set"));
      } else {
        this.portalTarget = wormhole.targets[props.name];
      }

      return;
    }

    var append = props.append;

    if (append) {
      var type = typeof append === 'string' ? append : 'DIV';
      var mountEl = document.createElement(type);
      el.appendChild(mountEl);
      el = mountEl;
    } // get props for target from $props
    // we have to rename a few of them


    var _props = pick(this.$props, targetProps);

    _props.slim = this.targetSlim;
    _props.tag = this.targetTag;
    _props.slotProps = this.targetSlotProps;
    _props.name = this.to;
    this.portalTarget = new PortalTarget({
      el: el,
      parent: this.$parent || this,
      propsData: _props
    });
  },
  beforeDestroy: function beforeDestroy() {
    var target = this.portalTarget;

    if (this.append) {
      var el = target.$el;
      el.parentNode.removeChild(el);
    }

    target.$destroy();
  },
  render: function render(h) {
    if (!this.portalTarget) {
      console.warn("[portal-vue] Target wasn't mounted");
      return h();
    } // if there's no "manual" scoped slot, so we create a <Portal> ourselves


    if (!this.$scopedSlots.manual) {
      var props = pick(this.$props, portalProps);
      return h(Portal, {
        props: props,
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    } // else, we render the scoped slot


    var content = this.$scopedSlots.manual({
      to: this.to
    }); // if user used <template> for the scoped slot
    // content will be an array

    if (Array.isArray(content)) {
      content = content[0];
    }

    if (!content) return h();
    return content;
  }
});

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue$$1.component(options.portalName || 'Portal', Portal);
  Vue$$1.component(options.portalTargetName || 'PortalTarget', PortalTarget);
  Vue$$1.component(options.MountingPortalName || 'MountingPortal', MountingPortal);
}

var index = {
  install: install
};

exports.default = index;
exports.Portal = Portal;
exports.PortalTarget = PortalTarget;
exports.MountingPortal = MountingPortal;
exports.Wormhole = wormhole;
//# sourceMappingURL=portal-vue.common.js.map


/***/ }),

/***/ "2c66":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("d612"),
    arrayIncludes = __webpack_require__("8db3"),
    arrayIncludesWith = __webpack_require__("5edf"),
    cacheHas = __webpack_require__("c584"),
    createSet = __webpack_require__("750a"),
    setToArray = __webpack_require__("ac41");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");
var bind = __webpack_require__("f8c2");
var html = __webpack_require__("1be4");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("b629");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts && !fails(post)) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d7c":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "2dcb":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("91e9");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "2e1f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c36e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("78905f8e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2eaa":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("d612"),
    arrayIncludes = __webpack_require__("8db3"),
    arrayIncludesWith = __webpack_require__("5edf"),
    arrayMap = __webpack_require__("7948"),
    baseUnary = __webpack_require__("b047"),
    cacheHas = __webpack_require__("c584");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ "2ec1":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("100e"),
    isIterateeCall = __webpack_require__("9aff");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "2fcc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "301f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDivider_vue_vue_type_style_index_0_id_00affc63_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2e1f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDivider_vue_vue_type_style_index_0_id_00affc63_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDivider_vue_vue_type_style_index_0_id_00affc63_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDivider_vue_vue_type_style_index_0_id_00affc63_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "30c9":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("9520"),
    isLength = __webpack_require__("b218");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "30d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBox_vue_vue_type_style_index_0_id_f89f5386_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("293b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBox_vue_vue_type_style_index_0_id_f89f5386_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBox_vue_vue_type_style_index_0_id_f89f5386_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBox_vue_vue_type_style_index_0_id_f89f5386_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "315e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableGroupHeader_vue_vue_type_style_index_0_id_a9896bf8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8464");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableGroupHeader_vue_vue_type_style_index_0_id_a9896bf8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableGroupHeader_vue_vue_type_style_index_0_id_a9896bf8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableGroupHeader_vue_vue_type_style_index_0_id_a9896bf8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "318e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3ef9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("259337d8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "32b3":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("872a"),
    eq = __webpack_require__("9638");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "32f4":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("2d7c"),
    stubArray = __webpack_require__("d327");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "3308":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c00b");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7ca18f4d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "34ac":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("9520"),
    isMasked = __webpack_require__("1368"),
    isObject = __webpack_require__("1a8c"),
    toSource = __webpack_require__("dc57");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "34ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBar_vue_vue_type_style_index_0_id_7b997ea4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0856");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBar_vue_vue_type_style_index_0_id_7b997ea4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBar_vue_vue_type_style_index_0_id_7b997ea4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBar_vue_vue_type_style_index_0_id_7b997ea4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3582":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e4a3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("43390e62", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3698":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "3729":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    getRawTag = __webpack_require__("00fdb"),
    objectToString = __webpack_require__("29f3");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3818":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    arrayEach = __webpack_require__("8057"),
    assignValue = __webpack_require__("32b3"),
    baseAssign = __webpack_require__("5b01"),
    baseAssignIn = __webpack_require__("0f0f"),
    cloneBuffer = __webpack_require__("e538"),
    copyArray = __webpack_require__("4359"),
    copySymbols = __webpack_require__("54eb"),
    copySymbolsIn = __webpack_require__("1041"),
    getAllKeys = __webpack_require__("a994"),
    getAllKeysIn = __webpack_require__("1bac"),
    getTag = __webpack_require__("42a2"),
    initCloneArray = __webpack_require__("c87c"),
    initCloneByTag = __webpack_require__("c2b6"),
    initCloneObject = __webpack_require__("fa21"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isMap = __webpack_require__("cc45"),
    isObject = __webpack_require__("1a8c"),
    isSet = __webpack_require__("d7ee"),
    keys = __webpack_require__("ec69");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "3879":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("699d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("c4bf3c98", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "39ff":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "3a33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToastPortalTarget_vue_vue_type_style_index_0_id_7b50b1a1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("96a0");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToastPortalTarget_vue_vue_type_style_index_0_id_7b50b1a1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToastPortalTarget_vue_vue_type_style_index_0_id_7b50b1a1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToastPortalTarget_vue_vue_type_style_index_0_id_7b50b1a1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3b4a":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "3bb4":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("08cc"),
    keys = __webpack_require__("ec69");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3ee8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmojiPicker_vue_vue_type_style_index_0_id_1ac18318_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4b64");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmojiPicker_vue_vue_type_style_index_0_id_1ac18318_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmojiPicker_vue_vue_type_style_index_0_id_1ac18318_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmojiPicker_vue_vue_type_style_index_0_id_1ac18318_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3ef9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".input-container[data-v-1a183058]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.input-container[data-v-1a183058]>:not(:last-child){margin-right:.25rem}.input-container .popover-wrapper[data-v-1a183058]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.input-container .popover-wrapper .input-box[data-v-1a183058]{display:-webkit-box;display:-ms-flexbox;-webkit-box-align:center;-ms-flex-align:center;outline:none!important;width:100%;min-width:2rem;height:1rem;padding:0 .25rem;border-radius:.125rem;-webkit-transition:.2s;transition:.2s;display:flex;align-items:center;font-weight:500}.input-container .popover-wrapper .input-box[data-v-1a183058]>:not(:last-child){margin-right:.25rem}.input-container .popover-wrapper .input-box .selected-option[data-v-1a183058]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.input-container .popover-wrapper .input-box .selected-option[data-v-1a183058]>:not(:last-child){margin-right:.25rem}.input-container .popover-wrapper .input-box .selected-option .icon-slot[data-v-1a183058]{-ms-flex-negative:0;flex-shrink:0}.input-container .popover-wrapper .input-box .selected-option .text-slot[data-v-1a183058]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.input-container .popover-wrapper .input-box .selected-option .dropdown-icon[data-v-1a183058]{-ms-flex-negative:0;flex-shrink:0;position:absolute;right:.25rem;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.input-container .popover-wrapper .input-box .right[data-v-1a183058]{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.input-container .popover-wrapper .input-box .right[data-v-1a183058]>:not(:last-child){margin-right:.125rem}.input-container .popover-wrapper .input-box.enabled[data-v-1a183058]{cursor:pointer}.input-container .popover-wrapper .input-box.disabled[data-v-1a183058]{opacity:.5;cursor:not-allowed}.input-container .popover-wrapper .input-box:not(.light).enabled[data-v-1a183058]{background-color:var(--c-black--opacity-5)}.input-container .popover-wrapper .input-box:not(.light).enabled[data-v-1a183058]:hover{background-color:var(--c-black--opacity-10)}.input-container .popover-wrapper .input-box:not(.light).disabled[data-v-1a183058]{background-color:var(--c-black--opacity-5)}.input-container .popover-wrapper .input-box:not(.light) .selected-option .placeholder[data-v-1a183058]{color:var(--c-text--lighten-30)}.input-container .popover-wrapper .input-box:not(.light) .dropdown-icon[data-v-1a183058]{color:var(--c-text--lighten-20)}.input-container .popover-wrapper .input-box.light.enabled[data-v-1a183058]{background-color:var(--c-white--opacity-20)}.input-container .popover-wrapper .input-box.light.enabled[data-v-1a183058]:hover{background-color:var(--c-white--opacity-30)}.input-container .popover-wrapper .input-box.light.disabled[data-v-1a183058]{background-color:var(--c-black--opacity-5)}.input-container .popover-wrapper .input-box.light .selected-option .placeholder[data-v-1a183058]{color:var(--c-text--lighten-40)}.input-container .popover-wrapper .input-box.light .dropdown-icon[data-v-1a183058]{color:var(--c-text-light)}.input-container .right-button-container[data-v-1a183058]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.input-container .right-button-container[data-v-1a183058]>:not(:last-child){margin-right:.125rem}.text-slot[data-v-1a183058]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}", ""]);


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4069":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

addToUnscopables('flat');


/***/ }),

/***/ "408c":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "41c3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c"),
    isPrototype = __webpack_require__("eac5"),
    nativeKeysIn = __webpack_require__("ec8c");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "4245":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("1290");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "42454":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("f909"),
    createAssigner = __webpack_require__("2ec1");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "4284":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "42a2":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("b5a7"),
    Map = __webpack_require__("79bc"),
    Promise = __webpack_require__("1cec"),
    Set = __webpack_require__("c869"),
    WeakMap = __webpack_require__("39ff"),
    baseGetTag = __webpack_require__("3729"),
    toSource = __webpack_require__("dc57");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "42e6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-table-row td[data-v-efec1a2c]{padding:.375rem .625rem}.ui-table-row td[data-v-efec1a2c]:not(:first-child){padding-left:0}.ui-table-row td[data-v-efec1a2c]:first-child{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.ui-table-row td[data-v-efec1a2c]:last-child{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.ui-table-row.interactable[data-v-efec1a2c]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui-table-row:not(.opaque) td[data-v-efec1a2c]{background-color:var(--c-black--opacity-5)}.ui-table-row:not(.opaque).highlighted td[data-v-efec1a2c],.ui-table-row:not(.opaque).interactable:hover td[data-v-efec1a2c]{background-color:var(--c-black--opacity-10)}.ui-table-row.opaque td[data-v-efec1a2c]{background-color:#fff}.ui-table-row.opaque.highlighted td[data-v-efec1a2c],.ui-table-row.opaque.interactable:hover td[data-v-efec1a2c]{background-color:var(--c-black--opacity-5)}", ""]);


/***/ }),

/***/ "4359":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "4416":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "4423":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebar_vue_vue_type_style_index_0_id_2571f8d6_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a116");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebar_vue_vue_type_style_index_0_id_2571f8d6_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebar_vue_vue_type_style_index_0_id_2571f8d6_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebar_vue_vue_type_style_index_0_id_2571f8d6_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44b6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7228");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5291acca", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var createNonEnumerableProperty = __webpack_require__("9112");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4633":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, "*[data-v-2c57e4ef]{-webkit-box-sizing:border-box;box-sizing:border-box}.ui-button-collection[data-v-2c57e4ef]{margin-bottom:0}.ui-button-collection .buttons[data-v-2c57e4ef]{display:-webkit-box;display:-ms-flexbox;display:flex}.ui-button-collection .buttons.horizontal[data-v-2c57e4ef]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-button-collection .buttons.horizontal.align-to-left[data-v-2c57e4ef]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.ui-button-collection .buttons.horizontal.align-to-center[data-v-2c57e4ef]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui-button-collection .buttons.horizontal.align-to-right[data-v-2c57e4ef]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.ui-button-collection .buttons.vertical[data-v-2c57e4ef]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui-button-collection .buttons.vertical.align-to-left[data-v-2c57e4ef]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.ui-button-collection .buttons.vertical.align-to-center[data-v-2c57e4ef]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-button-collection .buttons.vertical.align-to-right[data-v-2c57e4ef]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.ui-button-collection .buttons.horizontal.sparse[data-v-2c57e4ef]{margin-bottom:-.25rem}.ui-button-collection .buttons.horizontal.sparse.align-to-center[data-v-2c57e4ef]>:not(:last-child),.ui-button-collection .buttons.horizontal.sparse.align-to-left[data-v-2c57e4ef]>:not(:last-child){margin-right:.25rem}.ui-button-collection .buttons.horizontal.sparse.align-to-right[data-v-2c57e4ef]>:not(:first-child){margin-left:.25rem}.ui-button-collection .buttons.horizontal.sparse>*[data-v-2c57e4ef]{margin-bottom:.25rem}.ui-button-collection .buttons.horizontal.dense[data-v-2c57e4ef]{margin-bottom:-.25rem}.ui-button-collection .buttons.horizontal.dense.align-to-center[data-v-2c57e4ef]>:not(:last-child),.ui-button-collection .buttons.horizontal.dense.align-to-left[data-v-2c57e4ef]>:not(:last-child){margin-right:.125rem}.ui-button-collection .buttons.horizontal.dense.align-to-right[data-v-2c57e4ef]>:not(:first-child){margin-left:.125rem}.ui-button-collection .buttons.horizontal.dense>*[data-v-2c57e4ef]{margin-bottom:.25rem}.ui-button-collection .buttons.vertical[data-v-2c57e4ef]{margin-bottom:-.125rem}.ui-button-collection .buttons.vertical[data-v-2c57e4ef]>:not(:last-child){margin-bottom:.125rem}", ""]);


/***/ }),

/***/ "4662":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-badge[data-v-4e3ace4a]{line-height:0}.ui-badge .circle[data-v-4e3ace4a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:.3125rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui-badge:not(.has-number) .circle[data-v-4e3ace4a]{width:.25rem;height:.25rem;border-radius:100%}.ui-badge:not(.has-number):not(.static) .circle[data-v-4e3ace4a]{-webkit-animation-name:pulse-data-v-4e3ace4a;animation-name:pulse-data-v-4e3ace4a;-webkit-animation-duration:1.5s;animation-duration:1.5s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ui-badge.has-number:not(.small) .circle[data-v-4e3ace4a]{min-width:.625rem;height:.625rem;border-radius:.625rem;padding:0 .125rem}.ui-badge.has-number.small .circle[data-v-4e3ace4a]{min-width:.5rem;height:.5rem;border-radius:.625rem;padding:0 .125rem}.ui-badge.has-number:not(.static) .circle[data-v-4e3ace4a]{-webkit-animation-name:small-pulse-data-v-4e3ace4a;animation-name:small-pulse-data-v-4e3ace4a;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ui-badge.light .circle[data-v-4e3ace4a]{background-color:#fff;color:var(--c-danger)}.ui-badge:not(.light) .circle[data-v-4e3ace4a]{background-color:var(--c-danger);color:var(--c-text-light)}@-webkit-keyframes pulse-data-v-4e3ace4a{0%,to{-webkit-transform:scale(.65);transform:scale(.65)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}}@keyframes pulse-data-v-4e3ace4a{0%,to{-webkit-transform:scale(.65);transform:scale(.65)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}}@-webkit-keyframes small-pulse-data-v-4e3ace4a{0%,to{-webkit-transform:scale(.9);transform:scale(.9)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}}@keyframes small-pulse-data-v-4e3ace4a{0%,to{-webkit-transform:scale(.9);transform:scale(.9)}50%{-webkit-transform:scale(1.05);transform:scale(1.05)}}", ""]);


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "47d2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-avatar[data-v-b91c763e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:50%}.ui-avatar .initials[data-v-b91c763e]{line-height:0;color:#fff;font-weight:700}.ui-avatar.clickable[data-v-b91c763e]{cursor:pointer}.ui-avatar.medium[data-v-b91c763e]{width:.75rem;height:.75rem}.ui-avatar.medium .initials[data-v-b91c763e]{font-size:.3rem}.ui-avatar.large[data-v-b91c763e]{width:1rem;height:1rem}.ui-avatar.large .initials[data-v-b91c763e]{font-size:.4rem}", ""]);


/***/ }),

/***/ "47f5":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("2b03"),
    baseIsNaN = __webpack_require__("d9a8"),
    strictIndexOf = __webpack_require__("099a");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "48a0":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("242e"),
    createBaseEach = __webpack_require__("950a");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("e070");

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "49f4":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "4b64":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7426");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("086a4f6c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4bb4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-table-group-header td[data-v-a9896bf8]{padding-bottom:.375rem;padding-left:.625rem;padding-right:.625rem}.ui-table-group-header td[data-v-a9896bf8]:not(:first-child){padding-left:0}.ui-table-group-header td[data-v-a9896bf8]{z-index:1;position:-webkit-sticky;position:sticky;top:1.5rem;border-bottom:.03125rem solid var(--c-black--opacity-10)}", ""]);


/***/ }),

/***/ "4d49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_id_b91c763e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d645");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_id_b91c763e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_id_b91c763e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_id_b91c763e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isRegExp = __webpack_require__("44e7");
var getFlags = __webpack_require__("ad6d");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    return !thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined ? pattern
      : inheritIfRequired(CORRECT_NEW
        ? new NativeRegExp(patternIsRegExp && !flagsAreUndefined ? pattern.source : pattern, flags)
        : NativeRegExp((patternIsRegExp = pattern instanceof RegExpWrapper)
          ? pattern.source
          : pattern, patternIsRegExp && flagsAreUndefined ? getFlags.call(pattern) : flags)
      , thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var fails = __webpack_require__("d039");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = HAS_SPECIES_SUPPORT && !fails(function () {
  [].filter.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("f8c2");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty(result, index, mapping
        ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e9a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("af36");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("23869a2a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4f50":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("b760"),
    cloneBuffer = __webpack_require__("e538"),
    cloneTypedArray = __webpack_require__("c8fe"),
    copyArray = __webpack_require__("4359"),
    initCloneObject = __webpack_require__("fa21"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isArrayLikeObject = __webpack_require__("dcbe"),
    isBuffer = __webpack_require__("0d24"),
    isFunction = __webpack_require__("9520"),
    isObject = __webpack_require__("1a8c"),
    isPlainObject = __webpack_require__("60ed"),
    isTypedArray = __webpack_require__("73ac"),
    safeGet = __webpack_require__("8adb"),
    toPlainObject = __webpack_require__("8de2");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "50ca":
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__("8057"),
    baseCreate = __webpack_require__("7530"),
    baseForOwn = __webpack_require__("242e"),
    baseIteratee = __webpack_require__("badf"),
    getPrototype = __webpack_require__("2dcb"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isFunction = __webpack_require__("9520"),
    isObject = __webpack_require__("1a8c"),
    isTypedArray = __webpack_require__("73ac");

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),

/***/ "50d8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "52b3":
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__("2eaa"),
    baseFlatten = __webpack_require__("5c69"),
    baseRest = __webpack_require__("100e"),
    isArrayLikeObject = __webpack_require__("dcbe"),
    last = __webpack_require__("4416");

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

module.exports = differenceWith;


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "543e":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("5c69"),
    baseRest = __webpack_require__("100e"),
    baseUniq = __webpack_require__("2c66"),
    isArrayLikeObject = __webpack_require__("dcbe"),
    last = __webpack_require__("4416");

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),

/***/ "548b":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-color-dot[data-v-1be962c1]{width:.25rem;height:.25rem;border-radius:100%}", ""]);


/***/ }),

/***/ "54eb":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    getSymbols = __webpack_require__("32f4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "55a3":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "564c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHints_vue_vue_type_style_index_0_id_4a234f9e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b10e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHints_vue_vue_type_style_index_0_id_4a234f9e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHints_vue_vue_type_style_index_0_id_4a234f9e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHints_vue_vue_type_style_index_0_id_4a234f9e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5709":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9886");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2573f3d5", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "57a5":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("91e9");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "585a":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "58f7":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5b01":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keys = __webpack_require__("ec69");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "5b33":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("76e7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("48a7de07", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5c69":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("087d"),
    isFlattenable = __webpack_require__("0621");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5d41":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var has = __webpack_require__("5135");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var getPrototypeOf = __webpack_require__("e163");

// `Reflect.get` method
// https://tc39.github.io/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  if (descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey)) return has(descriptor, 'value')
    ? descriptor.value
    : descriptor.get === undefined
      ? undefined
      : descriptor.get.call(receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ "5d7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebarWrapper_vue_vue_type_style_index_0_id_157593b4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1f89");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebarWrapper_vue_vue_type_style_index_0_id_157593b4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebarWrapper_vue_vue_type_style_index_0_id_157593b4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSidebarWrapper_vue_vue_type_style_index_0_id_157593b4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "5d89":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "5da1":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("62e4")(module)))

/***/ }),

/***/ "5e2e":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("28c9"),
    listCacheDelete = __webpack_require__("69d5"),
    listCacheGet = __webpack_require__("b4c0"),
    listCacheHas = __webpack_require__("fba5"),
    listCacheSet = __webpack_require__("67ca");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "5edf":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "5f36":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__("dcbe");

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),

/***/ "6044":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "60ae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("b39a");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "60ed":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    getPrototype = __webpack_require__("2dcb"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "6149":
/***/ (function(module, exports, __webpack_require__) {

/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */

(function (global, factory) {
     true ? module.exports = factory() :
    undefined;
}(this, (function () { 'use strict';

    var limit = function (x, min, max) {
        if ( min === void 0 ) min=0;
        if ( max === void 0 ) max=1;

        return x < min ? min : x > max ? max : x;
    };

    var clip_rgb = function (rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for (var i=0; i<=3; i++) {
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) { rgb._clipped = true; }
                rgb[i] = limit(rgb[i], 0, 255);
            } else if (i === 3) {
                rgb[i] = limit(rgb[i], 0, 1);
            }
        }
        return rgb;
    };

    // ported from jQuery's $.type
    var classToType = {};
    for (var i = 0, list = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; i < list.length; i += 1) {
        var name = list[i];

        classToType[("[object " + name + "]")] = name.toLowerCase();
    }
    var type = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };

    var unpack = function (args, keyOrder) {
        if ( keyOrder === void 0 ) keyOrder=null;

    	// if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) { return Array.prototype.slice.call(args); }
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
    	if (type(args[0]) == 'object' && keyOrder) {
    		return keyOrder.split('')
    			.filter(function (k) { return args[0][k] !== undefined; })
    			.map(function (k) { return args[0][k]; });
    	}
    	// otherwise we just return the first argument
    	// (which we suppose is an array of args)
        return args[0];
    };

    var last = function (args) {
        if (args.length < 2) { return null; }
        var l = args.length-1;
        if (type(args[l]) == 'string') { return args[l].toLowerCase(); }
        return null;
    };

    var PI = Math.PI;

    var utils = {
    	clip_rgb: clip_rgb,
    	limit: limit,
    	type: type,
    	unpack: unpack,
    	last: last,
    	PI: PI,
    	TWOPI: PI*2,
    	PITHIRD: PI/3,
    	DEG2RAD: PI / 180,
    	RAD2DEG: 180 / PI
    };

    var input = {
    	format: {},
    	autodetect: []
    };

    var last$1 = utils.last;
    var clip_rgb$1 = utils.clip_rgb;
    var type$1 = utils.type;


    var Color = function Color() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var me = this;
        if (type$1(args[0]) === 'object' &&
            args[0].constructor &&
            args[0].constructor === this.constructor) {
            // the argument is already a Color instance
            return args[0];
        }

        // last argument could be the mode
        var mode = last$1(args);
        var autodetect = false;

        if (!mode) {
            autodetect = true;
            if (!input.sorted) {
                input.autodetect = input.autodetect.sort(function (a,b) { return b.p - a.p; });
                input.sorted = true;
            }
            // auto-detect format
            for (var i = 0, list = input.autodetect; i < list.length; i += 1) {
                var chk = list[i];

                mode = chk.test.apply(chk, args);
                if (mode) { break; }
            }
        }

        if (input.format[mode]) {
            var rgb = input.format[mode].apply(null, autodetect ? args : args.slice(0,-1));
            me._rgb = clip_rgb$1(rgb);
        } else {
            throw new Error('unknown format: '+args);
        }

        // add alpha channel
        if (me._rgb.length === 3) { me._rgb.push(1); }
    };

    Color.prototype.toString = function toString () {
        if (type$1(this.hex) == 'function') { return this.hex(); }
        return ("[" + (this._rgb.join(',')) + "]");
    };

    var Color_1 = Color;

    var chroma = function () {
    	var args = [], len = arguments.length;
    	while ( len-- ) args[ len ] = arguments[ len ];

    	return new (Function.prototype.bind.apply( chroma.Color, [ null ].concat( args) ));
    };

    chroma.Color = Color_1;
    chroma.version = '2.0.6';

    var chroma_1 = chroma;

    var unpack$1 = utils.unpack;
    var max = Math.max;

    var rgb2cmyk = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$1(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max(r,max(g,b));
        var f = k < 1 ? 1 / (1-k) : 0;
        var c = (1-r-k) * f;
        var m = (1-g-k) * f;
        var y = (1-b-k) * f;
        return [c,m,y,k];
    };

    var rgb2cmyk_1 = rgb2cmyk;

    var unpack$2 = utils.unpack;

    var cmyk2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$2(args, 'cmyk');
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) { return [0,0,0,alpha]; }
        return [
            c >= 1 ? 0 : 255 * (1-c) * (1-k), // r
            m >= 1 ? 0 : 255 * (1-m) * (1-k), // g
            y >= 1 ? 0 : 255 * (1-y) * (1-k), // b
            alpha
        ];
    };

    var cmyk2rgb_1 = cmyk2rgb;

    var unpack$3 = utils.unpack;
    var type$2 = utils.type;



    Color_1.prototype.cmyk = function() {
        return rgb2cmyk_1(this._rgb);
    };

    chroma_1.cmyk = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['cmyk']) ));
    };

    input.format.cmyk = cmyk2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$3(args, 'cmyk');
            if (type$2(args) === 'array' && args.length === 4) {
                return 'cmyk';
            }
        }
    });

    var unpack$4 = utils.unpack;
    var last$2 = utils.last;
    var rnd = function (a) { return Math.round(a*100)/100; };

    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */
    var hsl2css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var hsla = unpack$4(args, 'hsla');
        var mode = last$2(args) || 'lsa';
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1]*100) + '%';
        hsla[2] = rnd(hsla[2]*100) + '%';
        if (mode === 'hsla' || (hsla.length > 3 && hsla[3]<1)) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = 'hsla';
        } else {
            hsla.length = 3;
        }
        return (mode + "(" + (hsla.join(',')) + ")");
    };

    var hsl2css_1 = hsl2css;

    var unpack$5 = utils.unpack;

    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */
    var rgb2hsl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$5(args, 'rgba');
        var r = args[0];
        var g = args[1];
        var b = args[2];

        r /= 255;
        g /= 255;
        b /= 255;

        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);

        var l = (max + min) / 2;
        var s, h;

        if (max === min){
            s = 0;
            h = Number.NaN;
        } else {
            s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        }

        if (r == max) { h = (g - b) / (max - min); }
        else if (g == max) { h = 2 + (b - r) / (max - min); }
        else if (b == max) { h = 4 + (r - g) / (max - min); }

        h *= 60;
        if (h < 0) { h += 360; }
        if (args.length>3 && args[3]!==undefined) { return [h,s,l,args[3]]; }
        return [h,s,l];
    };

    var rgb2hsl_1 = rgb2hsl;

    var unpack$6 = utils.unpack;
    var last$3 = utils.last;


    var round = Math.round;

    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */
    var rgb2css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgba = unpack$6(args, 'rgba');
        var mode = last$3(args) || 'rgb';
        if (mode.substr(0,3) == 'hsl') {
            return hsl2css_1(rgb2hsl_1(rgba), mode);
        }
        rgba[0] = round(rgba[0]);
        rgba[1] = round(rgba[1]);
        rgba[2] = round(rgba[2]);
        if (mode === 'rgba' || (rgba.length > 3 && rgba[3]<1)) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = 'rgba';
        }
        return (mode + "(" + (rgba.slice(0,mode==='rgb'?3:4).join(',')) + ")");
    };

    var rgb2css_1 = rgb2css;

    var unpack$7 = utils.unpack;
    var round$1 = Math.round;

    var hsl2rgb = function () {
        var assign;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$7(args, 'hsl');
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r,g,b;
        if (s === 0) {
            r = g = b = l*255;
        } else {
            var t3 = [0,0,0];
            var c = [0,0,0];
            var t2 = l < 0.5 ? l * (1+s) : l+s-l*s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1/3;
            t3[1] = h_;
            t3[2] = h_ - 1/3;
            for (var i=0; i<3; i++) {
                if (t3[i] < 0) { t3[i] += 1; }
                if (t3[i] > 1) { t3[i] -= 1; }
                if (6 * t3[i] < 1)
                    { c[i] = t1 + (t2 - t1) * 6 * t3[i]; }
                else if (2 * t3[i] < 1)
                    { c[i] = t2; }
                else if (3 * t3[i] < 2)
                    { c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6; }
                else
                    { c[i] = t1; }
            }
            (assign = [round$1(c[0]*255),round$1(c[1]*255),round$1(c[2]*255)], r = assign[0], g = assign[1], b = assign[2]);
        }
        if (args.length > 3) {
            // keep alpha channel
            return [r,g,b,args[3]];
        }
        return [r,g,b,1];
    };

    var hsl2rgb_1 = hsl2rgb;

    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;

    var round$2 = Math.round;

    var css2rgb = function (css) {
        css = css.toLowerCase().trim();
        var m;

        if (input.format.named) {
            try {
                return input.format.named(css);
            } catch (e) {
                // eslint-disable-next-line
            }
        }

        // rgb(250,20,0)
        if ((m = css.match(RE_RGB))) {
            var rgb = m.slice(1,4);
            for (var i=0; i<3; i++) {
                rgb[i] = +rgb[i];
            }
            rgb[3] = 1;  // default alpha
            return rgb;
        }

        // rgba(250,20,0,0.4)
        if ((m = css.match(RE_RGBA))) {
            var rgb$1 = m.slice(1,5);
            for (var i$1=0; i$1<4; i$1++) {
                rgb$1[i$1] = +rgb$1[i$1];
            }
            return rgb$1;
        }

        // rgb(100%,0%,0%)
        if ((m = css.match(RE_RGB_PCT))) {
            var rgb$2 = m.slice(1,4);
            for (var i$2=0; i$2<3; i$2++) {
                rgb$2[i$2] = round$2(rgb$2[i$2] * 2.55);
            }
            rgb$2[3] = 1;  // default alpha
            return rgb$2;
        }

        // rgba(100%,0%,0%,0.4)
        if ((m = css.match(RE_RGBA_PCT))) {
            var rgb$3 = m.slice(1,5);
            for (var i$3=0; i$3<3; i$3++) {
                rgb$3[i$3] = round$2(rgb$3[i$3] * 2.55);
            }
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }

        // hsl(0,100%,50%)
        if ((m = css.match(RE_HSL))) {
            var hsl = m.slice(1,4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb_1(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }

        // hsla(0,100%,50%,0.5)
        if ((m = css.match(RE_HSLA))) {
            var hsl$1 = m.slice(1,4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb_1(hsl$1);
            rgb$5[3] = +m[4];  // default alpha = 1
            return rgb$5;
        }
    };

    css2rgb.test = function (s) {
        return RE_RGB.test(s) ||
            RE_RGBA.test(s) ||
            RE_RGB_PCT.test(s) ||
            RE_RGBA_PCT.test(s) ||
            RE_HSL.test(s) ||
            RE_HSLA.test(s);
    };

    var css2rgb_1 = css2rgb;

    var type$3 = utils.type;




    Color_1.prototype.css = function(mode) {
        return rgb2css_1(this._rgb, mode);
    };

    chroma_1.css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['css']) ));
    };

    input.format.css = css2rgb_1;

    input.autodetect.push({
        p: 5,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$3(h) === 'string' && css2rgb_1.test(h)) {
                return 'css';
            }
        }
    });

    var unpack$8 = utils.unpack;

    input.format.gl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgb = unpack$8(args, 'rgba');
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };

    chroma_1.gl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['gl']) ));
    };

    Color_1.prototype.gl = function() {
        var rgb = this._rgb;
        return [rgb[0]/255, rgb[1]/255, rgb[2]/255, rgb[3]];
    };

    var unpack$9 = utils.unpack;

    var rgb2hcg = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$9(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) {
            h = Number.NaN;
        } else {
            if (r === max) { h = (g - b) / delta; }
            if (g === max) { h = 2+(b - r) / delta; }
            if (b === max) { h = 4+(r - g) / delta; }
            h *= 60;
            if (h < 0) { h += 360; }
        }
        return [h, c, _g];
    };

    var rgb2hcg_1 = rgb2hcg;

    var unpack$a = utils.unpack;
    var floor = Math.floor;

    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */

    var hcg2rgb = function () {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$a(args, 'hcg');
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r,g,b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) {
            r = g = b = _g;
        } else {
            if (h === 360) { h = 0; }
            if (h > 360) { h -= 360; }
            if (h < 0) { h += 360; }
            h /= 60;
            var i = floor(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch (i) {
                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
            }
        }
        return [r, g, b, args.length > 3 ? args[3] : 1];
    };

    var hcg2rgb_1 = hcg2rgb;

    var unpack$b = utils.unpack;
    var type$4 = utils.type;






    Color_1.prototype.hcg = function() {
        return rgb2hcg_1(this._rgb);
    };

    chroma_1.hcg = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcg']) ));
    };

    input.format.hcg = hcg2rgb_1;

    input.autodetect.push({
        p: 1,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$b(args, 'hcg');
            if (type$4(args) === 'array' && args.length === 3) {
                return 'hcg';
            }
        }
    });

    var unpack$c = utils.unpack;
    var last$4 = utils.last;
    var round$3 = Math.round;

    var rgb2hex = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$c(args, 'rgba');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last$4(args) || 'auto';
        if (a === undefined) { a = 1; }
        if (mode === 'auto') {
            mode = a < 1 ? 'rgba' : 'rgb';
        }
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = '0' + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch (mode.toLowerCase()) {
            case 'rgba': return ("#" + str + hxa);
            case 'argb': return ("#" + hxa + str);
            default: return ("#" + str);
        }
    };

    var rgb2hex_1 = rgb2hex;

    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8})$/;

    var hex2rgb = function (hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) {
                hex = hex.substr(1);
            }
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split('');
                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [r,g,b,1];
        }

        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 9) {
                // remove optional leading #
                hex = hex.substr(1);
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [r$1,g$1,b$1,a];
        }

        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb

        throw new Error(("unknown hex color: " + hex));
    };

    var hex2rgb_1 = hex2rgb;

    var type$5 = utils.type;




    Color_1.prototype.hex = function(mode) {
        return rgb2hex_1(this._rgb, mode);
    };

    chroma_1.hex = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hex']) ));
    };

    input.format.hex = hex2rgb_1;
    input.autodetect.push({
        p: 4,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$5(h) === 'string' && [3,4,6,7,8,9].includes(h.length)) {
                return 'hex';
            }
        }
    });

    var unpack$d = utils.unpack;
    var TWOPI = utils.TWOPI;
    var min = Math.min;
    var sqrt = Math.sqrt;
    var acos = Math.acos;

    var rgb2hsi = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */
        var ref = unpack$d(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min(r,g,b);
        var i = (r+g+b) / 3;
        var s = i > 0 ? 1 - min_/i : 0;
        if (s === 0) {
            h = NaN;
        } else {
            h = ((r-g)+(r-b)) / 2;
            h /= sqrt((r-g)*(r-g) + (r-b)*(g-b));
            h = acos(h);
            if (b > g) {
                h = TWOPI - h;
            }
            h /= TWOPI;
        }
        return [h*360,s,i];
    };

    var rgb2hsi_1 = rgb2hsi;

    var unpack$e = utils.unpack;
    var limit$1 = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos = Math.cos;

    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */
    var hsi2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */
        args = unpack$e(args, 'hsi');
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r,g,b;

        if (isNaN(h)) { h = 0; }
        if (isNaN(s)) { s = 0; }
        // normalize hue
        if (h > 360) { h -= 360; }
        if (h < 0) { h += 360; }
        h /= 360;
        if (h < 1/3) {
            b = (1-s)/3;
            r = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            g = 1 - (b+r);
        } else if (h < 2/3) {
            h -= 1/3;
            r = (1-s)/3;
            g = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            b = 1 - (r+g);
        } else {
            h -= 2/3;
            g = (1-s)/3;
            b = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            r = 1 - (g+b);
        }
        r = limit$1(i*r*3);
        g = limit$1(i*g*3);
        b = limit$1(i*b*3);
        return [r*255, g*255, b*255, args.length > 3 ? args[3] : 1];
    };

    var hsi2rgb_1 = hsi2rgb;

    var unpack$f = utils.unpack;
    var type$6 = utils.type;






    Color_1.prototype.hsi = function() {
        return rgb2hsi_1(this._rgb);
    };

    chroma_1.hsi = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsi']) ));
    };

    input.format.hsi = hsi2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$f(args, 'hsi');
            if (type$6(args) === 'array' && args.length === 3) {
                return 'hsi';
            }
        }
    });

    var unpack$g = utils.unpack;
    var type$7 = utils.type;






    Color_1.prototype.hsl = function() {
        return rgb2hsl_1(this._rgb);
    };

    chroma_1.hsl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsl']) ));
    };

    input.format.hsl = hsl2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$g(args, 'hsl');
            if (type$7(args) === 'array' && args.length === 3) {
                return 'hsl';
            }
        }
    });

    var unpack$h = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;

    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */
    var rgb2hsl$1 = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$h(args, 'rgb');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h,s,v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) { h = (g - b) / delta; }
            if (g === max_) { h = 2+(b - r) / delta; }
            if (b === max_) { h = 4+(r - g) / delta; }
            h *= 60;
            if (h < 0) { h += 360; }
        }
        return [h, s, v]
    };

    var rgb2hsv = rgb2hsl$1;

    var unpack$i = utils.unpack;
    var floor$1 = Math.floor;

    var hsv2rgb = function () {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$i(args, 'hsv');
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r,g,b;
        v *= 255;
        if (s === 0) {
            r = g = b = v;
        } else {
            if (h === 360) { h = 0; }
            if (h > 360) { h -= 360; }
            if (h < 0) { h += 360; }
            h /= 60;

            var i = floor$1(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));

            switch (i) {
                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
            }
        }
        return [r,g,b,args.length > 3?args[3]:1];
    };

    var hsv2rgb_1 = hsv2rgb;

    var unpack$j = utils.unpack;
    var type$8 = utils.type;






    Color_1.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };

    chroma_1.hsv = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsv']) ));
    };

    input.format.hsv = hsv2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$j(args, 'hsv');
            if (type$8(args) === 'array' && args.length === 3) {
                return 'hsv';
            }
        }
    });

    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,

        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,

        t0: 0.137931034,  // 4 / 29
        t1: 0.206896552,  // 6 / 29
        t2: 0.12841855,   // 3 * t1 * t1
        t3: 0.008856452,  // t1 * t1 * t1
    };

    var unpack$k = utils.unpack;
    var pow = Math.pow;

    var rgb2lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$k(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r,g,b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [l < 0 ? 0 : l, 500 * (x - y), 200 * (y - z)];
    };

    var rgb_xyz = function (r) {
        if ((r /= 255) <= 0.04045) { return r / 12.92; }
        return pow((r + 0.055) / 1.055, 2.4);
    };

    var xyz_lab = function (t) {
        if (t > labConstants.t3) { return pow(t, 1 / 3); }
        return t / labConstants.t2 + labConstants.t0;
    };

    var rgb2xyz = function (r,g,b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / labConstants.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / labConstants.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / labConstants.Zn);
        return [x,y,z];
    };

    var rgb2lab_1 = rgb2lab;

    var unpack$l = utils.unpack;
    var pow$1 = Math.pow;

    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */
    var lab2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$l(args, 'lab');
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x,y,z, r,g,b_;

        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;

        y = labConstants.Yn * lab_xyz(y);
        x = labConstants.Xn * lab_xyz(x);
        z = labConstants.Zn * lab_xyz(z);

        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);  // D65 -> sRGB
        g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);

        return [r,g,b_,args.length > 3 ? args[3] : 1];
    };

    var xyz_rgb = function (r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$1(r, 1 / 2.4) - 0.055)
    };

    var lab_xyz = function (t) {
        return t > labConstants.t1 ? t * t * t : labConstants.t2 * (t - labConstants.t0)
    };

    var lab2rgb_1 = lab2rgb;

    var unpack$m = utils.unpack;
    var type$9 = utils.type;






    Color_1.prototype.lab = function() {
        return rgb2lab_1(this._rgb);
    };

    chroma_1.lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lab']) ));
    };

    input.format.lab = lab2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$m(args, 'lab');
            if (type$9(args) === 'array' && args.length === 3) {
                return 'lab';
            }
        }
    });

    var unpack$n = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$1 = Math.sqrt;
    var atan2 = Math.atan2;
    var round$4 = Math.round;

    var lab2lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$n(args, 'lab');
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$1(a * a + b * b);
        var h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round$4(c*10000) === 0) { h = Number.NaN; }
        return [l, c, h];
    };

    var lab2lch_1 = lab2lch;

    var unpack$o = utils.unpack;



    var rgb2lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$o(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab_1(r,g,b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch_1(l,a,b_);
    };

    var rgb2lch_1 = rgb2lch;

    var unpack$p = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin = Math.sin;
    var cos$1 = Math.cos;

    var lch2lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */
        var ref = unpack$p(args, 'lch');
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) { h = 0; }
        h = h * DEG2RAD;
        return [l, cos$1(h) * c, sin(h) * c]
    };

    var lch2lab_1 = lch2lab;

    var unpack$q = utils.unpack;



    var lch2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$q(args, 'lch');
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab_1 (l,c,h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb_1 (L,a,b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [r, g, b, args.length > 3 ? args[3] : 1];
    };

    var lch2rgb_1 = lch2rgb;

    var unpack$r = utils.unpack;


    var hcl2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var hcl = unpack$r(args, 'hcl').reverse();
        return lch2rgb_1.apply(void 0, hcl);
    };

    var hcl2rgb_1 = hcl2rgb;

    var unpack$s = utils.unpack;
    var type$a = utils.type;






    Color_1.prototype.lch = function() { return rgb2lch_1(this._rgb); };
    Color_1.prototype.hcl = function() { return rgb2lch_1(this._rgb).reverse(); };

    chroma_1.lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lch']) ));
    };
    chroma_1.hcl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcl']) ));
    };

    input.format.lch = lch2rgb_1;
    input.format.hcl = hcl2rgb_1;

    ['lch','hcl'].forEach(function (m) { return input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$s(args, m);
            if (type$a(args) === 'array' && args.length === 3) {
                return m;
            }
        }
    }); });

    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */

    var w3cx11 = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflower: '#6495ed',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        laserlemon: '#ffff54',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrod: '#fafad2',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        maroon2: '#7f0000',
        maroon3: '#b03060',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        purple2: '#7f007f',
        purple3: '#a020f0',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    };

    var w3cx11_1 = w3cx11;

    var type$b = utils.type;





    Color_1.prototype.name = function() {
        var hex = rgb2hex_1(this._rgb, 'rgb');
        for (var i = 0, list = Object.keys(w3cx11_1); i < list.length; i += 1) {
            var n = list[i];

            if (w3cx11_1[n] === hex) { return n.toLowerCase(); }
        }
        return hex;
    };

    input.format.named = function (name) {
        name = name.toLowerCase();
        if (w3cx11_1[name]) { return hex2rgb_1(w3cx11_1[name]); }
        throw new Error('unknown color name: '+name);
    };

    input.autodetect.push({
        p: 5,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$b(h) === 'string' && w3cx11_1[h.toLowerCase()]) {
                return 'named';
            }
        }
    });

    var unpack$t = utils.unpack;

    var rgb2num = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$t(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };

    var rgb2num_1 = rgb2num;

    var type$c = utils.type;

    var num2rgb = function (num) {
        if (type$c(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = (num >> 8) & 0xFF;
            var b = num & 0xFF;
            return [r,g,b,1];
        }
        throw new Error("unknown num color: "+num);
    };

    var num2rgb_1 = num2rgb;

    var type$d = utils.type;



    Color_1.prototype.num = function() {
        return rgb2num_1(this._rgb);
    };

    chroma_1.num = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['num']) ));
    };

    input.format.num = num2rgb_1;

    input.autodetect.push({
        p: 5,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            if (args.length === 1 && type$d(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) {
                return 'num';
            }
        }
    });

    var unpack$u = utils.unpack;
    var type$e = utils.type;
    var round$5 = Math.round;

    Color_1.prototype.rgb = function(rnd) {
        if ( rnd === void 0 ) rnd=true;

        if (rnd === false) { return this._rgb.slice(0,3); }
        return this._rgb.slice(0,3).map(round$5);
    };

    Color_1.prototype.rgba = function(rnd) {
        if ( rnd === void 0 ) rnd=true;

        return this._rgb.slice(0,4).map(function (v,i) {
            return i<3 ? (rnd === false ? v : round$5(v)) : v;
        });
    };

    chroma_1.rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['rgb']) ));
    };

    input.format.rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgba = unpack$u(args, 'rgba');
        if (rgba[3] === undefined) { rgba[3] = 1; }
        return rgba;
    };

    input.autodetect.push({
        p: 3,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$u(args, 'rgba');
            if (type$e(args) === 'array' && (args.length === 3 ||
                args.length === 4 && type$e(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
                return 'rgb';
            }
        }
    });

    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */

    var log = Math.log;

    var temperature2rgb = function (kelvin) {
        var temp = kelvin / 100;
        var r,g,b;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp-2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp-10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp-55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp-50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [r,g,b,1];
    };

    var temperature2rgb_1 = temperature2rgb;

    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/


    var unpack$v = utils.unpack;
    var round$6 = Math.round;

    var rgb2temperature = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgb = unpack$v(args, 'rgb');
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while (maxTemp - minTemp > eps) {
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb_1(temp);
            if ((rgb$1[2] / rgb$1[0]) >= (b / r)) {
                maxTemp = temp;
            } else {
                minTemp = temp;
            }
        }
        return round$6(temp);
    };

    var rgb2temperature_1 = rgb2temperature;

    Color_1.prototype.temp =
    Color_1.prototype.kelvin =
    Color_1.prototype.temperature = function() {
        return rgb2temperature_1(this._rgb);
    };

    chroma_1.temp =
    chroma_1.kelvin =
    chroma_1.temperature = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['temp']) ));
    };

    input.format.temp =
    input.format.kelvin =
    input.format.temperature = temperature2rgb_1;

    var type$f = utils.type;

    Color_1.prototype.alpha = function(a, mutate) {
        if ( mutate === void 0 ) mutate=false;

        if (a !== undefined && type$f(a) === 'number') {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color_1([this._rgb[0], this._rgb[1], this._rgb[2], a], 'rgb');
        }
        return this._rgb[3];
    };

    Color_1.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };

    Color_1.prototype.darken = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	var me = this;
    	var lab = me.lab();
    	lab[0] -= labConstants.Kn * amount;
    	return new Color_1(lab, 'lab').alpha(me.alpha(), true);
    };

    Color_1.prototype.brighten = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	return this.darken(-amount);
    };

    Color_1.prototype.darker = Color_1.prototype.darken;
    Color_1.prototype.brighter = Color_1.prototype.brighten;

    Color_1.prototype.get = function(mc) {
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) { return src[i]; }
            throw new Error(("unknown channel " + channel + " in mode " + mode));
        } else {
            return src;
        }
    };

    var type$g = utils.type;
    var pow$2 = Math.pow;

    var EPS = 1e-7;
    var MAX_ITER = 20;

    Color_1.prototype.luminance = function(lum) {
        if (lum !== undefined && type$g(lum) === 'number') {
            if (lum === 0) {
                // return pure black
                return new Color_1([0,0,0,this._rgb[3]], 'rgb');
            }
            if (lum === 1) {
                // return pure white
                return new Color_1([255,255,255,this._rgb[3]], 'rgb');
            }
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = 'rgb';
            var max_iter = MAX_ITER;

            var test = function (low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) {
                    // close enough
                    return mid;
                }
                return lm > lum ? test(low, mid) : test(mid, high);
            };

            var rgb = (cur_lum > lum ? test(new Color_1([0,0,0]), this) : test(this, new Color_1([255,255,255]))).rgb();
            return new Color_1(rgb.concat( [this._rgb[3]]));
        }
        return rgb2luminance.apply(void 0, (this._rgb).slice(0,3));
    };


    var rgb2luminance = function (r,g,b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    var luminance_x = function (x) {
        x /= 255;
        return x <= 0.03928 ? x/12.92 : pow$2((x+0.055)/1.055, 2.4);
    };

    var interpolator = {};

    var type$h = utils.type;


    var mix = function (col1, col2, f) {
        if ( f === void 0 ) f=0.5;
        var rest = [], len = arguments.length - 3;
        while ( len-- > 0 ) rest[ len ] = arguments[ len + 3 ];

        var mode = rest[0] || 'lrgb';
        if (!interpolator[mode] && !rest.length) {
            // fall back to the first supported mode
            mode = Object.keys(interpolator)[0];
        }
        if (!interpolator[mode]) {
            throw new Error(("interpolation mode " + mode + " is not defined"));
        }
        if (type$h(col1) !== 'object') { col1 = new Color_1(col1); }
        if (type$h(col2) !== 'object') { col2 = new Color_1(col2); }
        return interpolator[mode](col1, col2, f)
            .alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };

    Color_1.prototype.mix =
    Color_1.prototype.interpolate = function(col2, f) {
    	if ( f === void 0 ) f=0.5;
    	var rest = [], len = arguments.length - 2;
    	while ( len-- > 0 ) rest[ len ] = arguments[ len + 2 ];

    	return mix.apply(void 0, [ this, col2, f ].concat( rest ));
    };

    Color_1.prototype.premultiply = function(mutate) {
    	if ( mutate === void 0 ) mutate=false;

    	var rgb = this._rgb;
    	var a = rgb[3];
    	if (mutate) {
    		this._rgb = [rgb[0]*a, rgb[1]*a, rgb[2]*a, a];
    		return this;
    	} else {
    		return new Color_1([rgb[0]*a, rgb[1]*a, rgb[2]*a, a], 'rgb');
    	}
    };

    Color_1.prototype.saturate = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	var me = this;
    	var lch = me.lch();
    	lch[1] += labConstants.Kn * amount;
    	if (lch[1] < 0) { lch[1] = 0; }
    	return new Color_1(lch, 'lch').alpha(me.alpha(), true);
    };

    Color_1.prototype.desaturate = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	return this.saturate(-amount);
    };

    var type$i = utils.type;

    Color_1.prototype.set = function(mc, value, mutate) {
        if ( mutate === void 0 ) mutate=false;

        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) {
                if (type$i(value) == 'string') {
                    switch(value.charAt(0)) {
                        case '+': src[i] += +value; break;
                        case '-': src[i] += +value; break;
                        case '*': src[i] *= +(value.substr(1)); break;
                        case '/': src[i] /= +(value.substr(1)); break;
                        default: src[i] = +value;
                    }
                } else if (type$i(value) === 'number') {
                    src[i] = value;
                } else {
                    throw new Error("unsupported value for Color.set");
                }
                var out = new Color_1(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error(("unknown channel " + channel + " in mode " + mode));
        } else {
            return src;
        }
    };

    var rgb$1 = function (col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color_1(
            xyz0[0] + f * (xyz1[0]-xyz0[0]),
            xyz0[1] + f * (xyz1[1]-xyz0[1]),
            xyz0[2] + f * (xyz1[2]-xyz0[2]),
            'rgb'
        )
    };

    // register interpolator
    interpolator.rgb = rgb$1;

    var sqrt$2 = Math.sqrt;
    var pow$3 = Math.pow;

    var lrgb = function (col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color_1(
            sqrt$2(pow$3(x1,2) * (1-f) + pow$3(x2,2) * f),
            sqrt$2(pow$3(y1,2) * (1-f) + pow$3(y2,2) * f),
            sqrt$2(pow$3(z1,2) * (1-f) + pow$3(z2,2) * f),
            'rgb'
        )
    };

    // register interpolator
    interpolator.lrgb = lrgb;

    var lab$1 = function (col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color_1(
            xyz0[0] + f * (xyz1[0]-xyz0[0]),
            xyz0[1] + f * (xyz1[1]-xyz0[1]),
            xyz0[2] + f * (xyz1[2]-xyz0[2]),
            'lab'
        )
    };

    // register interpolator
    interpolator.lab = lab$1;

    var _hsx = function (col1, col2, f, m) {
        var assign, assign$1;

        var xyz0, xyz1;
        if (m === 'hsl') {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === 'hsv') {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === 'hcg') {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === 'hsi') {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === 'lch' || m === 'hcl') {
            m = 'hcl';
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }

        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === 'h') {
            (assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2]);
            (assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2]);
        }

        var sat, hue, lbv, dh;

        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) {
                dh = hue1-(hue0+360);
            } else if (hue1 < hue0 && hue0 - hue1 > 180) {
                dh = hue1+360-hue0;
            } else{
                dh = hue1 - hue0;
            }
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') { sat = sat0; }
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') { sat = sat1; }
        } else {
            hue = Number.NaN;
        }

        if (sat === undefined) { sat = sat0 + f * (sat1 - sat0); }
        lbv = lbv0 + f * (lbv1-lbv0);
        return new Color_1([hue, sat, lbv], m);
    };

    var lch$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'lch');
    };

    // register interpolator
    interpolator.lch = lch$1;
    interpolator.hcl = lch$1;

    var num$1 = function (col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color_1(c1 + f * (c2-c1), 'num')
    };

    // register interpolator
    interpolator.num = num$1;

    var hcg$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hcg');
    };

    // register interpolator
    interpolator.hcg = hcg$1;

    var hsi$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsi');
    };

    // register interpolator
    interpolator.hsi = hsi$1;

    var hsl$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsl');
    };

    // register interpolator
    interpolator.hsl = hsl$1;

    var hsv$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsv');
    };

    // register interpolator
    interpolator.hsv = hsv$1;

    var clip_rgb$2 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$3 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$1 = Math.sin;
    var atan2$1 = Math.atan2;

    var average = function (colors, mode) {
        if ( mode === void 0 ) mode='lrgb';

        var l = colors.length;
        // convert colors to Color objects
        colors = colors.map(function (c) { return new Color_1(c); });
        if (mode === 'lrgb') {
            return _average_lrgb(colors)
        }
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for (var i=0; i<xyz.length; i++) {
            xyz[i] = xyz[i] || 0;
            cnt.push(isNaN(xyz[i]) ? 0 : 1);
            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A);
                dy += sin$1(A);
            }
        }

        var alpha = first.alpha();
        colors.forEach(function (c) {
            var xyz2 = c.get(mode);
            alpha += c.alpha();
            for (var i=0; i<xyz.length; i++) {
                if (!isNaN(xyz2[i])) {
                    cnt[i]++;
                    if (mode.charAt(i) === 'h') {
                        var A = xyz2[i] / 180 * PI$1;
                        dx += cos$2(A);
                        dy += sin$1(A);
                    } else {
                        xyz[i] += xyz2[i];
                    }
                }
            }
        });

        for (var i$1=0; i$1<xyz.length; i$1++) {
            if (mode.charAt(i$1) === 'h') {
                var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
                while (A$1 < 0) { A$1 += 360; }
                while (A$1 >= 360) { A$1 -= 360; }
                xyz[i$1] = A$1;
            } else {
                xyz[i$1] = xyz[i$1]/cnt[i$1];
            }
        }
        alpha /= l;
        return (new Color_1(xyz, mode)).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };


    var _average_lrgb = function (colors) {
        var l = colors.length;
        var f = 1/l;
        var xyz = [0,0,0,0];
        for (var i = 0, list = colors; i < list.length; i += 1) {
            var col = list[i];

            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0],2) * f;
            xyz[1] += pow$4(rgb[1],2) * f;
            xyz[2] += pow$4(rgb[2],2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$3(xyz[0]);
        xyz[1] = sqrt$3(xyz[1]);
        xyz[2] = sqrt$3(xyz[2]);
        if (xyz[3] > 0.9999999) { xyz[3] = 1; }
        return new Color_1(clip_rgb$2(xyz));
    };

    // minimal multi-purpose interface

    // @requires utils color analyze


    var type$j = utils.type;

    var pow$5 = Math.pow;

    var scale = function(colors) {

        // constructor
        var _mode = 'rgb';
        var _nacol = chroma_1('#ccc');
        var _spread = 0;
        // const _fixed = false;
        var _domain = [0, 1];
        var _pos = [];
        var _padding = [0,0];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;

        // private methods

        var setColors = function(colors) {
            colors = colors || ['#fff', '#000'];
            if (colors && type$j(colors) === 'string' && chroma_1.brewer &&
                chroma_1.brewer[colors.toLowerCase()]) {
                colors = chroma_1.brewer[colors.toLowerCase()];
            }
            if (type$j(colors) === 'array') {
                // handle single color
                if (colors.length === 1) {
                    colors = [colors[0], colors[0]];
                }
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for (var c=0; c<colors.length; c++) {
                    colors[c] = chroma_1(colors[c]);
                }
                // auto-fill color position
                _pos.length = 0;
                for (var c$1=0; c$1<colors.length; c$1++) {
                    _pos.push(c$1/(colors.length-1));
                }
            }
            resetCache();
            return _colors = colors;
        };

        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length-1;
                var i = 0;
                while (i < n && value >= _classes[i]) {
                    i++;
                }
                return i-1;
            }
            return 0;
        };

        var tMapLightness = function (t) { return t; };
        var tMapDomain = function (t) { return t; };

        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };

        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) { bypassMap = false; }
            if (isNaN(val) || (val === null)) { return _nacol; }
            if (!bypassMap) {
                if (_classes && (_classes.length > 2)) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length-2);
                } else if (_max !== _min) {
                    // just interpolate between min/max
                    t = (val - _min) / (_max - _min);
                } else {
                    t = 1;
                }
            } else {
                t = val;
            }

            // domain map
            t = tMapDomain(t);

            if (!bypassMap) {
                t = tMapLightness(t);  // lightness correction
            }

            if (_gamma !== 1) { t = pow$5(t, _gamma); }

            t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));

            t = Math.min(1, Math.max(0, t));

            var k = Math.floor(t * 10000);

            if (_useCache && _colorCache[k]) {
                col = _colorCache[k];
            } else {
                if (type$j(_colors) === 'array') {
                    //for i in [0.._pos.length-1]
                    for (var i=0; i<_pos.length; i++) {
                        var p = _pos[i];
                        if (t <= p) {
                            col = _colors[i];
                            break;
                        }
                        if ((t >= p) && (i === (_pos.length-1))) {
                            col = _colors[i];
                            break;
                        }
                        if (t > p && t < _pos[i+1]) {
                            t = (t-p)/(_pos[i+1]-p);
                            col = chroma_1.interpolate(_colors[i], _colors[i+1], t, _mode);
                            break;
                        }
                    }
                } else if (type$j(_colors) === 'function') {
                    col = _colors(t);
                }
                if (_useCache) { _colorCache[k] = col; }
            }
            return col;
        };

        var resetCache = function () { return _colorCache = {}; };

        setColors(colors);

        // public interface

        var f = function(v) {
            var c = chroma_1(getColor(v));
            if (_out && c[_out]) { return c[_out](); } else { return c; }
        };

        f.classes = function(classes) {
            if (classes != null) {
                if (type$j(classes) === 'array') {
                    _classes = classes;
                    _domain = [classes[0], classes[classes.length-1]];
                } else {
                    var d = chroma_1.analyze(_domain);
                    if (classes === 0) {
                        _classes = [d.min, d.max];
                    } else {
                        _classes = chroma_1.limits(d, 'e', classes);
                    }
                }
                return f;
            }
            return _classes;
        };


        f.domain = function(domain) {
            if (!arguments.length) {
                return _domain;
            }
            _min = domain[0];
            _max = domain[domain.length-1];
            _pos = [];
            var k = _colors.length;
            if ((domain.length === k) && (_min !== _max)) {
                // update positions
                for (var i = 0, list = Array.from(domain); i < list.length; i += 1) {
                    var d = list[i];

                  _pos.push((d-_min) / (_max-_min));
                }
            } else {
                for (var c=0; c<k; c++) {
                    _pos.push(c/(k-1));
                }
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function (d,i) { return i/(domain.length-1); });
                    var tBreaks = domain.map(function (d) { return (d - _min) / (_max - _min); });
                    if (!tBreaks.every(function (val, i) { return tOut[i] === val; })) {
                        tMapDomain = function (t) {
                            if (t <= 0 || t >= 1) { return t; }
                            var i = 0;
                            while (t >= tBreaks[i+1]) { i++; }
                            var f = (t - tBreaks[i]) / (tBreaks[i+1] - tBreaks[i]);
                            var out = tOut[i] + f * (tOut[i+1] - tOut[i]);
                            return out;
                        };
                    }

                }
            }
            _domain = [_min, _max];
            return f;
        };

        f.mode = function(_m) {
            if (!arguments.length) {
                return _mode;
            }
            _mode = _m;
            resetCache();
            return f;
        };

        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };

        f.out = function(_o) {
            _out = _o;
            return f;
        };

        f.spread = function(val) {
            if (!arguments.length) {
                return _spread;
            }
            _spread = val;
            return f;
        };

        f.correctLightness = function(v) {
            if (v == null) { v = true; }
            _correctLightness = v;
            resetCache();
            if (_correctLightness) {
                tMapLightness = function(t) {
                    var L0 = getColor(0, true).lab()[0];
                    var L1 = getColor(1, true).lab()[0];
                    var pol = L0 > L1;
                    var L_actual = getColor(t, true).lab()[0];
                    var L_ideal = L0 + ((L1 - L0) * t);
                    var L_diff = L_actual - L_ideal;
                    var t0 = 0;
                    var t1 = 1;
                    var max_iter = 20;
                    while ((Math.abs(L_diff) > 1e-2) && (max_iter-- > 0)) {
                        (function() {
                            if (pol) { L_diff *= -1; }
                            if (L_diff < 0) {
                                t0 = t;
                                t += (t1 - t) * 0.5;
                            } else {
                                t1 = t;
                                t += (t0 - t) * 0.5;
                            }
                            L_actual = getColor(t, true).lab()[0];
                            return L_diff = L_actual - L_ideal;
                        })();
                    }
                    return t;
                };
            } else {
                tMapLightness = function (t) { return t; };
            }
            return f;
        };

        f.padding = function(p) {
            if (p != null) {
                if (type$j(p) === 'number') {
                    p = [p,p];
                }
                _padding = p;
                return f;
            } else {
                return _padding;
            }
        };

        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) { out = 'hex'; }
            var result = [];

            if (arguments.length === 0) {
                result = _colors.slice(0);

            } else if (numColors === 1) {
                result = [f(0.5)];

            } else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function (i) { return f( dm + ((i/(numColors-1)) * dd) ); });

            } else { // returns all colors based on the defined classes
                colors = [];
                var samples = [];
                if (_classes && (_classes.length > 2)) {
                    for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
                        samples.push((_classes[i-1]+_classes[i])*0.5);
                    }
                } else {
                    samples = _domain;
                }
                result = samples.map(function (v) { return f(v); });
            }

            if (chroma_1[out]) {
                result = result.map(function (c) { return c[out](); });
            }
            return result;
        };

        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else {
                return _useCache;
            }
        };

        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else {
                return _gamma;
            }
        };

        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma_1(d);
                return f;
            } else {
                return _nacol;
            }
        };

        return f;
    };

    function __range__(left, right, inclusive) {
      var range = [];
      var ascending = left < right;
      var end = !inclusive ? right : ascending ? right + 1 : right - 1;
      for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
      }
      return range;
    }

    //
    // interpolates between a set of colors uzing a bezier spline
    //

    // @requires utils lab




    var bezier = function(colors) {
        var assign, assign$1, assign$2;

        var I, lab0, lab1, lab2;
        colors = colors.map(function (c) { return new Color_1(c); });
        if (colors.length === 2) {
            // linear interpolation
            (assign = colors.map(function (c) { return c.lab(); }), lab0 = assign[0], lab1 = assign[1]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return lab0[i] + (t * (lab1[i] - lab0[i])); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            (assign$1 = colors.map(function (c) { return c.lab(); }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t) * lab0[i]) + (2 * (1-t) * t * lab1[i]) + (t * t * lab2[i]); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            (assign$2 = colors.map(function (c) { return c.lab(); }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t)*(1-t) * lab0[i]) + (3 * (1-t) * (1-t) * t * lab1[i]) + (3 * (1-t) * t * t * lab2[i]) + (t*t*t * lab3[i]); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 5) {
            var I0 = bezier(colors.slice(0, 3));
            var I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) {
                    return I0(t*2);
                } else {
                    return I1((t-0.5)*2);
                }
            };
        }
        return I;
    };

    var bezier_1 = function (colors) {
        var f = bezier(colors);
        f.scale = function () { return scale(f); };
        return f;
    };

    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */




    var blend = function (bottom, top, mode) {
        if (!blend[mode]) {
            throw new Error('unknown blend mode ' + mode);
        }
        return blend[mode](bottom, top);
    };

    var blend_f = function (f) { return function (bottom,top) {
            var c0 = chroma_1(top).rgb();
            var c1 = chroma_1(bottom).rgb();
            return chroma_1.rgb(f(c0, c1));
        }; };

    var each = function (f) { return function (c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        }; };

    var normal = function (a) { return a; };
    var multiply = function (a,b) { return a * b / 255; };
    var darken$1 = function (a,b) { return a > b ? b : a; };
    var lighten = function (a,b) { return a > b ? a : b; };
    var screen = function (a,b) { return 255 * (1 - (1-a/255) * (1-b/255)); };
    var overlay = function (a,b) { return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255 ) * ( 1 - b / 255 )); };
    var burn = function (a,b) { return 255 * (1 - (1 - b / 255) / (a/255)); };
    var dodge = function (a,b) {
        if (a === 255) { return 255; }
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a
    };

    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b

    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken$1));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));

    var blend_1 = blend;

    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf

    var type$k = utils.type;
    var clip_rgb$3 = utils.clip_rgb;
    var TWOPI$2 = utils.TWOPI;
    var pow$6 = Math.pow;
    var sin$2 = Math.sin;
    var cos$3 = Math.cos;


    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if ( start === void 0 ) start=300;
        if ( rotations === void 0 ) rotations=-1.5;
        if ( hue === void 0 ) hue=1;
        if ( gamma === void 0 ) gamma=1;
        if ( lightness === void 0 ) lightness=[0,1];

        var dh = 0, dl;
        if (type$k(lightness) === 'array') {
            dl = lightness[1] - lightness[0];
        } else {
            dl = 0;
            lightness = [lightness, lightness];
        }

        var f = function(fract) {
            var a = TWOPI$2 * (((start+120)/360) + (rotations * fract));
            var l = pow$6(lightness[0] + (dl * fract), gamma);
            var h = dh !== 0 ? hue[0] + (fract * dh) : hue;
            var amp = (h * l * (1-l)) / 2;
            var cos_a = cos$3(a);
            var sin_a = sin$2(a);
            var r = l + (amp * ((-0.14861 * cos_a) + (1.78277* sin_a)));
            var g = l + (amp * ((-0.29227 * cos_a) - (0.90649* sin_a)));
            var b = l + (amp * (+1.97294 * cos_a));
            return chroma_1(clip_rgb$3([r*255,g*255,b*255,1]));
        };

        f.start = function(s) {
            if ((s == null)) { return start; }
            start = s;
            return f;
        };

        f.rotations = function(r) {
            if ((r == null)) { return rotations; }
            rotations = r;
            return f;
        };

        f.gamma = function(g) {
            if ((g == null)) { return gamma; }
            gamma = g;
            return f;
        };

        f.hue = function(h) {
            if ((h == null)) { return hue; }
            hue = h;
            if (type$k(hue) === 'array') {
                dh = hue[1] - hue[0];
                if (dh === 0) { hue = hue[1]; }
            } else {
                dh = 0;
            }
            return f;
        };

        f.lightness = function(h) {
            if ((h == null)) { return lightness; }
            if (type$k(h) === 'array') {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [h,h];
                dl = 0;
            }
            return f;
        };

        f.scale = function () { return chroma_1.scale(f); };

        f.hue(hue);

        return f;
    };

    var digits = '0123456789abcdef';

    var floor$2 = Math.floor;
    var random = Math.random;

    var random_1 = function () {
        var code = '#';
        for (var i=0; i<6; i++) {
            code += digits.charAt(floor$2(random() * 16));
        }
        return new Color_1(code, 'hex');
    };

    var log$1 = Math.log;
    var pow$7 = Math.pow;
    var floor$3 = Math.floor;
    var abs = Math.abs;


    var analyze = function (data, key) {
        if ( key === void 0 ) key=null;

        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE*-1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === 'object') {
            data = Object.values(data);
        }
        data.forEach(function (val) {
            if (key && type(val) === 'object') { val = val[key]; }
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) { r.min = val; }
                if (val > r.max) { r.max = val; }
                r.count += 1;
            }
        });

        r.domain = [r.min, r.max];

        r.limits = function (mode, num) { return limits(r, mode, num); };

        return r;
    };


    var limits = function (data, mode, num) {
        if ( mode === void 0 ) mode='equal';
        if ( num === void 0 ) num=7;

        if (type(data) == 'array') {
            data = analyze(data);
        }
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function (a,b) { return a-b; });

        if (num === 1) { return [min,max]; }

        var limits = [];

        if (mode.substr(0,1) === 'c') { // continuous
            limits.push(min);
            limits.push(max);
        }

        if (mode.substr(0,1) === 'e') { // equal interval
            limits.push(min);
            for (var i=1; i<num; i++) {
                limits.push(min+((i/num)*(max-min)));
            }
            limits.push(max);
        }

        else if (mode.substr(0,1) === 'l') { // log scale
            if (min <= 0) {
                throw new Error('Logarithmic scales are only possible for values > 0');
            }
            var min_log = Math.LOG10E * log$1(min);
            var max_log = Math.LOG10E * log$1(max);
            limits.push(min);
            for (var i$1=1; i$1<num; i$1++) {
                limits.push(pow$7(10, min_log + ((i$1/num) * (max_log - min_log))));
            }
            limits.push(max);
        }

        else if (mode.substr(0,1) === 'q') { // quantile scale
            limits.push(min);
            for (var i$2=1; i$2<num; i$2++) {
                var p = ((values.length-1) * i$2)/num;
                var pb = floor$3(p);
                if (pb === p) {
                    limits.push(values[pb]);
                } else { // p > pb
                    var pr = p - pb;
                    limits.push((values[pb]*(1-pr)) + (values[pb+1]*pr));
                }
            }
            limits.push(max);

        }

        else if (mode.substr(0,1) === 'k') { // k-means clustering
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */
            var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;

            // get seed values
            centroids = [];
            centroids.push(min);
            for (var i$3=1; i$3<num; i$3++) {
                centroids.push(min + ((i$3/num) * (max-min)));
            }
            centroids.push(max);

            while (repeat) {
                // assignment step
                for (var j=0; j<num; j++) {
                    clusterSizes[j] = 0;
                }
                for (var i$4=0; i$4<n; i$4++) {
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = (void 0);
                    for (var j$1=0; j$1<num; j$1++) {
                        var dist = abs(centroids[j$1]-value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }

                // update centroids step
                var newCentroids = new Array(num);
                for (var j$2=0; j$2<num; j$2++) {
                    newCentroids[j$2] = null;
                }
                for (var i$5=0; i$5<n; i$5++) {
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) {
                        newCentroids[cluster] = values[i$5];
                    } else {
                        newCentroids[cluster] += values[i$5];
                    }
                }
                for (var j$3=0; j$3<num; j$3++) {
                    newCentroids[j$3] *= 1/clusterSizes[j$3];
                }

                // check convergence
                repeat = false;
                for (var j$4=0; j$4<num; j$4++) {
                    if (newCentroids[j$4] !== centroids[j$4]) {
                        repeat = true;
                        break;
                    }
                }

                centroids = newCentroids;
                nb_iters++;

                if (nb_iters > 200) {
                    repeat = false;
                }
            }

            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for (var j$5=0; j$5<num; j$5++) {
                kClusters[j$5] = [];
            }
            for (var i$6=0; i$6<n; i$6++) {
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for (var j$6=0; j$6<num; j$6++) {
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length-1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a,b){ return a-b; });
            limits.push(tmpKMeansBreaks[0]);
            for (var i$7=1; i$7 < tmpKMeansBreaks.length; i$7+= 2) {
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && (limits.indexOf(v) === -1)) {
                    limits.push(v);
                }
            }
        }
        return limits;
    };

    var analyze_1 = {analyze: analyze, limits: limits};

    var contrast = function (a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };

    var sqrt$4 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var abs$1 = Math.abs;
    var cos$4 = Math.cos;
    var PI$2 = Math.PI;

    var deltaE = function(a, b, L, C) {
        if ( L === void 0 ) L=1;
        if ( C === void 0 ) C=1;

        // Delta E (CMC)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CMC.html
        a = new Color_1(a);
        b = new Color_1(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var c1 = sqrt$4((a1 * a1) + (b1 * b1));
        var c2 = sqrt$4((a2 * a2) + (b2 * b2));
        var sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + (0.01765 * L1));
        var sc = ((0.0638 * c1) / (1.0 + (0.0131 * c1))) + 0.638;
        var h1 = c1 < 0.000001 ? 0.0 : (atan2$2(b1, a1) * 180.0) / PI$2;
        while (h1 < 0) { h1 += 360; }
        while (h1 >= 360) { h1 -= 360; }
        var t = (h1 >= 164.0) && (h1 <= 345.0) ? (0.56 + abs$1(0.2 * cos$4((PI$2 * (h1 + 168.0)) / 180.0))) : (0.36 + abs$1(0.4 * cos$4((PI$2 * (h1 + 35.0)) / 180.0)));
        var c4 = c1 * c1 * c1 * c1;
        var f = sqrt$4(c4 / (c4 + 1900.0));
        var sh = sc * (((f * t) + 1.0) - f);
        var delL = L1 - L2;
        var delC = c1 - c2;
        var delA = a1 - a2;
        var delB = b1 - b2;
        var dH2 = ((delA * delA) + (delB * delB)) - (delC * delC);
        var v1 = delL / (L * sl);
        var v2 = delC / (C * sc);
        var v3 = sh;
        return sqrt$4((v1 * v1) + (v2 * v2) + (dH2 / (v3 * v3)));
    };

    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if ( mode === void 0 ) mode='lab';

        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for (var i in l1) {
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d*d;
        }
        return Math.sqrt(sum_sq);
    };

    var valid = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        try {
            new (Function.prototype.bind.apply( Color_1, [ null ].concat( args) ));
            return true;
        } catch (e) {
            return false;
        }
    };

    // some pre-defined color scales:




    var scales = {
    	cool: function cool() { return scale([chroma_1.hsl(180,1,.9), chroma_1.hsl(250,.7,.4)]) },
    	hot: function hot() { return scale(['#000','#f00','#ff0','#fff'], [0,.25,.75,1]).mode('rgb') }
    };

    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */

    var colorbrewer = {
        // sequential
        OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
        PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
        BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
        Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
        BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
        YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
        YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
        Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
        RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
        Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
        YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
        Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
        GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
        Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
        YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
        PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
        Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
        PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
        Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],

        // diverging

        Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
        RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
        RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
        PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
        PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
        RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
        BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
        RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
        PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],

        // qualitative

        Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
        Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
        Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
        Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
        Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
        Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
        Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
        Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2'],
    };

    // add lowercase aliases for case-insensitive matches
    for (var i$1 = 0, list$1 = Object.keys(colorbrewer); i$1 < list$1.length; i$1 += 1) {
        var key = list$1[i$1];

        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }

    var colorbrewer_1 = colorbrewer;

    // feel free to comment out anything to rollup
    // a smaller chroma.js built

    // io --> convert colors















    // operators --> modify existing Colors










    // interpolators










    // generators -- > create new colors
    chroma_1.average = average;
    chroma_1.bezier = bezier_1;
    chroma_1.blend = blend_1;
    chroma_1.cubehelix = cubehelix;
    chroma_1.mix = chroma_1.interpolate = mix;
    chroma_1.random = random_1;
    chroma_1.scale = scale;

    // other utility methods
    chroma_1.analyze = analyze_1.analyze;
    chroma_1.contrast = contrast;
    chroma_1.deltaE = deltaE;
    chroma_1.distance = distance;
    chroma_1.limits = analyze_1.limits;
    chroma_1.valid = valid;

    // scale
    chroma_1.scales = scales;

    // colors
    chroma_1.colors = w3cx11_1;
    chroma_1.brewer = colorbrewer_1;

    var chroma_js = chroma_1;

    return chroma_js;

})));


/***/ }),

/***/ "6155":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f528");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5d6fdfde", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "634b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_id_a9ae3514_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5709");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_id_a9ae3514_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_id_a9ae3514_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_id_a9ae3514_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "63ea":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("c05f");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "642a":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("966f"),
    getMatchData = __webpack_require__("3bb4"),
    matchesStrictComparable = __webpack_require__("20ec");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "6444":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGridItem_vue_vue_type_style_index_0_id_cc71bf70_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7ecd");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGridItem_vue_vue_type_style_index_0_id_cc71bf70_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGridItem_vue_vue_type_style_index_0_id_cc71bf70_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGridItem_vue_vue_type_style_index_0_id_cc71bf70_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "656b":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("e2e4"),
    toKey = __webpack_require__("f4d6");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6716":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-hints[data-v-4a234f9e]{position:relative;margin-top:.0625rem}.ui-hints .spacer[data-v-4a234f9e]{line-height:0;height:1rem}.ui-hints .hints[data-v-4a234f9e]{position:absolute;top:0;left:0;width:100%}.hint-rise-enter-active[data-v-4a234f9e],.hint-rise-leave-active[data-v-4a234f9e]{-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform;-webkit-transition-duration:.2s;transition-duration:.2s}.hint-rise-enter[data-v-4a234f9e],.hint-rise-leave-to[data-v-4a234f9e]{opacity:0;-webkit-transform:translateY(50%);transform:translateY(50%)}.hint-rise-leave-to[data-v-4a234f9e]{position:absolute}.hints-stretch-enter-active[data-v-4a234f9e],.hints-stretch-leave-active[data-v-4a234f9e]{-webkit-transition-property:max-height;transition-property:max-height;-webkit-transition-duration:.2s;transition-duration:.2s;max-height:1rem}.hints-stretch-enter[data-v-4a234f9e],.hints-stretch-leave-to[data-v-4a234f9e]{opacity:0;max-height:0}", ""]);


/***/ }),

/***/ "6747":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "67ca":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "6912":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("756a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4b788921", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "699d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-icon[data-v-3e7d1ad4]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1em}.ui-icon.discreet[data-v-3e7d1ad4]{color:var(--c-text--lighten-50)}.ui-icon.discreet.clickable[data-v-3e7d1ad4]:hover{color:var(--c-text--lighten-20)}.ui-icon.subtle[data-v-3e7d1ad4]{color:var(--c-text--lighten-30)}.ui-icon.subtle.clickable[data-v-3e7d1ad4]:hover{color:var(--c-text)}.ui-icon.danger[data-v-3e7d1ad4]{color:var(--c-danger)}.ui-icon.danger.clickable[data-v-3e7d1ad4]:hover{color:var(--c-danger--shade-10)}.ui-icon.warning[data-v-3e7d1ad4]{color:var(--c-warning)}.ui-icon.warning.clickable[data-v-3e7d1ad4]:hover{color:var(--c-warning--shade-10)}.ui-icon.success[data-v-3e7d1ad4]{color:var(--c-success)}.ui-icon.success.clickable[data-v-3e7d1ad4]:hover{color:var(--c-success--shade-10)}.ui-icon.tiny[data-v-3e7d1ad4]{font-size:.4375rem}.ui-icon.small[data-v-3e7d1ad4]{font-size:.5rem}.ui-icon[data-v-3e7d1ad4]:not(.tiny):not(.small):not(.big):not(.huge):not(.massive){font-size:.5625rem}.ui-icon.big[data-v-3e7d1ad4]{font-size:.75rem}.ui-icon.huge[data-v-3e7d1ad4]{font-size:1.2rem}.ui-icon.massive[data-v-3e7d1ad4]{font-size:2.2rem}.ui-icon.spinning[data-v-3e7d1ad4]{-webkit-animation-name:spin-data-v-3e7d1ad4;animation-name:spin-data-v-3e7d1ad4;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.ui-icon.clickable[data-v-3e7d1ad4]{cursor:pointer}.ui-icon.mdi-timer-sand[data-v-3e7d1ad4]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}@-webkit-keyframes spin-data-v-3e7d1ad4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-data-v-3e7d1ad4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);


/***/ }),

/***/ "69d5":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6ac0":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ "6b63":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-box[data-v-f89f5386]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--c-black--opacity-5);-webkit-transition:background-color .2s;transition:background-color .2s}.ui-box[data-v-f89f5386]>:not(:last-child){margin-right:.375rem}.ui-box[data-v-f89f5386]:not(.large){-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.ui-box .icon-container[data-v-f89f5386]{-ms-flex-negative:0;flex-shrink:0}.ui-box .content[data-v-f89f5386]{width:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui-box.danger[data-v-f89f5386],.ui-box.success[data-v-f89f5386]{font-weight:500}.ui-box.success.subtle[data-v-f89f5386]{background-color:var(--c-success--tint-80);color:var(--c-success--shade-30)}.ui-box.success[data-v-f89f5386]:not(.subtle){background-color:var(--c-success);color:var(--c-text-light)}.ui-box.danger.subtle[data-v-f89f5386]{background-color:var(--c-danger--tint-80);color:var(--c-danger--shade-30)}.ui-box.danger[data-v-f89f5386]:not(.subtle){background-color:var(--c-danger);color:var(--c-text-light)}.ui-box.warning.subtle[data-v-f89f5386]{background-color:var(--c-warning--tint-80);color:var(--c-warning--shade-30)}.ui-box.warning[data-v-f89f5386]:not(.subtle){background-color:var(--c-warning);color:var(--c-text-light)}.ui-box.warning:not(.subtle).high-contrast[data-v-f89f5386]{color:#000}.ui-box.compact[data-v-f89f5386]{padding:.25rem .375rem;border-radius:.125rem}.ui-box[data-v-f89f5386]:not(.compact){padding:.5rem;border-radius:.25rem}.ui-box.small-corners[data-v-f89f5386]{border-radius:.125rem}.ui-box[data-v-f89f5386]:not(.small-corners){border-radius:.25rem}", ""]);


/***/ }),

/***/ "6d6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoadingOverlay_vue_vue_type_style_index_0_id_ab521812_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("19fd");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoadingOverlay_vue_vue_type_style_index_0_id_ab521812_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoadingOverlay_vue_vue_type_style_index_0_id_ab521812_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoadingOverlay_vue_vue_type_style_index_0_id_ab521812_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6e6b":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),

/***/ "6ed9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-grid-item[data-v-cc71bf70]{border-radius:.25rem;-webkit-transition-property:background-color,color,opacity;transition-property:background-color,color,opacity;-webkit-transition-duration:.1s;transition-duration:.1s}.ui-grid-item[data-v-cc71bf70],.ui-grid-item .content[data-v-cc71bf70]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui-grid-item .content[data-v-cc71bf70]>:not(:last-child){margin-bottom:.125rem}.ui-grid-item.dense[data-v-cc71bf70]>:not(:last-child){margin-bottom:.25rem}.ui-grid-item.sparse[data-v-cc71bf70]>:not(:last-child){margin-bottom:.75rem}.ui-grid-item.interactable[data-v-cc71bf70]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui-grid-item.disabled[data-v-cc71bf70]{cursor:not-allowed}.ui-grid-item.translucent.light[data-v-cc71bf70]{background-color:var(--c-black--opacity-3)}.ui-grid-item.translucent.light.highlighted[data-v-cc71bf70],.ui-grid-item.translucent.light.interactable[data-v-cc71bf70]:hover{background-color:var(--c-black--opacity-10)}.ui-grid-item.opaque[data-v-cc71bf70]{background-color:var(--c-white)}.ui-grid-item.opaque.highlighted[data-v-cc71bf70],.ui-grid-item.opaque.interactable[data-v-cc71bf70]:hover{background-color:var(--c-black--opacity-5)}.ui-grid-item.fill[data-v-cc71bf70]{width:100%;height:100%}.ui-grid-item.disabled[data-v-cc71bf70]{opacity:.4}", ""]);


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "6f6c":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "6fcd":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("50d8"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isIndex = __webpack_require__("c098"),
    isTypedArray = __webpack_require__("73ac");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "70b9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-card[data-v-2343ce25]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-transition-property:background-color,-webkit-box-shadow;transition-property:background-color,-webkit-box-shadow;transition-property:box-shadow,background-color;transition-property:box-shadow,background-color,-webkit-box-shadow;-webkit-transition-duration:.2s;transition-duration:.2s}.ui-card[data-v-2343ce25],.ui-card .ui-card-header[data-v-2343ce25]{display:-webkit-box;display:-ms-flexbox;display:flex}.ui-card .ui-card-header[data-v-2343ce25]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0}.ui-card .ui-card-header[data-v-2343ce25]>:not(:last-child){margin-right:.25rem}.ui-card .ui-card-header .ui-card-header-icon[data-v-2343ce25]{-ms-flex-negative:0;flex-shrink:0}.ui-card .ui-card-header .ui-card-header-right[data-v-2343ce25]{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-card .ui-card-header .ui-card-heading[data-v-2343ce25],.ui-card .ui-card-main[data-v-2343ce25]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui-card .ui-card-footer[data-v-2343ce25]{-ms-flex-negative:0;flex-shrink:0}.ui-card[data-v-2343ce25]:not(.compact)>:not(:last-child){margin-bottom:.75rem}.ui-card:not(.compact) .ui-card-header[data-v-2343ce25]{padding-top:.75rem;padding-left:.75rem;padding-right:.75rem}.ui-card:not(.compact) .ui-card-header[data-v-2343ce25]:last-child{padding-bottom:.75rem}.ui-card:not(.compact) .ui-card-footer[data-v-2343ce25]{padding-bottom:.75rem}.ui-card:not(.compact) .ui-card-footer[data-v-2343ce25],.ui-card:not(.compact).with-padding .ui-card-main[data-v-2343ce25]{padding-left:.75rem;padding-right:.75rem}.ui-card:not(.compact).with-padding .ui-card-main[data-v-2343ce25]:first-child{padding-top:.75rem}.ui-card:not(.compact).with-padding .ui-card-main[data-v-2343ce25]:last-child{padding-bottom:.75rem}.ui-card.compact[data-v-2343ce25]>:not(:last-child){margin-bottom:.5rem}.ui-card.compact .ui-card-header[data-v-2343ce25]{padding-top:.5rem;padding-left:.5rem;padding-right:.5rem}.ui-card.compact .ui-card-header[data-v-2343ce25]:last-child{padding-bottom:.5rem}.ui-card.compact .ui-card-footer[data-v-2343ce25]{padding-bottom:.5rem}.ui-card.compact .ui-card-footer[data-v-2343ce25],.ui-card.compact.with-padding .ui-card-main[data-v-2343ce25]{padding-left:.5rem;padding-right:.5rem}.ui-card.compact.with-padding .ui-card-main[data-v-2343ce25]:first-child{padding-top:.5rem}.ui-card.compact.with-padding .ui-card-main[data-v-2343ce25]:last-child{padding-bottom:.5rem}.ui-card.scrollable .ui-card-main[data-v-2343ce25]{overflow-y:auto}.ui-card.opaque[data-v-2343ce25]{background-color:#fff}.ui-card[data-v-2343ce25]:not(.opaque){background-color:var(--c-black--opacity-5)}.ui-card.flat[data-v-2343ce25]{-webkit-box-shadow:none;box-shadow:none}.ui-card[data-v-2343ce25]:not(.flat):not(.floating){-webkit-box-shadow:0 0 .1875rem rgba(0,0,0,.05),0 .1875rem .375rem rgba(0,0,0,.1);box-shadow:0 0 .1875rem rgba(0,0,0,.05),0 .1875rem .375rem rgba(0,0,0,.1)}.ui-card.floating[data-v-2343ce25]{-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15)}.ui-card.rounded-corners[data-v-2343ce25]{border-radius:.25rem}", ""]);


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7228":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-list-item[data-v-720b8e2e]{position:relative;border-radius:.125rem;-webkit-transition:.2s;transition:.2s;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-list-item .icon[data-v-720b8e2e]{-ms-flex-negative:0;flex-shrink:0}.ui-list-item .main[data-v-720b8e2e]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;min-width:0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-right:.5rem}.ui-list-item.enabled[data-v-720b8e2e]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui-list-item.enabled[data-v-720b8e2e]:hover{cursor:pointer}.ui-list-item.dark[data-v-720b8e2e]{background-color:var(--c-black--opacity-3)}.ui-list-item.dark.enabled[data-v-720b8e2e]:hover{background-color:var(--c-black--opacity-10)}.ui-list-item.dark.highlighted.regular-highlight[data-v-720b8e2e]{background-color:var(--c-black--opacity-15)}.ui-list-item.dark.highlighted.primary-highlight[data-v-720b8e2e]{background-color:var(--c-primary)}.ui-list-item.white[data-v-720b8e2e]{background-color:var(--c-white)}.ui-list-item.white:not(.floating).enabled[data-v-720b8e2e]:hover{background-color:var(--c-black--opacity-5)}.ui-list-item.white.floating.enabled[data-v-720b8e2e]:hover{background-color:var(--c-white--shade-5)}.ui-list-item.white.highlighted.regular-highlight[data-v-720b8e2e]{background-color:var(--c-black--opacity-5)}.ui-list-item.white.highlighted.primary-highlight[data-v-720b8e2e]{background-color:var(--c-primary)}.ui-list-item.subtle[data-v-720b8e2e]{background:none}.ui-list-item.subtle.enabled[data-v-720b8e2e]:hover{background-color:var(--c-black--opacity-5)}.ui-list-item.subtle.highlighted.regular-highlight[data-v-720b8e2e]{background-color:var(--c-black--opacity-15)}.ui-list-item.subtle.highlighted.primary-highlight[data-v-720b8e2e]{background-color:var(--c-primary)}.ui-list-item.success[data-v-720b8e2e]{background-color:var(--c-success--tint-80)}.ui-list-item.spacious[data-v-720b8e2e]{padding:.5rem}.ui-list-item.spacious[data-v-720b8e2e]>:not(:last-child){margin-right:.5rem}.ui-list-item.compact[data-v-720b8e2e]{padding:.25rem .375rem}.ui-list-item.compact[data-v-720b8e2e]>:not(:last-child){margin-right:.25rem}.ui-list-item.tight[data-v-720b8e2e]{padding:.125rem .25rem}.ui-list-item.tight[data-v-720b8e2e]>:not(:last-child){margin-right:.25rem}.ui-list-item.no-horizontal-padding[data-v-720b8e2e]{padding-left:0;padding-right:0}.ui-list-item.disabled[data-v-720b8e2e]{cursor:not-allowed;opacity:.5}.ui-list-item.floating[data-v-720b8e2e]{-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15)}", ""]);


/***/ }),

/***/ "72af":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("99cd");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "72f0":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "73ac":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("743f"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7426":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".emoji-picker-container[data-v-1ac18318]{padding:.5rem;height:8rem;overflow-y:auto;color:#000;background-color:var(--c-white);-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);border-radius:.25rem}.emoji-picker-container[data-v-1ac18318]>:not(:last-child){margin-bottom:.5rem}.emoji-picker-container .emoji-picker[data-v-1ac18318]{width:8rem}.emoji-picker-container .emoji-picker[data-v-1ac18318]>:not(:last-child){margin-bottom:.25rem}.emoji-picker-container .emoji-picker .emoji-list[data-v-1ac18318]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.emoji-picker-container .emoji-picker .emoji-list .emoji[data-v-1ac18318]{font-size:.625rem;width:1rem;height:1rem;padding:0;color:#000!important}.emoji-picker-container .emoji-picker .emoji-list .emoji[data-v-1ac18318]:hover{color:#000}", ""]);


/***/ }),

/***/ "743f":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isLength = __webpack_require__("b218"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("c032");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "750a":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("c869"),
    noop = __webpack_require__("bcdf"),
    setToArray = __webpack_require__("ac41");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "750d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCode_vue_vue_type_style_index_0_id_8fad4ba8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a570");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCode_vue_vue_type_style_index_0_id_8fad4ba8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCode_vue_vue_type_style_index_0_id_8fad4ba8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCode_vue_vue_type_style_index_0_id_8fad4ba8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7530":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "756a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-stepper .inputs[data-v-339cf9da]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-stepper .inputs[data-v-339cf9da]>:not(:last-child){margin-right:.25rem}.ui-stepper .inputs .numbers[data-v-339cf9da]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:.625rem;font-weight:700}.ui-stepper .inputs .numbers[data-v-339cf9da]>:not(:last-child){margin-right:.125rem}.ui-stepper .inputs .numbers .forward-slash[data-v-339cf9da],.ui-stepper .inputs .numbers .numerator[data-v-339cf9da]{color:var(--c-text--lighten-50)}.ui-stepper .inputs .numbers.increase .change[data-v-339cf9da]{color:var(--c-success)}.ui-stepper .inputs .numbers.decrease .change[data-v-339cf9da],.ui-stepper .inputs .numbers.denominator-less-than-numerator .value[data-v-339cf9da]{color:var(--c-danger)}.ui-stepper .inputs .numbers.has-numerator-tooltip .numerator[data-v-339cf9da]{cursor:help}.ui-stepper.align-to-center[data-v-339cf9da]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);


/***/ }),

/***/ "76dd":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("ce86");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "76e7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-table-cell-content[data-v-9f12c722]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.ui-table-cell-content .no-value[data-v-9f12c722]{color:var(--c-text--lighten-40)}", ""]);


/***/ }),

/***/ "77f3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextInput_vue_vue_type_style_index_0_id_62917763_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dfc6");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextInput_vue_vue_type_style_index_0_id_62917763_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextInput_vue_vue_type_style_index_0_id_62917763_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextInput_vue_vue_type_style_index_0_id_62917763_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7948":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "79bc":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "7a48":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "7aaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_id_3e7d1ad4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3879");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_id_3e7d1ad4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_id_3e7d1ad4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_id_3e7d1ad4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7b83":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("7c64"),
    mapCacheDelete = __webpack_require__("93ed"),
    mapCacheGet = __webpack_require__("2478"),
    mapCacheHas = __webpack_require__("a524"),
    mapCacheSet = __webpack_require__("1fc8");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "7b8c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e3f5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("16c6c339", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7b97":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    equalArrays = __webpack_require__("a2be"),
    equalByTag = __webpack_require__("1c3c"),
    equalObjects = __webpack_require__("b1e5"),
    getTag = __webpack_require__("42a2"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isTypedArray = __webpack_require__("73ac");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "7c64":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("e24b"),
    ListCache = __webpack_require__("5e2e"),
    Map = __webpack_require__("79bc");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");
var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;


/***/ }),

/***/ "7d1f":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("087d"),
    isArray = __webpack_require__("6747");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "7d6c":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".fade-enter-active[data-v-ab521812],.fade-leave-active[data-v-ab521812]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.2s;transition-duration:.2s}.fade-enter[data-v-ab521812],.fade-leave-to[data-v-ab521812]{opacity:0}.ui-loading-overlay[data-v-ab521812]{position:absolute;top:0;left:0;width:100%;height:100%;z-index:40;background-color:var(--c-overlay-light);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-loading-overlay.opaque[data-v-ab521812]{background-color:var(--c-white)}.ui-loading-overlay.aboveOverlay[data-v-ab521812]{z-index:80}", ""]);


/***/ }),

/***/ "7d92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGrid_vue_vue_type_style_index_0_id_74847860_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0c06");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGrid_vue_vue_type_style_index_0_id_74847860_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGrid_vue_vue_type_style_index_0_id_74847860_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiGrid_vue_vue_type_style_index_0_id_74847860_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7e64":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e"),
    stackClear = __webpack_require__("efb6"),
    stackDelete = __webpack_require__("2fcc"),
    stackGet = __webpack_require__("802a"),
    stackHas = __webpack_require__("55a3"),
    stackSet = __webpack_require__("d02c");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "7ecd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6ed9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3fb6e44c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7ed2":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "7f1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmptyState_vue_vue_type_style_index_0_id_a52249aa_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c1cc");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmptyState_vue_vue_type_style_index_0_id_a52249aa_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmptyState_vue_vue_type_style_index_0_id_a52249aa_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmptyState_vue_vue_type_style_index_0_id_a52249aa_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "802a":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "8057":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "829c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButtonCollection_vue_vue_type_style_index_0_id_2c57e4ef_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a846");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButtonCollection_vue_vue_type_style_index_0_id_2c57e4ef_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButtonCollection_vue_vue_type_style_index_0_id_2c57e4ef_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButtonCollection_vue_vue_type_style_index_0_id_2c57e4ef_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "8464":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4bb4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("283a1d32", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "84a2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "8595":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-table[data-v-1f3adc3a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto}.ui-table table[data-v-1f3adc3a]{table-layout:auto;border-collapse:separate;border-spacing:0 .125rem;margin-top:-.125rem;overflow:visible;width:100%;height:100%;-ms-flex-negative:0;flex-shrink:0}.ui-table table .group-header-spacer[data-v-1f3adc3a]{height:.75rem}.ui-table .footer[data-v-1f3adc3a]{width:100%;position:-webkit-sticky;position:sticky;left:0;right:0}.ui-table .footer.button[data-v-1f3adc3a]{padding:.5rem 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);


/***/ }),

/***/ "85e3":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "8604":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("26e8"),
    hasPath = __webpack_require__("e2c0");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "872a":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("3b4a");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "8834":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-empty-state[data-v-a52249aa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui-empty-state .message[data-v-a52249aa]{font-weight:700}.ui-empty-state .description[data-v-a52249aa],.ui-empty-state .message[data-v-a52249aa]{text-align:center}.ui-empty-state.small .message[data-v-a52249aa]{margin-top:0}.ui-empty-state.small .description[data-v-a52249aa]{margin-top:.125rem}.ui-empty-state.small .slot-container[data-v-a52249aa],.ui-empty-state:not(.small):not(.huge) .description[data-v-a52249aa],.ui-empty-state:not(.small):not(.huge) .message[data-v-a52249aa]{margin-top:.25rem}.ui-empty-state:not(.small):not(.huge) .slot-container[data-v-a52249aa]{margin-top:.5rem}.ui-empty-state.huge .message[data-v-a52249aa]{margin-top:1.25rem}.ui-empty-state.huge .description[data-v-a52249aa]{margin-top:.5rem}.ui-empty-state.huge .slot-container[data-v-a52249aa]{margin-top:1rem}.ui-empty-state.small[data-v-a52249aa]{font-size:.375rem}.ui-empty-state.huge .message[data-v-a52249aa]{font-weight:700;font-size:1rem;line-height:1.2em}.ui-empty-state.huge .description[data-v-a52249aa]{font-size:.625rem;opacity:.6;line-height:1.2em}.ui-empty-state:not(.light).subtle .description[data-v-a52249aa],.ui-empty-state:not(.light).subtle .icon[data-v-a52249aa],.ui-empty-state:not(.light).subtle .message[data-v-a52249aa]{color:var(--c-text--lighten-20)}.ui-empty-state:not(.light):not(.subtle) .description[data-v-a52249aa],.ui-empty-state:not(.light):not(.subtle) .icon[data-v-a52249aa],.ui-empty-state:not(.light):not(.subtle) .message[data-v-a52249aa]{color:var(--c-text--lighten-10)}.ui-empty-state.light .description[data-v-a52249aa],.ui-empty-state.light .icon[data-v-a52249aa],.ui-empty-state.light .message[data-v-a52249aa]{color:var(--c-text-light)}.ui-empty-state.fill[data-v-a52249aa]{width:100%;height:100%}", ""]);


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");

var functionToString = Function.toString;

module.exports = shared('inspectSource', function (it) {
  return functionToString.call(it);
});


/***/ }),

/***/ "8a2d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("21e7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6021bbe0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8adb":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8db3":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("47f5");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "8de2":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keysIn = __webpack_require__("9934");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "8e9a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-menu[data-v-7a58c329]{min-width:8rem;max-width:12rem;min-height:1rem;max-height:14rem;-ms-overflow-y:scroll;background-color:var(--c-white);-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);border-radius:.125rem;padding:.25rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui-menu[data-v-7a58c329]>:not(:last-child){margin-bottom:.25rem}.ui-menu .filter-input[data-v-7a58c329]{-ms-flex-negative:0;flex-shrink:0}.ui-menu .list[data-v-7a58c329]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow-y:auto}.title[data-v-7a58c329]{font-size:.4375rem;font-weight:500;color:var(--c-text);word-break:break-word}.title.selected[data-v-7a58c329]{font-weight:700}.title.disabled[data-v-7a58c329]{color:var(--c-text--lighten-40)}.subtitle[data-v-7a58c329]{word-break:break-word;font-size:.375rem;font-weight:500;color:var(--c-text--lighten-30);line-height:1.3em}", ""]);


/***/ }),

/***/ "8eeb":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("32b3"),
    baseAssignValue = __webpack_require__("872a");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "914f":
/***/ (function(module) {

module.exports = JSON.parse("[{\"emoji\":\"😀\",\"description\":\"grinning face\",\"category\":\"People\",\"aliases\":[\"grinning\"],\"tags\":[\"smile\",\"happy\"],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😃\",\"description\":\"smiling face with open mouth\",\"category\":\"People\",\"aliases\":[\"smiley\"],\"tags\":[\"happy\",\"joy\",\"haha\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😄\",\"description\":\"smiling face with open mouth & smiling eyes\",\"category\":\"People\",\"aliases\":[\"smile\"],\"tags\":[\"happy\",\"joy\",\"laugh\",\"pleased\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😁\",\"description\":\"grinning face with smiling eyes\",\"category\":\"People\",\"aliases\":[\"grin\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😆\",\"description\":\"smiling face with open mouth & closed eyes\",\"category\":\"People\",\"aliases\":[\"laughing\",\"satisfied\"],\"tags\":[\"happy\",\"haha\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😅\",\"description\":\"smiling face with open mouth & cold sweat\",\"category\":\"People\",\"aliases\":[\"sweat_smile\"],\"tags\":[\"hot\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😂\",\"description\":\"face with tears of joy\",\"category\":\"People\",\"aliases\":[\"joy\"],\"tags\":[\"tears\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤣\",\"description\":\"rolling on the floor laughing\",\"category\":\"People\",\"aliases\":[\"rofl\"],\"tags\":[\"lol\",\"laughing\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"☺️\",\"description\":\"smiling face\",\"category\":\"People\",\"aliases\":[\"relaxed\"],\"tags\":[\"blush\",\"pleased\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"😊\",\"description\":\"smiling face with smiling eyes\",\"category\":\"People\",\"aliases\":[\"blush\"],\"tags\":[\"proud\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😇\",\"description\":\"smiling face with halo\",\"category\":\"People\",\"aliases\":[\"innocent\"],\"tags\":[\"angel\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙂\",\"description\":\"slightly smiling face\",\"category\":\"People\",\"aliases\":[\"slightly_smiling_face\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🙃\",\"description\":\"upside-down face\",\"category\":\"People\",\"aliases\":[\"upside_down_face\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"😉\",\"description\":\"winking face\",\"category\":\"People\",\"aliases\":[\"wink\"],\"tags\":[\"flirt\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😌\",\"description\":\"relieved face\",\"category\":\"People\",\"aliases\":[\"relieved\"],\"tags\":[\"whew\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😍\",\"description\":\"smiling face with heart-eyes\",\"category\":\"People\",\"aliases\":[\"heart_eyes\"],\"tags\":[\"love\",\"crush\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😘\",\"description\":\"face blowing a kiss\",\"category\":\"People\",\"aliases\":[\"kissing_heart\"],\"tags\":[\"flirt\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😗\",\"description\":\"kissing face\",\"category\":\"People\",\"aliases\":[\"kissing\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😙\",\"description\":\"kissing face with smiling eyes\",\"category\":\"People\",\"aliases\":[\"kissing_smiling_eyes\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😚\",\"description\":\"kissing face with closed eyes\",\"category\":\"People\",\"aliases\":[\"kissing_closed_eyes\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😋\",\"description\":\"face savouring delicious food\",\"category\":\"People\",\"aliases\":[\"yum\"],\"tags\":[\"tongue\",\"lick\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😜\",\"description\":\"face with stuck-out tongue & winking eye\",\"category\":\"People\",\"aliases\":[\"stuck_out_tongue_winking_eye\"],\"tags\":[\"prank\",\"silly\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😝\",\"description\":\"face with stuck-out tongue & closed eyes\",\"category\":\"People\",\"aliases\":[\"stuck_out_tongue_closed_eyes\"],\"tags\":[\"prank\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😛\",\"description\":\"face with stuck-out tongue\",\"category\":\"People\",\"aliases\":[\"stuck_out_tongue\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤑\",\"description\":\"money-mouth face\",\"category\":\"People\",\"aliases\":[\"money_mouth_face\"],\"tags\":[\"rich\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤗\",\"description\":\"hugging face\",\"category\":\"People\",\"aliases\":[\"hugs\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤓\",\"description\":\"nerd face\",\"category\":\"People\",\"aliases\":[\"nerd_face\"],\"tags\":[\"geek\",\"glasses\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"😎\",\"description\":\"smiling face with sunglasses\",\"category\":\"People\",\"aliases\":[\"sunglasses\"],\"tags\":[\"cool\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤡\",\"description\":\"clown face\",\"category\":\"People\",\"aliases\":[\"clown_face\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤠\",\"description\":\"cowboy hat face\",\"category\":\"People\",\"aliases\":[\"cowboy_hat_face\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"😏\",\"description\":\"smirking face\",\"category\":\"People\",\"aliases\":[\"smirk\"],\"tags\":[\"smug\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😒\",\"description\":\"unamused face\",\"category\":\"People\",\"aliases\":[\"unamused\"],\"tags\":[\"meh\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😞\",\"description\":\"disappointed face\",\"category\":\"People\",\"aliases\":[\"disappointed\"],\"tags\":[\"sad\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😔\",\"description\":\"pensive face\",\"category\":\"People\",\"aliases\":[\"pensive\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😟\",\"description\":\"worried face\",\"category\":\"People\",\"aliases\":[\"worried\"],\"tags\":[\"nervous\"],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😕\",\"description\":\"confused face\",\"category\":\"People\",\"aliases\":[\"confused\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙁\",\"description\":\"slightly frowning face\",\"category\":\"People\",\"aliases\":[\"slightly_frowning_face\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"☹️\",\"description\":\"frowning face\",\"category\":\"People\",\"aliases\":[\"frowning_face\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"😣\",\"description\":\"persevering face\",\"category\":\"People\",\"aliases\":[\"persevere\"],\"tags\":[\"struggling\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😖\",\"description\":\"confounded face\",\"category\":\"People\",\"aliases\":[\"confounded\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😫\",\"description\":\"tired face\",\"category\":\"People\",\"aliases\":[\"tired_face\"],\"tags\":[\"upset\",\"whine\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😩\",\"description\":\"weary face\",\"category\":\"People\",\"aliases\":[\"weary\"],\"tags\":[\"tired\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😤\",\"description\":\"face with steam from nose\",\"category\":\"People\",\"aliases\":[\"triumph\"],\"tags\":[\"smug\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😠\",\"description\":\"angry face\",\"category\":\"People\",\"aliases\":[\"angry\"],\"tags\":[\"mad\",\"annoyed\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😡\",\"description\":\"pouting face\",\"category\":\"People\",\"aliases\":[\"rage\",\"pout\"],\"tags\":[\"angry\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😶\",\"description\":\"face without mouth\",\"category\":\"People\",\"aliases\":[\"no_mouth\"],\"tags\":[\"mute\",\"silence\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😐\",\"description\":\"neutral face\",\"category\":\"People\",\"aliases\":[\"neutral_face\"],\"tags\":[\"meh\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😑\",\"description\":\"expressionless face\",\"category\":\"People\",\"aliases\":[\"expressionless\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😯\",\"description\":\"hushed face\",\"category\":\"People\",\"aliases\":[\"hushed\"],\"tags\":[\"silence\",\"speechless\"],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😦\",\"description\":\"frowning face with open mouth\",\"category\":\"People\",\"aliases\":[\"frowning\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😧\",\"description\":\"anguished face\",\"category\":\"People\",\"aliases\":[\"anguished\"],\"tags\":[\"stunned\"],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😮\",\"description\":\"face with open mouth\",\"category\":\"People\",\"aliases\":[\"open_mouth\"],\"tags\":[\"surprise\",\"impressed\",\"wow\"],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"😲\",\"description\":\"astonished face\",\"category\":\"People\",\"aliases\":[\"astonished\"],\"tags\":[\"amazed\",\"gasp\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😵\",\"description\":\"dizzy face\",\"category\":\"People\",\"aliases\":[\"dizzy_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😳\",\"description\":\"flushed face\",\"category\":\"People\",\"aliases\":[\"flushed\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😱\",\"description\":\"face screaming in fear\",\"category\":\"People\",\"aliases\":[\"scream\"],\"tags\":[\"horror\",\"shocked\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😨\",\"description\":\"fearful face\",\"category\":\"People\",\"aliases\":[\"fearful\"],\"tags\":[\"scared\",\"shocked\",\"oops\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😰\",\"description\":\"face with open mouth & cold sweat\",\"category\":\"People\",\"aliases\":[\"cold_sweat\"],\"tags\":[\"nervous\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😢\",\"description\":\"crying face\",\"category\":\"People\",\"aliases\":[\"cry\"],\"tags\":[\"sad\",\"tear\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😥\",\"description\":\"disappointed but relieved face\",\"category\":\"People\",\"aliases\":[\"disappointed_relieved\"],\"tags\":[\"phew\",\"sweat\",\"nervous\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤤\",\"description\":\"drooling face\",\"category\":\"People\",\"aliases\":[\"drooling_face\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"😭\",\"description\":\"loudly crying face\",\"category\":\"People\",\"aliases\":[\"sob\"],\"tags\":[\"sad\",\"cry\",\"bawling\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😓\",\"description\":\"face with cold sweat\",\"category\":\"People\",\"aliases\":[\"sweat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😪\",\"description\":\"sleepy face\",\"category\":\"People\",\"aliases\":[\"sleepy\"],\"tags\":[\"tired\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😴\",\"description\":\"sleeping face\",\"category\":\"People\",\"aliases\":[\"sleeping\"],\"tags\":[\"zzz\"],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙄\",\"description\":\"face with rolling eyes\",\"category\":\"People\",\"aliases\":[\"roll_eyes\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤔\",\"description\":\"thinking face\",\"category\":\"People\",\"aliases\":[\"thinking\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤥\",\"description\":\"lying face\",\"category\":\"People\",\"aliases\":[\"lying_face\"],\"tags\":[\"liar\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"😬\",\"description\":\"grimacing face\",\"category\":\"People\",\"aliases\":[\"grimacing\"],\"tags\":[],\"unicode_version\":\"6.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤐\",\"description\":\"zipper-mouth face\",\"category\":\"People\",\"aliases\":[\"zipper_mouth_face\"],\"tags\":[\"silence\",\"hush\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤢\",\"description\":\"nauseated face\",\"category\":\"People\",\"aliases\":[\"nauseated_face\"],\"tags\":[\"sick\",\"barf\",\"disgusted\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤧\",\"description\":\"sneezing face\",\"category\":\"People\",\"aliases\":[\"sneezing_face\"],\"tags\":[\"achoo\",\"sick\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"😷\",\"description\":\"face with medical mask\",\"category\":\"People\",\"aliases\":[\"mask\"],\"tags\":[\"sick\",\"ill\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤒\",\"description\":\"face with thermometer\",\"category\":\"People\",\"aliases\":[\"face_with_thermometer\"],\"tags\":[\"sick\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤕\",\"description\":\"face with head-bandage\",\"category\":\"People\",\"aliases\":[\"face_with_head_bandage\"],\"tags\":[\"hurt\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"😈\",\"description\":\"smiling face with horns\",\"category\":\"People\",\"aliases\":[\"smiling_imp\"],\"tags\":[\"devil\",\"evil\",\"horns\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👿\",\"description\":\"angry face with horns\",\"category\":\"People\",\"aliases\":[\"imp\"],\"tags\":[\"angry\",\"devil\",\"evil\",\"horns\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👹\",\"description\":\"ogre\",\"category\":\"People\",\"aliases\":[\"japanese_ogre\"],\"tags\":[\"monster\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👺\",\"description\":\"goblin\",\"category\":\"People\",\"aliases\":[\"japanese_goblin\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💩\",\"description\":\"pile of poo\",\"category\":\"People\",\"aliases\":[\"hankey\",\"poop\",\"shit\"],\"tags\":[\"crap\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👻\",\"description\":\"ghost\",\"category\":\"People\",\"aliases\":[\"ghost\"],\"tags\":[\"halloween\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💀\",\"description\":\"skull\",\"category\":\"People\",\"aliases\":[\"skull\"],\"tags\":[\"dead\",\"danger\",\"poison\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☠️\",\"description\":\"skull and crossbones\",\"category\":\"People\",\"aliases\":[\"skull_and_crossbones\"],\"tags\":[\"danger\",\"pirate\"],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"👽\",\"description\":\"alien\",\"category\":\"People\",\"aliases\":[\"alien\"],\"tags\":[\"ufo\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👾\",\"description\":\"alien monster\",\"category\":\"People\",\"aliases\":[\"space_invader\"],\"tags\":[\"game\",\"retro\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤖\",\"description\":\"robot face\",\"category\":\"People\",\"aliases\":[\"robot\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎃\",\"description\":\"jack-o-lantern\",\"category\":\"People\",\"aliases\":[\"jack_o_lantern\"],\"tags\":[\"halloween\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😺\",\"description\":\"smiling cat face with open mouth\",\"category\":\"People\",\"aliases\":[\"smiley_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😸\",\"description\":\"grinning cat face with smiling eyes\",\"category\":\"People\",\"aliases\":[\"smile_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😹\",\"description\":\"cat face with tears of joy\",\"category\":\"People\",\"aliases\":[\"joy_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😻\",\"description\":\"smiling cat face with heart-eyes\",\"category\":\"People\",\"aliases\":[\"heart_eyes_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😼\",\"description\":\"cat face with wry smile\",\"category\":\"People\",\"aliases\":[\"smirk_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😽\",\"description\":\"kissing cat face with closed eyes\",\"category\":\"People\",\"aliases\":[\"kissing_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙀\",\"description\":\"weary cat face\",\"category\":\"People\",\"aliases\":[\"scream_cat\"],\"tags\":[\"horror\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😿\",\"description\":\"crying cat face\",\"category\":\"People\",\"aliases\":[\"crying_cat_face\"],\"tags\":[\"sad\",\"tear\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"😾\",\"description\":\"pouting cat face\",\"category\":\"People\",\"aliases\":[\"pouting_cat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👐\",\"description\":\"open hands\",\"category\":\"People\",\"aliases\":[\"open_hands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙌\",\"description\":\"raising hands\",\"category\":\"People\",\"aliases\":[\"raised_hands\"],\"tags\":[\"hooray\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👏\",\"description\":\"clapping hands\",\"category\":\"People\",\"aliases\":[\"clap\"],\"tags\":[\"praise\",\"applause\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙏\",\"description\":\"folded hands\",\"category\":\"People\",\"aliases\":[\"pray\"],\"tags\":[\"please\",\"hope\",\"wish\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤝\",\"description\":\"handshake\",\"category\":\"People\",\"aliases\":[\"handshake\"],\"tags\":[\"deal\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"👍\",\"description\":\"thumbs up\",\"category\":\"People\",\"aliases\":[\"+1\",\"thumbsup\"],\"tags\":[\"approve\",\"ok\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👎\",\"description\":\"thumbs down\",\"category\":\"People\",\"aliases\":[\"-1\",\"thumbsdown\"],\"tags\":[\"disapprove\",\"bury\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👊\",\"description\":\"oncoming fist\",\"category\":\"People\",\"aliases\":[\"fist_oncoming\",\"facepunch\",\"punch\"],\"tags\":[\"attack\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✊\",\"description\":\"raised fist\",\"category\":\"People\",\"aliases\":[\"fist_raised\",\"fist\"],\"tags\":[\"power\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤛\",\"description\":\"left-facing fist\",\"category\":\"People\",\"aliases\":[\"fist_left\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤜\",\"description\":\"right-facing fist\",\"category\":\"People\",\"aliases\":[\"fist_right\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤞\",\"description\":\"crossed fingers\",\"category\":\"People\",\"aliases\":[\"crossed_fingers\"],\"tags\":[\"luck\",\"hopeful\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"✌️\",\"description\":\"victory hand\",\"category\":\"People\",\"aliases\":[\"v\"],\"tags\":[\"victory\",\"peace\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤘\",\"description\":\"sign of the horns\",\"category\":\"People\",\"aliases\":[\"metal\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"👌\",\"description\":\"OK hand\",\"category\":\"People\",\"aliases\":[\"ok_hand\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👈\",\"description\":\"backhand index pointing left\",\"category\":\"People\",\"aliases\":[\"point_left\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👉\",\"description\":\"backhand index pointing right\",\"category\":\"People\",\"aliases\":[\"point_right\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👆\",\"description\":\"backhand index pointing up\",\"category\":\"People\",\"aliases\":[\"point_up_2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👇\",\"description\":\"backhand index pointing down\",\"category\":\"People\",\"aliases\":[\"point_down\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☝️\",\"description\":\"index pointing up\",\"category\":\"People\",\"aliases\":[\"point_up\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"✋\",\"description\":\"raised hand\",\"category\":\"People\",\"aliases\":[\"hand\",\"raised_hand\"],\"tags\":[\"highfive\",\"stop\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤚\",\"description\":\"raised back of hand\",\"category\":\"People\",\"aliases\":[\"raised_back_of_hand\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🖐\",\"description\":\"raised hand with fingers splayed\",\"category\":\"People\",\"aliases\":[\"raised_hand_with_fingers_splayed\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖖\",\"description\":\"vulcan salute\",\"category\":\"People\",\"aliases\":[\"vulcan_salute\"],\"tags\":[\"prosper\",\"spock\"],\"unicode_version\":\"7.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👋\",\"description\":\"waving hand\",\"category\":\"People\",\"aliases\":[\"wave\"],\"tags\":[\"goodbye\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤙\",\"description\":\"call me hand\",\"category\":\"People\",\"aliases\":[\"call_me_hand\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"💪\",\"description\":\"flexed biceps\",\"category\":\"People\",\"aliases\":[\"muscle\"],\"tags\":[\"flex\",\"bicep\",\"strong\",\"workout\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🖕\",\"description\":\"middle finger\",\"category\":\"People\",\"aliases\":[\"middle_finger\",\"fu\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"✍️\",\"description\":\"writing hand\",\"category\":\"People\",\"aliases\":[\"writing_hand\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤳\",\"description\":\"selfie\",\"category\":\"People\",\"aliases\":[\"selfie\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"💅\",\"description\":\"nail polish\",\"category\":\"People\",\"aliases\":[\"nail_care\"],\"tags\":[\"beauty\",\"manicure\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💍\",\"description\":\"ring\",\"category\":\"People\",\"aliases\":[\"ring\"],\"tags\":[\"wedding\",\"marriage\",\"engaged\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💄\",\"description\":\"lipstick\",\"category\":\"People\",\"aliases\":[\"lipstick\"],\"tags\":[\"makeup\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💋\",\"description\":\"kiss mark\",\"category\":\"People\",\"aliases\":[\"kiss\"],\"tags\":[\"lipstick\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👄\",\"description\":\"mouth\",\"category\":\"People\",\"aliases\":[\"lips\"],\"tags\":[\"kiss\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👅\",\"description\":\"tongue\",\"category\":\"People\",\"aliases\":[\"tongue\"],\"tags\":[\"taste\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👂\",\"description\":\"ear\",\"category\":\"People\",\"aliases\":[\"ear\"],\"tags\":[\"hear\",\"sound\",\"listen\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👃\",\"description\":\"nose\",\"category\":\"People\",\"aliases\":[\"nose\"],\"tags\":[\"smell\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👣\",\"description\":\"footprints\",\"category\":\"People\",\"aliases\":[\"footprints\"],\"tags\":[\"feet\",\"tracks\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👁\",\"description\":\"eye\",\"category\":\"People\",\"aliases\":[\"eye\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"👀\",\"description\":\"eyes\",\"category\":\"People\",\"aliases\":[\"eyes\"],\"tags\":[\"look\",\"see\",\"watch\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗣\",\"description\":\"speaking head\",\"category\":\"People\",\"aliases\":[\"speaking_head\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"👤\",\"description\":\"bust in silhouette\",\"category\":\"People\",\"aliases\":[\"bust_in_silhouette\"],\"tags\":[\"user\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👥\",\"description\":\"busts in silhouette\",\"category\":\"People\",\"aliases\":[\"busts_in_silhouette\"],\"tags\":[\"users\",\"group\",\"team\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👶\",\"description\":\"baby\",\"category\":\"People\",\"aliases\":[\"baby\"],\"tags\":[\"child\",\"newborn\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👦\",\"description\":\"boy\",\"category\":\"People\",\"aliases\":[\"boy\"],\"tags\":[\"child\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👧\",\"description\":\"girl\",\"category\":\"People\",\"aliases\":[\"girl\"],\"tags\":[\"child\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👨\",\"description\":\"man\",\"category\":\"People\",\"aliases\":[\"man\"],\"tags\":[\"mustache\",\"father\",\"dad\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👩\",\"description\":\"woman\",\"category\":\"People\",\"aliases\":[\"woman\"],\"tags\":[\"girls\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👱‍♀\",\"description\":\"blond-haired woman\",\"category\":\"People\",\"aliases\":[\"blonde_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👱\",\"description\":\"blond-haired person\",\"category\":\"People\",\"aliases\":[\"blonde_man\",\"person_with_blond_hair\"],\"tags\":[\"boy\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👴\",\"description\":\"old man\",\"category\":\"People\",\"aliases\":[\"older_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👵\",\"description\":\"old woman\",\"category\":\"People\",\"aliases\":[\"older_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👲\",\"description\":\"man with Chinese cap\",\"category\":\"People\",\"aliases\":[\"man_with_gua_pi_mao\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👳‍♀\",\"description\":\"woman wearing turban\",\"category\":\"People\",\"aliases\":[\"woman_with_turban\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👳\",\"description\":\"person wearing turban\",\"category\":\"People\",\"aliases\":[\"man_with_turban\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👮‍♀\",\"description\":\"woman police officer\",\"category\":\"People\",\"aliases\":[\"policewoman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👮\",\"description\":\"police officer\",\"category\":\"People\",\"aliases\":[\"policeman\",\"cop\"],\"tags\":[\"police\",\"law\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👷‍♀\",\"description\":\"woman construction worker\",\"category\":\"People\",\"aliases\":[\"construction_worker_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👷\",\"description\":\"construction worker\",\"category\":\"People\",\"aliases\":[\"construction_worker_man\",\"construction_worker\"],\"tags\":[\"helmet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💂‍♀\",\"description\":\"woman guard\",\"category\":\"People\",\"aliases\":[\"guardswoman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"💂\",\"description\":\"guard\",\"category\":\"People\",\"aliases\":[\"guardsman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕵️‍♀️\",\"description\":\"woman detective\",\"category\":\"People\",\"aliases\":[\"female_detective\"],\"tags\":[\"sleuth\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🕵\",\"description\":\"detective\",\"category\":\"People\",\"aliases\":[\"male_detective\",\"detective\"],\"tags\":[\"sleuth\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"👩‍⚕\",\"description\":\"woman health worker\",\"category\":\"People\",\"aliases\":[\"woman_health_worker\"],\"tags\":[\"doctor\",\"nurse\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍⚕\",\"description\":\"man health worker\",\"category\":\"People\",\"aliases\":[\"man_health_worker\"],\"tags\":[\"doctor\",\"nurse\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🌾\",\"description\":\"woman farmer\",\"category\":\"People\",\"aliases\":[\"woman_farmer\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🌾\",\"description\":\"man farmer\",\"category\":\"People\",\"aliases\":[\"man_farmer\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🍳\",\"description\":\"woman cook\",\"category\":\"People\",\"aliases\":[\"woman_cook\"],\"tags\":[\"chef\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🍳\",\"description\":\"man cook\",\"category\":\"People\",\"aliases\":[\"man_cook\"],\"tags\":[\"chef\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🎓\",\"description\":\"woman student\",\"category\":\"People\",\"aliases\":[\"woman_student\"],\"tags\":[\"graduation\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🎓\",\"description\":\"man student\",\"category\":\"People\",\"aliases\":[\"man_student\"],\"tags\":[\"graduation\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🎤\",\"description\":\"woman singer\",\"category\":\"People\",\"aliases\":[\"woman_singer\"],\"tags\":[\"rockstar\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🎤\",\"description\":\"man singer\",\"category\":\"People\",\"aliases\":[\"man_singer\"],\"tags\":[\"rockstar\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🏫\",\"description\":\"woman teacher\",\"category\":\"People\",\"aliases\":[\"woman_teacher\"],\"tags\":[\"school\",\"professor\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🏫\",\"description\":\"man teacher\",\"category\":\"People\",\"aliases\":[\"man_teacher\"],\"tags\":[\"school\",\"professor\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🏭\",\"description\":\"woman factory worker\",\"category\":\"People\",\"aliases\":[\"woman_factory_worker\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🏭\",\"description\":\"man factory worker\",\"category\":\"People\",\"aliases\":[\"man_factory_worker\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍💻\",\"description\":\"woman technologist\",\"category\":\"People\",\"aliases\":[\"woman_technologist\"],\"tags\":[\"coder\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍💻\",\"description\":\"man technologist\",\"category\":\"People\",\"aliases\":[\"man_technologist\"],\"tags\":[\"coder\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍💼\",\"description\":\"woman office worker\",\"category\":\"People\",\"aliases\":[\"woman_office_worker\"],\"tags\":[\"business\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍💼\",\"description\":\"man office worker\",\"category\":\"People\",\"aliases\":[\"man_office_worker\"],\"tags\":[\"business\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🔧\",\"description\":\"woman mechanic\",\"category\":\"People\",\"aliases\":[\"woman_mechanic\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🔧\",\"description\":\"man mechanic\",\"category\":\"People\",\"aliases\":[\"man_mechanic\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🔬\",\"description\":\"woman scientist\",\"category\":\"People\",\"aliases\":[\"woman_scientist\"],\"tags\":[\"research\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🔬\",\"description\":\"man scientist\",\"category\":\"People\",\"aliases\":[\"man_scientist\"],\"tags\":[\"research\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🎨\",\"description\":\"woman artist\",\"category\":\"People\",\"aliases\":[\"woman_artist\"],\"tags\":[\"painter\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🎨\",\"description\":\"man artist\",\"category\":\"People\",\"aliases\":[\"man_artist\"],\"tags\":[\"painter\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🚒\",\"description\":\"woman firefighter\",\"category\":\"People\",\"aliases\":[\"woman_firefighter\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🚒\",\"description\":\"man firefighter\",\"category\":\"People\",\"aliases\":[\"man_firefighter\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍✈\",\"description\":\"woman pilot\",\"category\":\"People\",\"aliases\":[\"woman_pilot\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍✈\",\"description\":\"man pilot\",\"category\":\"People\",\"aliases\":[\"man_pilot\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍🚀\",\"description\":\"woman astronaut\",\"category\":\"People\",\"aliases\":[\"woman_astronaut\"],\"tags\":[\"space\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍🚀\",\"description\":\"man astronaut\",\"category\":\"People\",\"aliases\":[\"man_astronaut\"],\"tags\":[\"space\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👩‍⚖\",\"description\":\"woman judge\",\"category\":\"People\",\"aliases\":[\"woman_judge\"],\"tags\":[\"justice\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"👨‍⚖\",\"description\":\"man judge\",\"category\":\"People\",\"aliases\":[\"man_judge\"],\"tags\":[\"justice\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤶\",\"description\":\"Mrs. Claus\",\"category\":\"People\",\"aliases\":[\"mrs_claus\"],\"tags\":[\"santa\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🎅\",\"description\":\"Santa Claus\",\"category\":\"People\",\"aliases\":[\"santa\"],\"tags\":[\"christmas\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👸\",\"description\":\"princess\",\"category\":\"People\",\"aliases\":[\"princess\"],\"tags\":[\"blonde\",\"crown\",\"royal\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤴\",\"description\":\"prince\",\"category\":\"People\",\"aliases\":[\"prince\"],\"tags\":[\"crown\",\"royal\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"👰\",\"description\":\"bride with veil\",\"category\":\"People\",\"aliases\":[\"bride_with_veil\"],\"tags\":[\"marriage\",\"wedding\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤵\",\"description\":\"man in tuxedo\",\"category\":\"People\",\"aliases\":[\"man_in_tuxedo\"],\"tags\":[\"groom\",\"marriage\",\"wedding\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"👼\",\"description\":\"baby angel\",\"category\":\"People\",\"aliases\":[\"angel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤰\",\"description\":\"pregnant woman\",\"category\":\"People\",\"aliases\":[\"pregnant_woman\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🙇‍♀\",\"description\":\"woman bowing\",\"category\":\"People\",\"aliases\":[\"bowing_woman\"],\"tags\":[\"respect\",\"thanks\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🙇\",\"description\":\"person bowing\",\"category\":\"People\",\"aliases\":[\"bowing_man\",\"bow\"],\"tags\":[\"respect\",\"thanks\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💁\",\"description\":\"person tipping hand\",\"category\":\"People\",\"aliases\":[\"tipping_hand_woman\",\"information_desk_person\",\"sassy_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💁‍♂\",\"description\":\"man tipping hand\",\"category\":\"People\",\"aliases\":[\"tipping_hand_man\",\"sassy_man\"],\"tags\":[\"information\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🙅\",\"description\":\"person gesturing NO\",\"category\":\"People\",\"aliases\":[\"no_good_woman\",\"no_good\",\"ng_woman\"],\"tags\":[\"stop\",\"halt\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙅‍♂\",\"description\":\"man gesturing NO\",\"category\":\"People\",\"aliases\":[\"no_good_man\",\"ng_man\"],\"tags\":[\"stop\",\"halt\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🙆\",\"description\":\"person gesturing OK\",\"category\":\"People\",\"aliases\":[\"ok_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙆‍♂\",\"description\":\"man gesturing OK\",\"category\":\"People\",\"aliases\":[\"ok_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🙋\",\"description\":\"person raising hand\",\"category\":\"People\",\"aliases\":[\"raising_hand_woman\",\"raising_hand\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙋‍♂\",\"description\":\"man raising hand\",\"category\":\"People\",\"aliases\":[\"raising_hand_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🤦‍♀\",\"description\":\"woman facepalming\",\"category\":\"People\",\"aliases\":[\"woman_facepalming\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤦‍♂\",\"description\":\"man facepalming\",\"category\":\"People\",\"aliases\":[\"man_facepalming\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤷‍♀\",\"description\":\"woman shrugging\",\"category\":\"People\",\"aliases\":[\"woman_shrugging\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤷‍♂\",\"description\":\"man shrugging\",\"category\":\"People\",\"aliases\":[\"man_shrugging\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🙎\",\"description\":\"person pouting\",\"category\":\"People\",\"aliases\":[\"pouting_woman\",\"person_with_pouting_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙎‍♂\",\"description\":\"man pouting\",\"category\":\"People\",\"aliases\":[\"pouting_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🙍\",\"description\":\"person frowning\",\"category\":\"People\",\"aliases\":[\"frowning_woman\",\"person_frowning\"],\"tags\":[\"sad\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙍‍♂\",\"description\":\"man frowning\",\"category\":\"People\",\"aliases\":[\"frowning_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"💇\",\"description\":\"person getting haircut\",\"category\":\"People\",\"aliases\":[\"haircut_woman\",\"haircut\"],\"tags\":[\"beauty\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💇‍♂\",\"description\":\"man getting haircut\",\"category\":\"People\",\"aliases\":[\"haircut_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"💆\",\"description\":\"person getting massage\",\"category\":\"People\",\"aliases\":[\"massage_woman\",\"massage\"],\"tags\":[\"spa\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💆‍♂\",\"description\":\"man getting massage\",\"category\":\"People\",\"aliases\":[\"massage_man\"],\"tags\":[\"spa\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🕴\",\"description\":\"man in business suit levitating\",\"category\":\"People\",\"aliases\":[\"business_suit_levitating\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💃\",\"description\":\"woman dancing\",\"category\":\"People\",\"aliases\":[\"dancer\"],\"tags\":[\"dress\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕺\",\"description\":\"man dancing\",\"category\":\"People\",\"aliases\":[\"man_dancing\"],\"tags\":[\"dancer\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"👯\",\"description\":\"people with bunny ears partying\",\"category\":\"People\",\"aliases\":[\"dancing_women\",\"dancers\"],\"tags\":[\"bunny\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👯‍♂\",\"description\":\"men with bunny ears partying\",\"category\":\"People\",\"aliases\":[\"dancing_men\"],\"tags\":[\"bunny\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🚶‍♀\",\"description\":\"woman walking\",\"category\":\"People\",\"aliases\":[\"walking_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🚶\",\"description\":\"person walking\",\"category\":\"People\",\"aliases\":[\"walking_man\",\"walking\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏃‍♀\",\"description\":\"woman running\",\"category\":\"People\",\"aliases\":[\"running_woman\"],\"tags\":[\"exercise\",\"workout\",\"marathon\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🏃\",\"description\":\"person running\",\"category\":\"People\",\"aliases\":[\"running_man\",\"runner\",\"running\"],\"tags\":[\"exercise\",\"workout\",\"marathon\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👫\",\"description\":\"man and woman holding hands\",\"category\":\"People\",\"aliases\":[\"couple\"],\"tags\":[\"date\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👭\",\"description\":\"two women holding hands\",\"category\":\"People\",\"aliases\":[\"two_women_holding_hands\"],\"tags\":[\"couple\",\"date\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👬\",\"description\":\"two men holding hands\",\"category\":\"People\",\"aliases\":[\"two_men_holding_hands\"],\"tags\":[\"couple\",\"date\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💑\",\"description\":\"couple with heart\",\"category\":\"People\",\"aliases\":[\"couple_with_heart_woman_man\",\"couple_with_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👩‍❤️‍👩\",\"description\":\"couple with heart: woman, woman\",\"category\":\"People\",\"aliases\":[\"couple_with_heart_woman_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍❤️‍👨\",\"description\":\"couple with heart: man, man\",\"category\":\"People\",\"aliases\":[\"couple_with_heart_man_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"💏\",\"description\":\"kiss\",\"category\":\"People\",\"aliases\":[\"couplekiss_man_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👩‍❤️‍💋‍👩\",\"description\":\"kiss: woman, woman\",\"category\":\"People\",\"aliases\":[\"couplekiss_woman_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍❤️‍💋‍👨\",\"description\":\"kiss: man, man\",\"category\":\"People\",\"aliases\":[\"couplekiss_man_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👪\",\"description\":\"family\",\"category\":\"People\",\"aliases\":[\"family_man_woman_boy\",\"family\"],\"tags\":[\"home\",\"parents\",\"child\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👨‍👩‍👧\",\"description\":\"family: man, woman, girl\",\"category\":\"People\",\"aliases\":[\"family_man_woman_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👩‍👧‍👦\",\"description\":\"family: man, woman, girl, boy\",\"category\":\"People\",\"aliases\":[\"family_man_woman_girl_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👩‍👦‍👦\",\"description\":\"family: man, woman, boy, boy\",\"category\":\"People\",\"aliases\":[\"family_man_woman_boy_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👩‍👧‍👧\",\"description\":\"family: man, woman, girl, girl\",\"category\":\"People\",\"aliases\":[\"family_man_woman_girl_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👩‍👩‍👦\",\"description\":\"family: woman, woman, boy\",\"category\":\"People\",\"aliases\":[\"family_woman_woman_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👩‍👩‍👧\",\"description\":\"family: woman, woman, girl\",\"category\":\"People\",\"aliases\":[\"family_woman_woman_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👩‍👩‍👧‍👦\",\"description\":\"family: woman, woman, girl, boy\",\"category\":\"People\",\"aliases\":[\"family_woman_woman_girl_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👩‍👩‍👦‍👦\",\"description\":\"family: woman, woman, boy, boy\",\"category\":\"People\",\"aliases\":[\"family_woman_woman_boy_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👩‍👩‍👧‍👧\",\"description\":\"family: woman, woman, girl, girl\",\"category\":\"People\",\"aliases\":[\"family_woman_woman_girl_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👨‍👦\",\"description\":\"family: man, man, boy\",\"category\":\"People\",\"aliases\":[\"family_man_man_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👨‍👧\",\"description\":\"family: man, man, girl\",\"category\":\"People\",\"aliases\":[\"family_man_man_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👨‍👧‍👦\",\"description\":\"family: man, man, girl, boy\",\"category\":\"People\",\"aliases\":[\"family_man_man_girl_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👨‍👦‍👦\",\"description\":\"family: man, man, boy, boy\",\"category\":\"People\",\"aliases\":[\"family_man_man_boy_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👨‍👨‍👧‍👧\",\"description\":\"family: man, man, girl, girl\",\"category\":\"People\",\"aliases\":[\"family_man_man_girl_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"👩‍👦\",\"description\":\"family: woman, boy\",\"category\":\"People\",\"aliases\":[\"family_woman_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👩‍👧\",\"description\":\"family: woman, girl\",\"category\":\"People\",\"aliases\":[\"family_woman_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👩‍👧‍👦\",\"description\":\"family: woman, girl, boy\",\"category\":\"People\",\"aliases\":[\"family_woman_girl_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👩‍👦‍👦\",\"description\":\"family: woman, boy, boy\",\"category\":\"People\",\"aliases\":[\"family_woman_boy_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👩‍👧‍👧\",\"description\":\"family: woman, girl, girl\",\"category\":\"People\",\"aliases\":[\"family_woman_girl_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👨‍👦\",\"description\":\"family: man, boy\",\"category\":\"People\",\"aliases\":[\"family_man_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👨‍👧\",\"description\":\"family: man, girl\",\"category\":\"People\",\"aliases\":[\"family_man_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👨‍👧‍👦\",\"description\":\"family: man, girl, boy\",\"category\":\"People\",\"aliases\":[\"family_man_girl_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👨‍👦‍👦\",\"description\":\"family: man, boy, boy\",\"category\":\"People\",\"aliases\":[\"family_man_boy_boy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👨‍👧‍👧\",\"description\":\"family: man, girl, girl\",\"category\":\"People\",\"aliases\":[\"family_man_girl_girl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"👚\",\"description\":\"woman’s clothes\",\"category\":\"People\",\"aliases\":[\"womans_clothes\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👕\",\"description\":\"t-shirt\",\"category\":\"People\",\"aliases\":[\"shirt\",\"tshirt\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👖\",\"description\":\"jeans\",\"category\":\"People\",\"aliases\":[\"jeans\"],\"tags\":[\"pants\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👔\",\"description\":\"necktie\",\"category\":\"People\",\"aliases\":[\"necktie\"],\"tags\":[\"shirt\",\"formal\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👗\",\"description\":\"dress\",\"category\":\"People\",\"aliases\":[\"dress\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👙\",\"description\":\"bikini\",\"category\":\"People\",\"aliases\":[\"bikini\"],\"tags\":[\"beach\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👘\",\"description\":\"kimono\",\"category\":\"People\",\"aliases\":[\"kimono\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👠\",\"description\":\"high-heeled shoe\",\"category\":\"People\",\"aliases\":[\"high_heel\"],\"tags\":[\"shoe\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👡\",\"description\":\"woman’s sandal\",\"category\":\"People\",\"aliases\":[\"sandal\"],\"tags\":[\"shoe\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👢\",\"description\":\"woman’s boot\",\"category\":\"People\",\"aliases\":[\"boot\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👞\",\"description\":\"man’s shoe\",\"category\":\"People\",\"aliases\":[\"mans_shoe\",\"shoe\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👟\",\"description\":\"running shoe\",\"category\":\"People\",\"aliases\":[\"athletic_shoe\"],\"tags\":[\"sneaker\",\"sport\",\"running\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👒\",\"description\":\"woman’s hat\",\"category\":\"People\",\"aliases\":[\"womans_hat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎩\",\"description\":\"top hat\",\"category\":\"People\",\"aliases\":[\"tophat\"],\"tags\":[\"hat\",\"classy\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎓\",\"description\":\"graduation cap\",\"category\":\"People\",\"aliases\":[\"mortar_board\"],\"tags\":[\"education\",\"college\",\"university\",\"graduation\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👑\",\"description\":\"crown\",\"category\":\"People\",\"aliases\":[\"crown\"],\"tags\":[\"king\",\"queen\",\"royal\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⛑\",\"description\":\"rescue worker’s helmet\",\"category\":\"People\",\"aliases\":[\"rescue_worker_helmet\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎒\",\"description\":\"school backpack\",\"category\":\"People\",\"aliases\":[\"school_satchel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👝\",\"description\":\"clutch bag\",\"category\":\"People\",\"aliases\":[\"pouch\"],\"tags\":[\"bag\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👛\",\"description\":\"purse\",\"category\":\"People\",\"aliases\":[\"purse\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👜\",\"description\":\"handbag\",\"category\":\"People\",\"aliases\":[\"handbag\"],\"tags\":[\"bag\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💼\",\"description\":\"briefcase\",\"category\":\"People\",\"aliases\":[\"briefcase\"],\"tags\":[\"business\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👓\",\"description\":\"glasses\",\"category\":\"People\",\"aliases\":[\"eyeglasses\"],\"tags\":[\"glasses\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕶\",\"description\":\"sunglasses\",\"category\":\"People\",\"aliases\":[\"dark_sunglasses\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌂\",\"description\":\"closed umbrella\",\"category\":\"People\",\"aliases\":[\"closed_umbrella\"],\"tags\":[\"weather\",\"rain\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☂️\",\"description\":\"umbrella\",\"category\":\"People\",\"aliases\":[\"open_umbrella\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"🐶\",\"description\":\"dog face\",\"category\":\"Nature\",\"aliases\":[\"dog\"],\"tags\":[\"pet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐱\",\"description\":\"cat face\",\"category\":\"Nature\",\"aliases\":[\"cat\"],\"tags\":[\"pet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐭\",\"description\":\"mouse face\",\"category\":\"Nature\",\"aliases\":[\"mouse\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐹\",\"description\":\"hamster face\",\"category\":\"Nature\",\"aliases\":[\"hamster\"],\"tags\":[\"pet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐰\",\"description\":\"rabbit face\",\"category\":\"Nature\",\"aliases\":[\"rabbit\"],\"tags\":[\"bunny\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦊\",\"description\":\"fox face\",\"category\":\"Nature\",\"aliases\":[\"fox_face\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐻\",\"description\":\"bear face\",\"category\":\"Nature\",\"aliases\":[\"bear\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐼\",\"description\":\"panda face\",\"category\":\"Nature\",\"aliases\":[\"panda_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐨\",\"description\":\"koala\",\"category\":\"Nature\",\"aliases\":[\"koala\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐯\",\"description\":\"tiger face\",\"category\":\"Nature\",\"aliases\":[\"tiger\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦁\",\"description\":\"lion face\",\"category\":\"Nature\",\"aliases\":[\"lion\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🐮\",\"description\":\"cow face\",\"category\":\"Nature\",\"aliases\":[\"cow\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐷\",\"description\":\"pig face\",\"category\":\"Nature\",\"aliases\":[\"pig\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐽\",\"description\":\"pig nose\",\"category\":\"Nature\",\"aliases\":[\"pig_nose\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐸\",\"description\":\"frog face\",\"category\":\"Nature\",\"aliases\":[\"frog\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐵\",\"description\":\"monkey face\",\"category\":\"Nature\",\"aliases\":[\"monkey_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙈\",\"description\":\"see-no-evil monkey\",\"category\":\"Nature\",\"aliases\":[\"see_no_evil\"],\"tags\":[\"monkey\",\"blind\",\"ignore\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙉\",\"description\":\"hear-no-evil monkey\",\"category\":\"Nature\",\"aliases\":[\"hear_no_evil\"],\"tags\":[\"monkey\",\"deaf\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🙊\",\"description\":\"speak-no-evil monkey\",\"category\":\"Nature\",\"aliases\":[\"speak_no_evil\"],\"tags\":[\"monkey\",\"mute\",\"hush\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐒\",\"description\":\"monkey\",\"category\":\"Nature\",\"aliases\":[\"monkey\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐔\",\"description\":\"chicken\",\"category\":\"Nature\",\"aliases\":[\"chicken\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐧\",\"description\":\"penguin\",\"category\":\"Nature\",\"aliases\":[\"penguin\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐦\",\"description\":\"bird\",\"category\":\"Nature\",\"aliases\":[\"bird\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐤\",\"description\":\"baby chick\",\"category\":\"Nature\",\"aliases\":[\"baby_chick\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐣\",\"description\":\"hatching chick\",\"category\":\"Nature\",\"aliases\":[\"hatching_chick\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐥\",\"description\":\"front-facing baby chick\",\"category\":\"Nature\",\"aliases\":[\"hatched_chick\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦆\",\"description\":\"duck\",\"category\":\"Nature\",\"aliases\":[\"duck\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🦅\",\"description\":\"eagle\",\"category\":\"Nature\",\"aliases\":[\"eagle\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🦉\",\"description\":\"owl\",\"category\":\"Nature\",\"aliases\":[\"owl\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🦇\",\"description\":\"bat\",\"category\":\"Nature\",\"aliases\":[\"bat\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐺\",\"description\":\"wolf face\",\"category\":\"Nature\",\"aliases\":[\"wolf\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐗\",\"description\":\"boar\",\"category\":\"Nature\",\"aliases\":[\"boar\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐴\",\"description\":\"horse face\",\"category\":\"Nature\",\"aliases\":[\"horse\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦄\",\"description\":\"unicorn face\",\"category\":\"Nature\",\"aliases\":[\"unicorn\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🐝\",\"description\":\"honeybee\",\"category\":\"Nature\",\"aliases\":[\"bee\",\"honeybee\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐛\",\"description\":\"bug\",\"category\":\"Nature\",\"aliases\":[\"bug\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦋\",\"description\":\"butterfly\",\"category\":\"Nature\",\"aliases\":[\"butterfly\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐌\",\"description\":\"snail\",\"category\":\"Nature\",\"aliases\":[\"snail\"],\"tags\":[\"slow\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐚\",\"description\":\"spiral shell\",\"category\":\"Nature\",\"aliases\":[\"shell\"],\"tags\":[\"sea\",\"beach\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐞\",\"description\":\"lady beetle\",\"category\":\"Nature\",\"aliases\":[\"beetle\"],\"tags\":[\"bug\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐜\",\"description\":\"ant\",\"category\":\"Nature\",\"aliases\":[\"ant\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕷\",\"description\":\"spider\",\"category\":\"Nature\",\"aliases\":[\"spider\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🕸\",\"description\":\"spider web\",\"category\":\"Nature\",\"aliases\":[\"spider_web\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🐢\",\"description\":\"turtle\",\"category\":\"Nature\",\"aliases\":[\"turtle\"],\"tags\":[\"slow\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐍\",\"description\":\"snake\",\"category\":\"Nature\",\"aliases\":[\"snake\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦎\",\"description\":\"lizard\",\"category\":\"Nature\",\"aliases\":[\"lizard\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🦂\",\"description\":\"scorpion\",\"category\":\"Nature\",\"aliases\":[\"scorpion\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🦀\",\"description\":\"crab\",\"category\":\"Nature\",\"aliases\":[\"crab\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🦑\",\"description\":\"squid\",\"category\":\"Nature\",\"aliases\":[\"squid\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐙\",\"description\":\"octopus\",\"category\":\"Nature\",\"aliases\":[\"octopus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦐\",\"description\":\"shrimp\",\"category\":\"Nature\",\"aliases\":[\"shrimp\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐠\",\"description\":\"tropical fish\",\"category\":\"Nature\",\"aliases\":[\"tropical_fish\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐟\",\"description\":\"fish\",\"category\":\"Nature\",\"aliases\":[\"fish\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐡\",\"description\":\"blowfish\",\"category\":\"Nature\",\"aliases\":[\"blowfish\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐬\",\"description\":\"dolphin\",\"category\":\"Nature\",\"aliases\":[\"dolphin\",\"flipper\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦈\",\"description\":\"shark\",\"category\":\"Nature\",\"aliases\":[\"shark\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐳\",\"description\":\"spouting whale\",\"category\":\"Nature\",\"aliases\":[\"whale\"],\"tags\":[\"sea\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐋\",\"description\":\"whale\",\"category\":\"Nature\",\"aliases\":[\"whale2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐊\",\"description\":\"crocodile\",\"category\":\"Nature\",\"aliases\":[\"crocodile\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐆\",\"description\":\"leopard\",\"category\":\"Nature\",\"aliases\":[\"leopard\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐅\",\"description\":\"tiger\",\"category\":\"Nature\",\"aliases\":[\"tiger2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐃\",\"description\":\"water buffalo\",\"category\":\"Nature\",\"aliases\":[\"water_buffalo\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐂\",\"description\":\"ox\",\"category\":\"Nature\",\"aliases\":[\"ox\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐄\",\"description\":\"cow\",\"category\":\"Nature\",\"aliases\":[\"cow2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦌\",\"description\":\"deer\",\"category\":\"Nature\",\"aliases\":[\"deer\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐪\",\"description\":\"camel\",\"category\":\"Nature\",\"aliases\":[\"dromedary_camel\"],\"tags\":[\"desert\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐫\",\"description\":\"two-hump camel\",\"category\":\"Nature\",\"aliases\":[\"camel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐘\",\"description\":\"elephant\",\"category\":\"Nature\",\"aliases\":[\"elephant\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦏\",\"description\":\"rhinoceros\",\"category\":\"Nature\",\"aliases\":[\"rhinoceros\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🦍\",\"description\":\"gorilla\",\"category\":\"Nature\",\"aliases\":[\"gorilla\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🐎\",\"description\":\"horse\",\"category\":\"Nature\",\"aliases\":[\"racehorse\"],\"tags\":[\"speed\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐖\",\"description\":\"pig\",\"category\":\"Nature\",\"aliases\":[\"pig2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐐\",\"description\":\"goat\",\"category\":\"Nature\",\"aliases\":[\"goat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐏\",\"description\":\"ram\",\"category\":\"Nature\",\"aliases\":[\"ram\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐑\",\"description\":\"sheep\",\"category\":\"Nature\",\"aliases\":[\"sheep\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐕\",\"description\":\"dog\",\"category\":\"Nature\",\"aliases\":[\"dog2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐩\",\"description\":\"poodle\",\"category\":\"Nature\",\"aliases\":[\"poodle\"],\"tags\":[\"dog\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐈\",\"description\":\"cat\",\"category\":\"Nature\",\"aliases\":[\"cat2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐓\",\"description\":\"rooster\",\"category\":\"Nature\",\"aliases\":[\"rooster\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🦃\",\"description\":\"turkey\",\"category\":\"Nature\",\"aliases\":[\"turkey\"],\"tags\":[\"thanksgiving\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🕊\",\"description\":\"dove\",\"category\":\"Nature\",\"aliases\":[\"dove\"],\"tags\":[\"peace\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🐇\",\"description\":\"rabbit\",\"category\":\"Nature\",\"aliases\":[\"rabbit2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐁\",\"description\":\"mouse\",\"category\":\"Nature\",\"aliases\":[\"mouse2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐀\",\"description\":\"rat\",\"category\":\"Nature\",\"aliases\":[\"rat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐿\",\"description\":\"chipmunk\",\"category\":\"Nature\",\"aliases\":[\"chipmunk\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🐾\",\"description\":\"paw prints\",\"category\":\"Nature\",\"aliases\":[\"feet\",\"paw_prints\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐉\",\"description\":\"dragon\",\"category\":\"Nature\",\"aliases\":[\"dragon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🐲\",\"description\":\"dragon face\",\"category\":\"Nature\",\"aliases\":[\"dragon_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌵\",\"description\":\"cactus\",\"category\":\"Nature\",\"aliases\":[\"cactus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎄\",\"description\":\"Christmas tree\",\"category\":\"Nature\",\"aliases\":[\"christmas_tree\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌲\",\"description\":\"evergreen tree\",\"category\":\"Nature\",\"aliases\":[\"evergreen_tree\"],\"tags\":[\"wood\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌳\",\"description\":\"deciduous tree\",\"category\":\"Nature\",\"aliases\":[\"deciduous_tree\"],\"tags\":[\"wood\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌴\",\"description\":\"palm tree\",\"category\":\"Nature\",\"aliases\":[\"palm_tree\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌱\",\"description\":\"seedling\",\"category\":\"Nature\",\"aliases\":[\"seedling\"],\"tags\":[\"plant\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌿\",\"description\":\"herb\",\"category\":\"Nature\",\"aliases\":[\"herb\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☘️\",\"description\":\"shamrock\",\"category\":\"Nature\",\"aliases\":[\"shamrock\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🍀\",\"description\":\"four leaf clover\",\"category\":\"Nature\",\"aliases\":[\"four_leaf_clover\"],\"tags\":[\"luck\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎍\",\"description\":\"pine decoration\",\"category\":\"Nature\",\"aliases\":[\"bamboo\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎋\",\"description\":\"tanabata tree\",\"category\":\"Nature\",\"aliases\":[\"tanabata_tree\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍃\",\"description\":\"leaf fluttering in wind\",\"category\":\"Nature\",\"aliases\":[\"leaves\"],\"tags\":[\"leaf\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍂\",\"description\":\"fallen leaf\",\"category\":\"Nature\",\"aliases\":[\"fallen_leaf\"],\"tags\":[\"autumn\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍁\",\"description\":\"maple leaf\",\"category\":\"Nature\",\"aliases\":[\"maple_leaf\"],\"tags\":[\"canada\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍄\",\"description\":\"mushroom\",\"category\":\"Nature\",\"aliases\":[\"mushroom\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌾\",\"description\":\"sheaf of rice\",\"category\":\"Nature\",\"aliases\":[\"ear_of_rice\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💐\",\"description\":\"bouquet\",\"category\":\"Nature\",\"aliases\":[\"bouquet\"],\"tags\":[\"flowers\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌷\",\"description\":\"tulip\",\"category\":\"Nature\",\"aliases\":[\"tulip\"],\"tags\":[\"flower\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌹\",\"description\":\"rose\",\"category\":\"Nature\",\"aliases\":[\"rose\"],\"tags\":[\"flower\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥀\",\"description\":\"wilted flower\",\"category\":\"Nature\",\"aliases\":[\"wilted_flower\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🌻\",\"description\":\"sunflower\",\"category\":\"Nature\",\"aliases\":[\"sunflower\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌼\",\"description\":\"blossom\",\"category\":\"Nature\",\"aliases\":[\"blossom\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌸\",\"description\":\"cherry blossom\",\"category\":\"Nature\",\"aliases\":[\"cherry_blossom\"],\"tags\":[\"flower\",\"spring\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌺\",\"description\":\"hibiscus\",\"category\":\"Nature\",\"aliases\":[\"hibiscus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌎\",\"description\":\"globe showing Americas\",\"category\":\"Nature\",\"aliases\":[\"earth_americas\"],\"tags\":[\"globe\",\"world\",\"international\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌍\",\"description\":\"globe showing Europe-Africa\",\"category\":\"Nature\",\"aliases\":[\"earth_africa\"],\"tags\":[\"globe\",\"world\",\"international\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌏\",\"description\":\"globe showing Asia-Australia\",\"category\":\"Nature\",\"aliases\":[\"earth_asia\"],\"tags\":[\"globe\",\"world\",\"international\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌕\",\"description\":\"full moon\",\"category\":\"Nature\",\"aliases\":[\"full_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌖\",\"description\":\"waning gibbous moon\",\"category\":\"Nature\",\"aliases\":[\"waning_gibbous_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌗\",\"description\":\"last quarter moon\",\"category\":\"Nature\",\"aliases\":[\"last_quarter_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌘\",\"description\":\"waning crescent moon\",\"category\":\"Nature\",\"aliases\":[\"waning_crescent_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌑\",\"description\":\"new moon\",\"category\":\"Nature\",\"aliases\":[\"new_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌒\",\"description\":\"waxing crescent moon\",\"category\":\"Nature\",\"aliases\":[\"waxing_crescent_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌓\",\"description\":\"first quarter moon\",\"category\":\"Nature\",\"aliases\":[\"first_quarter_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌔\",\"description\":\"waxing gibbous moon\",\"category\":\"Nature\",\"aliases\":[\"moon\",\"waxing_gibbous_moon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌚\",\"description\":\"new moon face\",\"category\":\"Nature\",\"aliases\":[\"new_moon_with_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌝\",\"description\":\"full moon with face\",\"category\":\"Nature\",\"aliases\":[\"full_moon_with_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌞\",\"description\":\"sun with face\",\"category\":\"Nature\",\"aliases\":[\"sun_with_face\"],\"tags\":[\"summer\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌛\",\"description\":\"first quarter moon with face\",\"category\":\"Nature\",\"aliases\":[\"first_quarter_moon_with_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌜\",\"description\":\"last quarter moon with face\",\"category\":\"Nature\",\"aliases\":[\"last_quarter_moon_with_face\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌙\",\"description\":\"crescent moon\",\"category\":\"Nature\",\"aliases\":[\"crescent_moon\"],\"tags\":[\"night\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💫\",\"description\":\"dizzy\",\"category\":\"Nature\",\"aliases\":[\"dizzy\"],\"tags\":[\"star\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⭐️\",\"description\":\"white medium star\",\"category\":\"Nature\",\"aliases\":[\"star\"],\"tags\":[],\"unicode_version\":\"5.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌟\",\"description\":\"glowing star\",\"category\":\"Nature\",\"aliases\":[\"star2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✨\",\"description\":\"sparkles\",\"category\":\"Nature\",\"aliases\":[\"sparkles\"],\"tags\":[\"shiny\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚡️\",\"description\":\"high voltage\",\"category\":\"Nature\",\"aliases\":[\"zap\"],\"tags\":[\"lightning\",\"thunder\"],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔥\",\"description\":\"fire\",\"category\":\"Nature\",\"aliases\":[\"fire\"],\"tags\":[\"burn\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💥\",\"description\":\"collision\",\"category\":\"Nature\",\"aliases\":[\"boom\",\"collision\"],\"tags\":[\"explode\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☄\",\"description\":\"comet\",\"category\":\"Nature\",\"aliases\":[\"comet\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"☀️\",\"description\":\"sun\",\"category\":\"Nature\",\"aliases\":[\"sunny\"],\"tags\":[\"weather\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌤\",\"description\":\"sun behind small cloud\",\"category\":\"Nature\",\"aliases\":[\"sun_behind_small_cloud\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛅️\",\"description\":\"sun behind cloud\",\"category\":\"Nature\",\"aliases\":[\"partly_sunny\"],\"tags\":[\"weather\",\"cloud\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌥\",\"description\":\"sun behind large cloud\",\"category\":\"Nature\",\"aliases\":[\"sun_behind_large_cloud\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌦\",\"description\":\"sun behind rain cloud\",\"category\":\"Nature\",\"aliases\":[\"sun_behind_rain_cloud\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌈\",\"description\":\"rainbow\",\"category\":\"Nature\",\"aliases\":[\"rainbow\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☁️\",\"description\":\"cloud\",\"category\":\"Nature\",\"aliases\":[\"cloud\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌧\",\"description\":\"cloud with rain\",\"category\":\"Nature\",\"aliases\":[\"cloud_with_rain\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛈\",\"description\":\"cloud with lightning and rain\",\"category\":\"Nature\",\"aliases\":[\"cloud_with_lightning_and_rain\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌩\",\"description\":\"cloud with lightning\",\"category\":\"Nature\",\"aliases\":[\"cloud_with_lightning\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌨\",\"description\":\"cloud with snow\",\"category\":\"Nature\",\"aliases\":[\"cloud_with_snow\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"☃️\",\"description\":\"snowman\",\"category\":\"Nature\",\"aliases\":[\"snowman_with_snow\"],\"tags\":[\"winter\",\"christmas\"],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛄️\",\"description\":\"snowman without snow\",\"category\":\"Nature\",\"aliases\":[\"snowman\"],\"tags\":[\"winter\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"❄️\",\"description\":\"snowflake\",\"category\":\"Nature\",\"aliases\":[\"snowflake\"],\"tags\":[\"winter\",\"cold\",\"weather\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌬\",\"description\":\"wind face\",\"category\":\"Nature\",\"aliases\":[\"wind_face\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💨\",\"description\":\"dashing away\",\"category\":\"Nature\",\"aliases\":[\"dash\"],\"tags\":[\"wind\",\"blow\",\"fast\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌪\",\"description\":\"tornado\",\"category\":\"Nature\",\"aliases\":[\"tornado\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌫\",\"description\":\"fog\",\"category\":\"Nature\",\"aliases\":[\"fog\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌊\",\"description\":\"water wave\",\"category\":\"Nature\",\"aliases\":[\"ocean\"],\"tags\":[\"sea\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💧\",\"description\":\"droplet\",\"category\":\"Nature\",\"aliases\":[\"droplet\"],\"tags\":[\"water\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💦\",\"description\":\"sweat droplets\",\"category\":\"Nature\",\"aliases\":[\"sweat_drops\"],\"tags\":[\"water\",\"workout\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☔️\",\"description\":\"umbrella with rain drops\",\"category\":\"Nature\",\"aliases\":[\"umbrella\"],\"tags\":[\"rain\",\"weather\"],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍏\",\"description\":\"green apple\",\"category\":\"Foods\",\"aliases\":[\"green_apple\"],\"tags\":[\"fruit\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍎\",\"description\":\"red apple\",\"category\":\"Foods\",\"aliases\":[\"apple\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍐\",\"description\":\"pear\",\"category\":\"Foods\",\"aliases\":[\"pear\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍊\",\"description\":\"tangerine\",\"category\":\"Foods\",\"aliases\":[\"tangerine\",\"orange\",\"mandarin\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍋\",\"description\":\"lemon\",\"category\":\"Foods\",\"aliases\":[\"lemon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍌\",\"description\":\"banana\",\"category\":\"Foods\",\"aliases\":[\"banana\"],\"tags\":[\"fruit\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍉\",\"description\":\"watermelon\",\"category\":\"Foods\",\"aliases\":[\"watermelon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍇\",\"description\":\"grapes\",\"category\":\"Foods\",\"aliases\":[\"grapes\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍓\",\"description\":\"strawberry\",\"category\":\"Foods\",\"aliases\":[\"strawberry\"],\"tags\":[\"fruit\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍈\",\"description\":\"melon\",\"category\":\"Foods\",\"aliases\":[\"melon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍒\",\"description\":\"cherries\",\"category\":\"Foods\",\"aliases\":[\"cherries\"],\"tags\":[\"fruit\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍑\",\"description\":\"peach\",\"category\":\"Foods\",\"aliases\":[\"peach\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍍\",\"description\":\"pineapple\",\"category\":\"Foods\",\"aliases\":[\"pineapple\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥝\",\"description\":\"kiwi fruit\",\"category\":\"Foods\",\"aliases\":[\"kiwi_fruit\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥑\",\"description\":\"avocado\",\"category\":\"Foods\",\"aliases\":[\"avocado\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍅\",\"description\":\"tomato\",\"category\":\"Foods\",\"aliases\":[\"tomato\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍆\",\"description\":\"eggplant\",\"category\":\"Foods\",\"aliases\":[\"eggplant\"],\"tags\":[\"aubergine\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥒\",\"description\":\"cucumber\",\"category\":\"Foods\",\"aliases\":[\"cucumber\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥕\",\"description\":\"carrot\",\"category\":\"Foods\",\"aliases\":[\"carrot\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🌽\",\"description\":\"ear of corn\",\"category\":\"Foods\",\"aliases\":[\"corn\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌶\",\"description\":\"hot pepper\",\"category\":\"Foods\",\"aliases\":[\"hot_pepper\"],\"tags\":[\"spicy\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🥔\",\"description\":\"potato\",\"category\":\"Foods\",\"aliases\":[\"potato\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍠\",\"description\":\"roasted sweet potato\",\"category\":\"Foods\",\"aliases\":[\"sweet_potato\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌰\",\"description\":\"chestnut\",\"category\":\"Foods\",\"aliases\":[\"chestnut\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥜\",\"description\":\"peanuts\",\"category\":\"Foods\",\"aliases\":[\"peanuts\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍯\",\"description\":\"honey pot\",\"category\":\"Foods\",\"aliases\":[\"honey_pot\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥐\",\"description\":\"croissant\",\"category\":\"Foods\",\"aliases\":[\"croissant\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍞\",\"description\":\"bread\",\"category\":\"Foods\",\"aliases\":[\"bread\"],\"tags\":[\"toast\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥖\",\"description\":\"baguette bread\",\"category\":\"Foods\",\"aliases\":[\"baguette_bread\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🧀\",\"description\":\"cheese wedge\",\"category\":\"Foods\",\"aliases\":[\"cheese\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🥚\",\"description\":\"egg\",\"category\":\"Foods\",\"aliases\":[\"egg\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍳\",\"description\":\"cooking\",\"category\":\"Foods\",\"aliases\":[\"fried_egg\"],\"tags\":[\"breakfast\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥓\",\"description\":\"bacon\",\"category\":\"Foods\",\"aliases\":[\"bacon\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥞\",\"description\":\"pancakes\",\"category\":\"Foods\",\"aliases\":[\"pancakes\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍤\",\"description\":\"fried shrimp\",\"category\":\"Foods\",\"aliases\":[\"fried_shrimp\"],\"tags\":[\"tempura\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍗\",\"description\":\"poultry leg\",\"category\":\"Foods\",\"aliases\":[\"poultry_leg\"],\"tags\":[\"meat\",\"chicken\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍖\",\"description\":\"meat on bone\",\"category\":\"Foods\",\"aliases\":[\"meat_on_bone\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍕\",\"description\":\"pizza\",\"category\":\"Foods\",\"aliases\":[\"pizza\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌭\",\"description\":\"hot dog\",\"category\":\"Foods\",\"aliases\":[\"hotdog\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🍔\",\"description\":\"hamburger\",\"category\":\"Foods\",\"aliases\":[\"hamburger\"],\"tags\":[\"burger\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍟\",\"description\":\"french fries\",\"category\":\"Foods\",\"aliases\":[\"fries\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥙\",\"description\":\"stuffed flatbread\",\"category\":\"Foods\",\"aliases\":[\"stuffed_flatbread\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🌮\",\"description\":\"taco\",\"category\":\"Foods\",\"aliases\":[\"taco\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌯\",\"description\":\"burrito\",\"category\":\"Foods\",\"aliases\":[\"burrito\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🥗\",\"description\":\"green salad\",\"category\":\"Foods\",\"aliases\":[\"green_salad\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥘\",\"description\":\"shallow pan of food\",\"category\":\"Foods\",\"aliases\":[\"shallow_pan_of_food\"],\"tags\":[\"paella\",\"curry\"],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍝\",\"description\":\"spaghetti\",\"category\":\"Foods\",\"aliases\":[\"spaghetti\"],\"tags\":[\"pasta\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍜\",\"description\":\"steaming bowl\",\"category\":\"Foods\",\"aliases\":[\"ramen\"],\"tags\":[\"noodle\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍲\",\"description\":\"pot of food\",\"category\":\"Foods\",\"aliases\":[\"stew\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍥\",\"description\":\"fish cake with swirl\",\"category\":\"Foods\",\"aliases\":[\"fish_cake\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍣\",\"description\":\"sushi\",\"category\":\"Foods\",\"aliases\":[\"sushi\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍱\",\"description\":\"bento box\",\"category\":\"Foods\",\"aliases\":[\"bento\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍛\",\"description\":\"curry rice\",\"category\":\"Foods\",\"aliases\":[\"curry\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍚\",\"description\":\"cooked rice\",\"category\":\"Foods\",\"aliases\":[\"rice\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍙\",\"description\":\"rice ball\",\"category\":\"Foods\",\"aliases\":[\"rice_ball\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍘\",\"description\":\"rice cracker\",\"category\":\"Foods\",\"aliases\":[\"rice_cracker\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍢\",\"description\":\"oden\",\"category\":\"Foods\",\"aliases\":[\"oden\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍡\",\"description\":\"dango\",\"category\":\"Foods\",\"aliases\":[\"dango\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍧\",\"description\":\"shaved ice\",\"category\":\"Foods\",\"aliases\":[\"shaved_ice\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍨\",\"description\":\"ice cream\",\"category\":\"Foods\",\"aliases\":[\"ice_cream\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍦\",\"description\":\"soft ice cream\",\"category\":\"Foods\",\"aliases\":[\"icecream\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍰\",\"description\":\"shortcake\",\"category\":\"Foods\",\"aliases\":[\"cake\"],\"tags\":[\"dessert\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎂\",\"description\":\"birthday cake\",\"category\":\"Foods\",\"aliases\":[\"birthday\"],\"tags\":[\"party\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍮\",\"description\":\"custard\",\"category\":\"Foods\",\"aliases\":[\"custard\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍭\",\"description\":\"lollipop\",\"category\":\"Foods\",\"aliases\":[\"lollipop\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍬\",\"description\":\"candy\",\"category\":\"Foods\",\"aliases\":[\"candy\"],\"tags\":[\"sweet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍫\",\"description\":\"chocolate bar\",\"category\":\"Foods\",\"aliases\":[\"chocolate_bar\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍿\",\"description\":\"popcorn\",\"category\":\"Foods\",\"aliases\":[\"popcorn\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🍩\",\"description\":\"doughnut\",\"category\":\"Foods\",\"aliases\":[\"doughnut\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍪\",\"description\":\"cookie\",\"category\":\"Foods\",\"aliases\":[\"cookie\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥛\",\"description\":\"glass of milk\",\"category\":\"Foods\",\"aliases\":[\"milk_glass\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍼\",\"description\":\"baby bottle\",\"category\":\"Foods\",\"aliases\":[\"baby_bottle\"],\"tags\":[\"milk\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☕️\",\"description\":\"hot beverage\",\"category\":\"Foods\",\"aliases\":[\"coffee\"],\"tags\":[\"cafe\",\"espresso\"],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍵\",\"description\":\"teacup without handle\",\"category\":\"Foods\",\"aliases\":[\"tea\"],\"tags\":[\"green\",\"breakfast\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍶\",\"description\":\"sake\",\"category\":\"Foods\",\"aliases\":[\"sake\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍺\",\"description\":\"beer mug\",\"category\":\"Foods\",\"aliases\":[\"beer\"],\"tags\":[\"drink\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍻\",\"description\":\"clinking beer mugs\",\"category\":\"Foods\",\"aliases\":[\"beers\"],\"tags\":[\"drinks\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥂\",\"description\":\"clinking glasses\",\"category\":\"Foods\",\"aliases\":[\"clinking_glasses\"],\"tags\":[\"cheers\",\"toast\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍷\",\"description\":\"wine glass\",\"category\":\"Foods\",\"aliases\":[\"wine_glass\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥃\",\"description\":\"tumbler glass\",\"category\":\"Foods\",\"aliases\":[\"tumbler_glass\"],\"tags\":[\"whisky\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍸\",\"description\":\"cocktail glass\",\"category\":\"Foods\",\"aliases\":[\"cocktail\"],\"tags\":[\"drink\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍹\",\"description\":\"tropical drink\",\"category\":\"Foods\",\"aliases\":[\"tropical_drink\"],\"tags\":[\"summer\",\"vacation\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍾\",\"description\":\"bottle with popping cork\",\"category\":\"Foods\",\"aliases\":[\"champagne\"],\"tags\":[\"bottle\",\"bubbly\",\"celebration\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🥄\",\"description\":\"spoon\",\"category\":\"Foods\",\"aliases\":[\"spoon\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🍴\",\"description\":\"fork and knife\",\"category\":\"Foods\",\"aliases\":[\"fork_and_knife\"],\"tags\":[\"cutlery\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🍽\",\"description\":\"fork and knife with plate\",\"category\":\"Foods\",\"aliases\":[\"plate_with_cutlery\"],\"tags\":[\"dining\",\"dinner\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⚽️\",\"description\":\"soccer ball\",\"category\":\"Activity\",\"aliases\":[\"soccer\"],\"tags\":[\"sports\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏀\",\"description\":\"basketball\",\"category\":\"Activity\",\"aliases\":[\"basketball\"],\"tags\":[\"sports\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏈\",\"description\":\"american football\",\"category\":\"Activity\",\"aliases\":[\"football\"],\"tags\":[\"sports\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚾️\",\"description\":\"baseball\",\"category\":\"Activity\",\"aliases\":[\"baseball\"],\"tags\":[\"sports\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎾\",\"description\":\"tennis\",\"category\":\"Activity\",\"aliases\":[\"tennis\"],\"tags\":[\"sports\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏐\",\"description\":\"volleyball\",\"category\":\"Activity\",\"aliases\":[\"volleyball\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏉\",\"description\":\"rugby football\",\"category\":\"Activity\",\"aliases\":[\"rugby_football\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎱\",\"description\":\"pool 8 ball\",\"category\":\"Activity\",\"aliases\":[\"8ball\"],\"tags\":[\"pool\",\"billiards\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏓\",\"description\":\"ping pong\",\"category\":\"Activity\",\"aliases\":[\"ping_pong\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏸\",\"description\":\"badminton\",\"category\":\"Activity\",\"aliases\":[\"badminton\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🥅\",\"description\":\"goal net\",\"category\":\"Activity\",\"aliases\":[\"goal_net\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🏒\",\"description\":\"ice hockey\",\"category\":\"Activity\",\"aliases\":[\"ice_hockey\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏑\",\"description\":\"field hockey\",\"category\":\"Activity\",\"aliases\":[\"field_hockey\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏏\",\"description\":\"cricket\",\"category\":\"Activity\",\"aliases\":[\"cricket\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛳️\",\"description\":\"flag in hole\",\"category\":\"Activity\",\"aliases\":[\"golf\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏹\",\"description\":\"bow and arrow\",\"category\":\"Activity\",\"aliases\":[\"bow_and_arrow\"],\"tags\":[\"archery\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎣\",\"description\":\"fishing pole\",\"category\":\"Activity\",\"aliases\":[\"fishing_pole_and_fish\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥊\",\"description\":\"boxing glove\",\"category\":\"Activity\",\"aliases\":[\"boxing_glove\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥋\",\"description\":\"martial arts uniform\",\"category\":\"Activity\",\"aliases\":[\"martial_arts_uniform\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"⛸\",\"description\":\"ice skate\",\"category\":\"Activity\",\"aliases\":[\"ice_skate\"],\"tags\":[\"skating\"],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎿\",\"description\":\"skis\",\"category\":\"Activity\",\"aliases\":[\"ski\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⛷\",\"description\":\"skier\",\"category\":\"Activity\",\"aliases\":[\"skier\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏂\",\"description\":\"snowboarder\",\"category\":\"Activity\",\"aliases\":[\"snowboarder\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏋️‍♀️\",\"description\":\"woman lifting weights\",\"category\":\"Activity\",\"aliases\":[\"weight_lifting_woman\"],\"tags\":[\"gym\",\"workout\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🏋\",\"description\":\"person lifting weights\",\"category\":\"Activity\",\"aliases\":[\"weight_lifting_man\"],\"tags\":[\"gym\",\"workout\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤺\",\"description\":\"person fencing\",\"category\":\"Activity\",\"aliases\":[\"person_fencing\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤼‍♀\",\"description\":\"women wrestling\",\"category\":\"Activity\",\"aliases\":[\"women_wrestling\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤼‍♂\",\"description\":\"men wrestling\",\"category\":\"Activity\",\"aliases\":[\"men_wrestling\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤸‍♀\",\"description\":\"woman cartwheeling\",\"category\":\"Activity\",\"aliases\":[\"woman_cartwheeling\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤸‍♂\",\"description\":\"man cartwheeling\",\"category\":\"Activity\",\"aliases\":[\"man_cartwheeling\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"⛹️‍♀️\",\"description\":\"woman bouncing ball\",\"category\":\"Activity\",\"aliases\":[\"basketball_woman\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"⛹\",\"description\":\"person bouncing ball\",\"category\":\"Activity\",\"aliases\":[\"basketball_man\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🤾‍♀\",\"description\":\"woman playing handball\",\"category\":\"Activity\",\"aliases\":[\"woman_playing_handball\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤾‍♂\",\"description\":\"man playing handball\",\"category\":\"Activity\",\"aliases\":[\"man_playing_handball\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🏌️‍♀️\",\"description\":\"woman golfing\",\"category\":\"Activity\",\"aliases\":[\"golfing_woman\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.0\"},{\"emoji\":\"🏌\",\"description\":\"person golfing\",\"category\":\"Activity\",\"aliases\":[\"golfing_man\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏄‍♀\",\"description\":\"woman surfing\",\"category\":\"Activity\",\"aliases\":[\"surfing_woman\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🏄\",\"description\":\"person surfing\",\"category\":\"Activity\",\"aliases\":[\"surfing_man\",\"surfer\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏊‍♀\",\"description\":\"woman swimming\",\"category\":\"Activity\",\"aliases\":[\"swimming_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🏊\",\"description\":\"person swimming\",\"category\":\"Activity\",\"aliases\":[\"swimming_man\",\"swimmer\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤽‍♀\",\"description\":\"woman playing water polo\",\"category\":\"Activity\",\"aliases\":[\"woman_playing_water_polo\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤽‍♂\",\"description\":\"man playing water polo\",\"category\":\"Activity\",\"aliases\":[\"man_playing_water_polo\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🚣‍♀\",\"description\":\"woman rowing boat\",\"category\":\"Activity\",\"aliases\":[\"rowing_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🚣\",\"description\":\"person rowing boat\",\"category\":\"Activity\",\"aliases\":[\"rowing_man\",\"rowboat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏇\",\"description\":\"horse racing\",\"category\":\"Activity\",\"aliases\":[\"horse_racing\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚴‍♀\",\"description\":\"woman biking\",\"category\":\"Activity\",\"aliases\":[\"biking_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🚴\",\"description\":\"person biking\",\"category\":\"Activity\",\"aliases\":[\"biking_man\",\"bicyclist\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚵‍♀\",\"description\":\"woman mountain biking\",\"category\":\"Activity\",\"aliases\":[\"mountain_biking_woman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🚵\",\"description\":\"person mountain biking\",\"category\":\"Activity\",\"aliases\":[\"mountain_biking_man\",\"mountain_bicyclist\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎽\",\"description\":\"running shirt\",\"category\":\"Activity\",\"aliases\":[\"running_shirt_with_sash\"],\"tags\":[\"marathon\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏅\",\"description\":\"sports medal\",\"category\":\"Activity\",\"aliases\":[\"medal_sports\"],\"tags\":[\"gold\",\"winner\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎖\",\"description\":\"military medal\",\"category\":\"Activity\",\"aliases\":[\"medal_military\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🥇\",\"description\":\"1st place medal\",\"category\":\"Activity\",\"aliases\":[\"1st_place_medal\"],\"tags\":[\"gold\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥈\",\"description\":\"2nd place medal\",\"category\":\"Activity\",\"aliases\":[\"2nd_place_medal\"],\"tags\":[\"silver\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🥉\",\"description\":\"3rd place medal\",\"category\":\"Activity\",\"aliases\":[\"3rd_place_medal\"],\"tags\":[\"bronze\"],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🏆\",\"description\":\"trophy\",\"category\":\"Activity\",\"aliases\":[\"trophy\"],\"tags\":[\"award\",\"contest\",\"winner\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏵\",\"description\":\"rosette\",\"category\":\"Activity\",\"aliases\":[\"rosette\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎗\",\"description\":\"reminder ribbon\",\"category\":\"Activity\",\"aliases\":[\"reminder_ribbon\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎫\",\"description\":\"ticket\",\"category\":\"Activity\",\"aliases\":[\"ticket\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎟\",\"description\":\"admission tickets\",\"category\":\"Activity\",\"aliases\":[\"tickets\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎪\",\"description\":\"circus tent\",\"category\":\"Activity\",\"aliases\":[\"circus_tent\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🤹‍♀\",\"description\":\"woman juggling\",\"category\":\"Activity\",\"aliases\":[\"woman_juggling\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🤹‍♂\",\"description\":\"man juggling\",\"category\":\"Activity\",\"aliases\":[\"man_juggling\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🎭\",\"description\":\"performing arts\",\"category\":\"Activity\",\"aliases\":[\"performing_arts\"],\"tags\":[\"theater\",\"drama\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎨\",\"description\":\"artist palette\",\"category\":\"Activity\",\"aliases\":[\"art\"],\"tags\":[\"design\",\"paint\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎬\",\"description\":\"clapper board\",\"category\":\"Activity\",\"aliases\":[\"clapper\"],\"tags\":[\"film\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎤\",\"description\":\"microphone\",\"category\":\"Activity\",\"aliases\":[\"microphone\"],\"tags\":[\"sing\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎧\",\"description\":\"headphone\",\"category\":\"Activity\",\"aliases\":[\"headphones\"],\"tags\":[\"music\",\"earphones\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎼\",\"description\":\"musical score\",\"category\":\"Activity\",\"aliases\":[\"musical_score\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎹\",\"description\":\"musical keyboard\",\"category\":\"Activity\",\"aliases\":[\"musical_keyboard\"],\"tags\":[\"piano\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🥁\",\"description\":\"drum\",\"category\":\"Activity\",\"aliases\":[\"drum\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"10.2\"},{\"emoji\":\"🎷\",\"description\":\"saxophone\",\"category\":\"Activity\",\"aliases\":[\"saxophone\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎺\",\"description\":\"trumpet\",\"category\":\"Activity\",\"aliases\":[\"trumpet\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎸\",\"description\":\"guitar\",\"category\":\"Activity\",\"aliases\":[\"guitar\"],\"tags\":[\"rock\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎻\",\"description\":\"violin\",\"category\":\"Activity\",\"aliases\":[\"violin\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎲\",\"description\":\"game die\",\"category\":\"Activity\",\"aliases\":[\"game_die\"],\"tags\":[\"dice\",\"gambling\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎯\",\"description\":\"direct hit\",\"category\":\"Activity\",\"aliases\":[\"dart\"],\"tags\":[\"target\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎳\",\"description\":\"bowling\",\"category\":\"Activity\",\"aliases\":[\"bowling\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎮\",\"description\":\"video game\",\"category\":\"Activity\",\"aliases\":[\"video_game\"],\"tags\":[\"play\",\"controller\",\"console\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎰\",\"description\":\"slot machine\",\"category\":\"Activity\",\"aliases\":[\"slot_machine\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚗\",\"description\":\"automobile\",\"category\":\"Places\",\"aliases\":[\"car\",\"red_car\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚕\",\"description\":\"taxi\",\"category\":\"Places\",\"aliases\":[\"taxi\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚙\",\"description\":\"sport utility vehicle\",\"category\":\"Places\",\"aliases\":[\"blue_car\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚌\",\"description\":\"bus\",\"category\":\"Places\",\"aliases\":[\"bus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚎\",\"description\":\"trolleybus\",\"category\":\"Places\",\"aliases\":[\"trolleybus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏎\",\"description\":\"racing car\",\"category\":\"Places\",\"aliases\":[\"racing_car\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚓\",\"description\":\"police car\",\"category\":\"Places\",\"aliases\":[\"police_car\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚑\",\"description\":\"ambulance\",\"category\":\"Places\",\"aliases\":[\"ambulance\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚒\",\"description\":\"fire engine\",\"category\":\"Places\",\"aliases\":[\"fire_engine\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚐\",\"description\":\"minibus\",\"category\":\"Places\",\"aliases\":[\"minibus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚚\",\"description\":\"delivery truck\",\"category\":\"Places\",\"aliases\":[\"truck\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚛\",\"description\":\"articulated lorry\",\"category\":\"Places\",\"aliases\":[\"articulated_lorry\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚜\",\"description\":\"tractor\",\"category\":\"Places\",\"aliases\":[\"tractor\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛴\",\"description\":\"kick scooter\",\"category\":\"Places\",\"aliases\":[\"kick_scooter\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🚲\",\"description\":\"bicycle\",\"category\":\"Places\",\"aliases\":[\"bike\"],\"tags\":[\"bicycle\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛵\",\"description\":\"motor scooter\",\"category\":\"Places\",\"aliases\":[\"motor_scooter\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🏍\",\"description\":\"motorcycle\",\"category\":\"Places\",\"aliases\":[\"motorcycle\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚨\",\"description\":\"police car light\",\"category\":\"Places\",\"aliases\":[\"rotating_light\"],\"tags\":[\"911\",\"emergency\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚔\",\"description\":\"oncoming police car\",\"category\":\"Places\",\"aliases\":[\"oncoming_police_car\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚍\",\"description\":\"oncoming bus\",\"category\":\"Places\",\"aliases\":[\"oncoming_bus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚘\",\"description\":\"oncoming automobile\",\"category\":\"Places\",\"aliases\":[\"oncoming_automobile\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚖\",\"description\":\"oncoming taxi\",\"category\":\"Places\",\"aliases\":[\"oncoming_taxi\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚡\",\"description\":\"aerial tramway\",\"category\":\"Places\",\"aliases\":[\"aerial_tramway\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚠\",\"description\":\"mountain cableway\",\"category\":\"Places\",\"aliases\":[\"mountain_cableway\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚟\",\"description\":\"suspension railway\",\"category\":\"Places\",\"aliases\":[\"suspension_railway\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚃\",\"description\":\"railway car\",\"category\":\"Places\",\"aliases\":[\"railway_car\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚋\",\"description\":\"tram car\",\"category\":\"Places\",\"aliases\":[\"train\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚞\",\"description\":\"mountain railway\",\"category\":\"Places\",\"aliases\":[\"mountain_railway\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚝\",\"description\":\"monorail\",\"category\":\"Places\",\"aliases\":[\"monorail\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚄\",\"description\":\"high-speed train\",\"category\":\"Places\",\"aliases\":[\"bullettrain_side\"],\"tags\":[\"train\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚅\",\"description\":\"high-speed train with bullet nose\",\"category\":\"Places\",\"aliases\":[\"bullettrain_front\"],\"tags\":[\"train\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚈\",\"description\":\"light rail\",\"category\":\"Places\",\"aliases\":[\"light_rail\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚂\",\"description\":\"locomotive\",\"category\":\"Places\",\"aliases\":[\"steam_locomotive\"],\"tags\":[\"train\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚆\",\"description\":\"train\",\"category\":\"Places\",\"aliases\":[\"train2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚇\",\"description\":\"metro\",\"category\":\"Places\",\"aliases\":[\"metro\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚊\",\"description\":\"tram\",\"category\":\"Places\",\"aliases\":[\"tram\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚉\",\"description\":\"station\",\"category\":\"Places\",\"aliases\":[\"station\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚁\",\"description\":\"helicopter\",\"category\":\"Places\",\"aliases\":[\"helicopter\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛩\",\"description\":\"small airplane\",\"category\":\"Places\",\"aliases\":[\"small_airplane\"],\"tags\":[\"flight\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"✈️\",\"description\":\"airplane\",\"category\":\"Places\",\"aliases\":[\"airplane\"],\"tags\":[\"flight\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛫\",\"description\":\"airplane departure\",\"category\":\"Places\",\"aliases\":[\"flight_departure\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛬\",\"description\":\"airplane arrival\",\"category\":\"Places\",\"aliases\":[\"flight_arrival\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚀\",\"description\":\"rocket\",\"category\":\"Places\",\"aliases\":[\"rocket\"],\"tags\":[\"ship\",\"launch\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛰\",\"description\":\"satellite\",\"category\":\"Places\",\"aliases\":[\"artificial_satellite\"],\"tags\":[\"orbit\",\"space\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💺\",\"description\":\"seat\",\"category\":\"Places\",\"aliases\":[\"seat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛶\",\"description\":\"canoe\",\"category\":\"Places\",\"aliases\":[\"canoe\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"⛵️\",\"description\":\"sailboat\",\"category\":\"Places\",\"aliases\":[\"boat\",\"sailboat\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛥\",\"description\":\"motor boat\",\"category\":\"Places\",\"aliases\":[\"motor_boat\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚤\",\"description\":\"speedboat\",\"category\":\"Places\",\"aliases\":[\"speedboat\"],\"tags\":[\"ship\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛳\",\"description\":\"passenger ship\",\"category\":\"Places\",\"aliases\":[\"passenger_ship\"],\"tags\":[\"cruise\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛴\",\"description\":\"ferry\",\"category\":\"Places\",\"aliases\":[\"ferry\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚢\",\"description\":\"ship\",\"category\":\"Places\",\"aliases\":[\"ship\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚓️\",\"description\":\"anchor\",\"category\":\"Places\",\"aliases\":[\"anchor\"],\"tags\":[\"ship\"],\"unicode_version\":\"4.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚧\",\"description\":\"construction\",\"category\":\"Places\",\"aliases\":[\"construction\"],\"tags\":[\"wip\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⛽️\",\"description\":\"fuel pump\",\"category\":\"Places\",\"aliases\":[\"fuelpump\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚏\",\"description\":\"bus stop\",\"category\":\"Places\",\"aliases\":[\"busstop\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚦\",\"description\":\"vertical traffic light\",\"category\":\"Places\",\"aliases\":[\"vertical_traffic_light\"],\"tags\":[\"semaphore\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚥\",\"description\":\"horizontal traffic light\",\"category\":\"Places\",\"aliases\":[\"traffic_light\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗺\",\"description\":\"world map\",\"category\":\"Places\",\"aliases\":[\"world_map\"],\"tags\":[\"travel\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗿\",\"description\":\"moai\",\"category\":\"Places\",\"aliases\":[\"moyai\"],\"tags\":[\"stone\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗽\",\"description\":\"Statue of Liberty\",\"category\":\"Places\",\"aliases\":[\"statue_of_liberty\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⛲️\",\"description\":\"fountain\",\"category\":\"Places\",\"aliases\":[\"fountain\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗼\",\"description\":\"Tokyo tower\",\"category\":\"Places\",\"aliases\":[\"tokyo_tower\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏰\",\"description\":\"castle\",\"category\":\"Places\",\"aliases\":[\"european_castle\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏯\",\"description\":\"Japanese castle\",\"category\":\"Places\",\"aliases\":[\"japanese_castle\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏟\",\"description\":\"stadium\",\"category\":\"Places\",\"aliases\":[\"stadium\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎡\",\"description\":\"ferris wheel\",\"category\":\"Places\",\"aliases\":[\"ferris_wheel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎢\",\"description\":\"roller coaster\",\"category\":\"Places\",\"aliases\":[\"roller_coaster\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎠\",\"description\":\"carousel horse\",\"category\":\"Places\",\"aliases\":[\"carousel_horse\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⛱\",\"description\":\"umbrella on ground\",\"category\":\"Places\",\"aliases\":[\"parasol_on_ground\"],\"tags\":[\"beach_umbrella\"],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏖\",\"description\":\"beach with umbrella\",\"category\":\"Places\",\"aliases\":[\"beach_umbrella\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏝\",\"description\":\"desert island\",\"category\":\"Places\",\"aliases\":[\"desert_island\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛰\",\"description\":\"mountain\",\"category\":\"Places\",\"aliases\":[\"mountain\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏔\",\"description\":\"snow-capped mountain\",\"category\":\"Places\",\"aliases\":[\"mountain_snow\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗻\",\"description\":\"mount fuji\",\"category\":\"Places\",\"aliases\":[\"mount_fuji\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌋\",\"description\":\"volcano\",\"category\":\"Places\",\"aliases\":[\"volcano\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏜\",\"description\":\"desert\",\"category\":\"Places\",\"aliases\":[\"desert\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏕\",\"description\":\"camping\",\"category\":\"Places\",\"aliases\":[\"camping\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛺️\",\"description\":\"tent\",\"category\":\"Places\",\"aliases\":[\"tent\"],\"tags\":[\"camping\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛤\",\"description\":\"railway track\",\"category\":\"Places\",\"aliases\":[\"railway_track\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛣\",\"description\":\"motorway\",\"category\":\"Places\",\"aliases\":[\"motorway\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏗\",\"description\":\"building construction\",\"category\":\"Places\",\"aliases\":[\"building_construction\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏭\",\"description\":\"factory\",\"category\":\"Places\",\"aliases\":[\"factory\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏠\",\"description\":\"house\",\"category\":\"Places\",\"aliases\":[\"house\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏡\",\"description\":\"house with garden\",\"category\":\"Places\",\"aliases\":[\"house_with_garden\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏘\",\"description\":\"house\",\"category\":\"Places\",\"aliases\":[\"houses\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏚\",\"description\":\"derelict house\",\"category\":\"Places\",\"aliases\":[\"derelict_house\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏢\",\"description\":\"office building\",\"category\":\"Places\",\"aliases\":[\"office\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏬\",\"description\":\"department store\",\"category\":\"Places\",\"aliases\":[\"department_store\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏣\",\"description\":\"Japanese post office\",\"category\":\"Places\",\"aliases\":[\"post_office\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏤\",\"description\":\"post office\",\"category\":\"Places\",\"aliases\":[\"european_post_office\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏥\",\"description\":\"hospital\",\"category\":\"Places\",\"aliases\":[\"hospital\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏦\",\"description\":\"bank\",\"category\":\"Places\",\"aliases\":[\"bank\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏨\",\"description\":\"hotel\",\"category\":\"Places\",\"aliases\":[\"hotel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏪\",\"description\":\"convenience store\",\"category\":\"Places\",\"aliases\":[\"convenience_store\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏫\",\"description\":\"school\",\"category\":\"Places\",\"aliases\":[\"school\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏩\",\"description\":\"love hotel\",\"category\":\"Places\",\"aliases\":[\"love_hotel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💒\",\"description\":\"wedding\",\"category\":\"Places\",\"aliases\":[\"wedding\"],\"tags\":[\"marriage\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏛\",\"description\":\"classical building\",\"category\":\"Places\",\"aliases\":[\"classical_building\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛪️\",\"description\":\"church\",\"category\":\"Places\",\"aliases\":[\"church\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕌\",\"description\":\"mosque\",\"category\":\"Places\",\"aliases\":[\"mosque\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🕍\",\"description\":\"synagogue\",\"category\":\"Places\",\"aliases\":[\"synagogue\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🕋\",\"description\":\"kaaba\",\"category\":\"Places\",\"aliases\":[\"kaaba\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛩\",\"description\":\"shinto shrine\",\"category\":\"Places\",\"aliases\":[\"shinto_shrine\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗾\",\"description\":\"map of Japan\",\"category\":\"Places\",\"aliases\":[\"japan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎑\",\"description\":\"moon viewing ceremony\",\"category\":\"Places\",\"aliases\":[\"rice_scene\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏞\",\"description\":\"national park\",\"category\":\"Places\",\"aliases\":[\"national_park\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌅\",\"description\":\"sunrise\",\"category\":\"Places\",\"aliases\":[\"sunrise\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌄\",\"description\":\"sunrise over mountains\",\"category\":\"Places\",\"aliases\":[\"sunrise_over_mountains\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌠\",\"description\":\"shooting star\",\"category\":\"Places\",\"aliases\":[\"stars\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎇\",\"description\":\"sparkler\",\"category\":\"Places\",\"aliases\":[\"sparkler\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎆\",\"description\":\"fireworks\",\"category\":\"Places\",\"aliases\":[\"fireworks\"],\"tags\":[\"festival\",\"celebration\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌇\",\"description\":\"sunset\",\"category\":\"Places\",\"aliases\":[\"city_sunrise\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌆\",\"description\":\"cityscape at dusk\",\"category\":\"Places\",\"aliases\":[\"city_sunset\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏙\",\"description\":\"cityscape\",\"category\":\"Places\",\"aliases\":[\"cityscape\"],\"tags\":[\"skyline\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🌃\",\"description\":\"night with stars\",\"category\":\"Places\",\"aliases\":[\"night_with_stars\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌌\",\"description\":\"milky way\",\"category\":\"Places\",\"aliases\":[\"milky_way\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌉\",\"description\":\"bridge at night\",\"category\":\"Places\",\"aliases\":[\"bridge_at_night\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌁\",\"description\":\"foggy\",\"category\":\"Places\",\"aliases\":[\"foggy\"],\"tags\":[\"karl\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⌚️\",\"description\":\"watch\",\"category\":\"Objects\",\"aliases\":[\"watch\"],\"tags\":[\"time\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"📱\",\"description\":\"mobile phone\",\"category\":\"Objects\",\"aliases\":[\"iphone\"],\"tags\":[\"smartphone\",\"mobile\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📲\",\"description\":\"mobile phone with arrow\",\"category\":\"Objects\",\"aliases\":[\"calling\"],\"tags\":[\"call\",\"incoming\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💻\",\"description\":\"laptop computer\",\"category\":\"Objects\",\"aliases\":[\"computer\"],\"tags\":[\"desktop\",\"screen\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⌨️\",\"description\":\"keyboard\",\"category\":\"Objects\",\"aliases\":[\"keyboard\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖥\",\"description\":\"desktop computer\",\"category\":\"Objects\",\"aliases\":[\"desktop_computer\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖨\",\"description\":\"printer\",\"category\":\"Objects\",\"aliases\":[\"printer\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖱\",\"description\":\"computer mouse\",\"category\":\"Objects\",\"aliases\":[\"computer_mouse\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖲\",\"description\":\"trackball\",\"category\":\"Objects\",\"aliases\":[\"trackball\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🕹\",\"description\":\"joystick\",\"category\":\"Objects\",\"aliases\":[\"joystick\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗜\",\"description\":\"clamp\",\"category\":\"Objects\",\"aliases\":[\"clamp\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💽\",\"description\":\"computer disk\",\"category\":\"Objects\",\"aliases\":[\"minidisc\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💾\",\"description\":\"floppy disk\",\"category\":\"Objects\",\"aliases\":[\"floppy_disk\"],\"tags\":[\"save\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💿\",\"description\":\"optical disk\",\"category\":\"Objects\",\"aliases\":[\"cd\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📀\",\"description\":\"dvd\",\"category\":\"Objects\",\"aliases\":[\"dvd\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📼\",\"description\":\"videocassette\",\"category\":\"Objects\",\"aliases\":[\"vhs\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📷\",\"description\":\"camera\",\"category\":\"Objects\",\"aliases\":[\"camera\"],\"tags\":[\"photo\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📸\",\"description\":\"camera with flash\",\"category\":\"Objects\",\"aliases\":[\"camera_flash\"],\"tags\":[\"photo\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📹\",\"description\":\"video camera\",\"category\":\"Objects\",\"aliases\":[\"video_camera\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎥\",\"description\":\"movie camera\",\"category\":\"Objects\",\"aliases\":[\"movie_camera\"],\"tags\":[\"film\",\"video\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📽\",\"description\":\"film projector\",\"category\":\"Objects\",\"aliases\":[\"film_projector\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎞\",\"description\":\"film frames\",\"category\":\"Objects\",\"aliases\":[\"film_strip\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📞\",\"description\":\"telephone receiver\",\"category\":\"Objects\",\"aliases\":[\"telephone_receiver\"],\"tags\":[\"phone\",\"call\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☎️\",\"description\":\"telephone\",\"category\":\"Objects\",\"aliases\":[\"phone\",\"telephone\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"📟\",\"description\":\"pager\",\"category\":\"Objects\",\"aliases\":[\"pager\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📠\",\"description\":\"fax machine\",\"category\":\"Objects\",\"aliases\":[\"fax\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📺\",\"description\":\"television\",\"category\":\"Objects\",\"aliases\":[\"tv\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📻\",\"description\":\"radio\",\"category\":\"Objects\",\"aliases\":[\"radio\"],\"tags\":[\"podcast\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎙\",\"description\":\"studio microphone\",\"category\":\"Objects\",\"aliases\":[\"studio_microphone\"],\"tags\":[\"podcast\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎚\",\"description\":\"level slider\",\"category\":\"Objects\",\"aliases\":[\"level_slider\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🎛\",\"description\":\"control knobs\",\"category\":\"Objects\",\"aliases\":[\"control_knobs\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏱\",\"description\":\"stopwatch\",\"category\":\"Objects\",\"aliases\":[\"stopwatch\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏲\",\"description\":\"timer clock\",\"category\":\"Objects\",\"aliases\":[\"timer_clock\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏰\",\"description\":\"alarm clock\",\"category\":\"Objects\",\"aliases\":[\"alarm_clock\"],\"tags\":[\"morning\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕰\",\"description\":\"mantelpiece clock\",\"category\":\"Objects\",\"aliases\":[\"mantelpiece_clock\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⌛️\",\"description\":\"hourglass\",\"category\":\"Objects\",\"aliases\":[\"hourglass\"],\"tags\":[\"time\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"⏳\",\"description\":\"hourglass with flowing sand\",\"category\":\"Objects\",\"aliases\":[\"hourglass_flowing_sand\"],\"tags\":[\"time\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📡\",\"description\":\"satellite antenna\",\"category\":\"Objects\",\"aliases\":[\"satellite\"],\"tags\":[\"signal\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔋\",\"description\":\"battery\",\"category\":\"Objects\",\"aliases\":[\"battery\"],\"tags\":[\"power\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔌\",\"description\":\"electric plug\",\"category\":\"Objects\",\"aliases\":[\"electric_plug\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💡\",\"description\":\"light bulb\",\"category\":\"Objects\",\"aliases\":[\"bulb\"],\"tags\":[\"idea\",\"light\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔦\",\"description\":\"flashlight\",\"category\":\"Objects\",\"aliases\":[\"flashlight\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕯\",\"description\":\"candle\",\"category\":\"Objects\",\"aliases\":[\"candle\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗑\",\"description\":\"wastebasket\",\"category\":\"Objects\",\"aliases\":[\"wastebasket\"],\"tags\":[\"trash\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛢\",\"description\":\"oil drum\",\"category\":\"Objects\",\"aliases\":[\"oil_drum\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💸\",\"description\":\"money with wings\",\"category\":\"Objects\",\"aliases\":[\"money_with_wings\"],\"tags\":[\"dollar\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💵\",\"description\":\"dollar banknote\",\"category\":\"Objects\",\"aliases\":[\"dollar\"],\"tags\":[\"money\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💴\",\"description\":\"yen banknote\",\"category\":\"Objects\",\"aliases\":[\"yen\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💶\",\"description\":\"euro banknote\",\"category\":\"Objects\",\"aliases\":[\"euro\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💷\",\"description\":\"pound banknote\",\"category\":\"Objects\",\"aliases\":[\"pound\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💰\",\"description\":\"money bag\",\"category\":\"Objects\",\"aliases\":[\"moneybag\"],\"tags\":[\"dollar\",\"cream\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💳\",\"description\":\"credit card\",\"category\":\"Objects\",\"aliases\":[\"credit_card\"],\"tags\":[\"subscription\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💎\",\"description\":\"gem stone\",\"category\":\"Objects\",\"aliases\":[\"gem\"],\"tags\":[\"diamond\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚖️\",\"description\":\"balance scale\",\"category\":\"Objects\",\"aliases\":[\"balance_scale\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔧\",\"description\":\"wrench\",\"category\":\"Objects\",\"aliases\":[\"wrench\"],\"tags\":[\"tool\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔨\",\"description\":\"hammer\",\"category\":\"Objects\",\"aliases\":[\"hammer\"],\"tags\":[\"tool\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚒\",\"description\":\"hammer and pick\",\"category\":\"Objects\",\"aliases\":[\"hammer_and_pick\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛠\",\"description\":\"hammer and wrench\",\"category\":\"Objects\",\"aliases\":[\"hammer_and_wrench\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛏\",\"description\":\"pick\",\"category\":\"Objects\",\"aliases\":[\"pick\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔩\",\"description\":\"nut and bolt\",\"category\":\"Objects\",\"aliases\":[\"nut_and_bolt\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚙️\",\"description\":\"gear\",\"category\":\"Objects\",\"aliases\":[\"gear\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛓\",\"description\":\"chains\",\"category\":\"Objects\",\"aliases\":[\"chains\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔫\",\"description\":\"pistol\",\"category\":\"Objects\",\"aliases\":[\"gun\"],\"tags\":[\"shoot\",\"weapon\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💣\",\"description\":\"bomb\",\"category\":\"Objects\",\"aliases\":[\"bomb\"],\"tags\":[\"boom\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔪\",\"description\":\"kitchen knife\",\"category\":\"Objects\",\"aliases\":[\"hocho\",\"knife\"],\"tags\":[\"cut\",\"chop\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗡\",\"description\":\"dagger\",\"category\":\"Objects\",\"aliases\":[\"dagger\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⚔️\",\"description\":\"crossed swords\",\"category\":\"Objects\",\"aliases\":[\"crossed_swords\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛡\",\"description\":\"shield\",\"category\":\"Objects\",\"aliases\":[\"shield\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚬\",\"description\":\"cigarette\",\"category\":\"Objects\",\"aliases\":[\"smoking\"],\"tags\":[\"cigarette\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚰️\",\"description\":\"coffin\",\"category\":\"Objects\",\"aliases\":[\"coffin\"],\"tags\":[\"funeral\"],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"⚱️\",\"description\":\"funeral urn\",\"category\":\"Objects\",\"aliases\":[\"funeral_urn\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏺\",\"description\":\"amphora\",\"category\":\"Objects\",\"aliases\":[\"amphora\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔮\",\"description\":\"crystal ball\",\"category\":\"Objects\",\"aliases\":[\"crystal_ball\"],\"tags\":[\"fortune\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📿\",\"description\":\"prayer beads\",\"category\":\"Objects\",\"aliases\":[\"prayer_beads\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💈\",\"description\":\"barber pole\",\"category\":\"Objects\",\"aliases\":[\"barber\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚗️\",\"description\":\"alembic\",\"category\":\"Objects\",\"aliases\":[\"alembic\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔭\",\"description\":\"telescope\",\"category\":\"Objects\",\"aliases\":[\"telescope\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔬\",\"description\":\"microscope\",\"category\":\"Objects\",\"aliases\":[\"microscope\"],\"tags\":[\"science\",\"laboratory\",\"investigate\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕳\",\"description\":\"hole\",\"category\":\"Objects\",\"aliases\":[\"hole\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💊\",\"description\":\"pill\",\"category\":\"Objects\",\"aliases\":[\"pill\"],\"tags\":[\"health\",\"medicine\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💉\",\"description\":\"syringe\",\"category\":\"Objects\",\"aliases\":[\"syringe\"],\"tags\":[\"health\",\"hospital\",\"needle\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌡\",\"description\":\"thermometer\",\"category\":\"Objects\",\"aliases\":[\"thermometer\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚽\",\"description\":\"toilet\",\"category\":\"Objects\",\"aliases\":[\"toilet\"],\"tags\":[\"wc\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚰\",\"description\":\"potable water\",\"category\":\"Objects\",\"aliases\":[\"potable_water\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚿\",\"description\":\"shower\",\"category\":\"Objects\",\"aliases\":[\"shower\"],\"tags\":[\"bath\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛁\",\"description\":\"bathtub\",\"category\":\"Objects\",\"aliases\":[\"bathtub\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛀\",\"description\":\"person taking bath\",\"category\":\"Objects\",\"aliases\":[\"bath\"],\"tags\":[\"shower\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛎\",\"description\":\"bellhop bell\",\"category\":\"Objects\",\"aliases\":[\"bellhop_bell\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔑\",\"description\":\"key\",\"category\":\"Objects\",\"aliases\":[\"key\"],\"tags\":[\"lock\",\"password\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗝\",\"description\":\"old key\",\"category\":\"Objects\",\"aliases\":[\"old_key\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🚪\",\"description\":\"door\",\"category\":\"Objects\",\"aliases\":[\"door\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛋\",\"description\":\"couch and lamp\",\"category\":\"Objects\",\"aliases\":[\"couch_and_lamp\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛏\",\"description\":\"bed\",\"category\":\"Objects\",\"aliases\":[\"bed\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛌\",\"description\":\"person in bed\",\"category\":\"Objects\",\"aliases\":[\"sleeping_bed\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖼\",\"description\":\"framed picture\",\"category\":\"Objects\",\"aliases\":[\"framed_picture\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛍\",\"description\":\"shopping bags\",\"category\":\"Objects\",\"aliases\":[\"shopping\"],\"tags\":[\"bags\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛒\",\"description\":\"shopping cart\",\"category\":\"Objects\",\"aliases\":[\"shopping_cart\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"🎁\",\"description\":\"wrapped gift\",\"category\":\"Objects\",\"aliases\":[\"gift\"],\"tags\":[\"present\",\"birthday\",\"christmas\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎈\",\"description\":\"balloon\",\"category\":\"Objects\",\"aliases\":[\"balloon\"],\"tags\":[\"party\",\"birthday\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎏\",\"description\":\"carp streamer\",\"category\":\"Objects\",\"aliases\":[\"flags\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎀\",\"description\":\"ribbon\",\"category\":\"Objects\",\"aliases\":[\"ribbon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎊\",\"description\":\"confetti ball\",\"category\":\"Objects\",\"aliases\":[\"confetti_ball\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎉\",\"description\":\"party popper\",\"category\":\"Objects\",\"aliases\":[\"tada\"],\"tags\":[\"hooray\",\"party\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎎\",\"description\":\"Japanese dolls\",\"category\":\"Objects\",\"aliases\":[\"dolls\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏮\",\"description\":\"red paper lantern\",\"category\":\"Objects\",\"aliases\":[\"izakaya_lantern\",\"lantern\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎐\",\"description\":\"wind chime\",\"category\":\"Objects\",\"aliases\":[\"wind_chime\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✉️\",\"description\":\"envelope\",\"category\":\"Objects\",\"aliases\":[\"email\",\"envelope\"],\"tags\":[\"letter\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"📩\",\"description\":\"envelope with arrow\",\"category\":\"Objects\",\"aliases\":[\"envelope_with_arrow\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📨\",\"description\":\"incoming envelope\",\"category\":\"Objects\",\"aliases\":[\"incoming_envelope\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📧\",\"description\":\"e-mail\",\"category\":\"Objects\",\"aliases\":[\"e-mail\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💌\",\"description\":\"love letter\",\"category\":\"Objects\",\"aliases\":[\"love_letter\"],\"tags\":[\"email\",\"envelope\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📥\",\"description\":\"inbox tray\",\"category\":\"Objects\",\"aliases\":[\"inbox_tray\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📤\",\"description\":\"outbox tray\",\"category\":\"Objects\",\"aliases\":[\"outbox_tray\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📦\",\"description\":\"package\",\"category\":\"Objects\",\"aliases\":[\"package\"],\"tags\":[\"shipping\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏷\",\"description\":\"label\",\"category\":\"Objects\",\"aliases\":[\"label\"],\"tags\":[\"tag\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📪\",\"description\":\"closed mailbox with lowered flag\",\"category\":\"Objects\",\"aliases\":[\"mailbox_closed\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📫\",\"description\":\"closed mailbox with raised flag\",\"category\":\"Objects\",\"aliases\":[\"mailbox\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📬\",\"description\":\"open mailbox with raised flag\",\"category\":\"Objects\",\"aliases\":[\"mailbox_with_mail\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📭\",\"description\":\"open mailbox with lowered flag\",\"category\":\"Objects\",\"aliases\":[\"mailbox_with_no_mail\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📮\",\"description\":\"postbox\",\"category\":\"Objects\",\"aliases\":[\"postbox\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📯\",\"description\":\"postal horn\",\"category\":\"Objects\",\"aliases\":[\"postal_horn\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📜\",\"description\":\"scroll\",\"category\":\"Objects\",\"aliases\":[\"scroll\"],\"tags\":[\"document\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📃\",\"description\":\"page with curl\",\"category\":\"Objects\",\"aliases\":[\"page_with_curl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📄\",\"description\":\"page facing up\",\"category\":\"Objects\",\"aliases\":[\"page_facing_up\"],\"tags\":[\"document\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📑\",\"description\":\"bookmark tabs\",\"category\":\"Objects\",\"aliases\":[\"bookmark_tabs\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📊\",\"description\":\"bar chart\",\"category\":\"Objects\",\"aliases\":[\"bar_chart\"],\"tags\":[\"stats\",\"metrics\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📈\",\"description\":\"chart increasing\",\"category\":\"Objects\",\"aliases\":[\"chart_with_upwards_trend\"],\"tags\":[\"graph\",\"metrics\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📉\",\"description\":\"chart decreasing\",\"category\":\"Objects\",\"aliases\":[\"chart_with_downwards_trend\"],\"tags\":[\"graph\",\"metrics\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗒\",\"description\":\"spiral notepad\",\"category\":\"Objects\",\"aliases\":[\"spiral_notepad\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗓\",\"description\":\"spiral calendar\",\"category\":\"Objects\",\"aliases\":[\"spiral_calendar\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📆\",\"description\":\"tear-off calendar\",\"category\":\"Objects\",\"aliases\":[\"calendar\"],\"tags\":[\"schedule\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📅\",\"description\":\"calendar\",\"category\":\"Objects\",\"aliases\":[\"date\"],\"tags\":[\"calendar\",\"schedule\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📇\",\"description\":\"card index\",\"category\":\"Objects\",\"aliases\":[\"card_index\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗃\",\"description\":\"card file box\",\"category\":\"Objects\",\"aliases\":[\"card_file_box\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗳\",\"description\":\"ballot box with ballot\",\"category\":\"Objects\",\"aliases\":[\"ballot_box\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗄\",\"description\":\"file cabinet\",\"category\":\"Objects\",\"aliases\":[\"file_cabinet\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📋\",\"description\":\"clipboard\",\"category\":\"Objects\",\"aliases\":[\"clipboard\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📁\",\"description\":\"file folder\",\"category\":\"Objects\",\"aliases\":[\"file_folder\"],\"tags\":[\"directory\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📂\",\"description\":\"open file folder\",\"category\":\"Objects\",\"aliases\":[\"open_file_folder\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗂\",\"description\":\"card index dividers\",\"category\":\"Objects\",\"aliases\":[\"card_index_dividers\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🗞\",\"description\":\"rolled-up newspaper\",\"category\":\"Objects\",\"aliases\":[\"newspaper_roll\"],\"tags\":[\"press\"],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📰\",\"description\":\"newspaper\",\"category\":\"Objects\",\"aliases\":[\"newspaper\"],\"tags\":[\"press\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📓\",\"description\":\"notebook\",\"category\":\"Objects\",\"aliases\":[\"notebook\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📔\",\"description\":\"notebook with decorative cover\",\"category\":\"Objects\",\"aliases\":[\"notebook_with_decorative_cover\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📒\",\"description\":\"ledger\",\"category\":\"Objects\",\"aliases\":[\"ledger\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📕\",\"description\":\"closed book\",\"category\":\"Objects\",\"aliases\":[\"closed_book\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📗\",\"description\":\"green book\",\"category\":\"Objects\",\"aliases\":[\"green_book\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📘\",\"description\":\"blue book\",\"category\":\"Objects\",\"aliases\":[\"blue_book\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📙\",\"description\":\"orange book\",\"category\":\"Objects\",\"aliases\":[\"orange_book\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📚\",\"description\":\"books\",\"category\":\"Objects\",\"aliases\":[\"books\"],\"tags\":[\"library\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📖\",\"description\":\"open book\",\"category\":\"Objects\",\"aliases\":[\"book\",\"open_book\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔖\",\"description\":\"bookmark\",\"category\":\"Objects\",\"aliases\":[\"bookmark\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔗\",\"description\":\"link\",\"category\":\"Objects\",\"aliases\":[\"link\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📎\",\"description\":\"paperclip\",\"category\":\"Objects\",\"aliases\":[\"paperclip\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🖇\",\"description\":\"linked paperclips\",\"category\":\"Objects\",\"aliases\":[\"paperclips\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📐\",\"description\":\"triangular ruler\",\"category\":\"Objects\",\"aliases\":[\"triangular_ruler\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📏\",\"description\":\"straight ruler\",\"category\":\"Objects\",\"aliases\":[\"straight_ruler\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📌\",\"description\":\"pushpin\",\"category\":\"Objects\",\"aliases\":[\"pushpin\"],\"tags\":[\"location\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📍\",\"description\":\"round pushpin\",\"category\":\"Objects\",\"aliases\":[\"round_pushpin\"],\"tags\":[\"location\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✂️\",\"description\":\"scissors\",\"category\":\"Objects\",\"aliases\":[\"scissors\"],\"tags\":[\"cut\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🖊\",\"description\":\"pen\",\"category\":\"Objects\",\"aliases\":[\"pen\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖋\",\"description\":\"fountain pen\",\"category\":\"Objects\",\"aliases\":[\"fountain_pen\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"✒️\",\"description\":\"black nib\",\"category\":\"Objects\",\"aliases\":[\"black_nib\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🖌\",\"description\":\"paintbrush\",\"category\":\"Objects\",\"aliases\":[\"paintbrush\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🖍\",\"description\":\"crayon\",\"category\":\"Objects\",\"aliases\":[\"crayon\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"📝\",\"description\":\"memo\",\"category\":\"Objects\",\"aliases\":[\"memo\",\"pencil\"],\"tags\":[\"document\",\"note\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✏️\",\"description\":\"pencil\",\"category\":\"Objects\",\"aliases\":[\"pencil2\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔍\",\"description\":\"left-pointing magnifying glass\",\"category\":\"Objects\",\"aliases\":[\"mag\"],\"tags\":[\"search\",\"zoom\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔎\",\"description\":\"right-pointing magnifying glass\",\"category\":\"Objects\",\"aliases\":[\"mag_right\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔏\",\"description\":\"locked with pen\",\"category\":\"Objects\",\"aliases\":[\"lock_with_ink_pen\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔐\",\"description\":\"locked with key\",\"category\":\"Objects\",\"aliases\":[\"closed_lock_with_key\"],\"tags\":[\"security\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔒\",\"description\":\"locked\",\"category\":\"Objects\",\"aliases\":[\"lock\"],\"tags\":[\"security\",\"private\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔓\",\"description\":\"unlocked\",\"category\":\"Objects\",\"aliases\":[\"unlock\"],\"tags\":[\"security\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❤️\",\"description\":\"red heart\",\"category\":\"Symbols\",\"aliases\":[\"heart\"],\"tags\":[\"love\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"💛\",\"description\":\"yellow heart\",\"category\":\"Symbols\",\"aliases\":[\"yellow_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💚\",\"description\":\"green heart\",\"category\":\"Symbols\",\"aliases\":[\"green_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💙\",\"description\":\"blue heart\",\"category\":\"Symbols\",\"aliases\":[\"blue_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💜\",\"description\":\"purple heart\",\"category\":\"Symbols\",\"aliases\":[\"purple_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🖤\",\"description\":\"black heart\",\"category\":\"Symbols\",\"aliases\":[\"black_heart\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"💔\",\"description\":\"broken heart\",\"category\":\"Symbols\",\"aliases\":[\"broken_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❣️\",\"description\":\"heavy heart exclamation\",\"category\":\"Symbols\",\"aliases\":[\"heavy_heart_exclamation\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"💕\",\"description\":\"two hearts\",\"category\":\"Symbols\",\"aliases\":[\"two_hearts\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💞\",\"description\":\"revolving hearts\",\"category\":\"Symbols\",\"aliases\":[\"revolving_hearts\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💓\",\"description\":\"beating heart\",\"category\":\"Symbols\",\"aliases\":[\"heartbeat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💗\",\"description\":\"growing heart\",\"category\":\"Symbols\",\"aliases\":[\"heartpulse\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💖\",\"description\":\"sparkling heart\",\"category\":\"Symbols\",\"aliases\":[\"sparkling_heart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💘\",\"description\":\"heart with arrow\",\"category\":\"Symbols\",\"aliases\":[\"cupid\"],\"tags\":[\"love\",\"heart\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💝\",\"description\":\"heart with ribbon\",\"category\":\"Symbols\",\"aliases\":[\"gift_heart\"],\"tags\":[\"chocolates\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💟\",\"description\":\"heart decoration\",\"category\":\"Symbols\",\"aliases\":[\"heart_decoration\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☮️\",\"description\":\"peace symbol\",\"category\":\"Symbols\",\"aliases\":[\"peace_symbol\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"✝️\",\"description\":\"latin cross\",\"category\":\"Symbols\",\"aliases\":[\"latin_cross\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"☪️\",\"description\":\"star and crescent\",\"category\":\"Symbols\",\"aliases\":[\"star_and_crescent\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"🕉\",\"description\":\"om\",\"category\":\"Symbols\",\"aliases\":[\"om\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"☸️\",\"description\":\"wheel of dharma\",\"category\":\"Symbols\",\"aliases\":[\"wheel_of_dharma\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"✡️\",\"description\":\"star of David\",\"category\":\"Symbols\",\"aliases\":[\"star_of_david\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔯\",\"description\":\"dotted six-pointed star\",\"category\":\"Symbols\",\"aliases\":[\"six_pointed_star\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕎\",\"description\":\"menorah\",\"category\":\"Symbols\",\"aliases\":[\"menorah\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"☯️\",\"description\":\"yin yang\",\"category\":\"Symbols\",\"aliases\":[\"yin_yang\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"☦️\",\"description\":\"orthodox cross\",\"category\":\"Symbols\",\"aliases\":[\"orthodox_cross\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"🛐\",\"description\":\"place of worship\",\"category\":\"Symbols\",\"aliases\":[\"place_of_worship\"],\"tags\":[],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⛎\",\"description\":\"Ophiuchus\",\"category\":\"Symbols\",\"aliases\":[\"ophiuchus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"♈️\",\"description\":\"Aries\",\"category\":\"Symbols\",\"aliases\":[\"aries\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♉️\",\"description\":\"Taurus\",\"category\":\"Symbols\",\"aliases\":[\"taurus\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♊️\",\"description\":\"Gemini\",\"category\":\"Symbols\",\"aliases\":[\"gemini\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♋️\",\"description\":\"Cancer\",\"category\":\"Symbols\",\"aliases\":[\"cancer\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♌️\",\"description\":\"Leo\",\"category\":\"Symbols\",\"aliases\":[\"leo\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♍️\",\"description\":\"Virgo\",\"category\":\"Symbols\",\"aliases\":[\"virgo\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♎️\",\"description\":\"Libra\",\"category\":\"Symbols\",\"aliases\":[\"libra\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♏️\",\"description\":\"Scorpius\",\"category\":\"Symbols\",\"aliases\":[\"scorpius\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♐️\",\"description\":\"Sagittarius\",\"category\":\"Symbols\",\"aliases\":[\"sagittarius\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♑️\",\"description\":\"Capricorn\",\"category\":\"Symbols\",\"aliases\":[\"capricorn\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♒️\",\"description\":\"Aquarius\",\"category\":\"Symbols\",\"aliases\":[\"aquarius\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♓️\",\"description\":\"Pisces\",\"category\":\"Symbols\",\"aliases\":[\"pisces\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆔\",\"description\":\"ID button\",\"category\":\"Symbols\",\"aliases\":[\"id\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚛️\",\"description\":\"atom symbol\",\"category\":\"Symbols\",\"aliases\":[\"atom_symbol\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🉑\",\"description\":\"Japanese “acceptable” button\",\"category\":\"Symbols\",\"aliases\":[\"accept\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"☢️\",\"description\":\"radioactive\",\"category\":\"Symbols\",\"aliases\":[\"radioactive\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"☣️\",\"description\":\"biohazard\",\"category\":\"Symbols\",\"aliases\":[\"biohazard\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"📴\",\"description\":\"mobile phone off\",\"category\":\"Symbols\",\"aliases\":[\"mobile_phone_off\"],\"tags\":[\"mute\",\"off\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📳\",\"description\":\"vibration mode\",\"category\":\"Symbols\",\"aliases\":[\"vibration_mode\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈶\",\"description\":\"Japanese “not free of charge” button\",\"category\":\"Symbols\",\"aliases\":[\"u6709\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈚️\",\"description\":\"Japanese “free of charge” button\",\"category\":\"Symbols\",\"aliases\":[\"u7121\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈸\",\"description\":\"Japanese “application” button\",\"category\":\"Symbols\",\"aliases\":[\"u7533\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈺\",\"description\":\"Japanese “open for business” button\",\"category\":\"Symbols\",\"aliases\":[\"u55b6\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈷️\",\"description\":\"Japanese “monthly amount” button\",\"category\":\"Symbols\",\"aliases\":[\"u6708\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✴️\",\"description\":\"eight-pointed star\",\"category\":\"Symbols\",\"aliases\":[\"eight_pointed_black_star\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆚\",\"description\":\"VS button\",\"category\":\"Symbols\",\"aliases\":[\"vs\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💮\",\"description\":\"white flower\",\"category\":\"Symbols\",\"aliases\":[\"white_flower\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🉐\",\"description\":\"Japanese “bargain” button\",\"category\":\"Symbols\",\"aliases\":[\"ideograph_advantage\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"㊙️\",\"description\":\"Japanese “secret” button\",\"category\":\"Symbols\",\"aliases\":[\"secret\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"㊗️\",\"description\":\"Japanese “congratulations” button\",\"category\":\"Symbols\",\"aliases\":[\"congratulations\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈴\",\"description\":\"Japanese “passing grade” button\",\"category\":\"Symbols\",\"aliases\":[\"u5408\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈵\",\"description\":\"Japanese “no vacancy” button\",\"category\":\"Symbols\",\"aliases\":[\"u6e80\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈹\",\"description\":\"Japanese “discount” button\",\"category\":\"Symbols\",\"aliases\":[\"u5272\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈲\",\"description\":\"Japanese “prohibited” button\",\"category\":\"Symbols\",\"aliases\":[\"u7981\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🅰️\",\"description\":\"A button (blood type)\",\"category\":\"Symbols\",\"aliases\":[\"a\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🅱️\",\"description\":\"B button (blood type)\",\"category\":\"Symbols\",\"aliases\":[\"b\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆎\",\"description\":\"AB button (blood type)\",\"category\":\"Symbols\",\"aliases\":[\"ab\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆑\",\"description\":\"CL button\",\"category\":\"Symbols\",\"aliases\":[\"cl\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🅾️\",\"description\":\"O button (blood type)\",\"category\":\"Symbols\",\"aliases\":[\"o2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆘\",\"description\":\"SOS button\",\"category\":\"Symbols\",\"aliases\":[\"sos\"],\"tags\":[\"help\",\"emergency\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❌\",\"description\":\"cross mark\",\"category\":\"Symbols\",\"aliases\":[\"x\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⭕️\",\"description\":\"heavy large circle\",\"category\":\"Symbols\",\"aliases\":[\"o\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛑\",\"description\":\"stop sign\",\"category\":\"Symbols\",\"aliases\":[\"stop_sign\"],\"tags\":[],\"unicode_version\":\"9.0\",\"ios_version\":\"10.2\"},{\"emoji\":\"⛔️\",\"description\":\"no entry\",\"category\":\"Symbols\",\"aliases\":[\"no_entry\"],\"tags\":[\"limit\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"📛\",\"description\":\"name badge\",\"category\":\"Symbols\",\"aliases\":[\"name_badge\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚫\",\"description\":\"prohibited\",\"category\":\"Symbols\",\"aliases\":[\"no_entry_sign\"],\"tags\":[\"block\",\"forbidden\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💯\",\"description\":\"hundred points\",\"category\":\"Symbols\",\"aliases\":[\"100\"],\"tags\":[\"score\",\"perfect\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💢\",\"description\":\"anger symbol\",\"category\":\"Symbols\",\"aliases\":[\"anger\"],\"tags\":[\"angry\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"♨️\",\"description\":\"hot springs\",\"category\":\"Symbols\",\"aliases\":[\"hotsprings\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚷\",\"description\":\"no pedestrians\",\"category\":\"Symbols\",\"aliases\":[\"no_pedestrians\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚯\",\"description\":\"no littering\",\"category\":\"Symbols\",\"aliases\":[\"do_not_litter\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚳\",\"description\":\"no bicycles\",\"category\":\"Symbols\",\"aliases\":[\"no_bicycles\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚱\",\"description\":\"non-potable water\",\"category\":\"Symbols\",\"aliases\":[\"non-potable_water\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔞\",\"description\":\"no one under eighteen\",\"category\":\"Symbols\",\"aliases\":[\"underage\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📵\",\"description\":\"no mobile phones\",\"category\":\"Symbols\",\"aliases\":[\"no_mobile_phones\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚭\",\"description\":\"no smoking\",\"category\":\"Symbols\",\"aliases\":[\"no_smoking\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❗️\",\"description\":\"exclamation mark\",\"category\":\"Symbols\",\"aliases\":[\"exclamation\",\"heavy_exclamation_mark\"],\"tags\":[\"bang\"],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"❕\",\"description\":\"white exclamation mark\",\"category\":\"Symbols\",\"aliases\":[\"grey_exclamation\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❓\",\"description\":\"question mark\",\"category\":\"Symbols\",\"aliases\":[\"question\"],\"tags\":[\"confused\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❔\",\"description\":\"white question mark\",\"category\":\"Symbols\",\"aliases\":[\"grey_question\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"‼️\",\"description\":\"double exclamation mark\",\"category\":\"Symbols\",\"aliases\":[\"bangbang\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"⁉️\",\"description\":\"exclamation question mark\",\"category\":\"Symbols\",\"aliases\":[\"interrobang\"],\"tags\":[],\"unicode_version\":\"3.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔅\",\"description\":\"dim button\",\"category\":\"Symbols\",\"aliases\":[\"low_brightness\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔆\",\"description\":\"bright button\",\"category\":\"Symbols\",\"aliases\":[\"high_brightness\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"〽️\",\"description\":\"part alternation mark\",\"category\":\"Symbols\",\"aliases\":[\"part_alternation_mark\"],\"tags\":[],\"unicode_version\":\"3.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚠️\",\"description\":\"warning\",\"category\":\"Symbols\",\"aliases\":[\"warning\"],\"tags\":[\"wip\"],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚸\",\"description\":\"children crossing\",\"category\":\"Symbols\",\"aliases\":[\"children_crossing\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔱\",\"description\":\"trident emblem\",\"category\":\"Symbols\",\"aliases\":[\"trident\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚜️\",\"description\":\"fleur-de-lis\",\"category\":\"Symbols\",\"aliases\":[\"fleur_de_lis\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"9.1\"},{\"emoji\":\"🔰\",\"description\":\"Japanese symbol for beginner\",\"category\":\"Symbols\",\"aliases\":[\"beginner\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"♻️\",\"description\":\"recycling symbol\",\"category\":\"Symbols\",\"aliases\":[\"recycle\"],\"tags\":[\"environment\",\"green\"],\"unicode_version\":\"3.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"✅\",\"description\":\"white heavy check mark\",\"category\":\"Symbols\",\"aliases\":[\"white_check_mark\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈯️\",\"description\":\"Japanese “reserved” button\",\"category\":\"Symbols\",\"aliases\":[\"u6307\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"💹\",\"description\":\"chart increasing with yen\",\"category\":\"Symbols\",\"aliases\":[\"chart\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"❇️\",\"description\":\"sparkle\",\"category\":\"Symbols\",\"aliases\":[\"sparkle\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"✳️\",\"description\":\"eight-spoked asterisk\",\"category\":\"Symbols\",\"aliases\":[\"eight_spoked_asterisk\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"❎\",\"description\":\"cross mark button\",\"category\":\"Symbols\",\"aliases\":[\"negative_squared_cross_mark\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌐\",\"description\":\"globe with meridians\",\"category\":\"Symbols\",\"aliases\":[\"globe_with_meridians\"],\"tags\":[\"world\",\"global\",\"international\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💠\",\"description\":\"diamond with a dot\",\"category\":\"Symbols\",\"aliases\":[\"diamond_shape_with_a_dot_inside\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"Ⓜ️\",\"description\":\"circled M\",\"category\":\"Symbols\",\"aliases\":[\"m\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🌀\",\"description\":\"cyclone\",\"category\":\"Symbols\",\"aliases\":[\"cyclone\"],\"tags\":[\"swirl\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💤\",\"description\":\"zzz\",\"category\":\"Symbols\",\"aliases\":[\"zzz\"],\"tags\":[\"sleeping\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏧\",\"description\":\"ATM sign\",\"category\":\"Symbols\",\"aliases\":[\"atm\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚾\",\"description\":\"water closet\",\"category\":\"Symbols\",\"aliases\":[\"wc\"],\"tags\":[\"toilet\",\"restroom\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"♿️\",\"description\":\"wheelchair symbol\",\"category\":\"Symbols\",\"aliases\":[\"wheelchair\"],\"tags\":[\"accessibility\"],\"unicode_version\":\"4.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🅿️\",\"description\":\"P button\",\"category\":\"Symbols\",\"aliases\":[\"parking\"],\"tags\":[],\"unicode_version\":\"5.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈳\",\"description\":\"Japanese “vacancy” button\",\"category\":\"Symbols\",\"aliases\":[\"u7a7a\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈂️\",\"description\":\"Japanese “service charge” button\",\"category\":\"Symbols\",\"aliases\":[\"sa\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛂\",\"description\":\"passport control\",\"category\":\"Symbols\",\"aliases\":[\"passport_control\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛃\",\"description\":\"customs\",\"category\":\"Symbols\",\"aliases\":[\"customs\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛄\",\"description\":\"baggage claim\",\"category\":\"Symbols\",\"aliases\":[\"baggage_claim\"],\"tags\":[\"airport\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🛅\",\"description\":\"left luggage\",\"category\":\"Symbols\",\"aliases\":[\"left_luggage\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚹\",\"description\":\"men’s room\",\"category\":\"Symbols\",\"aliases\":[\"mens\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚺\",\"description\":\"women’s room\",\"category\":\"Symbols\",\"aliases\":[\"womens\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚼\",\"description\":\"baby symbol\",\"category\":\"Symbols\",\"aliases\":[\"baby_symbol\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚻\",\"description\":\"restroom\",\"category\":\"Symbols\",\"aliases\":[\"restroom\"],\"tags\":[\"toilet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚮\",\"description\":\"litter in bin sign\",\"category\":\"Symbols\",\"aliases\":[\"put_litter_in_its_place\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎦\",\"description\":\"cinema\",\"category\":\"Symbols\",\"aliases\":[\"cinema\"],\"tags\":[\"film\",\"movie\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📶\",\"description\":\"antenna bars\",\"category\":\"Symbols\",\"aliases\":[\"signal_strength\"],\"tags\":[\"wifi\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🈁\",\"description\":\"Japanese “here” button\",\"category\":\"Symbols\",\"aliases\":[\"koko\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔣\",\"description\":\"input symbols\",\"category\":\"Symbols\",\"aliases\":[\"symbols\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"ℹ️\",\"description\":\"information\",\"category\":\"Symbols\",\"aliases\":[\"information_source\"],\"tags\":[],\"unicode_version\":\"3.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔤\",\"description\":\"input latin letters\",\"category\":\"Symbols\",\"aliases\":[\"abc\"],\"tags\":[\"alphabet\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔡\",\"description\":\"input latin lowercase\",\"category\":\"Symbols\",\"aliases\":[\"abcd\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔠\",\"description\":\"input latin uppercase\",\"category\":\"Symbols\",\"aliases\":[\"capital_abcd\"],\"tags\":[\"letters\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆖\",\"description\":\"NG button\",\"category\":\"Symbols\",\"aliases\":[\"ng\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆗\",\"description\":\"OK button\",\"category\":\"Symbols\",\"aliases\":[\"ok\"],\"tags\":[\"yes\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆙\",\"description\":\"UP! button\",\"category\":\"Symbols\",\"aliases\":[\"up\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆒\",\"description\":\"COOL button\",\"category\":\"Symbols\",\"aliases\":[\"cool\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆕\",\"description\":\"NEW button\",\"category\":\"Symbols\",\"aliases\":[\"new\"],\"tags\":[\"fresh\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🆓\",\"description\":\"FREE button\",\"category\":\"Symbols\",\"aliases\":[\"free\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"0️⃣\",\"description\":\"keycap: 0\",\"category\":\"Symbols\",\"aliases\":[\"zero\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"1️⃣\",\"description\":\"keycap: 1\",\"category\":\"Symbols\",\"aliases\":[\"one\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"2️⃣\",\"description\":\"keycap: 2\",\"category\":\"Symbols\",\"aliases\":[\"two\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"3️⃣\",\"description\":\"keycap: 3\",\"category\":\"Symbols\",\"aliases\":[\"three\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"4️⃣\",\"description\":\"keycap: 4\",\"category\":\"Symbols\",\"aliases\":[\"four\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"5️⃣\",\"description\":\"keycap: 5\",\"category\":\"Symbols\",\"aliases\":[\"five\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"6️⃣\",\"description\":\"keycap: 6\",\"category\":\"Symbols\",\"aliases\":[\"six\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"7️⃣\",\"description\":\"keycap: 7\",\"category\":\"Symbols\",\"aliases\":[\"seven\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"8️⃣\",\"description\":\"keycap: 8\",\"category\":\"Symbols\",\"aliases\":[\"eight\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"9️⃣\",\"description\":\"keycap: 9\",\"category\":\"Symbols\",\"aliases\":[\"nine\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔟\",\"description\":\"keycap 10\",\"category\":\"Symbols\",\"aliases\":[\"keycap_ten\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔢\",\"description\":\"input numbers\",\"category\":\"Symbols\",\"aliases\":[\"1234\"],\"tags\":[\"numbers\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"#️⃣\",\"description\":\"keycap: #\",\"category\":\"Symbols\",\"aliases\":[\"hash\"],\"tags\":[\"number\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"*️⃣\",\"description\":\"keycap: *\",\"category\":\"Symbols\",\"aliases\":[\"asterisk\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"9.1\"},{\"emoji\":\"▶️\",\"description\":\"play button\",\"category\":\"Symbols\",\"aliases\":[\"arrow_forward\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"⏸\",\"description\":\"pause button\",\"category\":\"Symbols\",\"aliases\":[\"pause_button\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏯\",\"description\":\"play or pause button\",\"category\":\"Symbols\",\"aliases\":[\"play_or_pause_button\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏹\",\"description\":\"stop button\",\"category\":\"Symbols\",\"aliases\":[\"stop_button\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏺\",\"description\":\"record button\",\"category\":\"Symbols\",\"aliases\":[\"record_button\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏭\",\"description\":\"next track button\",\"category\":\"Symbols\",\"aliases\":[\"next_track_button\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏮\",\"description\":\"last track button\",\"category\":\"Symbols\",\"aliases\":[\"previous_track_button\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"⏩\",\"description\":\"fast-forward button\",\"category\":\"Symbols\",\"aliases\":[\"fast_forward\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⏪\",\"description\":\"fast reverse button\",\"category\":\"Symbols\",\"aliases\":[\"rewind\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⏫\",\"description\":\"fast up button\",\"category\":\"Symbols\",\"aliases\":[\"arrow_double_up\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⏬\",\"description\":\"fast down button\",\"category\":\"Symbols\",\"aliases\":[\"arrow_double_down\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"◀️\",\"description\":\"reverse button\",\"category\":\"Symbols\",\"aliases\":[\"arrow_backward\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔼\",\"description\":\"up button\",\"category\":\"Symbols\",\"aliases\":[\"arrow_up_small\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔽\",\"description\":\"down button\",\"category\":\"Symbols\",\"aliases\":[\"arrow_down_small\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"➡️\",\"description\":\"right arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_right\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"⬅️\",\"description\":\"left arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_left\"],\"tags\":[],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⬆️\",\"description\":\"up arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_up\"],\"tags\":[],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⬇️\",\"description\":\"down arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_down\"],\"tags\":[],\"unicode_version\":\"4.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"↗️\",\"description\":\"up-right arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_upper_right\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↘️\",\"description\":\"down-right arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_lower_right\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↙️\",\"description\":\"down-left arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_lower_left\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↖️\",\"description\":\"up-left arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_upper_left\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↕️\",\"description\":\"up-down arrow\",\"category\":\"Symbols\",\"aliases\":[\"arrow_up_down\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↔️\",\"description\":\"left-right arrow\",\"category\":\"Symbols\",\"aliases\":[\"left_right_arrow\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↪️\",\"description\":\"left arrow curving right\",\"category\":\"Symbols\",\"aliases\":[\"arrow_right_hook\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"↩️\",\"description\":\"right arrow curving left\",\"category\":\"Symbols\",\"aliases\":[\"leftwards_arrow_with_hook\"],\"tags\":[\"return\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"⤴️\",\"description\":\"right arrow curving up\",\"category\":\"Symbols\",\"aliases\":[\"arrow_heading_up\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"⤵️\",\"description\":\"right arrow curving down\",\"category\":\"Symbols\",\"aliases\":[\"arrow_heading_down\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔀\",\"description\":\"shuffle tracks button\",\"category\":\"Symbols\",\"aliases\":[\"twisted_rightwards_arrows\"],\"tags\":[\"shuffle\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔁\",\"description\":\"repeat button\",\"category\":\"Symbols\",\"aliases\":[\"repeat\"],\"tags\":[\"loop\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔂\",\"description\":\"repeat single button\",\"category\":\"Symbols\",\"aliases\":[\"repeat_one\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔄\",\"description\":\"anticlockwise arrows button\",\"category\":\"Symbols\",\"aliases\":[\"arrows_counterclockwise\"],\"tags\":[\"sync\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔃\",\"description\":\"clockwise vertical arrows\",\"category\":\"Symbols\",\"aliases\":[\"arrows_clockwise\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎵\",\"description\":\"musical note\",\"category\":\"Symbols\",\"aliases\":[\"musical_note\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎶\",\"description\":\"musical notes\",\"category\":\"Symbols\",\"aliases\":[\"notes\"],\"tags\":[\"music\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"➕\",\"description\":\"heavy plus sign\",\"category\":\"Symbols\",\"aliases\":[\"heavy_plus_sign\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"➖\",\"description\":\"heavy minus sign\",\"category\":\"Symbols\",\"aliases\":[\"heavy_minus_sign\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"➗\",\"description\":\"heavy division sign\",\"category\":\"Symbols\",\"aliases\":[\"heavy_division_sign\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✖️\",\"description\":\"heavy multiplication x\",\"category\":\"Symbols\",\"aliases\":[\"heavy_multiplication_x\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"💲\",\"description\":\"heavy dollar sign\",\"category\":\"Symbols\",\"aliases\":[\"heavy_dollar_sign\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💱\",\"description\":\"currency exchange\",\"category\":\"Symbols\",\"aliases\":[\"currency_exchange\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"™️\",\"description\":\"trade mark\",\"category\":\"Symbols\",\"aliases\":[\"tm\"],\"tags\":[\"trademark\"],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"©️\",\"description\":\"copyright\",\"category\":\"Symbols\",\"aliases\":[\"copyright\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"®️\",\"description\":\"registered\",\"category\":\"Symbols\",\"aliases\":[\"registered\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"〰️\",\"description\":\"wavy dash\",\"category\":\"Symbols\",\"aliases\":[\"wavy_dash\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"➰\",\"description\":\"curly loop\",\"category\":\"Symbols\",\"aliases\":[\"curly_loop\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"➿\",\"description\":\"double curly loop\",\"category\":\"Symbols\",\"aliases\":[\"loop\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔚\",\"description\":\"END arrow\",\"category\":\"Symbols\",\"aliases\":[\"end\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔙\",\"description\":\"BACK arrow\",\"category\":\"Symbols\",\"aliases\":[\"back\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔛\",\"description\":\"ON! arrow\",\"category\":\"Symbols\",\"aliases\":[\"on\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔝\",\"description\":\"TOP arrow\",\"category\":\"Symbols\",\"aliases\":[\"top\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔜\",\"description\":\"SOON arrow\",\"category\":\"Symbols\",\"aliases\":[\"soon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"✔️\",\"description\":\"heavy check mark\",\"category\":\"Symbols\",\"aliases\":[\"heavy_check_mark\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"☑️\",\"description\":\"ballot box with check\",\"category\":\"Symbols\",\"aliases\":[\"ballot_box_with_check\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔘\",\"description\":\"radio button\",\"category\":\"Symbols\",\"aliases\":[\"radio_button\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚪️\",\"description\":\"white circle\",\"category\":\"Symbols\",\"aliases\":[\"white_circle\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"⚫️\",\"description\":\"black circle\",\"category\":\"Symbols\",\"aliases\":[\"black_circle\"],\"tags\":[],\"unicode_version\":\"4.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔴\",\"description\":\"red circle\",\"category\":\"Symbols\",\"aliases\":[\"red_circle\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔵\",\"description\":\"blue circle\",\"category\":\"Symbols\",\"aliases\":[\"large_blue_circle\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔺\",\"description\":\"red triangle pointed up\",\"category\":\"Symbols\",\"aliases\":[\"small_red_triangle\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔻\",\"description\":\"red triangle pointed down\",\"category\":\"Symbols\",\"aliases\":[\"small_red_triangle_down\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔸\",\"description\":\"small orange diamond\",\"category\":\"Symbols\",\"aliases\":[\"small_orange_diamond\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔹\",\"description\":\"small blue diamond\",\"category\":\"Symbols\",\"aliases\":[\"small_blue_diamond\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔶\",\"description\":\"large orange diamond\",\"category\":\"Symbols\",\"aliases\":[\"large_orange_diamond\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔷\",\"description\":\"large blue diamond\",\"category\":\"Symbols\",\"aliases\":[\"large_blue_diamond\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔳\",\"description\":\"white square button\",\"category\":\"Symbols\",\"aliases\":[\"white_square_button\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔲\",\"description\":\"black square button\",\"category\":\"Symbols\",\"aliases\":[\"black_square_button\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"▪️\",\"description\":\"black small square\",\"category\":\"Symbols\",\"aliases\":[\"black_small_square\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"▫️\",\"description\":\"white small square\",\"category\":\"Symbols\",\"aliases\":[\"white_small_square\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"◾️\",\"description\":\"black medium-small square\",\"category\":\"Symbols\",\"aliases\":[\"black_medium_small_square\"],\"tags\":[],\"unicode_version\":\"3.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"◽️\",\"description\":\"white medium-small square\",\"category\":\"Symbols\",\"aliases\":[\"white_medium_small_square\"],\"tags\":[],\"unicode_version\":\"3.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"◼️\",\"description\":\"black medium square\",\"category\":\"Symbols\",\"aliases\":[\"black_medium_square\"],\"tags\":[],\"unicode_version\":\"3.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"◻️\",\"description\":\"white medium square\",\"category\":\"Symbols\",\"aliases\":[\"white_medium_square\"],\"tags\":[],\"unicode_version\":\"3.2\",\"ios_version\":\"6.0\"},{\"emoji\":\"⬛️\",\"description\":\"black large square\",\"category\":\"Symbols\",\"aliases\":[\"black_large_square\"],\"tags\":[],\"unicode_version\":\"5.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"⬜️\",\"description\":\"white large square\",\"category\":\"Symbols\",\"aliases\":[\"white_large_square\"],\"tags\":[],\"unicode_version\":\"5.1\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔈\",\"description\":\"speaker low volume\",\"category\":\"Symbols\",\"aliases\":[\"speaker\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔇\",\"description\":\"muted speaker\",\"category\":\"Symbols\",\"aliases\":[\"mute\"],\"tags\":[\"sound\",\"volume\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔉\",\"description\":\"speaker medium volume\",\"category\":\"Symbols\",\"aliases\":[\"sound\"],\"tags\":[\"volume\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔊\",\"description\":\"speaker high volume\",\"category\":\"Symbols\",\"aliases\":[\"loud_sound\"],\"tags\":[\"volume\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔔\",\"description\":\"bell\",\"category\":\"Symbols\",\"aliases\":[\"bell\"],\"tags\":[\"sound\",\"notification\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🔕\",\"description\":\"bell with slash\",\"category\":\"Symbols\",\"aliases\":[\"no_bell\"],\"tags\":[\"volume\",\"off\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📣\",\"description\":\"megaphone\",\"category\":\"Symbols\",\"aliases\":[\"mega\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"📢\",\"description\":\"loudspeaker\",\"category\":\"Symbols\",\"aliases\":[\"loudspeaker\"],\"tags\":[\"announcement\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"👁‍🗨\",\"description\":\"eye in speech bubble\",\"category\":\"Symbols\",\"aliases\":[\"eye_speech_bubble\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"💬\",\"description\":\"speech balloon\",\"category\":\"Symbols\",\"aliases\":[\"speech_balloon\"],\"tags\":[\"comment\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"💭\",\"description\":\"thought balloon\",\"category\":\"Symbols\",\"aliases\":[\"thought_balloon\"],\"tags\":[\"thinking\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🗯\",\"description\":\"right anger bubble\",\"category\":\"Symbols\",\"aliases\":[\"right_anger_bubble\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"♠️\",\"description\":\"spade suit\",\"category\":\"Symbols\",\"aliases\":[\"spades\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♣️\",\"description\":\"club suit\",\"category\":\"Symbols\",\"aliases\":[\"clubs\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♥️\",\"description\":\"heart suit\",\"category\":\"Symbols\",\"aliases\":[\"hearts\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"♦️\",\"description\":\"diamond suit\",\"category\":\"Symbols\",\"aliases\":[\"diamonds\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🃏\",\"description\":\"joker\",\"category\":\"Symbols\",\"aliases\":[\"black_joker\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎴\",\"description\":\"flower playing cards\",\"category\":\"Symbols\",\"aliases\":[\"flower_playing_cards\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🀄️\",\"description\":\"mahjong red dragon\",\"category\":\"Symbols\",\"aliases\":[\"mahjong\"],\"tags\":[],\"unicode_version\":\"\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕐\",\"description\":\"one o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock1\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕑\",\"description\":\"two o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock2\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕒\",\"description\":\"three o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock3\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕓\",\"description\":\"four o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock4\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕔\",\"description\":\"five o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock5\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕕\",\"description\":\"six o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock6\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕖\",\"description\":\"seven o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock7\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕗\",\"description\":\"eight o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock8\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕘\",\"description\":\"nine o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock9\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕙\",\"description\":\"ten o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock10\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕚\",\"description\":\"eleven o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock11\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕛\",\"description\":\"twelve o’clock\",\"category\":\"Symbols\",\"aliases\":[\"clock12\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕜\",\"description\":\"one-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock130\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕝\",\"description\":\"two-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock230\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕞\",\"description\":\"three-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock330\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕟\",\"description\":\"four-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock430\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕠\",\"description\":\"five-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock530\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕡\",\"description\":\"six-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock630\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕢\",\"description\":\"seven-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock730\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕣\",\"description\":\"eight-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock830\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕤\",\"description\":\"nine-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock930\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕥\",\"description\":\"ten-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock1030\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕦\",\"description\":\"eleven-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock1130\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🕧\",\"description\":\"twelve-thirty\",\"category\":\"Symbols\",\"aliases\":[\"clock1230\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏳️\",\"description\":\"white flag\",\"category\":\"Flags\",\"aliases\":[\"white_flag\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏴\",\"description\":\"black flag\",\"category\":\"Flags\",\"aliases\":[\"black_flag\"],\"tags\":[],\"unicode_version\":\"7.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🏁\",\"description\":\"chequered flag\",\"category\":\"Flags\",\"aliases\":[\"checkered_flag\"],\"tags\":[\"milestone\",\"finish\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🚩\",\"description\":\"triangular flag\",\"category\":\"Flags\",\"aliases\":[\"triangular_flag_on_post\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🏳️‍🌈\",\"description\":\"rainbow flag\",\"category\":\"Flags\",\"aliases\":[\"rainbow_flag\"],\"tags\":[\"pride\"],\"unicode_version\":\"6.0\",\"ios_version\":\"10.0\"},{\"emoji\":\"🇦🇫\",\"description\":\"Afghanistan\",\"category\":\"Flags\",\"aliases\":[\"afghanistan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇽\",\"description\":\"Åland Islands\",\"category\":\"Flags\",\"aliases\":[\"aland_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇦🇱\",\"description\":\"Albania\",\"category\":\"Flags\",\"aliases\":[\"albania\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇩🇿\",\"description\":\"Algeria\",\"category\":\"Flags\",\"aliases\":[\"algeria\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇸\",\"description\":\"American Samoa\",\"category\":\"Flags\",\"aliases\":[\"american_samoa\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇩\",\"description\":\"Andorra\",\"category\":\"Flags\",\"aliases\":[\"andorra\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇴\",\"description\":\"Angola\",\"category\":\"Flags\",\"aliases\":[\"angola\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇮\",\"description\":\"Anguilla\",\"category\":\"Flags\",\"aliases\":[\"anguilla\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇶\",\"description\":\"Antarctica\",\"category\":\"Flags\",\"aliases\":[\"antarctica\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇦🇬\",\"description\":\"Antigua & Barbuda\",\"category\":\"Flags\",\"aliases\":[\"antigua_barbuda\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇷\",\"description\":\"Argentina\",\"category\":\"Flags\",\"aliases\":[\"argentina\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇲\",\"description\":\"Armenia\",\"category\":\"Flags\",\"aliases\":[\"armenia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇼\",\"description\":\"Aruba\",\"category\":\"Flags\",\"aliases\":[\"aruba\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇺\",\"description\":\"Australia\",\"category\":\"Flags\",\"aliases\":[\"australia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇹\",\"description\":\"Austria\",\"category\":\"Flags\",\"aliases\":[\"austria\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇿\",\"description\":\"Azerbaijan\",\"category\":\"Flags\",\"aliases\":[\"azerbaijan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇸\",\"description\":\"Bahamas\",\"category\":\"Flags\",\"aliases\":[\"bahamas\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇭\",\"description\":\"Bahrain\",\"category\":\"Flags\",\"aliases\":[\"bahrain\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇩\",\"description\":\"Bangladesh\",\"category\":\"Flags\",\"aliases\":[\"bangladesh\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇧\",\"description\":\"Barbados\",\"category\":\"Flags\",\"aliases\":[\"barbados\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇾\",\"description\":\"Belarus\",\"category\":\"Flags\",\"aliases\":[\"belarus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇪\",\"description\":\"Belgium\",\"category\":\"Flags\",\"aliases\":[\"belgium\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇿\",\"description\":\"Belize\",\"category\":\"Flags\",\"aliases\":[\"belize\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇯\",\"description\":\"Benin\",\"category\":\"Flags\",\"aliases\":[\"benin\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇲\",\"description\":\"Bermuda\",\"category\":\"Flags\",\"aliases\":[\"bermuda\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇹\",\"description\":\"Bhutan\",\"category\":\"Flags\",\"aliases\":[\"bhutan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇴\",\"description\":\"Bolivia\",\"category\":\"Flags\",\"aliases\":[\"bolivia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇶\",\"description\":\"Caribbean Netherlands\",\"category\":\"Flags\",\"aliases\":[\"caribbean_netherlands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇧🇦\",\"description\":\"Bosnia & Herzegovina\",\"category\":\"Flags\",\"aliases\":[\"bosnia_herzegovina\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇼\",\"description\":\"Botswana\",\"category\":\"Flags\",\"aliases\":[\"botswana\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇷\",\"description\":\"Brazil\",\"category\":\"Flags\",\"aliases\":[\"brazil\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇴\",\"description\":\"British Indian Ocean Territory\",\"category\":\"Flags\",\"aliases\":[\"british_indian_ocean_territory\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇻🇬\",\"description\":\"British Virgin Islands\",\"category\":\"Flags\",\"aliases\":[\"british_virgin_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇳\",\"description\":\"Brunei\",\"category\":\"Flags\",\"aliases\":[\"brunei\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇬\",\"description\":\"Bulgaria\",\"category\":\"Flags\",\"aliases\":[\"bulgaria\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇫\",\"description\":\"Burkina Faso\",\"category\":\"Flags\",\"aliases\":[\"burkina_faso\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇮\",\"description\":\"Burundi\",\"category\":\"Flags\",\"aliases\":[\"burundi\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇻\",\"description\":\"Cape Verde\",\"category\":\"Flags\",\"aliases\":[\"cape_verde\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇭\",\"description\":\"Cambodia\",\"category\":\"Flags\",\"aliases\":[\"cambodia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇲\",\"description\":\"Cameroon\",\"category\":\"Flags\",\"aliases\":[\"cameroon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇦\",\"description\":\"Canada\",\"category\":\"Flags\",\"aliases\":[\"canada\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇨\",\"description\":\"Canary Islands\",\"category\":\"Flags\",\"aliases\":[\"canary_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇰🇾\",\"description\":\"Cayman Islands\",\"category\":\"Flags\",\"aliases\":[\"cayman_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇫\",\"description\":\"Central African Republic\",\"category\":\"Flags\",\"aliases\":[\"central_african_republic\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇩\",\"description\":\"Chad\",\"category\":\"Flags\",\"aliases\":[\"chad\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇨🇱\",\"description\":\"Chile\",\"category\":\"Flags\",\"aliases\":[\"chile\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇳\",\"description\":\"China\",\"category\":\"Flags\",\"aliases\":[\"cn\"],\"tags\":[\"china\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇨🇽\",\"description\":\"Christmas Island\",\"category\":\"Flags\",\"aliases\":[\"christmas_island\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇨🇨\",\"description\":\"Cocos (Keeling) Islands\",\"category\":\"Flags\",\"aliases\":[\"cocos_islands\"],\"tags\":[\"keeling\"],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇨🇴\",\"description\":\"Colombia\",\"category\":\"Flags\",\"aliases\":[\"colombia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇲\",\"description\":\"Comoros\",\"category\":\"Flags\",\"aliases\":[\"comoros\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇬\",\"description\":\"Congo - Brazzaville\",\"category\":\"Flags\",\"aliases\":[\"congo_brazzaville\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇩\",\"description\":\"Congo - Kinshasa\",\"category\":\"Flags\",\"aliases\":[\"congo_kinshasa\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇰\",\"description\":\"Cook Islands\",\"category\":\"Flags\",\"aliases\":[\"cook_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇷\",\"description\":\"Costa Rica\",\"category\":\"Flags\",\"aliases\":[\"costa_rica\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇮\",\"description\":\"Côte d’Ivoire\",\"category\":\"Flags\",\"aliases\":[\"cote_divoire\"],\"tags\":[\"ivory\"],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇭🇷\",\"description\":\"Croatia\",\"category\":\"Flags\",\"aliases\":[\"croatia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇺\",\"description\":\"Cuba\",\"category\":\"Flags\",\"aliases\":[\"cuba\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇼\",\"description\":\"Curaçao\",\"category\":\"Flags\",\"aliases\":[\"curacao\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇾\",\"description\":\"Cyprus\",\"category\":\"Flags\",\"aliases\":[\"cyprus\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇿\",\"description\":\"Czech Republic\",\"category\":\"Flags\",\"aliases\":[\"czech_republic\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇩🇰\",\"description\":\"Denmark\",\"category\":\"Flags\",\"aliases\":[\"denmark\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇩🇯\",\"description\":\"Djibouti\",\"category\":\"Flags\",\"aliases\":[\"djibouti\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇩🇲\",\"description\":\"Dominica\",\"category\":\"Flags\",\"aliases\":[\"dominica\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇩🇴\",\"description\":\"Dominican Republic\",\"category\":\"Flags\",\"aliases\":[\"dominican_republic\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇨\",\"description\":\"Ecuador\",\"category\":\"Flags\",\"aliases\":[\"ecuador\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇬\",\"description\":\"Egypt\",\"category\":\"Flags\",\"aliases\":[\"egypt\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇻\",\"description\":\"El Salvador\",\"category\":\"Flags\",\"aliases\":[\"el_salvador\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇶\",\"description\":\"Equatorial Guinea\",\"category\":\"Flags\",\"aliases\":[\"equatorial_guinea\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇷\",\"description\":\"Eritrea\",\"category\":\"Flags\",\"aliases\":[\"eritrea\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇪\",\"description\":\"Estonia\",\"category\":\"Flags\",\"aliases\":[\"estonia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇹\",\"description\":\"Ethiopia\",\"category\":\"Flags\",\"aliases\":[\"ethiopia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇺\",\"description\":\"European Union\",\"category\":\"Flags\",\"aliases\":[\"eu\",\"european_union\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇫🇰\",\"description\":\"Falkland Islands\",\"category\":\"Flags\",\"aliases\":[\"falkland_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇫🇴\",\"description\":\"Faroe Islands\",\"category\":\"Flags\",\"aliases\":[\"faroe_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇫🇯\",\"description\":\"Fiji\",\"category\":\"Flags\",\"aliases\":[\"fiji\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇫🇮\",\"description\":\"Finland\",\"category\":\"Flags\",\"aliases\":[\"finland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇫🇷\",\"description\":\"France\",\"category\":\"Flags\",\"aliases\":[\"fr\"],\"tags\":[\"france\",\"french\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇬🇫\",\"description\":\"French Guiana\",\"category\":\"Flags\",\"aliases\":[\"french_guiana\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇫\",\"description\":\"French Polynesia\",\"category\":\"Flags\",\"aliases\":[\"french_polynesia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇹🇫\",\"description\":\"French Southern Territories\",\"category\":\"Flags\",\"aliases\":[\"french_southern_territories\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇦\",\"description\":\"Gabon\",\"category\":\"Flags\",\"aliases\":[\"gabon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇲\",\"description\":\"Gambia\",\"category\":\"Flags\",\"aliases\":[\"gambia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇪\",\"description\":\"Georgia\",\"category\":\"Flags\",\"aliases\":[\"georgia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇩🇪\",\"description\":\"Germany\",\"category\":\"Flags\",\"aliases\":[\"de\"],\"tags\":[\"flag\",\"germany\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇬🇭\",\"description\":\"Ghana\",\"category\":\"Flags\",\"aliases\":[\"ghana\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇮\",\"description\":\"Gibraltar\",\"category\":\"Flags\",\"aliases\":[\"gibraltar\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇷\",\"description\":\"Greece\",\"category\":\"Flags\",\"aliases\":[\"greece\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇱\",\"description\":\"Greenland\",\"category\":\"Flags\",\"aliases\":[\"greenland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇬🇩\",\"description\":\"Grenada\",\"category\":\"Flags\",\"aliases\":[\"grenada\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇵\",\"description\":\"Guadeloupe\",\"category\":\"Flags\",\"aliases\":[\"guadeloupe\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇬🇺\",\"description\":\"Guam\",\"category\":\"Flags\",\"aliases\":[\"guam\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇹\",\"description\":\"Guatemala\",\"category\":\"Flags\",\"aliases\":[\"guatemala\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇬\",\"description\":\"Guernsey\",\"category\":\"Flags\",\"aliases\":[\"guernsey\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇬🇳\",\"description\":\"Guinea\",\"category\":\"Flags\",\"aliases\":[\"guinea\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇼\",\"description\":\"Guinea-Bissau\",\"category\":\"Flags\",\"aliases\":[\"guinea_bissau\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇾\",\"description\":\"Guyana\",\"category\":\"Flags\",\"aliases\":[\"guyana\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇭🇹\",\"description\":\"Haiti\",\"category\":\"Flags\",\"aliases\":[\"haiti\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇭🇳\",\"description\":\"Honduras\",\"category\":\"Flags\",\"aliases\":[\"honduras\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇭🇰\",\"description\":\"Hong Kong SAR China\",\"category\":\"Flags\",\"aliases\":[\"hong_kong\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇭🇺\",\"description\":\"Hungary\",\"category\":\"Flags\",\"aliases\":[\"hungary\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇸\",\"description\":\"Iceland\",\"category\":\"Flags\",\"aliases\":[\"iceland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇳\",\"description\":\"India\",\"category\":\"Flags\",\"aliases\":[\"india\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇩\",\"description\":\"Indonesia\",\"category\":\"Flags\",\"aliases\":[\"indonesia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇷\",\"description\":\"Iran\",\"category\":\"Flags\",\"aliases\":[\"iran\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇶\",\"description\":\"Iraq\",\"category\":\"Flags\",\"aliases\":[\"iraq\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇪\",\"description\":\"Ireland\",\"category\":\"Flags\",\"aliases\":[\"ireland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇲\",\"description\":\"Isle of Man\",\"category\":\"Flags\",\"aliases\":[\"isle_of_man\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇮🇱\",\"description\":\"Israel\",\"category\":\"Flags\",\"aliases\":[\"israel\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇮🇹\",\"description\":\"Italy\",\"category\":\"Flags\",\"aliases\":[\"it\"],\"tags\":[\"italy\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇯🇲\",\"description\":\"Jamaica\",\"category\":\"Flags\",\"aliases\":[\"jamaica\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇯🇵\",\"description\":\"Japan\",\"category\":\"Flags\",\"aliases\":[\"jp\"],\"tags\":[\"japan\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🎌\",\"description\":\"crossed flags\",\"category\":\"Flags\",\"aliases\":[\"crossed_flags\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇯🇪\",\"description\":\"Jersey\",\"category\":\"Flags\",\"aliases\":[\"jersey\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇯🇴\",\"description\":\"Jordan\",\"category\":\"Flags\",\"aliases\":[\"jordan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇿\",\"description\":\"Kazakhstan\",\"category\":\"Flags\",\"aliases\":[\"kazakhstan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇪\",\"description\":\"Kenya\",\"category\":\"Flags\",\"aliases\":[\"kenya\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇮\",\"description\":\"Kiribati\",\"category\":\"Flags\",\"aliases\":[\"kiribati\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇽🇰\",\"description\":\"Kosovo\",\"category\":\"Flags\",\"aliases\":[\"kosovo\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇼\",\"description\":\"Kuwait\",\"category\":\"Flags\",\"aliases\":[\"kuwait\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇬\",\"description\":\"Kyrgyzstan\",\"category\":\"Flags\",\"aliases\":[\"kyrgyzstan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇦\",\"description\":\"Laos\",\"category\":\"Flags\",\"aliases\":[\"laos\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇻\",\"description\":\"Latvia\",\"category\":\"Flags\",\"aliases\":[\"latvia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇧\",\"description\":\"Lebanon\",\"category\":\"Flags\",\"aliases\":[\"lebanon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇸\",\"description\":\"Lesotho\",\"category\":\"Flags\",\"aliases\":[\"lesotho\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇷\",\"description\":\"Liberia\",\"category\":\"Flags\",\"aliases\":[\"liberia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇾\",\"description\":\"Libya\",\"category\":\"Flags\",\"aliases\":[\"libya\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇮\",\"description\":\"Liechtenstein\",\"category\":\"Flags\",\"aliases\":[\"liechtenstein\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇹\",\"description\":\"Lithuania\",\"category\":\"Flags\",\"aliases\":[\"lithuania\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇺\",\"description\":\"Luxembourg\",\"category\":\"Flags\",\"aliases\":[\"luxembourg\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇴\",\"description\":\"Macau SAR China\",\"category\":\"Flags\",\"aliases\":[\"macau\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇰\",\"description\":\"Macedonia\",\"category\":\"Flags\",\"aliases\":[\"macedonia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇬\",\"description\":\"Madagascar\",\"category\":\"Flags\",\"aliases\":[\"madagascar\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇼\",\"description\":\"Malawi\",\"category\":\"Flags\",\"aliases\":[\"malawi\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇾\",\"description\":\"Malaysia\",\"category\":\"Flags\",\"aliases\":[\"malaysia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇻\",\"description\":\"Maldives\",\"category\":\"Flags\",\"aliases\":[\"maldives\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇱\",\"description\":\"Mali\",\"category\":\"Flags\",\"aliases\":[\"mali\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇹\",\"description\":\"Malta\",\"category\":\"Flags\",\"aliases\":[\"malta\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇭\",\"description\":\"Marshall Islands\",\"category\":\"Flags\",\"aliases\":[\"marshall_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇲🇶\",\"description\":\"Martinique\",\"category\":\"Flags\",\"aliases\":[\"martinique\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇲🇷\",\"description\":\"Mauritania\",\"category\":\"Flags\",\"aliases\":[\"mauritania\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇺\",\"description\":\"Mauritius\",\"category\":\"Flags\",\"aliases\":[\"mauritius\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇾🇹\",\"description\":\"Mayotte\",\"category\":\"Flags\",\"aliases\":[\"mayotte\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇲🇽\",\"description\":\"Mexico\",\"category\":\"Flags\",\"aliases\":[\"mexico\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇫🇲\",\"description\":\"Micronesia\",\"category\":\"Flags\",\"aliases\":[\"micronesia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇲🇩\",\"description\":\"Moldova\",\"category\":\"Flags\",\"aliases\":[\"moldova\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇨\",\"description\":\"Monaco\",\"category\":\"Flags\",\"aliases\":[\"monaco\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇲🇳\",\"description\":\"Mongolia\",\"category\":\"Flags\",\"aliases\":[\"mongolia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇪\",\"description\":\"Montenegro\",\"category\":\"Flags\",\"aliases\":[\"montenegro\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇸\",\"description\":\"Montserrat\",\"category\":\"Flags\",\"aliases\":[\"montserrat\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇦\",\"description\":\"Morocco\",\"category\":\"Flags\",\"aliases\":[\"morocco\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇿\",\"description\":\"Mozambique\",\"category\":\"Flags\",\"aliases\":[\"mozambique\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇲🇲\",\"description\":\"Myanmar (Burma)\",\"category\":\"Flags\",\"aliases\":[\"myanmar\"],\"tags\":[\"burma\"],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇦\",\"description\":\"Namibia\",\"category\":\"Flags\",\"aliases\":[\"namibia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇷\",\"description\":\"Nauru\",\"category\":\"Flags\",\"aliases\":[\"nauru\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇳🇵\",\"description\":\"Nepal\",\"category\":\"Flags\",\"aliases\":[\"nepal\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇱\",\"description\":\"Netherlands\",\"category\":\"Flags\",\"aliases\":[\"netherlands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇨\",\"description\":\"New Caledonia\",\"category\":\"Flags\",\"aliases\":[\"new_caledonia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇿\",\"description\":\"New Zealand\",\"category\":\"Flags\",\"aliases\":[\"new_zealand\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇮\",\"description\":\"Nicaragua\",\"category\":\"Flags\",\"aliases\":[\"nicaragua\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇪\",\"description\":\"Niger\",\"category\":\"Flags\",\"aliases\":[\"niger\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇬\",\"description\":\"Nigeria\",\"category\":\"Flags\",\"aliases\":[\"nigeria\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇺\",\"description\":\"Niue\",\"category\":\"Flags\",\"aliases\":[\"niue\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇫\",\"description\":\"Norfolk Island\",\"category\":\"Flags\",\"aliases\":[\"norfolk_island\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇲🇵\",\"description\":\"Northern Mariana Islands\",\"category\":\"Flags\",\"aliases\":[\"northern_mariana_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇰🇵\",\"description\":\"North Korea\",\"category\":\"Flags\",\"aliases\":[\"north_korea\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇳🇴\",\"description\":\"Norway\",\"category\":\"Flags\",\"aliases\":[\"norway\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇴🇲\",\"description\":\"Oman\",\"category\":\"Flags\",\"aliases\":[\"oman\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇰\",\"description\":\"Pakistan\",\"category\":\"Flags\",\"aliases\":[\"pakistan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇼\",\"description\":\"Palau\",\"category\":\"Flags\",\"aliases\":[\"palau\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇸\",\"description\":\"Palestinian Territories\",\"category\":\"Flags\",\"aliases\":[\"palestinian_territories\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇦\",\"description\":\"Panama\",\"category\":\"Flags\",\"aliases\":[\"panama\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇬\",\"description\":\"Papua New Guinea\",\"category\":\"Flags\",\"aliases\":[\"papua_new_guinea\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇾\",\"description\":\"Paraguay\",\"category\":\"Flags\",\"aliases\":[\"paraguay\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇪\",\"description\":\"Peru\",\"category\":\"Flags\",\"aliases\":[\"peru\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇭\",\"description\":\"Philippines\",\"category\":\"Flags\",\"aliases\":[\"philippines\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇳\",\"description\":\"Pitcairn Islands\",\"category\":\"Flags\",\"aliases\":[\"pitcairn_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇵🇱\",\"description\":\"Poland\",\"category\":\"Flags\",\"aliases\":[\"poland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇹\",\"description\":\"Portugal\",\"category\":\"Flags\",\"aliases\":[\"portugal\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇷\",\"description\":\"Puerto Rico\",\"category\":\"Flags\",\"aliases\":[\"puerto_rico\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇶🇦\",\"description\":\"Qatar\",\"category\":\"Flags\",\"aliases\":[\"qatar\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇷🇪\",\"description\":\"Réunion\",\"category\":\"Flags\",\"aliases\":[\"reunion\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇷🇴\",\"description\":\"Romania\",\"category\":\"Flags\",\"aliases\":[\"romania\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇷🇺\",\"description\":\"Russia\",\"category\":\"Flags\",\"aliases\":[\"ru\"],\"tags\":[\"russia\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇷🇼\",\"description\":\"Rwanda\",\"category\":\"Flags\",\"aliases\":[\"rwanda\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇧🇱\",\"description\":\"St. Barthélemy\",\"category\":\"Flags\",\"aliases\":[\"st_barthelemy\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇸🇭\",\"description\":\"St. Helena\",\"category\":\"Flags\",\"aliases\":[\"st_helena\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇰🇳\",\"description\":\"St. Kitts & Nevis\",\"category\":\"Flags\",\"aliases\":[\"st_kitts_nevis\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇱🇨\",\"description\":\"St. Lucia\",\"category\":\"Flags\",\"aliases\":[\"st_lucia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇵🇲\",\"description\":\"St. Pierre & Miquelon\",\"category\":\"Flags\",\"aliases\":[\"st_pierre_miquelon\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇻🇨\",\"description\":\"St. Vincent & Grenadines\",\"category\":\"Flags\",\"aliases\":[\"st_vincent_grenadines\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇼🇸\",\"description\":\"Samoa\",\"category\":\"Flags\",\"aliases\":[\"samoa\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇲\",\"description\":\"San Marino\",\"category\":\"Flags\",\"aliases\":[\"san_marino\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇹\",\"description\":\"São Tomé & Príncipe\",\"category\":\"Flags\",\"aliases\":[\"sao_tome_principe\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇦\",\"description\":\"Saudi Arabia\",\"category\":\"Flags\",\"aliases\":[\"saudi_arabia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇳\",\"description\":\"Senegal\",\"category\":\"Flags\",\"aliases\":[\"senegal\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇷🇸\",\"description\":\"Serbia\",\"category\":\"Flags\",\"aliases\":[\"serbia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇨\",\"description\":\"Seychelles\",\"category\":\"Flags\",\"aliases\":[\"seychelles\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇱\",\"description\":\"Sierra Leone\",\"category\":\"Flags\",\"aliases\":[\"sierra_leone\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇬\",\"description\":\"Singapore\",\"category\":\"Flags\",\"aliases\":[\"singapore\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇽\",\"description\":\"Sint Maarten\",\"category\":\"Flags\",\"aliases\":[\"sint_maarten\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇰\",\"description\":\"Slovakia\",\"category\":\"Flags\",\"aliases\":[\"slovakia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇮\",\"description\":\"Slovenia\",\"category\":\"Flags\",\"aliases\":[\"slovenia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇧\",\"description\":\"Solomon Islands\",\"category\":\"Flags\",\"aliases\":[\"solomon_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇴\",\"description\":\"Somalia\",\"category\":\"Flags\",\"aliases\":[\"somalia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇿🇦\",\"description\":\"South Africa\",\"category\":\"Flags\",\"aliases\":[\"south_africa\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇸\",\"description\":\"South Georgia & South Sandwich Islands\",\"category\":\"Flags\",\"aliases\":[\"south_georgia_south_sandwich_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇰🇷\",\"description\":\"South Korea\",\"category\":\"Flags\",\"aliases\":[\"kr\"],\"tags\":[\"korea\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇸🇸\",\"description\":\"South Sudan\",\"category\":\"Flags\",\"aliases\":[\"south_sudan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇪🇸\",\"description\":\"Spain\",\"category\":\"Flags\",\"aliases\":[\"es\"],\"tags\":[\"spain\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇱🇰\",\"description\":\"Sri Lanka\",\"category\":\"Flags\",\"aliases\":[\"sri_lanka\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇩\",\"description\":\"Sudan\",\"category\":\"Flags\",\"aliases\":[\"sudan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇷\",\"description\":\"Suriname\",\"category\":\"Flags\",\"aliases\":[\"suriname\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇿\",\"description\":\"Swaziland\",\"category\":\"Flags\",\"aliases\":[\"swaziland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇪\",\"description\":\"Sweden\",\"category\":\"Flags\",\"aliases\":[\"sweden\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇨🇭\",\"description\":\"Switzerland\",\"category\":\"Flags\",\"aliases\":[\"switzerland\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇸🇾\",\"description\":\"Syria\",\"category\":\"Flags\",\"aliases\":[\"syria\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇼\",\"description\":\"Taiwan\",\"category\":\"Flags\",\"aliases\":[\"taiwan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇹🇯\",\"description\":\"Tajikistan\",\"category\":\"Flags\",\"aliases\":[\"tajikistan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇿\",\"description\":\"Tanzania\",\"category\":\"Flags\",\"aliases\":[\"tanzania\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇭\",\"description\":\"Thailand\",\"category\":\"Flags\",\"aliases\":[\"thailand\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇱\",\"description\":\"Timor-Leste\",\"category\":\"Flags\",\"aliases\":[\"timor_leste\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇬\",\"description\":\"Togo\",\"category\":\"Flags\",\"aliases\":[\"togo\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇰\",\"description\":\"Tokelau\",\"category\":\"Flags\",\"aliases\":[\"tokelau\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇹🇴\",\"description\":\"Tonga\",\"category\":\"Flags\",\"aliases\":[\"tonga\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇹\",\"description\":\"Trinidad & Tobago\",\"category\":\"Flags\",\"aliases\":[\"trinidad_tobago\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇳\",\"description\":\"Tunisia\",\"category\":\"Flags\",\"aliases\":[\"tunisia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇷\",\"description\":\"Turkey\",\"category\":\"Flags\",\"aliases\":[\"tr\"],\"tags\":[\"turkey\"],\"unicode_version\":\"8.0\",\"ios_version\":\"9.1\"},{\"emoji\":\"🇹🇲\",\"description\":\"Turkmenistan\",\"category\":\"Flags\",\"aliases\":[\"turkmenistan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇨\",\"description\":\"Turks & Caicos Islands\",\"category\":\"Flags\",\"aliases\":[\"turks_caicos_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇹🇻\",\"description\":\"Tuvalu\",\"category\":\"Flags\",\"aliases\":[\"tuvalu\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇺🇬\",\"description\":\"Uganda\",\"category\":\"Flags\",\"aliases\":[\"uganda\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇺🇦\",\"description\":\"Ukraine\",\"category\":\"Flags\",\"aliases\":[\"ukraine\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇦🇪\",\"description\":\"United Arab Emirates\",\"category\":\"Flags\",\"aliases\":[\"united_arab_emirates\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇬🇧\",\"description\":\"United Kingdom\",\"category\":\"Flags\",\"aliases\":[\"gb\",\"uk\"],\"tags\":[\"flag\",\"british\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇺🇸\",\"description\":\"United States\",\"category\":\"Flags\",\"aliases\":[\"us\"],\"tags\":[\"flag\",\"united\",\"america\"],\"unicode_version\":\"6.0\",\"ios_version\":\"6.0\"},{\"emoji\":\"🇻🇮\",\"description\":\"U.S. Virgin Islands\",\"category\":\"Flags\",\"aliases\":[\"us_virgin_islands\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇺🇾\",\"description\":\"Uruguay\",\"category\":\"Flags\",\"aliases\":[\"uruguay\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇺🇿\",\"description\":\"Uzbekistan\",\"category\":\"Flags\",\"aliases\":[\"uzbekistan\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇻🇺\",\"description\":\"Vanuatu\",\"category\":\"Flags\",\"aliases\":[\"vanuatu\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇻🇦\",\"description\":\"Vatican City\",\"category\":\"Flags\",\"aliases\":[\"vatican_city\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇻🇪\",\"description\":\"Venezuela\",\"category\":\"Flags\",\"aliases\":[\"venezuela\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇻🇳\",\"description\":\"Vietnam\",\"category\":\"Flags\",\"aliases\":[\"vietnam\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇼🇫\",\"description\":\"Wallis & Futuna\",\"category\":\"Flags\",\"aliases\":[\"wallis_futuna\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇪🇭\",\"description\":\"Western Sahara\",\"category\":\"Flags\",\"aliases\":[\"western_sahara\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"9.0\"},{\"emoji\":\"🇾🇪\",\"description\":\"Yemen\",\"category\":\"Flags\",\"aliases\":[\"yemen\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇿🇲\",\"description\":\"Zambia\",\"category\":\"Flags\",\"aliases\":[\"zambia\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"emoji\":\"🇿🇼\",\"description\":\"Zimbabwe\",\"category\":\"Flags\",\"aliases\":[\"zimbabwe\"],\"tags\":[],\"unicode_version\":\"6.0\",\"ios_version\":\"8.3\"},{\"aliases\":[\"basecamp\"],\"tags\":[]},{\"aliases\":[\"basecampy\"],\"tags\":[]},{\"aliases\":[\"bowtie\"],\"tags\":[]},{\"aliases\":[\"feelsgood\"],\"tags\":[]},{\"aliases\":[\"finnadie\"],\"tags\":[]},{\"aliases\":[\"goberserk\"],\"tags\":[]},{\"aliases\":[\"godmode\"],\"tags\":[]},{\"aliases\":[\"hurtrealbad\"],\"tags\":[]},{\"aliases\":[\"neckbeard\"],\"tags\":[]},{\"aliases\":[\"octocat\"],\"tags\":[]},{\"aliases\":[\"rage1\"],\"tags\":[]},{\"aliases\":[\"rage2\"],\"tags\":[]},{\"aliases\":[\"rage3\"],\"tags\":[]},{\"aliases\":[\"rage4\"],\"tags\":[]},{\"aliases\":[\"shipit\",\"squirrel\"],\"tags\":[]},{\"aliases\":[\"suspect\"],\"tags\":[]},{\"aliases\":[\"trollface\"],\"tags\":[]}]");

/***/ }),

/***/ "91e9":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "91ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_id_a3cb868a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7b8c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_id_a3cb868a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_id_a3cb868a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_id_a3cb868a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "93ed":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "950a":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("30c9");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "9520":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObject = __webpack_require__("1a8c");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "954c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4662");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1c9d7e87", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9638":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "9640":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_id_262299fd_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6155");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_id_262299fd_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_id_262299fd_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_id_262299fd_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "966f":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    baseIsEqual = __webpack_require__("c05f");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "9673":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("70b9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4a6f21c3", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "96a0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f6a8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5aae3982", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "96cf":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() {
    return this || (typeof self === "object" && self);
  })() || Function("return this")()
);


/***/ }),

/***/ "9788":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8595");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0b49a418", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9886":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-link[data-v-a9ae3514]{font-weight:700}.ui-link.light[data-v-a9ae3514]{color:var(--c-link--tint-40)}.ui-link[data-v-a9ae3514]:not(.light){color:var(--c-link)}.ui-link[data-v-a9ae3514]:hover{text-decoration:underline}", ""]);


/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("eae9");

// `String.prototype.link` method
// https://tc39.github.io/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "9934":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("6fcd"),
    baseKeysIn = __webpack_require__("41c3"),
    isArrayLike = __webpack_require__("30c9");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "99cd":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "99d3":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("585a");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "9aff":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("9638"),
    isArrayLike = __webpack_require__("30c9"),
    isIndex = __webpack_require__("c098"),
    isObject = __webpack_require__("1a8c");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "9b02":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("656b");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "9b47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "9ba8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLabel_vue_vue_type_style_index_0_id_f4f16454_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8a2d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLabel_vue_vue_type_style_index_0_id_f4f16454_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLabel_vue_vue_type_style_index_0_id_f4f16454_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLabel_vue_vue_type_style_index_0_id_f4f16454_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c4b":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("7948"),
    baseIntersection = __webpack_require__("b3e9"),
    baseRest = __webpack_require__("100e"),
    castArrayLikeObject = __webpack_require__("5f36"),
    last = __webpack_require__("4416");

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function(arrays) {
  var comparator = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, undefined, comparator)
    : [];
});

module.exports = intersectionWith;


/***/ }),

/***/ "9e69":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "a029":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("087d"),
    getPrototype = __webpack_require__("2dcb"),
    getSymbols = __webpack_require__("32f4"),
    stubArray = __webpack_require__("d327");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "a116":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f91a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b5f4da5a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var sloppyArrayMethod = __webpack_require__("b301");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var SLOPPY_METHOD = sloppyArrayMethod('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || SLOPPY_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a2be":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("d612"),
    arraySome = __webpack_require__("4284"),
    cacheHas = __webpack_require__("c584");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "a2bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__("e8b5");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("f8c2");

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "a2db":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "a3fd":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("7948");

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('splice') }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a454":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("72f0"),
    defineProperty = __webpack_require__("3b4a"),
    identity = __webpack_require__("cd9d");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("c032");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = NATIVE_SYMBOL && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

if (!USE_SYMBOL_AS_UID) {
  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a4e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStatusIcon_vue_vue_type_style_index_0_id_0dc263e4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("157a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStatusIcon_vue_vue_type_style_index_0_id_0dc263e4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStatusIcon_vue_vue_type_style_index_0_id_0dc263e4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStatusIcon_vue_vue_type_style_index_0_id_0dc263e4_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a524":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "a570":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0eaf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("04664d12", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a623":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $every = __webpack_require__("b727").every;
var sloppyArrayMethod = __webpack_require__("b301");

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: sloppyArrayMethod('every') }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a846":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4633");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2e747f61", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a994":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("7d1f"),
    getSymbols = __webpack_require__("32f4"),
    keys = __webpack_require__("ec69");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ac41":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae2a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b2b0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("121cdc39", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "af36":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-hint[data-v-1c88b113]{font-size:.375rem;margin-top:.125rem;line-height:1.5em}.ui-hint[data-v-1c88b113]>:not(:last-child){margin-right:.125rem}.ui-hint.dark.promiment[data-v-1c88b113]{color:var(--c-text--lighten-20)}.ui-hint.dark.subtle[data-v-1c88b113]{color:var(--c-text--lighten-30)}.ui-hint.light[data-v-1c88b113]{color:var(--c-text-light)}.ui-hint.danger[data-v-1c88b113]{font-weight:700;color:var(--c-danger)}", ""]);


/***/ }),

/***/ "b030":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-pull-out-tab[data-v-18d2e2f0]{position:absolute!important;top:50%;opacity:.6}.ui-pull-out-tab[data-v-18d2e2f0]:hover{opacity:1}.ui-pull-out-tab.left[data-v-18d2e2f0]{left:0;-webkit-transform:translateX(-100%) translateX(.9rem) translateY(-50%);transform:translateX(-100%) translateX(.9rem) translateY(-50%);border-top-right-radius:3.125rem!important;border-bottom-right-radius:3.125rem!important}.ui-pull-out-tab.left[data-v-18d2e2f0]:hover{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.ui-pull-out-tab.left.slide-enter[data-v-18d2e2f0],.ui-pull-out-tab.left.slide-leave-to[data-v-18d2e2f0]{-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.ui-pull-out-tab.right[data-v-18d2e2f0]{right:0;-webkit-transform:translateX(100%) translateX(-.9rem) translateY(-50%);transform:translateX(100%) translateX(-.9rem) translateY(-50%);border-top-left-radius:3.125rem!important;border-bottom-left-radius:3.125rem!important}.ui-pull-out-tab.right[data-v-18d2e2f0]:hover{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.ui-pull-out-tab.right.slide-enter[data-v-18d2e2f0],.ui-pull-out-tab.right.slide-leave-to[data-v-18d2e2f0]{-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}", ""]);


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b047":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "b047c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c"),
    now = __webpack_require__("408c"),
    toNumber = __webpack_require__("b4b0");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b10e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6716");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("03e61324", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b13e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c494");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0d36789b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b163":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCard_vue_vue_type_style_index_0_id_2343ce25_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9673");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCard_vue_vue_type_style_index_0_id_2343ce25_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCard_vue_vue_type_style_index_0_id_2343ce25_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCard_vue_vue_type_style_index_0_id_2343ce25_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b1e5":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("a994");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "b218":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "b2b0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".grow-enter-active[data-v-b0f1ccda],.grow-leave-active[data-v-b0f1ccda]{-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform;-webkit-transition-duration:.2s;transition-duration:.2s}.grow-enter[data-v-b0f1ccda],.grow-leave-to[data-v-b0f1ccda]{opacity:0;-webkit-transform:scale(.8);transform:scale(.8)}.fade-enter-active[data-v-b0f1ccda],.fade-leave-active[data-v-b0f1ccda]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.2s;transition-duration:.2s}.fade-enter[data-v-b0f1ccda],.fade-leave-to[data-v-b0f1ccda]{opacity:0}.modal[data-v-b0f1ccda]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:70;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.modal .overlay[data-v-b0f1ccda]{position:absolute;width:100%;height:100%;top:0;right:0;background-color:var(--c-overlay-dark)}.modal .container[data-v-b0f1ccda]{position:relative;background-color:#fff;border-radius:.25rem;-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);overflow-x:hidden;overflow-y:auto;max-width:calc(100vw - 1rem);max-height:calc(100vh - 1rem)}", ""]);


/***/ }),

/***/ "b301":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "b3e9":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("d612"),
    arrayIncludes = __webpack_require__("8db3"),
    arrayIncludesWith = __webpack_require__("5edf"),
    arrayMap = __webpack_require__("7948"),
    baseUnary = __webpack_require__("b047"),
    cacheHas = __webpack_require__("c584");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),

/***/ "b495":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListItem_vue_vue_type_style_index_0_id_720b8e2e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("44b6");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListItem_vue_vue_type_style_index_0_id_720b8e2e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListItem_vue_vue_type_style_index_0_id_720b8e2e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListItem_vue_vue_type_style_index_0_id_720b8e2e_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b4b0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c"),
    isSymbol = __webpack_require__("ffd6");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "b4c0":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var classof = __webpack_require__("c6b6");
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("b629");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b5a7":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b629":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("b39a");

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b6da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorDot_vue_vue_type_style_index_0_id_1be962c1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bf11");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorDot_vue_vue_type_style_index_0_id_1be962c1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorDot_vue_vue_type_style_index_0_id_1be962c1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorDot_vue_vue_type_style_index_0_id_1be962c1_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("f8c2");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "b760":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("872a"),
    eq = __webpack_require__("9638");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "b8b5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-input input[data-v-62917763]{border:none;outline:none;background:none;font-size:.4375rem;font-weight:500;color:var(--c-text)}.ui-input input[data-v-62917763]::-webkit-input-placeholder{color:var(--c-text--lighten-30)}.ui-input input[data-v-62917763]::-moz-placeholder{color:var(--c-text--lighten-30)}.ui-input input[data-v-62917763]:-ms-input-placeholder{color:var(--c-text--lighten-30)}.ui-input input[data-v-62917763]::-ms-input-placeholder{color:var(--c-text--lighten-30)}.ui-input input[data-v-62917763]::placeholder{color:var(--c-text--lighten-30)}.ui-input .input-wrapper.bare input[data-v-62917763]{padding:unset}.ui-input .input-wrapper.subtle[data-v-62917763]{background:none}.ui-input .input-wrapper.medium[data-v-62917763]{height:1.25rem}.ui-input .input-wrapper.medium input[data-v-62917763]{font-size:.5rem;font-weight:700}.ui-input .input-wrapper.big[data-v-62917763]{height:1.5rem}.ui-input .input-wrapper.big input[data-v-62917763]{font-size:.625rem;font-weight:700}.ui-input .input-wrapper.disabled[data-v-62917763]{cursor:not-allowed;opacity:.5}.ui-input .input-wrapper.light input[data-v-62917763]{color:var(--c-text-light)}.ui-input .input-wrapper.light[data-v-62917763]{background-color:var(--c-white--opacity-20)}.ui-input .input-wrapper[data-v-62917763]{display:-webkit-box;display:-ms-flexbox;display:flex;justify-items:center;padding:0 .25rem;height:1rem;width:100%;background-color:var(--c-black--opacity-5);border-radius:.125rem;-webkit-transition:.2s;transition:.2s}.ui-input .input-wrapper>input[data-v-62917763]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:0}.ui-input .input-wrapper .input-prefix[data-v-62917763],.ui-input .input-wrapper .input-suffix[data-v-62917763]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);


/***/ }),

/***/ "b8ce":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("3818");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "badf":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("642a"),
    baseMatchesProperty = __webpack_require__("1838"),
    identity = __webpack_require__("cd9d"),
    isArray = __webpack_require__("6747"),
    property = __webpack_require__("f9ce");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "bb5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBadge_vue_vue_type_style_index_0_id_4e3ace4a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("954c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBadge_vue_vue_type_style_index_0_id_4e3ace4a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBadge_vue_vue_type_style_index_0_id_4e3ace4a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBadge_vue_vue_type_style_index_0_id_4e3ace4a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "bbc0":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "bcdf":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "bf11":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("548b");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6752eeb7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c00b":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".tooltip:not(.popover) .tooltip-inner{background:var(--c-white);border-radius:.25rem;padding:.15625rem .3125rem .125rem;-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20);text-align:center;line-height:1.5em;word-wrap:break-word;max-width:8rem}.tooltip{display:block!important;z-index:100}.tooltip .tooltip-arrow{width:0;height:0;border-style:solid;border-width:.15625rem;border-color:transparent;position:absolute;margin:.15625rem;z-index:1}.tooltip[x-placement^=top]{margin-bottom:.15625rem}.tooltip[x-placement^=top] .tooltip-arrow{border-bottom-width:0;border-top-color:var(--c-white);bottom:-.15625rem;left:calc(50% - .15625rem);margin-top:0;margin-bottom:0}.tooltip[x-placement^=bottom]{margin-top:.15625rem}.tooltip[x-placement^=bottom] .tooltip-arrow{border-top-width:0;border-bottom-color:var(--c-white);top:-.15625rem;left:calc(50% - .15625rem);margin-top:0;margin-bottom:0}.tooltip[x-placement^=right]{margin-left:.15625rem}.tooltip[x-placement^=right] .tooltip-arrow{border-left-width:0;border-right-color:var(--c-white);left:-.15625rem;top:calc(50% - .15625rem);margin-left:0;margin-right:0}.tooltip[x-placement^=left]{margin-right:.15625rem}.tooltip[x-placement^=left] .tooltip-arrow{border-right-width:0;border-left-color:var(--c-white);right:-.15625rem;top:calc(50% - .15625rem);margin-left:0;margin-right:0}.tooltip[aria-hidden=true]{visibility:hidden;opacity:0;-webkit-transition:opacity .1s,visibility .1s;transition:opacity .1s,visibility .1s}.tooltip[aria-hidden=false]{visibility:visible;opacity:1;-webkit-transition:opacity .1s;transition:opacity .1s}.tooltip.popover .popover-inner{background:none;padding:0;-webkit-box-shadow:none;box-shadow:none}.tooltip.popover .tooltip-arrow{display:none}.v-popover>span{display:block!important;outline:none}", ""]);


/***/ }),

/***/ "c032":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c05f":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("7b97"),
    isObjectLike = __webpack_require__("1310");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "c098":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "c179":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToast_vue_vue_type_style_index_0_id_64afbb52_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d323");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToast_vue_vue_type_style_index_0_id_64afbb52_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToast_vue_vue_type_style_index_0_id_64afbb52_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiToast_vue_vue_type_style_index_0_id_64afbb52_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c18c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("fb6a");

__webpack_require__("a434");

var arrayMoveMutate = function arrayMoveMutate(array, from, to) {
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
};

var arrayMove = function arrayMove(array, from, to) {
  array = array.slice();
  arrayMoveMutate(array, from, to);
  return array;
};

module.exports = arrayMove; // TODO: Remove this for the next major release

module.exports.default = arrayMove;
module.exports.mutate = arrayMoveMutate;

/***/ }),

/***/ "c1c9":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("a454"),
    shortOut = __webpack_require__("f3c1");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "c1cc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8834");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("9008aefa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c2b6":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af"),
    cloneDataView = __webpack_require__("5d89"),
    cloneRegExp = __webpack_require__("6f6c"),
    cloneSymbol = __webpack_require__("a2db"),
    cloneTypedArray = __webpack_require__("c8fe");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "c335":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 132);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(130);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(102);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(98);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(52);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(52);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(31)('wks');
var uid = __webpack_require__(23);
var Symbol = __webpack_require__(7).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(54);
var toPrimitive = __webpack_require__(38);
var dP = Object.defineProperty;

exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(121);
var defined = __webpack_require__(36);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(20);
module.exports = __webpack_require__(9) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(5);
var ctx = __webpack_require__(39);
var hide = __webpack_require__(13);
var has = __webpack_require__(8);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SensorEvent = __webpack_require__(65);

Object.keys(_SensorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SensorEvent[key];
    }
  });
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(68);

var _Sensor2 = _interopRequireDefault(_Sensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sensor2.default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closest = __webpack_require__(72);

Object.defineProperty(exports, 'closest', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_closest).default;
  }
});

var _requestNextAnimationFrame = __webpack_require__(70);

Object.defineProperty(exports, 'requestNextAnimationFrame', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_requestNextAnimationFrame).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(88);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractPlugin = __webpack_require__(91);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AbstractPlugin2.default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractEvent = __webpack_require__(95);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AbstractEvent2.default;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(5);
var LIBRARY = __webpack_require__(24);
var wksExt = __webpack_require__(28);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(4);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(4)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(5);
var global = __webpack_require__(7);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(24) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(31)('keys');
var uid = __webpack_require__(23);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(48);
var enumBugKeys = __webpack_require__(30);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(12);
var dPs = __webpack_require__(122);
var enumBugKeys = __webpack_require__(30);
var IE_PROTO = __webpack_require__(32)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(53)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(118).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(127);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(16);

Object.defineProperty(exports, 'Sensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sensor).default;
  }
});

var _MouseSensor = __webpack_require__(67);

Object.defineProperty(exports, 'MouseSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MouseSensor).default;
  }
});

var _TouchSensor = __webpack_require__(64);

Object.defineProperty(exports, 'TouchSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TouchSensor).default;
  }
});

var _DragSensor = __webpack_require__(62);

Object.defineProperty(exports, 'DragSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSensor).default;
  }
});

var _ForceTouchSensor = __webpack_require__(60);

Object.defineProperty(exports, 'ForceTouchSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ForceTouchSensor).default;
  }
});

var _SensorEvent = __webpack_require__(15);

Object.keys(_SensorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SensorEvent[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Announcement = __webpack_require__(93);

Object.defineProperty(exports, 'Announcement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Announcement).default;
  }
});
Object.defineProperty(exports, 'defaultAnnouncementOptions', {
  enumerable: true,
  get: function get() {
    return _Announcement.defaultOptions;
  }
});

var _Focusable = __webpack_require__(90);

Object.defineProperty(exports, 'Focusable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Focusable).default;
  }
});

var _Mirror = __webpack_require__(79);

Object.defineProperty(exports, 'Mirror', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mirror).default;
  }
});
Object.defineProperty(exports, 'defaultMirrorOptions', {
  enumerable: true,
  get: function get() {
    return _Mirror.defaultOptions;
  }
});

var _Scrollable = __webpack_require__(74);

Object.defineProperty(exports, 'Scrollable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Scrollable).default;
  }
});
Object.defineProperty(exports, 'defaultScrollableOptions', {
  enumerable: true,
  get: function get() {
    return _Scrollable.defaultOptions;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DraggableEvent = __webpack_require__(94);

Object.keys(_DraggableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DraggableEvent[key];
    }
  });
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(26);
var createDesc = __webpack_require__(20);
var toIObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(38);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(54);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(48);
var hiddenKeys = __webpack_require__(30).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(36);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(37);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(10);
var arrayIndexOf = __webpack_require__(120)(false);
var IE_PROTO = __webpack_require__(32)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(24);
var $export = __webpack_require__(14);
var redefine = __webpack_require__(49);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(19);
var $iterCreate = __webpack_require__(123);
var setToStringTag = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(117);
var ITERATOR = __webpack_require__(4)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(124)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(50)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(126);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(112);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(7).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(9) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(53)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragEvent = __webpack_require__(131);

Object.keys(_DragEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DragEvent[key];
    }
  });
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Emitter is a simple emitter class that provides you with `on()`, `off()` and `trigger()` methods
 * @class Emitter
 * @module Emitter
 */
var Emitter = function () {
  function Emitter() {
    (0, _classCallCheck3.default)(this, Emitter);

    this.callbacks = {};
  }

  /**
   * Registers callbacks by event name
   * @param {String} type
   * @param {...Function} callbacks
   */


  (0, _createClass3.default)(Emitter, [{
    key: "on",
    value: function on(type) {
      var _callbacks$type;

      if (!this.callbacks[type]) {
        this.callbacks[type] = [];
      }

      for (var _len = arguments.length, callbacks = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        callbacks[_key - 1] = arguments[_key];
      }

      (_callbacks$type = this.callbacks[type]).push.apply(_callbacks$type, callbacks);

      return this;
    }

    /**
     * Unregisters callbacks by event name
     * @param {String} type
     * @param {Function} callback
     */

  }, {
    key: "off",
    value: function off(type, callback) {
      if (!this.callbacks[type]) {
        return null;
      }

      var copy = this.callbacks[type].slice(0);

      for (var i = 0; i < copy.length; i++) {
        if (callback === copy[i]) {
          this.callbacks[type].splice(i, 1);
        }
      }

      return this;
    }

    /**
     * Triggers event callbacks by event object
     * @param {AbstractEvent} event
     */

  }, {
    key: "trigger",
    value: function trigger(event) {
      if (!this.callbacks[event.type]) {
        return null;
      }

      var callbacks = [].concat((0, _toConsumableArray3.default)(this.callbacks[event.type]));
      var caughtErrors = [];

      for (var i = callbacks.length - 1; i >= 0; i--) {
        var callback = callbacks[i];

        try {
          callback(event);
        } catch (error) {
          caughtErrors.push(error);
        }
      }

      if (caughtErrors.length) {
        /* eslint-disable no-console */
        console.error("Draggable caught errors while triggering '" + event.type + "'", caughtErrors);
        /* eslint-disable no-console */
      }

      return this;
    }
  }]);
  return Emitter;
}();

exports.default = Emitter;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Emitter = __webpack_require__(56);

var _Emitter2 = _interopRequireDefault(_Emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Emitter2.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = __webpack_require__(17);

var _Plugins = __webpack_require__(41);

var _Emitter = __webpack_require__(57);

var _Emitter2 = _interopRequireDefault(_Emitter);

var _Sensors = __webpack_require__(40);

var _DraggableEvent = __webpack_require__(42);

var _DragEvent = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = Symbol('onDragStart');
var onDragMove = Symbol('onDragMove');
var onDragStop = Symbol('onDragStop');
var onDragPressure = Symbol('onDragPressure');

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['drag:start']
 * @const {Function} defaultAnnouncements['drag:stop']
 */
var defaultAnnouncements = {
  'drag:start': function dragStart(event) {
    return 'Picked up ' + (event.source.textContent.trim() || event.source.id || 'draggable element');
  },
  'drag:stop': function dragStop(event) {
    return 'Released ' + (event.source.textContent.trim() || event.source.id || 'draggable element');
  }
};

var defaultClasses = {
  'container:dragging': 'draggable-container--is-dragging',
  'source:dragging': 'draggable-source--is-dragging',
  'source:placed': 'draggable-source--placed',
  'container:placed': 'draggable-container--placed',
  'body:dragging': 'draggable--is-dragging',
  'draggable:over': 'draggable--over',
  'container:over': 'draggable-container--over',
  'source:original': 'draggable--original',
  mirror: 'draggable-mirror'
};

var defaultOptions = exports.defaultOptions = {
  draggable: '.draggable-source',
  handle: null,
  delay: 100,
  placedTimeout: 800,
  plugins: [],
  sensors: []
};

/**
 * This is the core draggable library that does the heavy lifting
 * @class Draggable
 * @module Draggable
 */

var Draggable = function () {

  /**
   * Draggable constructor.
   * @constructs Draggable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Draggable containers
   * @param {Object} options - Options for draggable
   */
  function Draggable() {
    var _this = this;

    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [document.body];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Draggable);

    /**
     * Draggable containers
     * @property containers
     * @type {HTMLElement[]}
     */
    if (containers instanceof NodeList || containers instanceof Array) {
      this.containers = [].concat((0, _toConsumableArray3.default)(containers));
    } else if (containers instanceof HTMLElement) {
      this.containers = [containers];
    } else {
      throw new Error('Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`');
    }

    this.options = Object.assign({}, defaultOptions, options, {
      classes: Object.assign({}, defaultClasses, options.classes || {}),
      announcements: Object.assign({}, defaultAnnouncements, options.announcements || {})
    });

    /**
     * Draggables event emitter
     * @property emitter
     * @type {Emitter}
     */
    this.emitter = new _Emitter2.default();

    /**
     * Current drag state
     * @property dragging
     * @type {Boolean}
     */
    this.dragging = false;

    /**
     * Active plugins
     * @property plugins
     * @type {Plugin[]}
     */
    this.plugins = [];

    /**
     * Active sensors
     * @property sensors
     * @type {Sensor[]}
     */
    this.sensors = [];

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onDragPressure] = this[onDragPressure].bind(this);

    document.addEventListener('drag:start', this[onDragStart], true);
    document.addEventListener('drag:move', this[onDragMove], true);
    document.addEventListener('drag:stop', this[onDragStop], true);
    document.addEventListener('drag:pressure', this[onDragPressure], true);

    var defaultPlugins = Object.values(Draggable.Plugins).map(function (Plugin) {
      return Plugin;
    });
    var defaultSensors = [_Sensors.MouseSensor, _Sensors.TouchSensor];

    this.addPlugin.apply(this, [].concat((0, _toConsumableArray3.default)(defaultPlugins), (0, _toConsumableArray3.default)(this.options.plugins)));
    this.addSensor.apply(this, [].concat(defaultSensors, (0, _toConsumableArray3.default)(this.options.sensors)));

    var draggableInitializedEvent = new _DraggableEvent.DraggableInitializedEvent({
      draggable: this
    });

    this.on('mirror:created', function (_ref) {
      var mirror = _ref.mirror;
      return _this.mirror = mirror;
    });
    this.on('mirror:destroy', function () {
      return _this.mirror = null;
    });

    this.trigger(draggableInitializedEvent);
  }

  /**
   * Destroys Draggable instance. This removes all internal event listeners and
   * deactivates sensors and plugins
   */

  /**
   * Default plugins draggable uses
   * @static
   * @property {Object} Plugins
   * @property {Announcement} Plugins.Announcement
   * @property {Focusable} Plugins.Focusable
   * @property {Mirror} Plugins.Mirror
   * @property {Scrollable} Plugins.Scrollable
   * @type {Object}
   */


  (0, _createClass3.default)(Draggable, [{
    key: 'destroy',
    value: function destroy() {
      document.removeEventListener('drag:start', this[onDragStart], true);
      document.removeEventListener('drag:move', this[onDragMove], true);
      document.removeEventListener('drag:stop', this[onDragStop], true);
      document.removeEventListener('drag:pressure', this[onDragPressure], true);

      var draggableDestroyEvent = new _DraggableEvent.DraggableDestroyEvent({
        draggable: this
      });

      this.trigger(draggableDestroyEvent);

      this.removePlugin.apply(this, (0, _toConsumableArray3.default)(this.plugins.map(function (plugin) {
        return plugin.constructor;
      })));
      this.removeSensor.apply(this, (0, _toConsumableArray3.default)(this.sensors.map(function (sensor) {
        return sensor.constructor;
      })));
    }

    /**
     * Adds plugin to this draggable instance. This will end up calling the attach method of the plugin
     * @param {...typeof Plugin} plugins - Plugins that you want attached to draggable
     * @return {Draggable}
     * @example draggable.addPlugin(CustomA11yPlugin, CustomMirrorPlugin)
     */

  }, {
    key: 'addPlugin',
    value: function addPlugin() {
      var _this2 = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      var activePlugins = plugins.map(function (Plugin) {
        return new Plugin(_this2);
      });

      activePlugins.forEach(function (plugin) {
        return plugin.attach();
      });
      this.plugins = [].concat((0, _toConsumableArray3.default)(this.plugins), (0, _toConsumableArray3.default)(activePlugins));

      return this;
    }

    /**
     * Removes plugins that are already attached to this draggable instance. This will end up calling
     * the detach method of the plugin
     * @param {...typeof Plugin} plugins - Plugins that you want detached from draggable
     * @return {Draggable}
     * @example draggable.removePlugin(MirrorPlugin, CustomMirrorPlugin)
     */

  }, {
    key: 'removePlugin',
    value: function removePlugin() {
      for (var _len2 = arguments.length, plugins = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        plugins[_key2] = arguments[_key2];
      }

      var removedPlugins = this.plugins.filter(function (plugin) {
        return plugins.includes(plugin.constructor);
      });

      removedPlugins.forEach(function (plugin) {
        return plugin.detach();
      });
      this.plugins = this.plugins.filter(function (plugin) {
        return !plugins.includes(plugin.constructor);
      });

      return this;
    }

    /**
     * Adds sensors to this draggable instance. This will end up calling the attach method of the sensor
     * @param {...typeof Sensor} sensors - Sensors that you want attached to draggable
     * @return {Draggable}
     * @example draggable.addSensor(ForceTouchSensor, CustomSensor)
     */

  }, {
    key: 'addSensor',
    value: function addSensor() {
      var _this3 = this;

      for (var _len3 = arguments.length, sensors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        sensors[_key3] = arguments[_key3];
      }

      var activeSensors = sensors.map(function (Sensor) {
        return new Sensor(_this3.containers, _this3.options);
      });

      activeSensors.forEach(function (sensor) {
        return sensor.attach();
      });
      this.sensors = [].concat((0, _toConsumableArray3.default)(this.sensors), (0, _toConsumableArray3.default)(activeSensors));

      return this;
    }

    /**
     * Removes sensors that are already attached to this draggable instance. This will end up calling
     * the detach method of the sensor
     * @param {...typeof Sensor} sensors - Sensors that you want attached to draggable
     * @return {Draggable}
     * @example draggable.removeSensor(TouchSensor, DragSensor)
     */

  }, {
    key: 'removeSensor',
    value: function removeSensor() {
      for (var _len4 = arguments.length, sensors = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        sensors[_key4] = arguments[_key4];
      }

      var removedSensors = this.sensors.filter(function (sensor) {
        return sensors.includes(sensor.constructor);
      });

      removedSensors.forEach(function (sensor) {
        return sensor.detach();
      });
      this.sensors = this.sensors.filter(function (sensor) {
        return !sensors.includes(sensor.constructor);
      });

      return this;
    }

    /**
     * Adds container to this draggable instance
     * @param {...HTMLElement} containers - Containers you want to add to draggable
     * @return {Draggable}
     * @example draggable.addContainer(document.body)
     */

  }, {
    key: 'addContainer',
    value: function addContainer() {
      for (var _len5 = arguments.length, containers = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        containers[_key5] = arguments[_key5];
      }

      this.containers = [].concat((0, _toConsumableArray3.default)(this.containers), containers);
      this.sensors.forEach(function (sensor) {
        return sensor.addContainer.apply(sensor, containers);
      });
      return this;
    }

    /**
     * Removes container from this draggable instance
     * @param {...HTMLElement} containers - Containers you want to remove from draggable
     * @return {Draggable}
     * @example draggable.removeContainer(document.body)
     */

  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      for (var _len6 = arguments.length, containers = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        containers[_key6] = arguments[_key6];
      }

      this.containers = this.containers.filter(function (container) {
        return !containers.includes(container);
      });
      this.sensors.forEach(function (sensor) {
        return sensor.removeContainer.apply(sensor, containers);
      });
      return this;
    }

    /**
     * Adds listener for draggable events
     * @param {String} type - Event name
     * @param {...Function} callbacks - Event callbacks
     * @return {Draggable}
     * @example draggable.on('drag:start', (dragEvent) => dragEvent.cancel());
     */

  }, {
    key: 'on',
    value: function on(type) {
      var _emitter;

      for (var _len7 = arguments.length, callbacks = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        callbacks[_key7 - 1] = arguments[_key7];
      }

      (_emitter = this.emitter).on.apply(_emitter, [type].concat(callbacks));
      return this;
    }

    /**
     * Removes listener from draggable
     * @param {String} type - Event name
     * @param {Function} callback - Event callback
     * @return {Draggable}
     * @example draggable.off('drag:start', handlerFunction);
     */

  }, {
    key: 'off',
    value: function off(type, callback) {
      this.emitter.off(type, callback);
      return this;
    }

    /**
     * Triggers draggable event
     * @param {AbstractEvent} event - Event instance
     * @return {Draggable}
     * @example draggable.trigger(event);
     */

  }, {
    key: 'trigger',
    value: function trigger(event) {
      this.emitter.trigger(event);
      return this;
    }

    /**
     * Returns class name for class identifier
     * @param {String} name - Name of class identifier
     * @return {String|null}
     */

  }, {
    key: 'getClassNameFor',
    value: function getClassNameFor(name) {
      return this.options.classes[name];
    }

    /**
     * Returns true if this draggable instance is currently dragging
     * @return {Boolean}
     */

  }, {
    key: 'isDragging',
    value: function isDragging() {
      return Boolean(this.dragging);
    }

    /**
     * Returns all draggable elements
     * @return {HTMLElement[]}
     */

  }, {
    key: 'getDraggableElements',
    value: function getDraggableElements() {
      var _this4 = this;

      return this.containers.reduce(function (current, container) {
        return [].concat((0, _toConsumableArray3.default)(current), (0, _toConsumableArray3.default)(_this4.getDraggableElementsForContainer(container)));
      }, []);
    }

    /**
     * Returns draggable elements for a given container, excluding the mirror and
     * original source element if present
     * @param {HTMLElement} container
     * @return {HTMLElement[]}
     */

  }, {
    key: 'getDraggableElementsForContainer',
    value: function getDraggableElementsForContainer(container) {
      var _this5 = this;

      var allDraggableElements = container.querySelectorAll(this.options.draggable);

      return [].concat((0, _toConsumableArray3.default)(allDraggableElements)).filter(function (childElement) {
        return childElement !== _this5.originalSource && childElement !== _this5.mirror;
      });
    }

    /**
     * Drag start handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragStart,
    value: function value(event) {
      var _this6 = this;

      var sensorEvent = getSensorEvent(event);
      var target = sensorEvent.target,
          container = sensorEvent.container;


      if (!this.containers.includes(container)) {
        return;
      }

      if (this.options.handle && target && !(0, _utils.closest)(target, this.options.handle)) {
        sensorEvent.cancel();
        return;
      }

      // Find draggable source element
      this.originalSource = (0, _utils.closest)(target, this.options.draggable);
      this.sourceContainer = container;

      if (!this.originalSource) {
        sensorEvent.cancel();
        return;
      }

      if (this.lastPlacedSource && this.lastPlacedContainer) {
        clearTimeout(this.placedTimeoutID);
        this.lastPlacedSource.classList.remove(this.getClassNameFor('source:placed'));
        this.lastPlacedContainer.classList.remove(this.getClassNameFor('container:placed'));
      }

      this.source = this.originalSource.cloneNode(true);
      this.originalSource.parentNode.insertBefore(this.source, this.originalSource);
      this.originalSource.style.display = 'none';

      var dragEvent = new _DragEvent.DragStartEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent: sensorEvent
      });

      this.trigger(dragEvent);

      this.dragging = !dragEvent.canceled();

      if (dragEvent.canceled()) {
        this.source.parentNode.removeChild(this.source);
        this.originalSource.style.display = null;
        return;
      }

      this.originalSource.classList.add(this.getClassNameFor('source:original'));
      this.source.classList.add(this.getClassNameFor('source:dragging'));
      this.sourceContainer.classList.add(this.getClassNameFor('container:dragging'));
      document.body.classList.add(this.getClassNameFor('body:dragging'));
      applyUserSelect(document.body, 'none');

      requestAnimationFrame(function () {
        var oldSensorEvent = getSensorEvent(event);
        var newSensorEvent = oldSensorEvent.clone({ target: _this6.source });

        _this6[onDragMove](Object.assign({}, event, {
          detail: newSensorEvent
        }));
      });
    }

    /**
     * Drag move handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var sensorEvent = getSensorEvent(event);
      var container = sensorEvent.container;

      var target = sensorEvent.target;

      var dragMoveEvent = new _DragEvent.DragMoveEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent: sensorEvent
      });

      this.trigger(dragMoveEvent);

      if (dragMoveEvent.canceled()) {
        sensorEvent.cancel();
      }

      target = (0, _utils.closest)(target, this.options.draggable);
      var withinCorrectContainer = (0, _utils.closest)(sensorEvent.target, this.containers);
      var overContainer = sensorEvent.overContainer || withinCorrectContainer;
      var isLeavingContainer = this.currentOverContainer && overContainer !== this.currentOverContainer;
      var isLeavingDraggable = this.currentOver && target !== this.currentOver;
      var isOverContainer = overContainer && this.currentOverContainer !== overContainer;
      var isOverDraggable = withinCorrectContainer && target && this.currentOver !== target;

      if (isLeavingDraggable) {
        var dragOutEvent = new _DragEvent.DragOutEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          over: this.currentOver
        });

        this.currentOver.classList.remove(this.getClassNameFor('draggable:over'));
        this.currentOver = null;

        this.trigger(dragOutEvent);
      }

      if (isLeavingContainer) {
        var dragOutContainerEvent = new _DragEvent.DragOutContainerEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: this.currentOverContainer
        });

        this.currentOverContainer.classList.remove(this.getClassNameFor('container:over'));
        this.currentOverContainer = null;

        this.trigger(dragOutContainerEvent);
      }

      if (isOverContainer) {
        overContainer.classList.add(this.getClassNameFor('container:over'));

        var dragOverContainerEvent = new _DragEvent.DragOverContainerEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: overContainer
        });

        this.currentOverContainer = overContainer;

        this.trigger(dragOverContainerEvent);
      }

      if (isOverDraggable) {
        target.classList.add(this.getClassNameFor('draggable:over'));

        var dragOverEvent = new _DragEvent.DragOverEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: overContainer,
          over: target
        });

        this.currentOver = target;

        this.trigger(dragOverEvent);
      }
    }

    /**
     * Drag stop handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragStop,
    value: function value(event) {
      var _this7 = this;

      if (!this.dragging) {
        return;
      }

      this.dragging = false;

      var dragStopEvent = new _DragEvent.DragStopEvent({
        source: this.source,
        originalSource: this.originalSource,
        sensorEvent: event.sensorEvent,
        sourceContainer: this.sourceContainer
      });

      this.trigger(dragStopEvent);

      this.source.parentNode.insertBefore(this.originalSource, this.source);
      this.source.parentNode.removeChild(this.source);
      this.originalSource.style.display = '';

      this.source.classList.remove(this.getClassNameFor('source:dragging'));
      this.originalSource.classList.remove(this.getClassNameFor('source:original'));
      this.originalSource.classList.add(this.getClassNameFor('source:placed'));
      this.sourceContainer.classList.add(this.getClassNameFor('container:placed'));
      this.sourceContainer.classList.remove(this.getClassNameFor('container:dragging'));
      document.body.classList.remove(this.getClassNameFor('body:dragging'));
      applyUserSelect(document.body, '');

      if (this.currentOver) {
        this.currentOver.classList.remove(this.getClassNameFor('draggable:over'));
      }

      if (this.currentOverContainer) {
        this.currentOverContainer.classList.remove(this.getClassNameFor('container:over'));
      }

      this.lastPlacedSource = this.originalSource;
      this.lastPlacedContainer = this.sourceContainer;

      this.placedTimeoutID = setTimeout(function () {
        if (_this7.lastPlacedSource) {
          _this7.lastPlacedSource.classList.remove(_this7.getClassNameFor('source:placed'));
        }

        if (_this7.lastPlacedContainer) {
          _this7.lastPlacedContainer.classList.remove(_this7.getClassNameFor('container:placed'));
        }

        _this7.lastPlacedSource = null;
        _this7.lastPlacedContainer = null;
      }, this.options.placedTimeout);

      this.source = null;
      this.originalSource = null;
      this.currentOverContainer = null;
      this.currentOver = null;
      this.sourceContainer = null;
    }

    /**
     * Drag pressure handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragPressure,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var sensorEvent = getSensorEvent(event);
      var source = this.source || (0, _utils.closest)(sensorEvent.originalEvent.target, this.options.draggable);

      var dragPressureEvent = new _DragEvent.DragPressureEvent({
        sensorEvent: sensorEvent,
        source: source,
        pressure: sensorEvent.pressure
      });

      this.trigger(dragPressureEvent);
    }
  }]);
  return Draggable;
}();

Draggable.Plugins = { Announcement: _Plugins.Announcement, Focusable: _Plugins.Focusable, Mirror: _Plugins.Mirror, Scrollable: _Plugins.Scrollable };
exports.default = Draggable;


function getSensorEvent(event) {
  return event.detail;
}

function applyUserSelect(element, value) {
  element.style.webkitUserSelect = value;
  element.style.mozUserSelect = value;
  element.style.msUserSelect = value;
  element.style.oUserSelect = value;
  element.style.userSelect = value;
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onMouseForceWillBegin = Symbol('onMouseForceWillBegin');
var onMouseForceDown = Symbol('onMouseForceDown');
var onMouseDown = Symbol('onMouseDown');
var onMouseForceChange = Symbol('onMouseForceChange');
var onMouseMove = Symbol('onMouseMove');
var onMouseUp = Symbol('onMouseUp');
var onMouseForceGlobalChange = Symbol('onMouseForceGlobalChange');

/**
 * This sensor picks up native force touch events and dictates drag operations
 * @class ForceTouchSensor
 * @module ForceTouchSensor
 * @extends Sensor
 */

var ForceTouchSensor = function (_Sensor) {
  (0, _inherits3.default)(ForceTouchSensor, _Sensor);

  /**
   * ForceTouchSensor constructor.
   * @constructs ForceTouchSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function ForceTouchSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, ForceTouchSensor);

    /**
     * Draggable element needs to be remembered to unset the draggable attribute after drag operation has completed
     * @property mightDrag
     * @type {Boolean}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (ForceTouchSensor.__proto__ || Object.getPrototypeOf(ForceTouchSensor)).call(this, containers, options));

    _this.mightDrag = false;

    _this[onMouseForceWillBegin] = _this[onMouseForceWillBegin].bind(_this);
    _this[onMouseForceDown] = _this[onMouseForceDown].bind(_this);
    _this[onMouseDown] = _this[onMouseDown].bind(_this);
    _this[onMouseForceChange] = _this[onMouseForceChange].bind(_this);
    _this[onMouseMove] = _this[onMouseMove].bind(_this);
    _this[onMouseUp] = _this[onMouseUp].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(ForceTouchSensor, [{
    key: 'attach',
    value: function attach() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.containers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var container = _step.value;

          container.addEventListener('webkitmouseforcewillbegin', this[onMouseForceWillBegin], false);
          container.addEventListener('webkitmouseforcedown', this[onMouseForceDown], false);
          container.addEventListener('mousedown', this[onMouseDown], true);
          container.addEventListener('webkitmouseforcechanged', this[onMouseForceChange], false);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      document.addEventListener('mousemove', this[onMouseMove]);
      document.addEventListener('mouseup', this[onMouseUp]);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.containers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var container = _step2.value;

          container.removeEventListener('webkitmouseforcewillbegin', this[onMouseForceWillBegin], false);
          container.removeEventListener('webkitmouseforcedown', this[onMouseForceDown], false);
          container.removeEventListener('mousedown', this[onMouseDown], true);
          container.removeEventListener('webkitmouseforcechanged', this[onMouseForceChange], false);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      document.removeEventListener('mousemove', this[onMouseMove]);
      document.removeEventListener('mouseup', this[onMouseUp]);
    }

    /**
     * Mouse force will begin handler
     * @private
     * @param {Event} event - Mouse force will begin event
     */

  }, {
    key: onMouseForceWillBegin,
    value: function value(event) {
      event.preventDefault();
      this.mightDrag = true;
    }

    /**
     * Mouse force down handler
     * @private
     * @param {Event} event - Mouse force down event
     */

  }, {
    key: onMouseForceDown,
    value: function value(event) {
      if (this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = event.currentTarget;

      var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragStartEvent);

      this.currentContainer = container;
      this.dragging = !dragStartEvent.canceled();
      this.mightDrag = false;
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: onMouseUp,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: null,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragStopEvent);

      this.currentContainer = null;
      this.dragging = false;
      this.mightDrag = false;
    }

    /**
     * Mouse down handler
     * @private
     * @param {Event} event - Mouse down event
     */

  }, {
    key: onMouseDown,
    value: function value(event) {
      if (!this.mightDrag) {
        return;
      }

      // Need workaround for real click
      // Cancel potential drag events
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
    }

    /**
     * Mouse move handler
     * @private
     * @param {Event} event - Mouse force will begin event
     */

  }, {
    key: onMouseMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragMoveEvent);
    }

    /**
     * Mouse force change handler
     * @private
     * @param {Event} event - Mouse force change event
     */

  }, {
    key: onMouseForceChange,
    value: function value(event) {
      if (this.dragging) {
        return;
      }

      var target = event.target;
      var container = event.currentTarget;

      var dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
        pressure: event.webkitForce,
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragPressureEvent);
    }

    /**
     * Mouse force global change handler
     * @private
     * @param {Event} event - Mouse force global change event
     */

  }, {
    key: onMouseForceGlobalChange,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = event.target;

      var dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
        pressure: event.webkitForce,
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragPressureEvent);
    }
  }]);
  return ForceTouchSensor;
}(_Sensor3.default);

exports.default = ForceTouchSensor;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForceTouchSensor = __webpack_require__(59);

var _ForceTouchSensor2 = _interopRequireDefault(_ForceTouchSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForceTouchSensor2.default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(17);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onMouseDown = Symbol('onMouseDown');
var onMouseUp = Symbol('onMouseUp');
var onDragStart = Symbol('onDragStart');
var onDragOver = Symbol('onDragOver');
var onDragEnd = Symbol('onDragEnd');
var onDrop = Symbol('onDrop');
var reset = Symbol('reset');

/**
 * This sensor picks up native browser drag events and dictates drag operations
 * @class DragSensor
 * @module DragSensor
 * @extends Sensor
 */

var DragSensor = function (_Sensor) {
  (0, _inherits3.default)(DragSensor, _Sensor);

  /**
   * DragSensor constructor.
   * @constructs DragSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function DragSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, DragSensor);

    /**
     * Mouse down timer which will end up setting the draggable attribute, unless canceled
     * @property mouseDownTimeout
     * @type {Number}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (DragSensor.__proto__ || Object.getPrototypeOf(DragSensor)).call(this, containers, options));

    _this.mouseDownTimeout = null;

    /**
     * Draggable element needs to be remembered to unset the draggable attribute after drag operation has completed
     * @property draggableElement
     * @type {HTMLElement}
     */
    _this.draggableElement = null;

    /**
     * Native draggable element could be links or images, their draggable state will be disabled during drag operation
     * @property nativeDraggableElement
     * @type {HTMLElement}
     */
    _this.nativeDraggableElement = null;

    _this[onMouseDown] = _this[onMouseDown].bind(_this);
    _this[onMouseUp] = _this[onMouseUp].bind(_this);
    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragOver] = _this[onDragOver].bind(_this);
    _this[onDragEnd] = _this[onDragEnd].bind(_this);
    _this[onDrop] = _this[onDrop].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(DragSensor, [{
    key: 'attach',
    value: function attach() {
      document.addEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      document.removeEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Drag start handler
     * @private
     * @param {Event} event - Drag start event
     */

  }, {
    key: onDragStart,
    value: function value(event) {
      var _this2 = this;

      // Need for firefox. "text" key is needed for IE
      event.dataTransfer.setData('text', '');
      event.dataTransfer.effectAllowed = this.options.type;

      var target = document.elementFromPoint(event.clientX, event.clientY);
      this.currentContainer = (0, _utils.closest)(event.target, this.containers);

      if (!this.currentContainer) {
        return;
      }

      var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      // Workaround
      setTimeout(function () {
        _this2.trigger(_this2.currentContainer, dragStartEvent);

        if (dragStartEvent.canceled()) {
          _this2.dragging = false;
        } else {
          _this2.dragging = true;
        }
      }, 0);
    }

    /**
     * Drag over handler
     * @private
     * @param {Event} event - Drag over event
     */

  }, {
    key: onDragOver,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = this.currentContainer;

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragMoveEvent);

      if (!dragMoveEvent.canceled()) {
        event.preventDefault();
        event.dataTransfer.dropEffect = this.options.type;
      }
    }

    /**
     * Drag end handler
     * @private
     * @param {Event} event - Drag end event
     */

  }, {
    key: onDragEnd,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      document.removeEventListener('mouseup', this[onMouseUp], true);

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = this.currentContainer;

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragStopEvent);

      this.dragging = false;

      this[reset]();
    }

    /**
     * Drop handler
     * @private
     * @param {Event} event - Drop event
     */

  }, {
    key: onDrop,
    value: function value(event) {
      // eslint-disable-line class-methods-use-this
      event.preventDefault();
    }

    /**
     * Mouse down handler
     * @private
     * @param {Event} event - Mouse down event
     */

  }, {
    key: onMouseDown,
    value: function value(event) {
      var _this3 = this;

      // Firefox bug for inputs within draggables https://bugzilla.mozilla.org/show_bug.cgi?id=739071
      if (event.target && (event.target.form || event.target.contenteditable)) {
        return;
      }

      var nativeDraggableElement = (0, _utils.closest)(event.target, function (element) {
        return element.draggable;
      });

      if (nativeDraggableElement) {
        nativeDraggableElement.draggable = false;
        this.nativeDraggableElement = nativeDraggableElement;
      }

      document.addEventListener('mouseup', this[onMouseUp], true);
      document.addEventListener('dragstart', this[onDragStart], false);
      document.addEventListener('dragover', this[onDragOver], false);
      document.addEventListener('dragend', this[onDragEnd], false);
      document.addEventListener('drop', this[onDrop], false);

      var target = (0, _utils.closest)(event.target, this.options.draggable);

      if (!target) {
        return;
      }

      this.mouseDownTimeout = setTimeout(function () {
        target.draggable = true;
        _this3.draggableElement = target;
      }, this.options.delay);
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: onMouseUp,
    value: function value() {
      this[reset]();
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: reset,
    value: function value() {
      clearTimeout(this.mouseDownTimeout);

      document.removeEventListener('mouseup', this[onMouseUp], true);
      document.removeEventListener('dragstart', this[onDragStart], false);
      document.removeEventListener('dragover', this[onDragOver], false);
      document.removeEventListener('dragend', this[onDragEnd], false);
      document.removeEventListener('drop', this[onDrop], false);

      if (this.nativeDraggableElement) {
        this.nativeDraggableElement.draggable = true;
        this.nativeDraggableElement = null;
      }

      if (this.draggableElement) {
        this.draggableElement.draggable = false;
        this.draggableElement = null;
      }
    }
  }]);
  return DragSensor;
}(_Sensor3.default);

exports.default = DragSensor;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragSensor = __webpack_require__(61);

var _DragSensor2 = _interopRequireDefault(_DragSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DragSensor2.default;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(17);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onTouchStart = Symbol('onTouchStart');
var onTouchHold = Symbol('onTouchHold');
var onTouchEnd = Symbol('onTouchEnd');
var onTouchMove = Symbol('onTouchMove');

/**
 * Prevents scrolling when set to true
 * @var {Boolean} preventScrolling
 */
var preventScrolling = false;

// WebKit requires cancelable `touchmove` events to be added as early as possible
window.addEventListener('touchmove', function (event) {
  if (!preventScrolling) {
    return;
  }

  // Prevent scrolling
  event.preventDefault();
}, { passive: false });

/**
 * This sensor picks up native browser touch events and dictates drag operations
 * @class TouchSensor
 * @module TouchSensor
 * @extends Sensor
 */

var TouchSensor = function (_Sensor) {
  (0, _inherits3.default)(TouchSensor, _Sensor);

  /**
   * TouchSensor constructor.
   * @constructs TouchSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function TouchSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, TouchSensor);

    /**
     * Closest scrollable container so accidental scroll can cancel long touch
     * @property currentScrollableParent
     * @type {HTMLElement}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchSensor.__proto__ || Object.getPrototypeOf(TouchSensor)).call(this, containers, options));

    _this.currentScrollableParent = null;

    /**
     * TimeoutID for long touch
     * @property tapTimeout
     * @type {Number}
     */
    _this.tapTimeout = null;

    /**
     * touchMoved indicates if touch has moved during tapTimeout
     * @property touchMoved
     * @type {Boolean}
     */
    _this.touchMoved = false;

    _this[onTouchStart] = _this[onTouchStart].bind(_this);
    _this[onTouchHold] = _this[onTouchHold].bind(_this);
    _this[onTouchEnd] = _this[onTouchEnd].bind(_this);
    _this[onTouchMove] = _this[onTouchMove].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(TouchSensor, [{
    key: 'attach',
    value: function attach() {
      document.addEventListener('touchstart', this[onTouchStart]);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      document.removeEventListener('touchstart', this[onTouchStart]);
    }

    /**
     * Touch start handler
     * @private
     * @param {Event} event - Touch start event
     */

  }, {
    key: onTouchStart,
    value: function value(event) {
      var container = (0, _utils.closest)(event.target, this.containers);

      if (!container) {
        return;
      }

      document.addEventListener('touchmove', this[onTouchMove]);
      document.addEventListener('touchend', this[onTouchEnd]);
      document.addEventListener('touchcancel', this[onTouchEnd]);
      container.addEventListener('contextmenu', onContextMenu);

      this.currentContainer = container;
      this.tapTimeout = setTimeout(this[onTouchHold](event, container), this.options.delay);
    }

    /**
     * Touch hold handler
     * @private
     * @param {Event} event - Touch start event
     * @param {HTMLElement} container - Container element
     */

  }, {
    key: onTouchHold,
    value: function value(event, container) {
      var _this2 = this;

      return function () {
        if (_this2.touchMoved) {
          return;
        }

        var touch = event.touches[0] || event.changedTouches[0];
        var target = event.target;

        var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
          clientX: touch.pageX,
          clientY: touch.pageY,
          target: target,
          container: container,
          originalEvent: event
        });

        _this2.trigger(container, dragStartEvent);

        _this2.dragging = !dragStartEvent.canceled();
        preventScrolling = _this2.dragging;
      };
    }

    /**
     * Touch move handler
     * @private
     * @param {Event} event - Touch move event
     */

  }, {
    key: onTouchMove,
    value: function value(event) {
      this.touchMoved = true;

      if (!this.dragging) {
        return;
      }

      var touch = event.touches[0] || event.changedTouches[0];
      var target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: touch.pageX,
        clientY: touch.pageY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragMoveEvent);
    }

    /**
     * Touch end handler
     * @private
     * @param {Event} event - Touch end event
     */

  }, {
    key: onTouchEnd,
    value: function value(event) {
      this.touchMoved = false;
      preventScrolling = false;

      document.removeEventListener('touchend', this[onTouchEnd]);
      document.removeEventListener('touchcancel', this[onTouchEnd]);
      document.removeEventListener('touchmove', this[onTouchMove]);

      if (this.currentContainer) {
        this.currentContainer.removeEventListener('contextmenu', onContextMenu);
      }

      clearTimeout(this.tapTimeout);

      if (!this.dragging) {
        return;
      }

      var touch = event.touches[0] || event.changedTouches[0];
      var target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);

      event.preventDefault();

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: touch.pageX,
        clientY: touch.pageY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragStopEvent);

      this.currentContainer = null;
      this.dragging = false;
    }
  }]);
  return TouchSensor;
}(_Sensor3.default);

exports.default = TouchSensor;


function onContextMenu(event) {
  event.preventDefault();
  event.stopPropagation();
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TouchSensor = __webpack_require__(63);

var _TouchSensor2 = _interopRequireDefault(_TouchSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TouchSensor2.default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragPressureSensorEvent = exports.DragStopSensorEvent = exports.DragMoveSensorEvent = exports.DragStartSensorEvent = exports.SensorEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(22);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sensor event
 * @class SensorEvent
 * @module SensorEvent
 * @extends AbstractEvent
 */
var SensorEvent = exports.SensorEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(SensorEvent, _AbstractEvent);

  function SensorEvent() {
    (0, _classCallCheck3.default)(this, SensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SensorEvent.__proto__ || Object.getPrototypeOf(SensorEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SensorEvent, [{
    key: 'originalEvent',

    /**
     * Original browser event that triggered a sensor
     * @property originalEvent
     * @type {Event}
     * @readonly
     */
    get: function get() {
      return this.data.originalEvent;
    }

    /**
     * Normalized clientX for both touch and mouse events
     * @property clientX
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'clientX',
    get: function get() {
      return this.data.clientX;
    }

    /**
     * Normalized clientY for both touch and mouse events
     * @property clientY
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'clientY',
    get: function get() {
      return this.data.clientY;
    }

    /**
     * Normalized target for both touch and mouse events
     * Returns the element that is behind cursor or touch pointer
     * @property target
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'target',
    get: function get() {
      return this.data.target;
    }

    /**
     * Container that initiated the sensor
     * @property container
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'container',
    get: function get() {
      return this.data.container;
    }

    /**
     * Trackpad pressure
     * @property pressure
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'pressure',
    get: function get() {
      return this.data.pressure;
    }
  }]);
  return SensorEvent;
}(_AbstractEvent3.default);

/**
 * Drag start sensor event
 * @class DragStartSensorEvent
 * @module DragStartSensorEvent
 * @extends SensorEvent
 */


var DragStartSensorEvent = exports.DragStartSensorEvent = function (_SensorEvent) {
  (0, _inherits3.default)(DragStartSensorEvent, _SensorEvent);

  function DragStartSensorEvent() {
    (0, _classCallCheck3.default)(this, DragStartSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStartSensorEvent.__proto__ || Object.getPrototypeOf(DragStartSensorEvent)).apply(this, arguments));
  }

  return DragStartSensorEvent;
}(SensorEvent);

/**
 * Drag move sensor event
 * @class DragMoveSensorEvent
 * @module DragMoveSensorEvent
 * @extends SensorEvent
 */


DragStartSensorEvent.type = 'drag:start';

var DragMoveSensorEvent = exports.DragMoveSensorEvent = function (_SensorEvent2) {
  (0, _inherits3.default)(DragMoveSensorEvent, _SensorEvent2);

  function DragMoveSensorEvent() {
    (0, _classCallCheck3.default)(this, DragMoveSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragMoveSensorEvent.__proto__ || Object.getPrototypeOf(DragMoveSensorEvent)).apply(this, arguments));
  }

  return DragMoveSensorEvent;
}(SensorEvent);

/**
 * Drag stop sensor event
 * @class DragStopSensorEvent
 * @module DragStopSensorEvent
 * @extends SensorEvent
 */


DragMoveSensorEvent.type = 'drag:move';

var DragStopSensorEvent = exports.DragStopSensorEvent = function (_SensorEvent3) {
  (0, _inherits3.default)(DragStopSensorEvent, _SensorEvent3);

  function DragStopSensorEvent() {
    (0, _classCallCheck3.default)(this, DragStopSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStopSensorEvent.__proto__ || Object.getPrototypeOf(DragStopSensorEvent)).apply(this, arguments));
  }

  return DragStopSensorEvent;
}(SensorEvent);

/**
 * Drag pressure sensor event
 * @class DragPressureSensorEvent
 * @module DragPressureSensorEvent
 * @extends SensorEvent
 */


DragStopSensorEvent.type = 'drag:stop';

var DragPressureSensorEvent = exports.DragPressureSensorEvent = function (_SensorEvent4) {
  (0, _inherits3.default)(DragPressureSensorEvent, _SensorEvent4);

  function DragPressureSensorEvent() {
    (0, _classCallCheck3.default)(this, DragPressureSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragPressureSensorEvent.__proto__ || Object.getPrototypeOf(DragPressureSensorEvent)).apply(this, arguments));
  }

  return DragPressureSensorEvent;
}(SensorEvent);

DragPressureSensorEvent.type = 'drag:pressure';

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(17);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onContextMenuWhileDragging = Symbol('onContextMenuWhileDragging');
var onMouseDown = Symbol('onMouseDown');
var onMouseMove = Symbol('onMouseMove');
var onMouseUp = Symbol('onMouseUp');

/**
 * This sensor picks up native browser mouse events and dictates drag operations
 * @class MouseSensor
 * @module MouseSensor
 * @extends Sensor
 */

var MouseSensor = function (_Sensor) {
  (0, _inherits3.default)(MouseSensor, _Sensor);

  /**
   * MouseSensor constructor.
   * @constructs MouseSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function MouseSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, MouseSensor);

    /**
     * Indicates if mouse button is still down
     * @property mouseDown
     * @type {Boolean}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (MouseSensor.__proto__ || Object.getPrototypeOf(MouseSensor)).call(this, containers, options));

    _this.mouseDown = false;

    /**
     * Mouse down timer which will end up triggering the drag start operation
     * @property mouseDownTimeout
     * @type {Number}
     */
    _this.mouseDownTimeout = null;

    /**
     * Indicates if context menu has been opened during drag operation
     * @property openedContextMenu
     * @type {Boolean}
     */
    _this.openedContextMenu = false;

    _this[onContextMenuWhileDragging] = _this[onContextMenuWhileDragging].bind(_this);
    _this[onMouseDown] = _this[onMouseDown].bind(_this);
    _this[onMouseMove] = _this[onMouseMove].bind(_this);
    _this[onMouseUp] = _this[onMouseUp].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(MouseSensor, [{
    key: 'attach',
    value: function attach() {
      document.addEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      document.removeEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Mouse down handler
     * @private
     * @param {Event} event - Mouse down event
     */

  }, {
    key: onMouseDown,
    value: function value(event) {
      var _this2 = this;

      if (event.button !== 0 || event.ctrlKey || event.metaKey) {
        return;
      }

      document.addEventListener('mouseup', this[onMouseUp]);

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = (0, _utils.closest)(target, this.containers);

      if (!container) {
        return;
      }

      document.addEventListener('dragstart', preventNativeDragStart);

      this.mouseDown = true;

      clearTimeout(this.mouseDownTimeout);
      this.mouseDownTimeout = setTimeout(function () {
        if (!_this2.mouseDown) {
          return;
        }

        var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
          clientX: event.clientX,
          clientY: event.clientY,
          target: target,
          container: container,
          originalEvent: event
        });

        _this2.trigger(container, dragStartEvent);

        _this2.currentContainer = container;
        _this2.dragging = !dragStartEvent.canceled();

        if (_this2.dragging) {
          document.addEventListener('contextmenu', _this2[onContextMenuWhileDragging]);
          document.addEventListener('mousemove', _this2[onMouseMove]);
        }
      }, this.options.delay);
    }

    /**
     * Mouse move handler
     * @private
     * @param {Event} event - Mouse move event
     */

  }, {
    key: onMouseMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragMoveEvent);
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: onMouseUp,
    value: function value(event) {
      this.mouseDown = Boolean(this.openedContextMenu);

      if (this.openedContextMenu) {
        this.openedContextMenu = false;
        return;
      }

      document.removeEventListener('mouseup', this[onMouseUp]);
      document.removeEventListener('dragstart', preventNativeDragStart);

      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragStopEvent);

      document.removeEventListener('contextmenu', this[onContextMenuWhileDragging]);
      document.removeEventListener('mousemove', this[onMouseMove]);

      this.currentContainer = null;
      this.dragging = false;
    }

    /**
     * Context menu handler
     * @private
     * @param {Event} event - Context menu event
     */

  }, {
    key: onContextMenuWhileDragging,
    value: function value(event) {
      event.preventDefault();
      this.openedContextMenu = true;
    }
  }]);
  return MouseSensor;
}(_Sensor3.default);

exports.default = MouseSensor;


function preventNativeDragStart(event) {
  event.preventDefault();
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseSensor = __webpack_require__(66);

var _MouseSensor2 = _interopRequireDefault(_MouseSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MouseSensor2.default;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sensor class. Extend from this class to create a new or custom sensor
 * @class Sensor
 * @module Sensor
 */
var Sensor = function () {
  /**
   * Sensor constructor.
   * @constructs Sensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function Sensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Sensor);

    /**
     * Current containers
     * @property containers
     * @type {HTMLElement[]}
     */
    this.containers = [].concat((0, _toConsumableArray3.default)(containers));

    /**
     * Current options
     * @property options
     * @type {Object}
     */
    this.options = Object.assign({}, options);

    /**
     * Current drag state
     * @property dragging
     * @type {Boolean}
     */
    this.dragging = false;

    /**
     * Current container
     * @property currentContainer
     * @type {HTMLElement}
     */
    this.currentContainer = null;
  }

  /**
   * Attaches sensors event listeners to the DOM
   * @return {Sensor}
   */


  (0, _createClass3.default)(Sensor, [{
    key: 'attach',
    value: function attach() {
      return this;
    }

    /**
     * Detaches sensors event listeners to the DOM
     * @return {Sensor}
     */

  }, {
    key: 'detach',
    value: function detach() {
      return this;
    }

    /**
     * Adds container to this sensor instance
     * @param {...HTMLElement} containers - Containers you want to add to this sensor
     * @example draggable.addContainer(document.body)
     */

  }, {
    key: 'addContainer',
    value: function addContainer() {
      for (var _len = arguments.length, containers = Array(_len), _key = 0; _key < _len; _key++) {
        containers[_key] = arguments[_key];
      }

      this.containers = [].concat((0, _toConsumableArray3.default)(this.containers), containers);
    }

    /**
     * Removes container from this sensor instance
     * @param {...HTMLElement} containers - Containers you want to remove from this sensor
     * @example draggable.removeContainer(document.body)
     */

  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      for (var _len2 = arguments.length, containers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        containers[_key2] = arguments[_key2];
      }

      this.containers = this.containers.filter(function (container) {
        return !containers.includes(container);
      });
    }

    /**
     * Triggers event on target element
     * @param {HTMLElement} element - Element to trigger event on
     * @param {SensorEvent} sensorEvent - Sensor event to trigger
     */

  }, {
    key: 'trigger',
    value: function trigger(element, sensorEvent) {
      var event = document.createEvent('Event');
      event.detail = sensorEvent;
      event.initEvent(sensorEvent.type, true, true);
      element.dispatchEvent(event);
      this.lastEvent = sensorEvent;

      return sensorEvent;
    }
  }]);
  return Sensor;
}();

exports.default = Sensor;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestNextAnimationFrame;
function requestNextAnimationFrame(callback) {
  return requestAnimationFrame(function () {
    requestAnimationFrame(callback);
  });
}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requestNextAnimationFrame = __webpack_require__(69);

var _requestNextAnimationFrame2 = _interopRequireDefault(_requestNextAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _requestNextAnimationFrame2.default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = closest;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchFunction = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;

/**
 * Get the closest parent element of a given element that matches the given
 * selector string or matching function
 *
 * @param {Element} element The child element to find a parent of
 * @param {String|Function} selector The string or function to use to match
 *     the parent element
 * @return {Element|null}
 */
function closest(element, value) {
  if (!element) {
    return null;
  }

  var selector = value;
  var callback = value;
  var nodeList = value;
  var singleElement = value;

  var isSelector = Boolean(typeof value === 'string');
  var isFunction = Boolean(typeof value === 'function');
  var isNodeList = Boolean(value instanceof NodeList || value instanceof Array);
  var isElement = Boolean(value instanceof HTMLElement);

  function conditionFn(currentElement) {
    if (!currentElement) {
      return currentElement;
    } else if (isSelector) {
      return matchFunction.call(currentElement, selector);
    } else if (isNodeList) {
      return [].concat((0, _toConsumableArray3.default)(nodeList)).includes(currentElement);
    } else if (isElement) {
      return singleElement === currentElement;
    } else if (isFunction) {
      return callback(currentElement);
    } else {
      return null;
    }
  }

  var current = element;

  do {
    current = current.correspondingUseElement || current.correspondingElement || current;

    if (conditionFn(current)) {
      return current;
    }

    current = current.parentNode;
  } while (current && current !== document.body && current !== document);

  return null;
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closest = __webpack_require__(71);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _closest2.default;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.scroll = exports.onDragStop = exports.onDragMove = exports.onDragStart = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(21);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

var _utils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = exports.onDragStart = Symbol('onDragStart');
var onDragMove = exports.onDragMove = Symbol('onDragMove');
var onDragStop = exports.onDragStop = Symbol('onDragStop');
var scroll = exports.scroll = Symbol('scroll');

/**
 * Scrollable default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.speed
 * @property {Number} defaultOptions.sensitivity
 * @property {HTMLElement[]} defaultOptions.scrollableElements
 * @type {Object}
 */
var defaultOptions = exports.defaultOptions = {
  speed: 6,
  sensitivity: 50,
  scrollableElements: []
};

/**
 * Scrollable plugin which scrolls the closest scrollable parent
 * @class Scrollable
 * @module Scrollable
 * @extends AbstractPlugin
 */

var Scrollable = function (_AbstractPlugin) {
  (0, _inherits3.default)(Scrollable, _AbstractPlugin);

  /**
   * Scrollable constructor.
   * @constructs Scrollable
   * @param {Draggable} draggable - Draggable instance
   */
  function Scrollable(draggable) {
    (0, _classCallCheck3.default)(this, Scrollable);

    /**
     * Scrollable options
     * @property {Object} options
     * @property {Number} options.speed
     * @property {Number} options.sensitivity
     * @property {HTMLElement[]} options.scrollableElements
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Scrollable.__proto__ || Object.getPrototypeOf(Scrollable)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    /**
     * Keeps current mouse position
     * @property {Object} currentMousePosition
     * @property {Number} currentMousePosition.clientX
     * @property {Number} currentMousePosition.clientY
     * @type {Object|null}
     */
    _this.currentMousePosition = null;

    /**
     * Scroll animation frame
     * @property scrollAnimationFrame
     * @type {Number|null}
     */
    _this.scrollAnimationFrame = null;

    /**
     * Closest scrollable element
     * @property scrollableElement
     * @type {HTMLElement|null}
     */
    _this.scrollableElement = null;

    /**
     * Animation frame looking for the closest scrollable element
     * @property findScrollableElementFrame
     * @type {Number|null}
     */
    _this.findScrollableElementFrame = null;

    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragMove] = _this[onDragMove].bind(_this);
    _this[onDragStop] = _this[onDragStop].bind(_this);
    _this[scroll] = _this[scroll].bind(_this);
    return _this;
  }

  /**
   * Attaches plugins event listeners
   */


  (0, _createClass3.default)(Scrollable, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]);
    }

    /**
     * Detaches plugins event listeners
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]);
    }

    /**
     * Returns options passed through draggable
     * @return {Object}
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.scrollable || {};
    }

    /**
     * Returns closest scrollable elements by element
     * @param {HTMLElement} target
     * @return {HTMLElement}
     */

  }, {
    key: 'getScrollableElement',
    value: function getScrollableElement(target) {
      if (this.hasDefinedScrollableElements()) {
        return (0, _utils.closest)(target, this.options.scrollableElements) || document.documentElement;
      } else {
        return closestScrollableElement(target);
      }
    }

    /**
     * Returns true if at least one scrollable element have been defined via options
     * @param {HTMLElement} target
     * @return {Boolean}
     */

  }, {
    key: 'hasDefinedScrollableElements',
    value: function hasDefinedScrollableElements() {
      return Boolean(this.options.scrollableElements.length !== 0);
    }

    /**
     * Drag start handler. Finds closest scrollable parent in separate frame
     * @param {DragStartEvent} dragEvent
     * @private
     */

  }, {
    key: onDragStart,
    value: function value(dragEvent) {
      var _this2 = this;

      this.findScrollableElementFrame = requestAnimationFrame(function () {
        _this2.scrollableElement = _this2.getScrollableElement(dragEvent.source);
      });
    }

    /**
     * Drag move handler. Remembers mouse position and initiates scrolling
     * @param {DragMoveEvent} dragEvent
     * @private
     */

  }, {
    key: onDragMove,
    value: function value(dragEvent) {
      var _this3 = this;

      this.findScrollableElementFrame = requestAnimationFrame(function () {
        _this3.scrollableElement = _this3.getScrollableElement(dragEvent.sensorEvent.target);
      });

      if (!this.scrollableElement) {
        return;
      }

      var sensorEvent = dragEvent.sensorEvent;
      var scrollOffset = { x: 0, y: 0 };

      if ('ontouchstart' in window) {
        scrollOffset.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        scrollOffset.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
      }

      this.currentMousePosition = {
        clientX: sensorEvent.clientX - scrollOffset.x,
        clientY: sensorEvent.clientY - scrollOffset.y
      };

      this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
    }

    /**
     * Drag stop handler. Cancels scroll animations and resets state
     * @private
     */

  }, {
    key: onDragStop,
    value: function value() {
      cancelAnimationFrame(this.scrollAnimationFrame);
      cancelAnimationFrame(this.findScrollableElementFrame);

      this.scrollableElement = null;
      this.scrollAnimationFrame = null;
      this.findScrollableElementFrame = null;
      this.currentMousePosition = null;
    }

    /**
     * Scroll function that does the heavylifting
     * @private
     */

  }, {
    key: scroll,
    value: function value() {
      if (!this.scrollableElement || !this.currentMousePosition) {
        return;
      }

      cancelAnimationFrame(this.scrollAnimationFrame);

      var _options = this.options,
          speed = _options.speed,
          sensitivity = _options.sensitivity;


      var rect = this.scrollableElement.getBoundingClientRect();
      var bottomCutOff = rect.bottom > window.innerHeight;
      var topCutOff = rect.top < 0;
      var cutOff = topCutOff || bottomCutOff;

      var documentScrollingElement = getDocumentScrollingElement();
      var scrollableElement = this.scrollableElement;
      var clientX = this.currentMousePosition.clientX;
      var clientY = this.currentMousePosition.clientY;

      if (scrollableElement !== document.body && scrollableElement !== document.documentElement && !cutOff) {
        var offsetHeight = scrollableElement.offsetHeight,
            offsetWidth = scrollableElement.offsetWidth;


        if (rect.top + offsetHeight - clientY < sensitivity) {
          scrollableElement.scrollTop += speed;
        } else if (clientY - rect.top < sensitivity) {
          scrollableElement.scrollTop -= speed;
        }

        if (rect.left + offsetWidth - clientX < sensitivity) {
          scrollableElement.scrollLeft += speed;
        } else if (clientX - rect.left < sensitivity) {
          scrollableElement.scrollLeft -= speed;
        }
      } else {
        var _window = window,
            innerHeight = _window.innerHeight,
            innerWidth = _window.innerWidth;


        if (clientY < sensitivity) {
          documentScrollingElement.scrollTop -= speed;
        } else if (innerHeight - clientY < sensitivity) {
          documentScrollingElement.scrollTop += speed;
        }

        if (clientX < sensitivity) {
          documentScrollingElement.scrollLeft -= speed;
        } else if (innerWidth - clientX < sensitivity) {
          documentScrollingElement.scrollLeft += speed;
        }
      }

      this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
    }
  }]);
  return Scrollable;
}(_AbstractPlugin3.default);

/**
 * Returns true if the passed element has overflow
 * @param {HTMLElement} element
 * @return {Boolean}
 * @private
 */


exports.default = Scrollable;
function hasOverflow(element) {
  var overflowRegex = /(auto|scroll)/;
  var computedStyles = getComputedStyle(element, null);

  var overflow = computedStyles.getPropertyValue('overflow') + computedStyles.getPropertyValue('overflow-y') + computedStyles.getPropertyValue('overflow-x');

  return overflowRegex.test(overflow);
}

/**
 * Returns true if the passed element is statically positioned
 * @param {HTMLElement} element
 * @return {Boolean}
 * @private
 */
function isStaticallyPositioned(element) {
  var position = getComputedStyle(element).getPropertyValue('position');
  return position === 'static';
}

/**
 * Finds closest scrollable element
 * @param {HTMLElement} element
 * @return {HTMLElement}
 * @private
 */
function closestScrollableElement(element) {
  if (!element) {
    return getDocumentScrollingElement();
  }

  var position = getComputedStyle(element).getPropertyValue('position');
  var excludeStaticParents = position === 'absolute';

  var scrollableElement = (0, _utils.closest)(element, function (parent) {
    if (excludeStaticParents && isStaticallyPositioned(parent)) {
      return false;
    }
    return hasOverflow(parent);
  });

  if (position === 'fixed' || !scrollableElement) {
    return getDocumentScrollingElement();
  } else {
    return scrollableElement;
  }
}

/**
 * Returns element that scrolls document
 * @return {HTMLElement}
 * @private
 */
function getDocumentScrollingElement() {
  return document.scrollingElement || document.documentElement;
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Scrollable = __webpack_require__(73);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Scrollable2.default;
exports.defaultOptions = _Scrollable.defaultOptions;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MirrorDestroyEvent = exports.MirrorMoveEvent = exports.MirrorAttachedEvent = exports.MirrorCreatedEvent = exports.MirrorCreateEvent = exports.MirrorEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(22);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base mirror event
 * @class MirrorEvent
 * @module MirrorEvent
 * @extends AbstractEvent
 */
var MirrorEvent = exports.MirrorEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(MirrorEvent, _AbstractEvent);

  function MirrorEvent() {
    (0, _classCallCheck3.default)(this, MirrorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorEvent.__proto__ || Object.getPrototypeOf(MirrorEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorEvent, [{
    key: 'source',

    /**
     * Draggables source element
     * @property source
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.source;
    }

    /**
     * Draggables original source element
     * @property originalSource
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'originalSource',
    get: function get() {
      return this.data.originalSource;
    }

    /**
     * Draggables source container element
     * @property sourceContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'sourceContainer',
    get: function get() {
      return this.data.sourceContainer;
    }

    /**
     * Sensor event
     * @property sensorEvent
     * @type {SensorEvent}
     * @readonly
     */

  }, {
    key: 'sensorEvent',
    get: function get() {
      return this.data.sensorEvent;
    }

    /**
     * Drag event
     * @property dragEvent
     * @type {DragEvent}
     * @readonly
     */

  }, {
    key: 'dragEvent',
    get: function get() {
      return this.data.dragEvent;
    }

    /**
     * Original event that triggered sensor event
     * @property originalEvent
     * @type {Event}
     * @readonly
     */

  }, {
    key: 'originalEvent',
    get: function get() {
      if (this.sensorEvent) {
        return this.sensorEvent.originalEvent;
      }

      return null;
    }
  }]);
  return MirrorEvent;
}(_AbstractEvent3.default);

/**
 * Mirror create event
 * @class MirrorCreateEvent
 * @module MirrorCreateEvent
 * @extends MirrorEvent
 */


var MirrorCreateEvent = exports.MirrorCreateEvent = function (_MirrorEvent) {
  (0, _inherits3.default)(MirrorCreateEvent, _MirrorEvent);

  function MirrorCreateEvent() {
    (0, _classCallCheck3.default)(this, MirrorCreateEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorCreateEvent.__proto__ || Object.getPrototypeOf(MirrorCreateEvent)).apply(this, arguments));
  }

  return MirrorCreateEvent;
}(MirrorEvent);

/**
 * Mirror created event
 * @class MirrorCreatedEvent
 * @module MirrorCreatedEvent
 * @extends MirrorEvent
 */


MirrorCreateEvent.type = 'mirror:create';

var MirrorCreatedEvent = exports.MirrorCreatedEvent = function (_MirrorEvent2) {
  (0, _inherits3.default)(MirrorCreatedEvent, _MirrorEvent2);

  function MirrorCreatedEvent() {
    (0, _classCallCheck3.default)(this, MirrorCreatedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorCreatedEvent.__proto__ || Object.getPrototypeOf(MirrorCreatedEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorCreatedEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorCreatedEvent;
}(MirrorEvent);

/**
 * Mirror attached event
 * @class MirrorAttachedEvent
 * @module MirrorAttachedEvent
 * @extends MirrorEvent
 */


MirrorCreatedEvent.type = 'mirror:created';

var MirrorAttachedEvent = exports.MirrorAttachedEvent = function (_MirrorEvent3) {
  (0, _inherits3.default)(MirrorAttachedEvent, _MirrorEvent3);

  function MirrorAttachedEvent() {
    (0, _classCallCheck3.default)(this, MirrorAttachedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorAttachedEvent.__proto__ || Object.getPrototypeOf(MirrorAttachedEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorAttachedEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorAttachedEvent;
}(MirrorEvent);

/**
 * Mirror move event
 * @class MirrorMoveEvent
 * @module MirrorMoveEvent
 * @extends MirrorEvent
 */


MirrorAttachedEvent.type = 'mirror:attached';

var MirrorMoveEvent = exports.MirrorMoveEvent = function (_MirrorEvent4) {
  (0, _inherits3.default)(MirrorMoveEvent, _MirrorEvent4);

  function MirrorMoveEvent() {
    (0, _classCallCheck3.default)(this, MirrorMoveEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorMoveEvent.__proto__ || Object.getPrototypeOf(MirrorMoveEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorMoveEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorMoveEvent;
}(MirrorEvent);

/**
 * Mirror destroy event
 * @class MirrorDestroyEvent
 * @module MirrorDestroyEvent
 * @extends MirrorEvent
 */


MirrorMoveEvent.type = 'mirror:move';
MirrorMoveEvent.cancelable = true;

var MirrorDestroyEvent = exports.MirrorDestroyEvent = function (_MirrorEvent5) {
  (0, _inherits3.default)(MirrorDestroyEvent, _MirrorEvent5);

  function MirrorDestroyEvent() {
    (0, _classCallCheck3.default)(this, MirrorDestroyEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorDestroyEvent.__proto__ || Object.getPrototypeOf(MirrorDestroyEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorDestroyEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorDestroyEvent;
}(MirrorEvent);

MirrorDestroyEvent.type = 'mirror:destroy';
MirrorDestroyEvent.cancelable = true;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MirrorEvent = __webpack_require__(75);

Object.keys(_MirrorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MirrorEvent[key];
    }
  });
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.getAppendableContainer = exports.onScroll = exports.onMirrorMove = exports.onMirrorCreated = exports.onDragStop = exports.onDragMove = exports.onDragStart = undefined;

var _objectWithoutProperties2 = __webpack_require__(77);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(21);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

var _MirrorEvent = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = exports.onDragStart = Symbol('onDragStart');
var onDragMove = exports.onDragMove = Symbol('onDragMove');
var onDragStop = exports.onDragStop = Symbol('onDragStop');
var onMirrorCreated = exports.onMirrorCreated = Symbol('onMirrorCreated');
var onMirrorMove = exports.onMirrorMove = Symbol('onMirrorMove');
var onScroll = exports.onScroll = Symbol('onScroll');
var getAppendableContainer = exports.getAppendableContainer = Symbol('getAppendableContainer');

/**
 * Mirror default options
 * @property {Object} defaultOptions
 * @property {Boolean} defaultOptions.constrainDimensions
 * @property {Boolean} defaultOptions.xAxis
 * @property {Boolean} defaultOptions.yAxis
 * @property {null} defaultOptions.cursorOffsetX
 * @property {null} defaultOptions.cursorOffsetY
 * @type {Object}
 */
var defaultOptions = exports.defaultOptions = {
  constrainDimensions: false,
  xAxis: true,
  yAxis: true,
  cursorOffsetX: null,
  cursorOffsetY: null
};

/**
 * Mirror plugin which controls the mirror positioning while dragging
 * @class Mirror
 * @module Mirror
 * @extends AbstractPlugin
 */

var Mirror = function (_AbstractPlugin) {
  (0, _inherits3.default)(Mirror, _AbstractPlugin);

  /**
   * Mirror constructor.
   * @constructs Mirror
   * @param {Draggable} draggable - Draggable instance
   */
  function Mirror(draggable) {
    (0, _classCallCheck3.default)(this, Mirror);

    /**
     * Mirror options
     * @property {Object} options
     * @property {Boolean} options.constrainDimensions
     * @property {Boolean} options.xAxis
     * @property {Boolean} options.yAxis
     * @property {Number|null} options.cursorOffsetX
     * @property {Number|null} options.cursorOffsetY
     * @property {String|HTMLElement|Function} options.appendTo
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Mirror.__proto__ || Object.getPrototypeOf(Mirror)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    /**
     * Scroll offset for touch devices because the mirror is positioned fixed
     * @property {Object} scrollOffset
     * @property {Number} scrollOffset.x
     * @property {Number} scrollOffset.y
     */
    _this.scrollOffset = { x: 0, y: 0 };

    /**
     * Initial scroll offset for touch devices because the mirror is positioned fixed
     * @property {Object} scrollOffset
     * @property {Number} scrollOffset.x
     * @property {Number} scrollOffset.y
     */
    _this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    };

    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragMove] = _this[onDragMove].bind(_this);
    _this[onDragStop] = _this[onDragStop].bind(_this);
    _this[onMirrorCreated] = _this[onMirrorCreated].bind(_this);
    _this[onMirrorMove] = _this[onMirrorMove].bind(_this);
    _this[onScroll] = _this[onScroll].bind(_this);
    return _this;
  }

  /**
   * Attaches plugins event listeners
   */


  (0, _createClass3.default)(Mirror, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]).on('mirror:created', this[onMirrorCreated]).on('mirror:move', this[onMirrorMove]);
    }

    /**
     * Detaches plugins event listeners
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]).off('mirror:created', this[onMirrorCreated]).off('mirror:move', this[onMirrorMove]);
    }

    /**
     * Returns options passed through draggable
     * @return {Object}
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.mirror || {};
    }
  }, {
    key: onDragStart,
    value: function value(dragEvent) {
      if (dragEvent.canceled()) {
        return;
      }

      if ('ontouchstart' in window) {
        document.addEventListener('scroll', this[onScroll], true);
      }

      this.initialScrollOffset = {
        x: window.scrollX,
        y: window.scrollY
      };

      var source = dragEvent.source,
          originalSource = dragEvent.originalSource,
          sourceContainer = dragEvent.sourceContainer,
          sensorEvent = dragEvent.sensorEvent;


      var mirrorCreateEvent = new _MirrorEvent.MirrorCreateEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent
      });

      this.draggable.trigger(mirrorCreateEvent);

      if (isNativeDragEvent(sensorEvent) || mirrorCreateEvent.canceled()) {
        return;
      }

      var appendableContainer = this[getAppendableContainer](source) || sourceContainer;
      this.mirror = source.cloneNode(true);

      var mirrorCreatedEvent = new _MirrorEvent.MirrorCreatedEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent,
        mirror: this.mirror
      });

      var mirrorAttachedEvent = new _MirrorEvent.MirrorAttachedEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent,
        mirror: this.mirror
      });

      this.draggable.trigger(mirrorCreatedEvent);
      appendableContainer.appendChild(this.mirror);
      this.draggable.trigger(mirrorAttachedEvent);
    }
  }, {
    key: onDragMove,
    value: function value(dragEvent) {
      if (!this.mirror || dragEvent.canceled()) {
        return;
      }

      var source = dragEvent.source,
          originalSource = dragEvent.originalSource,
          sourceContainer = dragEvent.sourceContainer,
          sensorEvent = dragEvent.sensorEvent;


      var mirrorMoveEvent = new _MirrorEvent.MirrorMoveEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent,
        mirror: this.mirror
      });

      this.draggable.trigger(mirrorMoveEvent);
    }
  }, {
    key: onDragStop,
    value: function value(dragEvent) {
      if ('ontouchstart' in window) {
        document.removeEventListener('scroll', this[onScroll], true);
      }

      this.initialScrollOffset = { x: 0, y: 0 };
      this.scrollOffset = { x: 0, y: 0 };

      if (!this.mirror) {
        return;
      }

      var source = dragEvent.source,
          sourceContainer = dragEvent.sourceContainer,
          sensorEvent = dragEvent.sensorEvent;


      var mirrorDestroyEvent = new _MirrorEvent.MirrorDestroyEvent({
        source: source,
        mirror: this.mirror,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent
      });

      this.draggable.trigger(mirrorDestroyEvent);

      if (!mirrorDestroyEvent.canceled()) {
        this.mirror.parentNode.removeChild(this.mirror);
      }
    }
  }, {
    key: onScroll,
    value: function value() {
      this.scrollOffset = {
        x: window.scrollX - this.initialScrollOffset.x,
        y: window.scrollY - this.initialScrollOffset.y
      };
    }

    /**
     * Mirror created handler
     * @param {MirrorCreatedEvent} mirrorEvent
     * @return {Promise}
     * @private
     */

  }, {
    key: onMirrorCreated,
    value: function value(_ref) {
      var _this2 = this;

      var mirror = _ref.mirror,
          source = _ref.source,
          sensorEvent = _ref.sensorEvent;

      var mirrorClass = this.draggable.getClassNameFor('mirror');

      var setState = function setState(_ref2) {
        var mirrorOffset = _ref2.mirrorOffset,
            initialX = _ref2.initialX,
            initialY = _ref2.initialY,
            args = (0, _objectWithoutProperties3.default)(_ref2, ['mirrorOffset', 'initialX', 'initialY']);

        _this2.mirrorOffset = mirrorOffset;
        _this2.initialX = initialX;
        _this2.initialY = initialY;
        return Object.assign({ mirrorOffset: mirrorOffset, initialX: initialX, initialY: initialY }, args);
      };

      var initialState = {
        mirror: mirror,
        source: source,
        sensorEvent: sensorEvent,
        mirrorClass: mirrorClass,
        scrollOffset: this.scrollOffset,
        options: this.options
      };

      return Promise.resolve(initialState)
      // Fix reflow here
      .then(computeMirrorDimensions).then(calculateMirrorOffset).then(resetMirror).then(addMirrorClasses).then(positionMirror({ initial: true })).then(removeMirrorID).then(setState);
    }

    /**
     * Mirror move handler
     * @param {MirrorMoveEvent} mirrorEvent
     * @return {Promise|null}
     * @private
     */

  }, {
    key: onMirrorMove,
    value: function value(mirrorEvent) {
      if (mirrorEvent.canceled()) {
        return null;
      }

      var initialState = {
        mirror: mirrorEvent.mirror,
        sensorEvent: mirrorEvent.sensorEvent,
        mirrorOffset: this.mirrorOffset,
        options: this.options,
        initialX: this.initialX,
        initialY: this.initialY,
        scrollOffset: this.scrollOffset
      };

      return Promise.resolve(initialState).then(positionMirror({ raf: true }));
    }

    /**
     * Returns appendable container for mirror based on the appendTo option
     * @private
     * @param {Object} options
     * @param {HTMLElement} options.source - Current source
     * @return {HTMLElement}
     */

  }, {
    key: getAppendableContainer,
    value: function value(source) {
      var appendTo = this.options.appendTo;

      if (typeof appendTo === 'string') {
        return document.querySelector(appendTo);
      } else if (appendTo instanceof HTMLElement) {
        return appendTo;
      } else if (typeof appendTo === 'function') {
        return appendTo(source);
      } else {
        return source.parentNode;
      }
    }
  }]);
  return Mirror;
}(_AbstractPlugin3.default);

/**
 * Computes mirror dimensions based on the source element
 * Adds sourceRect to state
 * @param {Object} state
 * @param {HTMLElement} state.source
 * @return {Promise}
 * @private
 */


exports.default = Mirror;
function computeMirrorDimensions(_ref3) {
  var source = _ref3.source,
      args = (0, _objectWithoutProperties3.default)(_ref3, ['source']);

  return withPromise(function (resolve) {
    var sourceRect = source.getBoundingClientRect();
    resolve(Object.assign({ source: source, sourceRect: sourceRect }, args));
  });
}

/**
 * Calculates mirror offset
 * Adds mirrorOffset to state
 * @param {Object} state
 * @param {SensorEvent} state.sensorEvent
 * @param {DOMRect} state.sourceRect
 * @return {Promise}
 * @private
 */
function calculateMirrorOffset(_ref4) {
  var sensorEvent = _ref4.sensorEvent,
      sourceRect = _ref4.sourceRect,
      options = _ref4.options,
      args = (0, _objectWithoutProperties3.default)(_ref4, ['sensorEvent', 'sourceRect', 'options']);

  return withPromise(function (resolve) {
    var top = options.cursorOffsetY === null ? sensorEvent.clientY - sourceRect.top : options.cursorOffsetY;
    var left = options.cursorOffsetX === null ? sensorEvent.clientX - sourceRect.left : options.cursorOffsetX;

    var mirrorOffset = { top: top, left: left };

    resolve(Object.assign({ sensorEvent: sensorEvent, sourceRect: sourceRect, mirrorOffset: mirrorOffset, options: options }, args));
  });
}

/**
 * Applys mirror styles
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {HTMLElement} state.source
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function resetMirror(_ref5) {
  var mirror = _ref5.mirror,
      source = _ref5.source,
      options = _ref5.options,
      args = (0, _objectWithoutProperties3.default)(_ref5, ['mirror', 'source', 'options']);

  return withPromise(function (resolve) {
    var offsetHeight = void 0;
    var offsetWidth = void 0;

    if (options.constrainDimensions) {
      var computedSourceStyles = getComputedStyle(source);
      offsetHeight = computedSourceStyles.getPropertyValue('height');
      offsetWidth = computedSourceStyles.getPropertyValue('width');
    }

    mirror.style.position = 'fixed';
    mirror.style.pointerEvents = 'none';
    mirror.style.top = 0;
    mirror.style.left = 0;
    mirror.style.margin = 0;

    if (options.constrainDimensions) {
      mirror.style.height = offsetHeight;
      mirror.style.width = offsetWidth;
    }

    resolve(Object.assign({ mirror: mirror, source: source, options: options }, args));
  });
}

/**
 * Applys mirror class on mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {String} state.mirrorClass
 * @return {Promise}
 * @private
 */
function addMirrorClasses(_ref6) {
  var mirror = _ref6.mirror,
      mirrorClass = _ref6.mirrorClass,
      args = (0, _objectWithoutProperties3.default)(_ref6, ['mirror', 'mirrorClass']);

  return withPromise(function (resolve) {
    mirror.classList.add(mirrorClass);
    resolve(Object.assign({ mirror: mirror, mirrorClass: mirrorClass }, args));
  });
}

/**
 * Removes source ID from cloned mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @return {Promise}
 * @private
 */
function removeMirrorID(_ref7) {
  var mirror = _ref7.mirror,
      args = (0, _objectWithoutProperties3.default)(_ref7, ['mirror']);

  return withPromise(function (resolve) {
    mirror.removeAttribute('id');
    delete mirror.id;
    resolve(Object.assign({ mirror: mirror }, args));
  });
}

/**
 * Positions mirror with translate3d
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {SensorEvent} state.sensorEvent
 * @param {Object} state.mirrorOffset
 * @param {Number} state.initialY
 * @param {Number} state.initialX
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function positionMirror() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref8$withFrame = _ref8.withFrame,
      withFrame = _ref8$withFrame === undefined ? false : _ref8$withFrame,
      _ref8$initial = _ref8.initial,
      initial = _ref8$initial === undefined ? false : _ref8$initial;

  return function (_ref9) {
    var mirror = _ref9.mirror,
        sensorEvent = _ref9.sensorEvent,
        mirrorOffset = _ref9.mirrorOffset,
        initialY = _ref9.initialY,
        initialX = _ref9.initialX,
        scrollOffset = _ref9.scrollOffset,
        options = _ref9.options,
        args = (0, _objectWithoutProperties3.default)(_ref9, ['mirror', 'sensorEvent', 'mirrorOffset', 'initialY', 'initialX', 'scrollOffset', 'options']);

    return withPromise(function (resolve) {
      var result = Object.assign({
        mirror: mirror,
        sensorEvent: sensorEvent,
        mirrorOffset: mirrorOffset,
        options: options
      }, args);

      if (mirrorOffset) {
        var x = sensorEvent.clientX - mirrorOffset.left - scrollOffset.x;
        var y = sensorEvent.clientY - mirrorOffset.top - scrollOffset.y;

        if (options.xAxis && options.yAxis || initial) {
          mirror.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
        } else if (options.xAxis && !options.yAxis) {
          mirror.style.transform = 'translate3d(' + x + 'px, ' + initialY + 'px, 0)';
        } else if (options.yAxis && !options.xAxis) {
          mirror.style.transform = 'translate3d(' + initialX + 'px, ' + y + 'px, 0)';
        }

        if (initial) {
          result.initialX = x;
          result.initialY = y;
        }
      }

      resolve(result);
    }, { frame: withFrame });
  };
}

/**
 * Wraps functions in promise with potential animation frame option
 * @param {Function} callback
 * @param {Object} options
 * @param {Boolean} options.raf
 * @return {Promise}
 * @private
 */
function withPromise(callback) {
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref10$raf = _ref10.raf,
      raf = _ref10$raf === undefined ? false : _ref10$raf;

  return new Promise(function (resolve, reject) {
    if (raf) {
      requestAnimationFrame(function () {
        callback(resolve, reject);
      });
    } else {
      callback(resolve, reject);
    }
  });
}

/**
 * Returns true if the sensor event was triggered by a native browser drag event
 * @param {SensorEvent} sensorEvent
 */
function isNativeDragEvent(sensorEvent) {
  return (/^drag/.test(sensorEvent.originalEvent.type)
  );
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Mirror = __webpack_require__(78);

var _Mirror2 = _interopRequireDefault(_Mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Mirror2.default;
exports.defaultOptions = _Mirror.defaultOptions;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(4)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(33);
var TAG = __webpack_require__(4)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(81);
var ITERATOR = __webpack_require__(4)('iterator');
var Iterators = __webpack_require__(19);
module.exports = __webpack_require__(5).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(20);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(19);
var ITERATOR = __webpack_require__(4)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(12);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(39);
var $export = __webpack_require__(14);
var toObject = __webpack_require__(46);
var call = __webpack_require__(85);
var isArrayIter = __webpack_require__(84);
var toLength = __webpack_require__(47);
var createProperty = __webpack_require__(83);
var getIterFn = __webpack_require__(82);

$export($export.S + $export.F * !__webpack_require__(80)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51);
__webpack_require__(86);
module.exports = __webpack_require__(5).Array.from;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(21);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onInitialize = Symbol('onInitialize');
var onDestroy = Symbol('onDestroy');

/**
 * Focusable default options
 * @property {Object} defaultOptions
 * @type {Object}
 */
var defaultOptions = {};

/**
 * Focusable plugin
 * @class Focusable
 * @module Focusable
 * @extends AbstractPlugin
 */

var Focusable = function (_AbstractPlugin) {
  (0, _inherits3.default)(Focusable, _AbstractPlugin);

  /**
   * Focusable constructor.
   * @constructs Focusable
   * @param {Draggable} draggable - Draggable instance
   */
  function Focusable(draggable) {
    (0, _classCallCheck3.default)(this, Focusable);

    /**
     * Focusable options
     * @property {Object} options
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Focusable.__proto__ || Object.getPrototypeOf(Focusable)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    _this[onInitialize] = _this[onInitialize].bind(_this);
    _this[onDestroy] = _this[onDestroy].bind(_this);
    return _this;
  }

  /**
   * Attaches listeners to draggable
   */


  (0, _createClass3.default)(Focusable, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('draggable:initialize', this[onInitialize]).on('draggable:destroy', this[onDestroy]);
    }

    /**
     * Detaches listeners from draggable
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('draggable:initialize', this[onInitialize]).off('draggable:destroy', this[onDestroy]);
    }

    /**
     * Returns options passed through draggable
     * @return {Object}
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.focusable || {};
    }

    /**
     * Returns draggable containers and elements
     * @return {HTMLElement[]}
     */

  }, {
    key: 'getElements',
    value: function getElements() {
      return [].concat((0, _toConsumableArray3.default)(this.draggable.containers), (0, _toConsumableArray3.default)(this.draggable.getDraggableElements()));
    }

    /**
     * Intialize handler
     * @private
     */

  }, {
    key: onInitialize,
    value: function value() {
      var _this2 = this;

      // Can wait until the next best frame is available
      requestAnimationFrame(function () {
        _this2.getElements().forEach(function (element) {
          return decorateElement(element);
        });
      });
    }

    /**
     * Destroy handler
     * @private
     */

  }, {
    key: onDestroy,
    value: function value() {
      var _this3 = this;

      // Can wait until the next best frame is available
      requestAnimationFrame(function () {
        _this3.getElements().forEach(function (element) {
          return stripElement(element);
        });
      });
    }
  }]);
  return Focusable;
}(_AbstractPlugin3.default);

/**
 * Keeps track of all the elements that are missing tabindex attributes
 * so they can be reset when draggable gets destroyed
 * @const {HTMLElement[]} elementsWithMissingTabIndex
 */


exports.default = Focusable;
var elementsWithMissingTabIndex = [];

/**
 * Decorates element with tabindex attributes
 * @param {HTMLElement} element
 * @return {Object}
 * @private
 */
function decorateElement(element) {
  var hasMissingTabIndex = Boolean(!element.getAttribute('tabindex') && element.tabIndex === -1);

  if (hasMissingTabIndex) {
    elementsWithMissingTabIndex.push(element);
    element.tabIndex = 0;
  }
}

/**
 * Removes elements tabindex attributes
 * @param {HTMLElement} element
 * @private
 */
function stripElement(element) {
  var tabIndexElementPosition = elementsWithMissingTabIndex.indexOf(element);

  if (tabIndexElementPosition !== -1) {
    element.tabIndex = -1;
    elementsWithMissingTabIndex.splice(tabIndexElementPosition, 1);
  }
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Focusable = __webpack_require__(89);

var _Focusable2 = _interopRequireDefault(_Focusable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Focusable2.default;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * All draggable plugins inherit from this class.
 * @abstract
 * @class AbstractPlugin
 * @module AbstractPlugin
 */
var AbstractPlugin = function () {
  /**
   * AbstractPlugin constructor.
   * @constructs AbstractPlugin
   * @param {Draggable} draggable - Draggable instance
   */
  function AbstractPlugin(draggable) {
    (0, _classCallCheck3.default)(this, AbstractPlugin);

    /**
     * Draggable instance
     * @property draggable
     * @type {Draggable}
     */
    this.draggable = draggable;
  }

  /**
   * Override to add listeners
   * @abstract
   */


  (0, _createClass3.default)(AbstractPlugin, [{
    key: 'attach',
    value: function attach() {
      throw new Error('Not Implemented');
    }

    /**
     * Override to remove listeners
     * @abstract
     */

  }, {
    key: 'detach',
    value: function detach() {
      throw new Error('Not Implemented');
    }
  }]);
  return AbstractPlugin;
}();

exports.default = AbstractPlugin;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(21);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onInitialize = Symbol('onInitialize');
var onDestroy = Symbol('onDestroy');
var announceEvent = Symbol('announceEvent');
var announceMessage = Symbol('announceMessage');

var ARIA_RELEVANT = 'aria-relevant';
var ARIA_ATOMIC = 'aria-atomic';
var ARIA_LIVE = 'aria-live';
var ROLE = 'role';

/**
 * Announcement default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.expire
 * @type {Object}
 */
var defaultOptions = exports.defaultOptions = {
  expire: 7000
};

/**
 * Announcement plugin
 * @class Announcement
 * @module Announcement
 * @extends AbstractPlugin
 */

var Announcement = function (_AbstractPlugin) {
  (0, _inherits3.default)(Announcement, _AbstractPlugin);

  /**
   * Announcement constructor.
   * @constructs Announcement
   * @param {Draggable} draggable - Draggable instance
   */
  function Announcement(draggable) {
    (0, _classCallCheck3.default)(this, Announcement);

    /**
     * Plugin options
     * @property options
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Announcement.__proto__ || Object.getPrototypeOf(Announcement)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    /**
     * Original draggable trigger method. Hack until we have onAll or on('all')
     * @property originalTriggerMethod
     * @type {Function}
     */
    _this.originalTriggerMethod = _this.draggable.trigger;

    _this[onInitialize] = _this[onInitialize].bind(_this);
    _this[onDestroy] = _this[onDestroy].bind(_this);
    return _this;
  }

  /**
   * Attaches listeners to draggable
   */


  (0, _createClass3.default)(Announcement, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('draggable:initialize', this[onInitialize]);
    }

    /**
     * Detaches listeners from draggable
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('draggable:destroy', this[onDestroy]);
    }

    /**
     * Returns passed in options
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.announcements || {};
    }

    /**
     * Announces event
     * @private
     * @param {AbstractEvent} event
     */

  }, {
    key: announceEvent,
    value: function value(event) {
      var message = this.options[event.type];

      if (message && typeof message === 'string') {
        this[announceMessage](message);
      }

      if (message && typeof message === 'function') {
        this[announceMessage](message(event));
      }
    }

    /**
     * Announces message to screen reader
     * @private
     * @param {String} message
     */

  }, {
    key: announceMessage,
    value: function value(message) {
      announce(message, { expire: this.options.expire });
    }

    /**
     * Initialize hander
     * @private
     */

  }, {
    key: onInitialize,
    value: function value() {
      var _this2 = this;

      // Hack until there is an api for listening for all events
      this.draggable.trigger = function (event) {
        try {
          _this2[announceEvent](event);
        } finally {
          // Ensure that original trigger is called
          _this2.originalTriggerMethod.call(_this2.draggable, event);
        }
      };
    }

    /**
     * Destroy hander
     * @private
     */

  }, {
    key: onDestroy,
    value: function value() {
      this.draggable.trigger = this.originalTriggerMethod;
    }
  }]);
  return Announcement;
}(_AbstractPlugin3.default);

/**
 * @const {HTMLElement} liveRegion
 */


exports.default = Announcement;
var liveRegion = createRegion();

/**
 * Announces message via live region
 * @param {String} message
 * @param {Object} options
 * @param {Number} options.expire
 */
function announce(message, _ref) {
  var expire = _ref.expire;

  var element = document.createElement('div');

  element.textContent = message;
  liveRegion.appendChild(element);

  return setTimeout(function () {
    liveRegion.removeChild(element);
  }, expire);
}

/**
 * Creates region element
 * @return {HTMLElement}
 */
function createRegion() {
  var element = document.createElement('div');

  element.setAttribute('id', 'draggable-live-region');
  element.setAttribute(ARIA_RELEVANT, 'additions');
  element.setAttribute(ARIA_ATOMIC, 'true');
  element.setAttribute(ARIA_LIVE, 'assertive');
  element.setAttribute(ROLE, 'log');

  element.style.position = 'fixed';
  element.style.width = '1px';
  element.style.height = '1px';
  element.style.top = '-1px';
  element.style.overflow = 'hidden';

  return element;
}

// Append live region element as early as possible
document.addEventListener('DOMContentLoaded', function () {
  document.body.appendChild(liveRegion);
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Announcement = __webpack_require__(92);

var _Announcement2 = _interopRequireDefault(_Announcement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Announcement2.default;
exports.defaultOptions = _Announcement.defaultOptions;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableDestroyEvent = exports.DraggableInitializedEvent = exports.DraggableEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(22);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base draggable event
 * @class DraggableEvent
 * @module DraggableEvent
 * @extends AbstractEvent
 */
var DraggableEvent = exports.DraggableEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(DraggableEvent, _AbstractEvent);

  function DraggableEvent() {
    (0, _classCallCheck3.default)(this, DraggableEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DraggableEvent.__proto__ || Object.getPrototypeOf(DraggableEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DraggableEvent, [{
    key: 'draggable',


    /**
     * Draggable instance
     * @property draggable
     * @type {Draggable}
     * @readonly
     */
    get: function get() {
      return this.data.draggable;
    }
  }]);
  return DraggableEvent;
}(_AbstractEvent3.default);

/**
 * Draggable initialized event
 * @class DraggableInitializedEvent
 * @module DraggableInitializedEvent
 * @extends DraggableEvent
 */


DraggableEvent.type = 'draggable';

var DraggableInitializedEvent = exports.DraggableInitializedEvent = function (_DraggableEvent) {
  (0, _inherits3.default)(DraggableInitializedEvent, _DraggableEvent);

  function DraggableInitializedEvent() {
    (0, _classCallCheck3.default)(this, DraggableInitializedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DraggableInitializedEvent.__proto__ || Object.getPrototypeOf(DraggableInitializedEvent)).apply(this, arguments));
  }

  return DraggableInitializedEvent;
}(DraggableEvent);

/**
 * Draggable destory event
 * @class DraggableInitializedEvent
 * @module DraggableDestroyEvent
 * @extends DraggableDestroyEvent
 */


DraggableInitializedEvent.type = 'draggable:initialize';

var DraggableDestroyEvent = exports.DraggableDestroyEvent = function (_DraggableEvent2) {
  (0, _inherits3.default)(DraggableDestroyEvent, _DraggableEvent2);

  function DraggableDestroyEvent() {
    (0, _classCallCheck3.default)(this, DraggableDestroyEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DraggableDestroyEvent.__proto__ || Object.getPrototypeOf(DraggableDestroyEvent)).apply(this, arguments));
  }

  return DraggableDestroyEvent;
}(DraggableEvent);

DraggableDestroyEvent.type = 'draggable:destroy';

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _canceled = Symbol('canceled');

/**
 * All events fired by draggable inherit this class. You can call `cancel()` to
 * cancel a specific event or you can check if an event has been canceled by
 * calling `canceled()`.
 * @abstract
 * @class AbstractEvent
 * @module AbstractEvent
 */

var AbstractEvent = function () {

  /**
   * AbstractEvent constructor.
   * @constructs AbstractEvent
   * @param {object} data - Event data
   */

  /**
   * Event type
   * @static
   * @abstract
   * @property type
   * @type {String}
   */
  function AbstractEvent(data) {
    (0, _classCallCheck3.default)(this, AbstractEvent);

    this[_canceled] = false;
    this.data = data;
  }

  /**
   * Read-only type
   * @abstract
   * @return {String}
   */


  /**
   * Event cancelable
   * @static
   * @abstract
   * @property cancelable
   * @type {Boolean}
   */


  (0, _createClass3.default)(AbstractEvent, [{
    key: 'cancel',


    /**
     * Cancels the event instance
     * @abstract
     */
    value: function cancel() {
      this[_canceled] = true;
    }

    /**
     * Check if event has been canceled
     * @abstract
     * @return {Boolean}
     */

  }, {
    key: 'canceled',
    value: function canceled() {
      return Boolean(this[_canceled]);
    }

    /**
     * Returns new event instance with existing event data.
     * This method allows for overriding of event data.
     * @param {Object} data
     * @return {AbstractEvent}
     */

  }, {
    key: 'clone',
    value: function clone(data) {
      return new this.constructor(Object.assign({}, this.data, data));
    }
  }, {
    key: 'type',
    get: function get() {
      return this.constructor.type;
    }

    /**
     * Read-only cancelable
     * @abstract
     * @return {Boolean}
     */

  }, {
    key: 'cancelable',
    get: function get() {
      return this.constructor.cancelable;
    }
  }]);
  return AbstractEvent;
}();

AbstractEvent.type = 'event';
AbstractEvent.cancelable = false;
exports.default = AbstractEvent;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(35) });


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
var $Object = __webpack_require__(5).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(97), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(12);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(39)(Function.call, __webpack_require__(43).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(14);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(99).set });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
module.exports = __webpack_require__(5).Object.setPrototypeOf;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('observable');


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('asyncIterator');


/***/ }),
/* 105 */
/***/ (function(module, exports) {



/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(10);
var gOPN = __webpack_require__(44).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(33);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(45);
var pIE = __webpack_require__(26);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(23)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(8);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(7);
var has = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(9);
var $export = __webpack_require__(14);
var redefine = __webpack_require__(49);
var META = __webpack_require__(109).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(31);
var setToStringTag = __webpack_require__(29);
var uid = __webpack_require__(23);
var wks = __webpack_require__(4);
var wksExt = __webpack_require__(28);
var wksDefine = __webpack_require__(27);
var enumKeys = __webpack_require__(108);
var isArray = __webpack_require__(107);
var anObject = __webpack_require__(12);
var isObject = __webpack_require__(11);
var toIObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(38);
var createDesc = __webpack_require__(20);
var _create = __webpack_require__(35);
var gOPNExt = __webpack_require__(106);
var $GOPD = __webpack_require__(43);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(34);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(44).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(26).f = $propertyIsEnumerable;
  __webpack_require__(45).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(24)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
__webpack_require__(105);
__webpack_require__(104);
__webpack_require__(103);
module.exports = __webpack_require__(5).Symbol;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(111), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(114);
var step = __webpack_require__(113);
var Iterators = __webpack_require__(19);
var toIObject = __webpack_require__(10);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(50)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115);
var global = __webpack_require__(7);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(19);
var TO_STRING_TAG = __webpack_require__(4)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(46);
var IE_PROTO = __webpack_require__(32)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(7).document;
module.exports = document && document.documentElement;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(10);
var toLength = __webpack_require__(47);
var toAbsoluteIndex = __webpack_require__(119);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(33);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(12);
var getKeys = __webpack_require__(34);

module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(35);
var descriptor = __webpack_require__(20);
var setToStringTag = __webpack_require__(29);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(4)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(37);
var defined = __webpack_require__(36);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51);
__webpack_require__(116);
module.exports = __webpack_require__(28).f('iterator');


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(125), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(129), __esModule: true };

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragStopEvent = exports.DragPressureEvent = exports.DragOutContainerEvent = exports.DragOverContainerEvent = exports.DragOutEvent = exports.DragOverEvent = exports.DragMoveEvent = exports.DragStartEvent = exports.DragEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(22);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base drag event
 * @class DragEvent
 * @module DragEvent
 * @extends AbstractEvent
 */
var DragEvent = exports.DragEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(DragEvent, _AbstractEvent);

  function DragEvent() {
    (0, _classCallCheck3.default)(this, DragEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragEvent.__proto__ || Object.getPrototypeOf(DragEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragEvent, [{
    key: 'source',


    /**
     * Draggables source element
     * @property source
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.source;
    }

    /**
     * Draggables original source element
     * @property originalSource
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'originalSource',
    get: function get() {
      return this.data.originalSource;
    }

    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'mirror',
    get: function get() {
      return this.data.mirror;
    }

    /**
     * Draggables source container element
     * @property sourceContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'sourceContainer',
    get: function get() {
      return this.data.sourceContainer;
    }

    /**
     * Sensor event
     * @property sensorEvent
     * @type {SensorEvent}
     * @readonly
     */

  }, {
    key: 'sensorEvent',
    get: function get() {
      return this.data.sensorEvent;
    }

    /**
     * Original event that triggered sensor event
     * @property originalEvent
     * @type {Event}
     * @readonly
     */

  }, {
    key: 'originalEvent',
    get: function get() {
      if (this.sensorEvent) {
        return this.sensorEvent.originalEvent;
      }

      return null;
    }
  }]);
  return DragEvent;
}(_AbstractEvent3.default);

/**
 * Drag start event
 * @class DragStartEvent
 * @module DragStartEvent
 * @extends DragEvent
 */


DragEvent.type = 'drag';

var DragStartEvent = exports.DragStartEvent = function (_DragEvent) {
  (0, _inherits3.default)(DragStartEvent, _DragEvent);

  function DragStartEvent() {
    (0, _classCallCheck3.default)(this, DragStartEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStartEvent.__proto__ || Object.getPrototypeOf(DragStartEvent)).apply(this, arguments));
  }

  return DragStartEvent;
}(DragEvent);

/**
 * Drag move event
 * @class DragMoveEvent
 * @module DragMoveEvent
 * @extends DragEvent
 */


DragStartEvent.type = 'drag:start';
DragStartEvent.cancelable = true;

var DragMoveEvent = exports.DragMoveEvent = function (_DragEvent2) {
  (0, _inherits3.default)(DragMoveEvent, _DragEvent2);

  function DragMoveEvent() {
    (0, _classCallCheck3.default)(this, DragMoveEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragMoveEvent.__proto__ || Object.getPrototypeOf(DragMoveEvent)).apply(this, arguments));
  }

  return DragMoveEvent;
}(DragEvent);

/**
 * Drag over event
 * @class DragOverEvent
 * @module DragOverEvent
 * @extends DragEvent
 */


DragMoveEvent.type = 'drag:move';

var DragOverEvent = exports.DragOverEvent = function (_DragEvent3) {
  (0, _inherits3.default)(DragOverEvent, _DragEvent3);

  function DragOverEvent() {
    (0, _classCallCheck3.default)(this, DragOverEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOverEvent.__proto__ || Object.getPrototypeOf(DragOverEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOverEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you are over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }

    /**
     * Draggable element you are over
     * @property over
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'over',
    get: function get() {
      return this.data.over;
    }
  }]);
  return DragOverEvent;
}(DragEvent);

/**
 * Drag out event
 * @class DragOutEvent
 * @module DragOutEvent
 * @extends DragEvent
 */


DragOverEvent.type = 'drag:over';
DragOverEvent.cancelable = true;

var DragOutEvent = exports.DragOutEvent = function (_DragEvent4) {
  (0, _inherits3.default)(DragOutEvent, _DragEvent4);

  function DragOutEvent() {
    (0, _classCallCheck3.default)(this, DragOutEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOutEvent.__proto__ || Object.getPrototypeOf(DragOutEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOutEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you are over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }

    /**
     * Draggable element you left
     * @property over
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'over',
    get: function get() {
      return this.data.over;
    }
  }]);
  return DragOutEvent;
}(DragEvent);

/**
 * Drag over container event
 * @class DragOverContainerEvent
 * @module DragOverContainerEvent
 * @extends DragEvent
 */


DragOutEvent.type = 'drag:out';

var DragOverContainerEvent = exports.DragOverContainerEvent = function (_DragEvent5) {
  (0, _inherits3.default)(DragOverContainerEvent, _DragEvent5);

  function DragOverContainerEvent() {
    (0, _classCallCheck3.default)(this, DragOverContainerEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOverContainerEvent.__proto__ || Object.getPrototypeOf(DragOverContainerEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOverContainerEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you are over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }
  }]);
  return DragOverContainerEvent;
}(DragEvent);

/**
 * Drag out container event
 * @class DragOutContainerEvent
 * @module DragOutContainerEvent
 * @extends DragEvent
 */


DragOverContainerEvent.type = 'drag:over:container';

var DragOutContainerEvent = exports.DragOutContainerEvent = function (_DragEvent6) {
  (0, _inherits3.default)(DragOutContainerEvent, _DragEvent6);

  function DragOutContainerEvent() {
    (0, _classCallCheck3.default)(this, DragOutContainerEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOutContainerEvent.__proto__ || Object.getPrototypeOf(DragOutContainerEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOutContainerEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you left
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }
  }]);
  return DragOutContainerEvent;
}(DragEvent);

/**
 * Drag pressure event
 * @class DragPressureEvent
 * @module DragPressureEvent
 * @extends DragEvent
 */


DragOutContainerEvent.type = 'drag:out:container';

var DragPressureEvent = exports.DragPressureEvent = function (_DragEvent7) {
  (0, _inherits3.default)(DragPressureEvent, _DragEvent7);

  function DragPressureEvent() {
    (0, _classCallCheck3.default)(this, DragPressureEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragPressureEvent.__proto__ || Object.getPrototypeOf(DragPressureEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragPressureEvent, [{
    key: 'pressure',


    /**
     * Pressure applied on draggable element
     * @property pressure
     * @type {Number}
     * @readonly
     */
    get: function get() {
      return this.data.pressure;
    }
  }]);
  return DragPressureEvent;
}(DragEvent);

/**
 * Drag stop event
 * @class DragStopEvent
 * @module DragStopEvent
 * @extends DragEvent
 */


DragPressureEvent.type = 'drag:pressure';

var DragStopEvent = exports.DragStopEvent = function (_DragEvent8) {
  (0, _inherits3.default)(DragStopEvent, _DragEvent8);

  function DragStopEvent() {
    (0, _classCallCheck3.default)(this, DragStopEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStopEvent.__proto__ || Object.getPrototypeOf(DragStopEvent)).apply(this, arguments));
  }

  return DragStopEvent;
}(DragEvent);

DragStopEvent.type = 'drag:stop';

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragEvent = __webpack_require__(55);

Object.keys(_DragEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DragEvent[key];
    }
  });
});

var _DraggableEvent = __webpack_require__(42);

Object.keys(_DraggableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DraggableEvent[key];
    }
  });
});

var _Plugins = __webpack_require__(41);

Object.keys(_Plugins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Plugins[key];
    }
  });
});

var _Sensors = __webpack_require__(40);

Object.keys(_Sensors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Sensors[key];
    }
  });
});

var _Draggable = __webpack_require__(58);

var _Draggable2 = _interopRequireDefault(_Draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Draggable2.default;

/***/ })
/******/ ]);
});

/***/ }),

/***/ "c359":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitchList_vue_vue_type_style_index_0_id_fec25b6a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3582");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitchList_vue_vue_type_style_index_0_id_fec25b6a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitchList_vue_vue_type_style_index_0_id_fec25b6a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitchList_vue_vue_type_style_index_0_id_fec25b6a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c36e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-divider[data-v-00affc63]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-divider .line[data-v-00affc63]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:.03125rem}.ui-divider .text[data-v-00affc63]{-ms-flex-negative:0;flex-shrink:0;margin:0 .5rem;font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20)}.ui-divider.subtle .line[data-v-00affc63]{background-color:var(--c-black--opacity-10)}.ui-divider.subtle .text[data-v-00affc63]{color:var(--c-text--lighten-40)}.ui-divider.prominent .line[data-v-00affc63]{background-color:var(--c-black--opacity-20)}.ui-divider.prominent .text[data-v-00affc63]{color:var(--c-text--lighten-20)}", ""]);


/***/ }),

/***/ "c3fc":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("42a2"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c494":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-table-header-cell-content[data-v-784a05b8]{font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20);white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:var(--c-text--lighten-30)}.ui-table-header-cell-content[data-v-784a05b8],.ui-table-header-cell-content .label[data-v-784a05b8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui-table-header-cell-content .label[data-v-784a05b8]>:not(:last-child){margin-right:.166666666666667rem}.ui-table-header-cell-content.interactable[data-v-784a05b8]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.ui-table-header-cell-content.interactable[data-v-784a05b8]:hover{color:var(--c-text)}.ui-table-header-cell-content.sorted[data-v-784a05b8]{color:var(--c-text--darken-10)}", ""]);


/***/ }),

/***/ "c546":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-table-header th[data-v-1b9e769c]{padding:0 .625rem;height:1.5rem}.ui-table-header th[data-v-1b9e769c]:not(:first-child){padding-left:0}.ui-table-header th[data-v-1b9e769c]{text-align:left;position:-webkit-sticky;position:sticky;top:0;z-index:1}.ui-table-header th.border[data-v-1b9e769c]{border-bottom:.03125rem solid var(--c-black--opacity-5)}", ""]);


/***/ }),

/***/ "c584":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "c5a2":
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__("6ac0"),
    baseEach = __webpack_require__("48a0"),
    baseIteratee = __webpack_require__("badf"),
    baseReduce = __webpack_require__("58f7"),
    isArray = __webpack_require__("6747");

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),

/***/ "c64e":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("e1f4");
var bytesToUuid = __webpack_require__("2366");

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c780":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".fade-enter-active[data-v-157593b4],.fade-leave-active[data-v-157593b4]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.2s;transition-duration:.2s}.fade-enter[data-v-157593b4],.fade-leave-to[data-v-157593b4]{opacity:0}.ui-sidebar-wrapper[data-v-157593b4]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden}.ui-sidebar-wrapper.darken-behind-sidebar .sidebar[data-v-157593b4]{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.ui-sidebar-wrapper .main-wrapper[data-v-157593b4]{position:absolute;top:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden;-webkit-box-sizing:content-box;box-sizing:content-box}.ui-sidebar-wrapper .sidebar[data-v-157593b4],.ui-sidebar-wrapper .sidebar-placeholder-container[data-v-157593b4]{position:absolute;top:0;bottom:0}.ui-sidebar-wrapper .sidebar[data-v-157593b4]{z-index:1;-webkit-transition-property:none;transition-property:none;-webkit-transition-duration:.35s;transition-duration:.35s}.ui-sidebar-wrapper .sidebar.sidebar-slide-enter-active[data-v-157593b4],.ui-sidebar-wrapper .sidebar.sidebar-slide-leave-active[data-v-157593b4]{-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform}.ui-sidebar-wrapper .resize-bar[data-v-157593b4]{z-index:2;position:absolute;top:0;bottom:0;width:.333333333333333rem;background-color:var(--c-black--opacity-10);opacity:0;-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.1s;transition-duration:.1s}.ui-sidebar-wrapper .resize-bar[data-v-157593b4]:hover{opacity:1;cursor:ew-resize}.ui-sidebar-wrapper .sidebar-placeholder-container[data-v-157593b4]{-webkit-transition-duration:.1s;transition-duration:.1s}.ui-sidebar-wrapper .sidebar-placeholder-container .sidebar-placeholder[data-v-157593b4]{position:absolute;left:0;right:0;top:0;bottom:0}.ui-sidebar-wrapper .pull-out-tab-anchor[data-v-157593b4]{position:absolute;top:0;bottom:0;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform;-webkit-transition-duration:.35s;transition-duration:.35s}.ui-sidebar-wrapper .overlay[data-v-157593b4]{position:fixed;top:0;left:0;right:0;bottom:0;background-color:var(--c-overlay-dark);z-index:50}.ui-sidebar-wrapper.left>.main-wrapper[data-v-157593b4]{right:0}.ui-sidebar-wrapper.left>.sidebar[data-v-157593b4],.ui-sidebar-wrapper.left>.sidebar-placeholder-container[data-v-157593b4]{left:0}.ui-sidebar-wrapper.left>.sidebar.sidebar-slide-enter[data-v-157593b4],.ui-sidebar-wrapper.left>.sidebar.sidebar-slide-leave-to[data-v-157593b4]{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.ui-sidebar-wrapper.left>.pull-out-tab-anchor[data-v-157593b4],.ui-sidebar-wrapper.right>.main-wrapper[data-v-157593b4]{left:0}.ui-sidebar-wrapper.right>.sidebar[data-v-157593b4],.ui-sidebar-wrapper.right>.sidebar-placeholder-container[data-v-157593b4]{right:0}.ui-sidebar-wrapper.right>.sidebar.sidebar-slide-enter[data-v-157593b4],.ui-sidebar-wrapper.right>.sidebar.sidebar-slide-leave-to[data-v-157593b4]{-webkit-transform:translateX(100%);transform:translateX(100%)}.ui-sidebar-wrapper.right>.pull-out-tab-anchor[data-v-157593b4]{right:0}.ui-sidebar-wrapper.overlay-visible>.resize-bar[data-v-157593b4],.ui-sidebar-wrapper.overlay-visible>.sidebar[data-v-157593b4]{z-index:60}.ui-sidebar-wrapper.resizing[data-v-157593b4]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);


/***/ }),

/***/ "c869":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "c87c":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8fe":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "c96a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("eae9");

// `String.prototype.small` method
// https://tc39.github.io/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var sloppyArrayMethod = __webpack_require__("b301");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var SLOPPY_METHOD = sloppyArrayMethod('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || SLOPPY_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cb5a":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("9638");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc45":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__("1a2d"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "cd9d":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ce86":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    arrayMap = __webpack_require__("7948"),
    isArray = __webpack_require__("6747"),
    isSymbol = __webpack_require__("ffd6");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "cebd":
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),

/***/ "cf7e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f88f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("36d5cfb6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d02c":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e"),
    Map = __webpack_require__("79bc"),
    MapCache = __webpack_require__("7b83");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d323":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2589");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("51d8a5bd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d327":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "d370":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("253c"),
    isObjectLike = __webpack_require__("1310");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var toLength = __webpack_require__("50c4");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d612":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("7b83"),
    setCacheAdd = __webpack_require__("7ed2"),
    setCacheHas = __webpack_require__("dc0f");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "d645":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("47d2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7a0a63af", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d674":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStepper_vue_vue_type_style_index_0_id_339cf9da_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6912");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStepper_vue_vue_type_style_index_0_id_339cf9da_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStepper_vue_vue_type_style_index_0_id_339cf9da_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiStepper_vue_vue_type_style_index_0_id_339cf9da_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};


/***/ }),

/***/ "d7ee":
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__("c3fc"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var fails = __webpack_require__("d039");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = HAS_SPECIES_SUPPORT && !fails(function () {
  [].map.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d9a8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "da03":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "da81":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("62e4")(module)))

/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "db96":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("00fd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("e0a7ca4a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc0f":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "dc57":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "dca9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".fade-enter-active[data-v-7b997ea4],.fade-leave-active[data-v-7b997ea4]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.2s;transition-duration:.2s}.fade-enter[data-v-7b997ea4],.fade-leave-to[data-v-7b997ea4]{opacity:0}.ui-bar[data-v-7b997ea4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.ui-bar[data-v-7b997ea4]>:not(:last-child){margin-bottom:.125rem}.ui-bar .label[data-v-7b997ea4]{font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20)}.ui-bar .bar-row[data-v-7b997ea4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.ui-bar .bar-row[data-v-7b997ea4]>:not(:last-child){margin-right:.25rem}.ui-bar .bar-row .bar-container[data-v-7b997ea4]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;position:relative;height:.25rem;border-radius:.125rem;-webkit-transition-property:background-color;transition-property:background-color;-webkit-transition-duration:.2s;transition-duration:.2s;width:100%}.ui-bar .bar-row .bar-container .bar-wrapper[data-v-7b997ea4]{height:100%}.ui-bar .bar-row .bar-container .bar-wrapper .bar[data-v-7b997ea4]{width:100%;height:100%;min-width:.25rem;border-radius:.125rem;-webkit-transition-property:width,background-color;transition-property:width,background-color;-webkit-transition-duration:.2s;transition-duration:.2s}.ui-bar:not(.light) .bar-container[data-v-7b997ea4]{background-color:var(--c-black--opacity-5)}.ui-bar:not(.light) .bar[data-v-7b997ea4]{background-color:var(--c-black--opacity-10)}.ui-bar:not(.light).danger.show-danger .bar-container[data-v-7b997ea4]{background-color:var(--c-danger--tint-80)}.ui-bar:not(.light).danger.show-danger .bar[data-v-7b997ea4]{background-color:var(--c-danger)}.ui-bar:not(.light).warning.show-warning .bar[data-v-7b997ea4]{background-color:var(--c-warning)}.ui-bar:not(.light).success.show-success .bar[data-v-7b997ea4]{background-color:var(--c-success)}.ui-bar.light .label[data-v-7b997ea4]{color:#fff}.ui-bar.light .bar-container[data-v-7b997ea4]{background-color:hsla(0,0%,100%,.1)}.ui-bar.light .bar[data-v-7b997ea4]{background-color:#fff}.ui-bar.light.danger.show-danger .bar[data-v-7b997ea4]{background-color:$c-danger-tint-30}.ui-bar.light.warning.show-warning .bar[data-v-7b997ea4]{background-color:var(--c-warning)}.ui-bar.light.success.show-success .bar[data-v-7b997ea4]{background-color:var(--c-success--tint-10)}", ""]);


/***/ }),

/***/ "dcbe":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("30c9"),
    isObjectLike = __webpack_require__("1310");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "dfc6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b8b5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0d895ee4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e070":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e1f4":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ "e24b":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("49f4"),
    hashDelete = __webpack_require__("1efc"),
    hashGet = __webpack_require__("bbc0"),
    hashHas = __webpack_require__("7a48"),
    hashSet = __webpack_require__("2524");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "e25e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var parseIntImplementation = __webpack_require__("e583");

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e26a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-switch[data-v-5f65fa32]{cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:0;-webkit-transition:opacity .2s;transition:opacity .2s}.ui-switch .label[data-v-5f65fa32]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui-switch .switch-housing[data-v-5f65fa32]{-ms-flex-negative:0;flex-shrink:0;-webkit-transition:background-color .2s;transition:background-color .2s;position:relative}.ui-switch .switch-housing[data-v-5f65fa32]:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.15);opacity:0;-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.1s;transition-duration:.1s}.ui-switch .switch-housing .switch-knob[data-v-5f65fa32]{border-radius:100%;background-color:var(--c-white);-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.1);box-shadow:0 0 .25rem rgba(0,0,0,.1);-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ui-switch:not(.switched-on):not(:hover) .switch-housing[data-v-5f65fa32]{background-color:var(--c-black--opacity-10)}.ui-switch:not(.switched-on):hover .switch-housing[data-v-5f65fa32]{background-color:var(--c-black--opacity-15)}.ui-switch.switched-on .switch-housing[data-v-5f65fa32]{background-color:var(--c-primary)}.ui-switch.switched-on:hover .switch-housing[data-v-5f65fa32]:before{opacity:1}.ui-switch.disabled[data-v-5f65fa32]{opacity:.4;cursor:not-allowed}.ui-switch[data-v-5f65fa32]:not(.big)>:not(:last-child){margin-right:.25rem}.ui-switch:not(.big) .switch-housing[data-v-5f65fa32]{width:.75rem;height:.416666666666667rem;padding:.083333333333333rem}.ui-switch:not(.big) .switch-housing[data-v-5f65fa32],.ui-switch:not(.big) .switch-housing[data-v-5f65fa32]:before{border-radius:.416666666666667rem}.ui-switch:not(.big) .switch-housing .switch-knob[data-v-5f65fa32]{width:.25rem;height:.25rem}.ui-switch:not(.big).switched-on .switch-housing .switch-knob[data-v-5f65fa32]{-webkit-transform:translateX(.33333rem);transform:translateX(.33333rem)}.ui-switch.big[data-v-5f65fa32]>:not(:last-child){margin-right:.25rem}.ui-switch.big .switch-housing[data-v-5f65fa32]{width:1.125rem;height:.625rem;padding:.125rem}.ui-switch.big .switch-housing[data-v-5f65fa32],.ui-switch.big .switch-housing[data-v-5f65fa32]:before{border-radius:.625rem}.ui-switch.big .switch-housing .switch-knob[data-v-5f65fa32]{width:.375rem;height:.375rem}.ui-switch.big.switched-on .switch-housing .switch-knob[data-v-5f65fa32]{-webkit-transform:translateX(.5rem);transform:translateX(.5rem)}", ""]);


/***/ }),

/***/ "e2bc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8e9a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7ad53e33", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e2c0":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("e2e4"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isIndex = __webpack_require__("c098"),
    isLength = __webpack_require__("b218"),
    toKey = __webpack_require__("f4d6");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e2e4":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("6747"),
    isKey = __webpack_require__("f608"),
    stringToPath = __webpack_require__("18d8"),
    toString = __webpack_require__("76dd");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "e37d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VClosePopover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VPopover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VTooltip; });
/* unused harmony export createTooltip */
/* unused harmony export destroyTooltip */
/* unused harmony export install */
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b47");
/* harmony import */ var vue_resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("252c");



function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var SVGAnimatedString = function SVGAnimatedString() {};

if (typeof window !== 'undefined') {
  SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
  if (typeof value === 'string') {
    value = value.split(' ');
  }

  return value;
}
/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */

function addClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    if (classList.indexOf(newClass) === -1) {
      classList.push(newClass);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */

function removeClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    var index = classList.indexOf(newClass);

    if (index !== -1) {
      classList.splice(index, 1);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

var DEFAULT_OPTIONS = {
  container: false,
  delay: 0,
  html: false,
  placement: 'top',
  title: '',
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  trigger: 'hover focus',
  offset: 0
};
var openTooltips = [];

var Tooltip =
/*#__PURE__*/
function () {
  /**
   * Create a new Tooltip.js instance
   * @class Tooltip
   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
   * @param {Object} options
   * @param {String} options.placement=bottom
   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
   *      left(-start, -end)`
   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
   * @param {Number|Object} options.delay=0
   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
   *      If a number is supplied, delay is applied to both hide/show.
   *      Object structure is: `{ show: 500, hide: 100 }`
   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
   *      Base HTML to used when creating the tooltip.
   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
   *      The outermost wrapper element should have the `.tooltip` class.
   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
   * @param {String} [options.trigger='hover focus']
   *      How tooltip is triggered - click, hover, focus, manual.
   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
   * @param {HTMLElement} options.boundariesElement
   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
   *      [offset docs](https://popper.js.org/popper-documentation.html)
   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
   *      [options docs](https://popper.js.org/popper-documentation.html)
   * @return {Object} instance - The generated tooltip instance
   */
  function Tooltip(_reference, _options) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    _defineProperty(this, "_events", []);

    _defineProperty(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
      var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

      var callback = function callback(evt2) {
        var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

        _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element


        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this._scheduleHide(reference, options.delay, options, evt2);
        }
      };

      if (_this._tooltipNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        _this._tooltipNode.addEventListener(evt.type, callback);

        return true;
      }

      return false;
    });

    // apply user options over default ones
    _options = _objectSpread({}, DEFAULT_OPTIONS, _options);
    _reference.jquery && (_reference = _reference[0]);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this); // cache reference and options

    this.reference = _reference;
    this.options = _options; // set initial state

    this._isOpen = false;

    this._init();
  } //
  // Public methods
  //

  /**
   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
   * Tooltips with zero-length titles are never displayed.
   * @method Tooltip#show
   * @memberof Tooltip
   */


  _createClass(Tooltip, [{
    key: "show",
    value: function show() {
      this._show(this.reference, this.options);
    }
    /**
     * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#hide
     * @memberof Tooltip
     */

  }, {
    key: "hide",
    value: function hide() {
      this._hide();
    }
    /**
     * Hides and destroys an element’s tooltip.
     * @method Tooltip#dispose
     * @memberof Tooltip
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#toggle
     * @memberof Tooltip
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isOpen) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classes) {
      this._classes = classes;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.options.title = content;

      if (this._tooltipNode) {
        this._setContent(content, this.options);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var classesUpdated = false;
      var classes = options && options.classes || directive.options.defaultClass;

      if (this._classes !== classes) {
        this.setClasses(classes);
        classesUpdated = true;
      }

      options = getOptions(options);
      var needPopperUpdate = false;
      var needRestart = false;

      if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
        needPopperUpdate = true;
      }

      if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
        needRestart = true;
      }

      for (var key in options) {
        this.options[key] = options[key];
      }

      if (this._tooltipNode) {
        if (needRestart) {
          var isOpen = this._isOpen;
          this.dispose();

          this._init();

          if (isOpen) {
            this.show();
          }
        } else if (needPopperUpdate) {
          this.popperInstance.update();
        }
      }
    } //
    // Private methods
    //

  }, {
    key: "_init",
    value: function _init() {
      // get events list
      var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
      this._isDisposed = false;
      this._enableDocumentTouch = events.indexOf('manual') === -1;
      events = events.filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }); // set event listeners

      this._setEventListeners(this.reference, events, this.options); // title attribute


      this.$_originalTitle = this.reference.getAttribute('title');
      this.reference.removeAttribute('title');
      this.reference.setAttribute('data-original-title', this.$_originalTitle);
    }
    /**
     * Creates a new tooltip node
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} reference
     * @param {String} template
     * @param {String|HTMLElement|TitleFunction} title
     * @param {Boolean} allowHtml
     * @return {HTMLelement} tooltipNode
     */

  }, {
    key: "_create",
    value: function _create(reference, template) {
      // create tooltip element
      var tooltipGenerator = window.document.createElement('div');
      tooltipGenerator.innerHTML = template.trim();
      var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

      tooltipNode.id = "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
      // The attribute will be switched in a next frame so
      // CSS transitions can play

      tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
        tooltipNode.addEventListener('mouseenter', this.hide);
        tooltipNode.addEventListener('click', this.hide);
      } // return the generated tooltip node


      return tooltipNode;
    }
  }, {
    key: "_setContent",
    value: function _setContent(content, options) {
      var _this2 = this;

      this.asyncContent = false;

      this._applyContent(content, options).then(function () {
        _this2.popperInstance.update();
      });
    }
  }, {
    key: "_applyContent",
    value: function _applyContent(title, options) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var allowHtml = options.html;
        var rootNode = _this3._tooltipNode;
        if (!rootNode) return;
        var titleNode = rootNode.querySelector(_this3.options.innerSelector);

        if (title.nodeType === 1) {
          // if title is a node, append it only if allowHtml is true
          if (allowHtml) {
            while (titleNode.firstChild) {
              titleNode.removeChild(titleNode.firstChild);
            }

            titleNode.appendChild(title);
          }
        } else if (typeof title === 'function') {
          // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
          var result = title();

          if (result && typeof result.then === 'function') {
            _this3.asyncContent = true;
            options.loadingClass && addClasses(rootNode, options.loadingClass);

            if (options.loadingContent) {
              _this3._applyContent(options.loadingContent, options);
            }

            result.then(function (asyncResult) {
              options.loadingClass && removeClasses(rootNode, options.loadingClass);
              return _this3._applyContent(asyncResult, options);
            }).then(resolve).catch(reject);
          } else {
            _this3._applyContent(result, options).then(resolve).catch(reject);
          }

          return;
        } else {
          // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
          allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
        }

        resolve();
      });
    }
  }, {
    key: "_show",
    value: function _show(reference, options) {
      if (options && typeof options.container === 'string') {
        var container = document.querySelector(options.container);
        if (!container) return;
      }

      clearTimeout(this._disposeTimer);
      options = Object.assign({}, options);
      delete options.offset;
      var updateClasses = true;

      if (this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
        updateClasses = false;
      }

      var result = this._ensureShown(reference, options);

      if (updateClasses && this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
      }

      addClasses(reference, ['v-tooltip-open']);
      return result;
    }
  }, {
    key: "_ensureShown",
    value: function _ensureShown(reference, options) {
      var _this4 = this;

      // don't show if it's already visible
      if (this._isOpen) {
        return this;
      }

      this._isOpen = true;
      openTooltips.push(this); // if the tooltipNode already exists, just show it

      if (this._tooltipNode) {
        this._tooltipNode.style.display = '';

        this._tooltipNode.setAttribute('aria-hidden', 'false');

        this.popperInstance.enableEventListeners();
        this.popperInstance.update();

        if (this.asyncContent) {
          this._setContent(options.title, options);
        }

        return this;
      } // get title


      var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

      if (!title) {
        return this;
      } // create tooltip node


      var tooltipNode = this._create(reference, options.template);

      this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

      reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

      var container = this._findContainer(options.container, reference);

      this._append(tooltipNode, container);

      var popperOptions = _objectSpread({}, options.popperOptions, {
        placement: options.placement
      });

      popperOptions.modifiers = _objectSpread({}, popperOptions.modifiers, {
        arrow: {
          element: this.options.arrowSelector
        }
      });

      if (options.boundariesElement) {
        popperOptions.modifiers.preventOverflow = {
          boundariesElement: options.boundariesElement
        };
      }

      this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](reference, tooltipNode, popperOptions);

      this._setContent(title, options); // Fix position


      requestAnimationFrame(function () {
        if (!_this4._isDisposed && _this4.popperInstance) {
          _this4.popperInstance.update(); // Show the tooltip


          requestAnimationFrame(function () {
            if (!_this4._isDisposed) {
              _this4._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
            } else {
              _this4.dispose();
            }
          });
        } else {
          _this4.dispose();
        }
      });
      return this;
    }
  }, {
    key: "_noLongerOpen",
    value: function _noLongerOpen() {
      var index = openTooltips.indexOf(this);

      if (index !== -1) {
        openTooltips.splice(index, 1);
      }
    }
  }, {
    key: "_hide",
    value: function _hide()
    /* reference, options */
    {
      var _this5 = this;

      // don't hide if it's already hidden
      if (!this._isOpen) {
        return this;
      }

      this._isOpen = false;

      this._noLongerOpen(); // hide tooltipNode


      this._tooltipNode.style.display = 'none';

      this._tooltipNode.setAttribute('aria-hidden', 'true');

      this.popperInstance.disableEventListeners();
      clearTimeout(this._disposeTimer);
      var disposeTime = directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this._disposeTimer = setTimeout(function () {
          if (_this5._tooltipNode) {
            _this5._tooltipNode.removeEventListener('mouseenter', _this5.hide);

            _this5._tooltipNode.removeEventListener('click', _this5.hide); // Don't remove popper instance, just the HTML element


            _this5._removeTooltipNode();
          }
        }, disposeTime);
      }

      removeClasses(this.reference, ['v-tooltip-open']);
      return this;
    }
  }, {
    key: "_removeTooltipNode",
    value: function _removeTooltipNode() {
      if (!this._tooltipNode) return;
      var parentNode = this._tooltipNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(this._tooltipNode);
        this.reference.removeAttribute('aria-describedby');
      }

      this._tooltipNode = null;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this6 = this;

      this._isDisposed = true;
      this.reference.removeAttribute('data-original-title');

      if (this.$_originalTitle) {
        this.reference.setAttribute('title', this.$_originalTitle);
      } // remove event listeners first to prevent any unexpected behaviour


      this._events.forEach(function (_ref) {
        var func = _ref.func,
            event = _ref.event;

        _this6.reference.removeEventListener(event, func);
      });

      this._events = [];

      if (this._tooltipNode) {
        this._hide();

        this._tooltipNode.removeEventListener('mouseenter', this.hide);

        this._tooltipNode.removeEventListener('click', this.hide); // destroy instance


        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          this._removeTooltipNode();
        }
      } else {
        this._noLongerOpen();
      }

      return this;
    }
  }, {
    key: "_findContainer",
    value: function _findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    }
    /**
     * Append tooltip to container
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} tooltip
     * @param {HTMLElement|String|false} container
     */

  }, {
    key: "_append",
    value: function _append(tooltipNode, container) {
      container.appendChild(tooltipNode);
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(reference, events, options) {
      var _this7 = this;

      var directEvents = [];
      var oppositeEvents = [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            if (_this7.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            if (_this7.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(evt) {
          if (_this7._isOpen === true) {
            return;
          }

          evt.usedByTooltip = true;

          _this7._scheduleShow(reference, options.delay, options, evt);
        };

        _this7._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(evt) {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this7._scheduleHide(reference, options.delay, options, evt);
        };

        _this7._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    }
  }, {
    key: "_onDocumentTouch",
    value: function _onDocumentTouch(event) {
      if (this._enableDocumentTouch) {
        this._scheduleHide(this.reference, this.options.delay, this.options, event);
      }
    }
  }, {
    key: "_scheduleShow",
    value: function _scheduleShow(reference, delay, options
    /*, evt */
    ) {
      var _this8 = this;

      // defaults to 0
      var computedDelay = delay && delay.show || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        return _this8._show(reference, options);
      }, computedDelay);
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide(reference, delay, options, evt) {
      var _this9 = this;

      // defaults to 0
      var computedDelay = delay && delay.hide || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        if (_this9._isOpen === false) {
          return;
        }

        if (!document.body.contains(_this9._tooltipNode)) {
          return;
        } // if we are hiding because of a mouseleave, we must check that the new
        // reference isn't the tooltip, because in this case we don't want to hide it


        if (evt.type === 'mouseleave') {
          var isSet = _this9._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
          // the new event will take care to hide it if necessary


          if (isSet) {
            return;
          }
        }

        _this9._hide(reference, options);
      }, computedDelay);
    }
  }]);

  return Tooltip;
}(); // Hide tooltips on touch devices

if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function (event) {
    for (var i = 0; i < openTooltips.length; i++) {
      openTooltips[i]._onDocumentTouch(event);
    }
  }, supportsPassive ? {
    passive: true,
    capture: true
  } : true);
}
/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */

var state = {
  enabled: true
};
var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
var defaultOptions = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'top',
  // Default CSS classes applied to the tooltip element
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover focus',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: true,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: true,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5000,
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    // Class added when popover is open
    defaultOpenClass: 'open',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true
  }
};
function getOptions(options) {
  var result = {
    placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
    delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
    html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
    template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
    arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
    innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
    trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
    offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
    container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
    boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
    autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
    hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
    loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
    loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
    popperOptions: _objectSpread({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
  };

  if (result.offset) {
    var typeofOffset = _typeof(result.offset);

    var offset = result.offset; // One value -> switch

    if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
      offset = "0, ".concat(offset);
    }

    if (!result.popperOptions.modifiers) {
      result.popperOptions.modifiers = {};
    }

    result.popperOptions.modifiers.offset = {
      offset: offset
    };
  }

  if (result.trigger && result.trigger.indexOf('click') !== -1) {
    result.hideOnTargetClick = false;
  }

  return result;
}
function getPlacement(value, modifiers) {
  var placement = value.placement;

  for (var i = 0; i < positions.length; i++) {
    var pos = positions[i];

    if (modifiers[pos]) {
      placement = pos;
    }
  }

  return placement;
}
function getContent(value) {
  var type = _typeof(value);

  if (type === 'string') {
    return value;
  } else if (value && type === 'object') {
    return value.content;
  } else {
    return false;
  }
}
function createTooltip(el, value) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = getContent(value);
  var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;

  var opts = _objectSpread({
    title: content
  }, getOptions(_objectSpread({}, value, {
    placement: getPlacement(value, modifiers)
  })));

  var tooltip = el._tooltip = new Tooltip(el, opts);
  tooltip.setClasses(classes);
  tooltip._vueEl = el; // Class on target

  var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
  el._tooltipTargetClasses = targetClasses;
  addClasses(el, targetClasses);
  return tooltip;
}
function destroyTooltip(el) {
  if (el._tooltip) {
    el._tooltip.dispose();

    delete el._tooltip;
    delete el._tooltipOldShow;
  }

  if (el._tooltipTargetClasses) {
    removeClasses(el, el._tooltipTargetClasses);
    delete el._tooltipTargetClasses;
  }
}
function bind(el, _ref) {
  var value = _ref.value,
      oldValue = _ref.oldValue,
      modifiers = _ref.modifiers;
  var content = getContent(value);

  if (!content || !state.enabled) {
    destroyTooltip(el);
  } else {
    var tooltip;

    if (el._tooltip) {
      tooltip = el._tooltip; // Content

      tooltip.setContent(content); // Options

      tooltip.setOptions(_objectSpread({}, value, {
        placement: getPlacement(value, modifiers)
      }));
    } else {
      tooltip = createTooltip(el, value, modifiers);
    } // Manual show


    if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
      el._tooltipOldShow = value.show;
      value.show ? tooltip.show() : tooltip.hide();
    }
  }
}
var directive = {
  options: defaultOptions,
  bind: bind,
  update: bind,
  unbind: function unbind(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener('click', onClick);
  el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener('click', onClick);
  el.removeEventListener('touchstart', onTouchStart);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var vclosepopover = {
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === 'undefined' || value) {
      addListeners(el);
    }
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue,
        modifiers = _ref2.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === 'undefined' || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind: function unbind(el) {
    removeListeners(el);
  }
};

function getDefault(key) {
  var value = directive.options.popover[key];

  if (typeof value === 'undefined') {
    return directive.options[key];
  }

  return value;
}

var isIOS = false;

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};

if (typeof window !== 'undefined') {
  Element = window.Element;
}

var script = {
  name: 'VPopover',
  components: {
    ResizeObserver: vue_resize__WEBPACK_IMPORTED_MODULE_1__[/* ResizeObserver */ "a"]
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: function _default() {
        return getDefault('defaultPlacement');
      }
    },
    delay: {
      type: [String, Number, Object],
      default: function _default() {
        return getDefault('defaultDelay');
      }
    },
    offset: {
      type: [String, Number],
      default: function _default() {
        return getDefault('defaultOffset');
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return getDefault('defaultTrigger');
      }
    },
    container: {
      type: [String, Object, Element, Boolean],
      default: function _default() {
        return getDefault('defaultContainer');
      }
    },
    boundariesElement: {
      type: [String, Element],
      default: function _default() {
        return getDefault('defaultBoundariesElement');
      }
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return getDefault('defaultPopperOptions');
      }
    },
    popoverClass: {
      type: [String, Array],
      default: function _default() {
        return getDefault('defaultClass');
      }
    },
    popoverBaseClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultBaseClass;
      }
    },
    popoverInnerClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultInnerClass;
      }
    },
    popoverWrapperClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultWrapperClass;
      }
    },
    popoverArrowClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultArrowClass;
      }
    },
    autoHide: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultAutoHide;
      }
    },
    handleResize: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultHandleResize;
      }
    },
    openGroup: {
      type: String,
      default: null
    },
    openClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultOpenClass;
      }
    }
  },
  data: function data() {
    return {
      isOpen: false,
      id: Math.random().toString(36).substr(2, 10)
    };
  },
  computed: {
    cssClass: function cssClass() {
      return _defineProperty({}, this.openClass, this.isOpen);
    },
    popoverId: function popoverId() {
      return "popover_".concat(this.id);
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
    disabled: function disabled(val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.hide();
        } else if (this.open) {
          this.show();
        }
      }
    },
    container: function container(val) {
      if (this.isOpen && this.popperInstance) {
        var popoverNode = this.$refs.popover;
        var reference = this.$refs.trigger;
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.popperInstance.scheduleUpdate();
      }
    },
    trigger: function trigger(val) {
      this.$_removeEventListeners();
      this.$_addEventListeners();
    },
    placement: function placement(val) {
      var _this = this;

      this.$_updatePopper(function () {
        _this.popperInstance.options.placement = val;
      });
    },
    offset: '$_restartPopper',
    boundariesElement: '$_restartPopper',
    popperOptions: {
      handler: '$_restartPopper',
      deep: true
    }
  },
  created: function created() {
    this.$_isDisposed = false;
    this.$_mounted = false;
    this.$_events = [];
    this.$_preventOpen = false;
  },
  mounted: function mounted() {
    var popoverNode = this.$refs.popover;
    popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
    this.$_init();

    if (this.open) {
      this.show();
    }
  },
  deactivated: function deactivated() {
    this.hide();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref2.event,
          _ref2$skipDelay = _ref2.skipDelay,
          _ref2$force = _ref2.force,
          force = _ref2$force === void 0 ? false : _ref2$force;

      if (force || !this.disabled) {
        this.$_scheduleShow(event);
        this.$emit('show');
      }

      this.$emit('update:open', true);
      this.$_beingShowed = true;
      requestAnimationFrame(function () {
        _this2.$_beingShowed = false;
      });
    },
    hide: function hide() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref3.event,
          _ref3$skipDelay = _ref3.skipDelay;

      this.$_scheduleHide(event);
      this.$emit('hide');
      this.$emit('update:open', false);
    },
    dispose: function dispose() {
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({
        skipDelay: true
      });

      if (this.popperInstance) {
        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
        }
      }

      this.$_mounted = false;
      this.popperInstance = null;
      this.isOpen = false;
      this.$emit('dispose');
    },
    $_init: function $_init() {
      if (this.trigger.indexOf('manual') === -1) {
        this.$_addEventListeners();
      }
    },
    $_show: function $_show() {
      var _this3 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      clearTimeout(this.$_disposeTimer); // Already open

      if (this.isOpen) {
        return;
      } // Popper is already initialized


      if (this.popperInstance) {
        this.isOpen = true;
        this.popperInstance.enableEventListeners();
        this.popperInstance.scheduleUpdate();
      }

      if (!this.$_mounted) {
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.$_mounted = true;
      }

      if (!this.popperInstance) {
        var popperOptions = _objectSpread({}, this.popperOptions, {
          placement: this.placement
        });

        popperOptions.modifiers = _objectSpread({}, popperOptions.modifiers, {
          arrow: _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow, {
            element: this.$refs.arrow
          })
        });

        if (this.offset) {
          var offset = this.$_getOffset();
          popperOptions.modifiers.offset = _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset, {
            offset: offset
          });
        }

        if (this.boundariesElement) {
          popperOptions.modifiers.preventOverflow = _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow, {
            boundariesElement: this.boundariesElement
          });
        }

        this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](reference, popoverNode, popperOptions); // Fix position

        requestAnimationFrame(function () {
          if (_this3.hidden) {
            _this3.hidden = false;

            _this3.$_hide();

            return;
          }

          if (!_this3.$_isDisposed && _this3.popperInstance) {
            _this3.popperInstance.scheduleUpdate(); // Show the tooltip


            requestAnimationFrame(function () {
              if (_this3.hidden) {
                _this3.hidden = false;

                _this3.$_hide();

                return;
              }

              if (!_this3.$_isDisposed) {
                _this3.isOpen = true;
              } else {
                _this3.dispose();
              }
            });
          } else {
            _this3.dispose();
          }
        });
      }

      var openGroup = this.openGroup;

      if (openGroup) {
        var popover;

        for (var i = 0; i < openPopovers.length; i++) {
          popover = openPopovers[i];

          if (popover.openGroup !== openGroup) {
            popover.hide();
            popover.$emit('close-group');
          }
        }
      }

      openPopovers.push(this);
      this.$emit('apply-show');
    },
    $_hide: function $_hide() {
      var _this4 = this;

      // Already hidden
      if (!this.isOpen) {
        return;
      }

      var index = openPopovers.indexOf(this);

      if (index !== -1) {
        openPopovers.splice(index, 1);
      }

      this.isOpen = false;

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this.$_disposeTimer);
      var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(function () {
          var popoverNode = _this4.$refs.popover;

          if (popoverNode) {
            // Don't remove popper instance, just the HTML element
            popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
            _this4.$_mounted = false;
          }
        }, disposeTime);
      }

      this.$emit('apply-hide');
    },
    $_findContainer: function $_findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    },
    $_getOffset: function $_getOffset() {
      var typeofOffset = _typeof(this.offset);

      var offset = this.offset; // One value -> switch

      if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
        offset = "0, ".concat(offset);
      }

      return offset;
    },
    $_addEventListeners: function $_addEventListeners() {
      var _this5 = this;

      var reference = this.$refs.trigger;
      var directEvents = [];
      var oppositeEvents = [];
      var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }) : [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(event) {
          if (_this5.isOpen) {
            return;
          }

          event.usedByTooltip = true;
          !_this5.$_preventOpen && _this5.show({
            event: event
          });
          _this5.hidden = false;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this5.hide({
            event: event
          });

          _this5.hidden = true;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    },
    $_scheduleShow: function $_scheduleShow() {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_show();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
        this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
      }
    },
    $_scheduleHide: function $_scheduleHide() {
      var _this6 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_hide();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
        this.$_scheduleTimer = setTimeout(function () {
          if (!_this6.isOpen) {
            return;
          } // if we are hiding because of a mouseleave, we must check that the new
          // reference isn't the tooltip, because in this case we don't want to hide it


          if (event && event.type === 'mouseleave') {
            var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
            // the new event will take care to hide it if necessary


            if (isSet) {
              return;
            }
          }

          _this6.$_hide();
        }, computedDelay);
      }
    },
    $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
      var _this7 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

      var callback = function callback(event2) {
        var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

        popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this7.hide({
            event: event2
          });
        }
      };

      if (popoverNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        popoverNode.addEventListener(event.type, callback);
        return true;
      }

      return false;
    },
    $_removeEventListeners: function $_removeEventListeners() {
      var reference = this.$refs.trigger;
      this.$_events.forEach(function (_ref4) {
        var func = _ref4.func,
            event = _ref4.event;
        reference.removeEventListener(event, func);
      });
      this.$_events = [];
    },
    $_updatePopper: function $_updatePopper(cb) {
      if (this.popperInstance) {
        cb();
        if (this.isOpen) this.popperInstance.scheduleUpdate();
      }
    },
    $_restartPopper: function $_restartPopper() {
      if (this.popperInstance) {
        var isOpen = this.isOpen;
        this.dispose();
        this.$_isDisposed = false;
        this.$_init();

        if (isOpen) {
          this.show({
            skipDelay: true,
            force: true
          });
        }
      }
    },
    $_handleGlobalClose: function $_handleGlobalClose(event) {
      var _this8 = this;

      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.$_beingShowed) return;
      this.hide({
        event: event
      });

      if (event.closePopover) {
        this.$emit('close-directive');
      } else {
        this.$emit('auto-hide');
      }

      if (touch) {
        this.$_preventOpen = true;
        setTimeout(function () {
          _this8.$_preventOpen = false;
        }, 300);
      }
    },
    $_handleResize: function $_handleResize() {
      if (this.isOpen && this.popperInstance) {
        this.popperInstance.scheduleUpdate();
        this.$emit('resize');
      }
    }
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (isIOS) {
    document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener('click', handleGlobalClick, true);
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _loop = function _loop(i) {
    var popover = openPopovers[i];

    if (popover.$refs.popover) {
      var contains = popover.$refs.popover.contains(event.target);
      requestAnimationFrame(function () {
        if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
          popover.$_handleGlobalClose(event, touch);
        }
      });
    }
  };

  // Delay so that close directive has time to set values
  for (var i = 0; i < openPopovers.length; i++) {
    _loop(i);
  }
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "v-popover",
    class: _vm.cssClass
  }, [_c("div", {
    ref: "trigger",
    staticClass: "trigger",
    staticStyle: {
      display: "inline-block"
    },
    attrs: {
      "aria-describedby": _vm.popoverId,
      tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    ref: "popover",
    class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
    style: {
      visibility: _vm.isOpen ? "visible" : "hidden"
    },
    attrs: {
      id: _vm.popoverId,
      "aria-hidden": _vm.isOpen ? "false" : "true",
      tabindex: _vm.autoHide ? 0 : undefined
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.autoHide && _vm.hide();
      }
    }
  }, [_c("div", {
    class: _vm.popoverWrapperClass
  }, [_c("div", {
    ref: "inner",
    class: _vm.popoverInnerClass,
    staticStyle: {
      position: "relative"
    }
  }, [_c("div", [_vm._t("popover")], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
    on: {
      notify: _vm.$_handleResize
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    ref: "arrow",
    class: _vm.popoverArrowClass
  })])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Popover = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    if (isObject_1(srcValue)) {
      stack || (stack = new _Stack);
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".resize-observer[data-v-b329ee4c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-b329ee4c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
styleInject(css);

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;
  var finalOptions = {};
  merge_1(finalOptions, defaultOptions, options);
  plugin.options = finalOptions;
  directive.options = finalOptions;
  Vue.directive('tooltip', directive);
  Vue.directive('close-popover', vclosepopover);
  Vue.component('v-popover', Popover);
}
var VTooltip = directive;
var VClosePopover = vclosepopover;
var VPopover = Popover;
var plugin = {
  install: install,

  get enabled() {
    return state.enabled;
  },

  set enabled(value) {
    state.enabled = value;
  }

}; // Auto-install

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "e380":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("7b83");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "e3f5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-progress[data-v-a3cb868a]{-webkit-transform:scaleX(-1) rotate(-90deg);transform:scaleX(-1) rotate(-90deg)}.ui-progress .placeholder-arc[data-v-a3cb868a]{stroke:var(--c-black--opacity-10)}", ""]);


/***/ }),

/***/ "e3f8":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("656b");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "e402":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ebbb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("e257ac66", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e4a3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-switch-list[data-v-fec25b6a]:not(.spacious)>:not(:last-child){margin-bottom:.25rem}.ui-switch-list.spacious[data-v-fec25b6a]>:not(:last-child){margin-bottom:.5rem}", ""]);


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("2b3e");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "e583":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var trim = __webpack_require__("58a8").trim;
var whitespaces = __webpack_require__("5899");

var nativeParseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return nativeParseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : nativeParseInt;


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e692":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_id_1f3adc3a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9788");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_id_1f3adc3a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_id_1f3adc3a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_id_1f3adc3a_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var isObject = __webpack_require__("861d");
var aFunction = __webpack_require__("1c0b");
var anInstance = __webpack_require__("19aa");
var classof = __webpack_require__("c6b6");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("60ae");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "eac5":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "eae9":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "eb92":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-list>.footer[data-v-2fabe444]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:.5rem}.ui-list[data-v-2fabe444],.ui-list>.item[data-v-2fabe444]{outline:none}.ui-list.compact[data-v-2fabe444]>:not(:last-child){margin-bottom:0}.ui-list.spacious[data-v-2fabe444]>:not(:last-child){margin-bottom:.25rem}", ""]);


/***/ }),

/***/ "ebbb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".fade-enter-active[data-v-001c5c02],.fade-leave-active[data-v-001c5c02]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.2s;transition-duration:.2s}.fade-enter[data-v-001c5c02],.fade-leave-to[data-v-001c5c02]{opacity:0}.ui-checkbox[data-v-001c5c02]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui-checkbox input[data-v-001c5c02]{position:absolute;opacity:0;height:0;width:0;margin:0;padding:0}.ui-checkbox .checkbox[data-v-001c5c02]{border-radius:100%;-webkit-transition:.1s;transition:.1s;position:relative}.ui-checkbox .checkbox .avatar[data-v-001c5c02]{position:absolute;width:100%;height:100%;top:0;left:0;z-index:1}.ui-checkbox .checkbox .icon[data-v-001c5c02],.ui-checkbox .checkbox .progress[data-v-001c5c02]{position:absolute;-webkit-transition:.1s;transition:.1s}.ui-checkbox .checkbox .icon[data-v-001c5c02]{font-weight:900;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.ui-checkbox .checkbox.interactable[data-v-001c5c02]{cursor:pointer}.ui-checkbox .checkbox.small .icon[data-v-001c5c02]{font-size:.375rem}.ui-checkbox .checkbox.medium .icon[data-v-001c5c02]{font-size:.5rem}.ui-checkbox .checkbox.no-progress[data-v-001c5c02]{background-color:var(--c-black--opacity-10)}.ui-checkbox .checkbox.no-progress.interactable[data-v-001c5c02]:hover{background-color:var(--c-black--opacity-15)}.ui-checkbox .checkbox.show-progress[data-v-001c5c02]{background:none}.ui-checkbox .checkbox.show-progress.interactable[data-v-001c5c02]:hover{background-color:var(--c-black--opacity-15)}.ui-checkbox .checkbox.checked.default-color[data-v-001c5c02],.ui-checkbox .checkbox.checked.default-color.interactable[data-v-001c5c02]:hover{background-color:var(--c-primary)}.ui-checkbox .checkbox.checked.success[data-v-001c5c02],.ui-checkbox .checkbox.checked.success.interactable[data-v-001c5c02]:hover{background-color:var(--c-success)}.ui-checkbox .checkbox.checked.danger[data-v-001c5c02],.ui-checkbox .checkbox.checked.danger.interactable[data-v-001c5c02]:hover{background-color:var(--c-danger)}.ui-checkbox .checkbox.checked.light[data-v-001c5c02]{background-color:#fff}.ui-checkbox .checkbox.checked.light.interactable[data-v-001c5c02]:hover{background-color:hsla(0,0%,100%,.7)}.ui-checkbox .checkbox.checked .icon[data-v-001c5c02]{color:#fff}.ui-checkbox .checkbox.show-progress .icon[data-v-001c5c02]{opacity:0}.ui-checkbox .checkbox.show-progress.checked .icon[data-v-001c5c02],.ui-checkbox .checkbox:hover .icon[data-v-001c5c02]{opacity:1}.ui-checkbox .checkbox.checked .progress[data-v-001c5c02],.ui-checkbox .checkbox:hover .progress[data-v-001c5c02]{opacity:0}.ui-checkbox .checkbox.disabled[data-v-001c5c02]{opacity:.5;cursor:not-allowed}", ""]);


/***/ }),

/***/ "ec47":
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__("a3fd"),
    getTag = __webpack_require__("42a2"),
    mapToArray = __webpack_require__("edfa"),
    setToPairs = __webpack_require__("cebd");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),

/***/ "ec69":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("6fcd"),
    baseKeys = __webpack_require__("03dd"),
    isArrayLike = __webpack_require__("30c9");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "ec8c":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "edfa":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "eed6":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("2c66");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "ef5d":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "efb6":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "efbb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eb92");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7c452f58", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f112":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 144);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(142);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(115);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(111);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(33)('wks');
var uid = __webpack_require__(24);
var Symbol = __webpack_require__(7).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(57);
var toPrimitive = __webpack_require__(40);
var dP = Object.defineProperty;

exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(133);
var defined = __webpack_require__(38);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(22)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(4);
var ctx = __webpack_require__(41);
var hide = __webpack_require__(14);
var has = __webpack_require__(9);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(21);
module.exports = __webpack_require__(10) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SensorEvent = __webpack_require__(68);

Object.keys(_SensorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SensorEvent[key];
    }
  });
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(71);

var _Sensor2 = _interopRequireDefault(_Sensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sensor2.default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closest = __webpack_require__(75);

Object.defineProperty(exports, 'closest', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_closest).default;
  }
});

var _requestNextAnimationFrame = __webpack_require__(73);

Object.defineProperty(exports, 'requestNextAnimationFrame', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_requestNextAnimationFrame).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(91);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractEvent = __webpack_require__(108);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AbstractEvent2.default;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractPlugin = __webpack_require__(94);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AbstractPlugin2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(27);
var createDesc = __webpack_require__(21);
var toIObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(40);
var has = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(57);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(4);
var LIBRARY = __webpack_require__(25);
var wksExt = __webpack_require__(29);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(38);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(9);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(4);
var global = __webpack_require__(7);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(25) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(33)('keys');
var uid = __webpack_require__(24);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(51);
var enumBugKeys = __webpack_require__(32);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(13);
var dPs = __webpack_require__(134);
var enumBugKeys = __webpack_require__(32);
var IE_PROTO = __webpack_require__(34)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(56)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(130).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(139);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(16);

Object.defineProperty(exports, 'Sensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sensor).default;
  }
});

var _MouseSensor = __webpack_require__(70);

Object.defineProperty(exports, 'MouseSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MouseSensor).default;
  }
});

var _TouchSensor = __webpack_require__(67);

Object.defineProperty(exports, 'TouchSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TouchSensor).default;
  }
});

var _DragSensor = __webpack_require__(65);

Object.defineProperty(exports, 'DragSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSensor).default;
  }
});

var _ForceTouchSensor = __webpack_require__(63);

Object.defineProperty(exports, 'ForceTouchSensor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ForceTouchSensor).default;
  }
});

var _SensorEvent = __webpack_require__(15);

Object.keys(_SensorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SensorEvent[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Announcement = __webpack_require__(96);

Object.defineProperty(exports, 'Announcement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Announcement).default;
  }
});
Object.defineProperty(exports, 'defaultAnnouncementOptions', {
  enumerable: true,
  get: function get() {
    return _Announcement.defaultOptions;
  }
});

var _Focusable = __webpack_require__(93);

Object.defineProperty(exports, 'Focusable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Focusable).default;
  }
});

var _Mirror = __webpack_require__(82);

Object.defineProperty(exports, 'Mirror', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mirror).default;
  }
});
Object.defineProperty(exports, 'defaultMirrorOptions', {
  enumerable: true,
  get: function get() {
    return _Mirror.defaultOptions;
  }
});

var _Scrollable = __webpack_require__(77);

Object.defineProperty(exports, 'Scrollable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Scrollable).default;
  }
});
Object.defineProperty(exports, 'defaultScrollableOptions', {
  enumerable: true,
  get: function get() {
    return _Scrollable.defaultOptions;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DraggableEvent = __webpack_require__(97);

Object.keys(_DraggableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DraggableEvent[key];
    }
  });
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragEvent = __webpack_require__(98);

Object.keys(_DragEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DragEvent[key];
    }
  });
});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(11);
var core = __webpack_require__(4);
var fails = __webpack_require__(22);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(51);
var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(9);
var toObject = __webpack_require__(30);
var IE_PROTO = __webpack_require__(34)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(39);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(9);
var toIObject = __webpack_require__(8);
var arrayIndexOf = __webpack_require__(132)(false);
var IE_PROTO = __webpack_require__(34)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(25);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(52);
var hide = __webpack_require__(14);
var Iterators = __webpack_require__(20);
var $iterCreate = __webpack_require__(135);
var setToStringTag = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(49);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(136)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(53)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(138);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(125);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(7).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(10) && !__webpack_require__(22)(function () {
  return Object.defineProperty(__webpack_require__(56)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableEvent = __webpack_require__(143);

Object.keys(_SortableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SortableEvent[key];
    }
  });
});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Emitter is a simple emitter class that provides you with `on()`, `off()` and `trigger()` methods
 * @class Emitter
 * @module Emitter
 */
var Emitter = function () {
  function Emitter() {
    (0, _classCallCheck3.default)(this, Emitter);

    this.callbacks = {};
  }

  /**
   * Registers callbacks by event name
   * @param {String} type
   * @param {...Function} callbacks
   */


  (0, _createClass3.default)(Emitter, [{
    key: "on",
    value: function on(type) {
      var _callbacks$type;

      if (!this.callbacks[type]) {
        this.callbacks[type] = [];
      }

      for (var _len = arguments.length, callbacks = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        callbacks[_key - 1] = arguments[_key];
      }

      (_callbacks$type = this.callbacks[type]).push.apply(_callbacks$type, callbacks);

      return this;
    }

    /**
     * Unregisters callbacks by event name
     * @param {String} type
     * @param {Function} callback
     */

  }, {
    key: "off",
    value: function off(type, callback) {
      if (!this.callbacks[type]) {
        return null;
      }

      var copy = this.callbacks[type].slice(0);

      for (var i = 0; i < copy.length; i++) {
        if (callback === copy[i]) {
          this.callbacks[type].splice(i, 1);
        }
      }

      return this;
    }

    /**
     * Triggers event callbacks by event object
     * @param {AbstractEvent} event
     */

  }, {
    key: "trigger",
    value: function trigger(event) {
      if (!this.callbacks[event.type]) {
        return null;
      }

      var callbacks = [].concat((0, _toConsumableArray3.default)(this.callbacks[event.type]));
      var caughtErrors = [];

      for (var i = callbacks.length - 1; i >= 0; i--) {
        var callback = callbacks[i];

        try {
          callback(event);
        } catch (error) {
          caughtErrors.push(error);
        }
      }

      if (caughtErrors.length) {
        /* eslint-disable no-console */
        console.error("Draggable caught errors while triggering '" + event.type + "'", caughtErrors);
        /* eslint-disable no-console */
      }

      return this;
    }
  }]);
  return Emitter;
}();

exports.default = Emitter;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Emitter = __webpack_require__(59);

var _Emitter2 = _interopRequireDefault(_Emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Emitter2.default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = __webpack_require__(17);

var _Plugins = __webpack_require__(43);

var _Emitter = __webpack_require__(60);

var _Emitter2 = _interopRequireDefault(_Emitter);

var _Sensors = __webpack_require__(42);

var _DraggableEvent = __webpack_require__(44);

var _DragEvent = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = Symbol('onDragStart');
var onDragMove = Symbol('onDragMove');
var onDragStop = Symbol('onDragStop');
var onDragPressure = Symbol('onDragPressure');

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['drag:start']
 * @const {Function} defaultAnnouncements['drag:stop']
 */
var defaultAnnouncements = {
  'drag:start': function dragStart(event) {
    return 'Picked up ' + (event.source.textContent.trim() || event.source.id || 'draggable element');
  },
  'drag:stop': function dragStop(event) {
    return 'Released ' + (event.source.textContent.trim() || event.source.id || 'draggable element');
  }
};

var defaultClasses = {
  'container:dragging': 'draggable-container--is-dragging',
  'source:dragging': 'draggable-source--is-dragging',
  'source:placed': 'draggable-source--placed',
  'container:placed': 'draggable-container--placed',
  'body:dragging': 'draggable--is-dragging',
  'draggable:over': 'draggable--over',
  'container:over': 'draggable-container--over',
  'source:original': 'draggable--original',
  mirror: 'draggable-mirror'
};

var defaultOptions = exports.defaultOptions = {
  draggable: '.draggable-source',
  handle: null,
  delay: 100,
  placedTimeout: 800,
  plugins: [],
  sensors: []
};

/**
 * This is the core draggable library that does the heavy lifting
 * @class Draggable
 * @module Draggable
 */

var Draggable = function () {

  /**
   * Draggable constructor.
   * @constructs Draggable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Draggable containers
   * @param {Object} options - Options for draggable
   */
  function Draggable() {
    var _this = this;

    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [document.body];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Draggable);

    /**
     * Draggable containers
     * @property containers
     * @type {HTMLElement[]}
     */
    if (containers instanceof NodeList || containers instanceof Array) {
      this.containers = [].concat((0, _toConsumableArray3.default)(containers));
    } else if (containers instanceof HTMLElement) {
      this.containers = [containers];
    } else {
      throw new Error('Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`');
    }

    this.options = Object.assign({}, defaultOptions, options, {
      classes: Object.assign({}, defaultClasses, options.classes || {}),
      announcements: Object.assign({}, defaultAnnouncements, options.announcements || {})
    });

    /**
     * Draggables event emitter
     * @property emitter
     * @type {Emitter}
     */
    this.emitter = new _Emitter2.default();

    /**
     * Current drag state
     * @property dragging
     * @type {Boolean}
     */
    this.dragging = false;

    /**
     * Active plugins
     * @property plugins
     * @type {Plugin[]}
     */
    this.plugins = [];

    /**
     * Active sensors
     * @property sensors
     * @type {Sensor[]}
     */
    this.sensors = [];

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onDragPressure] = this[onDragPressure].bind(this);

    document.addEventListener('drag:start', this[onDragStart], true);
    document.addEventListener('drag:move', this[onDragMove], true);
    document.addEventListener('drag:stop', this[onDragStop], true);
    document.addEventListener('drag:pressure', this[onDragPressure], true);

    var defaultPlugins = Object.values(Draggable.Plugins).map(function (Plugin) {
      return Plugin;
    });
    var defaultSensors = [_Sensors.MouseSensor, _Sensors.TouchSensor];

    this.addPlugin.apply(this, [].concat((0, _toConsumableArray3.default)(defaultPlugins), (0, _toConsumableArray3.default)(this.options.plugins)));
    this.addSensor.apply(this, [].concat(defaultSensors, (0, _toConsumableArray3.default)(this.options.sensors)));

    var draggableInitializedEvent = new _DraggableEvent.DraggableInitializedEvent({
      draggable: this
    });

    this.on('mirror:created', function (_ref) {
      var mirror = _ref.mirror;
      return _this.mirror = mirror;
    });
    this.on('mirror:destroy', function () {
      return _this.mirror = null;
    });

    this.trigger(draggableInitializedEvent);
  }

  /**
   * Destroys Draggable instance. This removes all internal event listeners and
   * deactivates sensors and plugins
   */

  /**
   * Default plugins draggable uses
   * @static
   * @property {Object} Plugins
   * @property {Announcement} Plugins.Announcement
   * @property {Focusable} Plugins.Focusable
   * @property {Mirror} Plugins.Mirror
   * @property {Scrollable} Plugins.Scrollable
   * @type {Object}
   */


  (0, _createClass3.default)(Draggable, [{
    key: 'destroy',
    value: function destroy() {
      document.removeEventListener('drag:start', this[onDragStart], true);
      document.removeEventListener('drag:move', this[onDragMove], true);
      document.removeEventListener('drag:stop', this[onDragStop], true);
      document.removeEventListener('drag:pressure', this[onDragPressure], true);

      var draggableDestroyEvent = new _DraggableEvent.DraggableDestroyEvent({
        draggable: this
      });

      this.trigger(draggableDestroyEvent);

      this.removePlugin.apply(this, (0, _toConsumableArray3.default)(this.plugins.map(function (plugin) {
        return plugin.constructor;
      })));
      this.removeSensor.apply(this, (0, _toConsumableArray3.default)(this.sensors.map(function (sensor) {
        return sensor.constructor;
      })));
    }

    /**
     * Adds plugin to this draggable instance. This will end up calling the attach method of the plugin
     * @param {...typeof Plugin} plugins - Plugins that you want attached to draggable
     * @return {Draggable}
     * @example draggable.addPlugin(CustomA11yPlugin, CustomMirrorPlugin)
     */

  }, {
    key: 'addPlugin',
    value: function addPlugin() {
      var _this2 = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      var activePlugins = plugins.map(function (Plugin) {
        return new Plugin(_this2);
      });

      activePlugins.forEach(function (plugin) {
        return plugin.attach();
      });
      this.plugins = [].concat((0, _toConsumableArray3.default)(this.plugins), (0, _toConsumableArray3.default)(activePlugins));

      return this;
    }

    /**
     * Removes plugins that are already attached to this draggable instance. This will end up calling
     * the detach method of the plugin
     * @param {...typeof Plugin} plugins - Plugins that you want detached from draggable
     * @return {Draggable}
     * @example draggable.removePlugin(MirrorPlugin, CustomMirrorPlugin)
     */

  }, {
    key: 'removePlugin',
    value: function removePlugin() {
      for (var _len2 = arguments.length, plugins = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        plugins[_key2] = arguments[_key2];
      }

      var removedPlugins = this.plugins.filter(function (plugin) {
        return plugins.includes(plugin.constructor);
      });

      removedPlugins.forEach(function (plugin) {
        return plugin.detach();
      });
      this.plugins = this.plugins.filter(function (plugin) {
        return !plugins.includes(plugin.constructor);
      });

      return this;
    }

    /**
     * Adds sensors to this draggable instance. This will end up calling the attach method of the sensor
     * @param {...typeof Sensor} sensors - Sensors that you want attached to draggable
     * @return {Draggable}
     * @example draggable.addSensor(ForceTouchSensor, CustomSensor)
     */

  }, {
    key: 'addSensor',
    value: function addSensor() {
      var _this3 = this;

      for (var _len3 = arguments.length, sensors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        sensors[_key3] = arguments[_key3];
      }

      var activeSensors = sensors.map(function (Sensor) {
        return new Sensor(_this3.containers, _this3.options);
      });

      activeSensors.forEach(function (sensor) {
        return sensor.attach();
      });
      this.sensors = [].concat((0, _toConsumableArray3.default)(this.sensors), (0, _toConsumableArray3.default)(activeSensors));

      return this;
    }

    /**
     * Removes sensors that are already attached to this draggable instance. This will end up calling
     * the detach method of the sensor
     * @param {...typeof Sensor} sensors - Sensors that you want attached to draggable
     * @return {Draggable}
     * @example draggable.removeSensor(TouchSensor, DragSensor)
     */

  }, {
    key: 'removeSensor',
    value: function removeSensor() {
      for (var _len4 = arguments.length, sensors = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        sensors[_key4] = arguments[_key4];
      }

      var removedSensors = this.sensors.filter(function (sensor) {
        return sensors.includes(sensor.constructor);
      });

      removedSensors.forEach(function (sensor) {
        return sensor.detach();
      });
      this.sensors = this.sensors.filter(function (sensor) {
        return !sensors.includes(sensor.constructor);
      });

      return this;
    }

    /**
     * Adds container to this draggable instance
     * @param {...HTMLElement} containers - Containers you want to add to draggable
     * @return {Draggable}
     * @example draggable.addContainer(document.body)
     */

  }, {
    key: 'addContainer',
    value: function addContainer() {
      for (var _len5 = arguments.length, containers = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        containers[_key5] = arguments[_key5];
      }

      this.containers = [].concat((0, _toConsumableArray3.default)(this.containers), containers);
      this.sensors.forEach(function (sensor) {
        return sensor.addContainer.apply(sensor, containers);
      });
      return this;
    }

    /**
     * Removes container from this draggable instance
     * @param {...HTMLElement} containers - Containers you want to remove from draggable
     * @return {Draggable}
     * @example draggable.removeContainer(document.body)
     */

  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      for (var _len6 = arguments.length, containers = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        containers[_key6] = arguments[_key6];
      }

      this.containers = this.containers.filter(function (container) {
        return !containers.includes(container);
      });
      this.sensors.forEach(function (sensor) {
        return sensor.removeContainer.apply(sensor, containers);
      });
      return this;
    }

    /**
     * Adds listener for draggable events
     * @param {String} type - Event name
     * @param {...Function} callbacks - Event callbacks
     * @return {Draggable}
     * @example draggable.on('drag:start', (dragEvent) => dragEvent.cancel());
     */

  }, {
    key: 'on',
    value: function on(type) {
      var _emitter;

      for (var _len7 = arguments.length, callbacks = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        callbacks[_key7 - 1] = arguments[_key7];
      }

      (_emitter = this.emitter).on.apply(_emitter, [type].concat(callbacks));
      return this;
    }

    /**
     * Removes listener from draggable
     * @param {String} type - Event name
     * @param {Function} callback - Event callback
     * @return {Draggable}
     * @example draggable.off('drag:start', handlerFunction);
     */

  }, {
    key: 'off',
    value: function off(type, callback) {
      this.emitter.off(type, callback);
      return this;
    }

    /**
     * Triggers draggable event
     * @param {AbstractEvent} event - Event instance
     * @return {Draggable}
     * @example draggable.trigger(event);
     */

  }, {
    key: 'trigger',
    value: function trigger(event) {
      this.emitter.trigger(event);
      return this;
    }

    /**
     * Returns class name for class identifier
     * @param {String} name - Name of class identifier
     * @return {String|null}
     */

  }, {
    key: 'getClassNameFor',
    value: function getClassNameFor(name) {
      return this.options.classes[name];
    }

    /**
     * Returns true if this draggable instance is currently dragging
     * @return {Boolean}
     */

  }, {
    key: 'isDragging',
    value: function isDragging() {
      return Boolean(this.dragging);
    }

    /**
     * Returns all draggable elements
     * @return {HTMLElement[]}
     */

  }, {
    key: 'getDraggableElements',
    value: function getDraggableElements() {
      var _this4 = this;

      return this.containers.reduce(function (current, container) {
        return [].concat((0, _toConsumableArray3.default)(current), (0, _toConsumableArray3.default)(_this4.getDraggableElementsForContainer(container)));
      }, []);
    }

    /**
     * Returns draggable elements for a given container, excluding the mirror and
     * original source element if present
     * @param {HTMLElement} container
     * @return {HTMLElement[]}
     */

  }, {
    key: 'getDraggableElementsForContainer',
    value: function getDraggableElementsForContainer(container) {
      var _this5 = this;

      var allDraggableElements = container.querySelectorAll(this.options.draggable);

      return [].concat((0, _toConsumableArray3.default)(allDraggableElements)).filter(function (childElement) {
        return childElement !== _this5.originalSource && childElement !== _this5.mirror;
      });
    }

    /**
     * Drag start handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragStart,
    value: function value(event) {
      var _this6 = this;

      var sensorEvent = getSensorEvent(event);
      var target = sensorEvent.target,
          container = sensorEvent.container;


      if (!this.containers.includes(container)) {
        return;
      }

      if (this.options.handle && target && !(0, _utils.closest)(target, this.options.handle)) {
        sensorEvent.cancel();
        return;
      }

      // Find draggable source element
      this.originalSource = (0, _utils.closest)(target, this.options.draggable);
      this.sourceContainer = container;

      if (!this.originalSource) {
        sensorEvent.cancel();
        return;
      }

      if (this.lastPlacedSource && this.lastPlacedContainer) {
        clearTimeout(this.placedTimeoutID);
        this.lastPlacedSource.classList.remove(this.getClassNameFor('source:placed'));
        this.lastPlacedContainer.classList.remove(this.getClassNameFor('container:placed'));
      }

      this.source = this.originalSource.cloneNode(true);
      this.originalSource.parentNode.insertBefore(this.source, this.originalSource);
      this.originalSource.style.display = 'none';

      var dragEvent = new _DragEvent.DragStartEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent: sensorEvent
      });

      this.trigger(dragEvent);

      this.dragging = !dragEvent.canceled();

      if (dragEvent.canceled()) {
        this.source.parentNode.removeChild(this.source);
        this.originalSource.style.display = null;
        return;
      }

      this.originalSource.classList.add(this.getClassNameFor('source:original'));
      this.source.classList.add(this.getClassNameFor('source:dragging'));
      this.sourceContainer.classList.add(this.getClassNameFor('container:dragging'));
      document.body.classList.add(this.getClassNameFor('body:dragging'));
      applyUserSelect(document.body, 'none');

      requestAnimationFrame(function () {
        var oldSensorEvent = getSensorEvent(event);
        var newSensorEvent = oldSensorEvent.clone({ target: _this6.source });

        _this6[onDragMove](Object.assign({}, event, {
          detail: newSensorEvent
        }));
      });
    }

    /**
     * Drag move handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var sensorEvent = getSensorEvent(event);
      var container = sensorEvent.container;

      var target = sensorEvent.target;

      var dragMoveEvent = new _DragEvent.DragMoveEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent: sensorEvent
      });

      this.trigger(dragMoveEvent);

      if (dragMoveEvent.canceled()) {
        sensorEvent.cancel();
      }

      target = (0, _utils.closest)(target, this.options.draggable);
      var withinCorrectContainer = (0, _utils.closest)(sensorEvent.target, this.containers);
      var overContainer = sensorEvent.overContainer || withinCorrectContainer;
      var isLeavingContainer = this.currentOverContainer && overContainer !== this.currentOverContainer;
      var isLeavingDraggable = this.currentOver && target !== this.currentOver;
      var isOverContainer = overContainer && this.currentOverContainer !== overContainer;
      var isOverDraggable = withinCorrectContainer && target && this.currentOver !== target;

      if (isLeavingDraggable) {
        var dragOutEvent = new _DragEvent.DragOutEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          over: this.currentOver
        });

        this.currentOver.classList.remove(this.getClassNameFor('draggable:over'));
        this.currentOver = null;

        this.trigger(dragOutEvent);
      }

      if (isLeavingContainer) {
        var dragOutContainerEvent = new _DragEvent.DragOutContainerEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: this.currentOverContainer
        });

        this.currentOverContainer.classList.remove(this.getClassNameFor('container:over'));
        this.currentOverContainer = null;

        this.trigger(dragOutContainerEvent);
      }

      if (isOverContainer) {
        overContainer.classList.add(this.getClassNameFor('container:over'));

        var dragOverContainerEvent = new _DragEvent.DragOverContainerEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: overContainer
        });

        this.currentOverContainer = overContainer;

        this.trigger(dragOverContainerEvent);
      }

      if (isOverDraggable) {
        target.classList.add(this.getClassNameFor('draggable:over'));

        var dragOverEvent = new _DragEvent.DragOverEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: overContainer,
          over: target
        });

        this.currentOver = target;

        this.trigger(dragOverEvent);
      }
    }

    /**
     * Drag stop handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragStop,
    value: function value(event) {
      var _this7 = this;

      if (!this.dragging) {
        return;
      }

      this.dragging = false;

      var dragStopEvent = new _DragEvent.DragStopEvent({
        source: this.source,
        originalSource: this.originalSource,
        sensorEvent: event.sensorEvent,
        sourceContainer: this.sourceContainer
      });

      this.trigger(dragStopEvent);

      this.source.parentNode.insertBefore(this.originalSource, this.source);
      this.source.parentNode.removeChild(this.source);
      this.originalSource.style.display = '';

      this.source.classList.remove(this.getClassNameFor('source:dragging'));
      this.originalSource.classList.remove(this.getClassNameFor('source:original'));
      this.originalSource.classList.add(this.getClassNameFor('source:placed'));
      this.sourceContainer.classList.add(this.getClassNameFor('container:placed'));
      this.sourceContainer.classList.remove(this.getClassNameFor('container:dragging'));
      document.body.classList.remove(this.getClassNameFor('body:dragging'));
      applyUserSelect(document.body, '');

      if (this.currentOver) {
        this.currentOver.classList.remove(this.getClassNameFor('draggable:over'));
      }

      if (this.currentOverContainer) {
        this.currentOverContainer.classList.remove(this.getClassNameFor('container:over'));
      }

      this.lastPlacedSource = this.originalSource;
      this.lastPlacedContainer = this.sourceContainer;

      this.placedTimeoutID = setTimeout(function () {
        if (_this7.lastPlacedSource) {
          _this7.lastPlacedSource.classList.remove(_this7.getClassNameFor('source:placed'));
        }

        if (_this7.lastPlacedContainer) {
          _this7.lastPlacedContainer.classList.remove(_this7.getClassNameFor('container:placed'));
        }

        _this7.lastPlacedSource = null;
        _this7.lastPlacedContainer = null;
      }, this.options.placedTimeout);

      this.source = null;
      this.originalSource = null;
      this.currentOverContainer = null;
      this.currentOver = null;
      this.sourceContainer = null;
    }

    /**
     * Drag pressure handler
     * @private
     * @param {Event} event - DOM Drag event
     */

  }, {
    key: onDragPressure,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var sensorEvent = getSensorEvent(event);
      var source = this.source || (0, _utils.closest)(sensorEvent.originalEvent.target, this.options.draggable);

      var dragPressureEvent = new _DragEvent.DragPressureEvent({
        sensorEvent: sensorEvent,
        source: source,
        pressure: sensorEvent.pressure
      });

      this.trigger(dragPressureEvent);
    }
  }]);
  return Draggable;
}();

Draggable.Plugins = { Announcement: _Plugins.Announcement, Focusable: _Plugins.Focusable, Mirror: _Plugins.Mirror, Scrollable: _Plugins.Scrollable };
exports.default = Draggable;


function getSensorEvent(event) {
  return event.detail;
}

function applyUserSelect(element, value) {
  element.style.webkitUserSelect = value;
  element.style.mozUserSelect = value;
  element.style.msUserSelect = value;
  element.style.oUserSelect = value;
  element.style.userSelect = value;
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onMouseForceWillBegin = Symbol('onMouseForceWillBegin');
var onMouseForceDown = Symbol('onMouseForceDown');
var onMouseDown = Symbol('onMouseDown');
var onMouseForceChange = Symbol('onMouseForceChange');
var onMouseMove = Symbol('onMouseMove');
var onMouseUp = Symbol('onMouseUp');
var onMouseForceGlobalChange = Symbol('onMouseForceGlobalChange');

/**
 * This sensor picks up native force touch events and dictates drag operations
 * @class ForceTouchSensor
 * @module ForceTouchSensor
 * @extends Sensor
 */

var ForceTouchSensor = function (_Sensor) {
  (0, _inherits3.default)(ForceTouchSensor, _Sensor);

  /**
   * ForceTouchSensor constructor.
   * @constructs ForceTouchSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function ForceTouchSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, ForceTouchSensor);

    /**
     * Draggable element needs to be remembered to unset the draggable attribute after drag operation has completed
     * @property mightDrag
     * @type {Boolean}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (ForceTouchSensor.__proto__ || Object.getPrototypeOf(ForceTouchSensor)).call(this, containers, options));

    _this.mightDrag = false;

    _this[onMouseForceWillBegin] = _this[onMouseForceWillBegin].bind(_this);
    _this[onMouseForceDown] = _this[onMouseForceDown].bind(_this);
    _this[onMouseDown] = _this[onMouseDown].bind(_this);
    _this[onMouseForceChange] = _this[onMouseForceChange].bind(_this);
    _this[onMouseMove] = _this[onMouseMove].bind(_this);
    _this[onMouseUp] = _this[onMouseUp].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(ForceTouchSensor, [{
    key: 'attach',
    value: function attach() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.containers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var container = _step.value;

          container.addEventListener('webkitmouseforcewillbegin', this[onMouseForceWillBegin], false);
          container.addEventListener('webkitmouseforcedown', this[onMouseForceDown], false);
          container.addEventListener('mousedown', this[onMouseDown], true);
          container.addEventListener('webkitmouseforcechanged', this[onMouseForceChange], false);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      document.addEventListener('mousemove', this[onMouseMove]);
      document.addEventListener('mouseup', this[onMouseUp]);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.containers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var container = _step2.value;

          container.removeEventListener('webkitmouseforcewillbegin', this[onMouseForceWillBegin], false);
          container.removeEventListener('webkitmouseforcedown', this[onMouseForceDown], false);
          container.removeEventListener('mousedown', this[onMouseDown], true);
          container.removeEventListener('webkitmouseforcechanged', this[onMouseForceChange], false);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      document.removeEventListener('mousemove', this[onMouseMove]);
      document.removeEventListener('mouseup', this[onMouseUp]);
    }

    /**
     * Mouse force will begin handler
     * @private
     * @param {Event} event - Mouse force will begin event
     */

  }, {
    key: onMouseForceWillBegin,
    value: function value(event) {
      event.preventDefault();
      this.mightDrag = true;
    }

    /**
     * Mouse force down handler
     * @private
     * @param {Event} event - Mouse force down event
     */

  }, {
    key: onMouseForceDown,
    value: function value(event) {
      if (this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = event.currentTarget;

      var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragStartEvent);

      this.currentContainer = container;
      this.dragging = !dragStartEvent.canceled();
      this.mightDrag = false;
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: onMouseUp,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: null,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragStopEvent);

      this.currentContainer = null;
      this.dragging = false;
      this.mightDrag = false;
    }

    /**
     * Mouse down handler
     * @private
     * @param {Event} event - Mouse down event
     */

  }, {
    key: onMouseDown,
    value: function value(event) {
      if (!this.mightDrag) {
        return;
      }

      // Need workaround for real click
      // Cancel potential drag events
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
    }

    /**
     * Mouse move handler
     * @private
     * @param {Event} event - Mouse force will begin event
     */

  }, {
    key: onMouseMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragMoveEvent);
    }

    /**
     * Mouse force change handler
     * @private
     * @param {Event} event - Mouse force change event
     */

  }, {
    key: onMouseForceChange,
    value: function value(event) {
      if (this.dragging) {
        return;
      }

      var target = event.target;
      var container = event.currentTarget;

      var dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
        pressure: event.webkitForce,
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragPressureEvent);
    }

    /**
     * Mouse force global change handler
     * @private
     * @param {Event} event - Mouse force global change event
     */

  }, {
    key: onMouseForceGlobalChange,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = event.target;

      var dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
        pressure: event.webkitForce,
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragPressureEvent);
    }
  }]);
  return ForceTouchSensor;
}(_Sensor3.default);

exports.default = ForceTouchSensor;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForceTouchSensor = __webpack_require__(62);

var _ForceTouchSensor2 = _interopRequireDefault(_ForceTouchSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForceTouchSensor2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(17);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onMouseDown = Symbol('onMouseDown');
var onMouseUp = Symbol('onMouseUp');
var onDragStart = Symbol('onDragStart');
var onDragOver = Symbol('onDragOver');
var onDragEnd = Symbol('onDragEnd');
var onDrop = Symbol('onDrop');
var reset = Symbol('reset');

/**
 * This sensor picks up native browser drag events and dictates drag operations
 * @class DragSensor
 * @module DragSensor
 * @extends Sensor
 */

var DragSensor = function (_Sensor) {
  (0, _inherits3.default)(DragSensor, _Sensor);

  /**
   * DragSensor constructor.
   * @constructs DragSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function DragSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, DragSensor);

    /**
     * Mouse down timer which will end up setting the draggable attribute, unless canceled
     * @property mouseDownTimeout
     * @type {Number}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (DragSensor.__proto__ || Object.getPrototypeOf(DragSensor)).call(this, containers, options));

    _this.mouseDownTimeout = null;

    /**
     * Draggable element needs to be remembered to unset the draggable attribute after drag operation has completed
     * @property draggableElement
     * @type {HTMLElement}
     */
    _this.draggableElement = null;

    /**
     * Native draggable element could be links or images, their draggable state will be disabled during drag operation
     * @property nativeDraggableElement
     * @type {HTMLElement}
     */
    _this.nativeDraggableElement = null;

    _this[onMouseDown] = _this[onMouseDown].bind(_this);
    _this[onMouseUp] = _this[onMouseUp].bind(_this);
    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragOver] = _this[onDragOver].bind(_this);
    _this[onDragEnd] = _this[onDragEnd].bind(_this);
    _this[onDrop] = _this[onDrop].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(DragSensor, [{
    key: 'attach',
    value: function attach() {
      document.addEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      document.removeEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Drag start handler
     * @private
     * @param {Event} event - Drag start event
     */

  }, {
    key: onDragStart,
    value: function value(event) {
      var _this2 = this;

      // Need for firefox. "text" key is needed for IE
      event.dataTransfer.setData('text', '');
      event.dataTransfer.effectAllowed = this.options.type;

      var target = document.elementFromPoint(event.clientX, event.clientY);
      this.currentContainer = (0, _utils.closest)(event.target, this.containers);

      if (!this.currentContainer) {
        return;
      }

      var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      // Workaround
      setTimeout(function () {
        _this2.trigger(_this2.currentContainer, dragStartEvent);

        if (dragStartEvent.canceled()) {
          _this2.dragging = false;
        } else {
          _this2.dragging = true;
        }
      }, 0);
    }

    /**
     * Drag over handler
     * @private
     * @param {Event} event - Drag over event
     */

  }, {
    key: onDragOver,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = this.currentContainer;

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragMoveEvent);

      if (!dragMoveEvent.canceled()) {
        event.preventDefault();
        event.dataTransfer.dropEffect = this.options.type;
      }
    }

    /**
     * Drag end handler
     * @private
     * @param {Event} event - Drag end event
     */

  }, {
    key: onDragEnd,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      document.removeEventListener('mouseup', this[onMouseUp], true);

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = this.currentContainer;

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: container,
        originalEvent: event
      });

      this.trigger(container, dragStopEvent);

      this.dragging = false;

      this[reset]();
    }

    /**
     * Drop handler
     * @private
     * @param {Event} event - Drop event
     */

  }, {
    key: onDrop,
    value: function value(event) {
      // eslint-disable-line class-methods-use-this
      event.preventDefault();
    }

    /**
     * Mouse down handler
     * @private
     * @param {Event} event - Mouse down event
     */

  }, {
    key: onMouseDown,
    value: function value(event) {
      var _this3 = this;

      // Firefox bug for inputs within draggables https://bugzilla.mozilla.org/show_bug.cgi?id=739071
      if (event.target && (event.target.form || event.target.contenteditable)) {
        return;
      }

      var nativeDraggableElement = (0, _utils.closest)(event.target, function (element) {
        return element.draggable;
      });

      if (nativeDraggableElement) {
        nativeDraggableElement.draggable = false;
        this.nativeDraggableElement = nativeDraggableElement;
      }

      document.addEventListener('mouseup', this[onMouseUp], true);
      document.addEventListener('dragstart', this[onDragStart], false);
      document.addEventListener('dragover', this[onDragOver], false);
      document.addEventListener('dragend', this[onDragEnd], false);
      document.addEventListener('drop', this[onDrop], false);

      var target = (0, _utils.closest)(event.target, this.options.draggable);

      if (!target) {
        return;
      }

      this.mouseDownTimeout = setTimeout(function () {
        target.draggable = true;
        _this3.draggableElement = target;
      }, this.options.delay);
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: onMouseUp,
    value: function value() {
      this[reset]();
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: reset,
    value: function value() {
      clearTimeout(this.mouseDownTimeout);

      document.removeEventListener('mouseup', this[onMouseUp], true);
      document.removeEventListener('dragstart', this[onDragStart], false);
      document.removeEventListener('dragover', this[onDragOver], false);
      document.removeEventListener('dragend', this[onDragEnd], false);
      document.removeEventListener('drop', this[onDrop], false);

      if (this.nativeDraggableElement) {
        this.nativeDraggableElement.draggable = true;
        this.nativeDraggableElement = null;
      }

      if (this.draggableElement) {
        this.draggableElement.draggable = false;
        this.draggableElement = null;
      }
    }
  }]);
  return DragSensor;
}(_Sensor3.default);

exports.default = DragSensor;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragSensor = __webpack_require__(64);

var _DragSensor2 = _interopRequireDefault(_DragSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DragSensor2.default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(17);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onTouchStart = Symbol('onTouchStart');
var onTouchHold = Symbol('onTouchHold');
var onTouchEnd = Symbol('onTouchEnd');
var onTouchMove = Symbol('onTouchMove');

/**
 * Prevents scrolling when set to true
 * @var {Boolean} preventScrolling
 */
var preventScrolling = false;

// WebKit requires cancelable `touchmove` events to be added as early as possible
window.addEventListener('touchmove', function (event) {
  if (!preventScrolling) {
    return;
  }

  // Prevent scrolling
  event.preventDefault();
}, { passive: false });

/**
 * This sensor picks up native browser touch events and dictates drag operations
 * @class TouchSensor
 * @module TouchSensor
 * @extends Sensor
 */

var TouchSensor = function (_Sensor) {
  (0, _inherits3.default)(TouchSensor, _Sensor);

  /**
   * TouchSensor constructor.
   * @constructs TouchSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function TouchSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, TouchSensor);

    /**
     * Closest scrollable container so accidental scroll can cancel long touch
     * @property currentScrollableParent
     * @type {HTMLElement}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchSensor.__proto__ || Object.getPrototypeOf(TouchSensor)).call(this, containers, options));

    _this.currentScrollableParent = null;

    /**
     * TimeoutID for long touch
     * @property tapTimeout
     * @type {Number}
     */
    _this.tapTimeout = null;

    /**
     * touchMoved indicates if touch has moved during tapTimeout
     * @property touchMoved
     * @type {Boolean}
     */
    _this.touchMoved = false;

    _this[onTouchStart] = _this[onTouchStart].bind(_this);
    _this[onTouchHold] = _this[onTouchHold].bind(_this);
    _this[onTouchEnd] = _this[onTouchEnd].bind(_this);
    _this[onTouchMove] = _this[onTouchMove].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(TouchSensor, [{
    key: 'attach',
    value: function attach() {
      document.addEventListener('touchstart', this[onTouchStart]);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      document.removeEventListener('touchstart', this[onTouchStart]);
    }

    /**
     * Touch start handler
     * @private
     * @param {Event} event - Touch start event
     */

  }, {
    key: onTouchStart,
    value: function value(event) {
      var container = (0, _utils.closest)(event.target, this.containers);

      if (!container) {
        return;
      }

      document.addEventListener('touchmove', this[onTouchMove]);
      document.addEventListener('touchend', this[onTouchEnd]);
      document.addEventListener('touchcancel', this[onTouchEnd]);
      container.addEventListener('contextmenu', onContextMenu);

      this.currentContainer = container;
      this.tapTimeout = setTimeout(this[onTouchHold](event, container), this.options.delay);
    }

    /**
     * Touch hold handler
     * @private
     * @param {Event} event - Touch start event
     * @param {HTMLElement} container - Container element
     */

  }, {
    key: onTouchHold,
    value: function value(event, container) {
      var _this2 = this;

      return function () {
        if (_this2.touchMoved) {
          return;
        }

        var touch = event.touches[0] || event.changedTouches[0];
        var target = event.target;

        var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
          clientX: touch.pageX,
          clientY: touch.pageY,
          target: target,
          container: container,
          originalEvent: event
        });

        _this2.trigger(container, dragStartEvent);

        _this2.dragging = !dragStartEvent.canceled();
        preventScrolling = _this2.dragging;
      };
    }

    /**
     * Touch move handler
     * @private
     * @param {Event} event - Touch move event
     */

  }, {
    key: onTouchMove,
    value: function value(event) {
      this.touchMoved = true;

      if (!this.dragging) {
        return;
      }

      var touch = event.touches[0] || event.changedTouches[0];
      var target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: touch.pageX,
        clientY: touch.pageY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragMoveEvent);
    }

    /**
     * Touch end handler
     * @private
     * @param {Event} event - Touch end event
     */

  }, {
    key: onTouchEnd,
    value: function value(event) {
      this.touchMoved = false;
      preventScrolling = false;

      document.removeEventListener('touchend', this[onTouchEnd]);
      document.removeEventListener('touchcancel', this[onTouchEnd]);
      document.removeEventListener('touchmove', this[onTouchMove]);

      if (this.currentContainer) {
        this.currentContainer.removeEventListener('contextmenu', onContextMenu);
      }

      clearTimeout(this.tapTimeout);

      if (!this.dragging) {
        return;
      }

      var touch = event.touches[0] || event.changedTouches[0];
      var target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);

      event.preventDefault();

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: touch.pageX,
        clientY: touch.pageY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragStopEvent);

      this.currentContainer = null;
      this.dragging = false;
    }
  }]);
  return TouchSensor;
}(_Sensor3.default);

exports.default = TouchSensor;


function onContextMenu(event) {
  event.preventDefault();
  event.stopPropagation();
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TouchSensor = __webpack_require__(66);

var _TouchSensor2 = _interopRequireDefault(_TouchSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TouchSensor2.default;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragPressureSensorEvent = exports.DragStopSensorEvent = exports.DragMoveSensorEvent = exports.DragStartSensorEvent = exports.SensorEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(19);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sensor event
 * @class SensorEvent
 * @module SensorEvent
 * @extends AbstractEvent
 */
var SensorEvent = exports.SensorEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(SensorEvent, _AbstractEvent);

  function SensorEvent() {
    (0, _classCallCheck3.default)(this, SensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SensorEvent.__proto__ || Object.getPrototypeOf(SensorEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SensorEvent, [{
    key: 'originalEvent',

    /**
     * Original browser event that triggered a sensor
     * @property originalEvent
     * @type {Event}
     * @readonly
     */
    get: function get() {
      return this.data.originalEvent;
    }

    /**
     * Normalized clientX for both touch and mouse events
     * @property clientX
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'clientX',
    get: function get() {
      return this.data.clientX;
    }

    /**
     * Normalized clientY for both touch and mouse events
     * @property clientY
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'clientY',
    get: function get() {
      return this.data.clientY;
    }

    /**
     * Normalized target for both touch and mouse events
     * Returns the element that is behind cursor or touch pointer
     * @property target
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'target',
    get: function get() {
      return this.data.target;
    }

    /**
     * Container that initiated the sensor
     * @property container
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'container',
    get: function get() {
      return this.data.container;
    }

    /**
     * Trackpad pressure
     * @property pressure
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'pressure',
    get: function get() {
      return this.data.pressure;
    }
  }]);
  return SensorEvent;
}(_AbstractEvent3.default);

/**
 * Drag start sensor event
 * @class DragStartSensorEvent
 * @module DragStartSensorEvent
 * @extends SensorEvent
 */


var DragStartSensorEvent = exports.DragStartSensorEvent = function (_SensorEvent) {
  (0, _inherits3.default)(DragStartSensorEvent, _SensorEvent);

  function DragStartSensorEvent() {
    (0, _classCallCheck3.default)(this, DragStartSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStartSensorEvent.__proto__ || Object.getPrototypeOf(DragStartSensorEvent)).apply(this, arguments));
  }

  return DragStartSensorEvent;
}(SensorEvent);

/**
 * Drag move sensor event
 * @class DragMoveSensorEvent
 * @module DragMoveSensorEvent
 * @extends SensorEvent
 */


DragStartSensorEvent.type = 'drag:start';

var DragMoveSensorEvent = exports.DragMoveSensorEvent = function (_SensorEvent2) {
  (0, _inherits3.default)(DragMoveSensorEvent, _SensorEvent2);

  function DragMoveSensorEvent() {
    (0, _classCallCheck3.default)(this, DragMoveSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragMoveSensorEvent.__proto__ || Object.getPrototypeOf(DragMoveSensorEvent)).apply(this, arguments));
  }

  return DragMoveSensorEvent;
}(SensorEvent);

/**
 * Drag stop sensor event
 * @class DragStopSensorEvent
 * @module DragStopSensorEvent
 * @extends SensorEvent
 */


DragMoveSensorEvent.type = 'drag:move';

var DragStopSensorEvent = exports.DragStopSensorEvent = function (_SensorEvent3) {
  (0, _inherits3.default)(DragStopSensorEvent, _SensorEvent3);

  function DragStopSensorEvent() {
    (0, _classCallCheck3.default)(this, DragStopSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStopSensorEvent.__proto__ || Object.getPrototypeOf(DragStopSensorEvent)).apply(this, arguments));
  }

  return DragStopSensorEvent;
}(SensorEvent);

/**
 * Drag pressure sensor event
 * @class DragPressureSensorEvent
 * @module DragPressureSensorEvent
 * @extends SensorEvent
 */


DragStopSensorEvent.type = 'drag:stop';

var DragPressureSensorEvent = exports.DragPressureSensorEvent = function (_SensorEvent4) {
  (0, _inherits3.default)(DragPressureSensorEvent, _SensorEvent4);

  function DragPressureSensorEvent() {
    (0, _classCallCheck3.default)(this, DragPressureSensorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragPressureSensorEvent.__proto__ || Object.getPrototypeOf(DragPressureSensorEvent)).apply(this, arguments));
  }

  return DragPressureSensorEvent;
}(SensorEvent);

DragPressureSensorEvent.type = 'drag:pressure';

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(17);

var _Sensor2 = __webpack_require__(16);

var _Sensor3 = _interopRequireDefault(_Sensor2);

var _SensorEvent = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onContextMenuWhileDragging = Symbol('onContextMenuWhileDragging');
var onMouseDown = Symbol('onMouseDown');
var onMouseMove = Symbol('onMouseMove');
var onMouseUp = Symbol('onMouseUp');

/**
 * This sensor picks up native browser mouse events and dictates drag operations
 * @class MouseSensor
 * @module MouseSensor
 * @extends Sensor
 */

var MouseSensor = function (_Sensor) {
  (0, _inherits3.default)(MouseSensor, _Sensor);

  /**
   * MouseSensor constructor.
   * @constructs MouseSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function MouseSensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, MouseSensor);

    /**
     * Indicates if mouse button is still down
     * @property mouseDown
     * @type {Boolean}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (MouseSensor.__proto__ || Object.getPrototypeOf(MouseSensor)).call(this, containers, options));

    _this.mouseDown = false;

    /**
     * Mouse down timer which will end up triggering the drag start operation
     * @property mouseDownTimeout
     * @type {Number}
     */
    _this.mouseDownTimeout = null;

    /**
     * Indicates if context menu has been opened during drag operation
     * @property openedContextMenu
     * @type {Boolean}
     */
    _this.openedContextMenu = false;

    _this[onContextMenuWhileDragging] = _this[onContextMenuWhileDragging].bind(_this);
    _this[onMouseDown] = _this[onMouseDown].bind(_this);
    _this[onMouseMove] = _this[onMouseMove].bind(_this);
    _this[onMouseUp] = _this[onMouseUp].bind(_this);
    return _this;
  }

  /**
   * Attaches sensors event listeners to the DOM
   */


  (0, _createClass3.default)(MouseSensor, [{
    key: 'attach',
    value: function attach() {
      document.addEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Detaches sensors event listeners to the DOM
     */

  }, {
    key: 'detach',
    value: function detach() {
      document.removeEventListener('mousedown', this[onMouseDown], true);
    }

    /**
     * Mouse down handler
     * @private
     * @param {Event} event - Mouse down event
     */

  }, {
    key: onMouseDown,
    value: function value(event) {
      var _this2 = this;

      if (event.button !== 0 || event.ctrlKey || event.metaKey) {
        return;
      }

      document.addEventListener('mouseup', this[onMouseUp]);

      var target = document.elementFromPoint(event.clientX, event.clientY);
      var container = (0, _utils.closest)(target, this.containers);

      if (!container) {
        return;
      }

      document.addEventListener('dragstart', preventNativeDragStart);

      this.mouseDown = true;

      clearTimeout(this.mouseDownTimeout);
      this.mouseDownTimeout = setTimeout(function () {
        if (!_this2.mouseDown) {
          return;
        }

        var dragStartEvent = new _SensorEvent.DragStartSensorEvent({
          clientX: event.clientX,
          clientY: event.clientY,
          target: target,
          container: container,
          originalEvent: event
        });

        _this2.trigger(container, dragStartEvent);

        _this2.currentContainer = container;
        _this2.dragging = !dragStartEvent.canceled();

        if (_this2.dragging) {
          document.addEventListener('contextmenu', _this2[onContextMenuWhileDragging]);
          document.addEventListener('mousemove', _this2[onMouseMove]);
        }
      }, this.options.delay);
    }

    /**
     * Mouse move handler
     * @private
     * @param {Event} event - Mouse move event
     */

  }, {
    key: onMouseMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);

      var dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragMoveEvent);
    }

    /**
     * Mouse up handler
     * @private
     * @param {Event} event - Mouse up event
     */

  }, {
    key: onMouseUp,
    value: function value(event) {
      this.mouseDown = Boolean(this.openedContextMenu);

      if (this.openedContextMenu) {
        this.openedContextMenu = false;
        return;
      }

      document.removeEventListener('mouseup', this[onMouseUp]);
      document.removeEventListener('dragstart', preventNativeDragStart);

      if (!this.dragging) {
        return;
      }

      var target = document.elementFromPoint(event.clientX, event.clientY);

      var dragStopEvent = new _SensorEvent.DragStopSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });

      this.trigger(this.currentContainer, dragStopEvent);

      document.removeEventListener('contextmenu', this[onContextMenuWhileDragging]);
      document.removeEventListener('mousemove', this[onMouseMove]);

      this.currentContainer = null;
      this.dragging = false;
    }

    /**
     * Context menu handler
     * @private
     * @param {Event} event - Context menu event
     */

  }, {
    key: onContextMenuWhileDragging,
    value: function value(event) {
      event.preventDefault();
      this.openedContextMenu = true;
    }
  }]);
  return MouseSensor;
}(_Sensor3.default);

exports.default = MouseSensor;


function preventNativeDragStart(event) {
  event.preventDefault();
}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseSensor = __webpack_require__(69);

var _MouseSensor2 = _interopRequireDefault(_MouseSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MouseSensor2.default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sensor class. Extend from this class to create a new or custom sensor
 * @class Sensor
 * @module Sensor
 */
var Sensor = function () {
  /**
   * Sensor constructor.
   * @constructs Sensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  function Sensor() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Sensor);

    /**
     * Current containers
     * @property containers
     * @type {HTMLElement[]}
     */
    this.containers = [].concat((0, _toConsumableArray3.default)(containers));

    /**
     * Current options
     * @property options
     * @type {Object}
     */
    this.options = Object.assign({}, options);

    /**
     * Current drag state
     * @property dragging
     * @type {Boolean}
     */
    this.dragging = false;

    /**
     * Current container
     * @property currentContainer
     * @type {HTMLElement}
     */
    this.currentContainer = null;
  }

  /**
   * Attaches sensors event listeners to the DOM
   * @return {Sensor}
   */


  (0, _createClass3.default)(Sensor, [{
    key: 'attach',
    value: function attach() {
      return this;
    }

    /**
     * Detaches sensors event listeners to the DOM
     * @return {Sensor}
     */

  }, {
    key: 'detach',
    value: function detach() {
      return this;
    }

    /**
     * Adds container to this sensor instance
     * @param {...HTMLElement} containers - Containers you want to add to this sensor
     * @example draggable.addContainer(document.body)
     */

  }, {
    key: 'addContainer',
    value: function addContainer() {
      for (var _len = arguments.length, containers = Array(_len), _key = 0; _key < _len; _key++) {
        containers[_key] = arguments[_key];
      }

      this.containers = [].concat((0, _toConsumableArray3.default)(this.containers), containers);
    }

    /**
     * Removes container from this sensor instance
     * @param {...HTMLElement} containers - Containers you want to remove from this sensor
     * @example draggable.removeContainer(document.body)
     */

  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      for (var _len2 = arguments.length, containers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        containers[_key2] = arguments[_key2];
      }

      this.containers = this.containers.filter(function (container) {
        return !containers.includes(container);
      });
    }

    /**
     * Triggers event on target element
     * @param {HTMLElement} element - Element to trigger event on
     * @param {SensorEvent} sensorEvent - Sensor event to trigger
     */

  }, {
    key: 'trigger',
    value: function trigger(element, sensorEvent) {
      var event = document.createEvent('Event');
      event.detail = sensorEvent;
      event.initEvent(sensorEvent.type, true, true);
      element.dispatchEvent(event);
      this.lastEvent = sensorEvent;

      return sensorEvent;
    }
  }]);
  return Sensor;
}();

exports.default = Sensor;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestNextAnimationFrame;
function requestNextAnimationFrame(callback) {
  return requestAnimationFrame(function () {
    requestAnimationFrame(callback);
  });
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requestNextAnimationFrame = __webpack_require__(72);

var _requestNextAnimationFrame2 = _interopRequireDefault(_requestNextAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _requestNextAnimationFrame2.default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = closest;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchFunction = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;

/**
 * Get the closest parent element of a given element that matches the given
 * selector string or matching function
 *
 * @param {Element} element The child element to find a parent of
 * @param {String|Function} selector The string or function to use to match
 *     the parent element
 * @return {Element|null}
 */
function closest(element, value) {
  if (!element) {
    return null;
  }

  var selector = value;
  var callback = value;
  var nodeList = value;
  var singleElement = value;

  var isSelector = Boolean(typeof value === 'string');
  var isFunction = Boolean(typeof value === 'function');
  var isNodeList = Boolean(value instanceof NodeList || value instanceof Array);
  var isElement = Boolean(value instanceof HTMLElement);

  function conditionFn(currentElement) {
    if (!currentElement) {
      return currentElement;
    } else if (isSelector) {
      return matchFunction.call(currentElement, selector);
    } else if (isNodeList) {
      return [].concat((0, _toConsumableArray3.default)(nodeList)).includes(currentElement);
    } else if (isElement) {
      return singleElement === currentElement;
    } else if (isFunction) {
      return callback(currentElement);
    } else {
      return null;
    }
  }

  var current = element;

  do {
    current = current.correspondingUseElement || current.correspondingElement || current;

    if (conditionFn(current)) {
      return current;
    }

    current = current.parentNode;
  } while (current && current !== document.body && current !== document);

  return null;
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closest = __webpack_require__(74);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _closest2.default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.scroll = exports.onDragStop = exports.onDragMove = exports.onDragStart = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(23);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

var _utils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = exports.onDragStart = Symbol('onDragStart');
var onDragMove = exports.onDragMove = Symbol('onDragMove');
var onDragStop = exports.onDragStop = Symbol('onDragStop');
var scroll = exports.scroll = Symbol('scroll');

/**
 * Scrollable default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.speed
 * @property {Number} defaultOptions.sensitivity
 * @property {HTMLElement[]} defaultOptions.scrollableElements
 * @type {Object}
 */
var defaultOptions = exports.defaultOptions = {
  speed: 6,
  sensitivity: 50,
  scrollableElements: []
};

/**
 * Scrollable plugin which scrolls the closest scrollable parent
 * @class Scrollable
 * @module Scrollable
 * @extends AbstractPlugin
 */

var Scrollable = function (_AbstractPlugin) {
  (0, _inherits3.default)(Scrollable, _AbstractPlugin);

  /**
   * Scrollable constructor.
   * @constructs Scrollable
   * @param {Draggable} draggable - Draggable instance
   */
  function Scrollable(draggable) {
    (0, _classCallCheck3.default)(this, Scrollable);

    /**
     * Scrollable options
     * @property {Object} options
     * @property {Number} options.speed
     * @property {Number} options.sensitivity
     * @property {HTMLElement[]} options.scrollableElements
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Scrollable.__proto__ || Object.getPrototypeOf(Scrollable)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    /**
     * Keeps current mouse position
     * @property {Object} currentMousePosition
     * @property {Number} currentMousePosition.clientX
     * @property {Number} currentMousePosition.clientY
     * @type {Object|null}
     */
    _this.currentMousePosition = null;

    /**
     * Scroll animation frame
     * @property scrollAnimationFrame
     * @type {Number|null}
     */
    _this.scrollAnimationFrame = null;

    /**
     * Closest scrollable element
     * @property scrollableElement
     * @type {HTMLElement|null}
     */
    _this.scrollableElement = null;

    /**
     * Animation frame looking for the closest scrollable element
     * @property findScrollableElementFrame
     * @type {Number|null}
     */
    _this.findScrollableElementFrame = null;

    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragMove] = _this[onDragMove].bind(_this);
    _this[onDragStop] = _this[onDragStop].bind(_this);
    _this[scroll] = _this[scroll].bind(_this);
    return _this;
  }

  /**
   * Attaches plugins event listeners
   */


  (0, _createClass3.default)(Scrollable, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]);
    }

    /**
     * Detaches plugins event listeners
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]);
    }

    /**
     * Returns options passed through draggable
     * @return {Object}
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.scrollable || {};
    }

    /**
     * Returns closest scrollable elements by element
     * @param {HTMLElement} target
     * @return {HTMLElement}
     */

  }, {
    key: 'getScrollableElement',
    value: function getScrollableElement(target) {
      if (this.hasDefinedScrollableElements()) {
        return (0, _utils.closest)(target, this.options.scrollableElements) || document.documentElement;
      } else {
        return closestScrollableElement(target);
      }
    }

    /**
     * Returns true if at least one scrollable element have been defined via options
     * @param {HTMLElement} target
     * @return {Boolean}
     */

  }, {
    key: 'hasDefinedScrollableElements',
    value: function hasDefinedScrollableElements() {
      return Boolean(this.options.scrollableElements.length !== 0);
    }

    /**
     * Drag start handler. Finds closest scrollable parent in separate frame
     * @param {DragStartEvent} dragEvent
     * @private
     */

  }, {
    key: onDragStart,
    value: function value(dragEvent) {
      var _this2 = this;

      this.findScrollableElementFrame = requestAnimationFrame(function () {
        _this2.scrollableElement = _this2.getScrollableElement(dragEvent.source);
      });
    }

    /**
     * Drag move handler. Remembers mouse position and initiates scrolling
     * @param {DragMoveEvent} dragEvent
     * @private
     */

  }, {
    key: onDragMove,
    value: function value(dragEvent) {
      var _this3 = this;

      this.findScrollableElementFrame = requestAnimationFrame(function () {
        _this3.scrollableElement = _this3.getScrollableElement(dragEvent.sensorEvent.target);
      });

      if (!this.scrollableElement) {
        return;
      }

      var sensorEvent = dragEvent.sensorEvent;
      var scrollOffset = { x: 0, y: 0 };

      if ('ontouchstart' in window) {
        scrollOffset.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        scrollOffset.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
      }

      this.currentMousePosition = {
        clientX: sensorEvent.clientX - scrollOffset.x,
        clientY: sensorEvent.clientY - scrollOffset.y
      };

      this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
    }

    /**
     * Drag stop handler. Cancels scroll animations and resets state
     * @private
     */

  }, {
    key: onDragStop,
    value: function value() {
      cancelAnimationFrame(this.scrollAnimationFrame);
      cancelAnimationFrame(this.findScrollableElementFrame);

      this.scrollableElement = null;
      this.scrollAnimationFrame = null;
      this.findScrollableElementFrame = null;
      this.currentMousePosition = null;
    }

    /**
     * Scroll function that does the heavylifting
     * @private
     */

  }, {
    key: scroll,
    value: function value() {
      if (!this.scrollableElement || !this.currentMousePosition) {
        return;
      }

      cancelAnimationFrame(this.scrollAnimationFrame);

      var _options = this.options,
          speed = _options.speed,
          sensitivity = _options.sensitivity;


      var rect = this.scrollableElement.getBoundingClientRect();
      var bottomCutOff = rect.bottom > window.innerHeight;
      var topCutOff = rect.top < 0;
      var cutOff = topCutOff || bottomCutOff;

      var documentScrollingElement = getDocumentScrollingElement();
      var scrollableElement = this.scrollableElement;
      var clientX = this.currentMousePosition.clientX;
      var clientY = this.currentMousePosition.clientY;

      if (scrollableElement !== document.body && scrollableElement !== document.documentElement && !cutOff) {
        var offsetHeight = scrollableElement.offsetHeight,
            offsetWidth = scrollableElement.offsetWidth;


        if (rect.top + offsetHeight - clientY < sensitivity) {
          scrollableElement.scrollTop += speed;
        } else if (clientY - rect.top < sensitivity) {
          scrollableElement.scrollTop -= speed;
        }

        if (rect.left + offsetWidth - clientX < sensitivity) {
          scrollableElement.scrollLeft += speed;
        } else if (clientX - rect.left < sensitivity) {
          scrollableElement.scrollLeft -= speed;
        }
      } else {
        var _window = window,
            innerHeight = _window.innerHeight,
            innerWidth = _window.innerWidth;


        if (clientY < sensitivity) {
          documentScrollingElement.scrollTop -= speed;
        } else if (innerHeight - clientY < sensitivity) {
          documentScrollingElement.scrollTop += speed;
        }

        if (clientX < sensitivity) {
          documentScrollingElement.scrollLeft -= speed;
        } else if (innerWidth - clientX < sensitivity) {
          documentScrollingElement.scrollLeft += speed;
        }
      }

      this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
    }
  }]);
  return Scrollable;
}(_AbstractPlugin3.default);

/**
 * Returns true if the passed element has overflow
 * @param {HTMLElement} element
 * @return {Boolean}
 * @private
 */


exports.default = Scrollable;
function hasOverflow(element) {
  var overflowRegex = /(auto|scroll)/;
  var computedStyles = getComputedStyle(element, null);

  var overflow = computedStyles.getPropertyValue('overflow') + computedStyles.getPropertyValue('overflow-y') + computedStyles.getPropertyValue('overflow-x');

  return overflowRegex.test(overflow);
}

/**
 * Returns true if the passed element is statically positioned
 * @param {HTMLElement} element
 * @return {Boolean}
 * @private
 */
function isStaticallyPositioned(element) {
  var position = getComputedStyle(element).getPropertyValue('position');
  return position === 'static';
}

/**
 * Finds closest scrollable element
 * @param {HTMLElement} element
 * @return {HTMLElement}
 * @private
 */
function closestScrollableElement(element) {
  if (!element) {
    return getDocumentScrollingElement();
  }

  var position = getComputedStyle(element).getPropertyValue('position');
  var excludeStaticParents = position === 'absolute';

  var scrollableElement = (0, _utils.closest)(element, function (parent) {
    if (excludeStaticParents && isStaticallyPositioned(parent)) {
      return false;
    }
    return hasOverflow(parent);
  });

  if (position === 'fixed' || !scrollableElement) {
    return getDocumentScrollingElement();
  } else {
    return scrollableElement;
  }
}

/**
 * Returns element that scrolls document
 * @return {HTMLElement}
 * @private
 */
function getDocumentScrollingElement() {
  return document.scrollingElement || document.documentElement;
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Scrollable = __webpack_require__(76);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Scrollable2.default;
exports.defaultOptions = _Scrollable.defaultOptions;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MirrorDestroyEvent = exports.MirrorMoveEvent = exports.MirrorAttachedEvent = exports.MirrorCreatedEvent = exports.MirrorCreateEvent = exports.MirrorEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(19);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base mirror event
 * @class MirrorEvent
 * @module MirrorEvent
 * @extends AbstractEvent
 */
var MirrorEvent = exports.MirrorEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(MirrorEvent, _AbstractEvent);

  function MirrorEvent() {
    (0, _classCallCheck3.default)(this, MirrorEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorEvent.__proto__ || Object.getPrototypeOf(MirrorEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorEvent, [{
    key: 'source',

    /**
     * Draggables source element
     * @property source
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.source;
    }

    /**
     * Draggables original source element
     * @property originalSource
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'originalSource',
    get: function get() {
      return this.data.originalSource;
    }

    /**
     * Draggables source container element
     * @property sourceContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'sourceContainer',
    get: function get() {
      return this.data.sourceContainer;
    }

    /**
     * Sensor event
     * @property sensorEvent
     * @type {SensorEvent}
     * @readonly
     */

  }, {
    key: 'sensorEvent',
    get: function get() {
      return this.data.sensorEvent;
    }

    /**
     * Drag event
     * @property dragEvent
     * @type {DragEvent}
     * @readonly
     */

  }, {
    key: 'dragEvent',
    get: function get() {
      return this.data.dragEvent;
    }

    /**
     * Original event that triggered sensor event
     * @property originalEvent
     * @type {Event}
     * @readonly
     */

  }, {
    key: 'originalEvent',
    get: function get() {
      if (this.sensorEvent) {
        return this.sensorEvent.originalEvent;
      }

      return null;
    }
  }]);
  return MirrorEvent;
}(_AbstractEvent3.default);

/**
 * Mirror create event
 * @class MirrorCreateEvent
 * @module MirrorCreateEvent
 * @extends MirrorEvent
 */


var MirrorCreateEvent = exports.MirrorCreateEvent = function (_MirrorEvent) {
  (0, _inherits3.default)(MirrorCreateEvent, _MirrorEvent);

  function MirrorCreateEvent() {
    (0, _classCallCheck3.default)(this, MirrorCreateEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorCreateEvent.__proto__ || Object.getPrototypeOf(MirrorCreateEvent)).apply(this, arguments));
  }

  return MirrorCreateEvent;
}(MirrorEvent);

/**
 * Mirror created event
 * @class MirrorCreatedEvent
 * @module MirrorCreatedEvent
 * @extends MirrorEvent
 */


MirrorCreateEvent.type = 'mirror:create';

var MirrorCreatedEvent = exports.MirrorCreatedEvent = function (_MirrorEvent2) {
  (0, _inherits3.default)(MirrorCreatedEvent, _MirrorEvent2);

  function MirrorCreatedEvent() {
    (0, _classCallCheck3.default)(this, MirrorCreatedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorCreatedEvent.__proto__ || Object.getPrototypeOf(MirrorCreatedEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorCreatedEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorCreatedEvent;
}(MirrorEvent);

/**
 * Mirror attached event
 * @class MirrorAttachedEvent
 * @module MirrorAttachedEvent
 * @extends MirrorEvent
 */


MirrorCreatedEvent.type = 'mirror:created';

var MirrorAttachedEvent = exports.MirrorAttachedEvent = function (_MirrorEvent3) {
  (0, _inherits3.default)(MirrorAttachedEvent, _MirrorEvent3);

  function MirrorAttachedEvent() {
    (0, _classCallCheck3.default)(this, MirrorAttachedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorAttachedEvent.__proto__ || Object.getPrototypeOf(MirrorAttachedEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorAttachedEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorAttachedEvent;
}(MirrorEvent);

/**
 * Mirror move event
 * @class MirrorMoveEvent
 * @module MirrorMoveEvent
 * @extends MirrorEvent
 */


MirrorAttachedEvent.type = 'mirror:attached';

var MirrorMoveEvent = exports.MirrorMoveEvent = function (_MirrorEvent4) {
  (0, _inherits3.default)(MirrorMoveEvent, _MirrorEvent4);

  function MirrorMoveEvent() {
    (0, _classCallCheck3.default)(this, MirrorMoveEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorMoveEvent.__proto__ || Object.getPrototypeOf(MirrorMoveEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorMoveEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorMoveEvent;
}(MirrorEvent);

/**
 * Mirror destroy event
 * @class MirrorDestroyEvent
 * @module MirrorDestroyEvent
 * @extends MirrorEvent
 */


MirrorMoveEvent.type = 'mirror:move';
MirrorMoveEvent.cancelable = true;

var MirrorDestroyEvent = exports.MirrorDestroyEvent = function (_MirrorEvent5) {
  (0, _inherits3.default)(MirrorDestroyEvent, _MirrorEvent5);

  function MirrorDestroyEvent() {
    (0, _classCallCheck3.default)(this, MirrorDestroyEvent);
    return (0, _possibleConstructorReturn3.default)(this, (MirrorDestroyEvent.__proto__ || Object.getPrototypeOf(MirrorDestroyEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MirrorDestroyEvent, [{
    key: 'mirror',


    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.mirror;
    }
  }]);
  return MirrorDestroyEvent;
}(MirrorEvent);

MirrorDestroyEvent.type = 'mirror:destroy';
MirrorDestroyEvent.cancelable = true;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MirrorEvent = __webpack_require__(78);

Object.keys(_MirrorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MirrorEvent[key];
    }
  });
});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.getAppendableContainer = exports.onScroll = exports.onMirrorMove = exports.onMirrorCreated = exports.onDragStop = exports.onDragMove = exports.onDragStart = undefined;

var _objectWithoutProperties2 = __webpack_require__(80);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(23);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

var _MirrorEvent = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = exports.onDragStart = Symbol('onDragStart');
var onDragMove = exports.onDragMove = Symbol('onDragMove');
var onDragStop = exports.onDragStop = Symbol('onDragStop');
var onMirrorCreated = exports.onMirrorCreated = Symbol('onMirrorCreated');
var onMirrorMove = exports.onMirrorMove = Symbol('onMirrorMove');
var onScroll = exports.onScroll = Symbol('onScroll');
var getAppendableContainer = exports.getAppendableContainer = Symbol('getAppendableContainer');

/**
 * Mirror default options
 * @property {Object} defaultOptions
 * @property {Boolean} defaultOptions.constrainDimensions
 * @property {Boolean} defaultOptions.xAxis
 * @property {Boolean} defaultOptions.yAxis
 * @property {null} defaultOptions.cursorOffsetX
 * @property {null} defaultOptions.cursorOffsetY
 * @type {Object}
 */
var defaultOptions = exports.defaultOptions = {
  constrainDimensions: false,
  xAxis: true,
  yAxis: true,
  cursorOffsetX: null,
  cursorOffsetY: null
};

/**
 * Mirror plugin which controls the mirror positioning while dragging
 * @class Mirror
 * @module Mirror
 * @extends AbstractPlugin
 */

var Mirror = function (_AbstractPlugin) {
  (0, _inherits3.default)(Mirror, _AbstractPlugin);

  /**
   * Mirror constructor.
   * @constructs Mirror
   * @param {Draggable} draggable - Draggable instance
   */
  function Mirror(draggable) {
    (0, _classCallCheck3.default)(this, Mirror);

    /**
     * Mirror options
     * @property {Object} options
     * @property {Boolean} options.constrainDimensions
     * @property {Boolean} options.xAxis
     * @property {Boolean} options.yAxis
     * @property {Number|null} options.cursorOffsetX
     * @property {Number|null} options.cursorOffsetY
     * @property {String|HTMLElement|Function} options.appendTo
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Mirror.__proto__ || Object.getPrototypeOf(Mirror)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    /**
     * Scroll offset for touch devices because the mirror is positioned fixed
     * @property {Object} scrollOffset
     * @property {Number} scrollOffset.x
     * @property {Number} scrollOffset.y
     */
    _this.scrollOffset = { x: 0, y: 0 };

    /**
     * Initial scroll offset for touch devices because the mirror is positioned fixed
     * @property {Object} scrollOffset
     * @property {Number} scrollOffset.x
     * @property {Number} scrollOffset.y
     */
    _this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    };

    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragMove] = _this[onDragMove].bind(_this);
    _this[onDragStop] = _this[onDragStop].bind(_this);
    _this[onMirrorCreated] = _this[onMirrorCreated].bind(_this);
    _this[onMirrorMove] = _this[onMirrorMove].bind(_this);
    _this[onScroll] = _this[onScroll].bind(_this);
    return _this;
  }

  /**
   * Attaches plugins event listeners
   */


  (0, _createClass3.default)(Mirror, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]).on('mirror:created', this[onMirrorCreated]).on('mirror:move', this[onMirrorMove]);
    }

    /**
     * Detaches plugins event listeners
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]).off('mirror:created', this[onMirrorCreated]).off('mirror:move', this[onMirrorMove]);
    }

    /**
     * Returns options passed through draggable
     * @return {Object}
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.mirror || {};
    }
  }, {
    key: onDragStart,
    value: function value(dragEvent) {
      if (dragEvent.canceled()) {
        return;
      }

      if ('ontouchstart' in window) {
        document.addEventListener('scroll', this[onScroll], true);
      }

      this.initialScrollOffset = {
        x: window.scrollX,
        y: window.scrollY
      };

      var source = dragEvent.source,
          originalSource = dragEvent.originalSource,
          sourceContainer = dragEvent.sourceContainer,
          sensorEvent = dragEvent.sensorEvent;


      var mirrorCreateEvent = new _MirrorEvent.MirrorCreateEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent
      });

      this.draggable.trigger(mirrorCreateEvent);

      if (isNativeDragEvent(sensorEvent) || mirrorCreateEvent.canceled()) {
        return;
      }

      var appendableContainer = this[getAppendableContainer](source) || sourceContainer;
      this.mirror = source.cloneNode(true);

      var mirrorCreatedEvent = new _MirrorEvent.MirrorCreatedEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent,
        mirror: this.mirror
      });

      var mirrorAttachedEvent = new _MirrorEvent.MirrorAttachedEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent,
        mirror: this.mirror
      });

      this.draggable.trigger(mirrorCreatedEvent);
      appendableContainer.appendChild(this.mirror);
      this.draggable.trigger(mirrorAttachedEvent);
    }
  }, {
    key: onDragMove,
    value: function value(dragEvent) {
      if (!this.mirror || dragEvent.canceled()) {
        return;
      }

      var source = dragEvent.source,
          originalSource = dragEvent.originalSource,
          sourceContainer = dragEvent.sourceContainer,
          sensorEvent = dragEvent.sensorEvent;


      var mirrorMoveEvent = new _MirrorEvent.MirrorMoveEvent({
        source: source,
        originalSource: originalSource,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent,
        mirror: this.mirror
      });

      this.draggable.trigger(mirrorMoveEvent);
    }
  }, {
    key: onDragStop,
    value: function value(dragEvent) {
      if ('ontouchstart' in window) {
        document.removeEventListener('scroll', this[onScroll], true);
      }

      this.initialScrollOffset = { x: 0, y: 0 };
      this.scrollOffset = { x: 0, y: 0 };

      if (!this.mirror) {
        return;
      }

      var source = dragEvent.source,
          sourceContainer = dragEvent.sourceContainer,
          sensorEvent = dragEvent.sensorEvent;


      var mirrorDestroyEvent = new _MirrorEvent.MirrorDestroyEvent({
        source: source,
        mirror: this.mirror,
        sourceContainer: sourceContainer,
        sensorEvent: sensorEvent,
        dragEvent: dragEvent
      });

      this.draggable.trigger(mirrorDestroyEvent);

      if (!mirrorDestroyEvent.canceled()) {
        this.mirror.parentNode.removeChild(this.mirror);
      }
    }
  }, {
    key: onScroll,
    value: function value() {
      this.scrollOffset = {
        x: window.scrollX - this.initialScrollOffset.x,
        y: window.scrollY - this.initialScrollOffset.y
      };
    }

    /**
     * Mirror created handler
     * @param {MirrorCreatedEvent} mirrorEvent
     * @return {Promise}
     * @private
     */

  }, {
    key: onMirrorCreated,
    value: function value(_ref) {
      var _this2 = this;

      var mirror = _ref.mirror,
          source = _ref.source,
          sensorEvent = _ref.sensorEvent;

      var mirrorClass = this.draggable.getClassNameFor('mirror');

      var setState = function setState(_ref2) {
        var mirrorOffset = _ref2.mirrorOffset,
            initialX = _ref2.initialX,
            initialY = _ref2.initialY,
            args = (0, _objectWithoutProperties3.default)(_ref2, ['mirrorOffset', 'initialX', 'initialY']);

        _this2.mirrorOffset = mirrorOffset;
        _this2.initialX = initialX;
        _this2.initialY = initialY;
        return Object.assign({ mirrorOffset: mirrorOffset, initialX: initialX, initialY: initialY }, args);
      };

      var initialState = {
        mirror: mirror,
        source: source,
        sensorEvent: sensorEvent,
        mirrorClass: mirrorClass,
        scrollOffset: this.scrollOffset,
        options: this.options
      };

      return Promise.resolve(initialState)
      // Fix reflow here
      .then(computeMirrorDimensions).then(calculateMirrorOffset).then(resetMirror).then(addMirrorClasses).then(positionMirror({ initial: true })).then(removeMirrorID).then(setState);
    }

    /**
     * Mirror move handler
     * @param {MirrorMoveEvent} mirrorEvent
     * @return {Promise|null}
     * @private
     */

  }, {
    key: onMirrorMove,
    value: function value(mirrorEvent) {
      if (mirrorEvent.canceled()) {
        return null;
      }

      var initialState = {
        mirror: mirrorEvent.mirror,
        sensorEvent: mirrorEvent.sensorEvent,
        mirrorOffset: this.mirrorOffset,
        options: this.options,
        initialX: this.initialX,
        initialY: this.initialY,
        scrollOffset: this.scrollOffset
      };

      return Promise.resolve(initialState).then(positionMirror({ raf: true }));
    }

    /**
     * Returns appendable container for mirror based on the appendTo option
     * @private
     * @param {Object} options
     * @param {HTMLElement} options.source - Current source
     * @return {HTMLElement}
     */

  }, {
    key: getAppendableContainer,
    value: function value(source) {
      var appendTo = this.options.appendTo;

      if (typeof appendTo === 'string') {
        return document.querySelector(appendTo);
      } else if (appendTo instanceof HTMLElement) {
        return appendTo;
      } else if (typeof appendTo === 'function') {
        return appendTo(source);
      } else {
        return source.parentNode;
      }
    }
  }]);
  return Mirror;
}(_AbstractPlugin3.default);

/**
 * Computes mirror dimensions based on the source element
 * Adds sourceRect to state
 * @param {Object} state
 * @param {HTMLElement} state.source
 * @return {Promise}
 * @private
 */


exports.default = Mirror;
function computeMirrorDimensions(_ref3) {
  var source = _ref3.source,
      args = (0, _objectWithoutProperties3.default)(_ref3, ['source']);

  return withPromise(function (resolve) {
    var sourceRect = source.getBoundingClientRect();
    resolve(Object.assign({ source: source, sourceRect: sourceRect }, args));
  });
}

/**
 * Calculates mirror offset
 * Adds mirrorOffset to state
 * @param {Object} state
 * @param {SensorEvent} state.sensorEvent
 * @param {DOMRect} state.sourceRect
 * @return {Promise}
 * @private
 */
function calculateMirrorOffset(_ref4) {
  var sensorEvent = _ref4.sensorEvent,
      sourceRect = _ref4.sourceRect,
      options = _ref4.options,
      args = (0, _objectWithoutProperties3.default)(_ref4, ['sensorEvent', 'sourceRect', 'options']);

  return withPromise(function (resolve) {
    var top = options.cursorOffsetY === null ? sensorEvent.clientY - sourceRect.top : options.cursorOffsetY;
    var left = options.cursorOffsetX === null ? sensorEvent.clientX - sourceRect.left : options.cursorOffsetX;

    var mirrorOffset = { top: top, left: left };

    resolve(Object.assign({ sensorEvent: sensorEvent, sourceRect: sourceRect, mirrorOffset: mirrorOffset, options: options }, args));
  });
}

/**
 * Applys mirror styles
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {HTMLElement} state.source
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function resetMirror(_ref5) {
  var mirror = _ref5.mirror,
      source = _ref5.source,
      options = _ref5.options,
      args = (0, _objectWithoutProperties3.default)(_ref5, ['mirror', 'source', 'options']);

  return withPromise(function (resolve) {
    var offsetHeight = void 0;
    var offsetWidth = void 0;

    if (options.constrainDimensions) {
      var computedSourceStyles = getComputedStyle(source);
      offsetHeight = computedSourceStyles.getPropertyValue('height');
      offsetWidth = computedSourceStyles.getPropertyValue('width');
    }

    mirror.style.position = 'fixed';
    mirror.style.pointerEvents = 'none';
    mirror.style.top = 0;
    mirror.style.left = 0;
    mirror.style.margin = 0;

    if (options.constrainDimensions) {
      mirror.style.height = offsetHeight;
      mirror.style.width = offsetWidth;
    }

    resolve(Object.assign({ mirror: mirror, source: source, options: options }, args));
  });
}

/**
 * Applys mirror class on mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {String} state.mirrorClass
 * @return {Promise}
 * @private
 */
function addMirrorClasses(_ref6) {
  var mirror = _ref6.mirror,
      mirrorClass = _ref6.mirrorClass,
      args = (0, _objectWithoutProperties3.default)(_ref6, ['mirror', 'mirrorClass']);

  return withPromise(function (resolve) {
    mirror.classList.add(mirrorClass);
    resolve(Object.assign({ mirror: mirror, mirrorClass: mirrorClass }, args));
  });
}

/**
 * Removes source ID from cloned mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @return {Promise}
 * @private
 */
function removeMirrorID(_ref7) {
  var mirror = _ref7.mirror,
      args = (0, _objectWithoutProperties3.default)(_ref7, ['mirror']);

  return withPromise(function (resolve) {
    mirror.removeAttribute('id');
    delete mirror.id;
    resolve(Object.assign({ mirror: mirror }, args));
  });
}

/**
 * Positions mirror with translate3d
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {SensorEvent} state.sensorEvent
 * @param {Object} state.mirrorOffset
 * @param {Number} state.initialY
 * @param {Number} state.initialX
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function positionMirror() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref8$withFrame = _ref8.withFrame,
      withFrame = _ref8$withFrame === undefined ? false : _ref8$withFrame,
      _ref8$initial = _ref8.initial,
      initial = _ref8$initial === undefined ? false : _ref8$initial;

  return function (_ref9) {
    var mirror = _ref9.mirror,
        sensorEvent = _ref9.sensorEvent,
        mirrorOffset = _ref9.mirrorOffset,
        initialY = _ref9.initialY,
        initialX = _ref9.initialX,
        scrollOffset = _ref9.scrollOffset,
        options = _ref9.options,
        args = (0, _objectWithoutProperties3.default)(_ref9, ['mirror', 'sensorEvent', 'mirrorOffset', 'initialY', 'initialX', 'scrollOffset', 'options']);

    return withPromise(function (resolve) {
      var result = Object.assign({
        mirror: mirror,
        sensorEvent: sensorEvent,
        mirrorOffset: mirrorOffset,
        options: options
      }, args);

      if (mirrorOffset) {
        var x = sensorEvent.clientX - mirrorOffset.left - scrollOffset.x;
        var y = sensorEvent.clientY - mirrorOffset.top - scrollOffset.y;

        if (options.xAxis && options.yAxis || initial) {
          mirror.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
        } else if (options.xAxis && !options.yAxis) {
          mirror.style.transform = 'translate3d(' + x + 'px, ' + initialY + 'px, 0)';
        } else if (options.yAxis && !options.xAxis) {
          mirror.style.transform = 'translate3d(' + initialX + 'px, ' + y + 'px, 0)';
        }

        if (initial) {
          result.initialX = x;
          result.initialY = y;
        }
      }

      resolve(result);
    }, { frame: withFrame });
  };
}

/**
 * Wraps functions in promise with potential animation frame option
 * @param {Function} callback
 * @param {Object} options
 * @param {Boolean} options.raf
 * @return {Promise}
 * @private
 */
function withPromise(callback) {
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref10$raf = _ref10.raf,
      raf = _ref10$raf === undefined ? false : _ref10$raf;

  return new Promise(function (resolve, reject) {
    if (raf) {
      requestAnimationFrame(function () {
        callback(resolve, reject);
      });
    } else {
      callback(resolve, reject);
    }
  });
}

/**
 * Returns true if the sensor event was triggered by a native browser drag event
 * @param {SensorEvent} sensorEvent
 */
function isNativeDragEvent(sensorEvent) {
  return (/^drag/.test(sensorEvent.originalEvent.type)
  );
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Mirror = __webpack_require__(81);

var _Mirror2 = _interopRequireDefault(_Mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Mirror2.default;
exports.defaultOptions = _Mirror.defaultOptions;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(35);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(84);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(20);
module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(21);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(20);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(41);
var $export = __webpack_require__(11);
var toObject = __webpack_require__(30);
var call = __webpack_require__(88);
var isArrayIter = __webpack_require__(87);
var toLength = __webpack_require__(50);
var createProperty = __webpack_require__(86);
var getIterFn = __webpack_require__(85);

$export($export.S + $export.F * !__webpack_require__(83)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54);
__webpack_require__(89);
module.exports = __webpack_require__(4).Array.from;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(23);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onInitialize = Symbol('onInitialize');
var onDestroy = Symbol('onDestroy');

/**
 * Focusable default options
 * @property {Object} defaultOptions
 * @type {Object}
 */
var defaultOptions = {};

/**
 * Focusable plugin
 * @class Focusable
 * @module Focusable
 * @extends AbstractPlugin
 */

var Focusable = function (_AbstractPlugin) {
  (0, _inherits3.default)(Focusable, _AbstractPlugin);

  /**
   * Focusable constructor.
   * @constructs Focusable
   * @param {Draggable} draggable - Draggable instance
   */
  function Focusable(draggable) {
    (0, _classCallCheck3.default)(this, Focusable);

    /**
     * Focusable options
     * @property {Object} options
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Focusable.__proto__ || Object.getPrototypeOf(Focusable)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    _this[onInitialize] = _this[onInitialize].bind(_this);
    _this[onDestroy] = _this[onDestroy].bind(_this);
    return _this;
  }

  /**
   * Attaches listeners to draggable
   */


  (0, _createClass3.default)(Focusable, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('draggable:initialize', this[onInitialize]).on('draggable:destroy', this[onDestroy]);
    }

    /**
     * Detaches listeners from draggable
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('draggable:initialize', this[onInitialize]).off('draggable:destroy', this[onDestroy]);
    }

    /**
     * Returns options passed through draggable
     * @return {Object}
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.focusable || {};
    }

    /**
     * Returns draggable containers and elements
     * @return {HTMLElement[]}
     */

  }, {
    key: 'getElements',
    value: function getElements() {
      return [].concat((0, _toConsumableArray3.default)(this.draggable.containers), (0, _toConsumableArray3.default)(this.draggable.getDraggableElements()));
    }

    /**
     * Intialize handler
     * @private
     */

  }, {
    key: onInitialize,
    value: function value() {
      var _this2 = this;

      // Can wait until the next best frame is available
      requestAnimationFrame(function () {
        _this2.getElements().forEach(function (element) {
          return decorateElement(element);
        });
      });
    }

    /**
     * Destroy handler
     * @private
     */

  }, {
    key: onDestroy,
    value: function value() {
      var _this3 = this;

      // Can wait until the next best frame is available
      requestAnimationFrame(function () {
        _this3.getElements().forEach(function (element) {
          return stripElement(element);
        });
      });
    }
  }]);
  return Focusable;
}(_AbstractPlugin3.default);

/**
 * Keeps track of all the elements that are missing tabindex attributes
 * so they can be reset when draggable gets destroyed
 * @const {HTMLElement[]} elementsWithMissingTabIndex
 */


exports.default = Focusable;
var elementsWithMissingTabIndex = [];

/**
 * Decorates element with tabindex attributes
 * @param {HTMLElement} element
 * @return {Object}
 * @private
 */
function decorateElement(element) {
  var hasMissingTabIndex = Boolean(!element.getAttribute('tabindex') && element.tabIndex === -1);

  if (hasMissingTabIndex) {
    elementsWithMissingTabIndex.push(element);
    element.tabIndex = 0;
  }
}

/**
 * Removes elements tabindex attributes
 * @param {HTMLElement} element
 * @private
 */
function stripElement(element) {
  var tabIndexElementPosition = elementsWithMissingTabIndex.indexOf(element);

  if (tabIndexElementPosition !== -1) {
    element.tabIndex = -1;
    elementsWithMissingTabIndex.splice(tabIndexElementPosition, 1);
  }
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Focusable = __webpack_require__(92);

var _Focusable2 = _interopRequireDefault(_Focusable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Focusable2.default;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * All draggable plugins inherit from this class.
 * @abstract
 * @class AbstractPlugin
 * @module AbstractPlugin
 */
var AbstractPlugin = function () {
  /**
   * AbstractPlugin constructor.
   * @constructs AbstractPlugin
   * @param {Draggable} draggable - Draggable instance
   */
  function AbstractPlugin(draggable) {
    (0, _classCallCheck3.default)(this, AbstractPlugin);

    /**
     * Draggable instance
     * @property draggable
     * @type {Draggable}
     */
    this.draggable = draggable;
  }

  /**
   * Override to add listeners
   * @abstract
   */


  (0, _createClass3.default)(AbstractPlugin, [{
    key: 'attach',
    value: function attach() {
      throw new Error('Not Implemented');
    }

    /**
     * Override to remove listeners
     * @abstract
     */

  }, {
    key: 'detach',
    value: function detach() {
      throw new Error('Not Implemented');
    }
  }]);
  return AbstractPlugin;
}();

exports.default = AbstractPlugin;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPlugin2 = __webpack_require__(23);

var _AbstractPlugin3 = _interopRequireDefault(_AbstractPlugin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onInitialize = Symbol('onInitialize');
var onDestroy = Symbol('onDestroy');
var announceEvent = Symbol('announceEvent');
var announceMessage = Symbol('announceMessage');

var ARIA_RELEVANT = 'aria-relevant';
var ARIA_ATOMIC = 'aria-atomic';
var ARIA_LIVE = 'aria-live';
var ROLE = 'role';

/**
 * Announcement default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.expire
 * @type {Object}
 */
var defaultOptions = exports.defaultOptions = {
  expire: 7000
};

/**
 * Announcement plugin
 * @class Announcement
 * @module Announcement
 * @extends AbstractPlugin
 */

var Announcement = function (_AbstractPlugin) {
  (0, _inherits3.default)(Announcement, _AbstractPlugin);

  /**
   * Announcement constructor.
   * @constructs Announcement
   * @param {Draggable} draggable - Draggable instance
   */
  function Announcement(draggable) {
    (0, _classCallCheck3.default)(this, Announcement);

    /**
     * Plugin options
     * @property options
     * @type {Object}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Announcement.__proto__ || Object.getPrototypeOf(Announcement)).call(this, draggable));

    _this.options = Object.assign({}, defaultOptions, _this.getOptions());

    /**
     * Original draggable trigger method. Hack until we have onAll or on('all')
     * @property originalTriggerMethod
     * @type {Function}
     */
    _this.originalTriggerMethod = _this.draggable.trigger;

    _this[onInitialize] = _this[onInitialize].bind(_this);
    _this[onDestroy] = _this[onDestroy].bind(_this);
    return _this;
  }

  /**
   * Attaches listeners to draggable
   */


  (0, _createClass3.default)(Announcement, [{
    key: 'attach',
    value: function attach() {
      this.draggable.on('draggable:initialize', this[onInitialize]);
    }

    /**
     * Detaches listeners from draggable
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.draggable.off('draggable:destroy', this[onDestroy]);
    }

    /**
     * Returns passed in options
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.draggable.options.announcements || {};
    }

    /**
     * Announces event
     * @private
     * @param {AbstractEvent} event
     */

  }, {
    key: announceEvent,
    value: function value(event) {
      var message = this.options[event.type];

      if (message && typeof message === 'string') {
        this[announceMessage](message);
      }

      if (message && typeof message === 'function') {
        this[announceMessage](message(event));
      }
    }

    /**
     * Announces message to screen reader
     * @private
     * @param {String} message
     */

  }, {
    key: announceMessage,
    value: function value(message) {
      announce(message, { expire: this.options.expire });
    }

    /**
     * Initialize hander
     * @private
     */

  }, {
    key: onInitialize,
    value: function value() {
      var _this2 = this;

      // Hack until there is an api for listening for all events
      this.draggable.trigger = function (event) {
        try {
          _this2[announceEvent](event);
        } finally {
          // Ensure that original trigger is called
          _this2.originalTriggerMethod.call(_this2.draggable, event);
        }
      };
    }

    /**
     * Destroy hander
     * @private
     */

  }, {
    key: onDestroy,
    value: function value() {
      this.draggable.trigger = this.originalTriggerMethod;
    }
  }]);
  return Announcement;
}(_AbstractPlugin3.default);

/**
 * @const {HTMLElement} liveRegion
 */


exports.default = Announcement;
var liveRegion = createRegion();

/**
 * Announces message via live region
 * @param {String} message
 * @param {Object} options
 * @param {Number} options.expire
 */
function announce(message, _ref) {
  var expire = _ref.expire;

  var element = document.createElement('div');

  element.textContent = message;
  liveRegion.appendChild(element);

  return setTimeout(function () {
    liveRegion.removeChild(element);
  }, expire);
}

/**
 * Creates region element
 * @return {HTMLElement}
 */
function createRegion() {
  var element = document.createElement('div');

  element.setAttribute('id', 'draggable-live-region');
  element.setAttribute(ARIA_RELEVANT, 'additions');
  element.setAttribute(ARIA_ATOMIC, 'true');
  element.setAttribute(ARIA_LIVE, 'assertive');
  element.setAttribute(ROLE, 'log');

  element.style.position = 'fixed';
  element.style.width = '1px';
  element.style.height = '1px';
  element.style.top = '-1px';
  element.style.overflow = 'hidden';

  return element;
}

// Append live region element as early as possible
document.addEventListener('DOMContentLoaded', function () {
  document.body.appendChild(liveRegion);
});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Announcement = __webpack_require__(95);

var _Announcement2 = _interopRequireDefault(_Announcement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Announcement2.default;
exports.defaultOptions = _Announcement.defaultOptions;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableDestroyEvent = exports.DraggableInitializedEvent = exports.DraggableEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(19);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base draggable event
 * @class DraggableEvent
 * @module DraggableEvent
 * @extends AbstractEvent
 */
var DraggableEvent = exports.DraggableEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(DraggableEvent, _AbstractEvent);

  function DraggableEvent() {
    (0, _classCallCheck3.default)(this, DraggableEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DraggableEvent.__proto__ || Object.getPrototypeOf(DraggableEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DraggableEvent, [{
    key: 'draggable',


    /**
     * Draggable instance
     * @property draggable
     * @type {Draggable}
     * @readonly
     */
    get: function get() {
      return this.data.draggable;
    }
  }]);
  return DraggableEvent;
}(_AbstractEvent3.default);

/**
 * Draggable initialized event
 * @class DraggableInitializedEvent
 * @module DraggableInitializedEvent
 * @extends DraggableEvent
 */


DraggableEvent.type = 'draggable';

var DraggableInitializedEvent = exports.DraggableInitializedEvent = function (_DraggableEvent) {
  (0, _inherits3.default)(DraggableInitializedEvent, _DraggableEvent);

  function DraggableInitializedEvent() {
    (0, _classCallCheck3.default)(this, DraggableInitializedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DraggableInitializedEvent.__proto__ || Object.getPrototypeOf(DraggableInitializedEvent)).apply(this, arguments));
  }

  return DraggableInitializedEvent;
}(DraggableEvent);

/**
 * Draggable destory event
 * @class DraggableInitializedEvent
 * @module DraggableDestroyEvent
 * @extends DraggableDestroyEvent
 */


DraggableInitializedEvent.type = 'draggable:initialize';

var DraggableDestroyEvent = exports.DraggableDestroyEvent = function (_DraggableEvent2) {
  (0, _inherits3.default)(DraggableDestroyEvent, _DraggableEvent2);

  function DraggableDestroyEvent() {
    (0, _classCallCheck3.default)(this, DraggableDestroyEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DraggableDestroyEvent.__proto__ || Object.getPrototypeOf(DraggableDestroyEvent)).apply(this, arguments));
  }

  return DraggableDestroyEvent;
}(DraggableEvent);

DraggableDestroyEvent.type = 'draggable:destroy';

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragStopEvent = exports.DragPressureEvent = exports.DragOutContainerEvent = exports.DragOverContainerEvent = exports.DragOutEvent = exports.DragOverEvent = exports.DragMoveEvent = exports.DragStartEvent = exports.DragEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(19);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base drag event
 * @class DragEvent
 * @module DragEvent
 * @extends AbstractEvent
 */
var DragEvent = exports.DragEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(DragEvent, _AbstractEvent);

  function DragEvent() {
    (0, _classCallCheck3.default)(this, DragEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragEvent.__proto__ || Object.getPrototypeOf(DragEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragEvent, [{
    key: 'source',


    /**
     * Draggables source element
     * @property source
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.source;
    }

    /**
     * Draggables original source element
     * @property originalSource
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'originalSource',
    get: function get() {
      return this.data.originalSource;
    }

    /**
     * Draggables mirror element
     * @property mirror
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'mirror',
    get: function get() {
      return this.data.mirror;
    }

    /**
     * Draggables source container element
     * @property sourceContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'sourceContainer',
    get: function get() {
      return this.data.sourceContainer;
    }

    /**
     * Sensor event
     * @property sensorEvent
     * @type {SensorEvent}
     * @readonly
     */

  }, {
    key: 'sensorEvent',
    get: function get() {
      return this.data.sensorEvent;
    }

    /**
     * Original event that triggered sensor event
     * @property originalEvent
     * @type {Event}
     * @readonly
     */

  }, {
    key: 'originalEvent',
    get: function get() {
      if (this.sensorEvent) {
        return this.sensorEvent.originalEvent;
      }

      return null;
    }
  }]);
  return DragEvent;
}(_AbstractEvent3.default);

/**
 * Drag start event
 * @class DragStartEvent
 * @module DragStartEvent
 * @extends DragEvent
 */


DragEvent.type = 'drag';

var DragStartEvent = exports.DragStartEvent = function (_DragEvent) {
  (0, _inherits3.default)(DragStartEvent, _DragEvent);

  function DragStartEvent() {
    (0, _classCallCheck3.default)(this, DragStartEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStartEvent.__proto__ || Object.getPrototypeOf(DragStartEvent)).apply(this, arguments));
  }

  return DragStartEvent;
}(DragEvent);

/**
 * Drag move event
 * @class DragMoveEvent
 * @module DragMoveEvent
 * @extends DragEvent
 */


DragStartEvent.type = 'drag:start';
DragStartEvent.cancelable = true;

var DragMoveEvent = exports.DragMoveEvent = function (_DragEvent2) {
  (0, _inherits3.default)(DragMoveEvent, _DragEvent2);

  function DragMoveEvent() {
    (0, _classCallCheck3.default)(this, DragMoveEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragMoveEvent.__proto__ || Object.getPrototypeOf(DragMoveEvent)).apply(this, arguments));
  }

  return DragMoveEvent;
}(DragEvent);

/**
 * Drag over event
 * @class DragOverEvent
 * @module DragOverEvent
 * @extends DragEvent
 */


DragMoveEvent.type = 'drag:move';

var DragOverEvent = exports.DragOverEvent = function (_DragEvent3) {
  (0, _inherits3.default)(DragOverEvent, _DragEvent3);

  function DragOverEvent() {
    (0, _classCallCheck3.default)(this, DragOverEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOverEvent.__proto__ || Object.getPrototypeOf(DragOverEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOverEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you are over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }

    /**
     * Draggable element you are over
     * @property over
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'over',
    get: function get() {
      return this.data.over;
    }
  }]);
  return DragOverEvent;
}(DragEvent);

/**
 * Drag out event
 * @class DragOutEvent
 * @module DragOutEvent
 * @extends DragEvent
 */


DragOverEvent.type = 'drag:over';
DragOverEvent.cancelable = true;

var DragOutEvent = exports.DragOutEvent = function (_DragEvent4) {
  (0, _inherits3.default)(DragOutEvent, _DragEvent4);

  function DragOutEvent() {
    (0, _classCallCheck3.default)(this, DragOutEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOutEvent.__proto__ || Object.getPrototypeOf(DragOutEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOutEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you are over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }

    /**
     * Draggable element you left
     * @property over
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'over',
    get: function get() {
      return this.data.over;
    }
  }]);
  return DragOutEvent;
}(DragEvent);

/**
 * Drag over container event
 * @class DragOverContainerEvent
 * @module DragOverContainerEvent
 * @extends DragEvent
 */


DragOutEvent.type = 'drag:out';

var DragOverContainerEvent = exports.DragOverContainerEvent = function (_DragEvent5) {
  (0, _inherits3.default)(DragOverContainerEvent, _DragEvent5);

  function DragOverContainerEvent() {
    (0, _classCallCheck3.default)(this, DragOverContainerEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOverContainerEvent.__proto__ || Object.getPrototypeOf(DragOverContainerEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOverContainerEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you are over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }
  }]);
  return DragOverContainerEvent;
}(DragEvent);

/**
 * Drag out container event
 * @class DragOutContainerEvent
 * @module DragOutContainerEvent
 * @extends DragEvent
 */


DragOverContainerEvent.type = 'drag:over:container';

var DragOutContainerEvent = exports.DragOutContainerEvent = function (_DragEvent6) {
  (0, _inherits3.default)(DragOutContainerEvent, _DragEvent6);

  function DragOutContainerEvent() {
    (0, _classCallCheck3.default)(this, DragOutContainerEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragOutContainerEvent.__proto__ || Object.getPrototypeOf(DragOutContainerEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragOutContainerEvent, [{
    key: 'overContainer',


    /**
     * Draggable container you left
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */
    get: function get() {
      return this.data.overContainer;
    }
  }]);
  return DragOutContainerEvent;
}(DragEvent);

/**
 * Drag pressure event
 * @class DragPressureEvent
 * @module DragPressureEvent
 * @extends DragEvent
 */


DragOutContainerEvent.type = 'drag:out:container';

var DragPressureEvent = exports.DragPressureEvent = function (_DragEvent7) {
  (0, _inherits3.default)(DragPressureEvent, _DragEvent7);

  function DragPressureEvent() {
    (0, _classCallCheck3.default)(this, DragPressureEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragPressureEvent.__proto__ || Object.getPrototypeOf(DragPressureEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DragPressureEvent, [{
    key: 'pressure',


    /**
     * Pressure applied on draggable element
     * @property pressure
     * @type {Number}
     * @readonly
     */
    get: function get() {
      return this.data.pressure;
    }
  }]);
  return DragPressureEvent;
}(DragEvent);

/**
 * Drag stop event
 * @class DragStopEvent
 * @module DragStopEvent
 * @extends DragEvent
 */


DragPressureEvent.type = 'drag:pressure';

var DragStopEvent = exports.DragStopEvent = function (_DragEvent8) {
  (0, _inherits3.default)(DragStopEvent, _DragEvent8);

  function DragStopEvent() {
    (0, _classCallCheck3.default)(this, DragStopEvent);
    return (0, _possibleConstructorReturn3.default)(this, (DragStopEvent.__proto__ || Object.getPrototypeOf(DragStopEvent)).apply(this, arguments));
  }

  return DragStopEvent;
}(DragEvent);

DragStopEvent.type = 'drag:stop';

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragEvent = __webpack_require__(45);

Object.keys(_DragEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DragEvent[key];
    }
  });
});

var _DraggableEvent = __webpack_require__(44);

Object.keys(_DraggableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DraggableEvent[key];
    }
  });
});

var _Plugins = __webpack_require__(43);

Object.keys(_Plugins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Plugins[key];
    }
  });
});

var _Sensors = __webpack_require__(42);

Object.keys(_Sensors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Sensors[key];
    }
  });
});

var _Draggable = __webpack_require__(61);

var _Draggable2 = _interopRequireDefault(_Draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Draggable2.default;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(8);
var $getOwnPropertyDescriptor = __webpack_require__(26).f;

__webpack_require__(46)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
var $Object = __webpack_require__(4).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(30);
var $getPrototypeOf = __webpack_require__(49);

__webpack_require__(46)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
module.exports = __webpack_require__(4).Object.getPrototypeOf;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(104), __esModule: true };

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(105);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(102);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(106);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Draggable2 = __webpack_require__(99);

var _Draggable3 = _interopRequireDefault(_Draggable2);

var _SortableEvent = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDragStart = Symbol('onDragStart');
var onDragOverContainer = Symbol('onDragOverContainer');
var onDragOver = Symbol('onDragOver');
var onDragStop = Symbol('onDragStop');

/**
 * Returns announcement message when a Draggable element has been sorted with another Draggable element
 * or moved into a new container
 * @param {SortableSortedEvent} sortableEvent
 * @return {String}
 */
function onSortableSortedDefaultAnnouncement(_ref) {
  var dragEvent = _ref.dragEvent;

  var sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || 'sortable element';

  if (dragEvent.over) {
    var overText = dragEvent.over.textContent.trim() || dragEvent.over.id || 'sortable element';
    var isFollowing = dragEvent.source.compareDocumentPosition(dragEvent.over) & Node.DOCUMENT_POSITION_FOLLOWING;

    if (isFollowing) {
      return 'Placed ' + sourceText + ' after ' + overText;
    } else {
      return 'Placed ' + sourceText + ' before ' + overText;
    }
  } else {
    // need to figure out how to compute container name
    return 'Placed ' + sourceText + ' into a different container';
  }
}

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['sortable:sorted']
 */
var defaultAnnouncements = {
  'sortable:sorted': onSortableSortedDefaultAnnouncement
};

/**
 * Sortable is built on top of Draggable and allows sorting of draggable elements. Sortable will keep
 * track of the original index and emits the new index as you drag over draggable elements.
 * @class Sortable
 * @module Sortable
 * @extends Draggable
 */

var Sortable = function (_Draggable) {
  (0, _inherits3.default)(Sortable, _Draggable);

  /**
   * Sortable constructor.
   * @constructs Sortable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Sortable containers
   * @param {Object} options - Options for Sortable
   */
  function Sortable() {
    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Sortable);

    /**
     * start index of source on drag start
     * @property startIndex
     * @type {Number}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Sortable.__proto__ || Object.getPrototypeOf(Sortable)).call(this, containers, Object.assign({}, options, {
      announcements: Object.assign({}, defaultAnnouncements, options.announcements || {})
    })));

    _this.startIndex = null;

    /**
     * start container on drag start
     * @property startContainer
     * @type {HTMLElement}
     * @default null
     */
    _this.startContainer = null;

    _this[onDragStart] = _this[onDragStart].bind(_this);
    _this[onDragOverContainer] = _this[onDragOverContainer].bind(_this);
    _this[onDragOver] = _this[onDragOver].bind(_this);
    _this[onDragStop] = _this[onDragStop].bind(_this);

    _this.on('drag:start', _this[onDragStart]).on('drag:over:container', _this[onDragOverContainer]).on('drag:over', _this[onDragOver]).on('drag:stop', _this[onDragStop]);
    return _this;
  }

  /**
   * Destroys Sortable instance.
   */


  (0, _createClass3.default)(Sortable, [{
    key: 'destroy',
    value: function destroy() {
      (0, _get3.default)(Sortable.prototype.__proto__ || Object.getPrototypeOf(Sortable.prototype), 'destroy', this).call(this);

      this.off('drag:start', this[onDragStart]).off('drag:over:container', this[onDragOverContainer]).off('drag:over', this[onDragOver]).off('drag:stop', this[onDragStop]);
    }

    /**
     * Returns true index of element within its container during drag operation, i.e. excluding mirror and original source
     * @param {HTMLElement} element - An element
     * @return {Number}
     */

  }, {
    key: 'index',
    value: function index(element) {
      return this.getDraggableElementsForContainer(element.parentNode).indexOf(element);
    }

    /**
     * Drag start handler
     * @private
     * @param {DragStartEvent} event - Drag start event
     */

  }, {
    key: onDragStart,
    value: function value(event) {
      this.startContainer = event.source.parentNode;
      this.startIndex = this.index(event.source);

      var sortableStartEvent = new _SortableEvent.SortableStartEvent({
        dragEvent: event,
        startIndex: this.startIndex,
        startContainer: this.startContainer
      });

      this.trigger(sortableStartEvent);

      if (sortableStartEvent.canceled()) {
        event.cancel();
      }
    }

    /**
     * Drag over container handler
     * @private
     * @param {DragOverContainerEvent} event - Drag over container event
     */

  }, {
    key: onDragOverContainer,
    value: function value(event) {
      if (event.canceled()) {
        return;
      }

      var source = event.source,
          over = event.over,
          overContainer = event.overContainer;

      var oldIndex = this.index(source);

      var sortableSortEvent = new _SortableEvent.SortableSortEvent({
        dragEvent: event,
        currentIndex: oldIndex,
        source: source,
        over: over
      });

      this.trigger(sortableSortEvent);

      if (sortableSortEvent.canceled()) {
        return;
      }

      var children = this.getDraggableElementsForContainer(overContainer);
      var moves = move({ source: source, over: over, overContainer: overContainer, children: children });

      if (!moves) {
        return;
      }

      var oldContainer = moves.oldContainer,
          newContainer = moves.newContainer;

      var newIndex = this.index(event.source);

      var sortableSortedEvent = new _SortableEvent.SortableSortedEvent({
        dragEvent: event,
        oldIndex: oldIndex,
        newIndex: newIndex,
        oldContainer: oldContainer,
        newContainer: newContainer
      });

      this.trigger(sortableSortedEvent);
    }

    /**
     * Drag over handler
     * @private
     * @param {DragOverEvent} event - Drag over event
     */

  }, {
    key: onDragOver,
    value: function value(event) {
      if (event.over === event.originalSource || event.over === event.source) {
        return;
      }

      var source = event.source,
          over = event.over,
          overContainer = event.overContainer;

      var oldIndex = this.index(source);

      var sortableSortEvent = new _SortableEvent.SortableSortEvent({
        dragEvent: event,
        currentIndex: oldIndex,
        source: source,
        over: over
      });

      this.trigger(sortableSortEvent);

      if (sortableSortEvent.canceled()) {
        return;
      }

      var children = this.getDraggableElementsForContainer(overContainer);
      var moves = move({ source: source, over: over, overContainer: overContainer, children: children });

      if (!moves) {
        return;
      }

      var oldContainer = moves.oldContainer,
          newContainer = moves.newContainer;

      var newIndex = this.index(source);

      var sortableSortedEvent = new _SortableEvent.SortableSortedEvent({
        dragEvent: event,
        oldIndex: oldIndex,
        newIndex: newIndex,
        oldContainer: oldContainer,
        newContainer: newContainer
      });

      this.trigger(sortableSortedEvent);
    }

    /**
     * Drag stop handler
     * @private
     * @param {DragStopEvent} event - Drag stop event
     */

  }, {
    key: onDragStop,
    value: function value(event) {
      var sortableStopEvent = new _SortableEvent.SortableStopEvent({
        dragEvent: event,
        oldIndex: this.startIndex,
        newIndex: this.index(event.source),
        oldContainer: this.startContainer,
        newContainer: event.source.parentNode
      });

      this.trigger(sortableStopEvent);

      this.startIndex = null;
      this.startContainer = null;
    }
  }]);
  return Sortable;
}(_Draggable3.default);

exports.default = Sortable;


function index(element) {
  return Array.prototype.indexOf.call(element.parentNode.children, element);
}

function move(_ref2) {
  var source = _ref2.source,
      over = _ref2.over,
      overContainer = _ref2.overContainer,
      children = _ref2.children;

  var emptyOverContainer = !children.length;
  var differentContainer = source.parentNode !== overContainer;
  var sameContainer = over && !differentContainer;

  if (emptyOverContainer) {
    return moveInsideEmptyContainer(source, overContainer);
  } else if (sameContainer) {
    return moveWithinContainer(source, over);
  } else if (differentContainer) {
    return moveOutsideContainer(source, over, overContainer);
  } else {
    return null;
  }
}

function moveInsideEmptyContainer(source, overContainer) {
  var oldContainer = source.parentNode;

  overContainer.appendChild(source);

  return { oldContainer: oldContainer, newContainer: overContainer };
}

function moveWithinContainer(source, over) {
  var oldIndex = index(source);
  var newIndex = index(over);

  if (oldIndex < newIndex) {
    source.parentNode.insertBefore(source, over.nextElementSibling);
  } else {
    source.parentNode.insertBefore(source, over);
  }

  return { oldContainer: source.parentNode, newContainer: source.parentNode };
}

function moveOutsideContainer(source, over, overContainer) {
  var oldContainer = source.parentNode;

  if (over) {
    over.parentNode.insertBefore(source, over);
  } else {
    // need to figure out proper position
    overContainer.appendChild(source);
  }

  return { oldContainer: oldContainer, newContainer: source.parentNode };
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _canceled = Symbol('canceled');

/**
 * All events fired by draggable inherit this class. You can call `cancel()` to
 * cancel a specific event or you can check if an event has been canceled by
 * calling `canceled()`.
 * @abstract
 * @class AbstractEvent
 * @module AbstractEvent
 */

var AbstractEvent = function () {

  /**
   * AbstractEvent constructor.
   * @constructs AbstractEvent
   * @param {object} data - Event data
   */

  /**
   * Event type
   * @static
   * @abstract
   * @property type
   * @type {String}
   */
  function AbstractEvent(data) {
    (0, _classCallCheck3.default)(this, AbstractEvent);

    this[_canceled] = false;
    this.data = data;
  }

  /**
   * Read-only type
   * @abstract
   * @return {String}
   */


  /**
   * Event cancelable
   * @static
   * @abstract
   * @property cancelable
   * @type {Boolean}
   */


  (0, _createClass3.default)(AbstractEvent, [{
    key: 'cancel',


    /**
     * Cancels the event instance
     * @abstract
     */
    value: function cancel() {
      this[_canceled] = true;
    }

    /**
     * Check if event has been canceled
     * @abstract
     * @return {Boolean}
     */

  }, {
    key: 'canceled',
    value: function canceled() {
      return Boolean(this[_canceled]);
    }

    /**
     * Returns new event instance with existing event data.
     * This method allows for overriding of event data.
     * @param {Object} data
     * @return {AbstractEvent}
     */

  }, {
    key: 'clone',
    value: function clone(data) {
      return new this.constructor(Object.assign({}, this.data, data));
    }
  }, {
    key: 'type',
    get: function get() {
      return this.constructor.type;
    }

    /**
     * Read-only cancelable
     * @abstract
     * @return {Boolean}
     */

  }, {
    key: 'cancelable',
    get: function get() {
      return this.constructor.cancelable;
    }
  }]);
  return AbstractEvent;
}();

AbstractEvent.type = 'event';
AbstractEvent.cancelable = false;
exports.default = AbstractEvent;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(11);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(37) });


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
var $Object = __webpack_require__(4).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(110), __esModule: true };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(13);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(41)(Function.call, __webpack_require__(26).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(11);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(112).set });


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113);
module.exports = __webpack_require__(4).Object.setPrototypeOf;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('observable');


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('asyncIterator');


/***/ }),
/* 118 */
/***/ (function(module, exports) {



/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(8);
var gOPN = __webpack_require__(47).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(35);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(27);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(24)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(9);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(22)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(7);
var has = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(10);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(52);
var META = __webpack_require__(122).KEY;
var $fails = __webpack_require__(22);
var shared = __webpack_require__(33);
var setToStringTag = __webpack_require__(31);
var uid = __webpack_require__(24);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(29);
var wksDefine = __webpack_require__(28);
var enumKeys = __webpack_require__(121);
var isArray = __webpack_require__(120);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(12);
var toIObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(40);
var createDesc = __webpack_require__(21);
var _create = __webpack_require__(37);
var gOPNExt = __webpack_require__(119);
var $GOPD = __webpack_require__(26);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(47).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(27).f = $propertyIsEnumerable;
  __webpack_require__(48).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(25)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(14)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
__webpack_require__(118);
__webpack_require__(117);
__webpack_require__(116);
module.exports = __webpack_require__(4).Symbol;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(124), __esModule: true };

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(127);
var step = __webpack_require__(126);
var Iterators = __webpack_require__(20);
var toIObject = __webpack_require__(8);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(53)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
var global = __webpack_require__(7);
var hide = __webpack_require__(14);
var Iterators = __webpack_require__(20);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(7).document;
module.exports = document && document.documentElement;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(8);
var toLength = __webpack_require__(50);
var toAbsoluteIndex = __webpack_require__(131);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(35);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(13);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(37);
var descriptor = __webpack_require__(21);
var setToStringTag = __webpack_require__(31);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(14)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);
var defined = __webpack_require__(38);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54);
__webpack_require__(129);
module.exports = __webpack_require__(29).f('iterator');


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(137), __esModule: true };

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(11);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(10), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(140);
var $Object = __webpack_require__(4).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(141), __esModule: true };

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableStopEvent = exports.SortableSortedEvent = exports.SortableSortEvent = exports.SortableStartEvent = exports.SortableEvent = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(0);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractEvent2 = __webpack_require__(19);

var _AbstractEvent3 = _interopRequireDefault(_AbstractEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sortable event
 * @class SortableEvent
 * @module SortableEvent
 * @extends AbstractEvent
 */
var SortableEvent = exports.SortableEvent = function (_AbstractEvent) {
  (0, _inherits3.default)(SortableEvent, _AbstractEvent);

  function SortableEvent() {
    (0, _classCallCheck3.default)(this, SortableEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SortableEvent.__proto__ || Object.getPrototypeOf(SortableEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableEvent, [{
    key: 'dragEvent',


    /**
     * Original drag event that triggered this sortable event
     * @property dragEvent
     * @type {DragEvent}
     * @readonly
     */
    get: function get() {
      return this.data.dragEvent;
    }
  }]);
  return SortableEvent;
}(_AbstractEvent3.default);

/**
 * Sortable start event
 * @class SortableStartEvent
 * @module SortableStartEvent
 * @extends SortableEvent
 */


SortableEvent.type = 'sortable';

var SortableStartEvent = exports.SortableStartEvent = function (_SortableEvent) {
  (0, _inherits3.default)(SortableStartEvent, _SortableEvent);

  function SortableStartEvent() {
    (0, _classCallCheck3.default)(this, SortableStartEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SortableStartEvent.__proto__ || Object.getPrototypeOf(SortableStartEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableStartEvent, [{
    key: 'startIndex',


    /**
     * Start index of source on sortable start
     * @property startIndex
     * @type {Number}
     * @readonly
     */
    get: function get() {
      return this.data.startIndex;
    }

    /**
     * Start container on sortable start
     * @property startContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'startContainer',
    get: function get() {
      return this.data.startContainer;
    }
  }]);
  return SortableStartEvent;
}(SortableEvent);

/**
 * Sortable sort event
 * @class SortableSortEvent
 * @module SortableSortEvent
 * @extends SortableEvent
 */


SortableStartEvent.type = 'sortable:start';
SortableStartEvent.cancelable = true;

var SortableSortEvent = exports.SortableSortEvent = function (_SortableEvent2) {
  (0, _inherits3.default)(SortableSortEvent, _SortableEvent2);

  function SortableSortEvent() {
    (0, _classCallCheck3.default)(this, SortableSortEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SortableSortEvent.__proto__ || Object.getPrototypeOf(SortableSortEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableSortEvent, [{
    key: 'currentIndex',


    /**
     * Index of current draggable element
     * @property currentIndex
     * @type {Number}
     * @readonly
     */
    get: function get() {
      return this.data.currentIndex;
    }

    /**
     * Draggable element you are hovering over
     * @property over
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'over',
    get: function get() {
      return this.data.oldIndex;
    }

    /**
     * Draggable container element you are hovering over
     * @property overContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'overContainer',
    get: function get() {
      return this.data.newIndex;
    }
  }]);
  return SortableSortEvent;
}(SortableEvent);

/**
 * Sortable sorted event
 * @class SortableSortedEvent
 * @module SortableSortedEvent
 * @extends SortableEvent
 */


SortableSortEvent.type = 'sortable:sort';
SortableSortEvent.cancelable = true;

var SortableSortedEvent = exports.SortableSortedEvent = function (_SortableEvent3) {
  (0, _inherits3.default)(SortableSortedEvent, _SortableEvent3);

  function SortableSortedEvent() {
    (0, _classCallCheck3.default)(this, SortableSortedEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SortableSortedEvent.__proto__ || Object.getPrototypeOf(SortableSortedEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableSortedEvent, [{
    key: 'oldIndex',


    /**
     * Index of last sorted event
     * @property oldIndex
     * @type {Number}
     * @readonly
     */
    get: function get() {
      return this.data.oldIndex;
    }

    /**
     * New index of this sorted event
     * @property newIndex
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'newIndex',
    get: function get() {
      return this.data.newIndex;
    }

    /**
     * Old container of draggable element
     * @property oldContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'oldContainer',
    get: function get() {
      return this.data.oldContainer;
    }

    /**
     * New container of draggable element
     * @property newContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'newContainer',
    get: function get() {
      return this.data.newContainer;
    }
  }]);
  return SortableSortedEvent;
}(SortableEvent);

/**
 * Sortable stop event
 * @class SortableStopEvent
 * @module SortableStopEvent
 * @extends SortableEvent
 */


SortableSortedEvent.type = 'sortable:sorted';

var SortableStopEvent = exports.SortableStopEvent = function (_SortableEvent4) {
  (0, _inherits3.default)(SortableStopEvent, _SortableEvent4);

  function SortableStopEvent() {
    (0, _classCallCheck3.default)(this, SortableStopEvent);
    return (0, _possibleConstructorReturn3.default)(this, (SortableStopEvent.__proto__ || Object.getPrototypeOf(SortableStopEvent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableStopEvent, [{
    key: 'oldIndex',


    /**
     * Original index on sortable start
     * @property oldIndex
     * @type {Number}
     * @readonly
     */
    get: function get() {
      return this.data.oldIndex;
    }

    /**
     * New index of draggable element
     * @property newIndex
     * @type {Number}
     * @readonly
     */

  }, {
    key: 'newIndex',
    get: function get() {
      return this.data.newIndex;
    }

    /**
     * Original container of draggable element
     * @property oldContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'oldContainer',
    get: function get() {
      return this.data.oldContainer;
    }

    /**
     * New container of draggable element
     * @property newContainer
     * @type {HTMLElement}
     * @readonly
     */

  }, {
    key: 'newContainer',
    get: function get() {
      return this.data.newContainer;
    }
  }]);
  return SortableStopEvent;
}(SortableEvent);

SortableStopEvent.type = 'sortable:stop';

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableEvent = __webpack_require__(58);

Object.keys(_SortableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SortableEvent[key];
    }
  });
});

var _Sortable = __webpack_require__(107);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sortable2.default;

/***/ })
/******/ ]);
});

/***/ }),

/***/ "f3c1":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "f4d6":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("ffd6");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "f528":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-button[data-v-262299fd]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:visible;border:none;outline:none;-webkit-transition-property:background-color,color,opacity,-webkit-transform;transition-property:background-color,color,opacity,-webkit-transform;transition-property:background-color,color,opacity,transform;transition-property:background-color,color,opacity,transform,-webkit-transform;-webkit-transition-duration:.2s;transition-duration:.2s;font-size:.375rem;font-weight:700;color:var(--c-text--lighten-20);white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:inherit}.ui-button[data-v-262299fd]:before{content:\"\";position:absolute;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.15);opacity:0;-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.1s;transition-duration:.1s;border-radius:inherit}.ui-button .label[data-v-262299fd]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.ui-button.horizontal.icon-on-left.has-label .icon[data-v-262299fd]{margin-right:.25rem}.ui-button.horizontal.icon-on-right[data-v-262299fd]{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui-button.horizontal.icon-on-right.has-label .icon[data-v-262299fd]{margin-left:.25rem}.ui-button.vertical[data-v-262299fd]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui-button.vertical[data-v-262299fd]>:not(:last-child){margin-bottom:.125rem}.ui-button.interactable.enabled[data-v-262299fd]{cursor:pointer}.ui-button.disabled[data-v-262299fd]{cursor:not-allowed;opacity:.4}.ui-button.tiny[data-v-262299fd]{font-size:.3125rem;padding:.125rem}.ui-button.tiny.has-label[data-v-262299fd]{padding-left:.1875rem;padding-right:.1875rem}.ui-button.tiny.has-label.horizontal.icon-on-left .icon[data-v-262299fd]{margin-right:.125rem}.ui-button.tiny.has-label.horizontal.icon-on-right .icon[data-v-262299fd]{margin-left:.125rem}.ui-button.small[data-v-262299fd]{padding:.166666666666667rem}.ui-button.small[data-v-262299fd]:not(.uppercase){font-size:.375rem}.ui-button.small.uppercase[data-v-262299fd]{font-size:.3125rem}.ui-button.small.has-label[data-v-262299fd]{padding-left:.25rem;padding-right:.25rem}.ui-button.small.has-label.horizontal.icon-on-left .icon[data-v-262299fd]{margin-right:.125rem}.ui-button.small.has-label.horizontal.icon-on-right .icon[data-v-262299fd]{margin-left:.125rem}.ui-button.medium[data-v-262299fd]{padding:.25rem}.ui-button.medium[data-v-262299fd]:not(.uppercase){font-size:.4375rem}.ui-button.medium.uppercase[data-v-262299fd]{font-size:.375rem}.ui-button.medium.has-label[data-v-262299fd]{padding-left:.375rem;padding-right:.375rem}.ui-button.medium.has-label.horizontal.icon-on-left .icon[data-v-262299fd]{margin-right:.25rem}.ui-button.medium.has-label.horizontal.icon-on-right .icon[data-v-262299fd]{margin-left:.25rem}.ui-button.big[data-v-262299fd]{font-size:.5rem;padding:.25rem .5rem}.ui-button.big.has-label.horizontal.icon-on-left .icon[data-v-262299fd]{margin-right:.25rem}.ui-button.big.has-label.horizontal.icon-on-right .icon[data-v-262299fd]{margin-left:.25rem}.ui-button.big.horizontal[data-v-262299fd]{min-height:1.3125rem}.ui-button.bare[data-v-262299fd]{padding:0}.ui-button.bare[data-v-262299fd]:hover{background-color:unset}.ui-button.big.embedded[data-v-262299fd]{padding:.5rem}.ui-button.no-color.flat.prominent.dark.not-selected[data-v-262299fd]{background-color:var(--c-black--opacity-5);color:var(--c-text)}.ui-button.no-color.flat.prominent.dark.not-selected.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-black--opacity-15)}.ui-button.no-color.flat.prominent.dark.selected[data-v-262299fd]{background-color:var(--c-primary);color:var(--c-text-light)}.ui-button.no-color.flat.prominent.light.not-selected[data-v-262299fd]{background-color:var(--c-white--opacity-20);color:var(--c-text-light)}.ui-button.no-color.flat.prominent.light.not-selected.interactable.enabled[data-v-262299fd]:hover{color:var(--c-text);background-color:var(--c-white)}.ui-button.no-color.floating[data-v-262299fd]{background-color:var(--c-white)}.ui-button.no-color.flat.subtle.dark.not-selected[data-v-262299fd]{background:none;color:var(--c-text--lighten-20)}.ui-button.no-color.flat.subtle.dark.not-selected.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-black--opacity-10);color:var(--c-text)}.ui-button.no-color.flat.subtle.dark.selected[data-v-262299fd]{background-color:var(--c-black--opacity-10);color:var(--c-primary)}.ui-button.no-color.flat.subtle.light.not-selected[data-v-262299fd]{color:var(--c-text-light);background:none}.ui-button.no-color.flat.subtle.light.not-selected.interactable.enabled[data-v-262299fd]:hover{color:var(--c-text-light);background-color:var(--c-white--opacity-20)}.ui-button.no-color.flat.subtle.light.selected[data-v-262299fd]{color:var(--c-text-light);background:var(--c-white--opacity-20)}.ui-button.no-color.flat.subtle.light.selected.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-white--opacity-20)}.ui-button.no-color.flat.discreet.dark.not-selected[data-v-262299fd]{background:none;color:var(--c-text--lighten-40)}.ui-button.no-color.flat.discreet.dark.not-selected.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-black--opacity-10);color:var(--c-text--lighten-20)}.ui-button.no-color.flat.discreet.dark.selected[data-v-262299fd]{background-color:var(--c-black--opacity-15);color:var(--c-primary)}.ui-button.no-color.flat.discreet.light.not-selected[data-v-262299fd]{color:var(--c-text-light);background:none}.ui-button.no-color.flat.discreet.light.not-selected.interactable.enabled[data-v-262299fd]:hover{color:var(--c-text-light);background-color:var(--c-white--opacity-20)}.ui-button.no-color.flat.discreet.light.selected[data-v-262299fd]{color:var(--c-text-light);background:var(--c-white--opacity-20)}.ui-button.no-color.flat.discreet.light.selected.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-white--opacity-20)}.ui-button.no-color.disabled[data-v-262299fd]{color:var(--c-text--lighten-40)}.ui-button.no-color.floating.interactable.enabled[data-v-262299fd]:hover:before,.ui-button:not(.no-color).prominent.interactable.enabled[data-v-262299fd]:hover:before{opacity:1}.ui-button.primary.prominent[data-v-262299fd]{background-color:var(--c-primary);color:var(--c-text-light)}.ui-button.primary.subtle.flat[data-v-262299fd]{background-color:var(--c-black--opacity-5);color:var(--c-primary)}.ui-button.primary.subtle.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-primary);color:var(--c-text-light)}.ui-button.danger.prominent[data-v-262299fd]{background-color:var(--c-danger);color:var(--c-text-light)}.ui-button.danger.subtle[data-v-262299fd]{background-color:var(--c-black--opacity-5);color:var(--c-danger)}.ui-button.danger.subtle.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-danger);color:var(--c-text-light)}.ui-button.warning.prominent[data-v-262299fd]{background-color:var(--c-warning--tint-20);color:var(--c-text-light)}.ui-button.warning.subtle[data-v-262299fd]{background-color:var(--c-black--opacity-5);color:var(--c-warning)}.ui-button.warning.subtle.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-warning--tint-20);color:var(--c-text-light)}.ui-button.success.prominent[data-v-262299fd]{background-color:var(--c-success);color:var(--c-text-light)}.ui-button.success.subtle[data-v-262299fd]{background-color:var(--c-black--opacity-5);color:var(--c-success)}.ui-button.success.subtle.interactable.enabled[data-v-262299fd]:hover{background-color:var(--c-success);color:var(--c-text-light)}.ui-button.floating[data-v-262299fd]{-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.15)}.ui-button.rectangular[data-v-262299fd]{border-radius:.125rem}.ui-button.rounded[data-v-262299fd]{border-radius:1000000px}.ui-button.rounded.has-label.medium[data-v-262299fd]{padding-left:.4375rem;padding-right:.4375rem}.ui-button.outline[data-v-262299fd]{-webkit-box-shadow:inset 0 0 0 .03125rem var(--c-black--opacity-10);box-shadow:inset 0 0 0 .03125rem var(--c-black--opacity-10)}.ui-button.uppercase[data-v-262299fd]{text-transform:uppercase;letter-spacing:-.05em}.ui-button.small .badge[data-v-262299fd],.ui-button.tiny .badge[data-v-262299fd]{margin-left:.125rem}.ui-button.small.has-badge-number[data-v-262299fd],.ui-button.tiny.has-badge-number[data-v-262299fd]{padding-right:.125rem}.ui-button.small.icon-on-right .badge[data-v-262299fd],.ui-button.tiny.icon-on-right .badge[data-v-262299fd]{margin-right:.125rem}.ui-button.small.external-badge .badge[data-v-262299fd],.ui-button.tiny.external-badge .badge[data-v-262299fd]{position:absolute;top:0;right:0}.ui-button.small.external-badge.has-badge-number.prominent.rectangular .badge[data-v-262299fd],.ui-button.small.external-badge.has-badge-number.prominent.rounded .badge[data-v-262299fd],.ui-button.tiny.external-badge.has-badge-number.prominent.rectangular .badge[data-v-262299fd],.ui-button.tiny.external-badge.has-badge-number.prominent.rounded .badge[data-v-262299fd]{-webkit-transform:translate(85%,-30%);transform:translate(85%,-30%)}.ui-button.small.external-badge:not(.has-badge-number).rectangular .badge[data-v-262299fd],.ui-button.small.external-badge:not(.has-badge-number).rounded .badge[data-v-262299fd],.ui-button.tiny.external-badge:not(.has-badge-number).rectangular .badge[data-v-262299fd],.ui-button.tiny.external-badge:not(.has-badge-number).rounded .badge[data-v-262299fd]{-webkit-transform:translate(80%,30%);transform:translate(80%,30%)}.ui-button.medium .badge[data-v-262299fd]{position:absolute;top:0;right:0}.ui-button.medium.has-badge-number.rectangular .badge[data-v-262299fd]{-webkit-transform:translate(60%,-30%);transform:translate(60%,-30%)}.ui-button.medium.has-badge-number.rounded .badge[data-v-262299fd]{-webkit-transform:translate(30%,-30%);transform:translate(30%,-30%)}.ui-button.medium:not(.has-badge-number).rectangular .badge[data-v-262299fd],.ui-button.medium:not(.has-badge-number).rounded .badge[data-v-262299fd]{-webkit-transform:translate(20%,60%);transform:translate(20%,60%)}", ""]);


/***/ }),

/***/ "f542":
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__("ec47"),
    keys = __webpack_require__("ec69");

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f608":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("6747"),
    isSymbol = __webpack_require__("ffd6");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "f6a8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-toast-portal-target[data-v-7b50b1a1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;left:0;right:0;bottom:2rem}", ""]);


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f7fe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "f88f":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".ui-formatted-text.light[data-v-0479b597]{color:var(--c-text-light)}.ui-formatted-text .emphasise[data-v-0479b597]{font-weight:700}.ui-formatted-text .no-break[data-v-0479b597]{white-space:nowrap}.ui-formatted-text .default-color .emphasise[data-v-0479b597]{color:var(--c-text--darken-10)}.ui-formatted-text .subtle[data-v-0479b597]{color:var(--c-text--lighten-40)}.ui-formatted-text .success[data-v-0479b597]{color:var(--c-success)}.ui-formatted-text .warning[data-v-0479b597]{color:var(--c-warning)}.ui-formatted-text .danger[data-v-0479b597]{color:var(--c-danger)}.ui-formatted-text .primary[data-v-0479b597]{color:var(--c-primary)}.ui-formatted-text pre[data-v-0479b597]{display:inline;background-color:var(--c-black--opacity-5);border-radius:.125rem;font-weight:700;padding:.0625rem .125rem}", ""]);


/***/ }),

/***/ "f8af":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("2474");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "f8c2":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "f909":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    assignMergeValue = __webpack_require__("b760"),
    baseFor = __webpack_require__("72af"),
    baseMergeDeep = __webpack_require__("4f50"),
    isObject = __webpack_require__("1a8c"),
    keysIn = __webpack_require__("9934"),
    safeGet = __webpack_require__("8adb");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "f91a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("24fb")(false);
// Module
exports.push([module.i, ".fade-enter-active[data-v-2571f8d6],.fade-leave-active[data-v-2571f8d6]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.2s;transition-duration:.2s}.fade-enter[data-v-2571f8d6],.fade-leave-to[data-v-2571f8d6]{opacity:0}.fade-enter-active[data-v-2571f8d6],.fade-leave-active[data-v-2571f8d6]{position:absolute}.ui-sidebar[data-v-2571f8d6]{height:100%;background-color:#fff;-webkit-box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.05);box-shadow:0 0 .25rem rgba(0,0,0,.08),0 .25rem .75rem rgba(0,0,0,.05);position:relative}.ui-sidebar__open[data-v-2571f8d6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;width:100%}.ui-sidebar__header[data-v-2571f8d6]{-ms-flex-negative:0;flex-shrink:0;border-bottom:.03125rem solid var(--c-black--opacity-10)}.ui-sidebar__container[data-v-2571f8d6]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;position:relative;width:100%;height:0}.ui-sidebar__wrapper[data-v-2571f8d6]{width:100%;height:100%}.ui-sidebar__collapsed[data-v-2571f8d6],.ui-sidebar__wrapper.collapsed[data-v-2571f8d6]{display:-webkit-box;display:-ms-flexbox;display:flex}.ui-sidebar__collapsed[data-v-2571f8d6]{width:100%;height:100%}.ui-sidebar.position-left .ui-sidebar__collapsed[data-v-2571f8d6]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.ui-sidebar.position-right .ui-sidebar__collapsed[data-v-2571f8d6]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);


/***/ }),

/***/ "f9ce":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("ef5d"),
    basePropertyDeep = __webpack_require__("e3f8"),
    isKey = __webpack_require__("f608"),
    toKey = __webpack_require__("f4d6");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "fa21":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("7530"),
    getPrototype = __webpack_require__("2dcb"),
    isPrototype = __webpack_require__("eac5");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "fa5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHint_vue_vue_type_style_index_0_id_1c88b113_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4e9a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHint_vue_vue_type_style_index_0_id_1c88b113_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHint_vue_vue_type_style_index_0_id_1c88b113_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiHint_vue_vue_type_style_index_0_id_1c88b113_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/styles/stylesheets/tooltip.styl
var tooltip = __webpack_require__("3308");

// EXTERNAL MODULE: ./src/styles/stylesheets/global.styl
var global = __webpack_require__("db96");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBox/UiBox.vue?vue&type=template&id=f89f5386&scoped=true&lang=pug&
var UiBoxvue_type_template_id_f89f5386_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-box",class:_vm.classes},[(_vm.icon)?_c('div',{staticClass:"icon-container"},[_c('ui-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"small":!_vm.large,"big":_vm.large,"light":(_vm.success || _vm.warning || _vm.danger) && !_vm.subtle}})],1):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiBox/UiBox.vue?vue&type=template&id=f89f5386&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/typeof.js








function _typeof3(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof3 = function _typeof3(obj) { return typeof obj; }; } else { _typeof3 = function _typeof3(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof3(obj); }

function _typeof2(obj) {
  if (typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol") {
    _typeof2 = function _typeof2(obj) {
      return _typeof3(obj);
    };
  } else {
    _typeof2 = function _typeof2(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof3(obj);
    };
  }

  return _typeof2(obj);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__("131a");

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js


function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.1.0
  * (c) 2015-present Evan You
  * @license MIT
  */


// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {}
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof external_commonjs_vue_commonjs2_vue_root_Vue_default.a
        ? superProto.constructor
        : external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {}
        Object.defineProperty(Extended, key, descriptor);
    });
}

function vue_class_component_esm_Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.2.2 MIT LICENSE copyright 2019 kaorun343 */
/// <reference types='reflect-metadata'/>




/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) ||
                    null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_2 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var _this = this;
                var rv = Object.create((typeof original_2 === 'function' ? original_2.call(this) : original_2) ||
                    null);
                rv[reactiveInjectKey] = {};
                var _loop_1 = function (i) {
                    rv[provide.managed[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
                    Object.defineProperty(rv[reactiveInjectKey], provide.managed[i], {
                        enumerable: true,
                        get: function () { return _this[i]; },
                    });
                };
                var this_1 = this;
                for (var i in provide.managed) {
                    _loop_1(i);
                }
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    // @ts-ignore
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                if (returnValue !== undefined)
                    args.unshift(returnValue);
                _this.$emit.apply(_this, [event || key].concat(args));
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (returnValue) {
                    emit(returnValue);
                });
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIcon/UiIcon.vue?vue&type=template&id=3e7d1ad4&scoped=true&lang=pug&
var UiIconvue_type_template_id_3e7d1ad4_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-icon",class:_vm.classes,style:(_vm.style),on:{"click":_vm.onClick,"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}})}
var UiIconvue_type_template_id_3e7d1ad4_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiIcon/UiIcon.vue?vue&type=template&id=3e7d1ad4&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.big.js
var es_string_big = __webpack_require__("1393");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("c96a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIcon/UiIcon.vue?vue&type=script&lang=ts&










var UiIconvue_type_script_lang_ts_UiIcon =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiIcon, _Vue);

  function UiIcon() {
    var _this;

    _classCallCheck(this, UiIcon);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiIcon).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.hovered = false;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiIcon, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClick() {
      if (this.clickable) this.$emit('click');
    }
  }, {
    key: "classes",
    get: function get() {
      return ['mdi', "mdi-".concat(this.icon), {
        'discreet': this.discreet,
        'subtle': this.subtle,
        'danger': this.danger,
        'warning': this.warning,
        'success': this.success,
        'tiny': this.tiny,
        'small': this.small,
        'big': this.big,
        'huge': this.huge,
        'massive': this.massive,
        'clickable': this.clickable,
        'spinning': this.spinning
      }];
    }
  }, {
    key: "style",
    get: function get() {
      var style = {};
      if (this.color && (!this.onlyUseColorWhenActive || this.hovered)) style.color = this.color;
      return style;
    }
  }]);

  return UiIcon;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  required: true
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "icon", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "color", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "discreet", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "danger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "warning", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "success", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "onlyUseColorWhenActive", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "tiny", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "small", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "big", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "huge", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "massive", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "clickable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiIconvue_type_script_lang_ts_UiIcon.prototype, "spinning", void 0);

UiIconvue_type_script_lang_ts_UiIcon = __decorate([vue_class_component_esm], UiIconvue_type_script_lang_ts_UiIcon);
/* harmony default export */ var UiIconvue_type_script_lang_ts_ = (UiIconvue_type_script_lang_ts_UiIcon);
// CONCATENATED MODULE: ./src/components/UiIcon/UiIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiIcon_UiIconvue_type_script_lang_ts_ = (UiIconvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiIcon/UiIcon.vue?vue&type=style&index=0&id=3e7d1ad4&lang=stylus&scoped=true&
var UiIconvue_type_style_index_0_id_3e7d1ad4_lang_stylus_scoped_true_ = __webpack_require__("7aaf");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/UiIcon/UiIcon.vue






/* normalize component */

var component = normalizeComponent(
  UiIcon_UiIconvue_type_script_lang_ts_,
  UiIconvue_type_template_id_3e7d1ad4_scoped_true_lang_pug_render,
  UiIconvue_type_template_id_3e7d1ad4_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "3e7d1ad4",
  null
  
)

/* harmony default export */ var UiIcon_UiIcon = (component.exports);
// CONCATENATED MODULE: ./src/components/UiIcon/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBox/UiBox.vue?vue&type=script&lang=ts&









var UiBoxvue_type_script_lang_ts_UiBox =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiBox, _Vue);

  function UiBox() {
    _classCallCheck(this, UiBox);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiBox).apply(this, arguments));
  }

  _createClass(UiBox, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'success': this.success,
        'warning': this.warning,
        'danger': this.danger,
        'subtle': this.subtle,
        'compact': this.compact && !this.large,
        'large': this.large,
        'small-corners': this.smallCorners,
        'high-contrast': this.highContrast
      };
    }
  }]);

  return UiBox;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "success", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "warning", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "danger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "highContrast", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "compact", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "large", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "smallCorners", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiBoxvue_type_script_lang_ts_UiBox.prototype, "icon", void 0);

UiBoxvue_type_script_lang_ts_UiBox = __decorate([vue_class_component_esm({
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiBoxvue_type_script_lang_ts_UiBox);
/* harmony default export */ var UiBoxvue_type_script_lang_ts_ = (UiBoxvue_type_script_lang_ts_UiBox);
// CONCATENATED MODULE: ./src/components/UiBox/UiBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiBox_UiBoxvue_type_script_lang_ts_ = (UiBoxvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiBox/UiBox.vue?vue&type=style&index=0&id=f89f5386&lang=stylus&scoped=true&
var UiBoxvue_type_style_index_0_id_f89f5386_lang_stylus_scoped_true_ = __webpack_require__("30d9");

// CONCATENATED MODULE: ./src/components/UiBox/UiBox.vue






/* normalize component */

var UiBox_component = normalizeComponent(
  UiBox_UiBoxvue_type_script_lang_ts_,
  UiBoxvue_type_template_id_f89f5386_scoped_true_lang_pug_render,
  staticRenderFns,
  false,
  null,
  "f89f5386",
  null
  
)

/* harmony default export */ var UiBox_UiBox = (UiBox_component.exports);
// CONCATENATED MODULE: ./src/components/UiBox/index.ts

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__("42454");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiWarningBox/UiWarningBox.vue?vue&type=script&lang=ts&


/* harmony default export */ var UiWarningBoxvue_type_script_lang_ts_ = ({
  functional: true,
  render: function render(h, context) {
    return h(UiBox_UiBox, merge_default()({
      props: {
        icon: 'alert-circle',
        warning: true
      },
      scopedSlots: context.scopedSlots
    }, context.data));
  }
});
// CONCATENATED MODULE: ./src/components/UiWarningBox/UiWarningBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiWarningBox_UiWarningBoxvue_type_script_lang_ts_ = (UiWarningBoxvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiWarningBox/UiWarningBox.vue
var UiWarningBox_render, UiWarningBox_staticRenderFns




/* normalize component */

var UiWarningBox_component = normalizeComponent(
  UiWarningBox_UiWarningBoxvue_type_script_lang_ts_,
  UiWarningBox_render,
  UiWarningBox_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiWarningBox = (UiWarningBox_component.exports);
// CONCATENATED MODULE: ./src/components/UiWarningBox/index.ts

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./src/utils/utils-clipboard.ts
function copyToClipboard(text) {
  var el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var clone = __webpack_require__("b8ce");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// CONCATENATED MODULE: ./src/utils/utils-component.ts









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/**
 * @param h The component render function
 * @param context The render context
 * @param component The component to render
 * @param overloadedProps Props to overload with new values
 *
 * @returns @param component rendered as a VNode with default props overloaded with @param overloadedProps
 */

function renderPropsWithDefaults(h, context, component, overloadedProps) {
  return h(component, {
    props: _objectSpread({}, context.props, {}, overloadedProps),
    attrs: context.data.attrs,
    on: context.listeners,
    scopedSlots: context.scopedSlots,
    style: context.data.style
  });
}
/**
 * @param defaultProps The component's default prop options
 * @param overloadedProps Props to overload with new values
 *
 * @returns component prop options overloaded with values from overloadedProps
 */

function overloadComponentProps(defaultProps, overloadedProps) {
  var newProps = clone_default()(defaultProps);

  Object.keys(overloadedProps).forEach(function (key) {
    newProps[key] = {
      default: overloadedProps[key]
    };
  });
  return newProps;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("a623");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__("0d03");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/iterableToArray.js










function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js



function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js









function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js



function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/lodash/intersectionWith.js
var intersectionWith = __webpack_require__("9c4b");
var intersectionWith_default = /*#__PURE__*/__webpack_require__.n(intersectionWith);

// EXTERNAL MODULE: ./node_modules/lodash/differenceWith.js
var differenceWith = __webpack_require__("52b3");
var differenceWith_default = /*#__PURE__*/__webpack_require__.n(differenceWith);

// EXTERNAL MODULE: ./node_modules/lodash/unionWith.js
var unionWith = __webpack_require__("543e");
var unionWith_default = /*#__PURE__*/__webpack_require__.n(unionWith);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("63ea");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isObject.js
var isObject = __webpack_require__("1a8c");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// EXTERNAL MODULE: ./node_modules/lodash/transform.js
var transform = __webpack_require__("50ca");
var transform_default = /*#__PURE__*/__webpack_require__.n(transform);

// EXTERNAL MODULE: ./node_modules/lodash/reduce.js
var reduce = __webpack_require__("c5a2");
var reduce_default = /*#__PURE__*/__webpack_require__.n(reduce);

// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__("0f5c");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/lodash/toPairs.js
var toPairs = __webpack_require__("f542");
var toPairs_default = /*#__PURE__*/__webpack_require__.n(toPairs);

// CONCATENATED MODULE: ./src/utils/utils-generic.ts





















function utils_generic_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function utils_generic_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { utils_generic_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { utils_generic_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};
function objectToArray(object) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  return Object.entries(object).map(function (_ref) {
    var _ref3;

    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return _ref3 = {}, _defineProperty(_ref3, key, k), _defineProperty(_ref3, value, v), _ref3;
  });
}
/**
 * @returns object representing the minimal set of changes to @param baseObject.
 *
 * @param existingChanges Object representing changes to be made to @param baseObject.
 * @param changeUpdates Object representing updates to @param existingChanges.
 * @param baseObject Object which is to be changed.
 */

function updateChanges(existingChanges, changeUpdates, baseObject) {
  var newChanges = utils_generic_objectSpread({}, existingChanges, {}, changeUpdates); // Delete keys with values unchanged compared to base object.


  var keysToDelete = [];

  var isEmptyValue = function isEmptyValue(value) {
    return value === null || typeof value === 'string' && value.length === 0 || Array.isArray(value) && value.length === 0;
  };

  Object.entries(changeUpdates).forEach(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    var baseValue = baseObject && baseObject[key];
    var newValue = value;

    if (baseObject) {
      if (isEqual_default()(baseValue, newValue) || isEmptyValue(baseValue) && isEmptyValue(newValue)) {
        keysToDelete.push(key);
      }
    } else {
      if (isEmptyValue(newValue)) {
        keysToDelete.push(key);
      }
    }
  });
  keysToDelete.forEach(function (key) {
    delete newChanges[key];
  });
  return newChanges;
} // TODO: Deprecated. Replace with utils-merged/mergeObjectsForSelection.

function combineEntities(entities, keysWithArrayValues) {
  if (!entities || entities.length === 0) return {};
  var keys = Object.keys(entities[0]);
  var combined = {};
  keys.forEach(function (key) {
    var hasArrayValue = !!keysWithArrayValues && keysWithArrayValues.includes(key);

    if (hasArrayValue) {
      var arrays = entities.map(function (entity) {
        return entity[key];
      }); // @ts-ignore

      var valuesInAll = intersectionWith_default.a.apply(void 0, _toConsumableArray(arrays).concat([isEqual_default.a])); // @ts-ignore


      var valuesInAtLeastOne = unionWith_default.a.apply(void 0, _toConsumableArray(arrays).concat([isEqual_default.a]));

      var valuesInSome = differenceWith_default()(valuesInAtLeastOne, valuesInAll, isEqual_default.a);

      combined[key] = {
        inAll: valuesInAll,
        inSome: valuesInSome
      };
    } else {
      if (entities.every(function (entity) {
        return isEqual_default()(entity[key], entities[0][key]);
      })) {
        combined[key] = entities[0][key];
      }
    }
  });
  return combined;
}
function deepMap(obj, iterator, context) {
  return transform_default()(obj, function (result, val, key) {
    result[key] = isObject_default()(val) ? deepMap(val, iterator, context) : iterator.call(context, val, key, obj);
  });
}
function deepFilter(obj, iterator, context) {
  return transform_default()(obj, function (result, val, key) {
    if (isObject_default()(val)) {
      result[key] = deepFilter(val, iterator, context);
    } else if (iterator.call(context, val, key, obj)) {
      result[key] = val;
    }
  });
}
function flattenKeys(obj) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (isObject_default()(obj)) return reduce_default()(obj, function (cum, next, key) {
    return merge_default()(cum, flattenKeys(next, [].concat(_toConsumableArray(path), [key])));
  }, {});
  return _defineProperty({}, path.join('.'), obj);
}
function unflattenKeys(obj) {
  return toPairs_default()(obj).reduce(function (cum, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return set_default()(cum, key, value);
  }, {});
}
/**
 *
 * @param original The original object.
 * @param changed A modified version of @param original.
 *
 * @returns an object with key/value pairs of @param changed that don't have a deeply-equal, corresponding key/value pair in @param original.
 */

function utils_generic_diff(original, changed) {
  return Object.entries(changed).reduce(function (diff, _ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        key = _ref10[0],
        changedValue = _ref10[1];

    var originalValue = original[key];

    if (!isEqual_default()(originalValue, changedValue)) {
      return utils_generic_objectSpread({}, diff, _defineProperty({}, key, changedValue));
    }

    return diff;
  }, {});
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__("e25e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/chroma-js/chroma.js
var chroma = __webpack_require__("6149");
var chroma_default = /*#__PURE__*/__webpack_require__.n(chroma);

// CONCATENATED MODULE: ./src/utils/utils-style.ts





var THRESHOLD = 4.5;
function shouldTextBeLight(backgroundColor) {
  var whiteContrast = chroma_default.a.contrast('white', backgroundColor);
  return whiteContrast >= THRESHOLD;
}
/**
 * @returns '#FFF' if it has enough contrast with @param backgroundColor.
 * Else, @returns '#333'.
 */

function getBestTextColor(backgroundColor) {
  return shouldTextBeLight(backgroundColor) ? '#FFF' : '#333';
}
/**
 * @returns true if there is insufficient contrast between @param color and a white background.
 */

function isBorderNeeded(color) {
  return chroma_default.a.contrast('white', color) < THRESHOLD;
}
function getColoredStyle(options) {
  var primaryColor = options.primaryColor,
      textColor = options.textColor,
      hovered = options.hovered,
      boxShadow = options.boxShadow;

  var backgroundColor = function () {
    if (boxShadow) {
      if (hovered) return primaryColor;
      return null;
    }

    if (hovered) return chroma_default()(primaryColor).darken(0.5).hex();
    return primaryColor;
  }();

  var foregroundColor = function () {
    if (textColor) return textColor;

    if (boxShadow) {
      if (hovered) return getBestTextColor(primaryColor);else return primaryColor;
    }

    return getBestTextColor(primaryColor);
  }();

  var boxShadowValue = function () {
    if (boxShadow) {
      var userAgent = window.navigator.userAgent;

      if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1 || userAgent.indexOf('Edge/') > -1) {
        return "inset 0 0 0 2px ".concat(primaryColor);
      } else {
        return "inset 0 0 0 calc(1/16 * 1rem) ".concat(primaryColor);
      }
    } else if (isBorderNeeded(primaryColor)) {
      return "inset 0 0 0 calc(1/32 * 1rem) rgba(0,0,0,0.08)";
    }

    return null;
  }();

  var style = {};
  if (backgroundColor) style.backgroundColor = backgroundColor;
  if (foregroundColor) style.color = foregroundColor;
  if (boxShadowValue) style.boxShadow = boxShadowValue;
  return style;
} ////////////////////////////////////////////////////////////////
// rem
////////////////////////////////////////////////////////////////

function getCurrentRemInPixels() {
  var _window$getComputedSt = window.getComputedStyle(window.document.documentElement),
      fontSize = _window$getComputedSt.fontSize;

  var matchResult = fontSize.match(/^[0-9]+/);
  return matchResult && parseInt(matchResult[0]) || 16;
}
function getPixelsAsRem(pixels) {
  return pixels / getCurrentRemInPixels();
}
function getRemAsPixels(rem) {
  return rem * getCurrentRemInPixels();
}
// CONCATENATED MODULE: ./src/utils/utils-typeguard.ts
////////////////////////////////////////////////////////////////
// type guards
////////////////////////////////////////////////////////////////
function notUndefined(x) {
  return x !== undefined;
}
function notNull(x) {
  return x !== null;
}
// CONCATENATED MODULE: ./src/utils/index.ts





// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBadge/UiBadge.vue?vue&type=template&id=4e3ace4a&scoped=true&lang=pug&
var UiBadgevue_type_template_id_4e3ace4a_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-badge",class:_vm.classes},[_c('div',{staticClass:"circle",style:(_vm.style)},[(_vm.numberToDisplay)?_c('div',{staticClass:"number"},[_c('span',[_vm._v(_vm._s(_vm.numberToDisplay))])]):_vm._e()])])}
var UiBadgevue_type_template_id_4e3ace4a_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiBadge/UiBadge.vue?vue&type=template&id=4e3ace4a&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBadge/UiBadge.vue?vue&type=script&lang=ts&













var UiBadgevue_type_script_lang_ts_UiBadge =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiBadge, _Vue);

  function UiBadge() {
    _classCallCheck(this, UiBadge);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiBadge).apply(this, arguments));
  }

  _createClass(UiBadge, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'has-number': this.number !== null,
        'light': this.light,
        'small': this.small,
        'static': this.static
      };
    }
  }, {
    key: "style",
    get: function get() {
      if (this.borderColor === 'transparent') return {};
      return {
        boxShadow: "0 0 0 calc(1rem * 2/32) ".concat(this.borderColor)
      };
    }
  }, {
    key: "numberToDisplay",
    get: function get() {
      if (!this.number) return null;
      if (this.number <= 99) return this.number.toString();else return "99+";
    }
  }]);

  return UiBadge;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Number,
  default: null
})], UiBadgevue_type_script_lang_ts_UiBadge.prototype, "number", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBadgevue_type_script_lang_ts_UiBadge.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBadgevue_type_script_lang_ts_UiBadge.prototype, "small", void 0);

__decorate([Prop({
  type: String,
  default: 'transparent'
})], UiBadgevue_type_script_lang_ts_UiBadge.prototype, "borderColor", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBadgevue_type_script_lang_ts_UiBadge.prototype, "static", void 0);

UiBadgevue_type_script_lang_ts_UiBadge = __decorate([vue_class_component_esm], UiBadgevue_type_script_lang_ts_UiBadge);
/* harmony default export */ var UiBadgevue_type_script_lang_ts_ = (UiBadgevue_type_script_lang_ts_UiBadge);
// CONCATENATED MODULE: ./src/components/UiBadge/UiBadge.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiBadge_UiBadgevue_type_script_lang_ts_ = (UiBadgevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiBadge/UiBadge.vue?vue&type=style&index=0&id=4e3ace4a&lang=stylus&scoped=true&
var UiBadgevue_type_style_index_0_id_4e3ace4a_lang_stylus_scoped_true_ = __webpack_require__("bb5e");

// CONCATENATED MODULE: ./src/components/UiBadge/UiBadge.vue






/* normalize component */

var UiBadge_component = normalizeComponent(
  UiBadge_UiBadgevue_type_script_lang_ts_,
  UiBadgevue_type_template_id_4e3ace4a_scoped_true_lang_pug_render,
  UiBadgevue_type_template_id_4e3ace4a_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "4e3ace4a",
  null
  
)

/* harmony default export */ var UiBadge_UiBadge = (UiBadge_component.exports);
// CONCATENATED MODULE: ./src/components/UiBadge/index.ts

// EXTERNAL MODULE: ./node_modules/v-tooltip/dist/v-tooltip.esm.js
var v_tooltip_esm = __webpack_require__("e37d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiButton/UiButton.vue?vue&type=script&lang=tsx&

















function UiButtonvue_type_script_lang_tsx_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiButtonvue_type_script_lang_tsx_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiButtonvue_type_script_lang_tsx_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiButtonvue_type_script_lang_tsx_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var UiButtonvue_type_script_lang_tsx_UiButton =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiButton, _Vue);

  function UiButton() {
    var _this;

    _classCallCheck(this, UiButton);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiButton).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.hovered = false;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiButton, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClick(event) {
      if (this.readOnly) return;

      if (this.disabled) {
        this.$emit('click:disabled', event);
        return;
      }

      this.$emit('click', event); // @ts-ignore

      if (this.to && this.$route && this.$router) {
        // @ts-ignore
        this.$router.push(UiButtonvue_type_script_lang_tsx_objectSpread({}, this.to, {
          params: UiButtonvue_type_script_lang_tsx_objectSpread({}, this.$route.params, {}, this.to.params)
        }));
      }
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(event) {
      this.hovered = true;
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(event) {
      this.hovered = false;
    } ////////////////////////////////////////////////////////////////
    // render
    ////////////////////////////////////////////////////////////////

  }, {
    key: "render",
    value: function render(h) {
      var _this2 = this;

      // `visibility: hidden` is used so that the button retains its original size when the loading overlay is shown.
      var icon = function () {
        if (_this2.$scopedSlots.icon) {
          return h("div", {
            "class": 'icon'
          }, [_this2.$scopedSlots.icon({})]);
        }

        if (_this2.icon) {
          return h("ui-icon", {
            "attrs": {
              "icon": _this2.icon,
              "small": _this2.tiny || _this2.small,
              "big": _this2.big,
              "spinning": _this2.spinning
            },
            "class": 'icon'
          });
        }

        return null;
      }();

      var label = h("span", {
        "class": 'label'
      }, [this.label]);
      var badge = h("ui-badge", {
        "class": 'badge',
        "attrs": {
          "number": this.badgeNumber,
          "light": this.light,
          "small": this.tiny || this.small,
          "static": (this.tiny || this.small) && !this.externalBadge,
          "borderColor": this.externalBackgroundColor
        }
      });
      var button = h("button", {
        "class": UiButtonvue_type_script_lang_tsx_objectSpread({}, this.classes),
        "style": this.style,
        "on": {
          "click": this.onClick,
          "mouseenter": this.onMouseEnter,
          "mouseleave": this.onMouseLeave
        },
        "directives": [{
          name: "tooltip",
          value: this.tooltipOptions
        }],
        "attrs": {
          "aria-label": this.showLabel ? null : this.label
        }
      }, [icon, this.label && this.showLabel ? label : null, this.showBadge ? badge : null]);
      var menuScopedSlot = this.$scopedSlots['menu:align-to-left'] || this.$scopedSlots['menu:align-to-right'] || this.$scopedSlots['menu'];

      if (menuScopedSlot) {
        var placement = this.$scopedSlots['menu:align-to-right'] ? 'bottom-end' : 'bottom-start';
        return h(v_tooltip_esm["b" /* VPopover */], {
          "scopedSlots": {
            popover: menuScopedSlot
          },
          "attrs": {
            "placement": placement
          }
        }, [button]);
      } else {
        return button;
      }
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        'ui-button': true,
        'bare': this.bare,
        // content
        'has-label': this.label && this.showLabel,
        'no-label': this.label && !this.showLabel,
        'has-icon': this.icon,
        'no-icon': !this.icon,
        // layout
        'vertical': this.vertical,
        'horizontal': !this.vertical,
        'icon-on-left': !this.iconOnRight,
        'icon-on-right': this.iconOnRight,
        // state
        'disabled': this.disabled,
        'enabled': !this.disabled,
        'selected': this.selected,
        'not-selected': !this.selected,
        'read-only': this.readOnly,
        'interactable': !this.readOnly,
        // size
        'tiny': this.tiny && !this.small && !this.big,
        'small': !this.tiny && this.small && !this.big,
        'medium': !this.tiny && !this.small && !this.big,
        'big': !this.tiny && !this.small && this.big,
        // color
        'no-color': !this.primary && !this.danger && !this.warning && !this.success,
        'primary': this.primary,
        'danger': this.danger,
        'warning': this.warning,
        'success': this.success,
        // internal appearance
        'discreet': this.discreet,
        'subtle': this.subtle && !this.discreet,
        'prominent': !this.discreet && !this.subtle,
        'light': this.light,
        'dark': !this.light,
        'outline': this.outline,
        // external appearance
        'floating': this.floating,
        'flat': !this.floating,
        'rounded': this.rounded,
        'rectangular': !this.rounded,
        // text style
        'uppercase': this.uppercase,
        // badge
        'has-badge-number': this.badgeNumber !== null && this.badgeNumber > 0,
        'external-badge': this.badge && !this.tiny && !this.small || this.externalBadge
      };
    }
  }, {
    key: "style",
    get: function get() {
      if (!this.color) return {};

      if (this.onlyUseColorWhenActive) {
        if ((this.hovered || this.selected) && !this.disabled && !this.readOnly) {
          return getColoredStyle({
            primaryColor: this.color
          });
        } else return {};
      } else {
        return getColoredStyle({
          primaryColor: this.color,
          hovered: !this.readOnly && this.hovered,
          boxShadow: this.outline
        });
      }
    }
  }, {
    key: "tooltipOptions",
    get: function get() {
      return {
        content: this.tooltip,
        placement: 'top',
        popperOptions: {
          modifiers: {
            preventOverflow: {
              boundariesElement: 'viewport'
            }
          }
        }
      };
    }
  }, {
    key: "showBadge",
    get: function get() {
      return this.badge || this.badgeNumber;
    }
  }]);

  return UiButton;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "icon", void 0);

__decorate([Prop({
  type: String,
  required: true
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "label", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "showLabel", void 0);

__decorate([Prop({
  default: null
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "tooltip", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "vertical", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "iconOnRight", void 0);

__decorate([Prop({
  type: Object,
  default: null
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "to", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "selected", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "readOnly", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "tiny", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "small", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "big", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "bare", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "color", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "onlyUseColorWhenActive", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "primary", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "danger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "warning", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "success", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "discreet", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "outline", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "spinning", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "floating", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "rounded", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "uppercase", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "badge", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "externalBadge", void 0);

__decorate([Prop({
  type: Number,
  default: null
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "badgeNumber", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiButtonvue_type_script_lang_tsx_UiButton.prototype, "externalBackgroundColor", void 0);

UiButtonvue_type_script_lang_tsx_UiButton = __decorate([vue_class_component_esm({
  components: {
    UiBadge: UiBadge_UiBadge,
    UiIcon: UiIcon_UiIcon
  },
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  }
})], UiButtonvue_type_script_lang_tsx_UiButton);
/* harmony default export */ var UiButtonvue_type_script_lang_tsx_ = (UiButtonvue_type_script_lang_tsx_UiButton);
// CONCATENATED MODULE: ./src/components/UiButton/UiButton.vue?vue&type=script&lang=tsx&
 /* harmony default export */ var UiButton_UiButtonvue_type_script_lang_tsx_ = (UiButtonvue_type_script_lang_tsx_); 
// EXTERNAL MODULE: ./src/components/UiButton/UiButton.vue?vue&type=style&index=0&id=262299fd&lang=stylus&scoped=true&
var UiButtonvue_type_style_index_0_id_262299fd_lang_stylus_scoped_true_ = __webpack_require__("9640");

// CONCATENATED MODULE: ./src/components/UiButton/UiButton.vue
var UiButton_render, UiButton_staticRenderFns





/* normalize component */

var UiButton_component = normalizeComponent(
  UiButton_UiButtonvue_type_script_lang_tsx_,
  UiButton_render,
  UiButton_staticRenderFns,
  false,
  null,
  "262299fd",
  null
  
)

/* harmony default export */ var UiButton_UiButton = (UiButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiButton/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCopyButton/UiCopyButton.vue?vue&type=template&id=8324571a&lang=pug&
var UiCopyButtonvue_type_template_id_8324571a_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',{staticClass:"ui-copy-button",attrs:{"icon":!_vm.copied ? 'content-copy' : 'check',"label":!_vm.copied ? 'Copy' : 'Copied',"success":_vm.copied,"subtle":_vm.copied,"small":"","uppercase":"","data-test-id":"copy-button:copy"},on:{"click":_vm.copy}})}
var UiCopyButtonvue_type_template_id_8324571a_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCopyButton/UiCopyButton.vue?vue&type=template&id=8324571a&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCopyButton/UiCopyButton.vue?vue&type=script&lang=ts&










var UiCopyButtonvue_type_script_lang_ts_UiCopyButton =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiCopyButton, _Vue);

  function UiCopyButton() {
    var _this;

    _classCallCheck(this, UiCopyButton);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiCopyButton).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // state
    ////////////////////////////////////////////////////////////////

    _this.copied = false;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // methods
  ////////////////////////////////////////////////////////////////


  _createClass(UiCopyButton, [{
    key: "copy",
    value: function copy() {
      copyToClipboard(this.text);
      this.copied = true;
    }
  }]);

  return UiCopyButton;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  required: true
})], UiCopyButtonvue_type_script_lang_ts_UiCopyButton.prototype, "text", void 0);

UiCopyButtonvue_type_script_lang_ts_UiCopyButton = __decorate([vue_class_component_esm({
  components: {
    UiButton: UiButton_UiButton
  }
})], UiCopyButtonvue_type_script_lang_ts_UiCopyButton);
/* harmony default export */ var UiCopyButtonvue_type_script_lang_ts_ = (UiCopyButtonvue_type_script_lang_ts_UiCopyButton);
// CONCATENATED MODULE: ./src/components/UiCopyButton/UiCopyButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiCopyButton_UiCopyButtonvue_type_script_lang_ts_ = (UiCopyButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiCopyButton/UiCopyButton.vue





/* normalize component */

var UiCopyButton_component = normalizeComponent(
  UiCopyButton_UiCopyButtonvue_type_script_lang_ts_,
  UiCopyButtonvue_type_template_id_8324571a_lang_pug_render,
  UiCopyButtonvue_type_template_id_8324571a_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiCopyButton_UiCopyButton = (UiCopyButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiCopyButton/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIconButton/UiIconButton.vue?vue&type=script&lang=ts&









function UiIconButtonvue_type_script_lang_ts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiIconButtonvue_type_script_lang_ts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiIconButtonvue_type_script_lang_ts_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiIconButtonvue_type_script_lang_ts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* harmony default export */ var UiIconButtonvue_type_script_lang_ts_ = ({
  functional: true,
  //@ts-ignore
  props: overloadComponentProps(UiButton_UiButton.options.props, {
    rounded: true,
    subtle: true,
    showLabel: false
  }),
  render: function render(h, context) {
    return h(UiButton_UiButton, UiIconButtonvue_type_script_lang_ts_objectSpread({}, context.data, {
      props: context.props,
      on: context.listeners,
      scopedSlots: context.scopedSlots
    }));
  }
});
// CONCATENATED MODULE: ./src/components/UiIconButton/UiIconButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiIconButton_UiIconButtonvue_type_script_lang_ts_ = (UiIconButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiIconButton/UiIconButton.vue
var UiIconButton_render, UiIconButton_staticRenderFns




/* normalize component */

var UiIconButton_component = normalizeComponent(
  UiIconButton_UiIconButtonvue_type_script_lang_ts_,
  UiIconButton_render,
  UiIconButton_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiIconButton = (UiIconButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiIconButton/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLoadMoreButton/UiLoadMoreButton.vue?vue&type=script&lang=ts&









function UiLoadMoreButtonvue_type_script_lang_ts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiLoadMoreButtonvue_type_script_lang_ts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiLoadMoreButtonvue_type_script_lang_ts_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiLoadMoreButtonvue_type_script_lang_ts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* harmony default export */ var UiLoadMoreButtonvue_type_script_lang_ts_ = ({
  functional: true,
  //@ts-ignore
  props: overloadComponentProps(UiButton_UiButton.options.props, {
    rounded: true,
    uppercase: true,
    icon: 'arrow-down',
    label: 'Load more',
    showLabel: false
  }),
  render: function render(h, context) {
    return h(UiButton_UiButton, UiLoadMoreButtonvue_type_script_lang_ts_objectSpread({}, context.data, {
      props: context.props,
      on: context.listeners,
      scopedSlots: context.scopedSlots
    }));
  }
});
// CONCATENATED MODULE: ./src/components/UiLoadMoreButton/UiLoadMoreButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiLoadMoreButton_UiLoadMoreButtonvue_type_script_lang_ts_ = (UiLoadMoreButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiLoadMoreButton/UiLoadMoreButton.vue
var UiLoadMoreButton_render, UiLoadMoreButton_staticRenderFns




/* normalize component */

var UiLoadMoreButton_component = normalizeComponent(
  UiLoadMoreButton_UiLoadMoreButtonvue_type_script_lang_ts_,
  UiLoadMoreButton_render,
  UiLoadMoreButton_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiLoadMoreButton = (UiLoadMoreButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiLoadMoreButton/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPillButton/UiPillButton.vue?vue&type=script&lang=ts&









function UiPillButtonvue_type_script_lang_ts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiPillButtonvue_type_script_lang_ts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiPillButtonvue_type_script_lang_ts_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiPillButtonvue_type_script_lang_ts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* harmony default export */ var UiPillButtonvue_type_script_lang_ts_ = ({
  functional: true,
  //@ts-ignore
  props: overloadComponentProps(UiButton_UiButton.options.props, {
    rounded: true,
    small: true
  }),
  render: function render(h, context) {
    return h(UiButton_UiButton, UiPillButtonvue_type_script_lang_ts_objectSpread({}, context.data, {
      props: context.props,
      on: context.listeners,
      scopedSlots: context.scopedSlots
    }));
  }
});
// CONCATENATED MODULE: ./src/components/UiPillButton/UiPillButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiPillButton_UiPillButtonvue_type_script_lang_ts_ = (UiPillButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiPillButton/UiPillButton.vue
var UiPillButton_render, UiPillButton_staticRenderFns




/* normalize component */

var UiPillButton_component = normalizeComponent(
  UiPillButton_UiPillButtonvue_type_script_lang_ts_,
  UiPillButton_render,
  UiPillButton_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiPillButton = (UiPillButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiPillButton/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiGrid/UiGrid.vue?vue&type=template&id=74847860&scoped=true&lang=pug&
var UiGridvue_type_template_id_74847860_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-grid",class:_vm.classes},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"item"},[_vm._t("item",null,{"item":item})],2)}),0)}
var UiGridvue_type_template_id_74847860_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiGrid/UiGrid.vue?vue&type=template&id=74847860&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiGrid/UiGrid.vue?vue&type=script&lang=ts&










var ItemSize;

(function (ItemSize) {
  ItemSize["SMALL"] = "small";
  ItemSize["MEDIUM"] = "medium";
  ItemSize["BIG"] = "big";
})(ItemSize || (ItemSize = {}));

var LayoutMode;

(function (LayoutMode) {
  LayoutMode["AUTO_FILL"] = "auto-fill";
  LayoutMode["AUTO_FIT"] = "auto-fit";
})(LayoutMode || (LayoutMode = {}));

var UiGridvue_type_script_lang_ts_UiGrid =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiGrid, _Vue);

  function UiGrid() {
    _classCallCheck(this, UiGrid);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiGrid).apply(this, arguments));
  }

  _createClass(UiGrid, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return [this.itemSize, this.layoutMode];
    }
  }]);

  return UiGrid;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiGridvue_type_script_lang_ts_UiGrid.prototype, "items", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return Object.values(ItemSize).includes(value);
  },
  default: ItemSize.MEDIUM
})], UiGridvue_type_script_lang_ts_UiGrid.prototype, "itemSize", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return Object.values(LayoutMode).includes(value);
  },
  default: LayoutMode.AUTO_FILL
})], UiGridvue_type_script_lang_ts_UiGrid.prototype, "layoutMode", void 0);

UiGridvue_type_script_lang_ts_UiGrid = __decorate([vue_class_component_esm], UiGridvue_type_script_lang_ts_UiGrid);
/* harmony default export */ var UiGridvue_type_script_lang_ts_ = (UiGridvue_type_script_lang_ts_UiGrid);
// CONCATENATED MODULE: ./src/components/UiGrid/UiGrid.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiGrid_UiGridvue_type_script_lang_ts_ = (UiGridvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiGrid/UiGrid.vue?vue&type=style&index=0&id=74847860&lang=stylus&scoped=true&
var UiGridvue_type_style_index_0_id_74847860_lang_stylus_scoped_true_ = __webpack_require__("7d92");

// CONCATENATED MODULE: ./src/components/UiGrid/UiGrid.vue






/* normalize component */

var UiGrid_component = normalizeComponent(
  UiGrid_UiGridvue_type_script_lang_ts_,
  UiGridvue_type_template_id_74847860_scoped_true_lang_pug_render,
  UiGridvue_type_template_id_74847860_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "74847860",
  null
  
)

/* harmony default export */ var UiGrid_UiGrid = (UiGrid_component.exports);
// CONCATENATED MODULE: ./src/components/UiGrid/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiGridItem/UiGridItem.vue?vue&type=template&id=cc71bf70&scoped=true&lang=pug&
var UiGridItemvue_type_template_id_cc71bf70_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-grid-item",class:_vm.classes,style:(_vm.style),on:{"click":_vm.onClick}},[(_vm.$scopedSlots['top'])?_c('div',{staticClass:"top"},[_vm._t("top")],2):_vm._e(),_c('div',{staticClass:"content"},[(_vm.$scopedSlots['icon'])?_c('div',{staticClass:"icon"},[_vm._t("icon")],2):_vm._e(),(_vm.$scopedSlots['title'])?_c('div',{staticClass:"title"},[_vm._t("title")],2):_vm._e()]),(_vm.$scopedSlots['bottom'])?_c('div',{staticClass:"top"},[_vm._t("bottom")],2):_vm._e()])}
var UiGridItemvue_type_template_id_cc71bf70_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiGridItem/UiGridItem.vue?vue&type=template&id=cc71bf70&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiGridItem/UiGridItem.vue?vue&type=script&lang=ts&












var Size;

(function (Size) {
  Size["SMALL"] = "small";
  Size["MEDIUM"] = "medium";
  Size["BIG"] = "big";
})(Size || (Size = {}));

var Opacity;

(function (Opacity) {
  Opacity["OPAQUE"] = "opaque";
  Opacity["TRANSLUCENT"] = "translucent";
})(Opacity || (Opacity = {}));

var Environment;

(function (Environment) {
  Environment["LIGHT"] = "light";
  Environment["DARK"] = "dark";
})(Environment || (Environment = {}));

var Density;

(function (Density) {
  Density["DENSE"] = "dense";
  Density["SPARSE"] = "sparse";
})(Density || (Density = {}));

var UiGridItemvue_type_script_lang_ts_UiGridItem =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiGridItem, _Vue);

  function UiGridItem() {
    _classCallCheck(this, UiGridItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiGridItem).apply(this, arguments));
  }

  _createClass(UiGridItem, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function onClick() {
      if (this.disabled || this.readOnly) return;
      this.$emit('click');
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return [this.size, this.opacity, this.environment, this.density, {
        'fill': this.fill,
        'interactable': !this.readOnly && !this.disabled,
        'disabled': this.disabled,
        'highlighted': this.highlighted
      }];
    }
  }, {
    key: "style",
    get: function get() {
      if (!this.color || !this.highlighted) return {};
      return getColoredStyle({
        primaryColor: this.color
      });
    }
  }]);

  return UiGridItem;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "fill", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return Object.values(Size).includes(value);
  },
  default: Size.MEDIUM
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "size", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return Object.values(Opacity).includes(value);
  },
  default: Opacity.TRANSLUCENT
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "opacity", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return Object.values(Environment).includes(value);
  },
  default: Environment.LIGHT
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "environment", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return Object.values(Density).includes(value);
  },
  default: Density.DENSE
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "density", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "color", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "readOnly", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "highlighted", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiGridItemvue_type_script_lang_ts_UiGridItem.prototype, "disabled", void 0);

UiGridItemvue_type_script_lang_ts_UiGridItem = __decorate([vue_class_component_esm], UiGridItemvue_type_script_lang_ts_UiGridItem);
/* harmony default export */ var UiGridItemvue_type_script_lang_ts_ = (UiGridItemvue_type_script_lang_ts_UiGridItem);
// CONCATENATED MODULE: ./src/components/UiGridItem/UiGridItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiGridItem_UiGridItemvue_type_script_lang_ts_ = (UiGridItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiGridItem/UiGridItem.vue?vue&type=style&index=0&id=cc71bf70&lang=stylus&scoped=true&
var UiGridItemvue_type_style_index_0_id_cc71bf70_lang_stylus_scoped_true_ = __webpack_require__("6444");

// CONCATENATED MODULE: ./src/components/UiGridItem/UiGridItem.vue






/* normalize component */

var UiGridItem_component = normalizeComponent(
  UiGridItem_UiGridItemvue_type_script_lang_ts_,
  UiGridItemvue_type_template_id_cc71bf70_scoped_true_lang_pug_render,
  UiGridItemvue_type_template_id_cc71bf70_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "cc71bf70",
  null
  
)

/* harmony default export */ var UiGridItem_UiGridItem = (UiGridItem_component.exports);
// CONCATENATED MODULE: ./src/components/UiGridItem/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiList/UiList.vue?vue&type=template&id=2fabe444&scoped=true&lang=pug&
var UiListvue_type_template_id_2fabe444_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"list",staticClass:"ui-list",class:_vm.classes},[_vm._l((_vm.items),function(item,index){
var _obj;
return _c('div',{key:index,staticClass:"item",class:( _obj = {}, _obj[_vm.rearrangeableItemClass] = _vm.isRearrangeable, _obj )},[_vm._t("item",null,{"item":item,"rearrangeableItemHandleClass":_vm.rearrangeableItemHandleClass})],2)}),(_vm.$scopedSlots['footer'])?_c('div',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e(),_vm._t("below-list")],2)}
var UiListvue_type_template_id_2fabe444_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiList/UiList.vue?vue&type=template&id=2fabe444&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__("5d41");

// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/superPropBase.js

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}
// CONCATENATED MODULE: ./node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/get.js



function get_get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    get_get = Reflect.get;
  } else {
    get_get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return get_get(target, property, receiver || target);
}
// EXTERNAL MODULE: ./node_modules/@shopify/draggable/lib/es5/draggable.js
var draggable = __webpack_require__("c335");
var draggable_default = /*#__PURE__*/__webpack_require__.n(draggable);

// EXTERNAL MODULE: ./node_modules/@shopify/draggable/lib/es5/sortable.js
var sortable = __webpack_require__("f112");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// CONCATENATED MODULE: ./src/libs/ContainerManager.js





var ContainerManager_ContainerManager =
/*#__PURE__*/
function () {
  function ContainerManager() {
    _classCallCheck(this, ContainerManager);

    this.containers = [];
  }

  _createClass(ContainerManager, [{
    key: "add",
    value: function add(container, payload) {
      this.containers.push({
        container: container,
        payload: payload
      });
    }
  }, {
    key: "payload",
    value: function payload(container) {
      var definition = this.containers[this.containers.findIndex(function (obj) {
        return obj.container === container;
      })];
      return definition ? definition.payload : null;
    }
  }, {
    key: "remove",
    value: function remove(container) {
      var index = this.containers.findIndex(function (obj) {
        return obj.container === container;
      });
      this.containers.splice(index, 1);
    }
  }]);

  return ContainerManager;
}();


// CONCATENATED MODULE: ./src/libs/DataSortable.js






















function DataSortable_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DataSortable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DataSortable_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DataSortable_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var onDragStart = Symbol('onDragStart');
var onDragOverContainer = Symbol('onDragOverContainer');
var onDragOver = Symbol('onDragOver');
var onDragStop = Symbol('onDragStop');
/**
 * Returns announcement message when a Draggable element has been sorted with another Draggable element
 * or moved into a new container
 * @param {SortableSortedEvent} sortableEvent
 * @return {String}
 */

function onSortableSortedDefaultAnnouncement(_ref) {
  var dragEvent = _ref.dragEvent;
  var sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || 'sortable element';

  if (dragEvent.over) {
    var overText = dragEvent.over.textContent.trim() || dragEvent.over.id || 'sortable element';
    var isFollowing = dragEvent.source.compareDocumentPosition(dragEvent.over) & Node.DOCUMENT_POSITION_FOLLOWING;

    if (isFollowing) {
      return "Placed ".concat(sourceText, " after ").concat(overText);
    } else {
      return "Placed ".concat(sourceText, " before ").concat(overText);
    }
  } else {
    // need to figure out how to compute container name
    return "Placed ".concat(sourceText, " into a different container");
  }
}
/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['sortable:sorted']
 */


var defaultAnnouncements = {
  'sortable:sorted': onSortableSortedDefaultAnnouncement
};
/**
 * Sortable is built on top of Draggable and allows sorting of draggable elements. Sortable will keep
 * track of the original index and emits the new index as you drag over draggable elements.
 * @class Sortable
 * @module Sortable
 * @extends Draggable
 */

var DataSortable_Sortable =
/*#__PURE__*/
function (_Draggable) {
  _inherits(Sortable, _Draggable);

  /**
   * Sortable constructor.
   * @constructs Sortable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Sortable containers
   * @param {Object} options - Options for Sortable
   */
  function Sortable() {
    var _this;

    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Sortable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sortable).call(this, containers, DataSortable_objectSpread({}, options, {
      announcements: DataSortable_objectSpread({}, defaultAnnouncements, {}, options.announcements || {})
    })));
    /**
     * start index of source on drag start
     * @property startIndex
     * @type {Number}
     */

    _this.startIndex = null;
    _this.startSibling = null;
    _this.containerManager = new ContainerManager_ContainerManager();
    /**
     * start container on drag start
     * @property startContainer
     * @type {HTMLElement}
     * @default null
     */

    _this.startContainer = null;
    _this[onDragStart] = _this[onDragStart].bind(_assertThisInitialized(_this));
    _this[onDragOverContainer] = _this[onDragOverContainer].bind(_assertThisInitialized(_this));
    _this[onDragOver] = _this[onDragOver].bind(_assertThisInitialized(_this));
    _this[onDragStop] = _this[onDragStop].bind(_assertThisInitialized(_this));

    _this.on('drag:start', _this[onDragStart]).on('drag:over:container', _this[onDragOverContainer]).on('drag:over', function (e) {
      try {
        return _this[onDragOver](e);
      } catch (error) {// console.log('error', error); // TODO - how else to catch this safely?
      }
    }).on('drag:stop', _this[onDragStop]);

    return _this;
  }
  /**
   * Destroys Sortable instance.
   */


  _createClass(Sortable, [{
    key: "destroy",
    value: function destroy() {
      get_get(_getPrototypeOf(Sortable.prototype), "destroy", this).call(this);

      this.off('drag:start', this[onDragStart]).off('drag:over:container', this[onDragOverContainer]).off('drag:over', this[onDragOver]).off('drag:stop', this[onDragStop]);
    }
    /**
     * Returns true index of element within its container during drag operation, i.e. excluding mirror and original source
     * @param {HTMLElement} element - An element
     * @return {Number}
     */

  }, {
    key: "index",
    value: function index(element) {
      return this.getDraggableElementsForContainer(element.parentNode).indexOf(element);
    } // TODO - have overriden base class to only look at one level deep for indexes.

  }, {
    key: "getDraggableElementsForContainer",
    value: function getDraggableElementsForContainer(container) {
      var _this2 = this;

      container.setAttribute('new-container', '');
      var allDraggableElements = container.parentNode.querySelectorAll("[new-container] > ".concat(this.options.draggable));
      container.removeAttribute('new-container'); // const allDraggableElements = container.querySelectorAll(this.options.draggable);

      return _toConsumableArray(allDraggableElements).filter(function (childElement) {
        return childElement !== _this2.originalSource && childElement !== _this2.mirror;
      });
    } // todo - overriden to support metadata

    /**
     * Adds container to this draggable instance
     * @param {HTMLElement} container - Container you want to add to draggable
     * @param payload?
     * @return {Draggable}
     * @example draggable.addContainer(document.body)
     */

  }, {
    key: "addContainer",
    value: function addContainer(container) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.containers.push(container);
      this.sensors.forEach(function (sensor) {
        return sensor.addContainer(container);
      });
      this.containerManager.add(container, payload);
      return this;
    } // todo - overriden to support metadata

    /**
     * Removes container from this draggable instance
     * @param {HTMLElement} container - Container you want to remove from draggable
     * @return {Draggable}
     * @example draggable.removeContainer(document.body)
     */

  }, {
    key: "removeContainer",
    value: function removeContainer(container) {
      this.containers = this.containers.filter(function (check) {
        return check !== container;
      });
      this.sensors.forEach(function (sensor) {
        return sensor.removeContainer(container);
      });
      return this;
    }
    /**
     * Drag start handler
     * @private
     * @param {DragStartEvent} event - Drag start event
     */

  }, {
    key: onDragStart,
    value: function value(event) {
      this.startContainer = event.source.parentNode;
      this.startIndex = this.index(event.source);
      this.startSibling = event.source.nextElementSibling;
      var sortableStartEvent = new sortable["SortableStartEvent"]({
        dragEvent: event,
        startIndex: this.startIndex,
        startContainer: this.startContainer
      });
      this.trigger(sortableStartEvent);

      if (sortableStartEvent.canceled()) {
        event.cancel();
      }
    }
    /**
     * Drag over container handler
     * @private
     * @param {DragOverContainerEvent} event - Drag over container event
     */

  }, {
    key: onDragOverContainer,
    value: function value(event) {
      if (event.canceled()) {
        return;
      }

      var source = event.source,
          over = event.over,
          overContainer = event.overContainer;
      var oldIndex = this.index(source);
      var sortableSortEvent = new sortable["SortableSortEvent"]({
        dragEvent: event,
        currentIndex: oldIndex,
        source: source,
        over: over
      });
      this.trigger(sortableSortEvent);

      if (sortableSortEvent.canceled()) {
        return;
      }

      var children = this.getDraggableElementsForContainer(overContainer);
      var moves = move({
        source: source,
        over: over,
        overContainer: overContainer,
        children: children
      });

      if (!moves) {
        return;
      }

      var oldContainer = moves.oldContainer,
          newContainer = moves.newContainer,
          revert = moves.revert;
      var newIndex = this.index(event.source);
      var sortableSortedEvent = new sortable["SortableSortedEvent"]({
        dragEvent: event,
        oldIndex: oldIndex,
        newIndex: newIndex,
        oldContainer: oldContainer,
        newContainer: newContainer,
        revert: revert
      });
      this.trigger(sortableSortedEvent);
    }
    /**
     * Drag over handler
     * @private
     * @param {DragOverEvent} event - Drag over event
     */

  }, {
    key: onDragOver,
    value: function value(event) {
      if (event.over === event.originalSource || event.over === event.source) {
        return;
      }

      var source = event.source,
          over = event.over,
          overContainer = event.overContainer;
      var oldIndex = this.index(source);
      var sortableSortEvent = new sortable["SortableSortEvent"]({
        dragEvent: event,
        currentIndex: oldIndex,
        source: source,
        over: over
      });
      this.trigger(sortableSortEvent);

      if (sortableSortEvent.canceled()) {
        return;
      }

      var children = this.getDraggableElementsForContainer(overContainer);
      var moves = move({
        source: source,
        over: over,
        overContainer: overContainer,
        children: children
      });

      if (!moves) {
        return;
      }

      var oldContainer = moves.oldContainer,
          newContainer = moves.newContainer,
          revert = moves.revert;
      var newIndex = this.index(source);
      var sortableSortedEvent = new sortable["SortableSortedEvent"]({
        dragEvent: event,
        oldIndex: oldIndex,
        newIndex: newIndex,
        oldContainer: oldContainer,
        newContainer: newContainer,
        revert: revert
      });
      this.trigger(sortableSortedEvent);
    }
    /**
     * Drag stop handler
     * @private
     * @param {DragStopEvent} event - Drag stop event
     */

  }, {
    key: onDragStop,
    value: function value(event) {
      var _this3 = this;

      var revert = function revert() {
        _this3.startContainer.insertBefore(event.source, _this3.startSibling);
      };

      var sortableStopEvent = new sortable["SortableStopEvent"]({
        dragEvent: event,
        oldIndex: this.startIndex,
        newIndex: this.index(event.source),
        oldContainer: this.startContainer,
        newContainer: event.source.parentNode,
        revert: revert,
        oldContainerPayload: this.containerManager.payload(this.startContainer),
        newContainerPayload: this.containerManager.payload(event.source.parentNode)
      });
      this.trigger(sortableStopEvent);
      this.startIndex = null;
      this.startContainer = null;
      this.startSibling = null;
    }
  }]);

  return Sortable;
}(draggable_default.a);



function DataSortable_index(element) {
  return Array.prototype.indexOf.call(element.parentNode.children, element);
}

function move(_ref2) {
  var source = _ref2.source,
      over = _ref2.over,
      overContainer = _ref2.overContainer,
      children = _ref2.children;
  var emptyOverContainer = !children.length;
  var differentContainer = source.parentNode !== overContainer;
  var sameContainer = over && !differentContainer;

  if (emptyOverContainer) {
    return moveInsideEmptyContainer(source, overContainer);
  } else if (sameContainer) {
    return moveWithinContainer(source, over);
  } else if (differentContainer) {
    return moveOutsideContainer(source, over, overContainer);
  } else {
    return null;
  }
}

function moveInsideEmptyContainer(source, overContainer) {
  var oldContainer = source.parentNode;
  overContainer.appendChild(source);

  var revert = function revert() {
    // just inserts it back prior to previously adjacent sibling
    oldContainer.appendChild(source);
  };

  return {
    oldContainer: oldContainer,
    newContainer: overContainer,
    revert: revert
  };
}

function moveWithinContainer(source, over) {
  var oldIndex = DataSortable_index(source);
  var newIndex = DataSortable_index(over);
  var revert;

  if (oldIndex < newIndex) {
    source.parentNode.insertBefore(source, over.nextElementSibling);

    revert = function revert() {
      // inside same container, so just move it back to oldIndex
      source.parentNode.insertBefore(source, source.parentNode.children[oldIndex]);
    };
  } else {
    source.parentNode.insertBefore(source, over);

    revert = function revert() {
      source.parentNode.insertBefore(source, over.nextElementSibling);
    };
  }

  return {
    oldContainer: source.parentNode,
    newContainer: source.parentNode,
    revert: revert
  };
}

function moveOutsideContainer(source, over, overContainer) {
  var oldContainer = source.parentNode;
  var oldNextSibling = source.nextElementSibling;

  var revert = function revert() {
    oldContainer.insertBefore(source, oldNextSibling);
  };

  if (over) {
    over.parentNode.insertBefore(source, over);
  } else {
    // need to figure out proper position
    overContainer.appendChild(source);
  }

  return {
    oldContainer: oldContainer,
    newContainer: source.parentNode,
    revert: revert
  };
}
// EXTERNAL MODULE: ./node_modules/array-move/index.js
var array_move = __webpack_require__("c18c");
var array_move_default = /*#__PURE__*/__webpack_require__.n(array_move);

// CONCATENATED MODULE: ./src/mixins/mixin-rearrangeable.ts








 // @ts-ignore

var mixin_rearrangeable_AbstractRearrangeableMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(AbstractRearrangeableMixin, _Vue);

  function AbstractRearrangeableMixin() {
    var _this;

    _classCallCheck(this, AbstractRearrangeableMixin);

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractRearrangeableMixin).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.sortableInstance = null;
    return _this;
  }

  _createClass(AbstractRearrangeableMixin, [{
    key: "mounted",
    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////
    value: function mounted() {
      if (this.isRearrangeable) {
        this.enableRearrangeability();
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.disableRearrangeability();
    } ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onChangeIsRearrangeable",
    value: function onChangeIsRearrangeable(isRearrangeable, wasRearrangeable) {
      if (!wasRearrangeable && isRearrangeable) this.enableRearrangeability();
      if (wasRearrangeable && !isRearrangeable) this.disableRearrangeability();
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

  }, {
    key: "enableRearrangeability",
    value: function enableRearrangeability() {
      var _this2 = this;

      var options = {
        draggable: ".".concat(this.rearrangeableItemClass),
        handle: ".".concat(this.rearrangeableItemHandleClass),
        mirror: {
          constrainDimensions: true
        }
      };
      this.sortableInstance = new DataSortable_Sortable(this.$el, options);
      this.sortableInstance.containerManager.add(this.$el);
      this.sortableInstance.on('sortable:stop', function (e) {
        var data = e.data;
        data.revert(); // moves it back so that dom manipulations don't interfere with Vue tracking

        var rearranged = array_move_default()(_this2.rearrangeableItems, data.oldIndex, data.newIndex);

        _this2.$emit('update:items', rearranged);
      });
    }
  }, {
    key: "disableRearrangeability",
    value: function disableRearrangeability() {
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
      }
    }
  }, {
    key: "isRearrangeable",
    get: function get() {
      return false;
    }
  }, {
    key: "rearrangeableItemClass",
    get: function get() {
      return 'rearrangeable-item';
    }
  }, {
    key: "rearrangeableItemHandleClass",
    get: function get() {
      return 'rearrangeable-item-handle';
    }
  }]);

  return AbstractRearrangeableMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Watch('isRearrangeable')], mixin_rearrangeable_AbstractRearrangeableMixin.prototype, "onChangeIsRearrangeable", null);

mixin_rearrangeable_AbstractRearrangeableMixin = __decorate([vue_class_component_esm], mixin_rearrangeable_AbstractRearrangeableMixin);


var mixin_rearrangeable_RearrangeableMixin =
/*#__PURE__*/
// @ts-ignore
function (_AbstractRearrangeabl) {
  _inherits(RearrangeableMixin, _AbstractRearrangeabl);

  function RearrangeableMixin() {
    _classCallCheck(this, RearrangeableMixin);

    return _possibleConstructorReturn(this, _getPrototypeOf(RearrangeableMixin).apply(this, arguments));
  }

  return RearrangeableMixin;
}(mixin_rearrangeable_AbstractRearrangeableMixin);

mixin_rearrangeable_RearrangeableMixin = __decorate([vue_class_component_esm // @ts-ignore
], mixin_rearrangeable_RearrangeableMixin);
/* harmony default export */ var mixin_rearrangeable = (mixin_rearrangeable_RearrangeableMixin);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiList/UiList.vue?vue&type=script&lang=ts&









var UiListvue_type_script_lang_ts_UiList =
/*#__PURE__*/
function (_Mixins) {
  _inherits(UiList, _Mixins);

  function UiList() {
    _classCallCheck(this, UiList);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiList).apply(this, arguments));
  }

  _createClass(UiList, [{
    key: "rearrangeableItems",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.items;
    }
  }, {
    key: "isRearrangeable",
    get: function get() {
      return this.rearrangeable;
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        'compact': this.compact,
        'spacious': !this.compact
      };
    }
  }]);

  return UiList;
}(mixins(mixin_rearrangeable));

__decorate([Prop({
  type: Array,
  required: true
})], UiListvue_type_script_lang_ts_UiList.prototype, "items", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListvue_type_script_lang_ts_UiList.prototype, "compact", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListvue_type_script_lang_ts_UiList.prototype, "sortable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListvue_type_script_lang_ts_UiList.prototype, "rearrangeable", void 0);

UiListvue_type_script_lang_ts_UiList = __decorate([vue_class_component_esm], UiListvue_type_script_lang_ts_UiList);
/* harmony default export */ var UiListvue_type_script_lang_ts_ = (UiListvue_type_script_lang_ts_UiList);
// CONCATENATED MODULE: ./src/components/UiList/UiList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiList_UiListvue_type_script_lang_ts_ = (UiListvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiList/UiList.vue?vue&type=style&index=0&id=2fabe444&lang=stylus&scoped=true&
var UiListvue_type_style_index_0_id_2fabe444_lang_stylus_scoped_true_ = __webpack_require__("1fbc");

// CONCATENATED MODULE: ./src/components/UiList/UiList.vue






/* normalize component */

var UiList_component = normalizeComponent(
  UiList_UiListvue_type_script_lang_ts_,
  UiListvue_type_template_id_2fabe444_scoped_true_lang_pug_render,
  UiListvue_type_template_id_2fabe444_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "2fabe444",
  null
  
)

/* harmony default export */ var UiList_UiList = (UiList_component.exports);
// CONCATENATED MODULE: ./src/components/UiList/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiListItem/UiListItem.vue?vue&type=template&id=720b8e2e&scoped=true&lang=pug&
var UiListItemvue_type_template_id_720b8e2e_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"ui-list-item",class:_vm.classes,style:(_vm.listItemStyleObject),on:{"click":_vm.onClick}},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.$scopedSlots['left-icon'])?_c('div',{staticClass:"icon"},[_vm._t("left-icon",null,null,_vm.$props)],2):_vm._e(),_c('div',{staticClass:"main"},[_vm._t("title",null,null,_vm.$props),_vm._t("subtitle",null,null,_vm.$props)],2),(_vm.$scopedSlots['right-icon'])?_c('div',{staticClass:"icon"},[_vm._t("right-icon",null,null,_vm.$props)],2):_vm._e()])}
var UiListItemvue_type_template_id_720b8e2e_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiListItem/UiListItem.vue?vue&type=template&id=720b8e2e&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiListItem/UiListItem.vue?vue&type=script&lang=ts&








var UiListItemvue_type_script_lang_ts_UiListItem =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiListItem, _Vue);

  function UiListItem() {
    _classCallCheck(this, UiListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiListItem).apply(this, arguments));
  }

  _createClass(UiListItem, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClick() {
      if (this.disabled || this.readOnly) return;
      this.$emit('click');
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        // color
        'white': this.white && !this.subtle,
        'dark': !this.white && !this.subtle,
        'subtle': !this.white && this.subtle,
        'danger': this.danger,
        'success': this.success,
        'regular-highlight': !this.primaryHighlight,
        'primary-highlight': this.primaryHighlight,
        // floating
        'floating': this.floating,
        // spacing
        'tight': this.tight && !this.compact,
        'compact': !this.tight && this.compact,
        'spacious': !this.tight && !this.compact,
        'no-horizontal-padding': this.noHorizontalPadding,
        // state
        'highlighted': this.highlighted,
        'enabled': !this.disabled && !this.readOnly,
        'disabled': this.disabled,
        'read-only': this.readOnly
      };
    }
  }, {
    key: "listItemStyleObject",
    get: function get() {
      if (!this.color) return null;
      return {
        borderLeftWidth: 'units(6/32)',
        borderLeftStyle: 'solid',
        borderLeftColor: this.color
      };
    }
  }]);

  return UiListItem;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "color", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "white", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "floating", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "compact", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "tight", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "noHorizontalPadding", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "readOnly", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "highlighted", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "danger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "success", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiListItemvue_type_script_lang_ts_UiListItem.prototype, "primaryHighlight", void 0);

UiListItemvue_type_script_lang_ts_UiListItem = __decorate([vue_class_component_esm], UiListItemvue_type_script_lang_ts_UiListItem);
/* harmony default export */ var UiListItemvue_type_script_lang_ts_ = (UiListItemvue_type_script_lang_ts_UiListItem);
// CONCATENATED MODULE: ./src/components/UiListItem/UiListItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiListItem_UiListItemvue_type_script_lang_ts_ = (UiListItemvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiListItem/UiListItem.vue?vue&type=style&index=0&id=720b8e2e&lang=stylus&scoped=true&
var UiListItemvue_type_style_index_0_id_720b8e2e_lang_stylus_scoped_true_ = __webpack_require__("b495");

// CONCATENATED MODULE: ./src/components/UiListItem/UiListItem.vue






/* normalize component */

var UiListItem_component = normalizeComponent(
  UiListItem_UiListItemvue_type_script_lang_ts_,
  UiListItemvue_type_template_id_720b8e2e_scoped_true_lang_pug_render,
  UiListItemvue_type_template_id_720b8e2e_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "720b8e2e",
  null
  
)

/* harmony default export */ var UiListItem_UiListItem = (UiListItem_component.exports);
// CONCATENATED MODULE: ./src/components/UiListItem/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiModal/UiModal.vue?vue&type=template&id=b0f1ccda&scoped=true&lang=pug&
var UiModalvue_type_template_id_b0f1ccda_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.portaled)?_c('portal',{attrs:{"to":_vm.portalTargetName}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"overlay",on:{"click":_vm.dismissModal}}),_c('transition',{attrs:{"name":"grow"}},[(_vm.show)?_c('div',{staticClass:"container"},[_vm._t("default")],2):_vm._e()])],1):_vm._e()])],1):_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"overlay",on:{"click":_vm.dismissModal}}),_c('transition',{attrs:{"name":"grow"}},[(_vm.show)?_c('div',{staticClass:"container"},[_vm._t("default")],2):_vm._e()])],1):_vm._e()])}
var UiModalvue_type_template_id_b0f1ccda_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiModal/UiModal.vue?vue&type=template&id=b0f1ccda&scoped=true&lang=pug&

// CONCATENATED MODULE: ./src/config.ts

var config = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.observable({
  modalPortalTargetName: 'modal-portal-target',
  toastPortalTargetName: 'toast-portal-target',
  toastDuration: 5000
});
/* harmony default export */ var src_config = (config);
// EXTERNAL MODULE: ./node_modules/portal-vue/dist/portal-vue.common.js
var portal_vue_common = __webpack_require__("2b88");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiModal/UiModal.vue?vue&type=script&lang=ts&










var UiModalvue_type_script_lang_ts_UiModal =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiModal, _Vue);

  function UiModal() {
    _classCallCheck(this, UiModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiModal).apply(this, arguments));
  }

  _createClass(UiModal, [{
    key: "dismissModal",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function dismissModal() {
      if (!this.clickOutsideToDismiss) return;
      this.$emit('dismiss');
      this.$emit('update:show', false);
      this.onClose();
    }
  }, {
    key: "portalTargetName",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.$attrs.to || src_config.modalPortalTargetName;
    }
  }]);

  return UiModal;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  required: true
})], UiModalvue_type_script_lang_ts_UiModal.prototype, "show", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiModalvue_type_script_lang_ts_UiModal.prototype, "clickOutsideToDismiss", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiModalvue_type_script_lang_ts_UiModal.prototype, "portaled", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return function () {};
  }
})], UiModalvue_type_script_lang_ts_UiModal.prototype, "onClose", void 0);

UiModalvue_type_script_lang_ts_UiModal = __decorate([vue_class_component_esm({
  components: {
    Portal: portal_vue_common["Portal"]
  }
})], UiModalvue_type_script_lang_ts_UiModal);
/* harmony default export */ var UiModalvue_type_script_lang_ts_ = (UiModalvue_type_script_lang_ts_UiModal);
// CONCATENATED MODULE: ./src/components/UiModal/UiModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiModal_UiModalvue_type_script_lang_ts_ = (UiModalvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiModal/UiModal.vue?vue&type=style&index=0&id=b0f1ccda&lang=stylus&scoped=true&
var UiModalvue_type_style_index_0_id_b0f1ccda_lang_stylus_scoped_true_ = __webpack_require__("13de");

// CONCATENATED MODULE: ./src/components/UiModal/UiModal.vue






/* normalize component */

var UiModal_component = normalizeComponent(
  UiModal_UiModalvue_type_script_lang_ts_,
  UiModalvue_type_template_id_b0f1ccda_scoped_true_lang_pug_render,
  UiModalvue_type_template_id_b0f1ccda_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "b0f1ccda",
  null
  
)

/* harmony default export */ var UiModal_UiModal = (UiModal_component.exports);
// CONCATENATED MODULE: ./src/components/UiModal/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiModalPortalTarget/UiModalPortalTarget.vue?vue&type=template&id=edc3b1e0&lang=pug&
var UiModalPortalTargetvue_type_template_id_edc3b1e0_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal-target',{attrs:{"name":_vm.portalTargetName,"multiple":""}})}
var UiModalPortalTargetvue_type_template_id_edc3b1e0_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiModalPortalTarget/UiModalPortalTarget.vue?vue&type=template&id=edc3b1e0&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiModalPortalTarget/UiModalPortalTarget.vue?vue&type=script&lang=ts&











var UiModalPortalTargetvue_type_script_lang_ts_UiModalPortalTarget =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiModalPortalTarget, _Vue);

  function UiModalPortalTarget() {
    _classCallCheck(this, UiModalPortalTarget);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiModalPortalTarget).apply(this, arguments));
  }

  _createClass(UiModalPortalTarget, [{
    key: "portalTargetName",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.$attrs.name || src_config.modalPortalTargetName;
    }
  }]);

  return UiModalPortalTarget;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

UiModalPortalTargetvue_type_script_lang_ts_UiModalPortalTarget = __decorate([vue_class_component_esm({
  components: {
    PortalTarget: portal_vue_common["PortalTarget"]
  }
})], UiModalPortalTargetvue_type_script_lang_ts_UiModalPortalTarget);
/* harmony default export */ var UiModalPortalTargetvue_type_script_lang_ts_ = (UiModalPortalTargetvue_type_script_lang_ts_UiModalPortalTarget);
// CONCATENATED MODULE: ./src/components/UiModalPortalTarget/UiModalPortalTarget.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiModalPortalTarget_UiModalPortalTargetvue_type_script_lang_ts_ = (UiModalPortalTargetvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiModalPortalTarget/UiModalPortalTarget.vue





/* normalize component */

var UiModalPortalTarget_component = normalizeComponent(
  UiModalPortalTarget_UiModalPortalTargetvue_type_script_lang_ts_,
  UiModalPortalTargetvue_type_template_id_edc3b1e0_lang_pug_render,
  UiModalPortalTargetvue_type_template_id_edc3b1e0_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiModalPortalTarget_UiModalPortalTarget = (UiModalPortalTarget_component.exports);
// CONCATENATED MODULE: ./src/components/UiModalPortalTarget/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPullOutTab/UiPullOutTab.vue?vue&type=template&id=18d2e2f0&scoped=true&lang=pug&
var UiPullOutTabvue_type_template_id_18d2e2f0_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('ui-button',_vm._b({staticClass:"ui-pull-out-tab",class:_vm.classes,attrs:{"icon":_vm.icon,"iconOnRight":_vm.position === 'left',"uppercase":"","floating":"","primary":"","subtle":"","label":_vm.$attrs.label || 'Show sidebar',"showLabel":!!_vm.$attrs.label || false},on:{"click":function($event){return _vm.$emit('click')}}},'ui-button',_vm.$attrs,false)):_vm._e()],1)}
var UiPullOutTabvue_type_template_id_18d2e2f0_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiPullOutTab/UiPullOutTab.vue?vue&type=template&id=18d2e2f0&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPullOutTab/UiPullOutTab.vue?vue&type=script&lang=ts&










var UiPullOutTabvue_type_script_lang_ts_UiPullOutTab =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiPullOutTab, _Vue);

  function UiPullOutTab() {
    _classCallCheck(this, UiPullOutTab);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiPullOutTab).apply(this, arguments));
  }

  _createClass(UiPullOutTab, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return [this.position];
    }
  }, {
    key: "icon",
    get: function get() {
      if (this.position === 'left') return 'arrow-right';
      return 'arrow-left';
    }
  }]);

  return UiPullOutTab;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiPullOutTabvue_type_script_lang_ts_UiPullOutTab.prototype, "show", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return ['left', 'right'].includes(value);
  },
  required: true
})], UiPullOutTabvue_type_script_lang_ts_UiPullOutTab.prototype, "position", void 0);

UiPullOutTabvue_type_script_lang_ts_UiPullOutTab = __decorate([vue_class_component_esm({
  components: {
    UiButton: UiButton_UiButton
  }
})], UiPullOutTabvue_type_script_lang_ts_UiPullOutTab);
/* harmony default export */ var UiPullOutTabvue_type_script_lang_ts_ = (UiPullOutTabvue_type_script_lang_ts_UiPullOutTab);
// CONCATENATED MODULE: ./src/components/UiPullOutTab/UiPullOutTab.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiPullOutTab_UiPullOutTabvue_type_script_lang_ts_ = (UiPullOutTabvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiPullOutTab/UiPullOutTab.vue?vue&type=style&index=0&id=18d2e2f0&lang=stylus&scoped=true&
var UiPullOutTabvue_type_style_index_0_id_18d2e2f0_lang_stylus_scoped_true_ = __webpack_require__("000b");

// CONCATENATED MODULE: ./src/components/UiPullOutTab/UiPullOutTab.vue






/* normalize component */

var UiPullOutTab_component = normalizeComponent(
  UiPullOutTab_UiPullOutTabvue_type_script_lang_ts_,
  UiPullOutTabvue_type_template_id_18d2e2f0_scoped_true_lang_pug_render,
  UiPullOutTabvue_type_template_id_18d2e2f0_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "18d2e2f0",
  null
  
)

/* harmony default export */ var UiPullOutTab_UiPullOutTab = (UiPullOutTab_component.exports);
// CONCATENATED MODULE: ./src/components/UiPullOutTab/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSidebar/UiSidebar.vue?vue&type=template&id=2571f8d6&scoped=true&lang=pug&
var UiSidebarvue_type_template_id_2571f8d6_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-sidebar",class:_vm.classes},[_c('transition',{attrs:{"name":"fade"}},[(_vm.state === 'collapsed')?_c('div',{key:"collapsed",staticClass:"ui-sidebar__collapsed"},[_vm._t("collapsed")],2):(_vm.state === 'open')?_c('div',{staticClass:"ui-sidebar__open"},[(_vm.$scopedSlots['header'] && _vm.state === 'open')?_c('div',{staticClass:"ui-sidebar__header"},[_vm._t("header")],2):_vm._e(),_c('transition-group',{staticClass:"ui-sidebar__container",attrs:{"name":"fade","tag":"div"}},[(_vm.empty)?_c('div',{key:"empty",staticClass:"ui-sidebar__wrapper"},[_vm._t("empty")],2):(_vm.tabKeys.length > 0)?[_vm._l((_vm.tabKeys),function(key){return (_vm.selected === key)?[_c('div',{key:("main:" + key),staticClass:"ui-sidebar__wrapper"},[_vm._t(("main:" + key))],2)]:_vm._e()})]:[_c('div',{key:"main",staticClass:"ui-sidebar__wrapper"},[_vm._t("main")],2)]],2)],1):_vm._e()])],1)}
var UiSidebarvue_type_template_id_2571f8d6_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSidebar/UiSidebar.vue?vue&type=template&id=2571f8d6&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSidebar/UiSidebar.vue?vue&type=script&lang=ts&










var UiSidebarvue_type_script_lang_ts_UiSidebar =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiSidebar, _Vue);

  function UiSidebar() {
    _classCallCheck(this, UiSidebar);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiSidebar).apply(this, arguments));
  }

  _createClass(UiSidebar, [{
    key: "classes",
    get: function get() {
      return ["position-".concat(this.position)];
    }
  }]);

  return UiSidebar;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiSidebarvue_type_script_lang_ts_UiSidebar.prototype, "tabKeys", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiSidebarvue_type_script_lang_ts_UiSidebar.prototype, "selected", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarvue_type_script_lang_ts_UiSidebar.prototype, "empty", void 0);

__decorate([Prop({
  type: String,
  default: 'open',
  validator: function validator(value) {
    return ['hidden', 'collapsed', 'open'].includes(value);
  }
})], UiSidebarvue_type_script_lang_ts_UiSidebar.prototype, "state", void 0);

__decorate([Prop({
  type: String,
  default: 'left',
  validator: function validator(value) {
    return ['left', 'right'].includes(value);
  }
})], UiSidebarvue_type_script_lang_ts_UiSidebar.prototype, "position", void 0);

UiSidebarvue_type_script_lang_ts_UiSidebar = __decorate([vue_class_component_esm({
  components: {
    UiIconButton: UiIconButton
  }
})], UiSidebarvue_type_script_lang_ts_UiSidebar);
/* harmony default export */ var UiSidebarvue_type_script_lang_ts_ = (UiSidebarvue_type_script_lang_ts_UiSidebar);
// CONCATENATED MODULE: ./src/components/UiSidebar/UiSidebar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiSidebar_UiSidebarvue_type_script_lang_ts_ = (UiSidebarvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiSidebar/UiSidebar.vue?vue&type=style&index=0&id=2571f8d6&lang=stylus&scoped=true&
var UiSidebarvue_type_style_index_0_id_2571f8d6_lang_stylus_scoped_true_ = __webpack_require__("4423");

// CONCATENATED MODULE: ./src/components/UiSidebar/UiSidebar.vue






/* normalize component */

var UiSidebar_component = normalizeComponent(
  UiSidebar_UiSidebarvue_type_script_lang_ts_,
  UiSidebarvue_type_template_id_2571f8d6_scoped_true_lang_pug_render,
  UiSidebarvue_type_template_id_2571f8d6_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "2571f8d6",
  null
  
)

/* harmony default export */ var UiSidebar_UiSidebar = (UiSidebar_component.exports);
// CONCATENATED MODULE: ./src/components/UiSidebar/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSidebarWrapper/UiSidebarWrapper.vue?vue&type=template&id=157593b4&scoped=true&lang=pug&
var UiSidebarWrappervue_type_template_id_157593b4_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sidebar-wrapper",staticClass:"ui-sidebar-wrapper",class:_vm.classes,on:{"mouseup":_vm.onMouseUp,"mousemove":_vm.onMouseMove}},[_c('div',{staticClass:"main-wrapper",style:(_vm.mainStyle),on:{"click":_vm.onClickOutsideSidebar}},[_vm._t("main")],2),_c('transition',{attrs:{"name":"sidebar-slide"},on:{"before-enter":function($event){_vm.sidebarEntering = true},"after-enter":function($event){_vm.sidebarEntering = false},"before-leave":function($event){_vm.sidebarLeaving = true},"after-leave":function($event){_vm.sidebarLeaving = false}}},[(_vm.willRenderSidebar)?_c('div',{ref:"sidebar",staticClass:"sidebar",style:(_vm.sidebarStyle)},[_vm._t("sidebar",null,{"state":_vm.currentSidebarState,"position":_vm.position})],2):_vm._e()]),_c('div',{staticClass:"pull-out-tab-anchor",style:(_vm.pullOutTabAnchorStyle)},[_c('ui-pull-out-tab',{attrs:{"show":_vm.willRenderPullOutTab,"position":_vm.position,"label":_vm.pullOutTabLabel},on:{"click":function($event){return _vm.$emit('update:showSidebar', true)}}})],1),_c('transition',{attrs:{"name":"fade"}},[(_vm.willRenderSidebarPlaceholder)?_c('div',{staticClass:"sidebar-placeholder-container",style:(_vm.sidebarPlaceholderContainerStyle)},[_vm._t("sidebar:placeholder",[_c('div',{staticClass:"sidebar-placeholder",style:(_vm.sidebarPlaceholderStyle)})],{"styleObject":_vm.sidebarPlaceholderStyle})],2):_vm._e()]),_c('transition',{attrs:{"name":"fade"},on:{"before-leave":function($event){_vm.overlayLeaving = true},"after-leave":function($event){_vm.overlayLeaving = false}}},[(_vm.willRenderOverlay)?_c('div',{staticClass:"overlay",on:{"click":_vm.onClickOutsideSidebar}}):_vm._e()]),(_vm.willRenderResizeBar)?_c('div',{staticClass:"resize-bar",style:(_vm.resizeBarStyle),on:{"mousedown":_vm.onMouseDown}}):_vm._e()],1)}
var UiSidebarWrappervue_type_template_id_157593b4_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSidebarWrapper/UiSidebarWrapper.vue?vue&type=template&id=157593b4&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/global.js
var global_global = typeof window === 'undefined' ? undefined || {} : window;


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js
var trigger;
var queueMicroTask_callbacks = [];
var notify = function () { return queueMicroTask_callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    if (!trigger) {
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = ''; };
    }
    queueMicroTask_callbacks.push(callback);
    trigger();
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js

var queueResizeObserver = function (cb) {
    queueMicroTask(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/scheduler.js



var CATCH_FRAMES = 60 / 5;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var scheduled = false;
var scheduler_Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (frames) {
        var _this = this;
        if (scheduled) {
            return;
        }
        scheduled = true;
        queueResizeObserver(function () {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = process();
            }
            finally {
                scheduled = false;
                if (!isWatching()) {
                    return;
                }
                if (elementsHaveResized) {
                    _this.run(60);
                }
                else if (frames) {
                    _this.run(frames - 1);
                }
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run(CATCH_FRAMES);
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : global_global.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return global_global.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return global_global.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new scheduler_Scheduler();


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js
var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js
var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return Object.freeze(this);
    }
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/element.js
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js




var cache = new Map();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(global_global.navigator && global_global.navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var calculateBoxSize_size = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return Object.freeze({
        inlineSize: (switchSizes ? blockSize : inlineSize) || 0,
        blockSize: (switchSizes ? inlineSize : blockSize) || 0
    });
};
var zeroBoxes = Object.freeze({
    borderBoxSize: calculateBoxSize_size(),
    contentBoxSize: calculateBoxSize_size(),
    contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function (target) {
    if (cache.has(target)) {
        return cache.get(target);
    }
    if (isHidden(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = isSVG(target) && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = Object.freeze({
        borderBoxSize: calculateBoxSize_size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: calculateBoxSize_size(contentWidth, contentHeight, switchSizes),
        contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox) {
    var _a = calculateBoxSizes(target), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize;
    return observedBox === ResizeObserverBoxOptions.BORDER_BOX ? borderBoxSize : contentBoxSize;
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObservation.js



var skipNotifyOnElement = function (target) {
    return !isSVG(target)
        && !isReplacedElement(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation_ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = calculateBoxSize(this.target, this.observedBox);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js
var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js

var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js

var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js

var ResizeObserverEntry_ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = boxes.borderBoxSize;
        this.contentBoxSize = boxes.contentBoxSize;
    }
    return ResizeObserverEntry;
}());


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js

var calculateDepthForNode = function (node) {
    if (isHidden(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js




var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new ResizeObserverEntry_ResizeObserverEntry(ot.target);
            var targetDepth = calculateDepthForNode(ot.target);
            entries.push(entry);
            ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js



var gatherActiveObservationsAtDepth = function (depth) {
    cache.clear();
    resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (calculateDepthForNode(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverController.js








var resizeObservers = [];
var observerMap = new Map();
var watching = 0;
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var process = function () {
    var depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopError();
    }
    return depth > 0;
};
var ResizeObserverController_ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new ResizeObserverDetail(resizeObserver, callback);
        resizeObservers.push(detail);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        if (observerMap.has(resizeObserver)) {
            var detail = observerMap.get(resizeObserver);
            if (getObservationIndex(detail.observationTargets, target) < 0) {
                detail.observationTargets.push(new ResizeObservation_ResizeObservation(target, options && options.box));
                updateCount(1);
                scheduler.schedule();
            }
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        if (observerMap.has(resizeObserver)) {
            var detail = observerMap.get(resizeObserver);
            var index = getObservationIndex(detail.observationTargets, target);
            if (index >= 0) {
                detail.observationTargets.splice(index, 1);
                updateCount(-1);
            }
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        if (observerMap.has(resizeObserver)) {
            var detail = observerMap.get(resizeObserver);
            resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            observerMap.delete(resizeObserver);
            updateCount(-detail.observationTargets.length);
        }
    };
    return ResizeObserverController;
}());
var isWatching = function () { return !!watching; };


// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserver.js

var ResizeObserver_ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        ResizeObserverController_ResizeObserverController.connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (target instanceof Element === false) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController_ResizeObserverController.observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (target instanceof Element === false) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController_ResizeObserverController.unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        ResizeObserverController_ResizeObserverController.disconnect(this);
    };
    ResizeObserver.toString = function () {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}());
/* harmony default export */ var lib_ResizeObserver = (ResizeObserver_ResizeObserver);


// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__("84a2");
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSidebarWrapper/UiSidebarWrapper.vue?vue&type=script&lang=ts&

















function UiSidebarWrappervue_type_script_lang_ts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiSidebarWrappervue_type_script_lang_ts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiSidebarWrappervue_type_script_lang_ts_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiSidebarWrappervue_type_script_lang_ts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var widthObserver;

var UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiSidebarWrapper, _Vue);

  function UiSidebarWrapper() {
    var _this;

    _classCallCheck(this, UiSidebarWrapper);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiSidebarWrapper).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.sidebarEntering = false;
    _this.sidebarLeaving = false;
    _this.sidebarExpanding = false;
    _this.sidebarCollapsing = false;
    _this.overlayLeaving = false;
    _this.previousSidebarState = null;
    _this.sidebarStyle = {}; // resize

    _this.startWidth = _this.width;
    _this.startX = null;
    _this.resizing = false; // responsive

    _this.totalWidth = null;
    _this.initialOverlap = _this.overlap;
    _this.initialDarkenBehindSidebar = _this.darkenBehindSidebar;
    _this.initialHiddenWhenClosed = _this.hiddenWhenClosed;
    _this.throttledEmitMainSlotWidth = lodash_throttle_default()(_this.emitMainSlotWidth, 200);
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////
  // classes


  _createClass(UiSidebarWrapper, [{
    key: "created",
    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////
    value: function created() {
      this.guessPreviousSidebarState();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.observeWidth();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      widthObserver && widthObserver.disconnect();
    } ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////
    // Records previous sidebar state.
    // Sets collapsing/expanding transition states.

  }, {
    key: "onChangeCurrentSidebarState",
    value: function onChangeCurrentSidebarState(newValue, oldValue) {
      var _this2 = this;

      if (newValue === oldValue) return;
      this.previousSidebarState = oldValue;
      if (oldValue === 'open' && newValue === 'collapsed') this.sidebarCollapsing = true;
      if (oldValue === 'collapsed' && newValue === 'open') this.sidebarExpanding = true;
      var transitionDuration = 350;
      setTimeout(function () {
        _this2.sidebarCollapsing = false;
        _this2.sidebarExpanding = false;
      }, transitionDuration);
    } // Applies CSS to enable transitions between expanded and collapsed sidebar states.

  }, {
    key: "onChangeSidebarStyleBeforeTransition",
    value: function onChangeSidebarStyleBeforeTransition(style) {
      var _this3 = this;

      var newStyle = UiSidebarWrappervue_type_script_lang_ts_objectSpread({}, style);

      if (this.sidebarExpanding || this.sidebarCollapsing) {
        newStyle.transform = "translateX(".concat(this.position === 'left' ? '-' : '').concat(this.width - this.widthWhenCollapsed, "rem)");

        if (this.sidebarCollapsing) {
          newStyle.transitionProperty = this.sidebarTransitioning ? 'transform' : 'none', this.sidebarStyle = newStyle;
        } else if (this.sidebarExpanding) {
          // To get the correct starting state for the expansion transition, the CSS transform (`newStyle.transform = ...`)
          // must be applied before enabling transitions (`newStyle.transitionProperty = ...`). A small wait of 50ms is used
          // to ensure one happens before the other. A combination of a computed property, a watcher, and a data property
          // must be used (instead of just a single computed property) because the `setTimeout` technique doesn't work
          // inside a computed property.
          this.sidebarStyle = newStyle;
          setTimeout(function () {
            newStyle.transitionProperty = _this3.sidebarTransitioning ? 'transform' : 'none', newStyle.transform = 'none';
            _this3.sidebarStyle = newStyle;
          }, 50);
        }
      } else {
        this.sidebarStyle = style;
      }
    }
  }, {
    key: "onChangeMainSlotMinWidthReachedIfSidebarOpen",
    value: function onChangeMainSlotMinWidthReachedIfSidebarOpen() {
      if (this.mainSlotMinWidthReachedIfSidebarOpen) {
        this.$emit('update:overlap', true);
        this.$emit('update:darkenBehindSidebar', true);
      } else {
        this.$emit('update:overlap', this.initialOverlap);
        this.$emit('update:darkenBehindSidebar', this.initialDarkenBehindSidebar);
      }
    }
  }, {
    key: "onChangeMainSlotMinWidthReachedIfSidebarClosed",
    value: function onChangeMainSlotMinWidthReachedIfSidebarClosed() {
      if (this.mainSlotMinWidthReachedIfSidebarClosed) {
        this.$emit('update:hiddenWhenClosed', true);
      } else {
        this.$emit('update:hiddenWhenClosed', this.initialHiddenWhenClosed);
      }
    }
  }, {
    key: "onChangeMainSlotWidth",
    value: function onChangeMainSlotWidth() {
      this.throttledEmitMainSlotWidth();
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    /**
     * Make a best guess as to what the previous sidebar state would have most likely been.
     */

  }, {
    key: "guessPreviousSidebarState",
    value: function guessPreviousSidebarState() {
      if (this.currentSidebarState === 'open') {
        if (this.hiddenWhenClosed) this.previousSidebarState = 'hidden';else this.previousSidebarState = 'collapsed';
      } else this.previousSidebarState = 'open';
    }
  }, {
    key: "observeWidth",
    value: function observeWidth() {
      var _this4 = this;

      widthObserver = new lib_ResizeObserver(function (entries, observer) {
        if (entries.length === 0) return;
        _this4.totalWidth = getPixelsAsRem(entries[0].contentRect.width);
      });
      widthObserver.observe(this.$refs['sidebar-wrapper']);
    }
  }, {
    key: "emitMainSlotWidth",
    value: function emitMainSlotWidth() {
      this.$emit('change:mainSlotWidth', this.mainSlotWidth);
    } ////////////////////////////////////////////////////////////////
    // methods → event handlers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      this.startX = event.clientX;
      this.startWidth = this.width;
      this.resizing = true;
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      this.startX = null;
      this.resizing = false;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      if (this.startX !== null) {
        var deltaInPixels = event.clientX - this.startX;
        var deltaInUnits = Math.round(getPixelsAsRem(deltaInPixels));
        var newWidth = this.startWidth + deltaInUnits * (this.position === 'left' ? 1 : -1);

        if (newWidth !== this.width && newWidth >= this.minWidth && newWidth <= this.maxWidth) {
          this.$emit('update:width', newWidth);
        }
      }
    }
  }, {
    key: "onClickOutsideSidebar",
    value: function onClickOutsideSidebar() {
      if (this.clickOutsideToHideSidebar && this.showSidebar) {
        this.$emit('update:showSidebar', false);
      }
    }
  }, {
    key: "classes",
    get: function get() {
      return [this.position, {
        'darken-behind-sidebar': this.willRenderOverlay,
        'overlay-visible': this.overlayVisible,
        'resizing': this.resizing
      }];
    }
  }, {
    key: "overlayVisible",
    get: function get() {
      return this.willRenderOverlay || this.overlayLeaving;
    } // transition states

  }, {
    key: "sidebarEnteringOrLeaving",
    get: function get() {
      return this.sidebarEntering || this.sidebarLeaving;
    }
  }, {
    key: "sidebarExpandingOrCollapsing",
    get: function get() {
      return this.sidebarExpanding || this.sidebarCollapsing;
    }
  }, {
    key: "sidebarTransitioning",
    get: function get() {
      return this.sidebarEnteringOrLeaving || this.sidebarExpandingOrCollapsing;
    } // sidebar state

  }, {
    key: "currentSidebarState",
    get: function get() {
      if (this.showSidebar) return 'open';
      if (!this.showSidebar && !this.hiddenWhenClosed) return 'collapsed';else return 'hidden';
    } // responsive

  }, {
    key: "mainSlotMinWidthReachedIfSidebarOpen",
    get: function get() {
      if (this.totalWidth === null) return false;
      return this.totalWidth - this.width < this.mainSlotMinWidth;
    }
  }, {
    key: "mainSlotMinWidthReachedIfSidebarClosed",
    get: function get() {
      if (this.totalWidth === null) return false;
      return this.totalWidth - this.widthWhenCollapsed < this.mainSlotMinWidth;
    } // widths

  }, {
    key: "visibleSidebarWidth",
    get: function get() {
      if (this.currentSidebarState === 'open' || this.previousSidebarState === 'open' && this.sidebarTransitioning) return this.width;
      if (this.currentSidebarState === 'hidden' && !this.sidebarTransitioning) return 0;
      return this.widthWhenCollapsed;
    }
  }, {
    key: "sidebarWidthOnPage",
    get: function get() {
      if (this.currentSidebarState === 'open') return this.width;
      if (this.currentSidebarState === 'collapsed') return this.widthWhenCollapsed;
      return 0;
    }
  }, {
    key: "previousSidebarWidthOnPage",
    get: function get() {
      if (this.previousSidebarState === 'open') return this.width;
      if (this.previousSidebarState === 'collapsed') return this.widthWhenCollapsed;
      return 0;
    }
  }, {
    key: "mainSlotWidth",
    get: function get() {
      if (!this.totalWidth) return 0;

      if (this.overlap && this.currentSidebarState === 'open') {
        return this.totalWidth - this.previousSidebarWidthOnPage;
      } else {
        return this.totalWidth - this.sidebarWidthOnPage;
      }
    }
  }, {
    key: "mainSlotOffset",
    get: function get() {
      if (this.overlap && this.currentSidebarState === 'open') {
        return this.previousSidebarWidthOnPage;
      } else {
        return this.sidebarWidthOnPage;
      }
    } // styles

  }, {
    key: "sidebarStyleBeforeTransition",
    get: function get() {
      // These data properties must be included because the watcher of this computed property must trigger when any of these data properties change.
      var dependencies = [this.sidebarCollapsing, this.sidebarExpanding];
      return {
        width: "".concat(this.visibleSidebarWidth, "rem"),
        maxWidth: "calc(100vw - ".concat(this.fullWidthBuffer, "rem)")
      };
    }
  }, {
    key: "sidebarPlaceholderContainerStyle",
    get: function get() {
      return {
        width: "".concat(this.visibleSidebarWidth, "rem")
      };
    }
  }, {
    key: "sidebarPlaceholderStyle",
    get: function get() {
      return {
        backgroundColor: 'rgba(0,0,0,0.08)'
      };
    }
  }, {
    key: "mainStyle",
    get: function get() {
      var style = {};
      style.width = "".concat(this.mainSlotWidth, "rem");
      if (this.position === 'left') style.left = "".concat(this.mainSlotOffset, "rem");
      return style;
    }
  }, {
    key: "pullOutTabAnchorStyle",
    get: function get() {
      return {
        transform: "translateX(".concat(this.showSidebar ? (this.position === 'left' ? 1 : -1) * this.visibleSidebarWidth : 0, "rem)")
      };
    }
  }, {
    key: "resizeBarStyle",
    get: function get() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, this.position, "".concat(this.visibleSidebarWidth, "rem")), _defineProperty(_ref, "transform", "translateX(".concat(this.position === 'left' ? '-' : '', "50%)")), _ref;
    } // will render

  }, {
    key: "willRenderOverlay",
    get: function get() {
      return this.darkenBehindSidebar && this.currentSidebarState === 'open';
    }
  }, {
    key: "willRenderSidebar",
    get: function get() {
      return this.currentSidebarState !== 'hidden';
    }
  }, {
    key: "willRenderPullOutTab",
    get: function get() {
      return this.showPullOutTab && this.currentSidebarState === 'hidden';
    }
  }, {
    key: "willRenderSidebarPlaceholder",
    get: function get() {
      return (this.sidebarEntering || this.sidebarExpanding) && !this.overlap;
    }
  }, {
    key: "willRenderResizeBar",
    get: function get() {
      return this.resizeable && this.currentSidebarState === 'open';
    }
  }]);

  return UiSidebarWrapper;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "showSidebar", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "darkenBehindSidebar", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "showPullOutTab", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "hiddenWhenClosed", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "resizeable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "overlap", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "clickOutsideToHideSidebar", void 0);

__decorate([Prop({
  type: Number,
  default: 14
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "width", void 0);

__decorate([Prop({
  type: Number,
  default: 10
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "minWidth", void 0);

__decorate([Prop({
  type: Number,
  default: 24
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "maxWidth", void 0);

__decorate([Prop({
  type: Number,
  default: 10
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "mainSlotMinWidth", void 0);

__decorate([Prop({
  type: Number,
  default: 2
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "widthWhenCollapsed", void 0);

__decorate([Prop({
  type: Number,
  default: 2
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "fullWidthBuffer", void 0);

__decorate([Prop({
  type: String,
  default: 'Show sidebar'
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "pullOutTabLabel", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return ['left', 'right'].includes(value);
  },
  default: 'right'
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "position", void 0);

__decorate([Watch('currentSidebarState')], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "onChangeCurrentSidebarState", null);

__decorate([Watch('sidebarStyleBeforeTransition', {
  immediate: true,
  deep: true
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "onChangeSidebarStyleBeforeTransition", null);

__decorate([Watch('mainSlotMinWidthReachedIfSidebarOpen', {
  immediate: true
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "onChangeMainSlotMinWidthReachedIfSidebarOpen", null);

__decorate([Watch('mainSlotMinWidthReachedIfSidebarClosed', {
  immediate: true
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "onChangeMainSlotMinWidthReachedIfSidebarClosed", null);

__decorate([Watch('mainSlotWidth', {
  immediate: true
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper.prototype, "onChangeMainSlotWidth", null);

UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper = __decorate([vue_class_component_esm({
  components: {
    UiPullOutTab: UiPullOutTab_UiPullOutTab
  }
})], UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper);
/* harmony default export */ var UiSidebarWrappervue_type_script_lang_ts_ = (UiSidebarWrappervue_type_script_lang_ts_UiSidebarWrapper);
// CONCATENATED MODULE: ./src/components/UiSidebarWrapper/UiSidebarWrapper.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiSidebarWrapper_UiSidebarWrappervue_type_script_lang_ts_ = (UiSidebarWrappervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiSidebarWrapper/UiSidebarWrapper.vue?vue&type=style&index=0&id=157593b4&lang=stylus&scoped=true&
var UiSidebarWrappervue_type_style_index_0_id_157593b4_lang_stylus_scoped_true_ = __webpack_require__("5d7a");

// CONCATENATED MODULE: ./src/components/UiSidebarWrapper/UiSidebarWrapper.vue






/* normalize component */

var UiSidebarWrapper_component = normalizeComponent(
  UiSidebarWrapper_UiSidebarWrappervue_type_script_lang_ts_,
  UiSidebarWrappervue_type_template_id_157593b4_scoped_true_lang_pug_render,
  UiSidebarWrappervue_type_template_id_157593b4_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "157593b4",
  null
  
)

/* harmony default export */ var UiSidebarWrapper_UiSidebarWrapper = (UiSidebarWrapper_component.exports);
// CONCATENATED MODULE: ./src/components/UiSidebarWrapper/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTable/UiTable.vue?vue&type=template&id=1f3adc3a&scoped=true&lang=pug&
var UiTablevue_type_template_id_1f3adc3a_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table"},[_c('table',[_c('thead',[_vm._t("header",null,null,{                    checkboxProps: _vm.tableHeaderCheckboxProps,                    checkboxListeners: _vm.tableHeaderCheckboxListeners,                })],2),_c('tbody',[(_vm.grouped)?[_vm._l((_vm.groupedItems),function(ref,index){
var group = ref.group;
var items = ref.items;
return [(index !== 0)?[_c('tr',[_c('td',{staticClass:"group-header-spacer",attrs:{"colspan":"1000"}})])]:_vm._e(),_vm._t("group-header",null,null,Object.assign({}, {group: group,                            items: items,                            checkboxProps: _vm.getGroupHeaderCheckboxProps(items),                            checkboxListeners: _vm.getGroupHeaderCheckboxListeners(items)},                            _vm.selectionBindings)),_vm._l((items),function(item){return _vm._t("row",null,null,Object.assign({}, {item: item,                            props: _vm.getRowProps(item),                            listeners: _vm.getRowListeners(item),                            checkboxProps: _vm.getRowCheckboxProps(item),                            checkboxListeners: _vm.getRowCheckboxListeners(item)},                            _vm.selectionBindings))})]})]:[_vm._l((_vm.items),function(item){return _vm._t("row",null,null,Object.assign({}, {item: item,                        props: _vm.getRowProps(item),                        listeners: _vm.getRowListeners(item),                        checkboxProps: _vm.getRowCheckboxProps(item),                        checkboxListeners: _vm.getRowCheckboxListeners(item)},                        _vm.selectionBindings))})]],2)]),(_vm.$scopedSlots['footer'])?_c('div',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e(),(_vm.$scopedSlots['footer.button'])?_c('div',{staticClass:"footer button"},[_vm._t("footer.button")],2):_vm._e()])}
var UiTablevue_type_template_id_1f3adc3a_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTable/UiTable.vue?vue&type=template&id=1f3adc3a&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__("5da1");
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);

// CONCATENATED MODULE: ./src/mixins/mixin-selectable.ts


















 // @ts-ignore

var mixin_selectable_AbstractSelectableMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(AbstractSelectableMixin, _Vue);

  function AbstractSelectableMixin() {
    var _this;

    _classCallCheck(this, AbstractSelectableMixin);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractSelectableMixin).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // state
    ////////////////////////////////////////////////////////////////

    _this.lastSelected = null;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(AbstractSelectableMixin, [{
    key: "onChangeSelected",
    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////
    value: function onChangeSelected() {
      this.refreshLastSelected();
    }
  }, {
    key: "onChangeSelectableItems",
    value: function onChangeSelectableItems() {
      this.refreshSelected();
    } ////////////////////////////////////////////////////////////////
    // methods → actions
    ////////////////////////////////////////////////////////////////

  }, {
    key: "updateSelection",
    value: function updateSelection(newSelection) {
      var _this2 = this;

      if (!this.exclusiveOption) {
        this.$emit('update:selected', newSelection);
        return;
      }

      var oldSelection = this.selected;
      var exclusiveOptionPreviouslySelected = !!oldSelection.find(function (item) {
        return !!_this2.exclusiveOption && _this2.equals(item, _this2.exclusiveOption);
      });
      var exclusiveOptionNowSelected = !!newSelection.find(function (item) {
        return !!_this2.exclusiveOption && _this2.equals(item, _this2.exclusiveOption);
      });

      if (!exclusiveOptionPreviouslySelected && exclusiveOptionNowSelected) {
        this.$emit('update:selected', [this.exclusiveOption]);
      } else if (exclusiveOptionPreviouslySelected && exclusiveOptionNowSelected) {
        this.$emit('update:selected', newSelection.filter(function (item) {
          return !!_this2.exclusiveOption && !_this2.equals(item, _this2.exclusiveOption);
        }));
      } else {
        this.$emit('update:selected', newSelection);
      }
    }
  }, {
    key: "selectOne",
    value: function selectOne(item) {
      if (this.isSelected(item)) return;
      this.updateSelection([].concat(_toConsumableArray(this.selected), [item]));
      this.lastSelected = item;
    }
  }, {
    key: "selectMany",
    value: function selectMany(items) {
      var _this3 = this;

      var newSelection = _toConsumableArray(this.selected);

      items.forEach(function (toSelect) {
        if (!_this3.isSelected(toSelect)) newSelection.push(toSelect);
      });
      this.updateSelection(newSelection);
    }
  }, {
    key: "selectOnlyOne",
    value: function selectOnlyOne(item) {
      this.updateSelection([item]);
      this.lastSelected = item;
    }
  }, {
    key: "selectOnlyMany",
    value: function selectOnlyMany(items) {
      this.updateSelection(_toConsumableArray(items));
    }
  }, {
    key: "deselectOne",
    value: function deselectOne(item) {
      var _this4 = this;

      this.updateSelection(this.selected.filter(function (possible) {
        return !_this4.equals(possible, item);
      }));
    }
  }, {
    key: "deselectMany",
    value: function deselectMany(items) {
      var _this5 = this;

      this.updateSelection(this.selected.filter(function (possible) {
        return !items.find(function (toDeselect) {
          return _this5.equals(possible, toDeselect);
        });
      }));
    }
  }, {
    key: "selectRangeFromLastSelectedTo",
    value: function selectRangeFromLastSelectedTo(item) {
      if (this.selectableItems.length === 0) return;

      if (!this.lastSelected) {
        this.selectOne(item);
      } else {
        var i1 = this.getItemIndex(item);
        var i2 = this.getItemIndex(this.lastSelected);
        this.selectMany(this.selectableItems.slice(Math.min(i1, i2), Math.max(i1, i2) + 1));
      }
    }
  }, {
    key: "toggleSelection",
    value: function toggleSelection(item) {
      if (this.isSelected(item)) {
        this.deselectOne(item);
      } else {
        this.selectOne(item);
      }
    }
  }, {
    key: "toggleSelectionForMany",
    value: function toggleSelectionForMany(items) {
      if (this.areAllSelected(items)) {
        this.deselectMany(items);
      } else {
        this.selectMany(items);
      }
    } ////////////////////////////////////////////////////////////////
    // methods → queries
    ////////////////////////////////////////////////////////////////

  }, {
    key: "isSelected",
    value: function isSelected(item) {
      var _this6 = this;

      return !!this.selected.find(function (possible) {
        return _this6.equals(possible, item);
      });
    }
  }, {
    key: "areAllSelected",
    value: function areAllSelected(items) {
      return items.every(this.isSelected);
    } ////////////////////////////////////////////////////////////////
    // methods → refreshers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "refreshLastSelected",
    value: function refreshLastSelected() {
      var _this7 = this;

      var lastSelectedDeselected = !this.selected.find(function (possible) {
        return !!_this7.lastSelected && _this7.equals(possible, _this7.lastSelected);
      });

      if (lastSelectedDeselected) {
        this.lastSelected = null;
      }
    }
  }, {
    key: "refreshSelected",
    value: function refreshSelected() {
      var _this8 = this;

      var refreshed = this.selected.map(function (selectedItem) {
        return _this8.selectableItems.find(function (item) {
          return _this8.equals(item, selectedItem);
        });
      }).filter(notUndefined);
      this.updateSelection(refreshed);
    } ////////////////////////////////////////////////////////////////
    // methods → helpers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "getItemIndex",
    value: function getItemIndex(item) {
      return this.selectableItems.indexOf(item);
    }
  }, {
    key: "equals",
    value: function equals(a, b) {
      return lodash_isequal_default()(this.getValue(a), this.getValue(b));
    }
  }, {
    key: "anySelected",
    get: function get() {
      return this.selected.length > 0;
    }
  }]);

  return AbstractSelectableMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], mixin_selectable_AbstractSelectableMixin.prototype, "selected", void 0);

__decorate([Prop({
  default: null
})], mixin_selectable_AbstractSelectableMixin.prototype, "exclusiveOption", void 0);

__decorate([Watch('selected')], mixin_selectable_AbstractSelectableMixin.prototype, "onChangeSelected", null);

__decorate([Watch('selectableItems')], mixin_selectable_AbstractSelectableMixin.prototype, "onChangeSelectableItems", null);

mixin_selectable_AbstractSelectableMixin = __decorate([vue_class_component_esm], mixin_selectable_AbstractSelectableMixin);


var mixin_selectable_SelectableMixin =
/*#__PURE__*/
// @ts-ignore
function (_AbstractSelectableMi) {
  _inherits(SelectableMixin, _AbstractSelectableMi);

  function SelectableMixin() {
    _classCallCheck(this, SelectableMixin);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectableMixin).apply(this, arguments));
  }

  return SelectableMixin;
}(mixin_selectable_AbstractSelectableMixin);

mixin_selectable_SelectableMixin = __decorate([vue_class_component_esm // @ts-ignore
], mixin_selectable_SelectableMixin);
/* harmony default export */ var mixin_selectable = (mixin_selectable_SelectableMixin);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTable/UiTable.vue?vue&type=script&lang=ts&











var UiTablevue_type_script_lang_ts_UiTable =
/*#__PURE__*/
function (_Mixins) {
  _inherits(UiTable, _Mixins);

  function UiTable() {
    _classCallCheck(this, UiTable);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiTable).apply(this, arguments));
  }

  _createClass(UiTable, [{
    key: "getValue",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    /**
     * @implements {mixin-selectable}.
     */
    value: function getValue(item) {
      return this.getItemValue(item);
    }
  }, {
    key: "grouped",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.groups.length > 0;
    }
  }, {
    key: "groupedItems",
    get: function get() {
      var _this = this;

      return this.groups.map(function (group) {
        return {
          group: group,
          items: _this.items.filter(function (item) {
            return _this.isItemInGroup(item, group);
          })
        };
      }).filter(function (_ref) {
        var items = _ref.items;
        return items.length > 0;
      });
    }
  }, {
    key: "selectionBindings",
    get: function get() {
      return {
        selectOne: this.selectOne,
        selectMany: this.selectMany,
        selectOnlyOne: this.selectOnlyOne,
        selectOnlyMany: this.selectOnlyMany,
        deselectOne: this.deselectOne,
        deselectMany: this.deselectMany,
        selectRangeFromLastSelectedTo: this.selectRangeFromLastSelectedTo,
        toggleSelection: this.toggleSelection,
        toggleSelectionForMany: this.toggleSelectionForMany,
        isSelected: this.isSelected,
        areAllSelected: this.areAllSelected
      };
    }
  }, {
    key: "tableHeaderCheckboxProps",
    get: function get() {
      return {
        checked: this.areAllSelected(this.items)
      };
    }
  }, {
    key: "tableHeaderCheckboxListeners",
    get: function get() {
      var _this2 = this;

      return {
        'toggle': function toggle() {
          _this2.toggleSelectionForMany(_this2.items);
        }
      };
    }
  }, {
    key: "getGroupHeaderCheckboxProps",
    get: function get() {
      var _this3 = this;

      return function (itemsInGroup) {
        return {
          checked: _this3.areAllSelected(itemsInGroup)
        };
      };
    }
  }, {
    key: "getGroupHeaderCheckboxListeners",
    get: function get() {
      var _this4 = this;

      return function (itemsInGroup) {
        return {
          'toggle': function toggle() {
            return _this4.toggleSelectionForMany(itemsInGroup);
          }
        };
      };
    }
  }, {
    key: "getRowCheckboxProps",
    get: function get() {
      var _this5 = this;

      return function (item) {
        return {
          checked: _this5.isSelected(item)
        };
      };
    }
  }, {
    key: "getRowCheckboxListeners",
    get: function get() {
      var _this6 = this;

      return function (item) {
        return {
          'toggle': function toggle() {
            return _this6.toggleSelection(item);
          }
        };
      };
    }
  }, {
    key: "getRowProps",
    get: function get() {
      var _this7 = this;

      return function (item) {
        return {
          highlighted: _this7.isSelected(item)
        };
      };
    }
  }, {
    key: "getRowListeners",
    get: function get() {
      var _this8 = this;

      return function (item) {
        return {
          'click': function click(event) {
            if (event.metaKey || event.ctrlKey) _this8.toggleSelection(item);else if (event.shiftKey) _this8.selectRangeFromLastSelectedTo(item);else _this8.selectOnlyOne(item);
          }
        };
      };
    }
    /**
     * @implements {mixin-selectable}.
     */

  }, {
    key: "selectableItems",
    get: function get() {
      return this.items;
    }
  }]);

  return UiTable;
}(mixins(mixin_selectable));

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiTablevue_type_script_lang_ts_UiTable.prototype, "items", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiTablevue_type_script_lang_ts_UiTable.prototype, "groups", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return false;
  }
})], UiTablevue_type_script_lang_ts_UiTable.prototype, "isItemInGroup", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiTablevue_type_script_lang_ts_UiTable.prototype, "getItemValue", void 0);

UiTablevue_type_script_lang_ts_UiTable = __decorate([vue_class_component_esm], UiTablevue_type_script_lang_ts_UiTable);
/* harmony default export */ var UiTablevue_type_script_lang_ts_ = (UiTablevue_type_script_lang_ts_UiTable);
// CONCATENATED MODULE: ./src/components/UiTable/UiTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTable_UiTablevue_type_script_lang_ts_ = (UiTablevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTable/UiTable.vue?vue&type=style&index=0&id=1f3adc3a&lang=stylus&scoped=true&
var UiTablevue_type_style_index_0_id_1f3adc3a_lang_stylus_scoped_true_ = __webpack_require__("e692");

// CONCATENATED MODULE: ./src/components/UiTable/UiTable.vue






/* normalize component */

var UiTable_component = normalizeComponent(
  UiTable_UiTablevue_type_script_lang_ts_,
  UiTablevue_type_template_id_1f3adc3a_scoped_true_lang_pug_render,
  UiTablevue_type_template_id_1f3adc3a_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "1f3adc3a",
  null
  
)

/* harmony default export */ var UiTable_UiTable = (UiTable_component.exports);
// CONCATENATED MODULE: ./src/components/UiTable/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableCellContent/UiTableCellContent.vue?vue&type=template&id=9f12c722&scoped=true&lang=pug&
var UiTableCellContentvue_type_template_id_9f12c722_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table-cell-content"},[(_vm.noValue)?_c('div',{staticClass:"no-value"},[_vm._t("no-value",[_c('span',[_vm._v("—")])])],2):_vm._t("default")],2)}
var UiTableCellContentvue_type_template_id_9f12c722_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTableCellContent/UiTableCellContent.vue?vue&type=template&id=9f12c722&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableCellContent/UiTableCellContent.vue?vue&type=script&lang=ts&








var UiTableCellContentvue_type_script_lang_ts_UiTableCellContent =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiTableCellContent, _Vue);

  function UiTableCellContent() {
    _classCallCheck(this, UiTableCellContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiTableCellContent).apply(this, arguments));
  }

  _createClass(UiTableCellContent, [{
    key: "noValue",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.value === null || this.value === undefined || this.value === '';
    }
  }]);

  return UiTableCellContent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  default: true
})], UiTableCellContentvue_type_script_lang_ts_UiTableCellContent.prototype, "value", void 0);

UiTableCellContentvue_type_script_lang_ts_UiTableCellContent = __decorate([vue_class_component_esm], UiTableCellContentvue_type_script_lang_ts_UiTableCellContent);
/* harmony default export */ var UiTableCellContentvue_type_script_lang_ts_ = (UiTableCellContentvue_type_script_lang_ts_UiTableCellContent);
// CONCATENATED MODULE: ./src/components/UiTableCellContent/UiTableCellContent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTableCellContent_UiTableCellContentvue_type_script_lang_ts_ = (UiTableCellContentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTableCellContent/UiTableCellContent.vue?vue&type=style&index=0&id=9f12c722&lang=stylus&scoped=true&
var UiTableCellContentvue_type_style_index_0_id_9f12c722_lang_stylus_scoped_true_ = __webpack_require__("0ba0");

// CONCATENATED MODULE: ./src/components/UiTableCellContent/UiTableCellContent.vue






/* normalize component */

var UiTableCellContent_component = normalizeComponent(
  UiTableCellContent_UiTableCellContentvue_type_script_lang_ts_,
  UiTableCellContentvue_type_template_id_9f12c722_scoped_true_lang_pug_render,
  UiTableCellContentvue_type_template_id_9f12c722_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "9f12c722",
  null
  
)

/* harmony default export */ var UiTableCellContent_UiTableCellContent = (UiTableCellContent_component.exports);
// CONCATENATED MODULE: ./src/components/UiTableCellContent/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableGroupHeader/UiTableGroupHeader.vue?vue&type=template&id=a9896bf8&scoped=true&lang=pug&
var UiTableGroupHeadervue_type_template_id_a9896bf8_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"ui-table-group-header"},[(_vm.$scopedSlots['left'])?_c('td',{style:(_vm.style)},[_vm._t("left")],2):_vm._e(),_c('td',{style:(_vm.style),attrs:{"colspan":"1000"}},[_vm._t("default")],2)])}
var UiTableGroupHeadervue_type_template_id_a9896bf8_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTableGroupHeader/UiTableGroupHeader.vue?vue&type=template&id=a9896bf8&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableGroupHeader/UiTableGroupHeader.vue?vue&type=script&lang=ts&








var UiTableGroupHeadervue_type_script_lang_ts_UiTableGroupHeader =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiTableGroupHeader, _Vue);

  function UiTableGroupHeader() {
    _classCallCheck(this, UiTableGroupHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiTableGroupHeader).apply(this, arguments));
  }

  _createClass(UiTableGroupHeader, [{
    key: "style",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  }]);

  return UiTableGroupHeader;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: 'white'
})], UiTableGroupHeadervue_type_script_lang_ts_UiTableGroupHeader.prototype, "backgroundColor", void 0);

UiTableGroupHeadervue_type_script_lang_ts_UiTableGroupHeader = __decorate([vue_class_component_esm], UiTableGroupHeadervue_type_script_lang_ts_UiTableGroupHeader);
/* harmony default export */ var UiTableGroupHeadervue_type_script_lang_ts_ = (UiTableGroupHeadervue_type_script_lang_ts_UiTableGroupHeader);
// CONCATENATED MODULE: ./src/components/UiTableGroupHeader/UiTableGroupHeader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTableGroupHeader_UiTableGroupHeadervue_type_script_lang_ts_ = (UiTableGroupHeadervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTableGroupHeader/UiTableGroupHeader.vue?vue&type=style&index=0&id=a9896bf8&lang=stylus&scoped=true&
var UiTableGroupHeadervue_type_style_index_0_id_a9896bf8_lang_stylus_scoped_true_ = __webpack_require__("315e");

// CONCATENATED MODULE: ./src/components/UiTableGroupHeader/UiTableGroupHeader.vue






/* normalize component */

var UiTableGroupHeader_component = normalizeComponent(
  UiTableGroupHeader_UiTableGroupHeadervue_type_script_lang_ts_,
  UiTableGroupHeadervue_type_template_id_a9896bf8_scoped_true_lang_pug_render,
  UiTableGroupHeadervue_type_template_id_a9896bf8_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "a9896bf8",
  null
  
)

/* harmony default export */ var UiTableGroupHeader_UiTableGroupHeader = (UiTableGroupHeader_component.exports);
// CONCATENATED MODULE: ./src/components/UiTableGroupHeader/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableHeader/UiTableHeader.vue?vue&type=template&id=1b9e769c&scoped=true&lang=pug&
var UiTableHeadervue_type_template_id_1b9e769c_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"ui-table-header"},[(_vm.$scopedSlots['left'])?_c('th',{class:_vm.classes,style:(_vm.style)},[_vm._t("left")],2):_vm._e(),_vm._l((_vm.columns),function(column){return _c('th',{class:_vm.classes,style:(_vm.style)},[_vm._t(_vm.getColumnKey ? ("cell:" + (_vm.getColumnKey(column))) : 'cell',null,{"column":column})],2)}),(_vm.$scopedSlots['right'])?_c('th',{class:_vm.classes,style:(_vm.style)},[_vm._t("right")],2):_vm._e()],2)}
var UiTableHeadervue_type_template_id_1b9e769c_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTableHeader/UiTableHeader.vue?vue&type=template&id=1b9e769c&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableHeader/UiTableHeader.vue?vue&type=script&lang=ts&








var UiTableHeadervue_type_script_lang_ts_UiTableHeader =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiTableHeader, _Vue);

  function UiTableHeader() {
    _classCallCheck(this, UiTableHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiTableHeader).apply(this, arguments));
  }

  _createClass(UiTableHeader, [{
    key: "style",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        'border': this.showBorder
      };
    }
  }]);

  return UiTableHeader;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiTableHeadervue_type_script_lang_ts_UiTableHeader.prototype, "columns", void 0);

__decorate([Prop({
  type: Function,
  default: null
})], UiTableHeadervue_type_script_lang_ts_UiTableHeader.prototype, "getColumnKey", void 0);

__decorate([Prop({
  type: String,
  default: 'white'
})], UiTableHeadervue_type_script_lang_ts_UiTableHeader.prototype, "backgroundColor", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiTableHeadervue_type_script_lang_ts_UiTableHeader.prototype, "showBorder", void 0);

UiTableHeadervue_type_script_lang_ts_UiTableHeader = __decorate([vue_class_component_esm], UiTableHeadervue_type_script_lang_ts_UiTableHeader);
/* harmony default export */ var UiTableHeadervue_type_script_lang_ts_ = (UiTableHeadervue_type_script_lang_ts_UiTableHeader);
// CONCATENATED MODULE: ./src/components/UiTableHeader/UiTableHeader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTableHeader_UiTableHeadervue_type_script_lang_ts_ = (UiTableHeadervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTableHeader/UiTableHeader.vue?vue&type=style&index=0&id=1b9e769c&lang=stylus&scoped=true&
var UiTableHeadervue_type_style_index_0_id_1b9e769c_lang_stylus_scoped_true_ = __webpack_require__("0d17");

// CONCATENATED MODULE: ./src/components/UiTableHeader/UiTableHeader.vue






/* normalize component */

var UiTableHeader_component = normalizeComponent(
  UiTableHeader_UiTableHeadervue_type_script_lang_ts_,
  UiTableHeadervue_type_template_id_1b9e769c_scoped_true_lang_pug_render,
  UiTableHeadervue_type_template_id_1b9e769c_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "1b9e769c",
  null
  
)

/* harmony default export */ var UiTableHeader_UiTableHeader = (UiTableHeader_component.exports);
// CONCATENATED MODULE: ./src/components/UiTableHeader/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableHeaderCellContent/UiTableHeaderCellContent.vue?vue&type=template&id=784a05b8&scoped=true&lang=pug&
var UiTableHeaderCellContentvue_type_template_id_784a05b8_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table-header-cell-content",class:_vm.classes,on:{"click":_vm.onClick}},[_c('div',{staticClass:"label"},[(_vm.icon)?_c('ui-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(!_vm.showText && _vm.text),expression:"!showText && text"}],attrs:{"icon":_vm.icon}}):_vm._e(),(_vm.text && _vm.showText)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1),(_vm.sortable)?_c('ui-icon',{attrs:{"icon":_vm.ascending ? 'menu-up' : 'menu-down'}}):_vm._e()],1)}
var UiTableHeaderCellContentvue_type_template_id_784a05b8_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTableHeaderCellContent/UiTableHeaderCellContent.vue?vue&type=template&id=784a05b8&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableHeaderCellContent/UiTableHeaderCellContent.vue?vue&type=script&lang=ts&










var UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiTableHeaderCellContent, _Vue);

  function UiTableHeaderCellContent() {
    _classCallCheck(this, UiTableHeaderCellContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiTableHeaderCellContent).apply(this, arguments));
  }

  _createClass(UiTableHeaderCellContent, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClick() {
      if (!this.sortable) return;
      this.$emit('sort');
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'interactable': this.sortable,
        'sorted': this.sorted
      };
    }
  }]);

  return UiTableHeaderCellContent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent.prototype, "text", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent.prototype, "icon", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent.prototype, "sortable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent.prototype, "sorted", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent.prototype, "ascending", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent.prototype, "showText", void 0);

UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  },
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent);
/* harmony default export */ var UiTableHeaderCellContentvue_type_script_lang_ts_ = (UiTableHeaderCellContentvue_type_script_lang_ts_UiTableHeaderCellContent);
// CONCATENATED MODULE: ./src/components/UiTableHeaderCellContent/UiTableHeaderCellContent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTableHeaderCellContent_UiTableHeaderCellContentvue_type_script_lang_ts_ = (UiTableHeaderCellContentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTableHeaderCellContent/UiTableHeaderCellContent.vue?vue&type=style&index=0&id=784a05b8&lang=stylus&scoped=true&
var UiTableHeaderCellContentvue_type_style_index_0_id_784a05b8_lang_stylus_scoped_true_ = __webpack_require__("fb25");

// CONCATENATED MODULE: ./src/components/UiTableHeaderCellContent/UiTableHeaderCellContent.vue






/* normalize component */

var UiTableHeaderCellContent_component = normalizeComponent(
  UiTableHeaderCellContent_UiTableHeaderCellContentvue_type_script_lang_ts_,
  UiTableHeaderCellContentvue_type_template_id_784a05b8_scoped_true_lang_pug_render,
  UiTableHeaderCellContentvue_type_template_id_784a05b8_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "784a05b8",
  null
  
)

/* harmony default export */ var UiTableHeaderCellContent_UiTableHeaderCellContent = (UiTableHeaderCellContent_component.exports);
// CONCATENATED MODULE: ./src/components/UiTableHeaderCellContent/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableRow/UiTableRow.vue?vue&type=template&id=efec1a2c&scoped=true&lang=pug&
var UiTableRowvue_type_template_id_efec1a2c_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"ui-table-row",class:_vm.classes,on:{"click":_vm.onClick}},[(_vm.$scopedSlots['left'])?_c('td',[_vm._t("left")],2):_vm._e(),_vm._l((_vm.columns),function(column){return _c('td',[_vm._t(_vm.getColumnKey ? ("cell:" + (_vm.getColumnKey(column))) : 'cell',null,{"column":column})],2)}),(_vm.$scopedSlots['right'])?_c('td',[_vm._t("right")],2):_vm._e()],2)}
var UiTableRowvue_type_template_id_efec1a2c_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTableRow/UiTableRow.vue?vue&type=template&id=efec1a2c&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTableRow/UiTableRow.vue?vue&type=script&lang=ts&








var UiTableRowvue_type_script_lang_ts_UiTableRow =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiTableRow, _Vue);

  function UiTableRow() {
    _classCallCheck(this, UiTableRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiTableRow).apply(this, arguments));
  }

  _createClass(UiTableRow, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClick(event) {
      this.$emit('click', event);
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'opaque': this.opaque,
        'highlighted': this.highlighted,
        'interactable': !this.readOnly
      };
    }
  }]);

  return UiTableRow;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiTableRowvue_type_script_lang_ts_UiTableRow.prototype, "columns", void 0);

__decorate([Prop({
  type: Function,
  default: null
})], UiTableRowvue_type_script_lang_ts_UiTableRow.prototype, "getColumnKey", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTableRowvue_type_script_lang_ts_UiTableRow.prototype, "opaque", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTableRowvue_type_script_lang_ts_UiTableRow.prototype, "readOnly", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTableRowvue_type_script_lang_ts_UiTableRow.prototype, "highlighted", void 0);

UiTableRowvue_type_script_lang_ts_UiTableRow = __decorate([vue_class_component_esm], UiTableRowvue_type_script_lang_ts_UiTableRow);
/* harmony default export */ var UiTableRowvue_type_script_lang_ts_ = (UiTableRowvue_type_script_lang_ts_UiTableRow);
// CONCATENATED MODULE: ./src/components/UiTableRow/UiTableRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTableRow_UiTableRowvue_type_script_lang_ts_ = (UiTableRowvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTableRow/UiTableRow.vue?vue&type=style&index=0&id=efec1a2c&lang=stylus&scoped=true&
var UiTableRowvue_type_style_index_0_id_efec1a2c_lang_stylus_scoped_true_ = __webpack_require__("0585");

// CONCATENATED MODULE: ./src/components/UiTableRow/UiTableRow.vue






/* normalize component */

var UiTableRow_component = normalizeComponent(
  UiTableRow_UiTableRowvue_type_script_lang_ts_,
  UiTableRowvue_type_template_id_efec1a2c_scoped_true_lang_pug_render,
  UiTableRowvue_type_template_id_efec1a2c_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "efec1a2c",
  null
  
)

/* harmony default export */ var UiTableRow_UiTableRow = (UiTableRow_component.exports);
// CONCATENATED MODULE: ./src/components/UiTableRow/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiToast/UiToast.vue?vue&type=template&id=64afbb52&scoped=true&lang=pug&
var UiToastvue_type_template_id_64afbb52_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":_vm.portalTargetName}},[_c('transition',{attrs:{"name":"rise"}},[(_vm.show)?_c('div',{staticClass:"ui-toast",class:_vm.classes},[_c('div',{staticClass:"message"},[_vm._t("message")],2),(_vm.dismissable)?_c('ui-icon-button',{attrs:{"label":"Dismiss message","icon":"close-circle","small":""},on:{"click":_vm.close}}):_vm._e()],1):_vm._e()])],1)}
var UiToastvue_type_template_id_64afbb52_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiToast/UiToast.vue?vue&type=template&id=64afbb52&scoped=true&lang=pug&

// CONCATENATED MODULE: ./src/store/store-toast.ts

var state = {
  currentToastUid: null
};
/* harmony default export */ var store_toast = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.observable(state));
// EXTERNAL MODULE: ./node_modules/uuid/v4.js
var v4 = __webpack_require__("c64e");
var v4_default = /*#__PURE__*/__webpack_require__.n(v4);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiToast/UiToast.vue?vue&type=script&lang=ts&
















var UiToastvue_type_script_lang_ts_UiToast =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiToast, _Vue);

  function UiToast() {
    var _this;

    _classCallCheck(this, UiToast);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiToast).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.timeoutId = null;
    _this.unwatchStore = null;
    _this.uid = v4_default()();
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiToast, [{
    key: "created",
    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////
    value: function created() {
      var _this2 = this;

      this.unwatchStore = this.$watch(function () {
        return store_toast.currentToastUid;
      }, function () {
        if (store_toast.currentToastUid !== _this2.uid) _this2.close();
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.unwatchStore && this.unwatchStore();
    } ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onChangeShow",
    value: function onChangeShow() {
      var _this3 = this;

      this.clearTimeout();

      if (this.show) {
        store_toast.currentToastUid = this.uid;

        if (!this.persistent) {
          this.timeoutId = setTimeout(function () {
            _this3.close();
          }, this.durationToUse);
        }
      }
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

  }, {
    key: "close",
    value: function close() {
      this.clearTimeout();
      this.$emit('update:show', false);
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    })
  }, {
    key: "classes",
    get: function get() {
      return {
        'compact': !this.spacious,
        'spacious': this.spacious
      };
    }
  }, {
    key: "portalTargetName",
    get: function get() {
      return this.$attrs.to || src_config.toastPortalTargetName;
    }
  }, {
    key: "durationToUse",
    get: function get() {
      return this.duration || src_config.toastDuration;
    }
  }]);

  return UiToast;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiToastvue_type_script_lang_ts_UiToast.prototype, "show", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiToastvue_type_script_lang_ts_UiToast.prototype, "spacious", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiToastvue_type_script_lang_ts_UiToast.prototype, "persistent", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiToastvue_type_script_lang_ts_UiToast.prototype, "dismissable", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return typeof value === 'number' && value > 0;
  },
  default: null
})], UiToastvue_type_script_lang_ts_UiToast.prototype, "duration", void 0);

__decorate([Watch('show', {
  immediate: true
})], UiToastvue_type_script_lang_ts_UiToast.prototype, "onChangeShow", null);

UiToastvue_type_script_lang_ts_UiToast = __decorate([vue_class_component_esm({
  components: {
    UiIconButton: UiIconButton,
    Portal: portal_vue_common["Portal"]
  }
})], UiToastvue_type_script_lang_ts_UiToast);
/* harmony default export */ var UiToastvue_type_script_lang_ts_ = (UiToastvue_type_script_lang_ts_UiToast);
// CONCATENATED MODULE: ./src/components/UiToast/UiToast.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiToast_UiToastvue_type_script_lang_ts_ = (UiToastvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiToast/UiToast.vue?vue&type=style&index=0&id=64afbb52&lang=stylus&scoped=true&
var UiToastvue_type_style_index_0_id_64afbb52_lang_stylus_scoped_true_ = __webpack_require__("c179");

// CONCATENATED MODULE: ./src/components/UiToast/UiToast.vue






/* normalize component */

var UiToast_component = normalizeComponent(
  UiToast_UiToastvue_type_script_lang_ts_,
  UiToastvue_type_template_id_64afbb52_scoped_true_lang_pug_render,
  UiToastvue_type_template_id_64afbb52_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "64afbb52",
  null
  
)

/* harmony default export */ var UiToast_UiToast = (UiToast_component.exports);
// CONCATENATED MODULE: ./src/components/UiToast/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiToastPortalTarget/UiToastPortalTarget.vue?vue&type=template&id=7b50b1a1&scoped=true&lang=pug&
var UiToastPortalTargetvue_type_template_id_7b50b1a1_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal-target',{staticClass:"ui-toast-portal-target",attrs:{"name":_vm.portalTargetName,"multiple":""}})}
var UiToastPortalTargetvue_type_template_id_7b50b1a1_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiToastPortalTarget/UiToastPortalTarget.vue?vue&type=template&id=7b50b1a1&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiToastPortalTarget/UiToastPortalTarget.vue?vue&type=script&lang=ts&











var UiToastPortalTargetvue_type_script_lang_ts_UiToastPortalTarget =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiToastPortalTarget, _Vue);

  function UiToastPortalTarget() {
    _classCallCheck(this, UiToastPortalTarget);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiToastPortalTarget).apply(this, arguments));
  }

  _createClass(UiToastPortalTarget, [{
    key: "portalTargetName",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.$attrs.name || src_config.toastPortalTargetName;
    }
  }]);

  return UiToastPortalTarget;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

UiToastPortalTargetvue_type_script_lang_ts_UiToastPortalTarget = __decorate([vue_class_component_esm({
  components: {
    PortalTarget: portal_vue_common["PortalTarget"]
  }
})], UiToastPortalTargetvue_type_script_lang_ts_UiToastPortalTarget);
/* harmony default export */ var UiToastPortalTargetvue_type_script_lang_ts_ = (UiToastPortalTargetvue_type_script_lang_ts_UiToastPortalTarget);
// CONCATENATED MODULE: ./src/components/UiToastPortalTarget/UiToastPortalTarget.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiToastPortalTarget_UiToastPortalTargetvue_type_script_lang_ts_ = (UiToastPortalTargetvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiToastPortalTarget/UiToastPortalTarget.vue?vue&type=style&index=0&id=7b50b1a1&lang=stylus&scoped=true&
var UiToastPortalTargetvue_type_style_index_0_id_7b50b1a1_lang_stylus_scoped_true_ = __webpack_require__("3a33");

// CONCATENATED MODULE: ./src/components/UiToastPortalTarget/UiToastPortalTarget.vue






/* normalize component */

var UiToastPortalTarget_component = normalizeComponent(
  UiToastPortalTarget_UiToastPortalTargetvue_type_script_lang_ts_,
  UiToastPortalTargetvue_type_template_id_7b50b1a1_scoped_true_lang_pug_render,
  UiToastPortalTargetvue_type_template_id_7b50b1a1_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "7b50b1a1",
  null
  
)

/* harmony default export */ var UiToastPortalTarget_UiToastPortalTarget = (UiToastPortalTarget_component.exports);
// CONCATENATED MODULE: ./src/components/UiToastPortalTarget/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAvatar/UiAvatar.vue?vue&type=template&id=b91c763e&scoped=true&lang=pug&
var UiAvatarvue_type_template_id_b91c763e_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"ui-avatar",class:_vm.classes,style:(_vm.styleObject),on:{"click":_vm.onClick}},[_c('div',{staticClass:"initials"},[_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var UiAvatarvue_type_template_id_b91c763e_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatar.vue?vue&type=template&id=b91c763e&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAvatar/UiAvatar.vue?vue&type=script&lang=ts&









var UiAvatarvue_type_script_lang_ts_UiAvatar =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiAvatar, _Vue);

  function UiAvatar() {
    _classCallCheck(this, UiAvatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiAvatar).apply(this, arguments));
  }

  _createClass(UiAvatar, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClick(event) {
      if (this.clickable) this.$emit('click', event);
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'medium': !this.large,
        'large': this.large,
        'clickable': this.clickable
      };
    }
  }, {
    key: "styleObject",
    get: function get() {
      return {
        backgroundColor: this.color
      };
    }
  }]);

  return UiAvatar;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiAvatarvue_type_script_lang_ts_UiAvatar.prototype, "text", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiAvatarvue_type_script_lang_ts_UiAvatar.prototype, "color", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiAvatarvue_type_script_lang_ts_UiAvatar.prototype, "tooltip", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiAvatarvue_type_script_lang_ts_UiAvatar.prototype, "large", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiAvatarvue_type_script_lang_ts_UiAvatar.prototype, "clickable", void 0);

UiAvatarvue_type_script_lang_ts_UiAvatar = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  }
})], UiAvatarvue_type_script_lang_ts_UiAvatar);
/* harmony default export */ var UiAvatarvue_type_script_lang_ts_ = (UiAvatarvue_type_script_lang_ts_UiAvatar);
// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiAvatar_UiAvatarvue_type_script_lang_ts_ = (UiAvatarvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiAvatar/UiAvatar.vue?vue&type=style&index=0&id=b91c763e&lang=stylus&scoped=true&
var UiAvatarvue_type_style_index_0_id_b91c763e_lang_stylus_scoped_true_ = __webpack_require__("4d49");

// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatar.vue






/* normalize component */

var UiAvatar_component = normalizeComponent(
  UiAvatar_UiAvatarvue_type_script_lang_ts_,
  UiAvatarvue_type_template_id_b91c763e_scoped_true_lang_pug_render,
  UiAvatarvue_type_template_id_b91c763e_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "b91c763e",
  null
  
)

/* harmony default export */ var UiAvatar_UiAvatar = (UiAvatar_component.exports);
// CONCATENATED MODULE: ./src/components/UiAvatar/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBar/UiBar.vue?vue&type=template&id=7b997ea4&scoped=true&lang=pug&
var UiBarvue_type_template_id_7b997ea4_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-bar",class:_vm.classes},[(_vm.showLabel && _vm.labelPosition === 'top')?_c('div',{staticClass:"label"},[(_vm.formatLabel)?[_vm._v(_vm._s(_vm.formatLabel(_vm.value, _vm.max)))]:(_vm.showFraction)?[_vm._v(_vm._s(_vm.value)+"/"+_vm._s(_vm.max))]:_vm._e()],2):_vm._e(),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltip, delay: 0 }),expression:"{ content: tooltip, delay: 0 }"}],staticClass:"bar-row"},[_c('div',{staticClass:"bar-container"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showBar)?_c('div',{staticClass:"bar-wrapper"},[_c('div',{staticClass:"bar",style:(_vm.barStyle)})]):_vm._e()])],1),(_vm.showLabel && _vm.labelPosition === 'right')?_c('div',{staticClass:"label"},[(_vm.formatLabel)?[_vm._v(_vm._s(_vm.formatLabel(_vm.value, _vm.max)))]:(_vm.showFraction)?[_vm._v(_vm._s(_vm.value)+"/"+_vm._s(_vm.max))]:_vm._e()],2):_vm._e(),(_vm.shouldShowWarningIcon(_vm.truePercentage))?_c('ui-icon',{attrs:{"icon":"alert","small":"","warning":""}}):_vm._e()],1)])}
var UiBarvue_type_template_id_7b997ea4_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiBar/UiBar.vue?vue&type=template&id=7b997ea4&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/lodash.clamp/index.js
var lodash_clamp = __webpack_require__("6e6b");
var lodash_clamp_default = /*#__PURE__*/__webpack_require__.n(lodash_clamp);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBar/UiBar.vue?vue&type=script&lang=ts&













var UiBarvue_type_script_lang_ts_UiBar =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiBar, _Vue);

  function UiBar() {
    var _this;

    _classCallCheck(this, UiBar);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiBar).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // state
    ////////////////////////////////////////////////////////////////

    _this.showBar = false;
    _this.barPercentage = 1;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // getters
  ////////////////////////////////////////////////////////////////


  _createClass(UiBar, [{
    key: "onChangeTruePercentage",
    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////
    value: function onChangeTruePercentage() {
      this.updateBarState();
    } ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

  }, {
    key: "created",
    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////
    value: function created() {
      this.updateBarState();
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

  }, {
    key: "updateBarState",
    value: function updateBarState() {
      if (this.truePercentage === 0) {
        this.showBar = false;
      } else {
        this.showBar = true;
        this.barPercentage = this.truePercentage;
      }
    }
  }, {
    key: "truePercentage",
    get: function get() {
      return this.value / this.max;
    }
  }, {
    key: "barWidth",
    get: function get() {
      return lodash_clamp_default()(this.barPercentage, 0, 1) * 100;
    }
  }, {
    key: "barStyle",
    get: function get() {
      return {
        width: "".concat(this.barWidth, "%")
      };
    }
  }, {
    key: "success",
    get: function get() {
      return this.barPercentage >= this.successThreshold;
    }
  }, {
    key: "warning",
    get: function get() {
      return this.barPercentage > this.dangerThreshold && this.barPercentage < this.successThreshold;
    }
  }, {
    key: "danger",
    get: function get() {
      return this.barPercentage <= this.dangerThreshold && this.barPercentage !== 0;
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        'subtle': this.isSubtle(this.truePercentage),
        'success': this.success,
        'warning': this.warning,
        'danger': this.danger,
        'show-success': this.showSuccess,
        'show-warning': this.showWarning,
        'show-danger': this.showDanger,
        'light': this.light
      };
    }
  }, {
    key: "showLabel",
    get: function get() {
      return !!this.formatLabel || this.showFraction;
    }
  }]);

  return UiBar;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Number,
  required: true
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "value", void 0);

__decorate([Prop({
  type: Number,
  required: true
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "max", void 0);

__decorate([Prop({
  type: Number,
  default: 0.25
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "successThreshold", void 0);

__decorate([Prop({
  type: Number,
  default: 0.1
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "dangerThreshold", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "showSuccess", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "showWarning", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "showDanger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "showFraction", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return false;
  }
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "shouldShowWarningIcon", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return false;
  }
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "isSubtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "light", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "tooltip", void 0);

__decorate([Prop({
  type: Function,
  default: null
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "formatLabel", void 0);

__decorate([Prop({
  validator: function validator(value) {
    return ['top', 'right'].includes(value);
  },
  default: 'top'
})], UiBarvue_type_script_lang_ts_UiBar.prototype, "labelPosition", void 0);

__decorate([Watch('truePercentage')], UiBarvue_type_script_lang_ts_UiBar.prototype, "onChangeTruePercentage", null);

UiBarvue_type_script_lang_ts_UiBar = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  },
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiBarvue_type_script_lang_ts_UiBar);
/* harmony default export */ var UiBarvue_type_script_lang_ts_ = (UiBarvue_type_script_lang_ts_UiBar);
// CONCATENATED MODULE: ./src/components/UiBar/UiBar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiBar_UiBarvue_type_script_lang_ts_ = (UiBarvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiBar/UiBar.vue?vue&type=style&index=0&id=7b997ea4&lang=stylus&scoped=true&
var UiBarvue_type_style_index_0_id_7b997ea4_lang_stylus_scoped_true_ = __webpack_require__("34ef");

// CONCATENATED MODULE: ./src/components/UiBar/UiBar.vue






/* normalize component */

var UiBar_component = normalizeComponent(
  UiBar_UiBarvue_type_script_lang_ts_,
  UiBarvue_type_template_id_7b997ea4_scoped_true_lang_pug_render,
  UiBarvue_type_template_id_7b997ea4_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "7b997ea4",
  null
  
)

/* harmony default export */ var UiBar_UiBar = (UiBar_component.exports);
// CONCATENATED MODULE: ./src/components/UiBar/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiButtonCollection/UiButtonCollection.vue?vue&type=template&id=2c57e4ef&scoped=true&lang=pug&
var UiButtonCollectionvue_type_template_id_2c57e4ef_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-button-collection"},[(_vm.label)?_c('ui-label',{staticClass:"label",attrs:{"label":_vm.label,"alignToCenter":_vm.alignToCenter,"alignToRight":_vm.alignToRight}}):_vm._e(),_c('div',{staticClass:"buttons",class:_vm.classes},[_vm._l((_vm.buttons),function(button){return _vm._t("button",[_c('ui-button',{attrs:{"label":_vm.getButtonLabel(button),"icon":_vm.getButtonIcon(button),"color":_vm.getButtonColor(button),"selected":_vm.isButtonSelected(button),"to":_vm.getButtonRoute(button),"tooltip":_vm.getButtonTooltip(button),"onlyUseColorWhenActive":!_vm.alwaysShowColor,"rounded":"","small":"","light":_vm.light,"subtle":_vm.subtle,"uppercase":_vm.uppercase},on:{"click":function($event){_vm.onClick(_vm.getButtonValue(button))}},nativeOn:{"mouseenter":function($event){_vm.onMouseEnter(_vm.getButtonValue(button))},"mouseleave":function($event){_vm.onMouseLeave(_vm.getButtonValue(button))}}})],{"button":button,"styleObject":{ maxWidth: '100%' }})}),(_vm.showAddButton)?_c('v-popover',{attrs:{"open":_vm.addMenuOpen,"placement":"bottom-start"},on:{"update:open":function($event){_vm.addMenuOpen=$event}},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_vm._t("add-menu",null,{"open":_vm.addMenuOpen,"closePopover":function () { return _vm.addMenuOpen = false; }}),_vm._t("addMenu",null,{"open":_vm.addMenuOpen,"closePopover":function () { return _vm.addMenuOpen = false; }})]},proxy:true}],null,true)},[_c('ui-button',{staticClass:"add-button",attrs:{"icon":"plus-circle","label":"Add","showLabel":false,"rounded":"","small":"","subtle":"","data-test-id":"button-collection:add-button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('add')}}})],1):_vm._e()],2),(_vm.errors.length > 0)?_c('ui-hints',{attrs:{"hints":_vm.errors,"light":_vm.light,"danger":""}}):_vm._e()],1)}
var UiButtonCollectionvue_type_template_id_2c57e4ef_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiButtonCollection/UiButtonCollection.vue?vue&type=template&id=2c57e4ef&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLabel/UiLabel.vue?vue&type=template&id=f4f16454&scoped=true&lang=pug&
var UiLabelvue_type_template_id_f4f16454_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-label",class:_vm.classes},[_c('span',[_vm._v(_vm._s(_vm.labelWithAsterisk))]),(_vm.info)?_c('ui-status-icon',{attrs:{"icon":"information","message":_vm.info,"light":_vm.light,"subtle":"","small":""}}):_vm._e()],1)}
var UiLabelvue_type_template_id_f4f16454_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiLabel/UiLabel.vue?vue&type=template&id=f4f16454&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiStatusIcon/UiStatusIcon.vue?vue&type=template&id=0dc263e4&scoped=true&lang=pug&
var UiStatusIconvue_type_template_id_0dc263e4_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.message),expression:"message"}],staticClass:"icon",class:_vm.classes,attrs:{"icon":_vm.icon,"small":_vm.small}})}
var UiStatusIconvue_type_template_id_0dc263e4_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiStatusIcon/UiStatusIcon.vue?vue&type=template&id=0dc263e4&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiStatusIcon/UiStatusIcon.vue?vue&type=script&lang=ts&










var UiStatusIconvue_type_script_lang_ts_UiStatusIcon =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiStatusIcon, _Vue);

  function UiStatusIcon() {
    _classCallCheck(this, UiStatusIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiStatusIcon).apply(this, arguments));
  }

  _createClass(UiStatusIcon, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        subtle: this.subtle,
        light: this.light
      };
    }
  }]);

  return UiStatusIcon;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  required: true
})], UiStatusIconvue_type_script_lang_ts_UiStatusIcon.prototype, "icon", void 0);

__decorate([Prop({
  type: String,
  required: true
})], UiStatusIconvue_type_script_lang_ts_UiStatusIcon.prototype, "message", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiStatusIconvue_type_script_lang_ts_UiStatusIcon.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiStatusIconvue_type_script_lang_ts_UiStatusIcon.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiStatusIconvue_type_script_lang_ts_UiStatusIcon.prototype, "small", void 0);

UiStatusIconvue_type_script_lang_ts_UiStatusIcon = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  },
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiStatusIconvue_type_script_lang_ts_UiStatusIcon);
/* harmony default export */ var UiStatusIconvue_type_script_lang_ts_ = (UiStatusIconvue_type_script_lang_ts_UiStatusIcon);
// CONCATENATED MODULE: ./src/components/UiStatusIcon/UiStatusIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiStatusIcon_UiStatusIconvue_type_script_lang_ts_ = (UiStatusIconvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiStatusIcon/UiStatusIcon.vue?vue&type=style&index=0&id=0dc263e4&lang=stylus&scoped=true&
var UiStatusIconvue_type_style_index_0_id_0dc263e4_lang_stylus_scoped_true_ = __webpack_require__("a4e8");

// CONCATENATED MODULE: ./src/components/UiStatusIcon/UiStatusIcon.vue






/* normalize component */

var UiStatusIcon_component = normalizeComponent(
  UiStatusIcon_UiStatusIconvue_type_script_lang_ts_,
  UiStatusIconvue_type_template_id_0dc263e4_scoped_true_lang_pug_render,
  UiStatusIconvue_type_template_id_0dc263e4_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "0dc263e4",
  null
  
)

/* harmony default export */ var UiStatusIcon_UiStatusIcon = (UiStatusIcon_component.exports);
// CONCATENATED MODULE: ./src/components/UiStatusIcon/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLabel/UiLabel.vue?vue&type=script&lang=ts&










var UiLabelvue_type_script_lang_ts_UiLabel =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiLabel, _Vue);

  function UiLabel() {
    _classCallCheck(this, UiLabel);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiLabel).apply(this, arguments));
  }

  _createClass(UiLabel, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'light': this.light,
        'align-to-left': !this.alignToCenter && !this.alignToRight,
        'align-to-center': this.alignToCenter,
        'align-to-right': this.alignToRight
      };
    }
  }, {
    key: "labelWithAsterisk",
    get: function get() {
      return "".concat(this.label).concat(this.showAsterisk ? '*' : '');
    }
  }]);

  return UiLabel;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  required: true
})], UiLabelvue_type_script_lang_ts_UiLabel.prototype, "label", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLabelvue_type_script_lang_ts_UiLabel.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLabelvue_type_script_lang_ts_UiLabel.prototype, "showAsterisk", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLabelvue_type_script_lang_ts_UiLabel.prototype, "alignToCenter", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLabelvue_type_script_lang_ts_UiLabel.prototype, "alignToRight", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiLabelvue_type_script_lang_ts_UiLabel.prototype, "info", void 0);

UiLabelvue_type_script_lang_ts_UiLabel = __decorate([vue_class_component_esm({
  components: {
    UiStatusIcon: UiStatusIcon_UiStatusIcon
  }
})], UiLabelvue_type_script_lang_ts_UiLabel);
/* harmony default export */ var UiLabelvue_type_script_lang_ts_ = (UiLabelvue_type_script_lang_ts_UiLabel);
// CONCATENATED MODULE: ./src/components/UiLabel/UiLabel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiLabel_UiLabelvue_type_script_lang_ts_ = (UiLabelvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiLabel/UiLabel.vue?vue&type=style&index=0&id=f4f16454&lang=stylus&scoped=true&
var UiLabelvue_type_style_index_0_id_f4f16454_lang_stylus_scoped_true_ = __webpack_require__("9ba8");

// CONCATENATED MODULE: ./src/components/UiLabel/UiLabel.vue






/* normalize component */

var UiLabel_component = normalizeComponent(
  UiLabel_UiLabelvue_type_script_lang_ts_,
  UiLabelvue_type_template_id_f4f16454_scoped_true_lang_pug_render,
  UiLabelvue_type_template_id_f4f16454_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "f4f16454",
  null
  
)

/* harmony default export */ var UiLabel_UiLabel = (UiLabel_component.exports);
// CONCATENATED MODULE: ./src/components/UiLabel/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiHints/UiHints.vue?vue&type=template&id=4a234f9e&scoped=true&lang=pug&
var UiHintsvue_type_template_id_4a234f9e_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-hints"},[_c('transition',{attrs:{"name":"hints-stretch"}},[(_vm.hintsExist)?_c('div',{staticClass:"spacer"}):_vm._e()]),_c('transition-group',{staticClass:"hints",attrs:{"name":"hint-rise"}},_vm._l((_vm.hints),function(hint){return _c('ui-hint',{key:hint,attrs:{"hint":hint,"danger":_vm.danger,"light":_vm.light}})}),1)],1)}
var UiHintsvue_type_template_id_4a234f9e_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiHints/UiHints.vue?vue&type=template&id=4a234f9e&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiHint/UiHint.vue?vue&type=template&id=1c88b113&scoped=true&lang=pug&
var UiHintvue_type_template_id_1c88b113_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-hint",class:_vm.classes},[(_vm.light)?_c('ui-icon',{attrs:{"icon":"alert-circle","small":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.hint))])],1)}
var UiHintvue_type_template_id_1c88b113_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiHint/UiHint.vue?vue&type=template&id=1c88b113&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiHint/UiHint.vue?vue&type=script&lang=ts&









var UiHintvue_type_script_lang_ts_UiHint =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiHint, _Vue);

  function UiHint() {
    _classCallCheck(this, UiHint);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiHint).apply(this, arguments));
  }

  _createClass(UiHint, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'light': this.light,
        'dark': !this.light,
        'subtle': this.subtle,
        'prominent': !this.subtle,
        'normal': !this.danger,
        'danger': this.danger && !this.light
      };
    }
  }]);

  return UiHint;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  required: true
})], UiHintvue_type_script_lang_ts_UiHint.prototype, "hint", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiHintvue_type_script_lang_ts_UiHint.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiHintvue_type_script_lang_ts_UiHint.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiHintvue_type_script_lang_ts_UiHint.prototype, "danger", void 0);

UiHintvue_type_script_lang_ts_UiHint = __decorate([vue_class_component_esm({
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiHintvue_type_script_lang_ts_UiHint);
/* harmony default export */ var UiHintvue_type_script_lang_ts_ = (UiHintvue_type_script_lang_ts_UiHint);
// CONCATENATED MODULE: ./src/components/UiHint/UiHint.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiHint_UiHintvue_type_script_lang_ts_ = (UiHintvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiHint/UiHint.vue?vue&type=style&index=0&id=1c88b113&lang=stylus&scoped=true&
var UiHintvue_type_style_index_0_id_1c88b113_lang_stylus_scoped_true_ = __webpack_require__("fa5a");

// CONCATENATED MODULE: ./src/components/UiHint/UiHint.vue






/* normalize component */

var UiHint_component = normalizeComponent(
  UiHint_UiHintvue_type_script_lang_ts_,
  UiHintvue_type_template_id_1c88b113_scoped_true_lang_pug_render,
  UiHintvue_type_template_id_1c88b113_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "1c88b113",
  null
  
)

/* harmony default export */ var UiHint_UiHint = (UiHint_component.exports);
// CONCATENATED MODULE: ./src/components/UiHint/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiHints/UiHints.vue?vue&type=script&lang=ts&









var UiHintsvue_type_script_lang_ts_UiHints =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiHints, _Vue);

  function UiHints() {
    _classCallCheck(this, UiHints);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiHints).apply(this, arguments));
  }

  _createClass(UiHints, [{
    key: "hintsExist",
    ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return !!this.hints && this.hints.length > 0;
    }
  }]);

  return UiHints;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiHintsvue_type_script_lang_ts_UiHints.prototype, "hints", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiHintsvue_type_script_lang_ts_UiHints.prototype, "danger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiHintsvue_type_script_lang_ts_UiHints.prototype, "light", void 0);

UiHintsvue_type_script_lang_ts_UiHints = __decorate([vue_class_component_esm({
  components: {
    UiHint: UiHint_UiHint
  }
})], UiHintsvue_type_script_lang_ts_UiHints);
/* harmony default export */ var UiHintsvue_type_script_lang_ts_ = (UiHintsvue_type_script_lang_ts_UiHints);
// CONCATENATED MODULE: ./src/components/UiHints/UiHints.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiHints_UiHintsvue_type_script_lang_ts_ = (UiHintsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiHints/UiHints.vue?vue&type=style&index=0&id=4a234f9e&lang=stylus&scoped=true&
var UiHintsvue_type_style_index_0_id_4a234f9e_lang_stylus_scoped_true_ = __webpack_require__("564c");

// CONCATENATED MODULE: ./src/components/UiHints/UiHints.vue






/* normalize component */

var UiHints_component = normalizeComponent(
  UiHints_UiHintsvue_type_script_lang_ts_,
  UiHintsvue_type_template_id_4a234f9e_scoped_true_lang_pug_render,
  UiHintsvue_type_template_id_4a234f9e_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "4a234f9e",
  null
  
)

/* harmony default export */ var UiHints_UiHints = (UiHints_component.exports);
// CONCATENATED MODULE: ./src/components/UiHints/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiButtonCollection/UiButtonCollection.vue?vue&type=script&lang=ts&














var UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiButtonCollection, _Vue);

  function UiButtonCollection() {
    var _this;

    _classCallCheck(this, UiButtonCollection);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiButtonCollection).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.addMenuOpen = false;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiButtonCollection, [{
    key: "isButtonSelected",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function isButtonSelected(button) {
      var value = this.getButtonValue(button);
      return this.selectedButtonValues.includes(value);
    } ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onClick",
    value: function onClick(value) {
      this.$emit('click', value);
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(value) {
      this.$emit('hover', value);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.$emit('hover', null);
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        'vertical': this.vertical,
        'horizontal': !this.vertical,
        'align-to-left': !this.alignToCenter && !this.alignToRight,
        'align-to-center': this.alignToCenter,
        'align-to-right': this.alignToRight,
        'dense': !this.sparse,
        'sparse': this.sparse
      };
    }
  }]);

  return UiButtonCollection;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Array,
  required: true
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "buttons", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "selectedButtonValues", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "label", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "alignToCenter", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "alignToRight", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "disabled", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "getButtonValue", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "getButtonLabel", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "getButtonIcon", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "getButtonColor", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "getButtonRoute", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "getButtonTooltip", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "showAddButton", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "vertical", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "uppercase", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "alwaysShowColor", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "sparse", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection.prototype, "errors", void 0);

UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection = __decorate([vue_class_component_esm({
  components: {
    UiButton: UiButton_UiButton,
    UiLabel: UiLabel_UiLabel,
    UiHints: UiHints_UiHints,
    VPopover: v_tooltip_esm["b" /* VPopover */]
  }
})], UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection);
/* harmony default export */ var UiButtonCollectionvue_type_script_lang_ts_ = (UiButtonCollectionvue_type_script_lang_ts_UiButtonCollection);
// CONCATENATED MODULE: ./src/components/UiButtonCollection/UiButtonCollection.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiButtonCollection_UiButtonCollectionvue_type_script_lang_ts_ = (UiButtonCollectionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiButtonCollection/UiButtonCollection.vue?vue&type=style&index=0&id=2c57e4ef&lang=stylus&scoped=true&
var UiButtonCollectionvue_type_style_index_0_id_2c57e4ef_lang_stylus_scoped_true_ = __webpack_require__("829c");

// CONCATENATED MODULE: ./src/components/UiButtonCollection/UiButtonCollection.vue






/* normalize component */

var UiButtonCollection_component = normalizeComponent(
  UiButtonCollection_UiButtonCollectionvue_type_script_lang_ts_,
  UiButtonCollectionvue_type_template_id_2c57e4ef_scoped_true_lang_pug_render,
  UiButtonCollectionvue_type_template_id_2c57e4ef_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "2c57e4ef",
  null
  
)

/* harmony default export */ var UiButtonCollection_UiButtonCollection = (UiButtonCollection_component.exports);
// CONCATENATED MODULE: ./src/components/UiButtonCollection/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCard/UiCard.vue?vue&type=template&id=2343ce25&scoped=true&lang=pug&
var UiCardvue_type_template_id_2343ce25_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-card",class:_vm.classes},[(_vm.$scopedSlots['icon'] || _vm.$scopedSlots['heading'] || _vm.$scopedSlots['header-right'])?_c('div',{staticClass:"ui-card-header"},[(_vm.$scopedSlots['icon'])?_c('div',{staticClass:"ui-card-header-icon"},[_vm._t("icon")],2):_vm._e(),(_vm.$scopedSlots['heading'])?_c('div',{staticClass:"ui-card-heading"},[_vm._t("heading")],2):_vm._e(),(_vm.$scopedSlots['header-right'])?_c('div',{staticClass:"ui-card-header-right"},[_vm._t("header-right")],2):_vm._e()]):_vm._e(),(_vm.$scopedSlots['main'])?_c('div',{staticClass:"ui-card-main"},[_vm._t("main")],2):_vm._e(),(_vm.$scopedSlots['footer'])?_c('div',{staticClass:"ui-card-footer"},[_vm._t("footer")],2):_vm._e()])}
var UiCardvue_type_template_id_2343ce25_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCard/UiCard.vue?vue&type=template&id=2343ce25&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCard/UiCard.vue?vue&type=script&lang=ts&











var UiCardvue_type_script_lang_ts_UiCard =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiCard, _Vue);

  function UiCard() {
    _classCallCheck(this, UiCard);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiCard).apply(this, arguments));
  }

  _createClass(UiCard, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'flat': this.flat,
        'rounded-corners': this.roundedCorners,
        'floating': this.floating,
        'compact': this.compact,
        'opaque': this.opaque,
        'with-padding': !this.noPadding,
        'scrollable': this.scrollable
      };
    }
  }]);

  return UiCard;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "compact", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "flat", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "floating", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "opaque", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "roundedCorners", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "scrollable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCardvue_type_script_lang_ts_UiCard.prototype, "noPadding", void 0);

UiCardvue_type_script_lang_ts_UiCard = __decorate([vue_class_component_esm({
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiCardvue_type_script_lang_ts_UiCard);
/* harmony default export */ var UiCardvue_type_script_lang_ts_ = (UiCardvue_type_script_lang_ts_UiCard);
// CONCATENATED MODULE: ./src/components/UiCard/UiCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiCard_UiCardvue_type_script_lang_ts_ = (UiCardvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiCard/UiCard.vue?vue&type=style&index=0&id=2343ce25&lang=stylus&scoped=true&
var UiCardvue_type_style_index_0_id_2343ce25_lang_stylus_scoped_true_ = __webpack_require__("b163");

// CONCATENATED MODULE: ./src/components/UiCard/UiCard.vue






/* normalize component */

var UiCard_component = normalizeComponent(
  UiCard_UiCardvue_type_script_lang_ts_,
  UiCardvue_type_template_id_2343ce25_scoped_true_lang_pug_render,
  UiCardvue_type_template_id_2343ce25_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "2343ce25",
  null
  
)

/* harmony default export */ var UiCard_UiCard = (UiCard_component.exports);
// CONCATENATED MODULE: ./src/components/UiCard/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCode/UiCode.vue?vue&type=template&id=8fad4ba8&scoped=true&lang=pug&
var UiCodevue_type_template_id_8fad4ba8_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-code"},[_c('pre',{staticClass:"code",class:_vm.classes},[_vm._v(_vm._s(_vm.code))]),_c('ui-copy-button',{staticClass:"copy-button",attrs:{"text":_vm.code}})],1)}
var UiCodevue_type_template_id_8fad4ba8_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCode/UiCode.vue?vue&type=template&id=8fad4ba8&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCode/UiCode.vue?vue&type=script&lang=ts&









var UiCodevue_type_script_lang_ts_UiCode =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiCode, _Vue);

  function UiCode() {
    _classCallCheck(this, UiCode);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiCode).apply(this, arguments));
  }

  _createClass(UiCode, [{
    key: "classes",
    get: function get() {
      return {
        'pad-for-button': this.makeSpaceForButton
      };
    }
  }]);

  return UiCode;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  required: true
})], UiCodevue_type_script_lang_ts_UiCode.prototype, "code", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCodevue_type_script_lang_ts_UiCode.prototype, "makeSpaceForButton", void 0);

UiCodevue_type_script_lang_ts_UiCode = __decorate([vue_class_component_esm({
  components: {
    UiCopyButton: UiCopyButton_UiCopyButton
  }
})], UiCodevue_type_script_lang_ts_UiCode);
/* harmony default export */ var UiCodevue_type_script_lang_ts_ = (UiCodevue_type_script_lang_ts_UiCode);
// CONCATENATED MODULE: ./src/components/UiCode/UiCode.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiCode_UiCodevue_type_script_lang_ts_ = (UiCodevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiCode/UiCode.vue?vue&type=style&index=0&id=8fad4ba8&lang=stylus&scoped=true&
var UiCodevue_type_style_index_0_id_8fad4ba8_lang_stylus_scoped_true_ = __webpack_require__("750d");

// CONCATENATED MODULE: ./src/components/UiCode/UiCode.vue






/* normalize component */

var UiCode_component = normalizeComponent(
  UiCode_UiCodevue_type_script_lang_ts_,
  UiCodevue_type_template_id_8fad4ba8_scoped_true_lang_pug_render,
  UiCodevue_type_template_id_8fad4ba8_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "8fad4ba8",
  null
  
)

/* harmony default export */ var UiCode_UiCode = (UiCode_component.exports);
// CONCATENATED MODULE: ./src/components/UiCode/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorDot/UiColorDot.vue?vue&type=script&lang=tsx&

/* harmony default export */ var UiColorDotvue_type_script_lang_tsx_ = ({
  functional: true,
  props: {
    color: {
      type: String,
      required: true
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props;
    return h("div", {
      "class": 'ui-color-dot',
      "style": getColoredStyle({
        primaryColor: props.color
      })
    });
  }
});
// CONCATENATED MODULE: ./src/components/UiColorDot/UiColorDot.vue?vue&type=script&lang=tsx&
 /* harmony default export */ var UiColorDot_UiColorDotvue_type_script_lang_tsx_ = (UiColorDotvue_type_script_lang_tsx_); 
// EXTERNAL MODULE: ./src/components/UiColorDot/UiColorDot.vue?vue&type=style&index=0&id=1be962c1&lang=stylus&scoped=true&
var UiColorDotvue_type_style_index_0_id_1be962c1_lang_stylus_scoped_true_ = __webpack_require__("b6da");

// CONCATENATED MODULE: ./src/components/UiColorDot/UiColorDot.vue
var UiColorDot_render, UiColorDot_staticRenderFns





/* normalize component */

var UiColorDot_component = normalizeComponent(
  UiColorDot_UiColorDotvue_type_script_lang_tsx_,
  UiColorDot_render,
  UiColorDot_staticRenderFns,
  false,
  null,
  "1be962c1",
  null
  
)

/* harmony default export */ var UiColorDot = (UiColorDot_component.exports);
// CONCATENATED MODULE: ./src/components/UiColorDot/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCheckbox/UiCheckbox.vue?vue&type=template&id=001c5c02&scoped=true&lang=pug&
var UiCheckboxvue_type_template_id_001c5c02_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-checkbox",on:{"click":_vm.onClick}},[_c('input',{ref:"checkbox",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked}}),_c('div',{staticClass:"checkbox",class:_vm.classes,style:(_vm.checkboxStyle)},[(_vm.$scopedSlots['avatar'])?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"avatar"},[(!_vm.checked)?_vm._t("avatar"):_vm._e()],2)]):_vm._e(),(_vm.progress)?_c('ui-progress',{staticClass:"progress",attrs:{"diameter":_vm.diameter,"width":1/8,"progress":_vm.progress}}):_vm._e(),_c('ui-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"color":_vm.light && (_vm.color || 'rgba(0,0,0,0.5)') || 'white'}})],1)])}
var UiCheckboxvue_type_template_id_001c5c02_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCheckbox/UiCheckbox.vue?vue&type=template&id=001c5c02&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiProgress/UiProgress.vue?vue&type=template&id=a3cb868a&scoped=true&lang=pug&
var UiProgressvue_type_template_id_a3cb868a_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({staticClass:"ui-progress"},'svg',_vm.svgAttrs,false),[_c('circle',_vm._b({staticClass:"placeholder-arc"},'circle',_vm.circleAttrs,false)),_c('circle',_vm._b({staticClass:"progress-arc",style:({ strokeDashoffset: _vm.strokeDashoffset }),attrs:{"stroke":_vm.color,"stroke-dasharray":_vm.strokeDasharray}},'circle',_vm.circleAttrs,false))])}
var UiProgressvue_type_template_id_a3cb868a_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiProgress/UiProgress.vue?vue&type=template&id=a3cb868a&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiProgress/UiProgress.vue?vue&type=script&lang=ts&











var UiProgressvue_type_script_lang_ts_UiProgress =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiProgress, _Vue);

  function UiProgress() {
    _classCallCheck(this, UiProgress);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiProgress).apply(this, arguments));
  }

  _createClass(UiProgress, [{
    key: "radius",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.diameter / 2;
    }
  }, {
    key: "normalisedRadius",
    get: function get() {
      return this.radius - this.width / 2;
    }
  }, {
    key: "circumference",
    get: function get() {
      return this.normalisedRadius * 2 * Math.PI;
    }
  }, {
    key: "strokeDashoffset",
    get: function get() {
      if (this.progress === null) return 0;
      var circumference = getRemAsPixels(this.circumference);
      return circumference - this.progress * circumference;
    }
  }, {
    key: "strokeDasharray",
    get: function get() {
      var circumference = getRemAsPixels(this.circumference);
      return "".concat(circumference, " ").concat(circumference);
    }
  }, {
    key: "svgAttrs",
    get: function get() {
      return {
        width: getRemAsPixels(this.diameter),
        height: getRemAsPixels(this.diameter)
      };
    }
  }, {
    key: "circleAttrs",
    get: function get() {
      return {
        'stroke-width': getRemAsPixels(this.width),
        fill: 'transparent',
        r: getRemAsPixels(this.normalisedRadius),
        cx: getRemAsPixels(this.radius),
        cy: getRemAsPixels(this.radius)
      };
    }
  }]);

  return UiProgress;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Number,
  required: true
})], UiProgressvue_type_script_lang_ts_UiProgress.prototype, "diameter", void 0);

__decorate([Prop({
  type: Number,
  required: true
})], UiProgressvue_type_script_lang_ts_UiProgress.prototype, "width", void 0);

__decorate([Prop({
  type: String,
  default: '#078cb0'
})], UiProgressvue_type_script_lang_ts_UiProgress.prototype, "color", void 0);

__decorate([Prop({
  validator: function validator(progress) {
    return typeof progress === 'number' && progress >= 0 && progress <= 1 || progress === undefined;
  },
  default: null
})], UiProgressvue_type_script_lang_ts_UiProgress.prototype, "progress", void 0);

UiProgressvue_type_script_lang_ts_UiProgress = __decorate([vue_class_component_esm], UiProgressvue_type_script_lang_ts_UiProgress);
/* harmony default export */ var UiProgressvue_type_script_lang_ts_ = (UiProgressvue_type_script_lang_ts_UiProgress);
// CONCATENATED MODULE: ./src/components/UiProgress/UiProgress.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiProgress_UiProgressvue_type_script_lang_ts_ = (UiProgressvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiProgress/UiProgress.vue?vue&type=style&index=0&id=a3cb868a&lang=stylus&scoped=true&
var UiProgressvue_type_style_index_0_id_a3cb868a_lang_stylus_scoped_true_ = __webpack_require__("91ee");

// CONCATENATED MODULE: ./src/components/UiProgress/UiProgress.vue






/* normalize component */

var UiProgress_component = normalizeComponent(
  UiProgress_UiProgressvue_type_script_lang_ts_,
  UiProgressvue_type_template_id_a3cb868a_scoped_true_lang_pug_render,
  UiProgressvue_type_template_id_a3cb868a_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "a3cb868a",
  null
  
)

/* harmony default export */ var UiProgress_UiProgress = (UiProgress_component.exports);
// CONCATENATED MODULE: ./src/components/UiProgress/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCheckbox/UiCheckbox.vue?vue&type=script&lang=ts&











var UiCheckboxvue_type_script_lang_ts_UiCheckbox =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiCheckbox, _Vue);

  function UiCheckbox() {
    _classCallCheck(this, UiCheckbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiCheckbox).apply(this, arguments));
  }

  _createClass(UiCheckbox, [{
    key: "onClick",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function onClick(event) {
      if (this.disabled || this.readOnly) return;
      event.stopPropagation();
      this.$emit('toggle', event, event.target.checked);
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        checked: this.checked,
        small: this.small,
        medium: !this.small,
        'interactable': !this.readOnly && !this.disabled,
        success: this.success,
        danger: this.danger,
        light: this.light,
        'default-color': !this.success && !this.danger,
        'show-progress': this.progress !== null,
        'no-progress': this.progress === null,
        'disabled': this.disabled
      };
    }
  }, {
    key: "diameter",
    get: function get() {
      if (this.small) return 5 / 8;
      return 6 / 8;
    }
  }, {
    key: "checkboxStyle",
    get: function get() {
      return {
        width: "".concat(this.diameter, "rem"),
        height: "".concat(this.diameter, "rem")
      };
    }
  }, {
    key: "icon",
    get: function get() {
      if (this.danger) return 'close';
      return 'check';
    }
  }]);

  return UiCheckbox;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  required: true
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "checked", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "readOnly", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "small", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "success", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "danger", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "light", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "color", void 0);

__decorate([Prop({
  validator: function validator(progress) {
    return typeof progress === 'number' && progress >= 0 && progress <= 1 || progress === undefined;
  },
  default: null
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox.prototype, "progress", void 0);

UiCheckboxvue_type_script_lang_ts_UiCheckbox = __decorate([vue_class_component_esm({
  components: {
    UiProgress: UiProgress_UiProgress,
    UiIcon: UiIcon_UiIcon
  }
})], UiCheckboxvue_type_script_lang_ts_UiCheckbox);
/* harmony default export */ var UiCheckboxvue_type_script_lang_ts_ = (UiCheckboxvue_type_script_lang_ts_UiCheckbox);
// CONCATENATED MODULE: ./src/components/UiCheckbox/UiCheckbox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiCheckbox_UiCheckboxvue_type_script_lang_ts_ = (UiCheckboxvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiCheckbox/UiCheckbox.vue?vue&type=style&index=0&id=001c5c02&lang=stylus&scoped=true&
var UiCheckboxvue_type_style_index_0_id_001c5c02_lang_stylus_scoped_true_ = __webpack_require__("22e4");

// CONCATENATED MODULE: ./src/components/UiCheckbox/UiCheckbox.vue






/* normalize component */

var UiCheckbox_component = normalizeComponent(
  UiCheckbox_UiCheckboxvue_type_script_lang_ts_,
  UiCheckboxvue_type_template_id_001c5c02_scoped_true_lang_pug_render,
  UiCheckboxvue_type_template_id_001c5c02_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "001c5c02",
  null
  
)

/* harmony default export */ var UiCheckbox_UiCheckbox = (UiCheckbox_component.exports);
// CONCATENATED MODULE: ./src/components/UiCheckbox/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDivider/UiDivider.vue?vue&type=template&id=00affc63&scoped=true&lang=pug&
var UiDividervue_type_template_id_00affc63_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-divider",class:_vm.classes},[_c('div',{staticClass:"line"}),(_vm.text)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('div',{staticClass:"line"})])}
var UiDividervue_type_template_id_00affc63_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiDivider/UiDivider.vue?vue&type=template&id=00affc63&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDivider/UiDivider.vue?vue&type=script&lang=ts&









var UiDividervue_type_script_lang_ts_UiDivider =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiDivider, _Vue);

  function UiDivider() {
    _classCallCheck(this, UiDivider);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiDivider).apply(this, arguments));
  }

  _createClass(UiDivider, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'subtle': this.subtle,
        'prominent': !this.subtle
      };
    }
  }, {
    key: "tooltip",
    get: function get() {
      if (!this.tooltipText || !this.text) return null;
      return {
        content: this.tooltipText
      };
    }
  }]);

  return UiDivider;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiDividervue_type_script_lang_ts_UiDivider.prototype, "text", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiDividervue_type_script_lang_ts_UiDivider.prototype, "tooltipText", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiDividervue_type_script_lang_ts_UiDivider.prototype, "subtle", void 0);

UiDividervue_type_script_lang_ts_UiDivider = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  }
})], UiDividervue_type_script_lang_ts_UiDivider);
/* harmony default export */ var UiDividervue_type_script_lang_ts_ = (UiDividervue_type_script_lang_ts_UiDivider);
// CONCATENATED MODULE: ./src/components/UiDivider/UiDivider.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiDivider_UiDividervue_type_script_lang_ts_ = (UiDividervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiDivider/UiDivider.vue?vue&type=style&index=0&id=00affc63&lang=stylus&scoped=true&
var UiDividervue_type_style_index_0_id_00affc63_lang_stylus_scoped_true_ = __webpack_require__("301f");

// CONCATENATED MODULE: ./src/components/UiDivider/UiDivider.vue






/* normalize component */

var UiDivider_component = normalizeComponent(
  UiDivider_UiDividervue_type_script_lang_ts_,
  UiDividervue_type_template_id_00affc63_scoped_true_lang_pug_render,
  UiDividervue_type_template_id_00affc63_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "00affc63",
  null
  
)

/* harmony default export */ var UiDivider_UiDivider = (UiDivider_component.exports);
// CONCATENATED MODULE: ./src/components/UiDivider/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropdown/UiDropdown.vue?vue&type=template&id=1a183058&scoped=true&lang=pug&
var UiDropdownvue_type_template_id_1a183058_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-dropdown"},[(_vm.label)?_c('ui-label',{attrs:{"label":_vm.label,"showAsterisk":_vm.showAsterisk,"light":_vm.light}}):_vm._e(),_c('div',{staticClass:"input-container"},[_c('v-popover',{staticClass:"popover-wrapper",attrs:{"open":_vm.open,"disabled":_vm.disabled,"placement":"bottom-start","boundariesElement":"viewport"},on:{"update:open":function($event){_vm.open=$event}},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_c('ui-menu',{style:({ width: (_vm.width + "rem") }),attrs:{"selectedOptions":[ _vm.selectedOption ],"options":_vm.options,"getOptionValue":_vm.getOptionValue,"isOptionDisabled":_vm.isOptionDisabled,"getOptionFilterKey":_vm.getOptionFilterKey,"async":_vm.async,"filterable":_vm.filterable,"visible":_vm.open,"data-test-id":"dropdown:menu"},on:{"filter":function($event){return _vm.$emit('filter', $event)},"select":_vm.onSelect,"close":_vm.closeDropdown},scopedSlots:_vm._u([{key:"icon",fn:function(ref){
var option = ref.option;
return [_vm._t("icon",null,{"option":option})]}},{key:"text",fn:function(ref){
var option = ref.option;
return [_vm._t("text",null,{"option":option})]}},{key:"subtitle",fn:function(ref){
var option = ref.option;
return [_vm._t("subtitle",null,{"option":option})]}}],null,true)})]},proxy:true}])},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],ref:"inputBox",staticClass:"input-box popover-target",class:_vm.classes,on:{"click":_vm.onClickInputBox}},[_c('div',{staticClass:"selected-option"},[(_vm.selectedOption)?[(_vm.$scopedSlots.icon)?_c('div',{staticClass:"icon-slot"},[_vm._t("icon",null,{"option":_vm.selectedOption})],2):_vm._e(),_c('div',{staticClass:"text-slot"},[_vm._t("display-text",[_vm._t("text",null,{"option":_vm.selectedOption})],{"option":_vm.selectedOption})],2)]:(_vm.placeholder)?_c('div',{staticClass:"placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e()],2),_c('div',{staticClass:"right"},[(_vm.$scopedSlots['right'])?_c('div',{staticClass:"slot-container"},[_vm._t("right",null,{"option":_vm.selectedOption})],2):_vm._e(),_c('ui-icon',{staticClass:"dropdown-icon",attrs:{"icon":"menu-down","data-test-id":"dropdown:menu-down-icon"}})],1)])]),(_vm.showAnyButtons)?_c('div',{staticClass:"right-button-container"},[(_vm.showEditButton)?_c('ui-icon-button',{attrs:{"label":"Edit","showLabel":false,"icon":"pencil","small":"","data-test-id":"dropdown:edit-button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('edit')}}}):_vm._e(),(_vm.showCreateButton)?_c('ui-icon-button',{attrs:{"label":"Create","showLabel":false,"icon":"plus","small":"","data-test-id":"dropdown:create-button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('create')}}}):_vm._e(),(_vm.showRemoveButton)?_c('ui-icon-button',{attrs:{"label":"Remove","showLabel":false,"icon":"minus-circle","small":"","data-test-id":"dropdown:remove-button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('remove')}}}):_vm._e(),(_vm.showClearButton)?_c('ui-icon-button',{attrs:{"label":"Clear","showLabel":false,"icon":"close-circle","small":"","data-test-id":"dropdown:clear-button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('clear')}}}):_vm._e()],1):_vm._e()],1),_c('ui-hints',{attrs:{"hints":_vm.errors,"light":_vm.light,"danger":""}})],1)}
var UiDropdownvue_type_template_id_1a183058_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiDropdown/UiDropdown.vue?vue&type=template&id=1a183058&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiMenu/UiMenu.vue?vue&type=template&id=7a58c329&scoped=true&lang=pug&
var UiMenuvue_type_template_id_7a58c329_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-menu",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onPressEscape($event)}}},[(_vm.filterable || _vm.creatable)?_c('ui-error-wrapper',{attrs:{"clientErrors":_vm.clientErrors,"names":['filterText']}},[_c('ui-text-input',{ref:"searchInput",staticClass:"filter-input",attrs:{"data-test-id":"menu:filter-input","placeholder":_vm.textInputPlaceholder},model:{value:(_vm.filterText),callback:function ($$v) {_vm.filterText=$$v},expression:"filterText"}})],1):_vm._e(),(_vm.paginatedItems.length > 0)?_c('ui-list',{ref:"list",staticClass:"list",attrs:{"items":_vm.paginatedItems,"compact":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [(item === _vm.createListItem)?[_c('ui-list-item',{attrs:{"tight":"","subtle":"","data-test-id":"menu:create-item"},on:{"click":_vm.onCreate},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.filterText))])]},proxy:true},(_vm.createHint)?{key:"subtitle",fn:function(){return [_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.createHint))])]},proxy:true}:null],null,true)})]:[_c('ui-list-item',{attrs:{"tight":"","subtle":"","highlighted":_vm.isOptionSelected(item),"disabled":_vm.isOptionDisabled(item)},on:{"click":function($event){return _vm.onClickOption(item)}},scopedSlots:_vm._u([{key:"left-icon",fn:function(){return [_vm._t("icon",null,{"option":item})]},proxy:true},{key:"title",fn:function(){return [_c('div',{staticClass:"title",class:_vm.getOptionClasses(item)},[_vm._t("text",null,{"option":item})],2)]},proxy:true},{key:"subtitle",fn:function(){return [_c('div',{staticClass:"subtitle"},[_vm._t("subtitle",null,{"option":item})],2)]},proxy:true},(_vm.isOptionSelected(item))?{key:"right-icon",fn:function(){return [_c('ui-icon',{attrs:{"icon":"check"}})]},proxy:true}:null],null,true)})]]}}],null,false,4219735014)}):_vm._e(),(_vm.paginatedItems.length === 0 && !_vm.creatable)?_vm._t("empty-state",[_c('ui-empty-state',{attrs:{"icon":"alert-circle","message":"No options","small":""}})]):_vm._e()],2)}
var UiMenuvue_type_template_id_7a58c329_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiMenu/UiMenu.vue?vue&type=template&id=7a58c329&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("b047c");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./src/mixins/mixin-scrolling-pagination.ts









 // @ts-ignore

var mixin_scrolling_pagination_AbstractScrollingPaginationMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(AbstractScrollingPaginationMixin, _Vue);

  function AbstractScrollingPaginationMixin() {
    var _this;

    _classCallCheck(this, AbstractScrollingPaginationMixin);

    ////////////////////////////////////////////////////////////////
    // state
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractScrollingPaginationMixin).apply(this, arguments));
    _this.visibleItemCount = 0;
    _this.debouncedPaginationScrollHandler = debounce_default()(_this.paginationScrollHandler, _this.paginationScrollDebounceRate);
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(AbstractScrollingPaginationMixin, [{
    key: "created",
    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////
    value: function created() {
      this.resetPagination();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      // Paginated element may not have rendered yet.
      // Could not reliably get paginated element using $nextTick and element's v-if.
      // So instead, try every second to get the paginated element; only add scroll listener once element exists.
      // Note: Typically succeeds on first try since interval function is queued and executed after initial render has completed.
      var intervalId = setInterval(function () {
        if (_this2.getPaginatedElement()) {
          clearInterval(intervalId);

          _this2.startPaginationScrollListener();
        }
      }, 1000);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.stopPaginationScrollListener();
    } ////////////////////////////////////////////////////////////////
    // methods → item count
    ////////////////////////////////////////////////////////////////

  }, {
    key: "nextPage",
    value: function nextPage() {
      if (this.visibleItemCount < this.itemsToPaginate.length) {
        this.visibleItemCount += this.itemsPerPage;
      }
    }
  }, {
    key: "resetPagination",
    value: function resetPagination() {
      this.visibleItemCount = this.itemsPerPage;
    }
  }, {
    key: "startPaginationScrollListener",
    value: function startPaginationScrollListener() {
      var paginatedElement = this.getPaginatedElement();
      if (!paginatedElement) return;
      paginatedElement.addEventListener('scroll', this.debouncedPaginationScrollHandler);
    }
  }, {
    key: "stopPaginationScrollListener",
    value: function stopPaginationScrollListener() {
      var paginatedElement = this.getPaginatedElement();
      if (!paginatedElement) return;
      paginatedElement.removeEventListener('scroll', this.debouncedPaginationScrollHandler);
    }
  }, {
    key: "paginationScrollHandler",
    value: function paginationScrollHandler() {
      var paginatedElement = this.getPaginatedElement();
      if (!paginatedElement) return;
      var scrollTop = getPixelsAsRem(paginatedElement.scrollTop);
      var scrollHeight = getPixelsAsRem(paginatedElement.scrollHeight);
      var clientHeight = getPixelsAsRem(paginatedElement.clientHeight);
      var maxScrollTop = scrollHeight - clientHeight;
      var scrolledCloseToBottom = scrollTop > maxScrollTop - this.paginationScrollThreshold;
      if (scrolledCloseToBottom) this.nextPage();
    }
  }, {
    key: "shouldPaginate",
    get: function get() {
      return true;
    }
  }, {
    key: "itemsPerPage",
    get: function get() {
      return 20;
    }
  }, {
    key: "paginationScrollDebounceRate",
    get: function get() {
      return 100;
    }
  }, {
    key: "paginationScrollThreshold",
    get: function get() {
      return 4;
    }
  }, {
    key: "paginatedItems",
    get: function get() {
      if (this.shouldPaginate) return this.itemsToPaginate.slice(0, this.visibleItemCount);
      return this.itemsToPaginate;
    }
  }]);

  return AbstractScrollingPaginationMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

mixin_scrolling_pagination_AbstractScrollingPaginationMixin = __decorate([vue_class_component_esm], mixin_scrolling_pagination_AbstractScrollingPaginationMixin);


var mixin_scrolling_pagination_ScrollingPaginationMixin =
/*#__PURE__*/
// @ts-ignore
function (_AbstractScrollingPag) {
  _inherits(ScrollingPaginationMixin, _AbstractScrollingPag);

  function ScrollingPaginationMixin() {
    _classCallCheck(this, ScrollingPaginationMixin);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollingPaginationMixin).apply(this, arguments));
  }

  return ScrollingPaginationMixin;
}(mixin_scrolling_pagination_AbstractScrollingPaginationMixin);

mixin_scrolling_pagination_ScrollingPaginationMixin = __decorate([vue_class_component_esm // @ts-ignore
], mixin_scrolling_pagination_ScrollingPaginationMixin);
/* harmony default export */ var mixin_scrolling_pagination = (mixin_scrolling_pagination_ScrollingPaginationMixin);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__("1dce");

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__("9b02");
var get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__("eed6");
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// CONCATENATED MODULE: ./src/mixins/mixin-validation-client.ts





















 // Note: `validationMixin` is only mixed-in for TypeScript purposes.
// @ts-ignore

var mixin_validation_client_AbstractClientValidationMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(AbstractClientValidationMixin, _Mixins);

  function AbstractClientValidationMixin() {
    _classCallCheck(this, AbstractClientValidationMixin);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractClientValidationMixin).apply(this, arguments));
  }

  _createClass(AbstractClientValidationMixin, [{
    key: "clientErrors",
    get: function get() {
      var _this = this;

      var errors = {};

      var fieldPaths = uniq_default()(Object.keys(flattenKeys(this.errorMessages)).map(function (key) {
        return key.replace(new RegExp(".[0-9].[A-Za-z]+$"), '');
      }));

      fieldPaths.forEach(function (fieldPath) {
        var $error = get_default()(_this.$v, fieldPath) && get_default()(_this.$v, fieldPath).$error;

        if (!$error) return;

        var messageObjects = get_default()(_this.errorMessages, fieldPath);

        var messages = messageObjects.filter(function (_ref) {
          var validator = _ref.validator,
              message = _ref.message;
          var validatorPath = "".concat(fieldPath, ".").concat(validator);

          var valid = get_default()(_this.$v, validatorPath);

          return !valid;
        }).map(function (_ref2) {
          var validator = _ref2.validator,
              message = _ref2.message;
          return message;
        });

        set_default()(errors, fieldPath, messages);
      });
      return errors;
    }
  }]);

  return AbstractClientValidationMixin;
}(mixins(lib["validationMixin"]));

mixin_validation_client_AbstractClientValidationMixin = __decorate([vue_class_component_esm], mixin_validation_client_AbstractClientValidationMixin);


var mixin_validation_client_ClientValidationMixin =
/*#__PURE__*/
// @ts-ignore
function (_AbstractClientValida) {
  _inherits(ClientValidationMixin, _AbstractClientValida);

  function ClientValidationMixin() {
    _classCallCheck(this, ClientValidationMixin);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClientValidationMixin).apply(this, arguments));
  }

  return ClientValidationMixin;
}(mixin_validation_client_AbstractClientValidationMixin);

mixin_validation_client_ClientValidationMixin = __decorate([vue_class_component_esm // @ts-ignore
], mixin_validation_client_ClientValidationMixin);
/* harmony default export */ var mixin_validation_client = (mixin_validation_client_ClientValidationMixin);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiErrorWrapper/UiErrorWrapper.vue?vue&type=template&id=7c74a8e0&scoped=true&lang=pug&
var UiErrorWrappervue_type_template_id_7c74a8e0_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-error-wrapper"},[_vm._t("default",null,{"errors":_vm.localErrors}),_c('ui-hints',{attrs:{"hints":_vm.localErrors,"danger":!_vm.light,"light":_vm.light}})],2)}
var UiErrorWrappervue_type_template_id_7c74a8e0_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiErrorWrapper/UiErrorWrapper.vue?vue&type=template&id=7c74a8e0&scoped=true&lang=pug&

// EXTERNAL MODULE: ./node_modules/lodash.merge/index.js
var lodash_merge = __webpack_require__("da81");
var lodash_merge_default = /*#__PURE__*/__webpack_require__.n(lodash_merge);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiErrorWrapper/UiErrorWrapper.vue?vue&type=script&lang=ts&

















function UiErrorWrappervue_type_script_lang_ts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiErrorWrappervue_type_script_lang_ts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiErrorWrappervue_type_script_lang_ts_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiErrorWrappervue_type_script_lang_ts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiErrorWrapper, _Vue);

  function UiErrorWrapper() {
    _classCallCheck(this, UiErrorWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiErrorWrapper).apply(this, arguments));
  }

  _createClass(UiErrorWrapper, [{
    key: "onChangeMonitor",
    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////
    value: function onChangeMonitor(newValue, oldValue) {
      if (lodash_isequal_default()(newValue, oldValue)) return;

      var newServerErrors = UiErrorWrappervue_type_script_lang_ts_objectSpread({}, this.serverErrors);

      this.names.forEach(function (name) {
        newServerErrors[name] = [];
      });
      this.$emit('update:serverErrors', newServerErrors);
    }
  }, {
    key: "allErrors",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      var allErrors = lodash_merge_default()(this.clientErrors, this.serverErrors, function (clientErrorMessages, serverErrorMessages) {
        return [].concat(_toConsumableArray(clientErrorMessages), _toConsumableArray(serverErrorMessages));
      });

      return allErrors;
    }
  }, {
    key: "localErrors",
    get: function get() {
      var _this = this;

      var localErrors = this.names.reduce(function (all, name) {
        var messages = _this.allErrors[name] || [];
        return [].concat(_toConsumableArray(all), _toConsumableArray(messages));
      }, []);
      return localErrors;
    }
  }]);

  return UiErrorWrapper;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Object,
  default: function _default() {
    return {};
  }
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper.prototype, "clientErrors", void 0);

__decorate([Prop({
  type: Object,
  default: function _default() {
    return {};
  }
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper.prototype, "serverErrors", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper.prototype, "light", void 0);

__decorate([Prop({
  type: Array,
  required: true
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper.prototype, "names", void 0);

__decorate([Prop({
  default: null
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper.prototype, "monitor", void 0);

__decorate([Watch('monitor', {
  deep: true
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper.prototype, "onChangeMonitor", null);

UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper = __decorate([vue_class_component_esm({
  components: {
    UiHints: UiHints_UiHints
  }
})], UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper);
/* harmony default export */ var UiErrorWrappervue_type_script_lang_ts_ = (UiErrorWrappervue_type_script_lang_ts_UiErrorWrapper);
// CONCATENATED MODULE: ./src/components/UiErrorWrapper/UiErrorWrapper.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiErrorWrapper_UiErrorWrappervue_type_script_lang_ts_ = (UiErrorWrappervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiErrorWrapper/UiErrorWrapper.vue





/* normalize component */

var UiErrorWrapper_component = normalizeComponent(
  UiErrorWrapper_UiErrorWrappervue_type_script_lang_ts_,
  UiErrorWrappervue_type_template_id_7c74a8e0_scoped_true_lang_pug_render,
  UiErrorWrappervue_type_template_id_7c74a8e0_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "7c74a8e0",
  null
  
)

/* harmony default export */ var UiErrorWrapper_UiErrorWrapper = (UiErrorWrapper_component.exports);
// CONCATENATED MODULE: ./src/components/UiErrorWrapper/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTextInput/UiTextInput.vue?vue&type=template&id=62917763&scoped=true&lang=pug&
var UiTextInputvue_type_template_id_62917763_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"ui-input",class:{bare: _vm.bare}},[(_vm.label)?_c('ui-label',{staticClass:"label",attrs:{"label":_vm.label,"info":_vm.info,"light":_vm.light,"showAsterisk":_vm.showAsterisk}}):_vm._e(),_c('div',{staticClass:"input-wrapper",class:_vm.classes},[_c('div',{staticClass:"input-prefix"},[_vm._t("prefix")],2),_c('input',{ref:"input",attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"keyup":function($event){return _vm.$emit('keyup', $event)},"click":function($event){return _vm.$emit('click', $event)},"input":_vm.handleInput,"focus":_vm.onFocus,"blur":_vm.onBlur}}),_c('div',{staticClass:"input-suffix"},[_vm._t("suffix")],2)]),(_vm.errors)?_c('ui-hints',{attrs:{"hints":_vm.errors,"light":_vm.light,"danger":""}}):_vm._e()],1)}
var UiTextInputvue_type_template_id_62917763_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTextInput/UiTextInput.vue?vue&type=template&id=62917763&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTextInput/UiTextInput.vue?vue&type=script&lang=ts&













var UiTextInputvue_type_script_lang_ts_UiTextInput =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiTextInput, _Vue);

  function UiTextInput() {
    var _this;

    _classCallCheck(this, UiTextInput);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiTextInput).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.focus = false;
    _this.lastAcceptableValue = '';
    _this.timeoutId = null;
    _this.maxWidth = 0;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiTextInput, [{
    key: "mounted",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function mounted() {
      if (this.autofocus) {
        var input = this.$refs.input;
        input.focus();
      }
    }
  }, {
    key: "handleInput",
    value: function handleInput(event) {
      var value = event.target.value;
      this.changeValue(value);
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      var _this2 = this;

      if (this.debounce) {
        // Clear previous timeout.
        if (this.timeoutId !== null) {
          clearTimeout(this.timeoutId);
        } // Set up new timeout.
        // @ts-ignore


        this.timeoutId = setTimeout(function () {
          _this2.$emit('input', value);
        }, this.debounceDuration);
      } else {
        this.$emit('input', value);
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.$emit('focus');
      this.focus = true;

      if (this.nonEmpty) {
        this.lastAcceptableValue = this.value;
      }

      if (this.selectAll) {
        this.$refs.input.select();
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.$emit('blur');
      this.focus = false;

      if (this.nonEmpty) {
        var trimmedValue = this.value.trim();

        if (trimmedValue.length === 0) {
          this.changeValue(this.lastAcceptableValue);
        } else if (trimmedValue !== this.value) {
          this.changeValue(trimmedValue);
        }
      }
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        medium: this.medium,
        big: this.big,
        disabled: this.disabled,
        subtle: this.subtle,
        light: this.light,
        bare: this.bare
      };
    }
  }]);

  return UiTextInput;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "value", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "nonEmpty", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "selectAll", void 0);

__decorate([Prop({
  type: String,
  default: 'text'
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "type", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "autocomplete", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "debounce", void 0);

__decorate([Prop({
  type: Number,
  default: 500
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "debounceDuration", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "autofocus", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "bare", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "label", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "info", void 0);

__decorate([Prop({
  type: String,
  default: ''
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Array,
  default: null
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "errors", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "showAsterisk", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "medium", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "big", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiTextInputvue_type_script_lang_ts_UiTextInput.prototype, "subtle", void 0);

UiTextInputvue_type_script_lang_ts_UiTextInput = __decorate([vue_class_component_esm({
  components: {
    UiLabel: UiLabel_UiLabel,
    UiHints: UiHints_UiHints
  }
})], UiTextInputvue_type_script_lang_ts_UiTextInput);
/* harmony default export */ var UiTextInputvue_type_script_lang_ts_ = (UiTextInputvue_type_script_lang_ts_UiTextInput);
// CONCATENATED MODULE: ./src/components/UiTextInput/UiTextInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiTextInput_UiTextInputvue_type_script_lang_ts_ = (UiTextInputvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiTextInput/UiTextInput.vue?vue&type=style&index=0&id=62917763&lang=stylus&scoped=true&
var UiTextInputvue_type_style_index_0_id_62917763_lang_stylus_scoped_true_ = __webpack_require__("77f3");

// CONCATENATED MODULE: ./src/components/UiTextInput/UiTextInput.vue






/* normalize component */

var UiTextInput_component = normalizeComponent(
  UiTextInput_UiTextInputvue_type_script_lang_ts_,
  UiTextInputvue_type_template_id_62917763_scoped_true_lang_pug_render,
  UiTextInputvue_type_template_id_62917763_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "62917763",
  null
  
)

/* harmony default export */ var UiTextInput_UiTextInput = (UiTextInput_component.exports);
// CONCATENATED MODULE: ./src/components/UiTextInput/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiEmptyState/UiEmptyState.vue?vue&type=template&id=a52249aa&scoped=true&lang=pug&
var UiEmptyStatevue_type_template_id_a52249aa_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-empty-state",class:_vm.classes},[(_vm.icon)?_c('ui-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"light":_vm.light,"big":!_vm.small && !_vm.huge,"huge":_vm.huge}}):_vm._e(),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),(_vm.$slots.default)?_c('div',{staticClass:"slot-container"},[_vm._t("default")],2):_vm._e()],1)}
var UiEmptyStatevue_type_template_id_a52249aa_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiEmptyState/UiEmptyState.vue?vue&type=template&id=a52249aa&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiEmptyState/UiEmptyState.vue?vue&type=script&lang=ts&











var UiEmptyStatevue_type_script_lang_ts_UiEmptyState =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiEmptyState, _Vue);

  function UiEmptyState() {
    _classCallCheck(this, UiEmptyState);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiEmptyState).apply(this, arguments));
  }

  _createClass(UiEmptyState, [{
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'small': this.small,
        'huge': this.huge,
        'light': this.light,
        'subtle': this.subtle,
        'fill': this.fill
      };
    }
  }]);

  return UiEmptyState;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "icon", void 0);

__decorate([Prop({
  type: String,
  required: true
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "message", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "description", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "small", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "huge", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "subtle", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState.prototype, "fill", void 0);

UiEmptyStatevue_type_script_lang_ts_UiEmptyState = __decorate([vue_class_component_esm({
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiEmptyStatevue_type_script_lang_ts_UiEmptyState);
/* harmony default export */ var UiEmptyStatevue_type_script_lang_ts_ = (UiEmptyStatevue_type_script_lang_ts_UiEmptyState);
// CONCATENATED MODULE: ./src/components/UiEmptyState/UiEmptyState.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiEmptyState_UiEmptyStatevue_type_script_lang_ts_ = (UiEmptyStatevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiEmptyState/UiEmptyState.vue?vue&type=style&index=0&id=a52249aa&lang=stylus&scoped=true&
var UiEmptyStatevue_type_style_index_0_id_a52249aa_lang_stylus_scoped_true_ = __webpack_require__("7f1b");

// CONCATENATED MODULE: ./src/components/UiEmptyState/UiEmptyState.vue






/* normalize component */

var UiEmptyState_component = normalizeComponent(
  UiEmptyState_UiEmptyStatevue_type_script_lang_ts_,
  UiEmptyStatevue_type_template_id_a52249aa_scoped_true_lang_pug_render,
  UiEmptyStatevue_type_template_id_a52249aa_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "a52249aa",
  null
  
)

/* harmony default export */ var UiEmptyState_UiEmptyState = (UiEmptyState_component.exports);
// CONCATENATED MODULE: ./src/components/UiEmptyState/index.ts

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("f7fe");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiMenu/UiMenu.vue?vue&type=script&lang=ts&





























var UiMenuvue_type_script_lang_ts_UiMenu =
/*#__PURE__*/
function (_Mixins) {
  _inherits(UiMenu, _Mixins);

  function UiMenu() {
    var _this;

    _classCallCheck(this, UiMenu);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiMenu).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.filterText = '';
    _this.visibleOptionCount = 20;
    _this.debouncedEmitFilterText = lodash_debounce_default()(_this.emitFilterText, 300);
    _this.createListItem = Symbol();
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiMenu, [{
    key: "mounted",
    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////
    value: function mounted() {
      var _this2 = this;

      if (this.visible) {
        this.$nextTick(function () {
          _this2.focusSearchInput();
        });
      }
    } ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onChangeFilterText",
    value: function onChangeFilterText(filterText) {
      return regeneratorRuntime.async(function onChangeFilterText$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (filterText.length === 0) this.$v.$reset();

              if (!this.async) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", this.debouncedEmitFilterText());

            case 5:
              this.emitFilterText();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "onChangeVisible",
    value: function onChangeVisible(visible) {
      var _this3 = this;

      if (visible) {
        this.focusSearchInput();
      } else {
        setTimeout(function () {
          _this3.filterText = '';
        }, 100);
      }
    } ////////////////////////////////////////////////////////////////
    // data getters
    ////////////////////////////////////////////////////////////////

  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option) {
      var selectedOptionValues = this.selectedOptions.map(this.getOptionValue);
      return selectedOptionValues.includes(this.getOptionValue(option));
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

  }, {
    key: "emitFilterText",
    value: function emitFilterText() {
      this.$emit('filter', this.filterText);
    }
  }, {
    key: "getOptionClasses",
    value: function getOptionClasses(option) {
      return {
        'selected': this.isOptionSelected(option),
        'disabled': this.isOptionDisabled(option)
      };
    }
  }, {
    key: "focusSearchInput",
    value: function focusSearchInput() {
      var searchInputParent = this.$refs.searchInput;
      if (!searchInputParent) return;
      var searchInput = searchInputParent.$refs.input; // Wait until search input is able to be focused.

      setTimeout(function () {
        searchInput.focus();
      }, 200);
    } ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onClickOption",
    value: function onClickOption(option) {
      this.$emit('select', option);
    }
  }, {
    key: "onPressEscape",
    value: function onPressEscape() {
      this.$emit('close');
    }
  }, {
    key: "onCreate",
    value: function onCreate() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        this.$emit('create', this.filterText);
      }
    } ////////////////////////////////////////////////////////////////
    // pagination mixin
    ////////////////////////////////////////////////////////////////

  }, {
    key: "getPaginatedElement",
    value: function getPaginatedElement() {
      return this.$refs.list && this.$refs.list.$el;
    }
  }, {
    key: "filteredOptions",
    get: function get() {
      var _this4 = this;

      var filteredOptions = function () {
        if (!_this4.filterable) return _this4.options;
        if (_this4.filterable && _this4.async) return _this4.options;

        if (_this4.filterable && !_this4.async) {
          if (_this4.options === null) return [];
          return _this4.options.filter(function (option) {
            if (!_this4.getOptionFilterKey(option)) return false;

            var filterKey = _this4.getOptionFilterKey(option).toLowerCase();

            var filterText = _this4.filterText.toLowerCase();

            return filterKey.includes(filterText);
          });
        }

        return [];
      }();

      if (this.creatable && this.filterText.length > 0) return [this.createListItem].concat(_toConsumableArray(filteredOptions));
      return filteredOptions;
    }
  }, {
    key: "errorMessages",
    get: function get() {
      return {
        filterText: this.textInputErrorMessages
      };
    }
  }, {
    key: "itemsToPaginate",
    get: function get() {
      return this.filteredOptions;
    }
  }, {
    key: "shouldPaginate",
    get: function get() {
      return this.filterText.length === 0;
    }
  }]);

  return UiMenu;
}(mixins(mixin_scrolling_pagination, mixin_validation_client, lib["validationMixin"]));

__decorate([Model('change', {
  validator: function validator() {
    return true;
  },
  default: function _default() {
    return [];
  }
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "selectedOptions", void 0);

__decorate([Prop({
  type: Array,
  required: true
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "options", void 0);

__decorate([Prop({
  type: Function,
  required: true
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "getOptionValue", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return false;
  }
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "isOptionDisabled", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "getOptionFilterKey", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "async", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "filterable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "creatable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "visible", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "createHint", void 0);

__decorate([Prop({
  type: String,
  default: ''
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "textInputPlaceholder", void 0);

__decorate([Prop({
  type: Object,
  default: function _default() {
    return {};
  }
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "textInputValidations", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "textInputErrorMessages", void 0);

__decorate([Watch('filterText')], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "onChangeFilterText", null);

__decorate([Watch('visible')], UiMenuvue_type_script_lang_ts_UiMenu.prototype, "onChangeVisible", null);

UiMenuvue_type_script_lang_ts_UiMenu = __decorate([vue_class_component_esm({
  components: {
    UiErrorWrapper: UiErrorWrapper_UiErrorWrapper,
    UiTextInput: UiTextInput_UiTextInput,
    UiList: UiList_UiList,
    UiListItem: UiListItem_UiListItem,
    UiIcon: UiIcon_UiIcon,
    UiEmptyState: UiEmptyState_UiEmptyState
  },
  validations: function validations() {
    var context = this;
    return {
      filterText: context.textInputValidations
    };
  }
})], UiMenuvue_type_script_lang_ts_UiMenu);
/* harmony default export */ var UiMenuvue_type_script_lang_ts_ = (UiMenuvue_type_script_lang_ts_UiMenu);
// CONCATENATED MODULE: ./src/components/UiMenu/UiMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiMenu_UiMenuvue_type_script_lang_ts_ = (UiMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiMenu/UiMenu.vue?vue&type=style&index=0&id=7a58c329&lang=stylus&scoped=true&
var UiMenuvue_type_style_index_0_id_7a58c329_lang_stylus_scoped_true_ = __webpack_require__("208a");

// CONCATENATED MODULE: ./src/components/UiMenu/UiMenu.vue






/* normalize component */

var UiMenu_component = normalizeComponent(
  UiMenu_UiMenuvue_type_script_lang_ts_,
  UiMenuvue_type_template_id_7a58c329_scoped_true_lang_pug_render,
  UiMenuvue_type_template_id_7a58c329_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "7a58c329",
  null
  
)

/* harmony default export */ var UiMenu_UiMenu = (UiMenu_component.exports);
// CONCATENATED MODULE: ./src/components/UiMenu/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropdown/UiDropdown.vue?vue&type=script&lang=ts&















var UiDropdownvue_type_script_lang_ts_UiDropdown =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiDropdown, _Vue);

  function UiDropdown() {
    var _this;

    _classCallCheck(this, UiDropdown);

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UiDropdown).apply(this, arguments)); ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    _this.open = false;
    _this.width = 0;
    return _this;
  } ////////////////////////////////////////////////////////////////
  // computed
  ////////////////////////////////////////////////////////////////


  _createClass(UiDropdown, [{
    key: "onChangeOpen",
    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////
    value: function onChangeOpen(open) {
      var _this2 = this;

      if (!open) {
        // Wait for exit transition to finish.
        setTimeout(function () {
          _this2.$emit('filter', '');
        }, 100);
      }
    }
  }, {
    key: "onChangeDisabled",
    value: function onChangeDisabled(disabled) {
      this.open = false;
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

  }, {
    key: "updatePopoverWidth",
    value: function updatePopoverWidth() {
      this.width = getPixelsAsRem(this.$refs.inputBox.clientWidth);
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      this.open = !this.open;
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.open = false;
    } ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onClickInputBox",
    value: function onClickInputBox() {
      if (this.disabled) return;
      this.updatePopoverWidth();
      this.toggleDropdown();
    }
  }, {
    key: "onSelect",
    value: function onSelect(option) {
      this.$emit('select', option);
      this.closeDropdown();
    }
  }, {
    key: "classes",
    get: function get() {
      return {
        'enabled': !this.disabled,
        'disabled': this.disabled,
        'light': this.light
      };
    }
  }, {
    key: "tooltipOptions",
    get: function get() {
      return {
        content: this.tooltip,
        placement: 'top'
      };
    }
  }, {
    key: "somethingSelected",
    get: function get() {
      return this.selectedOption !== null;
    }
  }, {
    key: "showClearButton",
    get: function get() {
      return this.clearable && (this.alwaysClearable || this.somethingSelected);
    }
  }, {
    key: "showRemoveButton",
    get: function get() {
      return this.removable && this.somethingSelected;
    }
  }, {
    key: "showCreateButton",
    get: function get() {
      return this.creatable;
    }
  }, {
    key: "showEditButton",
    get: function get() {
      return this.editable && this.somethingSelected;
    }
  }, {
    key: "showAnyButtons",
    get: function get() {
      return this.showClearButton || this.showRemoveButton || this.showCreateButton || this.showEditButton;
    }
  }]);

  return UiDropdown;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Model('select', {
  validator: function validator() {
    return true;
  },
  default: null
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "selectedOption", void 0);

__decorate([Prop({
  type: Array,
  required: true
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "options", void 0);

__decorate([Prop({
  type: Function,
  required: true
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "getOptionValue", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return false;
  }
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "isOptionDisabled", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return function () {
      return null;
    };
  }
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "getOptionFilterKey", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "async", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "filterable", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "label", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "showAsterisk", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "tooltip", void 0);

__decorate([Prop({
  type: Array,
  default: null
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "errors", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "light", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "clearable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "alwaysClearable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "removable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "creatable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "editable", void 0);

__decorate([Watch('open')], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "onChangeOpen", null);

__decorate([Watch('disabled')], UiDropdownvue_type_script_lang_ts_UiDropdown.prototype, "onChangeDisabled", null);

UiDropdownvue_type_script_lang_ts_UiDropdown = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  },
  components: {
    UiLabel: UiLabel_UiLabel,
    UiIcon: UiIcon_UiIcon,
    UiIconButton: UiIconButton,
    UiMenu: UiMenu_UiMenu,
    UiHints: UiHints_UiHints,
    VPopover: v_tooltip_esm["b" /* VPopover */]
  }
})], UiDropdownvue_type_script_lang_ts_UiDropdown);
/* harmony default export */ var UiDropdownvue_type_script_lang_ts_ = (UiDropdownvue_type_script_lang_ts_UiDropdown);
// CONCATENATED MODULE: ./src/components/UiDropdown/UiDropdown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiDropdown_UiDropdownvue_type_script_lang_ts_ = (UiDropdownvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiDropdown/UiDropdown.vue?vue&type=style&index=0&id=1a183058&lang=stylus&scoped=true&
var UiDropdownvue_type_style_index_0_id_1a183058_lang_stylus_scoped_true_ = __webpack_require__("280f");

// CONCATENATED MODULE: ./src/components/UiDropdown/UiDropdown.vue






/* normalize component */

var UiDropdown_component = normalizeComponent(
  UiDropdown_UiDropdownvue_type_script_lang_ts_,
  UiDropdownvue_type_template_id_1a183058_scoped_true_lang_pug_render,
  UiDropdownvue_type_template_id_1a183058_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "1a183058",
  null
  
)

/* harmony default export */ var UiDropdown_UiDropdown = (UiDropdown_component.exports);
// CONCATENATED MODULE: ./src/components/UiDropdown/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiEmojiPicker/UiEmojiPicker.vue?vue&type=template&id=1ac18318&scoped=true&lang=pug&
var UiEmojiPickervue_type_template_id_1ac18318_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"placement":_vm.placement,"boundariesElement":"viewport","open":_vm.open,"data-test-id":"popover"},on:{"update:open":function($event){return _vm.$emit('update:open', $event)}}},[_c('ui-icon-button',{attrs:{"icon":"emoticon-outline","label":"Emoji picker","showLabel":false}}),_c('div',{ref:"picker",staticClass:"emoji-picker-container",attrs:{"slot":"popover"},slot:"popover"},[_c('div',{staticClass:"emoji-picker"},[_c('ui-button-collection',{attrs:{"buttons":_vm.categories,"getButtonValue":function (category) { return category.name; },"getButtonLabel":function (category) { return category.name; },"selectedButtonValues":[_vm.category],"data-test-id":"tabs"},on:{"click":_vm.onClickCategory}}),_c('div',{staticClass:"emoji-list"},_vm._l((_vm.emojisToDisplay),function(emoji,index){return _c('ui-button',{key:index,staticClass:"emoji",attrs:{"label":emoji.emoji,"subtle":"","data-test-id":emoji.emoji === '😀' ? 'emoji-button:smile' : undefined},on:{"click":function($event){return _vm.onClickEmoji(emoji.emoji)}}})}),1)],1)])],1)}
var UiEmojiPickervue_type_template_id_1ac18318_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiEmojiPicker/UiEmojiPicker.vue?vue&type=template&id=1ac18318&scoped=true&lang=pug&

// EXTERNAL MODULE: ./src/assets/emoji.json
var emoji = __webpack_require__("914f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiEmojiPicker/UiEmojiPicker.vue?vue&type=script&lang=ts&














var ORDERED_CATEGORY_NAMES = ['People', 'Nature', 'Foods', 'Activity', 'Places', 'Objects', 'Symbols', 'Flags'];

var UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker =
/*#__PURE__*/
function (_Mixins) {
  _inherits(UiEmojiPicker, _Mixins);

  function UiEmojiPicker() {
    _classCallCheck(this, UiEmojiPicker);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiEmojiPicker).apply(this, arguments));
  }

  _createClass(UiEmojiPicker, [{
    key: "onClickEmoji",
    ////////////////////////////////////////////////////////////////
    // methods → event handlers
    ////////////////////////////////////////////////////////////////
    value: function onClickEmoji(emoji) {
      this.$emit('input', emoji);
    }
  }, {
    key: "onClickCategory",
    value: function onClickCategory(category) {
      this.$emit('update:category', category);
      this.resetPagination();
    } ////////////////////////////////////////////////////////////////
    // mixin → scrolling pagination
    ////////////////////////////////////////////////////////////////

  }, {
    key: "getPaginatedElement",
    value: function getPaginatedElement() {
      return this.$refs.picker;
    }
  }, {
    key: "categories",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return [{
        name: 'People',
        icon: 'emoticon-outline',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'People';
        })
      }, {
        name: 'Nature',
        icon: 'flower',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Nature';
        })
      }, {
        name: 'Foods',
        icon: 'silverware-fork-knife',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Foods';
        })
      }, {
        name: 'Activity',
        icon: 'basketball',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Activity';
        })
      }, {
        name: 'Places',
        icon: 'city',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Places';
        })
      }, {
        name: 'Objects',
        icon: 'bell',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Objects';
        })
      }, {
        name: 'Symbols',
        icon: 'rhombus',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Symbols';
        })
      }, {
        name: 'Flags',
        icon: 'flag',
        emojis: emoji.filter(function (emoji) {
          return emoji.category === 'Flags';
        })
      }];
    }
  }, {
    key: "emojis",
    get: function get() {
      var _this = this;

      return emoji.filter(function (emoji) {
        return emoji.category === _this.category;
      });
    }
  }, {
    key: "itemsToPaginate",
    get: function get() {
      return this.emojis;
    }
  }, {
    key: "itemsPerPage",
    get: function get() {
      return 80;
    }
  }, {
    key: "emojisToDisplay",
    get: function get() {
      return this.paginatedItems;
    }
  }]);

  return UiEmojiPicker;
}(mixins(mixin_scrolling_pagination));

__decorate([Prop({
  type: String,
  default: ORDERED_CATEGORY_NAMES[0]
})], UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker.prototype, "category", void 0);

__decorate([Prop({
  type: String,
  default: 'top'
})], UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker.prototype, "placement", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker.prototype, "open", void 0);

UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker = __decorate([vue_class_component_esm({
  components: {
    UiButtonCollection: UiButtonCollection_UiButtonCollection,
    UiIconButton: UiIconButton,
    UiButton: UiButton_UiButton,
    VPopover: v_tooltip_esm["b" /* VPopover */]
  }
})], UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker);
/* harmony default export */ var UiEmojiPickervue_type_script_lang_ts_ = (UiEmojiPickervue_type_script_lang_ts_UiEmojiPicker);
// CONCATENATED MODULE: ./src/components/UiEmojiPicker/UiEmojiPicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiEmojiPicker_UiEmojiPickervue_type_script_lang_ts_ = (UiEmojiPickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiEmojiPicker/UiEmojiPicker.vue?vue&type=style&index=0&id=1ac18318&lang=stylus&scoped=true&
var UiEmojiPickervue_type_style_index_0_id_1ac18318_lang_stylus_scoped_true_ = __webpack_require__("3ee8");

// CONCATENATED MODULE: ./src/components/UiEmojiPicker/UiEmojiPicker.vue






/* normalize component */

var UiEmojiPicker_component = normalizeComponent(
  UiEmojiPicker_UiEmojiPickervue_type_script_lang_ts_,
  UiEmojiPickervue_type_template_id_1ac18318_scoped_true_lang_pug_render,
  UiEmojiPickervue_type_template_id_1ac18318_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "1ac18318",
  null
  
)

/* harmony default export */ var UiEmojiPicker_UiEmojiPicker = (UiEmojiPicker_component.exports);
// CONCATENATED MODULE: ./src/components/UiEmojiPicker/index.ts

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("9911");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLink/UiLink.vue?vue&type=script&lang=ts&








var UiLinkvue_type_script_lang_ts_UiLink =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiLink, _Vue);

  function UiLink() {
    _classCallCheck(this, UiLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiLink).apply(this, arguments));
  }

  _createClass(UiLink, [{
    key: "render",
    ////////////////////////////////////////////////////////////////
    // render
    ////////////////////////////////////////////////////////////////
    value: function render(h) {
      var _this = this;

      // @ts-ignore
      if (this.$router && this.route) {
        return h('router-link', {
          class: this.classes,
          props: {
            to: this.route
          },
          nativeOn: {
            click: function click() {
              _this.$emit('click');
            }
          }
        }, [this.$slots.default]);
      } else {
        return h('a', {
          class: this.classes,
          on: {
            click: function click() {
              _this.$emit('click');
            }
          }
        }, [this.$slots.default]);
      }
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return ['ui-link', {
        'light': this.light
      }];
    }
  }]);

  return UiLink;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Object,
  default: null
})], UiLinkvue_type_script_lang_ts_UiLink.prototype, "route", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLinkvue_type_script_lang_ts_UiLink.prototype, "light", void 0);

UiLinkvue_type_script_lang_ts_UiLink = __decorate([vue_class_component_esm], UiLinkvue_type_script_lang_ts_UiLink);
/* harmony default export */ var UiLinkvue_type_script_lang_ts_ = (UiLinkvue_type_script_lang_ts_UiLink);
// CONCATENATED MODULE: ./src/components/UiLink/UiLink.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiLink_UiLinkvue_type_script_lang_ts_ = (UiLinkvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiLink/UiLink.vue?vue&type=style&index=0&id=a9ae3514&lang=stylus&scoped=true&
var UiLinkvue_type_style_index_0_id_a9ae3514_lang_stylus_scoped_true_ = __webpack_require__("634b");

// CONCATENATED MODULE: ./src/components/UiLink/UiLink.vue
var UiLink_render, UiLink_staticRenderFns





/* normalize component */

var UiLink_component = normalizeComponent(
  UiLink_UiLinkvue_type_script_lang_ts_,
  UiLink_render,
  UiLink_staticRenderFns,
  false,
  null,
  "a9ae3514",
  null
  
)

/* harmony default export */ var UiLink_UiLink = (UiLink_component.exports);
// CONCATENATED MODULE: ./src/components/UiLink/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiFormattedText/UiFormattedText.vue?vue&type=script&lang=tsx&












function UiFormattedTextvue_type_script_lang_tsx_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function UiFormattedTextvue_type_script_lang_tsx_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UiFormattedTextvue_type_script_lang_tsx_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UiFormattedTextvue_type_script_lang_tsx_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var UiFormattedText = {
  functional: true,
  render: function render(h, context) {
    var textElements = [];
    var _context$props = context.props,
        text = _context$props.text,
        light = _context$props.light,
        truncate = _context$props.truncate,
        _context$props$maxCha = _context$props.maxCharacters,
        maxCharacters = _context$props$maxCha === void 0 ? 100 : _context$props$maxCha;
    var shouldTruncateAllItems = truncate;
    var charactersRemaining = maxCharacters;
    var lastItemEndsWithEllipsis = false;
    text.forEach(function (item, index) {
      if (shouldTruncateAllItems && charactersRemaining <= 0) return;
      if (!item) return;

      if (item.break) {
        textElements.push(h("br"));
      }

      if (!item.text) return; // Insert whitespace.
      else if (index !== 0) {
          if (text.length > 0 && !'.,?!:'.includes(item.text[0])) {
            textElements.push(' ');
          }
        } // Insert text.

      if (text) {
        var MAX_TRUNCATED_STRING_LENGTH = 100;
        var surroundWithSingleQuotes = !!item.title;
        var surroundWithDoubleQuotes = !!item.quote;
        var showEllipsis = item.truncate && text.length > MAX_TRUNCATED_STRING_LENGTH;

        var textToDisplay = function () {
          var textToDisplay = function () {
            if (item.truncate) return item.text.substring(0, MAX_TRUNCATED_STRING_LENGTH);else return item.text;
          }();

          textToDisplay = function () {
            if (shouldTruncateAllItems) return item.text.substring(0, charactersRemaining);
            return textToDisplay;
          }();

          textToDisplay = function () {
            if (showEllipsis) return "".concat(textToDisplay, "...");
            return textToDisplay;
          }();

          textToDisplay = function () {
            if (surroundWithSingleQuotes) return "'".concat(textToDisplay, "'");else if (surroundWithDoubleQuotes) return "\"".concat(textToDisplay, "\"");
            return textToDisplay;
          }();

          return textToDisplay;
        }();

        if (shouldTruncateAllItems) {
          charactersRemaining -= textToDisplay.length;

          if (charactersRemaining <= 0 && showEllipsis && !surroundWithSingleQuotes && !surroundWithDoubleQuotes) {
            lastItemEndsWithEllipsis = true;
          }
        }

        var _classes = {
          emphasise: item.emphasise || item.name || item.title,
          'no-break': item.doNotBreak || name,
          'success': item.success,
          'danger': item.danger,
          'warning': item.warning,
          'subtle': item.subtle,
          'primary': item.primary,
          'default-color': !item.success && !item.danger && !item.warning && !item.subtle && !item.primary
        };

        if (item.link || item.route) {
          var props = {
            route: item.route
          };
          var attrs = item.link;

          var clickHandler = function clickHandler() {
            var clickLinkListener = context.listeners['click-link'];

            if (Array.isArray(clickLinkListener) || !clickLinkListener) {
              return;
            }

            clickLinkListener();
          }; // @ts-ignore


          textElements.push(h(UiLink_UiLink, {
            "class": _classes,
            "attrs": UiFormattedTextvue_type_script_lang_tsx_objectSpread({
              "light": light
            }, attrs),
            "props": UiFormattedTextvue_type_script_lang_tsx_objectSpread({}, props),
            "on": {
              "click": clickHandler
            }
          }, [textToDisplay]));
        } else if (item.code) {
          textElements.push(h("pre", [textToDisplay]));
        } else {
          textElements.push(h("span", {
            "class": _classes
          }, [textToDisplay]));
        }
      }
    });

    if (shouldTruncateAllItems && charactersRemaining <= 0 && !lastItemEndsWithEllipsis) {
      textElements.push(h("span", ["..."]));
    }

    var classes = {
      'ui-formatted-text': true,
      'light': light
    };
    return h("div", {
      "class": classes
    }, [textElements]);
  }
};
/* harmony default export */ var UiFormattedTextvue_type_script_lang_tsx_ = (UiFormattedText);
// CONCATENATED MODULE: ./src/components/UiFormattedText/UiFormattedText.vue?vue&type=script&lang=tsx&
 /* harmony default export */ var UiFormattedText_UiFormattedTextvue_type_script_lang_tsx_ = (UiFormattedTextvue_type_script_lang_tsx_); 
// EXTERNAL MODULE: ./src/components/UiFormattedText/UiFormattedText.vue?vue&type=style&index=0&id=0479b597&lang=stylus&scoped=true&
var UiFormattedTextvue_type_style_index_0_id_0479b597_lang_stylus_scoped_true_ = __webpack_require__("1333");

// CONCATENATED MODULE: ./src/components/UiFormattedText/UiFormattedText.vue
var UiFormattedText_render, UiFormattedText_staticRenderFns





/* normalize component */

var UiFormattedText_component = normalizeComponent(
  UiFormattedText_UiFormattedTextvue_type_script_lang_tsx_,
  UiFormattedText_render,
  UiFormattedText_staticRenderFns,
  false,
  null,
  "0479b597",
  null
  
)

/* harmony default export */ var UiFormattedText_UiFormattedText = (UiFormattedText_component.exports);
// CONCATENATED MODULE: ./src/components/UiFormattedText/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLabelWrapper/UiLabelWrapper.vue?vue&type=template&id=3f42f04c&lang=pug&
var UiLabelWrappervue_type_template_id_3f42f04c_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-label-wrapper"},[_c('ui-label',_vm._b({},'ui-label',_vm.$attrs,false)),_vm._t("default")],2)}
var UiLabelWrappervue_type_template_id_3f42f04c_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiLabelWrapper/UiLabelWrapper.vue?vue&type=template&id=3f42f04c&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLabelWrapper/UiLabelWrapper.vue?vue&type=script&lang=ts&








var UiLabelWrappervue_type_script_lang_ts_UiLabelWrapper =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiLabelWrapper, _Vue);

  function UiLabelWrapper() {
    _classCallCheck(this, UiLabelWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiLabelWrapper).apply(this, arguments));
  }

  return UiLabelWrapper;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

UiLabelWrappervue_type_script_lang_ts_UiLabelWrapper = __decorate([vue_class_component_esm({
  components: {
    UiLabel: UiLabel_UiLabel
  }
})], UiLabelWrappervue_type_script_lang_ts_UiLabelWrapper);
/* harmony default export */ var UiLabelWrappervue_type_script_lang_ts_ = (UiLabelWrappervue_type_script_lang_ts_UiLabelWrapper);
// CONCATENATED MODULE: ./src/components/UiLabelWrapper/UiLabelWrapper.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiLabelWrapper_UiLabelWrappervue_type_script_lang_ts_ = (UiLabelWrappervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiLabelWrapper/UiLabelWrapper.vue





/* normalize component */

var UiLabelWrapper_component = normalizeComponent(
  UiLabelWrapper_UiLabelWrappervue_type_script_lang_ts_,
  UiLabelWrappervue_type_template_id_3f42f04c_lang_pug_render,
  UiLabelWrappervue_type_template_id_3f42f04c_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiLabelWrapper_UiLabelWrapper = (UiLabelWrapper_component.exports);
// CONCATENATED MODULE: ./src/components/UiLabelWrapper/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLoadingOverlay/UiLoadingOverlay.vue?vue&type=template&id=ab521812&scoped=true&lang=pug&
var UiLoadingOverlayvue_type_template_id_ab521812_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"ui-loading-overlay",class:_vm.$props},[_vm._t("default",[_c('ui-icon',{staticClass:"default-icon",attrs:{"subtle":"","icon":"loading","spinning":"","huge":""}})])],2):_vm._e()])}
var UiLoadingOverlayvue_type_template_id_ab521812_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiLoadingOverlay/UiLoadingOverlay.vue?vue&type=template&id=ab521812&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLoadingOverlay/UiLoadingOverlay.vue?vue&type=script&lang=ts&








var UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiLoadingOverlay, _Vue);

  function UiLoadingOverlay() {
    _classCallCheck(this, UiLoadingOverlay);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiLoadingOverlay).apply(this, arguments));
  }

  return UiLoadingOverlay;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: Boolean,
  required: true
})], UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay.prototype, "loading", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay.prototype, "opaque", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay.prototype, "aboveOverlay", void 0);

UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay = __decorate([vue_class_component_esm({
  components: {
    UiIcon: UiIcon_UiIcon
  }
})], UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay);
/* harmony default export */ var UiLoadingOverlayvue_type_script_lang_ts_ = (UiLoadingOverlayvue_type_script_lang_ts_UiLoadingOverlay);
// CONCATENATED MODULE: ./src/components/UiLoadingOverlay/UiLoadingOverlay.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiLoadingOverlay_UiLoadingOverlayvue_type_script_lang_ts_ = (UiLoadingOverlayvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiLoadingOverlay/UiLoadingOverlay.vue?vue&type=style&index=0&id=ab521812&lang=stylus&scoped=true&
var UiLoadingOverlayvue_type_style_index_0_id_ab521812_lang_stylus_scoped_true_ = __webpack_require__("6d6a");

// CONCATENATED MODULE: ./src/components/UiLoadingOverlay/UiLoadingOverlay.vue






/* normalize component */

var UiLoadingOverlay_component = normalizeComponent(
  UiLoadingOverlay_UiLoadingOverlayvue_type_script_lang_ts_,
  UiLoadingOverlayvue_type_template_id_ab521812_scoped_true_lang_pug_render,
  UiLoadingOverlayvue_type_template_id_ab521812_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "ab521812",
  null
  
)

/* harmony default export */ var UiLoadingOverlay_UiLoadingOverlay = (UiLoadingOverlay_component.exports);
// CONCATENATED MODULE: ./src/components/UiLoadingOverlay/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiMultiSelect/UiMultiSelect.vue?vue&type=template&id=5f9db0f6&scoped=true&lang=pug&
var UiMultiSelectvue_type_template_id_5f9db0f6_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-multi-select"},[(_vm.label)?_c('ui-label',{attrs:{"label":_vm.label}}):_vm._e(),_c('ui-button-collection',{attrs:{"buttons":_vm.selectedOptions,"getButtonValue":_vm.getOptionValue,"disabled":_vm.disabled,"showAddButton":!_vm.readOnly,"alwaysShowColor":true,"data-test-id":"multi-select:button-collection"},scopedSlots:_vm._u([{key:"button",fn:function(ref){
var button = ref.button;
var styleObject = ref.styleObject;
return [_c('v-popover',{style:(styleObject),attrs:{"placement":"bottom-start"},scopedSlots:_vm._u([(!_vm.disabled && !_vm.readOnly)?{key:"popover",fn:function(){return [_c('ui-menu',{directives:[{name:"close-popover",rawName:"v-close-popover"}],attrs:{"options":_vm.editMenuOptions,"getOptionValue":function (option) { return option.title; },"data-test-id":"multi-select:remove-menu"},on:{"select":function($event){return _vm.onSelectEditMenuOption($event, button)}},scopedSlots:_vm._u([{key:"text",fn:function(ref){
var option = ref.option;
return [_vm._v(_vm._s(option.title))]}},{key:"icon",fn:function(ref){
var option = ref.option;
return [_c('ui-icon',{attrs:{"icon":option.icon,"small":""}})]}}],null,true)})]},proxy:true}:null],null,true)},[_vm._t("item",[_c('ui-pill-button',{style:(_vm.itemStyle),attrs:{"label":_vm.getOptionTitle(button),"color":_vm.getOptionColor(button),"disabled":_vm.disabled,"readOnly":_vm.readOnly,"tooltip":_vm.tooltip}})],{"item":button,"styleObject":_vm.itemStyle})],2)]}},(!_vm.disabled && !_vm.readOnly)?{key:"add-menu",fn:function(ref){
var open = ref.open;
var closePopover = ref.closePopover;
return [_c('ui-menu',{attrs:{"options":_vm.optionsToDisplay,"getOptionValue":_vm.getOptionValue,"visible":open,"filterable":_vm.filterable,"creatable":_vm.creatable,"createHint":_vm.createHint,"textInputPlaceholder":_vm.textInputPlaceholder,"textInputValidations":_vm.textInputValidations,"textInputErrorMessages":_vm.textInputErrorMessages,"data-test-id":"multi-select:add-menu"},on:{"select":function($event){_vm.onSelectAddMenuOption($event); closePopover()},"create":function($event){_vm.$emit('create', $event); closePopover()}},scopedSlots:_vm._u([{key:"text",fn:function(ref){
var option = ref.option;
return [_vm._t("text",null,{"option":option})]}},{key:"subtitle",fn:function(ref){
var option = ref.option;
return [_vm._t("subtitle",null,{"option":option})]}},{key:"icon",fn:function(ref){
var option = ref.option;
return [_vm._t("icon",null,{"option":option})]}}],null,true)})]}}:null],null,true)})],1)}
var UiMultiSelectvue_type_template_id_5f9db0f6_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiMultiSelect/UiMultiSelect.vue?vue&type=template&id=5f9db0f6&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiMultiSelect/UiMultiSelect.vue?vue&type=script&lang=ts&




















var UiMultiSelectvue_type_script_lang_ts_UiMultiSelect =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiMultiSelect, _Vue);

  function UiMultiSelect() {
    _classCallCheck(this, UiMultiSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiMultiSelect).apply(this, arguments));
  }

  _createClass(UiMultiSelect, [{
    key: "onSelectAddMenuOption",
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////
    value: function onSelectAddMenuOption(option) {
      this.$emit('change', [].concat(_toConsumableArray(this.selectedOptions), [option]));
      this.$emit('add', option);
    }
  }, {
    key: "onSelectEditMenuOption",
    value: function onSelectEditMenuOption(editMenuOption, optionToEdit) {
      editMenuOption.onSelect(optionToEdit);
    }
  }, {
    key: "selectedOptionValues",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return this.selectedOptions.map(this.getOptionValue);
    }
  }, {
    key: "optionsToDisplay",
    get: function get() {
      var _this = this;

      return this.options.filter(function (option) {
        return !_this.selectedOptionValues.includes(_this.getOptionValue(option));
      });
    }
  }, {
    key: "editMenuOptions",
    get: function get() {
      var _this2 = this;

      return [{
        title: 'Remove',
        icon: 'minus-circle',
        onSelect: function onSelect(optionToEdit) {
          var newSelectedOptions = _this2.selectedOptions.filter(function (option) {
            return _this2.getOptionValue(option) !== _this2.getOptionValue(optionToEdit);
          });

          _this2.$emit('change', newSelectedOptions);

          _this2.$emit('remove', optionToEdit);
        }
      }];
    }
  }, {
    key: "itemStyle",
    get: function get() {
      return {
        width: '100%'
      };
    }
  }]);

  return UiMultiSelect;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  type: String,
  default: null
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "label", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "options", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "selectedOptions", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "filterable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "creatable", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "readOnly", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "tooltip", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "getOptionValue", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "getOptionTitle", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "getOptionColor", void 0);

__decorate([Prop({
  type: String,
  default: ''
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "textInputPlaceholder", void 0);

__decorate([Prop({
  type: Object,
  default: function _default() {
    return {};
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "textInputValidations", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "textInputErrorMessages", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect.prototype, "createHint", void 0);

UiMultiSelectvue_type_script_lang_ts_UiMultiSelect = __decorate([vue_class_component_esm({
  directives: {
    'close-popover': v_tooltip_esm["a" /* VClosePopover */]
  },
  components: {
    UiButtonCollection: UiButtonCollection_UiButtonCollection,
    UiPillButton: UiPillButton,
    UiLabel: UiLabel_UiLabel,
    UiMenu: UiMenu_UiMenu,
    UiIcon: UiIcon_UiIcon,
    VPopover: v_tooltip_esm["b" /* VPopover */]
  }
})], UiMultiSelectvue_type_script_lang_ts_UiMultiSelect);
/* harmony default export */ var UiMultiSelectvue_type_script_lang_ts_ = (UiMultiSelectvue_type_script_lang_ts_UiMultiSelect);
// CONCATENATED MODULE: ./src/components/UiMultiSelect/UiMultiSelect.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiMultiSelect_UiMultiSelectvue_type_script_lang_ts_ = (UiMultiSelectvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/UiMultiSelect/UiMultiSelect.vue





/* normalize component */

var UiMultiSelect_component = normalizeComponent(
  UiMultiSelect_UiMultiSelectvue_type_script_lang_ts_,
  UiMultiSelectvue_type_template_id_5f9db0f6_scoped_true_lang_pug_render,
  UiMultiSelectvue_type_template_id_5f9db0f6_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "5f9db0f6",
  null
  
)

/* harmony default export */ var UiMultiSelect_UiMultiSelect = (UiMultiSelect_component.exports);
// CONCATENATED MODULE: ./src/components/UiMultiSelect/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiStepper/UiStepper.vue?vue&type=template&id=339cf9da&scoped=true&lang=pug&
var UiSteppervue_type_template_id_339cf9da_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-stepper",class:_vm.stepperClasses},[(_vm.label)?_c('ui-label',{attrs:{"label":_vm.label}}):_vm._e(),_c('div',{staticClass:"inputs"},[(!_vm.hideButtons)?_c('ui-icon-button',{attrs:{"icon":"minus-circle","label":("Add " + _vm.step + " to " + _vm.value),"data-test-id":"stepper:minus-button","tooltip":_vm.stepDownButtonTooltip,"disabled":_vm.stepDownButtonDisabled},on:{"click":_vm.stepDown}}):_vm._e(),_c('div',{staticClass:"numbers",class:_vm.numberClasses},[(_vm.numerator)?[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.numeratorTooltip),expression:"numeratorTooltip"}],staticClass:"numerator"},[_vm._v(_vm._s(_vm.numerator))]),_c('div',{staticClass:"forward-slash"},[_vm._v("/")])]:_vm._e(),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.valueToDisplay))]),(_vm.showChange)?_c('div',{staticClass:"change"},[_vm._v(_vm._s(_vm.changeText))]):_vm._e()],2),(!_vm.hideButtons)?_c('ui-icon-button',{attrs:{"icon":"plus-circle","data-test-id":"stepper:plus-button","label":("Minus " + _vm.step + " from " + _vm.value),"tooltip":_vm.stepUpButtonTooltip,"disabled":_vm.stepUpButtonDisabled},on:{"click":_vm.stepUp}}):_vm._e()],1)],1)}
var UiSteppervue_type_template_id_339cf9da_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiStepper/UiStepper.vue?vue&type=template&id=339cf9da&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiStepper/UiStepper.vue?vue&type=script&lang=ts&













var UiSteppervue_type_script_lang_ts_UiStepper =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiStepper, _Vue);

  function UiStepper() {
    _classCallCheck(this, UiStepper);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiStepper).apply(this, arguments));
  }

  _createClass(UiStepper, [{
    key: "stepUp",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function stepUp() {
      if (this.canStepUp) this.$emit('input', this.value + this.step);
    }
  }, {
    key: "stepDown",
    value: function stepDown() {
      if (this.canStepDown) this.$emit('input', this.value - this.step);
    }
  }, {
    key: "stepperClasses",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'align-to-center': this.alignToCenter
      };
    }
  }, {
    key: "numberClasses",
    get: function get() {
      return {
        'increase': this.changeAmount > 0,
        'decrease': this.changeAmount < 0,
        'denominator-less-than-numerator': this.numerator !== null && this.value < this.numerator,
        'has-numerator-tooltip': this.numeratorTooltip,
        'not-showing-change': !this.showChange
      };
    }
  }, {
    key: "valueToDisplay",
    get: function get() {
      if (this.initialValue !== null && this.showChange) return this.initialValue;else return this.value;
    }
  }, {
    key: "changeAmount",
    get: function get() {
      return this.value - (this.initialValue || 0);
    }
  }, {
    key: "changeSign",
    get: function get() {
      if (this.changeAmount >= 0) return '+';else return '–';
    }
  }, {
    key: "changeText",
    get: function get() {
      if (this.initialValue === null || !this.showChange || this.changeAmount === 0) return null;
      return "".concat(this.changeSign, " ").concat(Math.abs(this.changeAmount));
    }
  }, {
    key: "canStepDown",
    get: function get() {
      return this.min === null || this.value - this.step >= this.min;
    }
  }, {
    key: "canStepUp",
    get: function get() {
      return this.max === null || this.value + this.step <= this.max;
    } ////////////////////////////////////////////////////////////////
    // computed → disabled
    ////////////////////////////////////////////////////////////////

  }, {
    key: "stepDownButtonDisabled",
    get: function get() {
      return this.disabled || !this.canStepDown;
    }
  }, {
    key: "stepUpButtonDisabled",
    get: function get() {
      return this.disabled || !this.canStepUp;
    } ////////////////////////////////////////////////////////////////
    // computed → button tooltips
    ////////////////////////////////////////////////////////////////

  }, {
    key: "stepDownButtonTooltip",
    get: function get() {
      return this.disabled && this.disabledTooltip || !this.canStepDown && this.minTooltip;
    }
  }, {
    key: "stepUpButtonTooltip",
    get: function get() {
      return this.disabled && this.disabledTooltip || !this.canStepUp && this.maxTooltip;
    }
  }]);

  return UiStepper;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Model('input', {
  type: Number,
  default: 0
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "value", void 0);

__decorate([Prop({
  type: Number,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "min", void 0);

__decorate([Prop({
  type: Number,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "max", void 0);

__decorate([Prop({
  type: Number,
  default: 1
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "step", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "label", void 0);

__decorate([Prop({
  type: Number,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "numerator", void 0);

__decorate([Prop({
  type: Number,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "initialValue", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "showChange", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "disabled", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "disabledTooltip", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "hideButtons", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "minTooltip", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "maxTooltip", void 0);

__decorate([Prop({
  type: String,
  default: null
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "numeratorTooltip", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSteppervue_type_script_lang_ts_UiStepper.prototype, "alignToCenter", void 0);

UiSteppervue_type_script_lang_ts_UiStepper = __decorate([vue_class_component_esm({
  directives: {
    'tooltip': v_tooltip_esm["c" /* VTooltip */]
  },
  components: {
    UiIconButton: UiIconButton,
    UiLabel: UiLabel_UiLabel
  }
})], UiSteppervue_type_script_lang_ts_UiStepper);
/* harmony default export */ var UiSteppervue_type_script_lang_ts_ = (UiSteppervue_type_script_lang_ts_UiStepper);
// CONCATENATED MODULE: ./src/components/UiStepper/UiStepper.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiStepper_UiSteppervue_type_script_lang_ts_ = (UiSteppervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiStepper/UiStepper.vue?vue&type=style&index=0&id=339cf9da&lang=stylus&scoped=true&
var UiSteppervue_type_style_index_0_id_339cf9da_lang_stylus_scoped_true_ = __webpack_require__("d674");

// CONCATENATED MODULE: ./src/components/UiStepper/UiStepper.vue






/* normalize component */

var UiStepper_component = normalizeComponent(
  UiStepper_UiSteppervue_type_script_lang_ts_,
  UiSteppervue_type_template_id_339cf9da_scoped_true_lang_pug_render,
  UiSteppervue_type_template_id_339cf9da_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "339cf9da",
  null
  
)

/* harmony default export */ var UiStepper_UiStepper = (UiStepper_component.exports);
// CONCATENATED MODULE: ./src/components/UiStepper/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSwitch/UiSwitch.vue?vue&type=template&id=5f65fa32&scoped=true&lang=pug&
var UiSwitchvue_type_template_id_5f65fa32_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-switch",class:_vm.classes,on:{"click":_vm.onClick}},[_vm._m(0),(_vm.$scopedSlots['label'])?_c('div',{staticClass:"label"},[_vm._t("label")],2):_vm._e()])}
var UiSwitchvue_type_template_id_5f65fa32_scoped_true_lang_pug_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-housing"},[_c('div',{staticClass:"switch-knob"})])}]


// CONCATENATED MODULE: ./src/components/UiSwitch/UiSwitch.vue?vue&type=template&id=5f65fa32&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSwitch/UiSwitch.vue?vue&type=script&lang=ts&









var UiSwitchvue_type_script_lang_ts_UiSwitch =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiSwitch, _Vue);

  function UiSwitch() {
    _classCallCheck(this, UiSwitch);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiSwitch).apply(this, arguments));
  }

  _createClass(UiSwitch, [{
    key: "onChangeDisabled",
    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////
    value: function onChangeDisabled() {
      if (this.disabled && this.switchOffWhenDisabled) {
        this.switchOff();
      }
    } ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

  }, {
    key: "switchOn",
    value: function switchOn() {
      this.$emit('input', true);
      this.$emit('switch:on');
    }
  }, {
    key: "switchOff",
    value: function switchOff() {
      this.$emit('input', false);
      this.$emit('switch:off');
    } ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

  }, {
    key: "onClick",
    value: function onClick() {
      if (this.disabled) return;
      this.value ? this.switchOff() : this.switchOn();
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'switched-on': this.value,
        'big': this.big,
        'disabled': this.disabled
      };
    }
  }]);

  return UiSwitch;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Model('input', {
  type: Boolean,
  default: false
})], UiSwitchvue_type_script_lang_ts_UiSwitch.prototype, "value", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSwitchvue_type_script_lang_ts_UiSwitch.prototype, "big", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSwitchvue_type_script_lang_ts_UiSwitch.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSwitchvue_type_script_lang_ts_UiSwitch.prototype, "switchOffWhenDisabled", void 0);

__decorate([Watch('disabled', {
  immediate: true
})], UiSwitchvue_type_script_lang_ts_UiSwitch.prototype, "onChangeDisabled", null);

UiSwitchvue_type_script_lang_ts_UiSwitch = __decorate([vue_class_component_esm], UiSwitchvue_type_script_lang_ts_UiSwitch);
/* harmony default export */ var UiSwitchvue_type_script_lang_ts_ = (UiSwitchvue_type_script_lang_ts_UiSwitch);
// CONCATENATED MODULE: ./src/components/UiSwitch/UiSwitch.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiSwitch_UiSwitchvue_type_script_lang_ts_ = (UiSwitchvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiSwitch/UiSwitch.vue?vue&type=style&index=0&id=5f65fa32&lang=stylus&scoped=true&
var UiSwitchvue_type_style_index_0_id_5f65fa32_lang_stylus_scoped_true_ = __webpack_require__("1685");

// CONCATENATED MODULE: ./src/components/UiSwitch/UiSwitch.vue






/* normalize component */

var UiSwitch_component = normalizeComponent(
  UiSwitch_UiSwitchvue_type_script_lang_ts_,
  UiSwitchvue_type_template_id_5f65fa32_scoped_true_lang_pug_render,
  UiSwitchvue_type_template_id_5f65fa32_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "5f65fa32",
  null
  
)

/* harmony default export */ var UiSwitch_UiSwitch = (UiSwitch_component.exports);
// CONCATENATED MODULE: ./src/components/UiSwitch/index.ts

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"29d2be31-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/pug-plain-loader!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSwitchList/UiSwitchList.vue?vue&type=template&id=fec25b6a&scoped=true&lang=pug&
var UiSwitchListvue_type_template_id_fec25b6a_scoped_true_lang_pug_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-switch-list",class:_vm.classes},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"switch"},[_vm._t("switch",null,{"value":_vm.values.includes(_vm.getOptionValue(option)),"option":option,"switchOn":function (value) { return _vm.switchOn(value || [ _vm.getOptionValue(option) ]); },"switchOff":function (value) { return _vm.switchOff(value || [ _vm.getOptionValue(option) ]); }})],2)}),0)}
var UiSwitchListvue_type_template_id_fec25b6a_scoped_true_lang_pug_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSwitchList/UiSwitchList.vue?vue&type=template&id=fec25b6a&scoped=true&lang=pug&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSwitchList/UiSwitchList.vue?vue&type=script&lang=ts&
















var UiSwitchListvue_type_script_lang_ts_UiSwitchList =
/*#__PURE__*/
function (_Vue) {
  _inherits(UiSwitchList, _Vue);

  function UiSwitchList() {
    _classCallCheck(this, UiSwitchList);

    return _possibleConstructorReturn(this, _getPrototypeOf(UiSwitchList).apply(this, arguments));
  }

  _createClass(UiSwitchList, [{
    key: "switchOn",
    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    value: function switchOn(values) {
      var _this = this;

      var newValues = values.filter(function (value) {
        return !_this.values.includes(value);
      });
      this.$emit('input', [].concat(_toConsumableArray(this.values), _toConsumableArray(newValues)));
    }
  }, {
    key: "switchOff",
    value: function switchOff(values) {
      this.$emit('input', this.values.filter(function (existing) {
        return !values.includes(existing);
      }));
    }
  }, {
    key: "classes",
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////
    get: function get() {
      return {
        'spacious': this.spacious
      };
    }
  }]);

  return UiSwitchList;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Model('input', {
  type: Array,
  default: function _default() {
    return [];
  }
})], UiSwitchListvue_type_script_lang_ts_UiSwitchList.prototype, "values", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], UiSwitchListvue_type_script_lang_ts_UiSwitchList.prototype, "options", void 0);

__decorate([Prop({
  type: Function,
  default: function _default() {
    return null;
  }
})], UiSwitchListvue_type_script_lang_ts_UiSwitchList.prototype, "getOptionValue", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], UiSwitchListvue_type_script_lang_ts_UiSwitchList.prototype, "spacious", void 0);

UiSwitchListvue_type_script_lang_ts_UiSwitchList = __decorate([vue_class_component_esm], UiSwitchListvue_type_script_lang_ts_UiSwitchList);
/* harmony default export */ var UiSwitchListvue_type_script_lang_ts_ = (UiSwitchListvue_type_script_lang_ts_UiSwitchList);
// CONCATENATED MODULE: ./src/components/UiSwitchList/UiSwitchList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UiSwitchList_UiSwitchListvue_type_script_lang_ts_ = (UiSwitchListvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/UiSwitchList/UiSwitchList.vue?vue&type=style&index=0&id=fec25b6a&lang=stylus&scoped=true&
var UiSwitchListvue_type_style_index_0_id_fec25b6a_lang_stylus_scoped_true_ = __webpack_require__("c359");

// CONCATENATED MODULE: ./src/components/UiSwitchList/UiSwitchList.vue






/* normalize component */

var UiSwitchList_component = normalizeComponent(
  UiSwitchList_UiSwitchListvue_type_script_lang_ts_,
  UiSwitchListvue_type_template_id_fec25b6a_scoped_true_lang_pug_render,
  UiSwitchListvue_type_template_id_fec25b6a_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "fec25b6a",
  null
  
)

/* harmony default export */ var UiSwitchList_UiSwitchList = (UiSwitchList_component.exports);
// CONCATENATED MODULE: ./src/components/UiSwitchList/index.ts

// CONCATENATED MODULE: ./src/components/index.ts

 // import '@/styles/theme/theme.styl'
// import '@mdi/font/css/materialdesignicons.min.css'






















































// CONCATENATED MODULE: ./src/index.ts


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js
/* concated harmony reexport config */__webpack_require__.d(__webpack_exports__, "config", function() { return src_config; });
/* concated harmony reexport UiBox */__webpack_require__.d(__webpack_exports__, "UiBox", function() { return UiBox_UiBox; });
/* concated harmony reexport UiWarningBox */__webpack_require__.d(__webpack_exports__, "UiWarningBox", function() { return UiWarningBox; });
/* concated harmony reexport UiButton */__webpack_require__.d(__webpack_exports__, "UiButton", function() { return UiButton_UiButton; });
/* concated harmony reexport UiCopyButton */__webpack_require__.d(__webpack_exports__, "UiCopyButton", function() { return UiCopyButton_UiCopyButton; });
/* concated harmony reexport UiIconButton */__webpack_require__.d(__webpack_exports__, "UiIconButton", function() { return UiIconButton; });
/* concated harmony reexport UiLoadMoreButton */__webpack_require__.d(__webpack_exports__, "UiLoadMoreButton", function() { return UiLoadMoreButton; });
/* concated harmony reexport UiPillButton */__webpack_require__.d(__webpack_exports__, "UiPillButton", function() { return UiPillButton; });
/* concated harmony reexport UiGrid */__webpack_require__.d(__webpack_exports__, "UiGrid", function() { return UiGrid_UiGrid; });
/* concated harmony reexport UiGridItem */__webpack_require__.d(__webpack_exports__, "UiGridItem", function() { return UiGridItem_UiGridItem; });
/* concated harmony reexport UiList */__webpack_require__.d(__webpack_exports__, "UiList", function() { return UiList_UiList; });
/* concated harmony reexport UiListItem */__webpack_require__.d(__webpack_exports__, "UiListItem", function() { return UiListItem_UiListItem; });
/* concated harmony reexport UiModal */__webpack_require__.d(__webpack_exports__, "UiModal", function() { return UiModal_UiModal; });
/* concated harmony reexport UiModalPortalTarget */__webpack_require__.d(__webpack_exports__, "UiModalPortalTarget", function() { return UiModalPortalTarget_UiModalPortalTarget; });
/* concated harmony reexport UiPullOutTab */__webpack_require__.d(__webpack_exports__, "UiPullOutTab", function() { return UiPullOutTab_UiPullOutTab; });
/* concated harmony reexport UiSidebar */__webpack_require__.d(__webpack_exports__, "UiSidebar", function() { return UiSidebar_UiSidebar; });
/* concated harmony reexport UiSidebarWrapper */__webpack_require__.d(__webpack_exports__, "UiSidebarWrapper", function() { return UiSidebarWrapper_UiSidebarWrapper; });
/* concated harmony reexport UiTable */__webpack_require__.d(__webpack_exports__, "UiTable", function() { return UiTable_UiTable; });
/* concated harmony reexport UiTableCellContent */__webpack_require__.d(__webpack_exports__, "UiTableCellContent", function() { return UiTableCellContent_UiTableCellContent; });
/* concated harmony reexport UiTableGroupHeader */__webpack_require__.d(__webpack_exports__, "UiTableGroupHeader", function() { return UiTableGroupHeader_UiTableGroupHeader; });
/* concated harmony reexport UiTableHeader */__webpack_require__.d(__webpack_exports__, "UiTableHeader", function() { return UiTableHeader_UiTableHeader; });
/* concated harmony reexport UiTableHeaderCellContent */__webpack_require__.d(__webpack_exports__, "UiTableHeaderCellContent", function() { return UiTableHeaderCellContent_UiTableHeaderCellContent; });
/* concated harmony reexport UiTableRow */__webpack_require__.d(__webpack_exports__, "UiTableRow", function() { return UiTableRow_UiTableRow; });
/* concated harmony reexport UiToast */__webpack_require__.d(__webpack_exports__, "UiToast", function() { return UiToast_UiToast; });
/* concated harmony reexport UiToastPortalTarget */__webpack_require__.d(__webpack_exports__, "UiToastPortalTarget", function() { return UiToastPortalTarget_UiToastPortalTarget; });
/* concated harmony reexport UiAvatar */__webpack_require__.d(__webpack_exports__, "UiAvatar", function() { return UiAvatar_UiAvatar; });
/* concated harmony reexport UiBadge */__webpack_require__.d(__webpack_exports__, "UiBadge", function() { return UiBadge_UiBadge; });
/* concated harmony reexport UiBar */__webpack_require__.d(__webpack_exports__, "UiBar", function() { return UiBar_UiBar; });
/* concated harmony reexport UiButtonCollection */__webpack_require__.d(__webpack_exports__, "UiButtonCollection", function() { return UiButtonCollection_UiButtonCollection; });
/* concated harmony reexport UiCard */__webpack_require__.d(__webpack_exports__, "UiCard", function() { return UiCard_UiCard; });
/* concated harmony reexport UiCode */__webpack_require__.d(__webpack_exports__, "UiCode", function() { return UiCode_UiCode; });
/* concated harmony reexport UiColorDot */__webpack_require__.d(__webpack_exports__, "UiColorDot", function() { return UiColorDot; });
/* concated harmony reexport UiCheckbox */__webpack_require__.d(__webpack_exports__, "UiCheckbox", function() { return UiCheckbox_UiCheckbox; });
/* concated harmony reexport UiDivider */__webpack_require__.d(__webpack_exports__, "UiDivider", function() { return UiDivider_UiDivider; });
/* concated harmony reexport UiDropdown */__webpack_require__.d(__webpack_exports__, "UiDropdown", function() { return UiDropdown_UiDropdown; });
/* concated harmony reexport UiEmojiPicker */__webpack_require__.d(__webpack_exports__, "UiEmojiPicker", function() { return UiEmojiPicker_UiEmojiPicker; });
/* concated harmony reexport UiEmptyState */__webpack_require__.d(__webpack_exports__, "UiEmptyState", function() { return UiEmptyState_UiEmptyState; });
/* concated harmony reexport UiErrorWrapper */__webpack_require__.d(__webpack_exports__, "UiErrorWrapper", function() { return UiErrorWrapper_UiErrorWrapper; });
/* concated harmony reexport UiFormattedText */__webpack_require__.d(__webpack_exports__, "UiFormattedText", function() { return UiFormattedText_UiFormattedText; });
/* concated harmony reexport UiHint */__webpack_require__.d(__webpack_exports__, "UiHint", function() { return UiHint_UiHint; });
/* concated harmony reexport UiHints */__webpack_require__.d(__webpack_exports__, "UiHints", function() { return UiHints_UiHints; });
/* concated harmony reexport UiIcon */__webpack_require__.d(__webpack_exports__, "UiIcon", function() { return UiIcon_UiIcon; });
/* concated harmony reexport UiLabel */__webpack_require__.d(__webpack_exports__, "UiLabel", function() { return UiLabel_UiLabel; });
/* concated harmony reexport UiLabelWrapper */__webpack_require__.d(__webpack_exports__, "UiLabelWrapper", function() { return UiLabelWrapper_UiLabelWrapper; });
/* concated harmony reexport UiLink */__webpack_require__.d(__webpack_exports__, "UiLink", function() { return UiLink_UiLink; });
/* concated harmony reexport UiLoadingOverlay */__webpack_require__.d(__webpack_exports__, "UiLoadingOverlay", function() { return UiLoadingOverlay_UiLoadingOverlay; });
/* concated harmony reexport UiMenu */__webpack_require__.d(__webpack_exports__, "UiMenu", function() { return UiMenu_UiMenu; });
/* concated harmony reexport UiMultiSelect */__webpack_require__.d(__webpack_exports__, "UiMultiSelect", function() { return UiMultiSelect_UiMultiSelect; });
/* concated harmony reexport UiProgress */__webpack_require__.d(__webpack_exports__, "UiProgress", function() { return UiProgress_UiProgress; });
/* concated harmony reexport UiStatusIcon */__webpack_require__.d(__webpack_exports__, "UiStatusIcon", function() { return UiStatusIcon_UiStatusIcon; });
/* concated harmony reexport UiStepper */__webpack_require__.d(__webpack_exports__, "UiStepper", function() { return UiStepper_UiStepper; });
/* concated harmony reexport UiSwitch */__webpack_require__.d(__webpack_exports__, "UiSwitch", function() { return UiSwitch_UiSwitch; });
/* concated harmony reexport UiSwitchList */__webpack_require__.d(__webpack_exports__, "UiSwitchList", function() { return UiSwitchList_UiSwitchList; });
/* concated harmony reexport UiTextInput */__webpack_require__.d(__webpack_exports__, "UiTextInput", function() { return UiTextInput_UiTextInput; });




/***/ }),

/***/ "fb25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeaderCellContent_vue_vue_type_style_index_0_id_784a05b8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b13e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeaderCellContent_vue_vue_type_style_index_0_id_784a05b8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeaderCellContent_vue_vue_type_style_index_0_id_784a05b8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_11_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_11_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_11_oneOf_1_3_node_modules_stylus_loader_index_js_ref_11_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTableHeaderCellContent_vue_vue_type_style_index_0_id_784a05b8_lang_stylus_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fba5":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "fbf4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({
    data: vval.args
  });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);

  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};

  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }

  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx, idxInOld, elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx];
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;

      if (isUndef(idxInOld)) {
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];

        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }

  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];

    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }

  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return {
    tag: tag,
    key: key,
    args: args
  };
}

/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ffd6":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ })

/******/ });
//# sourceMappingURL=hubsolv-ui.common.js.map